export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Instant: { input: any; output: any }
  LocalDate: { input: any; output: any }
  LocalDateTime: { input: any; output: any }
  LocalTime: { input: any; output: any }
  Long: { input: any; output: any }
}

export type Absenteismo = {
  readonly __typename?: 'Absenteismo'
  readonly categoriaProfissional?: Maybe<Scalars['String']['output']>
  readonly cbo?: Maybe<Scalars['String']['output']>
  readonly equipe?: Maybe<Scalars['String']['output']>
  readonly faixaEtaria: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly intervaloAgendamento: Scalars['String']['output']
  readonly municipio?: Maybe<Scalars['String']['output']>
  readonly nomeProfissional?: Maybe<Scalars['String']['output']>
  readonly nomeSituacaoAgendamento: Scalars['String']['output']
  readonly producoes?: Maybe<Scalars['String']['output']>
  readonly turno: Scalars['String']['output']
  readonly unidadeSaude?: Maybe<Scalars['String']['output']>
}

export type Acesso = {
  readonly actions: BaseAcessoActions
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly perfis?: Maybe<ReadonlyArray<Maybe<Perfil>>>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
}

export type AcessoActions = BaseAcessoActions & {
  readonly __typename?: 'AcessoActions'
  readonly permissaoAtivacaoInativacao: Action
  readonly permissaoEdicao: Action
  readonly permissaoExclusao: Action
}

export enum AcessoCbo {
  ACS = 'ACS',
  AUXILIAR_OU_TECNICO_ENFERMAGEM = 'AUXILIAR_OU_TECNICO_ENFERMAGEM',
  CIRURGIAO_DENTISTA = 'CIRURGIAO_DENTISTA',
  ENFERMEIRO = 'ENFERMEIRO',
  FARMACEUTICO = 'FARMACEUTICO',
  GERENTE_SERVICOS = 'GERENTE_SERVICOS',
  MEDICO = 'MEDICO',
  NIVEL_MEDIO = 'NIVEL_MEDIO',
  NUTRICIONISTA = 'NUTRICIONISTA',
  OUTRO_PROF_NIVEL_SUPERIOR = 'OUTRO_PROF_NIVEL_SUPERIOR',
  PSICOLOGO = 'PSICOLOGO',
  TSB = 'TSB',
}

export type AcessoConecteSusInput = {
  readonly cnes: Scalars['String']['input']
  readonly cnsCidadao: Scalars['String']['input']
  readonly cnsProfissional: Scalars['String']['input']
  readonly municipio: Scalars['Long']['input']
}

export type AcessosConnectionInput = {
  readonly mostrarInativos?: InputMaybe<Scalars['Boolean']['input']>
}

export type AcompanhamentoCidadaosVinculados = {
  readonly __typename?: 'AcompanhamentoCidadaosVinculados'
  readonly cidadao?: Maybe<Cidadao>
  readonly cnsCidadao?: Maybe<Scalars['String']['output']>
  readonly cpfCidadao?: Maybe<Scalars['String']['output']>
  readonly dataNascimentoCidadao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaAtualizacaoCidadao?: Maybe<Scalars['LocalDate']['output']>
  readonly endereco: Scalars['String']['output']
  readonly equipe: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly idade: Scalars['String']['output']
  readonly microarea: Scalars['String']['output']
  readonly nomeCidadao: Scalars['String']['output']
  readonly origem: Scalars['String']['output']
  readonly sexoIdentidadeGeneroCidadao: Scalars['String']['output']
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly telefoneResidencial?: Maybe<Scalars['String']['output']>
}

export type AcompanhamentoCidadaosVinculadosFilterInput = {
  readonly equipeResponsavelId?: InputMaybe<Scalars['ID']['input']>
  readonly faixaEtaria?: InputMaybe<FaixaEtariaAcompanhamentoInput>
  readonly identidadeGenero?: InputMaybe<ReadonlyArray<IdentidadeGeneroEnum>>
  readonly microareas?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly sexo?: InputMaybe<ReadonlyArray<SexoEnum>>
}

export type AcompanhamentoCidadaosVinculadosPayload = {
  readonly __typename?: 'AcompanhamentoCidadaosVinculadosPayload'
  readonly content: ReadonlyArray<AcompanhamentoCidadaosVinculados>
  readonly pageInfo: PageInfo
}

export type AcompanhamentoCondicaoSaudeDto = {
  readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
  readonly cidadao?: Maybe<Cidadao>
  readonly cidadaoId: Scalars['ID']['output']
  readonly cnsCidadao?: Maybe<Scalars['String']['output']>
  readonly cpfCidadao?: Maybe<Scalars['String']['output']>
  readonly dataNascimentoCidadao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaMedicaoPesoAltura?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaMedicaoPressaoArterial?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaVisitaDomiciliar?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimoAtendimentoEnfermagem?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimoAtendimentoMedico?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimoAtendimentoOdontologico?: Maybe<Scalars['LocalDate']['output']>
  readonly endereco?: Maybe<Scalars['String']['output']>
  readonly identidadeGeneroCidadao?: Maybe<IdentidadeGeneroEnum>
  readonly ivcf?: Maybe<AcompanhamentoCondicaoSaudeIvcfDto>
  readonly microarea?: Maybe<Scalars['String']['output']>
  readonly nomeCidadao?: Maybe<Scalars['String']['output']>
  readonly nomeSocialCidadao?: Maybe<Scalars['String']['output']>
  readonly racaCorCidadao?: Maybe<Scalars['String']['output']>
  readonly sexoCidadao?: Maybe<SexoEnum>
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly telefoneResidencial?: Maybe<Scalars['String']['output']>
  readonly ultimaMedicaoAltura?: Maybe<Scalars['String']['output']>
  readonly ultimaMedicaoPeso?: Maybe<Scalars['String']['output']>
  readonly ultimaMedicaoPressaoArterial?: Maybe<Scalars['String']['output']>
}

export type AcompanhamentoCondicaoSaudeIvcfDto = {
  readonly __typename?: 'AcompanhamentoCondicaoSaudeIvcfDto'
  readonly dataResultado?: Maybe<Scalars['LocalDate']['output']>
  readonly riscoVulnerabilidade?: Maybe<RiscoVulnerabilidadeIvcfEnum>
  readonly subgrupo?: Maybe<ReadonlyArray<Maybe<IvcfSubgrupoPerguntaEnum>>>
}

export type AcompanhamentoCondicaoSaudeIvcfInput = {
  readonly exibirApenasCidadaosIdososSemIvcf?: InputMaybe<Scalars['Boolean']['input']>
  readonly pontuacaoMax?: InputMaybe<Scalars['Int']['input']>
  readonly pontuacaoMin?: InputMaybe<Scalars['Int']['input']>
  readonly riscoVulnerabilidade?: InputMaybe<ReadonlyArray<InputMaybe<RiscoVulnerabilidadeIvcfEnum>>>
  readonly subgrupo?: InputMaybe<ReadonlyArray<InputMaybe<IvcfSubgrupoPerguntaEnum>>>
}

export type AcompanhamentoCondicaoSaudeQueryInput = {
  readonly ciaps?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly cid10?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly condicaoMaternal?: InputMaybe<CondicaoMaternalFiltroEnum>
  readonly equipeResponsavelId?: InputMaybe<Scalars['ID']['input']>
  readonly faixaEtaria?: InputMaybe<FaixaEtariaAcompanhamentoInput>
  readonly grupoCondicao?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly identidadeGenero?: InputMaybe<ReadonlyArray<InputMaybe<IdentidadeGeneroEnum>>>
  readonly isIvcfListing?: InputMaybe<Scalars['Boolean']['input']>
  readonly ivcf?: InputMaybe<AcompanhamentoCondicaoSaudeIvcfInput>
  readonly microareas?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodoCadastroIndividual?: InputMaybe<PeriodoCadastroIndividualEnum>
  readonly periodoUltimoAtendimento?: InputMaybe<Period>
  readonly racaCor?: InputMaybe<RacaCorDbEnum>
  readonly riscoInsegurancaAlimentar?: InputMaybe<Scalars['Boolean']['input']>
  readonly semRegistroTriaNoPeriodo?: InputMaybe<Scalars['Boolean']['input']>
  readonly sexo?: InputMaybe<ReadonlyArray<InputMaybe<SexoEnum>>>
  readonly tematica?: InputMaybe<AcompanhamentoCondicaoSaudeTematicaEnum>
  readonly tipoFiltroLPC?: InputMaybe<TipoFiltroLpcEnum>
  readonly unidadeResponsavelId?: InputMaybe<Scalars['ID']['input']>
}

export type AcompanhamentoCondicaoSaudeQueryPayload = {
  readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
  readonly ciapsConsiderados?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly cidsConsiderados?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly content: ReadonlyArray<Maybe<AcompanhamentoCondicaoSaudeDto>>
  readonly pageInfo: PageInfo
}

export enum AcompanhamentoCondicaoSaudeTematicaEnum {
  DESENVOLVIMENTO_INFANTIL = 'DESENVOLVIMENTO_INFANTIL',
  DIABETES = 'DIABETES',
  GERAL = 'GERAL',
  GESTANTE_PUERPERA = 'GESTANTE_PUERPERA',
  HIPERTENSAO_ARTERIAL = 'HIPERTENSAO_ARTERIAL',
  PESSOA_IDOSA = 'PESSOA_IDOSA',
  SAUDE_BUCAL = 'SAUDE_BUCAL',
  SAUDE_MULHER = 'SAUDE_MULHER',
}

export type AcompanhamentoIdosoQueryInput = {
  readonly cidadaoId: Scalars['ID']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export enum AcompanhamentoPreNatalStatusExameEnum {
  NAO_SOLICITADO = 'NAO_SOLICITADO',
  RESULTADO = 'RESULTADO',
  RESULTADO_ANTERIOR = 'RESULTADO_ANTERIOR',
  SOLICITADO = 'SOLICITADO',
}

export type AcompanhamentoPreNatalVacina = {
  readonly __typename?: 'AcompanhamentoPreNatalVacina'
  readonly dataRegistro?: Maybe<Scalars['LocalDate']['output']>
  readonly idImuno?: Maybe<Scalars['Long']['output']>
  readonly nomeImuno: Scalars['String']['output']
  readonly siglaDoseImuno?: Maybe<Scalars['String']['output']>
}

export type AcompanhamentoPreNatalVacinacao = {
  readonly __typename?: 'AcompanhamentoPreNatalVacinacao'
  readonly idadeGestacionalEmSemanasAplicacao?: Maybe<Scalars['Long']['output']>
  readonly vacina: AcompanhamentoPreNatalVacina
}

export type AcompanhamentoPuerperioExamesPayload = {
  readonly __typename?: 'AcompanhamentoPuerperioExamesPayload'
  readonly content: ReadonlyArray<ExamesPuerperioDto>
  readonly pageInfo: PageInfo
}

export type AcompanhamentosProntuarioInput = {
  readonly dataInicioCondicao: Scalars['LocalDate']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId: Scalars['Long']['input']
}

export type AcompanhamentosVacinacaoInput = {
  readonly dataInicioGestacao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicioPuerperio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly prontuarioId: Scalars['Long']['input']
  readonly tipoAcompanhamento: TipoAcompanhamentoEnum
}

export type AcompanhamentosVisitasDomiciliaresInput = {
  readonly cidadaoId: Scalars['Long']['input']
  readonly dataFimCondicao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicioCondicao: Scalars['LocalDate']['input']
  readonly pageParams?: InputMaybe<PageParams>
}

export type AcompanhamentosVisitasDomiciliaresPayload = {
  readonly __typename?: 'AcompanhamentosVisitasDomiciliaresPayload'
  readonly content: ReadonlyArray<FatoVisitaDomiciliar>
  readonly pageInfo: PageInfo
}

export type Action = {
  readonly __typename?: 'Action'
  readonly enabled: Scalars['Boolean']['output']
  readonly hint?: Maybe<Scalars['String']['output']>
}

export type AdministradorGeral = Acesso & {
  readonly __typename?: 'AdministradorGeral'
  readonly actions: AcessoActions
  readonly ativo: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly perfis: ReadonlyArray<Maybe<Perfil>>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
}

export type AdministradorMunicipal = Acesso & {
  readonly __typename?: 'AdministradorMunicipal'
  readonly actions: AcessoActions
  readonly ativo: Scalars['Boolean']['output']
  readonly autorizado: Scalars['Boolean']['output']
  readonly chaveMunicipio: Scalars['String']['output']
  readonly dataAdicao?: Maybe<Scalars['Instant']['output']>
  readonly dataInativacao?: Maybe<Scalars['Instant']['output']>
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio: Municipio
  readonly perfis: ReadonlyArray<Maybe<Perfil>>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
}

export enum AgeRangeType {
  ANOS = 'ANOS',
  DIAS = 'DIAS',
  MESES = 'MESES',
  SEMANAS = 'SEMANAS',
}

export type AgendaOnline = {
  readonly __typename?: 'AgendaOnline'
  readonly ativa: Scalars['Boolean']['output']
  readonly detalhesAtivacao?: Maybe<DetalhesAtivacao>
  readonly testeConexao?: Maybe<TesteConexao>
}

export type Agendado = {
  readonly __typename?: 'Agendado'
  readonly agendamentoParticipante?: Maybe<Agendado>
  readonly agendamentoPrincipal?: Maybe<Agendado>
  readonly atendimento?: Maybe<Atendimento>
  readonly cidadao?: Maybe<CidadaoBasico>
  readonly dataCriacao?: Maybe<Scalars['Instant']['output']>
  readonly enviouEmailCidadao: Scalars['Boolean']['output']
  readonly horarioFinal: Scalars['Instant']['output']
  readonly horarioInicial: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly isAtencaoDomiciliar: Scalars['Boolean']['output']
  readonly isForaUbs: Scalars['Boolean']['output']
  readonly justificativaCancelamento?: Maybe<JustificativaCancelamentoAgendado>
  readonly localAtendimento?: Maybe<LocalAtendimento>
  readonly lotacaoAgendada: Lotacao
  readonly lotacaoParticipante?: Maybe<Lotacao>
  readonly motivoReserva?: Maybe<MotivoAgendamentoReservaEnum>
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly origem?: Maybe<OrigemAgendamentoEnum>
  readonly outroMotivoReserva?: Maybe<Scalars['String']['output']>
  readonly responsavelCriador?: Maybe<LotacaoOuEstagio>
  readonly situacao: SituacaoAgendadoEnum
  readonly situacaoSincronizacao: SituacaoSincronizacaoAgendaOnlineEnum
  readonly tipoAgendamento: TipoAgendamentoEnum
  readonly videochamada?: Maybe<Videochamada>
}

export type AgendadoQueryPayload = {
  readonly __typename?: 'AgendadoQueryPayload'
  readonly content: ReadonlyArray<Agendado>
  readonly pageInfo: PageInfo
}

export type AgendadosQueryInput = {
  readonly cbosToFilter?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly cidadaoId?: InputMaybe<Scalars['ID']['input']>
  readonly dataAgendadoFim?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataAgendadoInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly isForaDaUbs?: InputMaybe<Scalars['Boolean']['input']>
  readonly isOrigemAtencaoDomiciliar?: InputMaybe<Scalars['Boolean']['input']>
  readonly lotacaoId?: InputMaybe<Scalars['ID']['input']>
  readonly maisNovosPrimeiro?: InputMaybe<Scalars['Boolean']['input']>
  readonly nomeProfissional?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly profissionalId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId?: InputMaybe<Scalars['ID']['input']>
  readonly situacao?: InputMaybe<ReadonlyArray<SituacaoAgendadoEnum>>
  readonly unidadeSaudeId?: InputMaybe<Scalars['ID']['input']>
}

export type AgendamentoConflitanteInput = {
  readonly agendamentoIdDesconsiderar?: InputMaybe<Scalars['ID']['input']>
  readonly agendamentos: ReadonlyArray<LotacaoAgendamentoConflitanteInput>
  readonly cidadaoId: Scalars['ID']['input']
}

export type AgendamentoConsultaAtendimentoInput = {
  readonly horario: Scalars['Instant']['input']
  readonly horarioFinal?: InputMaybe<Scalars['Instant']['input']>
  readonly isForaUbs: Scalars['Boolean']['input']
  readonly localAtendimento?: InputMaybe<Scalars['ID']['input']>
  readonly lotacao: Scalars['ID']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type AgendamentoConsultasAtendimentoInput = {
  readonly avulsa?: InputMaybe<AgendamentoConsultaAtendimentoInput>
  readonly enviarComprovantesParaCidadao: Scalars['Boolean']['input']
  readonly planejadas?: InputMaybe<AgendamentoConsultasPlanejadasAtendimentoInput>
}

export type AgendamentoConsultasPlanejadasAtendimentoInput = {
  readonly odontologica?: InputMaybe<AgendamentoConsultaAtendimentoInput>
  readonly preNatal?: InputMaybe<AgendamentoConsultaAtendimentoInput>
}

export type AgendamentoCuidadoCompartilhadoInput = {
  readonly horario: Scalars['Instant']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type AgendamentoMesmoProfissionalDataFutura = {
  readonly __typename?: 'AgendamentoMesmoProfissionalDataFutura'
  readonly dataFutura: Scalars['Instant']['output']
  readonly profissionalId: Scalars['ID']['output']
}

export enum AggregatorRelatorioGerencialEnum {
  CONTAGEM = 'CONTAGEM',
  MAXIMO = 'MAXIMO',
  MEDIA = 'MEDIA',
  MINIMO = 'MINIMO',
  PERCENTUAL = 'PERCENTUAL',
}

export type Aldeia = {
  readonly __typename?: 'Aldeia'
  readonly id: Scalars['ID']['output']
  readonly municipio: ReadonlyArray<Municipio>
  readonly nome: Scalars['String']['output']
  readonly poloBase: PoloBase
}

export type AldeiaInput = {
  readonly dseiId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly poloBaseId?: InputMaybe<Scalars['ID']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type AldeiaQueryPayload = {
  readonly __typename?: 'AldeiaQueryPayload'
  readonly content: ReadonlyArray<Aldeia>
  readonly pageInfo: PageInfo
}

export type AleitamentoMaterno = {
  readonly __typename?: 'AleitamentoMaterno'
  readonly dataInicioAtendimento?: Maybe<Scalars['Instant']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly tipo?: Maybe<TipoAleitamentoMaternoEnum>
}

export type Alergia = {
  readonly __typename?: 'Alergia'
  readonly categoriaSubstanciaEspecificaLegado?: Maybe<CategoriaSubstanciaAlergiaLegado>
  readonly criticidade: CriticidadeAlergia
  readonly evolucoes: ReadonlyArray<EvolucaoAlergia>
  readonly grauCerteza: GrauCertezaAlergia
  readonly id: Scalars['ID']['output']
  readonly substanciaEspecifica?: Maybe<SubstanciaEspecificaAlergia>
  readonly substanciaEspecificaLegado?: Maybe<Scalars['String']['output']>
  readonly tipoReacao?: Maybe<TipoReacaoAlergia>
  readonly ultimaEvolucao: EvolucaoAlergia
}

export type AlergiaQueryPayload = {
  readonly __typename?: 'AlergiaQueryPayload'
  readonly content: ReadonlyArray<Alergia>
  readonly pageInfo: PageInfo
}

export type AlergiasQueryInput = {
  readonly grausCerteza?: InputMaybe<ReadonlyArray<GrauCertezaAlergia>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId: Scalars['ID']['input']
}

export type AlertaSdc = EventoSdc & {
  readonly __typename?: 'AlertaSdc'
  readonly acompanhamento?: Maybe<Scalars['String']['output']>
  readonly conjuntoFatoresSdc?: Maybe<ConjuntoFatoresSdcDto>
  readonly conteudoPersonalizado?: Maybe<Scalars['String']['output']>
  readonly exames?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly medicamentos?: Maybe<Scalars['String']['output']>
  readonly notificar: Scalars['Boolean']['output']
  readonly orientacoes?: Maybe<Scalars['String']['output']>
  readonly recomendacoes?: Maybe<Scalars['String']['output']>
  readonly referencias?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly retorno?: Maybe<Scalars['String']['output']>
  readonly riscos?: Maybe<ReadonlyArray<Risco>>
  readonly subtitulo?: Maybe<Scalars['String']['output']>
  readonly titulo?: Maybe<Scalars['String']['output']>
  readonly tituloMedicamentos?: Maybe<Scalars['String']['output']>
  readonly tituloOrientacoes?: Maybe<Scalars['String']['output']>
  readonly tituloReferencias?: Maybe<Scalars['String']['output']>
  readonly tituloRetorno?: Maybe<Scalars['String']['output']>
}

export type AlteracaoFenotipica = AvaliacaoDesenvolvimento & {
  readonly __typename?: 'AlteracaoFenotipica'
  readonly dataAvaliacao?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly status: StatusAvaliadoEnum
}

export type AlterarCadsusInput = {
  readonly desabilitadoAteData?: InputMaybe<Scalars['Instant']['input']>
  readonly habilitado: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
  readonly intervalo?: InputMaybe<Scalars['Int']['input']>
}

export type AlterarConfiguracaoAnexoArquivosInput = {
  readonly diretorio: Scalars['String']['input']
  readonly habilitado?: InputMaybe<Scalars['Boolean']['input']>
}

export type AlterarConfiguracaoPrescricaoDigitalInput = {
  readonly habilitado: Scalars['Boolean']['input']
  readonly senha: Scalars['String']['input']
  readonly usuario: Scalars['String']['input']
}

export type AlterarConfiguracaoVideochamadasInput = {
  readonly habilitado: Scalars['Boolean']['input']
}

export type AlterarHorusInput = {
  readonly desabilitadoAteData?: InputMaybe<Scalars['Instant']['input']>
  readonly habilitado: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
  readonly intervalo?: InputMaybe<Scalars['Int']['input']>
}

export type AlterarLotacaoInput = {
  readonly ativo: Scalars['Boolean']['input']
  readonly atualizaPerfil: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
  readonly perfis: ReadonlyArray<Scalars['ID']['input']>
}

export type AlterarSenhaAtualInput = {
  readonly novaSenha: Scalars['String']['input']
  readonly senhaAtual?: InputMaybe<Scalars['String']['input']>
}

export type AnexoArquivoInput = {
  readonly arquivoUuid: Scalars['String']['input']
  readonly categoria: CategoriaArquivoAtendProfEnum
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly titulo: Scalars['String']['input']
}

export enum AnimaisDomicilioEnum {
  CACHORRO = 'CACHORRO',
  GALINHA = 'GALINHA',
  GATO = 'GATO',
  MACACO = 'MACACO',
  OUTRO = 'OUTRO',
  PASSARO = 'PASSARO',
  PORCO = 'PORCO',
  REPTEIS = 'REPTEIS',
}

export type AnimaisImovel = {
  readonly __typename?: 'AnimaisImovel'
  readonly id?: Maybe<Scalars['Long']['output']>
  readonly possuiAnimais?: Maybe<Scalars['Boolean']['output']>
  readonly possuiCachorro?: Maybe<Scalars['Boolean']['output']>
  readonly possuiGalinha?: Maybe<Scalars['Boolean']['output']>
  readonly possuiGato?: Maybe<Scalars['Boolean']['output']>
  readonly possuiMacaco?: Maybe<Scalars['Boolean']['output']>
  readonly possuiOutros?: Maybe<Scalars['Boolean']['output']>
  readonly possuiPassaro?: Maybe<Scalars['Boolean']['output']>
  readonly possuiPorco?: Maybe<Scalars['Boolean']['output']>
  readonly possuiRepteis?: Maybe<Scalars['Boolean']['output']>
  readonly quantidadeAnimais?: Maybe<Scalars['Int']['output']>
}

export type AnimaisImovelInput = {
  readonly possuiAnimais: Scalars['Boolean']['input']
  readonly possuiCachorro?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiGalinha?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiGato?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiMacaco?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiOutros?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiPassaro?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiPorco?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiRepteis?: InputMaybe<Scalars['Boolean']['input']>
  readonly quantidadeAnimais?: InputMaybe<Scalars['Int']['input']>
}

export type Antecedente = {
  readonly __typename?: 'Antecedente'
  readonly altura?: Maybe<Scalars['String']['output']>
  readonly antecedentesFamiliaresCiap?: Maybe<ReadonlyArray<Maybe<AntecedentesFamiliaresCiap>>>
  readonly apgarCinco?: Maybe<Scalars['String']['output']>
  readonly apgarDez?: Maybe<Scalars['String']['output']>
  readonly apgarUm?: Maybe<Scalars['String']['output']>
  readonly cirurgiasInternacoes?: Maybe<ReadonlyArray<Maybe<AntecedenteCirurgiasInternacoes>>>
  readonly dataUltimaAtualizacaoGestacional?: Maybe<Scalars['Instant']['output']>
  readonly dataUltimaAtualizacaoPessoal?: Maybe<Scalars['Instant']['output']>
  readonly dataUltimaAtualizacaoPuericultura?: Maybe<Scalars['Instant']['output']>
  readonly dataUltimoParto?: Maybe<Scalars['Instant']['output']>
  readonly desfechoUltimaGestacao?: Maybe<DesfechoUltimaGestacaoEnum>
  readonly filhosVivos?: Maybe<Scalars['String']['output']>
  readonly gestacoesPrevias?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly idadeGestacionalDias?: Maybe<Scalars['String']['output']>
  readonly idadeGestacionalSemanas?: Maybe<Scalars['String']['output']>
  readonly nascidosVivos?: Maybe<Scalars['String']['output']>
  readonly natimortos?: Maybe<Scalars['String']['output']>
  readonly obitoAntesPrimeiraSemana?: Maybe<Scalars['String']['output']>
  readonly obitoAposPrimeiraSemana?: Maybe<Scalars['String']['output']>
  readonly observacoes?: Maybe<Scalars['String']['output']>
  readonly partosDomiciliares?: Maybe<Scalars['String']['output']>
  readonly partosVaginais?: Maybe<Scalars['String']['output']>
  readonly perimetroCefalico?: Maybe<Scalars['String']['output']>
  readonly peso?: Maybe<Scalars['String']['output']>
  readonly qtAbortos?: Maybe<Scalars['String']['output']>
  readonly qtCesareas?: Maybe<Scalars['String']['output']>
  readonly qtPartos?: Maybe<Scalars['String']['output']>
  readonly recemNascidosAbaixo?: Maybe<Scalars['String']['output']>
  readonly recemNascidosAcima?: Maybe<Scalars['String']['output']>
  readonly tipoGravidez?: Maybe<TipoGravidezEnum>
  readonly tipoParto?: Maybe<TipoPartoEnum>
}

export type AntecedenteCirurgiaInternacaoInput = {
  readonly dataRealizada?: InputMaybe<Scalars['LocalDate']['input']>
  readonly descricao: Scalars['String']['input']
  readonly idCirurgiaInternacao?: InputMaybe<Scalars['ID']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
}

export type AntecedenteCirurgiasInternacoes = {
  readonly __typename?: 'AntecedenteCirurgiasInternacoes'
  readonly dataCirurgiaInternacao?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly observacoes?: Maybe<Scalars['String']['output']>
}

export type AntecedenteFamiliarCiapInput = {
  readonly ciapId: Scalars['ID']['input']
  readonly observacao?: InputMaybe<Scalars['String']['input']>
}

export type AntecedenteInformacoesObstetricasDto = {
  readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
  readonly abortos?: Maybe<Scalars['String']['output']>
  readonly desfechoUltimaGestacao?: Maybe<Scalars['String']['output']>
  readonly filhosVivos?: Maybe<Scalars['String']['output']>
  readonly gestaPrevias?: Maybe<Scalars['String']['output']>
  readonly nascidosVivos?: Maybe<Scalars['String']['output']>
  readonly natimortos?: Maybe<Scalars['String']['output']>
  readonly obitoAntesPrimeiraSemana?: Maybe<Scalars['String']['output']>
  readonly obitoAposPrimeiraSemana?: Maybe<Scalars['String']['output']>
  readonly partos?: Maybe<Scalars['String']['output']>
  readonly partosCesareas?: Maybe<Scalars['String']['output']>
  readonly partosDomiciliares?: Maybe<Scalars['String']['output']>
  readonly partosVaginais?: Maybe<Scalars['String']['output']>
  readonly recemNascidoAbaixo?: Maybe<Scalars['String']['output']>
  readonly recemNascidoAcima?: Maybe<Scalars['String']['output']>
}

export type AntecedenteItemDto = {
  readonly __typename?: 'AntecedenteItemDto'
  readonly id: Scalars['ID']['output']
  readonly informacoesObstetricas?: Maybe<AntecedenteInformacoesObstetricasDto>
  readonly observacoes?: Maybe<Scalars['String']['output']>
  readonly puericultura?: Maybe<AntecedentePuericulturaDto>
}

export type AntecedentePuericulturaDto = {
  readonly __typename?: 'AntecedentePuericulturaDto'
  readonly apgarCinco?: Maybe<Scalars['String']['output']>
  readonly apgarDez?: Maybe<Scalars['String']['output']>
  readonly apgarUm?: Maybe<Scalars['String']['output']>
  readonly comprimento?: Maybe<Scalars['String']['output']>
  readonly idadeGestacionalDias?: Maybe<Scalars['String']['output']>
  readonly idadeGestacionalSemanas?: Maybe<Scalars['String']['output']>
  readonly perimetroCefalico?: Maybe<Scalars['String']['output']>
  readonly peso?: Maybe<Scalars['String']['output']>
  readonly tipoGravidez?: Maybe<Scalars['String']['output']>
  readonly tipoParto?: Maybe<Scalars['String']['output']>
}

export type AntecedentesFamiliaresCiap = {
  readonly __typename?: 'AntecedentesFamiliaresCiap'
  readonly codigoCiap: Scalars['String']['output']
  readonly descricao: Scalars['String']['output']
  readonly idCiap: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
}

export type AntecedentesInput = {
  readonly familiar?: InputMaybe<FamiliarAntecedentesInput>
  readonly pessoal?: InputMaybe<PessoalAntecedentesInput>
}

export type AplicacaoMedicamento = {
  readonly __typename?: 'AplicacaoMedicamento'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type AplicacaoMedicamentoPayload = {
  readonly __typename?: 'AplicacaoMedicamentoPayload'
  readonly content: ReadonlyArray<Maybe<AplicacaoMedicamento>>
  readonly pageInfo: PageInfo
}

export type AplicacaoMedicamentoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type Arquivo = {
  readonly __typename?: 'Arquivo'
  readonly dataCriacao: Scalars['Instant']['output']
  readonly formato: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly uuid: Scalars['String']['output']
}

export type ArquivoAtendimentoProfissional = {
  readonly __typename?: 'ArquivoAtendimentoProfissional'
  readonly arquivo: Arquivo
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly categoria: CategoriaArquivoAtendProfEnum
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly titulo: Scalars['String']['output']
}

export type ArquivoTemporario = {
  readonly __typename?: 'ArquivoTemporario'
  readonly dataInicioGerado: Scalars['Instant']['output']
  readonly formato: ArquivoTemporarioFormatoEnum
  readonly id: Scalars['ID']['output']
  readonly identificador: ArquivoTemporarioIdentificadorEnum
  readonly status: ArquivoTemporarioStatusEnum
}

export enum ArquivoTemporarioFormatoEnum {
  CSV = 'CSV',
  PDF = 'PDF',
  ZIP = 'ZIP',
}

export enum ArquivoTemporarioIdentificadorEnum {
  RELATORIO_ACOMPANHAMENTO_CIDADAOS_VINCULADOS = 'RELATORIO_ACOMPANHAMENTO_CIDADAOS_VINCULADOS',
  RELATORIO_ACOMPANHAMENTO_CONDICAO_SAUDE = 'RELATORIO_ACOMPANHAMENTO_CONDICAO_SAUDE',
  RELATORIO_ACOMPANHAMENTO_TERRITORIO_MICROAREA = 'RELATORIO_ACOMPANHAMENTO_TERRITORIO_MICROAREA',
  RELATORIO_BUSCA_ATIVA_VACINACAO = 'RELATORIO_BUSCA_ATIVA_VACINACAO',
  RELATORIO_CADASTROS_DUPLICADOS = 'RELATORIO_CADASTROS_DUPLICADOS',
  RELATORIO_IMPORTACAO_CIDADAOS = 'RELATORIO_IMPORTACAO_CIDADAOS',
  RELATORIO_RNDS = 'RELATORIO_RNDS',
}

export type ArquivoTemporarioPagingQueryInput = {
  readonly arquivoIdentificador: ArquivoTemporarioIdentificadorEnum
  readonly pageParams?: InputMaybe<PageParams>
}

export type ArquivoTemporarioQueryInput = {
  readonly apenasUltimosSeteDias?: InputMaybe<Scalars['Boolean']['input']>
  readonly arquivoTemporarioIdentificadorEnum: ArquivoTemporarioIdentificadorEnum
}

export type ArquivoTemporarioQueryPayload = {
  readonly __typename?: 'ArquivoTemporarioQueryPayload'
  readonly content: ReadonlyArray<ArquivoTemporario>
  readonly pageInfo: PageInfo
}

export enum ArquivoTemporarioStatusEnum {
  EM_PROCESSAMENTO = 'EM_PROCESSAMENTO',
  ERRO = 'ERRO',
  ERRO_RELATORIO_SEM_DADOS = 'ERRO_RELATORIO_SEM_DADOS',
  PRONTO = 'PRONTO',
}

export type AssinaturaEletronica = {
  readonly __typename?: 'AssinaturaEletronica'
  readonly dtAssinatura: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly status: StatusAssinatura
}

export enum AsyncProcessingNameEnum {
  RELATORIO_GERENCIAL_ATENDIMENTO = 'RELATORIO_GERENCIAL_ATENDIMENTO',
  RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL = 'RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL',
  RELATORIO_GERENCIAL_EXAMES = 'RELATORIO_GERENCIAL_EXAMES',
  RELATORIO_GERENCIAL_VACINACAO = 'RELATORIO_GERENCIAL_VACINACAO',
}

export type AsyncProcessingStatus = {
  readonly __typename?: 'AsyncProcessingStatus'
  readonly errorMessage?: Maybe<Scalars['String']['output']>
  readonly isFinished: Scalars['Boolean']['output']
  readonly isStarted: Scalars['Boolean']['output']
}

export type AtencaoDomiciliarCidadao = {
  readonly __typename?: 'AtencaoDomiciliarCidadao'
  readonly actions: AtencaoDomiciliarCidadaoActions
  readonly cid10Principal?: Maybe<Cid10>
  readonly cid10Secundario1?: Maybe<Cid10>
  readonly cid10Secundario2?: Maybe<Cid10>
  readonly cidadao?: Maybe<Cidadao>
  readonly cidadaoAdEmObito?: Maybe<AtencaoDomiciliarCidadao>
  readonly cidadaosAdEmPosObito?: Maybe<ReadonlyArray<Maybe<AtencaoDomiciliarCidadao>>>
  readonly condutaDesfecho?: Maybe<AtencaoDomiciliarCondutaDesfecho>
  readonly dataAdmissao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataAgendado?: Maybe<Scalars['Instant']['output']>
  readonly dataObito?: Maybe<Scalars['LocalDate']['output']>
  readonly dataSaida?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaVisita?: Maybe<Scalars['LocalDate']['output']>
  readonly equipe?: Maybe<Equipe>
  readonly id: Scalars['ID']['output']
  readonly modalidade?: Maybe<AtencaoDomiciliarModalidade>
  readonly numeroDocumentoObito?: Maybe<Scalars['String']['output']>
  readonly procedencia?: Maybe<AtencaoDomiciliarOrigem>
  readonly procedenciaEspecificacao?: Maybe<Scalars['String']['output']>
}

export type AtencaoDomiciliarCidadaoActions = {
  readonly __typename?: 'AtencaoDomiciliarCidadaoActions'
  readonly adEncerrado: Action
  readonly permissaoEditarAD: Action
  readonly permissaoExcluirAD: Action
}

export type AtencaoDomiciliarCidadaoInput = {
  readonly cid10PrincipalId: Scalars['ID']['input']
  readonly cid10Secundario1Id?: InputMaybe<Scalars['ID']['input']>
  readonly cid10Secundario2Id?: InputMaybe<Scalars['ID']['input']>
  readonly cidadaoAdEmObitoId?: InputMaybe<Scalars['ID']['input']>
  readonly cidadaoId: Scalars['ID']['input']
  readonly condutaDesfecho?: InputMaybe<AtencaoDomiciliarCondutaDesfecho>
  readonly cpfCnsCuidador?: InputMaybe<Scalars['String']['input']>
  readonly cpfCnsResponsavel?: InputMaybe<Scalars['String']['input']>
  readonly dataAdmissao: Scalars['LocalDate']['input']
  readonly dataNascimentoCuidador?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataNascimentoResponsavel?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataObito?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataSaida?: InputMaybe<Scalars['LocalDate']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly modalidade: AtencaoDomiciliarModalidade
  readonly naoPossuiCuidador?: InputMaybe<Scalars['Boolean']['input']>
  readonly nomeCuidador?: InputMaybe<Scalars['String']['input']>
  readonly nomeResponsavel?: InputMaybe<Scalars['String']['input']>
  readonly numeroDO?: InputMaybe<Scalars['String']['input']>
  readonly procedencia?: InputMaybe<AtencaoDomiciliarOrigem>
  readonly procedenciaEspecificacao?: InputMaybe<Scalars['String']['input']>
  readonly relacaoCidadaoCuidador?: InputMaybe<RelacaoCidadaoCuidador>
}

export enum AtencaoDomiciliarCondutaDesfecho {
  ACOMPANHAMENTO_POS_OBITO = 'ACOMPANHAMENTO_POS_OBITO',
  ALTA_ADMINISTRATIVA = 'ALTA_ADMINISTRATIVA',
  ALTA_CLINICA = 'ALTA_CLINICA',
  ATENCAO_BASICA_AD1 = 'ATENCAO_BASICA_AD1',
  OBITO = 'OBITO',
  PERMANENCIA = 'PERMANENCIA',
  SAIDA_POR_OBITO = 'SAIDA_POR_OBITO',
  SERVICO_INTERNACAO_HOSPITALAR = 'SERVICO_INTERNACAO_HOSPITALAR',
  SERVICO_URGENCIA_EMERGENCIA = 'SERVICO_URGENCIA_EMERGENCIA',
}

export enum AtencaoDomiciliarModalidade {
  INELEGIVEL = 'INELEGIVEL',
  MODALIDADE_AD_1 = 'MODALIDADE_AD_1',
  MODALIDADE_AD_2 = 'MODALIDADE_AD_2',
  MODALIDADE_AD_3 = 'MODALIDADE_AD_3',
  POS_OBITO = 'POS_OBITO',
}

export enum AtencaoDomiciliarOrigem {
  ATENCAO_BASICA = 'ATENCAO_BASICA',
  CACON_UNACON = 'CACON_UNACON',
  HOSPITAL = 'HOSPITAL',
  HOSPITAL_DEMAIS_SETORES = 'HOSPITAL_DEMAIS_SETORES',
  HOSPITAL_URGENCIA_EMERGENCIA = 'HOSPITAL_URGENCIA_EMERGENCIA',
  INICIATIVA_PACIENTE_TERCEIROS = 'INICIATIVA_PACIENTE_TERCEIROS',
  INTERNACAO_HOSPITALAR = 'INTERNACAO_HOSPITALAR',
  OUTROS = 'OUTROS',
  UBS = 'UBS',
  UNIDADE_PRONTO_ATENDIMENTO = 'UNIDADE_PRONTO_ATENDIMENTO',
  URGENCIA_EMERGENCIA = 'URGENCIA_EMERGENCIA',
}

export type AtencaoDomiciliarQuestao = {
  readonly __typename?: 'AtencaoDomiciliarQuestao'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export type AtencaoDomiciliarResposta = {
  readonly __typename?: 'AtencaoDomiciliarResposta'
  readonly id: Scalars['Int']['output']
  readonly questao?: Maybe<AtencaoDomiciliarQuestao>
  readonly situacaoAtiva?: Maybe<Scalars['Boolean']['output']>
}

export type Atendimento = {
  readonly __typename?: 'Atendimento'
  readonly actions: AtendimentoActions
  readonly agendado?: Maybe<Agendado>
  readonly atendimentoProfissional?: Maybe<AtendimentoProfissional>
  readonly cidadao: CidadaoBasico
  readonly classificacaoRisco?: Maybe<ClassificacaoRisco>
  readonly dataCriacaoRegistro?: Maybe<Scalars['Instant']['output']>
  readonly encaminhadoEm: Scalars['Instant']['output']
  readonly equipe?: Maybe<Equipe>
  readonly escutaInicialAtendProf?: Maybe<AtendimentoProfissional>
  readonly hasTagNaoFinalizado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly iniciadoEm: Scalars['Instant']['output']
  readonly isAgendado: Scalars['Boolean']['output']
  readonly isRegistroTardio: Scalars['Boolean']['output']
  readonly justificativa?: Maybe<RegistroTardioJustificativaEnum>
  readonly localAtendimento?: Maybe<LocalAtendimento>
  readonly possuiAtendimentosProfissionais: Scalars['Boolean']['output']
  readonly prontuario: Prontuario
  readonly prontuarioId: Scalars['ID']['output']
  readonly responsavel?: Maybe<LotacaoOuEstagio>
  readonly statusAtendimento: StatusAtendimento
  readonly statusRevisaoAtendimento?: Maybe<StatusRevisaoAtendimento>
  readonly tiposServico?: Maybe<ReadonlyArray<Maybe<TipoServico>>>
  readonly ultimaAlteracaoStatusEm: Scalars['Instant']['output']
  readonly ultimoResponsavelObservacao?: Maybe<Lotacao>
  readonly unidadeSaude: UnidadeSaude
}

export type AtendimentoActions = {
  readonly __typename?: 'AtendimentoActions'
  readonly atender?: Maybe<Action>
  readonly atendimentosDia?: Maybe<Action>
  readonly cancelarAusencia?: Maybe<Action>
  readonly cancelarRegistro?: Maybe<Action>
  readonly chamarCidadaoPainel?: Maybe<Action>
  readonly declaracaoComparecimento?: Maybe<Action>
  readonly editar?: Maybe<Action>
  readonly escutaInicial?: Maybe<Action>
  readonly excluir?: Maybe<Action>
  readonly gerarAutorizacaoRetiradaAbsorventes?: Maybe<Action>
  readonly informarAusencia?: Maybe<Action>
  readonly revisarRetificar?: Maybe<Action>
  readonly tornarResponsavelObservacao?: Maybe<Action>
  readonly vacinacao?: Maybe<Action>
  readonly visualizarEscutaInicial?: Maybe<Action>
  readonly visualizarProntuario?: Maybe<Action>
}

export type AtendimentoEditInput = {
  readonly atendimento: Scalars['ID']['input']
  readonly equipe?: InputMaybe<Scalars['ID']['input']>
  readonly responsavel?: InputMaybe<Scalars['ID']['input']>
  readonly tiposServico?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export type AtendimentoIndividualAprovacaoInput = {
  readonly atendimentoInput: AtendimentoIndividualInput
  readonly rascunho: Scalars['String']['input']
}

export type AtendimentoIndividualInput = {
  readonly antecedentes?: InputMaybe<AntecedentesInput>
  readonly avaliacao?: InputMaybe<AvaliacaoInput>
  readonly finalizacao?: InputMaybe<FinalizacaoAtendimentoInput>
  readonly id: Scalars['ID']['input']
  readonly imprimirAtendimento?: InputMaybe<Scalars['Boolean']['input']>
  readonly lembretes?: InputMaybe<ReadonlyArray<InputMaybe<LembreteSaveInput>>>
  readonly medicamentoInterromper?: InputMaybe<ReadonlyArray<InputMaybe<MedicamentoInterromperInput>>>
  readonly medicoesAnteriores?: InputMaybe<ReadonlyArray<InputMaybe<MedicoesInput>>>
  readonly objetivo?: InputMaybe<ObjetivoInput>
  readonly plano?: InputMaybe<PlanoInput>
  readonly preNatal?: InputMaybe<PreNatalInput>
  readonly problemasECondicoes?: InputMaybe<ReadonlyArray<ProblemasECondicoesInput>>
  readonly registrosVacinacao?: InputMaybe<ReadonlyArray<InputMaybe<RegistroVacinacaoInput>>>
  readonly subjetivo?: InputMaybe<SubjetivoInput>
}

export type AtendimentoInput = {
  readonly agendado?: InputMaybe<Scalars['ID']['input']>
  readonly cidadao: Scalars['ID']['input']
  readonly equipe?: InputMaybe<Scalars['ID']['input']>
  readonly responsavel?: InputMaybe<Scalars['ID']['input']>
  readonly tiposServico?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export type AtendimentoObservacao = {
  readonly __typename?: 'AtendimentoObservacao'
  readonly atendimentoProfissionalFinalizador?: Maybe<AtendimentoProfissional>
  readonly atendimentoProfissionalIniciador: AtendimentoProfissional
  readonly id: Scalars['ID']['output']
  readonly isFinalizado: Scalars['Boolean']['output']
  readonly responsaveis: ReadonlyArray<AtendimentoObservacaoResponsavel>
  readonly ultimoResponsavelObservacao: Lotacao
}

export type AtendimentoObservacaoPlanoCuidado = {
  readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
  readonly atendimentoProfissionalObservacao: AtendimentoProfissionalObservacao
  readonly dataDescricao: Scalars['Instant']['output']
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export type AtendimentoObservacaoResponsavel = {
  readonly __typename?: 'AtendimentoObservacaoResponsavel'
  readonly atendeuComoResponsavel: Scalars['Boolean']['output']
  readonly atendimentoObservacao: AtendimentoObservacao
  readonly id: Scalars['ID']['output']
  readonly responsavel: Lotacao
}

export type AtendimentoProcedimento = {
  readonly __typename?: 'AtendimentoProcedimento'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly automatico?: Maybe<Scalars['Boolean']['output']>
  readonly cid10Principal?: Maybe<Cid10>
  readonly id: Scalars['ID']['output']
  readonly obrigatorio?: Maybe<Scalars['Boolean']['output']>
  readonly procedimento: Procedimento
}

export type AtendimentoProfissional = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly alergiaEvolucao?: Maybe<ReadonlyArray<Maybe<EvolucaoAlergia>>>
  readonly antecedentes?: Maybe<AntecedenteItemDto>
  readonly arquivosAnexados: ReadonlyArray<ArquivoAtendimentoProfissional>
  readonly assinaturaEletronicaAtend?: Maybe<AssinaturaEletronica>
  readonly atendimento?: Maybe<Atendimento>
  readonly atendimentoProfissionalAD?: Maybe<AtendimentoProfissionalAtencaoDomiciliar>
  readonly atendimentoProfissionalObservacao?: Maybe<AtendimentoProfissionalObservacao>
  readonly atendimentoProfissionalOdonto?: Maybe<AtendimentoProfissionalOdonto>
  readonly atendimentoProfissionalPreNatal?: Maybe<AtendimentoProfissionalPreNatal>
  readonly atendimentoProfissionalPuericultura?: Maybe<AtendimentoProfissionalPuericultura>
  readonly atestados?: Maybe<ReadonlyArray<Atestado>>
  readonly cidadaoAD?: Maybe<AtencaoDomiciliarCidadao>
  readonly cirurgiasInternacoes?: Maybe<ReadonlyArray<Maybe<AntecedenteCirurgiasInternacoes>>>
  readonly classificacaoRisco?: Maybe<ClassificacaoRisco>
  readonly codigoUnicoRegistro: Scalars['String']['output']
  readonly condutas?: Maybe<ReadonlyArray<Maybe<CondutaEnum>>>
  readonly cuidadosCompartilhados?: Maybe<ReadonlyArray<CuidadoCompartilhado>>
  readonly encaminhamentos?: Maybe<ReadonlyArray<TipoEncaminhamentoExternoEnum>>
  readonly encaminhamentosEspecializados?: Maybe<ReadonlyArray<Maybe<EncaminhamentoExternoEspecializado>>>
  readonly estagio?: Maybe<Estagio>
  readonly evolucaoAvaliacao?: Maybe<EvolucaoAvaliacao>
  readonly evolucaoObjetivo?: Maybe<EvolucaoObjetivo>
  readonly evolucaoPlano?: Maybe<EvolucaoPlano>
  readonly evolucaoProblema?: Maybe<ReadonlyArray<Maybe<EvolucaoProblema>>>
  readonly evolucaoSubjetivo?: Maybe<EvolucaoSubjetivo>
  readonly examesResultados?: Maybe<ReadonlyArray<Maybe<ResultadoExame>>>
  readonly finalizadoEm?: Maybe<Scalars['Instant']['output']>
  readonly guiasEncaminhamento?: Maybe<ReadonlyArray<GuiaEncaminhamento>>
  readonly id: Scalars['ID']['output']
  readonly iniciadoEm: Scalars['Instant']['output']
  readonly isAtendRecente: Scalars['Boolean']['output']
  readonly ivcf?: Maybe<Ivcf>
  readonly lotacao: Lotacao
  readonly lotacaoAtendimentoCompartilhado?: Maybe<Lotacao>
  readonly mChats?: Maybe<ReadonlyArray<MChat>>
  readonly marcadorConsumoAlimentar?: Maybe<MarcadorConsumoAlimentar>
  readonly medicoes?: Maybe<ReadonlyArray<Maybe<Medicao>>>
  readonly notificacoesCasoSuspeito?: Maybe<ReadonlyArray<Maybe<SinanNotificacaoEvolucao>>>
  readonly orientacoes?: Maybe<ReadonlyArray<Maybe<Orientacao>>>
  readonly planosDeCuidado?: Maybe<ReadonlyArray<AtendimentoObservacaoPlanoCuidado>>
  readonly procedimentosAtendimento?: Maybe<ReadonlyArray<Maybe<AtendimentoProcedimento>>>
  readonly quantidadeAtestados?: Maybe<Scalars['Int']['output']>
  readonly quantidadeOrientacoes?: Maybe<Scalars['Int']['output']>
  readonly racionalidadeSaude?: Maybe<RacionalidadeEmSaudeEnum>
  readonly rascunho?: Maybe<Scalars['String']['output']>
  readonly receitaMedicamento?: Maybe<ReadonlyArray<Maybe<ReceitaMedicamento>>>
  readonly requisicoesExames?: Maybe<ReadonlyArray<SolicitacaoExame>>
  readonly solicitacoesOci?: Maybe<ReadonlyArray<SolicitacaoExame>>
  readonly stCancelado?: Maybe<Scalars['Boolean']['output']>
  readonly tipo: TipoAtendimentoProfissional
  readonly tipoAtendimento?: Maybe<TipoAtendimentoEnum>
  readonly tipoParticipacaoCidadao?: Maybe<TipoParticipacaoAtendimentoEnum>
  readonly tipoParticipacaoProfissionalConvidado?: Maybe<TipoParticipacaoAtendimentoEnum>
  readonly vacinacao?: Maybe<AtendimentoVacinacao>
  readonly versao?: Maybe<Scalars['String']['output']>
  readonly versaoAnterior?: Maybe<Scalars['Boolean']['output']>
}

export type AtendimentoProfissionalAtencaoDomiciliar = {
  readonly __typename?: 'AtendimentoProfissionalAtencaoDomiciliar'
  readonly cid10Principal?: Maybe<Cid10>
  readonly cid10Secundario1?: Maybe<Cid10>
  readonly cid10Secundario2?: Maybe<Cid10>
  readonly conclusao?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly condicoesAvaliadasAD?: Maybe<ReadonlyArray<Maybe<AtencaoDomiciliarResposta>>>
  readonly condicoesAvaliadasElegibilidade?: Maybe<
    ReadonlyArray<Maybe<AtendimentoProfissionalAtencaoDomiciliarQuestao>>
  >
  readonly conduta?: Maybe<AtencaoDomiciliarCondutaDesfecho>
  readonly elegivel?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly modalidade: AtencaoDomiciliarModalidade
  readonly origem?: Maybe<AtencaoDomiciliarOrigem>
}

export type AtendimentoProfissionalAtencaoDomiciliarQuestao = {
  readonly __typename?: 'AtendimentoProfissionalAtencaoDomiciliarQuestao'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly situacaoAtiva?: Maybe<Scalars['Boolean']['output']>
}

export type AtendimentoProfissionalObservacao = {
  readonly __typename?: 'AtendimentoProfissionalObservacao'
  readonly atendimentoObservacao: AtendimentoObservacao
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly id: Scalars['ID']['output']
}

export type AtendimentoProfissionalOdonto = {
  readonly __typename?: 'AtendimentoProfissionalOdonto'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly cdsTipoFornecimOdonto?: Maybe<ReadonlyArray<Maybe<FornecimentoOdontoEnum>>>
  readonly evolucoes?: Maybe<ReadonlyArray<Maybe<EvolucaoProcedimentoOdonto>>>
  readonly id: Scalars['ID']['output']
  readonly observacaoRPC?: Maybe<Scalars['String']['output']>
  readonly odontograma?: Maybe<Odontograma>
  readonly periogramaCompleto?: Maybe<ReadonlyArray<Maybe<PeriogramaCompleto>>>
  readonly periogramaSimplificado?: Maybe<PeriogramaSimplificado>
  readonly tecidosMoles?: Maybe<ReadonlyArray<Maybe<TecidoMole>>>
  readonly tipoConduta?: Maybe<ReadonlyArray<Maybe<TipoEncaminhamentoOdontoEnum>>>
  readonly tipoConsultaOdonto?: Maybe<TipoConsultaOdontoEnum>
}

export type AtendimentoProfissionalPreNatal = {
  readonly __typename?: 'AtendimentoProfissionalPreNatal'
  readonly gravidezPlanejada?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly movimentacaoFetal?: Maybe<Scalars['Boolean']['output']>
  readonly preNatal?: Maybe<PreNatal>
  readonly tipoEdema?: Maybe<TipoEdemaEnum>
}

export type AtendimentoProfissionalPuericultura = {
  readonly __typename?: 'AtendimentoProfissionalPuericultura'
  readonly aleitamentoMaterno?: Maybe<TipoAleitamentoMaternoEnum>
  readonly id: Scalars['ID']['output']
  readonly neuroAlteracaoFenotipica?: Maybe<ReadonlyArray<Maybe<NeuroAlteracaoFenotipicaEvolucao>>>
  readonly neuroFatorRisco?: Maybe<ReadonlyArray<Maybe<NeuroFatorRiscoEvolucao>>>
  readonly neuroMarco?: Maybe<ReadonlyArray<Maybe<NeuroMarcoEvolucao>>>
}

export type AtendimentoPuericultura = {
  readonly __typename?: 'AtendimentoPuericultura'
  readonly dataInicio?: Maybe<Scalars['Instant']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly nomeProfissional?: Maybe<Scalars['String']['output']>
}

export type AtendimentoVacinacao = {
  readonly __typename?: 'AtendimentoVacinacao'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly condicaoMaternal?: Maybe<CondicaoMaternalDbEnum>
  readonly id: Scalars['ID']['output']
  readonly isComunicanteHanseniase?: Maybe<Scalars['Boolean']['output']>
  readonly isViajante?: Maybe<Scalars['Boolean']['output']>
  readonly prontuario: Prontuario
  readonly registrosVacinacao?: Maybe<ReadonlyArray<RegistroVacinacao>>
}

export type AtendimentoVacinacaoAprovacaoInput = {
  readonly atendimentoInput: AtendimentoVacinacaoInput
  readonly rascunho: Scalars['String']['input']
}

export type AtendimentoVacinacaoInput = {
  readonly condicoesVacinacao: CondicoesInput
  readonly finalizacaoVacinacao: FinalizacaoAtendimentoInput
  readonly id: Scalars['ID']['input']
  readonly imprimirAtendimento?: InputMaybe<Scalars['Boolean']['input']>
  readonly registroVacinacao: ReadonlyArray<RegistroVacinacaoInput>
}

export type AtendimentosFinalizadosInput = {
  readonly hasAssinatura?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams: PageParams
  readonly periodo?: InputMaybe<Period>
}

export type AtendimentosPayload = {
  readonly __typename?: 'AtendimentosPayload'
  readonly content: ReadonlyArray<Maybe<Atendimento>>
  readonly pageInfo: PageInfo
}

export type AtendimentosPreNatalPuerperioConsolidado = {
  readonly __typename?: 'AtendimentosPreNatalPuerperioConsolidado'
  readonly consultasOdontologicasGestacao?: Maybe<Scalars['Long']['output']>
  readonly consultasPreNatalGestacao?: Maybe<Scalars['Long']['output']>
  readonly consultasPrimeirasDozeSemanas?: Maybe<Scalars['Long']['output']>
  readonly consultasPuerperio?: Maybe<Scalars['Long']['output']>
  readonly dataUltimaConsultaPreNatal?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaConsultaPuerperio?: Maybe<Scalars['LocalDate']['output']>
}

export type AtendimentosProfissionalPayload = {
  readonly __typename?: 'AtendimentosProfissionalPayload'
  readonly content: ReadonlyArray<Maybe<AtendimentoProfissional>>
  readonly pageInfo: PageInfo
}

export type AtendimentosProfissionalQueryInput = {
  readonly cidadao?: InputMaybe<Scalars['ID']['input']>
  readonly dataInicioAfter?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicioBefore?: InputMaybe<Scalars['LocalDate']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly status?: InputMaybe<StatusAtendimentoProfissional>
}

export type AtendimentosQueryInput = {
  readonly dataFim?: InputMaybe<Scalars['Instant']['input']>
  readonly dataInicio?: InputMaybe<Scalars['Instant']['input']>
  readonly equipesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly isRegistroTardio?: InputMaybe<Scalars['Boolean']['input']>
  readonly ordem?: InputMaybe<OrdemListaAtendimentoEnum>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly responsaveisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly somenteMeusAtendimentos?: InputMaybe<Scalars['Boolean']['input']>
  readonly statusAtendimento?: InputMaybe<ReadonlyArray<StatusAtendimento>>
  readonly tiposServicoIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export type Atestado = {
  readonly __typename?: 'Atestado'
  readonly assinadoDigitalmente: Scalars['Boolean']['output']
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly cid10?: Maybe<Cid10>
  readonly dataHorarioAfastamento?: Maybe<Scalars['Instant']['output']>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly dias?: Maybe<Scalars['Int']['output']>
  readonly id: Scalars['ID']['output']
  readonly tipo?: Maybe<TipoAtestadoEnum>
}

export type AtestadoEmBrancoPlanoInput = {
  readonly assinadoDigitalmente: Scalars['Boolean']['input']
  readonly descricao: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
}

export type AtestadoModelo = {
  readonly __typename?: 'AtestadoModelo'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly profissional: Profissional
}

export type AtestadoModeloInput = {
  readonly descricao: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly nome: Scalars['String']['input']
}

export type AtestadoPadraoPlanoInput = {
  readonly assinadoDigitalmente: Scalars['Boolean']['input']
  readonly cid10Id?: InputMaybe<Scalars['ID']['input']>
  readonly cpfCns?: InputMaybe<Scalars['String']['input']>
  readonly date: Scalars['LocalDate']['input']
  readonly descricao: Scalars['String']['input']
  readonly dias: Scalars['Int']['input']
  readonly hora: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly naoPossui?: InputMaybe<Scalars['Boolean']['input']>
}

export type AtestadoPlanoInput = {
  readonly emBranco?: InputMaybe<ReadonlyArray<AtestadoEmBrancoPlanoInput>>
  readonly licencaMaternidade?: InputMaybe<ReadonlyArray<LicencaMaternidadePlanoInput>>
  readonly padrao?: InputMaybe<ReadonlyArray<AtestadoPadraoPlanoInput>>
  readonly solicitacaoFraldasGeriatricas?: InputMaybe<ReadonlyArray<SolicitacaoFraldasGeriatricasPlanoInput>>
}

export type AtestadoQueryInput = {
  readonly cboId?: InputMaybe<Scalars['ID']['input']>
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodo?: InputMaybe<Period>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteMeusAtestados?: InputMaybe<Scalars['Boolean']['input']>
}

export type AtestadoQueryPayload = {
  readonly __typename?: 'AtestadoQueryPayload'
  readonly content: ReadonlyArray<Maybe<Atestado>>
}

export type AtestadoSdcDto = {
  readonly __typename?: 'AtestadoSdcDto'
  readonly cid10?: Maybe<Cid10>
  readonly dias: Scalars['Int']['output']
  readonly tipoAtestado: TipoAtestadoEnum
}

export type AtivacaoAgendaOnlineInput = {
  readonly chave: Scalars['String']['input']
  readonly contraChave: Scalars['String']['input']
}

export type AtividadeColetiva = {
  readonly __typename?: 'AtividadeColetiva'
  readonly anotacoes?: Maybe<Scalars['String']['output']>
  readonly atividadeEducacaoPse: Scalars['Boolean']['output']
  readonly atividadeSaudePse: Scalars['Boolean']['output']
  readonly dataAtividade: Scalars['LocalDate']['output']
  readonly id: Scalars['ID']['output']
  readonly inepLocalAtividade?: Maybe<Inep>
  readonly lotacaoResponsavel: Lotacao
  readonly lotacoesEnvolvidas?: Maybe<ReadonlyArray<Maybe<Lotacao>>>
  readonly numeroAvaliacoesAlteradas?: Maybe<Scalars['Int']['output']>
  readonly numeroParticipantes: Scalars['Int']['output']
  readonly observacao?: Maybe<AtividadeColetivaObservacaoCidadao>
  readonly observacoes?: Maybe<ReadonlyArray<Maybe<AtividadeColetivaObservacaoCidadao>>>
  readonly outraLocalidade?: Maybe<Scalars['String']['output']>
  readonly participante?: Maybe<AtividadeColetivaRegistroParticipante>
  readonly participantes?: Maybe<ReadonlyArray<Maybe<AtividadeColetivaRegistroParticipante>>>
  readonly praticasSaude?: Maybe<ReadonlyArray<Maybe<PraticaSaudeEnum>>>
  readonly procedimento?: Maybe<Procedimento>
  readonly publicoAlvo?: Maybe<ReadonlyArray<Maybe<PublicoAlvoEnum>>>
  readonly registroEnviado: Scalars['Boolean']['output']
  readonly temasReuniao?: Maybe<ReadonlyArray<Maybe<TemaReuniaoEnum>>>
  readonly temasSaude?: Maybe<ReadonlyArray<Maybe<TemaSaudeEnum>>>
  readonly tipoAtividade: TipoAtividadeEnum
  readonly turno: TurnoEnum
  readonly unidadeSaudeLocalAtividade?: Maybe<UnidadeSaude>
  readonly uuid: Scalars['String']['output']
}

export type AtividadeColetivaObservacaoArgs = {
  cidadaoId: Scalars['Long']['input']
}

export type AtividadeColetivaParticipanteArgs = {
  cidadaoId: Scalars['Long']['input']
}

export type AtividadeColetivaCidadaoParticipante = {
  readonly __typename?: 'AtividadeColetivaCidadaoParticipante'
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly dataNascimento: Scalars['LocalDate']['output']
  readonly id: Scalars['ID']['output']
  readonly justificativaNaoPossuiCpf?: Maybe<JustificativaNaoPossuiCpfEnum>
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly sexo: SexoEnum
  readonly stNaoPossuiCpf?: Maybe<Scalars['Boolean']['output']>
}

export type AtividadeColetivaCidadaoParticipanteInput = {
  readonly cns?: InputMaybe<Scalars['String']['input']>
  readonly cpf?: InputMaybe<Scalars['String']['input']>
  readonly dataNascimento: Scalars['LocalDate']['input']
  readonly justificativaNaoPossuiCpf?: InputMaybe<JustificativaNaoPossuiCpfEnum>
  readonly nome?: InputMaybe<Scalars['String']['input']>
  readonly sexo: SexoEnum
  readonly stNaoPossuiCpf?: InputMaybe<Scalars['Boolean']['input']>
}

export type AtividadeColetivaInput = {
  readonly anotacoes?: InputMaybe<Scalars['String']['input']>
  readonly atividadeEducacaoPse: Scalars['Boolean']['input']
  readonly atividadeSaudePse: Scalars['Boolean']['input']
  readonly dataAtividade: Scalars['LocalDate']['input']
  readonly id?: InputMaybe<Scalars['Long']['input']>
  readonly inepLocalAtividadeId?: InputMaybe<Scalars['Long']['input']>
  readonly lotacaoEnvolvidaIds: ReadonlyArray<Scalars['ID']['input']>
  readonly lotacaoResponsavelId: Scalars['Long']['input']
  readonly numeroParticipantes: Scalars['Int']['input']
  readonly observacoes?: InputMaybe<ReadonlyArray<InputMaybe<AtividadeColetivaObservacaoCidadaoInput>>>
  readonly outraLocalidade?: InputMaybe<Scalars['String']['input']>
  readonly participantes?: InputMaybe<ReadonlyArray<InputMaybe<AtividadeColetivaRegistroParticipanteInput>>>
  readonly praticaSaudeEnums?: InputMaybe<ReadonlyArray<InputMaybe<PraticaSaudeEnum>>>
  readonly procedimentoId?: InputMaybe<Scalars['Long']['input']>
  readonly publicoAlvoEnums?: InputMaybe<ReadonlyArray<InputMaybe<PublicoAlvoEnum>>>
  readonly temaReuniaoEnums?: InputMaybe<ReadonlyArray<InputMaybe<TemaReuniaoEnum>>>
  readonly temaSaudeEnums?: InputMaybe<ReadonlyArray<InputMaybe<TemaSaudeEnum>>>
  readonly tipoAtividadeEnum: TipoAtividadeEnum
  readonly turnoEnum: TurnoEnum
  readonly unidadeSaudeLocalAtividadeId?: InputMaybe<Scalars['Long']['input']>
}

export type AtividadeColetivaObservacaoCidadao = {
  readonly __typename?: 'AtividadeColetivaObservacaoCidadao'
  readonly atividadeColetivaId: Scalars['Long']['output']
  readonly cidadao: Cidadao
  readonly id: Scalars['ID']['output']
  readonly observacao: Scalars['String']['output']
}

export type AtividadeColetivaObservacaoCidadaoInput = {
  readonly cidadaoId: Scalars['Long']['input']
  readonly observacao: Scalars['String']['input']
}

export type AtividadeColetivaPayload = {
  readonly __typename?: 'AtividadeColetivaPayload'
  readonly content: ReadonlyArray<Maybe<AtividadeColetiva>>
  readonly pageInfo: PageInfo
}

export type AtividadeColetivaQueryInput = {
  readonly cidadaoId?: InputMaybe<Scalars['Long']['input']>
  readonly equipesIne?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly isProcessado?: InputMaybe<Scalars['Boolean']['input']>
  readonly isReuniao?: InputMaybe<Scalars['Boolean']['input']>
  readonly nomeCnsCpfProfissionalResponsavel?: InputMaybe<Scalars['String']['input']>
  readonly origens?: InputMaybe<ReadonlyArray<OrigemDadoEnum>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodo?: InputMaybe<Period>
  readonly publicoAlvo?: InputMaybe<ReadonlyArray<PublicoAlvoEnum>>
  readonly temasReuniao?: InputMaybe<ReadonlyArray<TemaReuniaoEnum>>
  readonly tiposAtividade?: InputMaybe<ReadonlyArray<TipoAtividadeEnum>>
}

export type AtividadeColetivaRegistroParticipante = {
  readonly __typename?: 'AtividadeColetivaRegistroParticipante'
  readonly altura?: Maybe<Scalars['Float']['output']>
  readonly atividadeColetivaId: Scalars['Long']['output']
  readonly avaliacaoAlterada?: Maybe<Scalars['Boolean']['output']>
  readonly cidadao?: Maybe<Cidadao>
  readonly cidadaoParticipante?: Maybe<AtividadeColetivaCidadaoParticipante>
  readonly id: Scalars['ID']['output']
  readonly peso?: Maybe<Scalars['Float']['output']>
  readonly pnctAbandonouGrupo?: Maybe<Scalars['Boolean']['output']>
  readonly pnctCessouHabitoFumar?: Maybe<Scalars['Boolean']['output']>
}

export type AtividadeColetivaRegistroParticipanteInput = {
  readonly altura?: InputMaybe<Scalars['Float']['input']>
  readonly avaliacaoAlterada?: InputMaybe<Scalars['Boolean']['input']>
  readonly cidadaoId?: InputMaybe<Scalars['Long']['input']>
  readonly cidadaoParticipanteInput?: InputMaybe<AtividadeColetivaCidadaoParticipanteInput>
  readonly peso?: InputMaybe<Scalars['Float']['input']>
  readonly pnctAbandonouGrupo?: InputMaybe<Scalars['Boolean']['input']>
  readonly pnctCessouHabitoFumar?: InputMaybe<Scalars['Boolean']['input']>
}

export type AtualizarContatoCidadaoInput = {
  readonly cidadaoId: Scalars['Long']['input']
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly telefoneCelular?: InputMaybe<Scalars['String']['input']>
}

export type AtualizarEmailCidadaoInput = {
  readonly cidadaoId: Scalars['Long']['input']
  readonly email?: InputMaybe<Scalars['String']['input']>
}

export type AtualizarEnderecoTerritorioInput = {
  readonly bairro: Scalars['String']['input']
  readonly cep: Scalars['String']['input']
  readonly filter: TerritorioMicroareaQueryInput
  readonly logradouro: Scalars['String']['input']
  readonly progressToken: Scalars['String']['input']
  readonly tipoLogradouroNuDne: Scalars['String']['input']
}

export type AuditoriaHistorico = {
  readonly __typename?: 'AuditoriaHistorico'
  readonly csv?: Maybe<Scalars['Boolean']['output']>
  readonly dataFim: Scalars['LocalDate']['output']
  readonly dataInicio: Scalars['LocalDate']['output']
  readonly dataSolicitacao: Scalars['Instant']['output']
  readonly descricaoErro?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly status: StatusProcessoAuditoria
}

export type AuditoriaHistoricoPayload = {
  readonly __typename?: 'AuditoriaHistoricoPayload'
  readonly content: ReadonlyArray<Maybe<AuditoriaHistorico>>
  readonly pageInfo: PageInfo
}

export type AuditoriaHistoricoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
}

export type AuditoriaInput = {
  readonly componenteGerador?: InputMaybe<Scalars['String']['input']>
  readonly dataFim: Scalars['LocalDate']['input']
  readonly dataInicio: Scalars['LocalDate']['input']
  readonly detalheEvento?: InputMaybe<Scalars['String']['input']>
  readonly idRegistroAfetado?: InputMaybe<Scalars['String']['input']>
  readonly tipoArquivo: TipoArquivoEnum
  readonly tiposEvento?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly tiposRegistroAfetado?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly usuariosGerador?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
}

export type AuditoriaTipoEvento = {
  readonly __typename?: 'AuditoriaTipoEvento'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type AuditoriaTipoRegistroAfetado = {
  readonly __typename?: 'AuditoriaTipoRegistroAfetado'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type AutorizacaoRetiradaAbsorvente = {
  readonly __typename?: 'AutorizacaoRetiradaAbsorvente'
  readonly cidadao: CidadaoDignidadeMenstrual
  readonly codigoRms?: Maybe<Scalars['String']['output']>
  readonly hash?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly quantidadeCertificadoGerado?: Maybe<Scalars['Long']['output']>
  readonly ufRms?: Maybe<Scalars['String']['output']>
}

export type AutorizacaoRetiradaAbsorventeQueryPayload = {
  readonly __typename?: 'AutorizacaoRetiradaAbsorventeQueryPayload'
  readonly autorizacao?: Maybe<AutorizacaoRetiradaAbsorvente>
  readonly status: StatusAutorizacaoAbsorvente
}

export type AutorizarMunicipioInput = {
  readonly contraChave: Scalars['String']['input']
}

export type AvaliacaoAlergiaInput = {
  readonly alergiaId?: InputMaybe<Scalars['ID']['input']>
  readonly categoriaSubstancia: CategoriaSubstanciaAlergia
  readonly criticidade?: InputMaybe<CriticidadeAlergia>
  readonly dataInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly grauCerteza?: InputMaybe<GrauCertezaAlergia>
  readonly isAvaliacao?: InputMaybe<Scalars['Boolean']['input']>
  readonly manifestacoesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly substanciaId: Scalars['ID']['input']
  readonly tipoReacao?: InputMaybe<TipoReacaoAlergia>
}

export type AvaliacaoDesenvolvimento = {
  readonly dataAvaliacao?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly status: StatusAvaliadoEnum
}

export type AvaliacaoDesenvolvimentoInput = {
  readonly alcancadoComAnos?: InputMaybe<Scalars['Int']['input']>
  readonly alcancadoComMeses?: InputMaybe<Scalars['Int']['input']>
  readonly id: Scalars['ID']['input']
  readonly status?: InputMaybe<StatusAvaliadoEnum>
}

export type AvaliacaoInput = {
  readonly alergiasAvaliadas?: InputMaybe<ReadonlyArray<AvaliacaoAlergiaInput>>
  readonly encerrarGestacao?: InputMaybe<EncerrarGestacaoInput>
  readonly problemasCondicoesAvaliadas?: InputMaybe<ReadonlyArray<AvaliacaoProblemaInput>>
  readonly texto?: InputMaybe<Scalars['String']['input']>
  readonly vigilanciaSaudeBucal?: InputMaybe<VigilanciaSaudeBucalInput>
}

export type AvaliacaoProblemaInput = {
  readonly ciapId?: InputMaybe<Scalars['ID']['input']>
  readonly cid11Id?: InputMaybe<Scalars['ID']['input']>
  readonly cidId?: InputMaybe<Scalars['ID']['input']>
  readonly dataFim?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly incluirListaProblemas?: InputMaybe<Scalars['Boolean']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly problemaId?: InputMaybe<Scalars['ID']['input']>
  readonly situacao?: InputMaybe<SituacaoProblema>
}

export type Bairro = {
  readonly __typename?: 'Bairro'
  readonly dne: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly municipio: Municipio
  readonly nome: Scalars['String']['output']
}

export type BairroInput = {
  readonly municipioId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly ufId?: InputMaybe<Scalars['ID']['input']>
}

export type BairroQueryPayload = {
  readonly __typename?: 'BairroQueryPayload'
  readonly content: ReadonlyArray<Maybe<Bairro>>
  readonly pageInfo: PageInfo
}

export type BaseAcessoActions = {
  readonly permissaoAtivacaoInativacao: Action
  readonly permissaoEdicao: Action
  readonly permissaoExclusao: Action
}

export type BaseCalendarioVacinal = {
  readonly __typename?: 'BaseCalendarioVacinal'
  readonly descricaoImunobiologico: Scalars['String']['output']
  readonly dose: DoseImunobiologico
  readonly faixaEtaria: FaixaEtariaVacinacao
  readonly id: Scalars['ID']['output']
  readonly idadeRecomendada?: Maybe<Scalars['String']['output']>
  readonly imunobiologico: Imunobiologico
  readonly mostrarNoCalendarioDoGrupo: Scalars['Boolean']['output']
  readonly ordemImuno: Scalars['Int']['output']
}

export type BeneficiarioBolsaFamilia = {
  readonly __typename?: 'BeneficiarioBolsaFamilia'
  readonly id: Scalars['ID']['output']
  readonly isBeneficiario: Scalars['Boolean']['output']
  readonly vigencia?: Maybe<Scalars['String']['output']>
}

export enum BeneficioDbEnum {
  APOSENTADO = 'APOSENTADO',
  BENEFICIO_DE_PRESTACAO_CONTINUADA = 'BENEFICIO_DE_PRESTACAO_CONTINUADA',
  BOLSA_FAMILIA = 'BOLSA_FAMILIA',
  CESTA_DE_ALIMENTO = 'CESTA_DE_ALIMENTO',
  LEITE_NAO_HUMANO = 'LEITE_NAO_HUMANO',
  NAO_RECEBE_BENEFICIO_SOCIAL = 'NAO_RECEBE_BENEFICIO_SOCIAL',
  OUTROS_BENEFICIOS = 'OUTROS_BENEFICIOS',
}

export type BundleFhirComAssinaturaPendente = {
  readonly __typename?: 'BundleFhirComAssinaturaPendente'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly tipoRegistroRndsEnum: TipoRegistroRndsEnum
}

export type BuscaAtivaVacinaImuno = {
  readonly __typename?: 'BuscaAtivaVacinaImuno'
  readonly cidadaoId: Scalars['ID']['output']
  readonly dataAplicacaoVacina?: Maybe<Scalars['LocalDate']['output']>
  readonly doseId?: Maybe<Scalars['Long']['output']>
  readonly imunobiologicoId?: Maybe<Scalars['Long']['output']>
  readonly nome: Scalars['String']['output']
  readonly siglaDose: Scalars['String']['output']
}

export type BuscaAtivaVacinacaoDto = {
  readonly __typename?: 'BuscaAtivaVacinacaoDto'
  readonly cidadaoId?: Maybe<Scalars['ID']['output']>
  readonly cnsCidadao?: Maybe<Scalars['String']['output']>
  readonly cpfCidadao?: Maybe<Scalars['String']['output']>
  readonly dataNascimentoCidadao: Scalars['LocalDate']['output']
  readonly endereco?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly nomeSocialOuNomeCidadao: Scalars['String']['output']
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly telefoneResidencial?: Maybe<Scalars['String']['output']>
  readonly vacinasAplicadas?: Maybe<ReadonlyArray<Maybe<BuscaAtivaVacinaImuno>>>
  readonly vacinasAtrasadas?: Maybe<ReadonlyArray<Maybe<BuscaAtivaVacinaImuno>>>
  readonly vacinasNoPrazo?: Maybe<ReadonlyArray<Maybe<BuscaAtivaVacinaImuno>>>
}

export type BuscaAtivaVacinacaoFiltrosAvancadosInput = {
  readonly bairro?: InputMaybe<Scalars['String']['input']>
  readonly doseIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly grupoAtendimentoIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly imunobiologicoIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly logradouro?: InputMaybe<Scalars['String']['input']>
  readonly nomeTipoLogradouro?: InputMaybe<Scalars['String']['input']>
}

export type BuscaAtivaVacinacaoInput = {
  readonly equipeVinculadaIne: Scalars['String']['input']
  readonly faixaEtaria?: InputMaybe<FaixaEtariaInput>
  readonly filtrosAvancados?: InputMaybe<BuscaAtivaVacinacaoFiltrosAvancadosInput>
  readonly grupoAlvo: GrupoAlvoBuscaAtivaVacinacaoEnum
  readonly microareas?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly status?: InputMaybe<StatusVacinacaoEnum>
  readonly tipoVisualizacao: TipoVisualizacaoBuscaAtivaVacinacaoEnum
}

export type BuscaAtivaVacinacaoPayload = {
  readonly __typename?: 'BuscaAtivaVacinacaoPayload'
  readonly content: ReadonlyArray<BuscaAtivaVacinacaoDto>
  readonly pageInfo: PageInfo
}

export type BuscaCidadaoCadsusInput = {
  readonly cidadao: Scalars['ID']['input']
  readonly uuid: Scalars['String']['input']
}

export type BuscaCidadaosCadsusResultDto = {
  readonly __typename?: 'BuscaCidadaosCadsusResultDto'
  readonly cidadaos?: Maybe<ReadonlyArray<Maybe<CidadaoCadsus>>>
  readonly resultCadsus?: Maybe<SincronizacaoCadsusResultEnum>
  readonly usuario: Scalars['ID']['output']
  readonly uuid: Scalars['String']['output']
}

export type BuscaListaCidadaoCadsusInput = {
  readonly query: CidadaosQueryInput
  readonly uuid: Scalars['String']['input']
}

export enum BuscaPeriodoEnum {
  PERIODO_ENTROU_EM_AD = 'PERIODO_ENTROU_EM_AD',
  PERIODO_NENHUM = 'PERIODO_NENHUM',
  PERIODO_PROXIMA_VISITA = 'PERIODO_PROXIMA_VISITA',
  PERIODO_REGISTRO_OBITO = 'PERIODO_REGISTRO_OBITO',
  PERIODO_ULTIMA_VISITA = 'PERIODO_ULTIMA_VISITA',
}

export type CadastroEnderecoEnvioDto = {
  readonly __typename?: 'CadastroEnderecoEnvioDto'
  readonly errorImportacaoCnes?: Maybe<LocalidadeCnesDesatualizadoDto>
  readonly errorLogin?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly pedidoEnvioBase?: Maybe<PedidoEnvioBase>
}

export type CampoAlteradoCadsus = {
  readonly __typename?: 'CampoAlteradoCadsus'
  readonly campo?: Maybe<Scalars['String']['output']>
  readonly conteudo?: Maybe<Scalars['String']['output']>
}

export type CampoSalvoRelatorioGerencial = {
  readonly __typename?: 'CampoSalvoRelatorioGerencial'
  readonly items: ReadonlyArray<Scalars['String']['output']>
  readonly key: Scalars['String']['output']
  readonly posicao: PosicaoCampoRelatorioGerencialEnum
}

export type CampoSalvoRelatorioGerencialInput = {
  readonly items: ReadonlyArray<Scalars['String']['input']>
  readonly key: Scalars['String']['input']
  readonly posicao: PosicaoCampoRelatorioGerencialEnum
}

export type CancelarAgendamentoInput = {
  readonly enviarEmailCidadao: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
  readonly justificativa: JustificativaCancelarAgendamentoEnum
  readonly justificativaOutra?: InputMaybe<Scalars['String']['input']>
}

export type CancelarSolicitacaoEntradaVideochamadaInput = {
  readonly participanteId: Scalars['ID']['input']
  readonly videochamadaUuid: Scalars['String']['input']
}

export type CancelarSolicitacaoEnvioInput = {
  readonly solicitacaoId: Scalars['ID']['input']
}

export type CaracteristicaLesao = {
  readonly __typename?: 'CaracteristicaLesao'
  readonly caracteristicaLesao: CaracteristicaLesaoEnum
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export enum CaracteristicaLesaoEnum {
  BASE_PEDICULADA = 'BASE_PEDICULADA',
  BASE_SESSIL = 'BASE_SESSIL',
  CONSISTENCIA_DURA = 'CONSISTENCIA_DURA',
  CONSISTENCIA_FIRME = 'CONSISTENCIA_FIRME',
  CONSISTENCIA_MOLE = 'CONSISTENCIA_MOLE',
  COR_ACASTANHADA = 'COR_ACASTANHADA',
  COR_BRANCA = 'COR_BRANCA',
  COR_VERMELHA = 'COR_VERMELHA',
  COR_VIOLACEA = 'COR_VIOLACEA',
  LESAO_LIQUIDA_PUSTULA = 'LESAO_LIQUIDA_PUSTULA',
  LESAO_LIQUIDA_VESICULA = 'LESAO_LIQUIDA_VESICULA',
  LESAO_PLANA_MACULA = 'LESAO_PLANA_MACULA',
  LESAO_PLANA_PAPULA = 'LESAO_PLANA_PAPULA',
  LESAO_PLANA_PLACA = 'LESAO_PLANA_PLACA',
  LESAO_PLANA_PSEUDOMEMBRANA = 'LESAO_PLANA_PSEUDOMEMBRANA',
  LESAO_PLANA_TUMEFACAO = 'LESAO_PLANA_TUMEFACAO',
  LESAO_TECIDUAL_EROSAO = 'LESAO_TECIDUAL_EROSAO',
  LESAO_TECIDUAL_FISSURA = 'LESAO_TECIDUAL_FISSURA',
  LESAO_TECIDUAL_ULCERA = 'LESAO_TECIDUAL_ULCERA',
  QUANTIDADE_BILATERAL = 'QUANTIDADE_BILATERAL',
  QUANTIDADE_MULTIPLAS = 'QUANTIDADE_MULTIPLAS',
  QUANTIDADE_UNICA = 'QUANTIDADE_UNICA',
  SINTOMATOLOGIA_ARDENCIA = 'SINTOMATOLOGIA_ARDENCIA',
  SINTOMATOLOGIA_AUSENTE = 'SINTOMATOLOGIA_AUSENTE',
  SINTOMATOLOGIA_DOR = 'SINTOMATOLOGIA_DOR',
  SINTOMATOLOGIA_PARESTESIA = 'SINTOMATOLOGIA_PARESTESIA',
  SUPERFICIE_GLANULOMATOSA = 'SUPERFICIE_GLANULOMATOSA',
  SUPERFICIE_LISA = 'SUPERFICIE_LISA',
  SUPERFICIE_NECROSADA = 'SUPERFICIE_NECROSADA',
  SUPERFICIE_RUGOSA = 'SUPERFICIE_RUGOSA',
  SUPERFICIE_ULCERADA = 'SUPERFICIE_ULCERADA',
  TAMANHO_ACIMA_DE_10 = 'TAMANHO_ACIMA_DE_10',
  TAMANHO_ATE_4 = 'TAMANHO_ATE_4',
  TAMANHO_ENTRE_5_E_10 = 'TAMANHO_ENTRE_5_E_10',
}

export enum CategoriaArquivoAtendProfEnum {
  EXAME_DE_IMAGEM = 'EXAME_DE_IMAGEM',
  EXAME_DE_IMAGEM_ODONTOLOGICO = 'EXAME_DE_IMAGEM_ODONTOLOGICO',
  EXAME_LABORATORIAL = 'EXAME_LABORATORIAL',
  IMAGEM_DE_LESAO = 'IMAGEM_DE_LESAO',
  PRESCRICAO_DE_MEDICAMENTOS = 'PRESCRICAO_DE_MEDICAMENTOS',
  PRONTUARIO_EXTERNO = 'PRONTUARIO_EXTERNO',
}

export type CategoriaMedicamento = {
  readonly __typename?: 'CategoriaMedicamento'
  readonly categoriasCompativeis: ReadonlyArray<ListaMedicamentoEnum>
  readonly disponivelParaPrescricaoDigital: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: ListaMedicamentoEnum
}

export enum CategoriaProblemaEnum {
  CIAP = 'CIAP',
  CID10 = 'CID10',
  CID10_PRINCIPAL = 'CID10_PRINCIPAL',
  CID10_SECUNDARIO_DOIS = 'CID10_SECUNDARIO_DOIS',
  CID10_SECUNDARIO_UM = 'CID10_SECUNDARIO_UM',
  EXAME = 'EXAME',
  OUTRO = 'OUTRO',
}

export enum CategoriaSubstanciaAlergia {
  ALIMENTO = 'ALIMENTO',
  AMBIENTE = 'AMBIENTE',
  BIOLOGICO = 'BIOLOGICO',
  MEDICAMENTO = 'MEDICAMENTO',
}

export enum CategoriaSubstanciaAlergiaLegado {
  ALIMENTO = 'ALIMENTO',
  ANIMAL = 'ANIMAL',
  FARMACO_PRESENTE = 'FARMACO_PRESENTE',
  INGREDIENTE_NAO_ATIVO = 'INGREDIENTE_NAO_ATIVO',
  OUTRAS_SUBSTANCIAS = 'OUTRAS_SUBSTANCIAS',
  OUTROS = 'OUTROS',
  PRODUTO_AMBIENTAL = 'PRODUTO_AMBIENTAL',
}

export type Cbo = {
  readonly __typename?: 'Cbo'
  readonly actions?: Maybe<CboActions>
  readonly cbo2002: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type CboActions = {
  readonly __typename?: 'CboActions'
  readonly atividadeColetiva: Action
  readonly cadastroDomiciliar: Action
  readonly cadastroIndividual: Action
}

export type CboDisponibilizarFormInput = {
  readonly disponivelLotacao: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
}

export type CboDuracaoFormInput = {
  readonly duracao?: InputMaybe<Scalars['Int']['input']>
  readonly id: Scalars['ID']['input']
}

export type CboGrupo = {
  readonly __typename?: 'CboGrupo'
  readonly cbos?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly grupo: AcessoCbo
}

export type CboMunicipio = {
  readonly __typename?: 'CboMunicipio'
  readonly actions: CboMunicipioActions
  readonly cbo: Cbo
  readonly disponivelLotacao?: Maybe<Scalars['Boolean']['output']>
  readonly duracao?: Maybe<Scalars['Int']['output']>
  readonly duracaoPadrao?: Maybe<Scalars['Int']['output']>
  readonly possuiLotacaoComAgendaOnline?: Maybe<Scalars['Boolean']['output']>
}

export type CboMunicipioActions = {
  readonly __typename?: 'CboMunicipioActions'
  readonly inativar: Action
}

export type CboPayload = {
  readonly __typename?: 'CboPayload'
  readonly content: ReadonlyArray<Cbo>
  readonly pageInfo: PageInfo
}

export type CbosCuidadoCompartilhadoDto = {
  readonly __typename?: 'CbosCuidadoCompartilhadoDto'
  readonly cbo: Cbo
  readonly isCuidado?: Maybe<Scalars['Boolean']['output']>
  readonly isGuia?: Maybe<Scalars['Boolean']['output']>
  readonly isVinculado?: Maybe<Scalars['Boolean']['output']>
}

export type CbosCuidadoCompartilhadoPayload = {
  readonly __typename?: 'CbosCuidadoCompartilhadoPayload'
  readonly content: ReadonlyArray<CbosCuidadoCompartilhadoDto>
  readonly pageInfo: PageInfo
}

export type CbosCuidadoCompartilhadoQueryInput = {
  readonly onlyEmulti?: InputMaybe<Scalars['Boolean']['input']>
  readonly onlyOdontologico?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type CbosListaCuidadoCompartilhadoQueryInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly role: CuidadoCompartilhadoQueryFilterEnum
  readonly somenteSemExecutante: Scalars['Boolean']['input']
}

export type CbosQueryInput = {
  readonly cboSupervisor?: InputMaybe<Scalars['String']['input']>
  readonly equipeVinculadaId?: InputMaybe<Scalars['ID']['input']>
  readonly excludeProfissionaisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly mostrarIndisponivelLotacao?: InputMaybe<Scalars['Boolean']['input']>
  readonly nivelSuperior?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly profissionalPrescritor?: InputMaybe<Scalars['Boolean']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type CbosQueryPayload = {
  readonly __typename?: 'CbosQueryPayload'
  readonly content: ReadonlyArray<Maybe<CboMunicipio>>
  readonly pageInfo: PageInfo
}

export type CbosTrocaExecutanteCuidadoCompartilhadoQueryInput = {
  readonly equipeExecutanteId?: InputMaybe<Scalars['ID']['input']>
  readonly equipeSolicitanteId?: InputMaybe<Scalars['ID']['input']>
  readonly estabelecimentoReferenciaId?: InputMaybe<Scalars['ID']['input']>
  readonly excludeProfissionaisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly onlyVinculacaoEquipe: Scalars['Boolean']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum CdsOrigemEnum {
  ANDROID_AC = 'ANDROID_AC',
  ANDROID_ACS = 'ANDROID_ACS',
  APP_VACINACAO = 'APP_VACINACAO',
  EXTERNO = 'EXTERNO',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  PEC = 'PEC',
  TODAS = 'TODAS',
}

export type Certificado = {
  readonly __typename?: 'Certificado'
  readonly nome: Scalars['String']['output']
  readonly path: Scalars['ID']['output']
}

export type CertificadoPayload = {
  readonly __typename?: 'CertificadoPayload'
  readonly content: ReadonlyArray<Maybe<Certificado>>
}

export type CertificadoQueryInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type ChamarPainelInput = {
  readonly atendimentoId: Scalars['ID']['input']
  readonly salaId: Scalars['ID']['input']
  readonly tipoAtendimentoPainelChamada: TipoAtendimentoPainelChamadaEnum
}

export type Ciap = {
  readonly __typename?: 'Ciap'
  readonly cid10Encaminhamento?: Maybe<Cid10>
  readonly codigo: Scalars['String']['output']
  readonly descricao: Scalars['String']['output']
  readonly exclui?: Maybe<Scalars['String']['output']>
  readonly gruposCondicao?: Maybe<ReadonlyArray<GrupoCondicao>>
  readonly id: Scalars['ID']['output']
  readonly inclui?: Maybe<Scalars['String']['output']>
}

export type CiapByCodigosQueryInput = {
  readonly codigos: ReadonlyArray<Scalars['String']['input']>
}

export enum CiapCapituloEnum {
  CIRCULATORIO = 'CIRCULATORIO',
  DIGESTIVO = 'DIGESTIVO',
  ENDOCRINO_METABOLICO_NUTRICIONAL = 'ENDOCRINO_METABOLICO_NUTRICIONAL',
  GENITAL_FEMININO = 'GENITAL_FEMININO',
  GENITAL_MASCULINO = 'GENITAL_MASCULINO',
  GERAL_INESPECIFICO = 'GERAL_INESPECIFICO',
  GRAVIDEZ_PARTO_PLANEJAMENTO_FAMILIAR = 'GRAVIDEZ_PARTO_PLANEJAMENTO_FAMILIAR',
  MUSCULO_ESQUELETICO = 'MUSCULO_ESQUELETICO',
  NEUROLOGICO = 'NEUROLOGICO',
  OLHO = 'OLHO',
  OUVIDO = 'OUVIDO',
  PELE = 'PELE',
  PROBLEMAS_SOCIAIS = 'PROBLEMAS_SOCIAIS',
  PROCEDIMENTOS = 'PROCEDIMENTOS',
  PSICOLOGICO = 'PSICOLOGICO',
  RESPIRATORIO = 'RESPIRATORIO',
  SANGUE_SISTEMA_HEMATOPOIETICO_LINFATICO_BACO = 'SANGUE_SISTEMA_HEMATOPOIETICO_LINFATICO_BACO',
  URINARIO = 'URINARIO',
}

export type CiapCidSugestao = {
  readonly __typename?: 'CiapCidSugestao'
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly dataRegistroProblema?: Maybe<Scalars['String']['output']>
}

export type CiapPlanoInput = {
  readonly ciapId: Scalars['ID']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
}

export type CiapQueryInput = {
  readonly capitulosExcluidos?: InputMaybe<ReadonlyArray<InputMaybe<CiapCapituloEnum>>>
  readonly capitulosIncluidos?: InputMaybe<ReadonlyArray<InputMaybe<CiapCapituloEnum>>>
  readonly ciapComCid10Encaminhamento?: InputMaybe<Scalars['Boolean']['input']>
  readonly excluirCIAPsDAB?: InputMaybe<Scalars['Boolean']['input']>
  readonly idadeCidadaoEmAnos?: InputMaybe<Scalars['Int']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly sexo?: InputMaybe<SexoEnum>
}

export type CiapQueryPayLoad = {
  readonly __typename?: 'CiapQueryPayLoad'
  readonly content: ReadonlyArray<Ciap>
  readonly pageInfo: PageInfo
}

export type Cid10 = {
  readonly __typename?: 'Cid10'
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly ciapsRelacionadas?: Maybe<ReadonlyArray<Maybe<Ciap>>>
  readonly codigo: Scalars['String']['output']
  readonly gruposCondicao?: Maybe<ReadonlyArray<GrupoCondicao>>
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sexo?: Maybe<Scalars['String']['output']>
}

export type Cid10QueryInput = {
  readonly ciapRelacionada?: InputMaybe<Scalars['ID']['input']>
  readonly idadeCidadaoEmAnos?: InputMaybe<Scalars['Int']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly parteBucal?: InputMaybe<ParteBucalEnum>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly sexo?: InputMaybe<SexoEnum>
  readonly somenteRelacionados?: InputMaybe<Scalars['Boolean']['input']>
}

export type Cid10QueryPayLoad = {
  readonly __typename?: 'Cid10QueryPayLoad'
  readonly content: ReadonlyArray<Maybe<Cid10>>
  readonly pageInfo: PageInfo
}

export type Cid11 = {
  readonly __typename?: 'Cid11'
  readonly ativo: Scalars['Boolean']['output']
  readonly codigo: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type Cid11QueryInput = {
  readonly cid10Id: Scalars['ID']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type Cid11QueryPayLoad = {
  readonly __typename?: 'Cid11QueryPayLoad'
  readonly content: ReadonlyArray<Cid11>
  readonly pageInfo: PageInfo
}

export type Cidadao = {
  readonly __typename?: 'Cidadao'
  readonly area?: Maybe<Scalars['String']['output']>
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly beneficiarioBolsaFamilia: BeneficiarioBolsaFamilia
  readonly cbo?: Maybe<Cbo>
  readonly cidadaoAldeado?: Maybe<CidadaoAldeado>
  readonly cidadaoConsolidado?: Maybe<CidadaoConsolidado>
  readonly cidadaoNucleoFamiliar?: Maybe<CidadaoNucleoFamiliar>
  readonly cidadaoVinculacaoEquipe?: Maybe<CidadaoVinculacaoEquipe>
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly condicoesSaudeAutorreferidas?: Maybe<CondicoesSaudeAutorreferidas>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly cpfCnsCuidador?: Maybe<Scalars['String']['output']>
  readonly cpfCnsResponsavel?: Maybe<Scalars['String']['output']>
  readonly dataAtualizado?: Maybe<Scalars['Instant']['output']>
  readonly dataEntradaBrasil?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNaturalizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataObito?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaRecusa?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimoAtendimento?: Maybe<Scalars['LocalDate']['output']>
  readonly desconheceNomeMae?: Maybe<Scalars['Boolean']['output']>
  readonly desconheceNomePai?: Maybe<Scalars['Boolean']['output']>
  readonly desejaInformarIdentidadeGenero?: Maybe<Scalars['Boolean']['output']>
  readonly desejaInformarOrientacaoSexual?: Maybe<Scalars['Boolean']['output']>
  readonly dtNascimentoCuidador?: Maybe<Scalars['LocalDate']['output']>
  readonly dtNascimentoResponsavel?: Maybe<Scalars['LocalDate']['output']>
  readonly email?: Maybe<Scalars['String']['output']>
  readonly endereco?: Maybe<Endereco>
  readonly enderecoIndigena?: Maybe<EnderecoIndigena>
  readonly equipeAtendimentoAd?: Maybe<Equipe>
  readonly escolaridade?: Maybe<Escolaridade>
  readonly estadoCivil?: Maybe<EstadoCivil>
  readonly etnia?: Maybe<Etnia>
  readonly faleceu?: Maybe<Scalars['Boolean']['output']>
  readonly familias: ReadonlyArray<Familia>
  readonly id: Scalars['ID']['output']
  readonly identidadeGeneroDbEnum?: Maybe<IdentidadeGeneroEnum>
  readonly informacoesSocioEconomicas?: Maybe<InformacoesSocioEconomicas>
  readonly informacoesSocioEconomicasDW?: Maybe<InformacoesSocioEconomicasDw>
  readonly informacoesSociodemograficas?: Maybe<InformacoesSociodemograficas>
  readonly isCidadaoAusente?: Maybe<Scalars['Boolean']['output']>
  readonly isCpfCadsus?: Maybe<Scalars['Boolean']['output']>
  readonly justificativaNaoPossuiCpf?: Maybe<JustificativaNaoPossuiCpfEnum>
  readonly localidadeExterior?: Maybe<Scalars['String']['output']>
  readonly localidadeNascimento?: Maybe<Municipio>
  readonly microArea?: Maybe<Scalars['String']['output']>
  readonly nacionalidade?: Maybe<Nacionalidade>
  readonly naoPossuiCuidador?: Maybe<Scalars['Boolean']['output']>
  readonly nisPisPasep?: Maybe<Scalars['String']['output']>
  readonly nome: Scalars['String']['output']
  readonly nomeCuidador?: Maybe<Scalars['String']['output']>
  readonly nomeMae?: Maybe<Scalars['String']['output']>
  readonly nomePai?: Maybe<Scalars['String']['output']>
  readonly nomeResponsavel?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
  readonly nomeTradicional?: Maybe<Scalars['String']['output']>
  readonly numeroDnv?: Maybe<Scalars['String']['output']>
  readonly numeroDocumentoObito?: Maybe<Scalars['String']['output']>
  readonly numeroFamilia?: Maybe<Scalars['String']['output']>
  readonly orientacaoSexualDbEnum?: Maybe<OrientacaoSexualEnum>
  readonly paisExterior?: Maybe<Pais>
  readonly paisNascimento?: Maybe<Pais>
  readonly periodoAusenciaList?: Maybe<ReadonlyArray<Maybe<PeriodoAusencia>>>
  readonly portariaNaturalizacao?: Maybe<Scalars['String']['output']>
  readonly possuiAgendamento?: Maybe<Scalars['Boolean']['output']>
  readonly presenteListaAtendimento?: Maybe<Scalars['Boolean']['output']>
  readonly prontuario?: Maybe<Prontuario>
  readonly racaCor: RacaCor
  readonly sexo: SexoEnum
  readonly situacaoDeRua?: Maybe<SituacaoDeRua>
  readonly stCompartilhaProntuario?: Maybe<Scalars['Boolean']['output']>
  readonly stNaoPossuiCpf?: Maybe<Scalars['Boolean']['output']>
  readonly stRegistroCadsus?: Maybe<Scalars['Boolean']['output']>
  readonly statusForaArea?: Maybe<Scalars['Boolean']['output']>
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly telefoneResidencial?: Maybe<Scalars['String']['output']>
  readonly tipoCuidador?: Maybe<RelacaoCidadaoCuidador>
  readonly tipoEndereco?: Maybe<TipoEnderecoEnum>
  readonly tipoLocalNascimento?: Maybe<TipoLocalNascimentoEnum>
  readonly tipoSanguineoEnum?: Maybe<TipoSanguineoEnum>
  readonly ultimaDum?: Maybe<Dum>
  readonly unificacaoBase?: Maybe<Scalars['String']['output']>
  readonly unificado?: Maybe<Scalars['Boolean']['output']>
  readonly uuidUltimaFicha?: Maybe<Scalars['String']['output']>
}

export type CidadaoFamiliasArgs = {
  input?: InputMaybe<FamiliasImovelInput>
}

export type CidadaoAldeado = {
  readonly __typename?: 'CidadaoAldeado'
  readonly aldeiaNascimento?: Maybe<Aldeia>
  readonly beneficios?: Maybe<ReadonlyArray<Maybe<BeneficioDbEnum>>>
  readonly cadastroUnico?: Maybe<Scalars['String']['output']>
  readonly dtAusencia?: Maybe<Scalars['LocalDate']['output']>
  readonly dtEmissao?: Maybe<Scalars['LocalDate']['output']>
  readonly dtReconhecimento?: Maybe<Scalars['LocalDate']['output']>
  readonly dtRetorno?: Maybe<Scalars['LocalDate']['output']>
  readonly folha?: Maybe<Scalars['Int']['output']>
  readonly funcaoSocial?: Maybe<FuncaoSocial>
  readonly id: Scalars['ID']['output']
  readonly livro?: Maybe<Scalars['Int']['output']>
  readonly localOcorrencia?: Maybe<LocalOcorrencia>
  readonly nomeTradicional?: Maybe<Scalars['String']['output']>
  readonly responsavelLegal?: Maybe<Scalars['String']['output']>
  readonly stChefeFamilia: Scalars['Boolean']['output']
  readonly ufNascimento?: Maybe<Uf>
  readonly unidadeFunai?: Maybe<Scalars['String']['output']>
}

export type CidadaoAldeadoInput = {
  readonly aldeiaNascimentoId?: InputMaybe<Scalars['Long']['input']>
  readonly beneficios: ReadonlyArray<InputMaybe<BeneficioDbEnum>>
  readonly cadastroUnico?: InputMaybe<Scalars['String']['input']>
  readonly dtAusencia?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dtEmissao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dtReconhecimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dtRetorno?: InputMaybe<Scalars['LocalDate']['input']>
  readonly folha?: InputMaybe<Scalars['Int']['input']>
  readonly funcaoSocial?: InputMaybe<Scalars['Long']['input']>
  readonly livro?: InputMaybe<Scalars['Int']['input']>
  readonly localOcorrenciaId?: InputMaybe<Scalars['Long']['input']>
  readonly nomeTradicional?: InputMaybe<Scalars['String']['input']>
  readonly responsavelLegal?: InputMaybe<Scalars['String']['input']>
  readonly stChefeFamilia: Scalars['Boolean']['input']
  readonly ufNascimentoId?: InputMaybe<Scalars['Long']['input']>
  readonly unidadeFunai?: InputMaybe<Scalars['String']['input']>
}

export type CidadaoAldeadoQueryInput = {
  readonly aldeia?: InputMaybe<Scalars['String']['input']>
  readonly dsei?: InputMaybe<Scalars['String']['input']>
  readonly etnia?: InputMaybe<Scalars['String']['input']>
  readonly naoIndigena?: InputMaybe<Scalars['Boolean']['input']>
  readonly poloBase?: InputMaybe<Scalars['String']['input']>
}

export type CidadaoBasico = {
  readonly __typename?: 'CidadaoBasico'
  readonly area?: Maybe<Scalars['String']['output']>
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly contato?: Maybe<ContatoCidadao>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly desejaInformarIdentidadeGenero?: Maybe<Scalars['Boolean']['output']>
  readonly equipeAtendimentoAd?: Maybe<Equipe>
  readonly id: Scalars['ID']['output']
  readonly identidadeGeneroDbEnum?: Maybe<IdentidadeGeneroEnum>
  readonly isCidadaoAusente?: Maybe<Scalars['Boolean']['output']>
  readonly microArea?: Maybe<Scalars['String']['output']>
  readonly nome: Scalars['String']['output']
  readonly nomeMae?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
  readonly nomeTradicional?: Maybe<Scalars['String']['output']>
  readonly presenteListaAtendimento?: Maybe<Scalars['Boolean']['output']>
  readonly racaCor?: Maybe<RacaCor>
  readonly sexo: SexoEnum
  readonly stCompartilhaProntuario?: Maybe<Scalars['Boolean']['output']>
  readonly statusResponsavelFamiliar?: Maybe<Scalars['Boolean']['output']>
  readonly ultimaDum?: Maybe<Dum>
  readonly uuidUltimaFicha?: Maybe<Scalars['String']['output']>
}

export type CidadaoCadsus = {
  readonly __typename?: 'CidadaoCadsus'
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly cpfOuCnsJaCadastradoBaseLocal?: Maybe<Scalars['Boolean']['output']>
  readonly dataEntradaBrasil?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNaturalizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataObito?: Maybe<Scalars['LocalDate']['output']>
  readonly email?: Maybe<Scalars['String']['output']>
  readonly endereco?: Maybe<Endereco>
  readonly etnia?: Maybe<Etnia>
  readonly municipioNascimento?: Maybe<Municipio>
  readonly municipioResidenciaExterior?: Maybe<Scalars['String']['output']>
  readonly nacionalidade?: Maybe<Nacionalidade>
  readonly nome: Scalars['String']['output']
  readonly nomeMae?: Maybe<Scalars['String']['output']>
  readonly nomePai?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
  readonly numeroPisPasep?: Maybe<Scalars['String']['output']>
  readonly obito?: Maybe<Scalars['String']['output']>
  readonly paisNascimento?: Maybe<Pais>
  readonly paisResidencia?: Maybe<Pais>
  readonly portariaNaturalizacao?: Maybe<Scalars['String']['output']>
  readonly racaCor?: Maybe<RacaCor>
  readonly sexo?: Maybe<SexoEnum>
  readonly telefoneCelular?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly telefoneContato?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly telefoneResidencial?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
}

export type CidadaoConsolidado = {
  readonly __typename?: 'CidadaoConsolidado'
  readonly desenvolvimentoInfantil?: Maybe<DesenvolvimentoInfantilConsolidado>
  readonly diabetes?: Maybe<DiabetesConsolidado>
  readonly hipertensao?: Maybe<HipertensaoConsolidado>
  readonly pessoaIdosa?: Maybe<PessoaIdosaConsolidado>
  readonly preNatalPuerperio?: Maybe<PreNatalPuerperioConsolidado>
  readonly saudeBucal?: Maybe<SaudeBucalConsolidado>
  readonly saudeMulher?: Maybe<SaudeMulherConsolidado>
}

export type CidadaoDignidadeMenstrual = {
  readonly __typename?: 'CidadaoDignidadeMenstrual'
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly id: Scalars['ID']['output']
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly nomeMae?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
}

export type CidadaoDuplicadoDto = {
  readonly __typename?: 'CidadaoDuplicadoDto'
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly nome?: Maybe<Scalars['String']['output']>
}

export type CidadaoInput = {
  readonly cidadaoAldeadoInput?: InputMaybe<CidadaoAldeadoInput>
  readonly cns?: InputMaybe<Scalars['String']['input']>
  readonly condicoesSaudeAutorreferidas?: InputMaybe<CondicoesSaudeAutorreferidasInput>
  readonly cpf?: InputMaybe<Scalars['String']['input']>
  readonly dataEntradaPais?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataNascimento: Scalars['LocalDate']['input']
  readonly dataNaturalizacao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataObito?: InputMaybe<Scalars['LocalDate']['input']>
  readonly desconheceNomeMae?: InputMaybe<Scalars['Boolean']['input']>
  readonly desconheceNomePai?: InputMaybe<Scalars['Boolean']['input']>
  readonly desejaInformarIdentidadeGenero: Scalars['Boolean']['input']
  readonly desejaInformarOrientacaoSexual: Scalars['Boolean']['input']
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly endereco?: InputMaybe<EnderecoInput>
  readonly enderecoIndigenaInput?: InputMaybe<EnderecoIndigenaInput>
  readonly estadoCivil?: InputMaybe<EstadoCivilEnum>
  readonly etniaId?: InputMaybe<Scalars['ID']['input']>
  readonly faleceu?: InputMaybe<Scalars['Boolean']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly identidadeGenero?: InputMaybe<IdentidadeGeneroEnum>
  readonly informacoesSocioEconomicas?: InputMaybe<InformacoesSocioEconomicasInput>
  readonly informacoesSociodemograficas?: InputMaybe<InformacoesSociodemograficasInput>
  readonly isCidadaoAldeado: Scalars['Boolean']['input']
  readonly justificativaNaoPossuiCpf?: InputMaybe<JustificativaNaoPossuiCpfEnum>
  readonly microarea?: InputMaybe<Scalars['String']['input']>
  readonly municipioNascimento?: InputMaybe<Scalars['ID']['input']>
  readonly municipioResidenciaExterior?: InputMaybe<Scalars['String']['input']>
  readonly nacionalidade: NacionalidadeEnum
  readonly nisPisPasep?: InputMaybe<Scalars['String']['input']>
  readonly nome: Scalars['String']['input']
  readonly nomeMae?: InputMaybe<Scalars['String']['input']>
  readonly nomePai?: InputMaybe<Scalars['String']['input']>
  readonly nomeSocial?: InputMaybe<Scalars['String']['input']>
  readonly numeroDeclaracaoObito?: InputMaybe<Scalars['String']['input']>
  readonly numeroDnv?: InputMaybe<Scalars['String']['input']>
  readonly numeroFamilia?: InputMaybe<Scalars['String']['input']>
  readonly orientacaoSexual?: InputMaybe<OrientacaoSexualEnum>
  readonly paisNascimento?: InputMaybe<Scalars['ID']['input']>
  readonly paisResidenciaId?: InputMaybe<Scalars['Long']['input']>
  readonly portariaNaturalizacao?: InputMaybe<Scalars['String']['input']>
  readonly racaCor: RacaCorDbEnum
  readonly sexo: SexoEnum
  readonly situacaoDeRua?: InputMaybe<SituacaoDeRuaInput>
  readonly stCompartilhaProntuario?: InputMaybe<Scalars['Boolean']['input']>
  readonly stNaoPossuiCpf?: InputMaybe<Scalars['Boolean']['input']>
  readonly stSituacaoDeRua?: InputMaybe<Scalars['Boolean']['input']>
  readonly statusForaArea?: InputMaybe<Scalars['Boolean']['input']>
  readonly telefoneCelular?: InputMaybe<Scalars['String']['input']>
  readonly telefoneContato?: InputMaybe<Scalars['String']['input']>
  readonly telefoneResidencial?: InputMaybe<Scalars['String']['input']>
  readonly tipoEndereco: TipoEnderecoEnum
  readonly tipoLocalNascimento?: InputMaybe<TipoLocalNascimentoEnum>
  readonly tipoSanguineoEnum?: InputMaybe<TipoSanguineoEnum>
  readonly vinculacaoCidadaoFamilia: VinculacaoCidadaoFamiliaInput
  readonly vinculacaoCidadaoTerritorio?: InputMaybe<VinculacaoCidadaoTerritorioInput>
}

export type CidadaoNucleoFamiliar = {
  readonly __typename?: 'CidadaoNucleoFamiliar'
  readonly cbo?: Maybe<Cbo>
  readonly cpfCnsResponsavel?: Maybe<Scalars['String']['output']>
  readonly equipe?: Maybe<Equipe>
  readonly grauParentescoResponsavelFamiliar?: Maybe<GrauParentescoEnum>
  readonly id: Scalars['ID']['output']
  readonly isResponsavel?: Maybe<Scalars['Boolean']['output']>
  readonly mudouSe?: Maybe<Scalars['Boolean']['output']>
  readonly profissional?: Maybe<Profissional>
  readonly responsavelFamiliar?: Maybe<CidadaoBasico>
  readonly unidadeSaude?: Maybe<UnidadeSaude>
}

export type CidadaoPossuiAgendamentoFuturoQueryInput = {
  readonly dataReferencia: Scalars['LocalDate']['input']
  readonly id: Scalars['ID']['input']
}

export type CidadaoPresenteOutroAtendimentoNaListaQueryInput = {
  readonly atendimentoIdDesconsiderar: Scalars['ID']['input']
  readonly cidadaoId: Scalars['ID']['input']
}

export type CidadaoTerritorio = {
  readonly __typename?: 'CidadaoTerritorio'
  readonly cidadaoAldeadoId?: Maybe<Scalars['ID']['output']>
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly dataEntradaBrasil?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNaturalizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataObito?: Maybe<Scalars['LocalDate']['output']>
  readonly desconheceNomeMae?: Maybe<Scalars['Boolean']['output']>
  readonly desconheceNomePai?: Maybe<Scalars['Boolean']['output']>
  readonly etniaId?: Maybe<Scalars['ID']['output']>
  readonly id: Scalars['ID']['output']
  readonly isFaleceu?: Maybe<Scalars['Boolean']['output']>
  readonly justificativaNaoPossuiCpf?: Maybe<Scalars['Long']['output']>
  readonly localidadeNascimentoId?: Maybe<Scalars['ID']['output']>
  readonly nacionalidadeDbEnum?: Maybe<NacionalidadeEnum>
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly nomeMae?: Maybe<Scalars['String']['output']>
  readonly nomePai?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
  readonly numeroDocumentoObito?: Maybe<Scalars['String']['output']>
  readonly paisNascimentoId?: Maybe<Scalars['ID']['output']>
  readonly permissaoSalvarImovel: Action
  readonly portariaNaturalizacao?: Maybe<Scalars['String']['output']>
  readonly racaCorDbEnum?: Maybe<RacaCorDbEnum>
  readonly sexo?: Maybe<SexoEnum>
  readonly stNaoPossuiCpf?: Maybe<Scalars['Boolean']['output']>
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly ufNascimentoId?: Maybe<Scalars['ID']['output']>
  readonly uuidCidadao?: Maybe<Scalars['ID']['output']>
}

export type CidadaoTerritorioBasico = {
  readonly __typename?: 'CidadaoTerritorioBasico'
  readonly cidadaoNucleoFamiliar?: Maybe<CidadaoNucleoFamiliar>
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly dataEntradaBrasil?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly dataNaturalizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly id: Scalars['ID']['output']
  readonly isFaleceu?: Maybe<Scalars['Boolean']['output']>
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
  readonly permissaoReterritorializar?: Maybe<Action>
  readonly prontuario?: Maybe<Prontuario>
  readonly sexo?: Maybe<SexoEnum>
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly ultimaFichaCadastrada?: Maybe<UltimaFichaCadastradaDto>
  readonly uuidCidadao?: Maybe<Scalars['ID']['output']>
}

export type CidadaoTerritorioInput = {
  readonly id: Scalars['ID']['input']
  readonly mudouSe?: InputMaybe<Scalars['Boolean']['input']>
  readonly registroObito?: InputMaybe<RegistroObitoInput>
}

export type CidadaoUnificacaoBase = {
  readonly __typename?: 'CidadaoUnificacaoBase'
  readonly cidadao: Cidadao
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['Long']['output']
}

export type CidadaoUnificacaoBaseInput = {
  readonly pageParams: PageParams
}

export type CidadaoUnificacaoBasePayload = {
  readonly __typename?: 'CidadaoUnificacaoBasePayload'
  readonly content: ReadonlyArray<Maybe<CidadaoUnificacaoBase>>
  readonly pageInfo: PageInfo
}

export type CidadaoVinculacaoEquipe = {
  readonly __typename?: 'CidadaoVinculacaoEquipe'
  readonly dataAtualizacaoCadastro?: Maybe<Scalars['Instant']['output']>
  readonly equipe?: Maybe<Equipe>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly tpCdsOrigem?: Maybe<CdsOrigemEnum>
  readonly unidadeSaude?: Maybe<UnidadeSaude>
  readonly utilizarCadastroIndividual?: Maybe<Scalars['Boolean']['output']>
}

export type CidadaoVinculacaoEquipeEquipeArgs = {
  mostrarInativas?: InputMaybe<Scalars['Boolean']['input']>
}

export type CidadaoVinculacaoEquipeUnidadeSaudeArgs = {
  mostrarInativas?: InputMaybe<Scalars['Boolean']['input']>
}

export type CidadaoVinculacaoFichaDto = {
  readonly __typename?: 'CidadaoVinculacaoFichaDto'
  readonly equipe?: Maybe<Equipe>
  readonly perguntaSaidaCadastroEnum?: Maybe<PerguntaSaidaCadastroEnum>
  readonly unidadeSaude?: Maybe<UnidadeSaude>
}

export type CidadaoVinculacaoFichaQueryInput = {
  readonly cnsCidadao?: InputMaybe<Scalars['String']['input']>
  readonly cpfCidadao?: InputMaybe<Scalars['String']['input']>
  readonly uuidFicha?: InputMaybe<Scalars['String']['input']>
}

export type CidadaoVinculacaoInput = {
  readonly cnes?: InputMaybe<Scalars['String']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly ine?: InputMaybe<Scalars['String']['input']>
  readonly utilizarFichaCadastroIndividual?: InputMaybe<Scalars['Boolean']['input']>
}

export type CidadaosAdQueryInput = {
  readonly condutaDesfecho?: InputMaybe<AtencaoDomiciliarCondutaDesfecho>
  readonly equipeId?: InputMaybe<Scalars['ID']['input']>
  readonly modalidade?: InputMaybe<AtencaoDomiciliarModalidade>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodoBusca?: InputMaybe<Period>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tipoBuscaPeriodo?: InputMaybe<Scalars['String']['input']>
}

export type CidadaosAdQueryPayload = {
  readonly __typename?: 'CidadaosAdQueryPayload'
  readonly content: ReadonlyArray<Maybe<AtencaoDomiciliarCidadao>>
  readonly pageInfo: PageInfo
}

export type CidadaosComboQueryInput = {
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly dataNascimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly emAtencaoDomiciliar?: InputMaybe<Scalars['Boolean']['input']>
  readonly limit?: InputMaybe<Scalars['Int']['input']>
  readonly municipioNascimento?: InputMaybe<Scalars['String']['input']>
  readonly nomeMae?: InputMaybe<Scalars['String']['input']>
  readonly obito?: InputMaybe<Scalars['Boolean']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type CidadaosFamiliaInput = {
  readonly mostrarInconsistentes: Scalars['Boolean']['input']
}

export type CidadaosPayload = {
  readonly __typename?: 'CidadaosPayload'
  readonly content: ReadonlyArray<Maybe<Cidadao>>
  readonly pageInfo: PageInfo
}

export type CidadaosQueryInput = {
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly cidadaoAldeado?: InputMaybe<CidadaoAldeadoQueryInput>
  readonly dataNascimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly documentosAnyOf?: InputMaybe<DocumentosCidadaoQueryInput>
  readonly emAtencaoDomiciliar?: InputMaybe<Scalars['Boolean']['input']>
  readonly ibgeMunicipioNascimento?: InputMaybe<Scalars['String']['input']>
  readonly idCidadaoList?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly idCidadaoUnificacao?: InputMaybe<Scalars['Long']['input']>
  readonly municipioNascimento?: InputMaybe<Scalars['String']['input']>
  readonly nomeMae?: InputMaybe<Scalars['String']['input']>
  readonly obito?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum ClassificacaoPrioridadeCuidadoEnum {
  ALTA = 'ALTA',
  BAIXA = 'BAIXA',
  MEDIA = 'MEDIA',
  MUITO_ALTA = 'MUITO_ALTA',
}

export enum ClassificacaoRisco {
  NAO_CLASSIFICADO = 'NAO_CLASSIFICADO',
  PEC_ALTA = 'PEC_ALTA',
  PEC_BAIXA = 'PEC_BAIXA',
  PEC_INTERMEDIARIA = 'PEC_INTERMEDIARIA',
  PEC_NAO_AGUDA = 'PEC_NAO_AGUDA',
}

export enum ClassificacaoRiscoEncaminhamentoEnum {
  ELETIVO = 'ELETIVO',
  EMERGENCIA = 'EMERGENCIA',
  PRIORITARIO = 'PRIORITARIO',
  URGENCIA = 'URGENCIA',
}

export enum ClassificacaoVulnerabilidadeFamiliar {
  HABITUAL = 'HABITUAL',
  INEQUIVOCA = 'INEQUIVOCA',
  SUGESTIVA = 'SUGESTIVA',
}

export type CompartilhamentoCuidadoPlanoDto = {
  readonly __typename?: 'CompartilhamentoCuidadoPlanoDto'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly cbo: Cbo
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly cidadaoAceitaAtendTic?: Maybe<Scalars['Boolean']['output']>
  readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
  readonly dataInicio: Scalars['Instant']['output']
  readonly discussao: Scalars['String']['output']
  readonly especialidade?: Maybe<EspecialidadeEsusReg>
  readonly id: Scalars['ID']['output']
  readonly isEncaminhamento: Scalars['Boolean']['output']
  readonly lotacaoExecutanteAtual?: Maybe<Lotacao>
  readonly lotacaoSolicitante: Lotacao
  readonly unidadeSaude?: Maybe<UnidadeSaude>
}

export type CompartilhamentoCuidadoPlanoInput = {
  readonly cboId: Scalars['ID']['input']
  readonly ciap?: InputMaybe<Scalars['ID']['input']>
  readonly cid10?: InputMaybe<Scalars['ID']['input']>
  readonly cidadaoAceitaAtendTic?: InputMaybe<Scalars['Boolean']['input']>
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly discussao: Scalars['String']['input']
  readonly especialidadeId?: InputMaybe<Scalars['ID']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly isEncaminhamento: Scalars['Boolean']['input']
  readonly lotacaoExecutanteId?: InputMaybe<Scalars['ID']['input']>
  readonly unidadeSaudeId?: InputMaybe<Scalars['ID']['input']>
}

export type CompartilhamentoCuidadoPlanoQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export type CompartilharVideochamadaInput = {
  readonly emailDestinatario: Scalars['String']['input']
  readonly videochamadaUuid: Scalars['String']['input']
}

export type Complexidade = {
  readonly __typename?: 'Complexidade'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sigla: Scalars['String']['output']
}

export type CondicaoAutorreferida = {
  readonly __typename?: 'CondicaoAutorreferida'
  readonly descricao: Scalars['String']['output']
}

export enum CondicaoMaternalDbEnum {
  GESTANTE = 'GESTANTE',
  NENHUMA = 'NENHUMA',
  PUERPERA = 'PUERPERA',
}

export enum CondicaoMaternalFiltroEnum {
  GESTANTE = 'GESTANTE',
  PUERPERA = 'PUERPERA',
  TODAS = 'TODAS',
}

export type CondicoesInput = {
  readonly condicaoMaternal?: InputMaybe<CondicaoMaternalDbEnum>
  readonly isComunicanteHanseniase?: InputMaybe<Scalars['Boolean']['input']>
  readonly isViajante?: InputMaybe<Scalars['Boolean']['input']>
}

export type CondicoesMoradia = {
  readonly __typename?: 'CondicoesMoradia'
  readonly id: Scalars['ID']['output']
  readonly isEnergiaEletricaDisponivel?: Maybe<Scalars['Boolean']['output']>
  readonly numeroComodos?: Maybe<Scalars['Int']['output']>
  readonly tipoAbastecimentoAgua?: Maybe<TipoAbastecimentoAguaEnum>
  readonly tipoAcessoDomicilio?: Maybe<TipoAcessoDomicilioEnum>
  readonly tipoDestinoLixo?: Maybe<TipoDestinoLixoEnum>
  readonly tipoDomicilio?: Maybe<TipoDomicilioEnum>
  readonly tipoEscoamentoSanitario?: Maybe<TipoEscoamentoSanitarioEnum>
  readonly tipoLocalizacao?: Maybe<TipoLocalizacaoEnum>
  readonly tipoMaterialParede?: Maybe<TipoMaterialParedeEnum>
  readonly tipoOrigemEnergiaEletrica?: Maybe<TipoOrigemEnergiaEletricaEnum>
  readonly tipoPosseTerra?: Maybe<TipoPosseTerraEnum>
  readonly tipoSituacaoMoradia?: Maybe<TipoSituacaoMoradiaEnum>
  readonly tipoTratamentoAgua?: Maybe<TipoTratamentoAguaEnum>
}

export type CondicoesMoradiaInput = {
  readonly isEnergiaEletricaDisponivel?: InputMaybe<Scalars['Boolean']['input']>
  readonly numeroComodos?: InputMaybe<Scalars['Int']['input']>
  readonly tipoAbastecimentoAgua?: InputMaybe<TipoAbastecimentoAguaEnum>
  readonly tipoAcessoDomicilio?: InputMaybe<TipoAcessoDomicilioEnum>
  readonly tipoDestinoLixo?: InputMaybe<TipoDestinoLixoEnum>
  readonly tipoDomicilio?: InputMaybe<TipoDomicilioEnum>
  readonly tipoEscoamentoSanitario?: InputMaybe<TipoEscoamentoSanitarioEnum>
  readonly tipoLocalizacao?: InputMaybe<TipoLocalizacaoEnum>
  readonly tipoMaterialParede?: InputMaybe<TipoMaterialParedeEnum>
  readonly tipoOrigemEnergiaEletrica?: InputMaybe<TipoOrigemEnergiaEletricaEnum>
  readonly tipoPosseTerra?: InputMaybe<TipoPosseTerraEnum>
  readonly tipoSituacaoMoradia?: InputMaybe<TipoSituacaoMoradiaEnum>
  readonly tipoTratamentoAgua?: InputMaybe<TipoTratamentoAguaEnum>
}

export type CondicoesSaudeAutorreferidas = {
  readonly __typename?: 'CondicoesSaudeAutorreferidas'
  readonly autodenominacaoPeso?: Maybe<PesoAutorreferidoEnum>
  readonly causaInternacaoUltimos12Meses?: Maybe<Scalars['String']['output']>
  readonly condicaoSaude1?: Maybe<Scalars['String']['output']>
  readonly condicaoSaude2?: Maybe<Scalars['String']['output']>
  readonly condicaoSaude3?: Maybe<Scalars['String']['output']>
  readonly doencaCardiaca?: Maybe<ReadonlyArray<DoencaCardiacaAutorreferidoEnum>>
  readonly doencaRins?: Maybe<ReadonlyArray<DoencaRinsAutorreferidoEnum>>
  readonly doencasRespiratorias?: Maybe<ReadonlyArray<DoencaRespiratoriaAutorreferidoEnum>>
  readonly id: Scalars['ID']['output']
  readonly maternidadeReferencia?: Maybe<Scalars['String']['output']>
  readonly plantasMedicinais?: Maybe<Scalars['String']['output']>
  readonly stAcamado?: Maybe<Scalars['Boolean']['output']>
  readonly stCancer?: Maybe<Scalars['Boolean']['output']>
  readonly stDerrame?: Maybe<Scalars['Boolean']['output']>
  readonly stDiabetes?: Maybe<Scalars['Boolean']['output']>
  readonly stDoencaCardiaca?: Maybe<Scalars['Boolean']['output']>
  readonly stDoencaRespiratoria?: Maybe<Scalars['Boolean']['output']>
  readonly stDomiciliar?: Maybe<Scalars['Boolean']['output']>
  readonly stFumante?: Maybe<Scalars['Boolean']['output']>
  readonly stGestante?: Maybe<Scalars['Boolean']['output']>
  readonly stHanseniase?: Maybe<Scalars['Boolean']['output']>
  readonly stHipertensaoArterial?: Maybe<Scalars['Boolean']['output']>
  readonly stInfarto?: Maybe<Scalars['Boolean']['output']>
  readonly stInternacaoUltimos12Meses?: Maybe<Scalars['Boolean']['output']>
  readonly stPlantasMedicinais?: Maybe<Scalars['Boolean']['output']>
  readonly stPraticasComplementares?: Maybe<Scalars['Boolean']['output']>
  readonly stProblemaRins?: Maybe<Scalars['Boolean']['output']>
  readonly stProblemaSaudeMental?: Maybe<Scalars['Boolean']['output']>
  readonly stTuberculose?: Maybe<Scalars['Boolean']['output']>
  readonly stUsoAlcool?: Maybe<Scalars['Boolean']['output']>
  readonly stUsoOutrasDrogas?: Maybe<Scalars['Boolean']['output']>
}

export type CondicoesSaudeAutorreferidasInput = {
  readonly autodenominacaoPeso?: InputMaybe<PesoAutorreferidoEnum>
  readonly causaInternacaoUltimos12Meses?: InputMaybe<Scalars['String']['input']>
  readonly condicaoSaude1?: InputMaybe<Scalars['String']['input']>
  readonly condicaoSaude2?: InputMaybe<Scalars['String']['input']>
  readonly condicaoSaude3?: InputMaybe<Scalars['String']['input']>
  readonly doencaCardiaca?: InputMaybe<ReadonlyArray<DoencaCardiacaAutorreferidoEnum>>
  readonly doencaRins?: InputMaybe<ReadonlyArray<DoencaRinsAutorreferidoEnum>>
  readonly doencasRespiratorias?: InputMaybe<ReadonlyArray<DoencaRespiratoriaAutorreferidoEnum>>
  readonly maternidadeReferencia?: InputMaybe<Scalars['String']['input']>
  readonly plantasMedicinais?: InputMaybe<Scalars['String']['input']>
  readonly stAcamado?: InputMaybe<Scalars['Boolean']['input']>
  readonly stCancer?: InputMaybe<Scalars['Boolean']['input']>
  readonly stDerrame?: InputMaybe<Scalars['Boolean']['input']>
  readonly stDiabetes?: InputMaybe<Scalars['Boolean']['input']>
  readonly stDoencaCardiaca?: InputMaybe<Scalars['Boolean']['input']>
  readonly stDoencaRespiratoria?: InputMaybe<Scalars['Boolean']['input']>
  readonly stDomiciliar?: InputMaybe<Scalars['Boolean']['input']>
  readonly stFumante?: InputMaybe<Scalars['Boolean']['input']>
  readonly stGestante?: InputMaybe<Scalars['Boolean']['input']>
  readonly stHanseniase?: InputMaybe<Scalars['Boolean']['input']>
  readonly stHipertensaoArterial?: InputMaybe<Scalars['Boolean']['input']>
  readonly stInfarto?: InputMaybe<Scalars['Boolean']['input']>
  readonly stInternacaoUltimos12Meses?: InputMaybe<Scalars['Boolean']['input']>
  readonly stPlantasMedicinais?: InputMaybe<Scalars['Boolean']['input']>
  readonly stPraticasComplementares?: InputMaybe<Scalars['Boolean']['input']>
  readonly stProblemaRins?: InputMaybe<Scalars['Boolean']['input']>
  readonly stProblemaSaudeMental?: InputMaybe<Scalars['Boolean']['input']>
  readonly stTuberculose?: InputMaybe<Scalars['Boolean']['input']>
  readonly stUsoAlcool?: InputMaybe<Scalars['Boolean']['input']>
  readonly stUsoOutrasDrogas?: InputMaybe<Scalars['Boolean']['input']>
}

export type CondicoesVacinacao = {
  readonly __typename?: 'CondicoesVacinacao'
  readonly condicaoMaternal?: Maybe<CondicaoMaternalDbEnum>
  readonly idAtend: Scalars['ID']['output']
  readonly isComunicanteHanseniase?: Maybe<Scalars['Boolean']['output']>
  readonly isViajante?: Maybe<Scalars['Boolean']['output']>
}

export enum CondutaCuidadoCompartilhadoEnum {
  AGENDADO_CONSULTA_CIDADAO_PRESENCIAL = 'AGENDADO_CONSULTA_CIDADAO_PRESENCIAL',
  AGENDADO_INTERCONSULTA_COM_CIDADAO = 'AGENDADO_INTERCONSULTA_COM_CIDADAO',
  AGENDADO_INTERCONSULTA_SEM_CIDADAO = 'AGENDADO_INTERCONSULTA_SEM_CIDADAO',
  AGENDADO_TELEINTERCONSULTA_COM_CIDADAO = 'AGENDADO_TELEINTERCONSULTA_COM_CIDADAO',
  AGENDADO_TELEINTERCONSULTA_SEM_CIDADAO = 'AGENDADO_TELEINTERCONSULTA_SEM_CIDADAO',
  ENVIAR_GARANTIA_ACESSO = 'ENVIAR_GARANTIA_ACESSO',
  NOVA_PERGUNTA = 'NOVA_PERGUNTA',
  PARECER_TECNICO_CONCLUSIVO = 'PARECER_TECNICO_CONCLUSIVO',
  PEDIDO_ESCLARECIMENTO = 'PEDIDO_ESCLARECIMENTO',
  RECONDUCAO_CUIDADO = 'RECONDUCAO_CUIDADO',
  SUGESTAO_AGENDAMENTO_GRUPO = 'SUGESTAO_AGENDAMENTO_GRUPO',
  TELECONSULTORIA = 'TELECONSULTORIA',
  TROCA_PROFISSIONAL_REFERENCIA = 'TROCA_PROFISSIONAL_REFERENCIA',
}

export enum CondutaEnum {
  AGENDAMENTO_PARA_EMULTI = 'AGENDAMENTO_PARA_EMULTI',
  AGENDAMENTO_PARA_GRUPOS = 'AGENDAMENTO_PARA_GRUPOS',
  AGENDAMENTO_PARA_NASF = 'AGENDAMENTO_PARA_NASF',
  ALTA_DO_EPISODIO = 'ALTA_DO_EPISODIO',
  MANTER_EM_OBSERVACAO = 'MANTER_EM_OBSERVACAO',
  RETORNO_PARA_CONSULTA_AGENDADA = 'RETORNO_PARA_CONSULTA_AGENDADA',
  RETORNO_PARA_CUIDADO_CONTINUADO_PROGRAMADO = 'RETORNO_PARA_CUIDADO_CONTINUADO_PROGRAMADO',
}

export type CondutaSdc = EventoSdc & {
  readonly __typename?: 'CondutaSdc'
  readonly atestadosSdc: ReadonlyArray<AtestadoSdcDto>
  readonly diferencial?: Maybe<Scalars['String']['output']>
  readonly examesSdc?: Maybe<ExamesSdcDto>
  readonly grupoDengue?: Maybe<GrupoSdcDengueEnum>
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly prescricoes: ReadonlyArray<PrescricaoSdcDto>
  readonly subtitulo?: Maybe<Scalars['String']['output']>
  readonly tipo: TipoCondutaSdcEnum
  readonly titulo?: Maybe<Scalars['String']['output']>
}

export type ConfigAtendimentoDomInput = {
  readonly idEquipeFilho: Scalars['ID']['input']
  readonly idEquipePai: Scalars['ID']['input']
}

export type ConfiguracaoAgendaLotacao = {
  readonly __typename?: 'ConfiguracaoAgendaLotacao'
  readonly configuracaoHorarioAgenda: ConfiguracaoHorarioAgenda
  readonly duracaoAgendamento?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoAgendaLotacaoDuracaoAgendamentoArgs = {
  isAtencaoDomiciliar?: InputMaybe<Scalars['Boolean']['input']>
}

export type ConfiguracaoAgendaLotacaoInput = {
  readonly configuracaoHorarioAgenda: ConfiguracaoHorarioAgendaInput
  readonly lotacaoId: Scalars['ID']['input']
}

export type ConfiguracaoAgendaMunicipal = {
  readonly __typename?: 'ConfiguracaoAgendaMunicipal'
  readonly configuracaoHorarioAgenda: ConfiguracaoHorarioAgenda
  readonly id: Scalars['ID']['output']
}

export type ConfiguracaoAgendaMunicipalInput = {
  readonly configuracaoHorarioAgendaInput: ConfiguracaoHorarioAgendaInput
  readonly id: Scalars['ID']['input']
}

export type ConfiguracaoAgendaOnlineLotacao = {
  readonly __typename?: 'ConfiguracaoAgendaOnlineLotacao'
  readonly configuracoesSemana?: Maybe<ReadonlyArray<ConfiguracaoSemanaAgendaOnline>>
  readonly diasLiberacaoReserva: Scalars['Long']['output']
  readonly horariosConsolidados: ReadonlyArray<Maybe<Scalars['String']['output']>>
}

export type ConfiguracaoAgendaOnlineLotacaoInput = {
  readonly configuracoesSemana?: InputMaybe<ReadonlyArray<ConfiguracaoSemanaAgendaOnlineInput>>
  readonly lotacaoId: Scalars['ID']['input']
}

export type ConfiguracaoAnexoArquivos = {
  readonly __typename?: 'ConfiguracaoAnexoArquivos'
  readonly diretorio?: Maybe<Scalars['String']['output']>
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['Int']['output']
}

export type ConfiguracaoAvancada = {
  readonly __typename?: 'ConfiguracaoAvancada'
  readonly cadastroDomiciliarViaCds: ConfiguracaoFeatureStateDto
  readonly cadastroIndividualViaCds: ConfiguracaoFeatureStateDto
  readonly performance: ConfiguracaoPerformance
}

export type ConfiguracaoBuscaCidadaoPorPropriedades = {
  readonly __typename?: 'ConfiguracaoBuscaCidadaoPorPropriedades'
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
}

export type ConfiguracaoCadsus = {
  readonly __typename?: 'ConfiguracaoCadsus'
  readonly desabilitadoAteData?: Maybe<Scalars['Instant']['output']>
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly intervalo?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoCertificado = {
  readonly __typename?: 'ConfiguracaoCertificado'
  readonly admMunicipal: AdministradorMunicipal
  readonly cadsusHabilitado: Scalars['Boolean']['output']
  readonly dataHabilitacao: Scalars['Instant']['output']
  readonly dataInclusao: Scalars['Instant']['output']
  readonly dataValidadeCertificado: Scalars['Instant']['output']
  readonly error?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly farmaciaHabilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly idSolicitante: Scalars['String']['output']
  readonly municipio: Municipio
  readonly nomeCertificado: Scalars['String']['output']
  readonly rndsHabilitado: Scalars['Boolean']['output']
  readonly senhaCertificado: Scalars['String']['output']
}

export type ConfiguracaoCertificadoInput = {
  readonly error?: InputMaybe<Scalars['String']['input']>
  readonly idSolicitante?: InputMaybe<Scalars['String']['input']>
  readonly pathCertificado: Scalars['String']['input']
  readonly senhaCertificado: Scalars['String']['input']
  readonly servicos: ReadonlyArray<InputMaybe<ServicosCertificadoEnum>>
}

export type ConfiguracaoConexao = {
  readonly __typename?: 'ConfiguracaoConexao'
  readonly agendaOnline?: Maybe<AgendaOnline>
  readonly cadsus: ConfiguracaoCadsus
  readonly hasLotacoesConfiguradasOnline?: Maybe<Scalars['Boolean']['output']>
  readonly horus: ConfiguracaoHorus
  readonly internet: ConfiguracaoInternet
  readonly lotacoesAgendaOnlineComDuracaoPadrao?: Maybe<Scalars['Int']['output']>
  readonly prescricaoDigital: ConfiguracaoPrescricaoDigital
  readonly videochamadas: ConfiguracaoVideochamadas
}

export type ConfiguracaoDadosServidorFormDto = {
  readonly __typename?: 'ConfiguracaoDadosServidorFormDto'
  readonly linkInstalacao?: Maybe<Scalars['String']['output']>
  readonly nomeInstalacao?: Maybe<Scalars['String']['output']>
}

export type ConfiguracaoDadosServidorInput = {
  readonly linkInstalacao?: InputMaybe<Scalars['String']['input']>
  readonly nomeInstalacao?: InputMaybe<Scalars['String']['input']>
}

export type ConfiguracaoDiaSemana = {
  readonly __typename?: 'ConfiguracaoDiaSemana'
  readonly diaSemana: DiaSemanaEnum
  readonly periodos?: Maybe<ReadonlyArray<ConfiguracaoPeriodo>>
}

export type ConfiguracaoDiaSemanaInput = {
  readonly diaSemana: DiaSemanaEnum
  readonly periodos?: InputMaybe<ReadonlyArray<ConfiguracaoPeriodoInput>>
}

export type ConfiguracaoFeatureStateDto = {
  readonly __typename?: 'ConfiguracaoFeatureStateDto'
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
}

export type ConfiguracaoHorarioAgenda = {
  readonly __typename?: 'ConfiguracaoHorarioAgenda'
  readonly configuracaoDiasSemana?: Maybe<ReadonlyArray<ConfiguracaoDiaSemana>>
}

export type ConfiguracaoHorarioAgendaInput = {
  readonly configuracaoDiasSemana?: InputMaybe<ReadonlyArray<ConfiguracaoDiaSemanaInput>>
}

export type ConfiguracaoHorarioAgendaOnline = {
  readonly __typename?: 'ConfiguracaoHorarioAgendaOnline'
  readonly ativo: Scalars['Boolean']['output']
  readonly horario: Scalars['String']['output']
}

export type ConfiguracaoHorarioAgendaOnlineInput = {
  readonly ativo: Scalars['Boolean']['input']
  readonly horario: Scalars['String']['input']
}

export type ConfiguracaoHorus = {
  readonly __typename?: 'ConfiguracaoHorus'
  readonly desabilitadoAteData?: Maybe<Scalars['Instant']['output']>
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly intervalo?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoInternet = {
  readonly __typename?: 'ConfiguracaoInternet'
  readonly dataUltimoTeste?: Maybe<Scalars['Instant']['output']>
  readonly habilitado: Scalars['Boolean']['output']
  readonly resultadoUltimoTeste?: Maybe<Scalars['Boolean']['output']>
}

export type ConfiguracaoPerformance = {
  readonly __typename?: 'ConfiguracaoPerformance'
  readonly buscaCidadaoPorPropriedades: ConfiguracaoBuscaCidadaoPorPropriedades
  readonly qtdRequisicoesSimultaneas?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoPeriodo = {
  readonly __typename?: 'ConfiguracaoPeriodo'
  readonly horarioFinal?: Maybe<Scalars['String']['output']>
  readonly horarioInicial?: Maybe<Scalars['String']['output']>
  readonly periodo: PeriodoEnum
}

export type ConfiguracaoPeriodoInatividade = {
  readonly __typename?: 'ConfiguracaoPeriodoInatividade'
  readonly periodoInatividade?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoPeriodoInput = {
  readonly horarioFinal?: InputMaybe<Scalars['String']['input']>
  readonly horarioInicial?: InputMaybe<Scalars['String']['input']>
  readonly periodo: PeriodoEnum
}

export type ConfiguracaoPrescricaoDigital = {
  readonly __typename?: 'ConfiguracaoPrescricaoDigital'
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly senha?: Maybe<Scalars['String']['output']>
  readonly usuario?: Maybe<Scalars['String']['output']>
}

export type ConfiguracaoRedefinicaoSenha = {
  readonly __typename?: 'ConfiguracaoRedefinicaoSenha'
  readonly redefinicaoSenha?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoSmtpInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly endereco?: InputMaybe<Scalars['String']['input']>
  readonly porta?: InputMaybe<Scalars['String']['input']>
  readonly senha?: InputMaybe<Scalars['String']['input']>
  readonly usuario?: InputMaybe<Scalars['String']['input']>
}

export type ConfiguracaoSeguranca = {
  readonly __typename?: 'ConfiguracaoSeguranca'
  readonly loginNumeroTentativas: ConfiguracaoTentativasLogin
  readonly periodoEmMesesParaRedefinir: ConfiguracaoRedefinicaoSenha
  readonly periodoEmMinutosInatividade: ConfiguracaoPeriodoInatividade
}

export type ConfiguracaoSemanaAgendaOnline = {
  readonly __typename?: 'ConfiguracaoSemanaAgendaOnline'
  readonly configuracoes: ReadonlyArray<Maybe<ConfiguracaoHorarioAgendaOnline>>
  readonly diaSemana: DiaSemanaEnum
}

export type ConfiguracaoSemanaAgendaOnlineInput = {
  readonly configuracoes: ReadonlyArray<InputMaybe<ConfiguracaoHorarioAgendaOnlineInput>>
  readonly diaSemana: DiaSemanaEnum
}

export type ConfiguracaoServidoresFormDto = {
  readonly __typename?: 'ConfiguracaoServidoresFormDto'
  readonly dadosServidor?: Maybe<ConfiguracaoDadosServidorFormDto>
  readonly internet: ConfiguracaoInternet
  readonly servidorSMTP?: Maybe<ServidorSmtp>
}

export type ConfiguracaoTentativasLogin = {
  readonly __typename?: 'ConfiguracaoTentativasLogin'
  readonly tentativasLogin?: Maybe<Scalars['Int']['output']>
}

export type ConfiguracaoVideochamadas = {
  readonly __typename?: 'ConfiguracaoVideochamadas'
  readonly habilitado: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
}

export type ConfiguracoesAtencaoDom = {
  readonly __typename?: 'ConfiguracoesAtencaoDom'
  readonly duracao: Scalars['Int']['output']
  readonly emadsAtendemEmads: ConfiguracoesAtendimentosDomPayload
  readonly emapsApoiamEmads: ConfiguracoesAtendimentosDomPayload
}

export type ConfiguracoesAtencaoDomEmadsAtendemEmadsArgs = {
  input?: InputMaybe<ConfiguracoesAtendimentosDomInput>
}

export type ConfiguracoesAtencaoDomEmapsApoiamEmadsArgs = {
  input?: InputMaybe<ConfiguracoesAtendimentosDomInput>
}

export type ConfiguracoesAtendimentosDomInput = {
  readonly pageParams?: InputMaybe<PageParams>
}

export type ConfiguracoesAtendimentosDomPayload = {
  readonly __typename?: 'ConfiguracoesAtendimentosDomPayload'
  readonly content: ReadonlyArray<Maybe<ConfiguracoesAtendimentosDomiciliares>>
  readonly pageInfo: PageInfo
}

export type ConfiguracoesAtendimentosDomiciliares = {
  readonly __typename?: 'ConfiguracoesAtendimentosDomiciliares'
  readonly id: Scalars['ID']['output']
  readonly identificadorNacionalEquipeFilho: Equipe
  readonly identificadorNacionalEquipePai: Equipe
}

export type ConjuntoFatoresSdcDto = {
  readonly __typename?: 'ConjuntoFatoresSdcDto'
  readonly fatoresNaoVerificadosSdc: Scalars['String']['output']
  readonly fatoresVerificadosSdc: SdcFatoresVerificadosDto
}

export type ConselhoClasse = {
  readonly __typename?: 'ConselhoClasse'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly sigla: Scalars['String']['output']
}

export type ConselhoClassePayload = {
  readonly __typename?: 'ConselhoClassePayload'
  readonly content: ReadonlyArray<Maybe<ConselhoClasse>>
  readonly pageInfo: PageInfo
}

export type ConselhoClasseQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type ConsultaEstoqueHorusQueryInput = {
  readonly codCatMat: Scalars['String']['input']
  readonly principioAtivo: Scalars['String']['input']
  readonly uuid: Scalars['String']['input']
}

export type ConsultasDesenvolvimentoInfantil = {
  readonly __typename?: 'ConsultasDesenvolvimentoInfantil'
  readonly dataPrimeiraConsulta?: Maybe<Scalars['LocalDate']['output']>
  readonly qtdConsultas?: Maybe<Scalars['Long']['output']>
}

export type ContatoCidadao = {
  readonly __typename?: 'ContatoCidadao'
  readonly email?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly telefoneCelular?: Maybe<Scalars['String']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly telefoneResidencial?: Maybe<Scalars['String']['output']>
}

export type CpfContraChaveInput = {
  readonly contraChave: Scalars['String']['input']
  readonly cpf: Scalars['String']['input']
}

export type CredenciaIntegracao = {
  readonly __typename?: 'CredenciaIntegracao'
  readonly ativo: Scalars['Boolean']['output']
  readonly cpfCnpj: Scalars['String']['output']
  readonly dataCriacao: Scalars['Instant']['output']
  readonly email: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly municipiosVinculados?: Maybe<ReadonlyArray<Municipio>>
  readonly nomeCredencial: Scalars['String']['output']
  readonly nomeResponsavel: Scalars['String']['output']
  readonly recursos: ReadonlyArray<RecursoIntegracaoEnum>
  readonly tipoPessoa: TipoPessoaEnum
  readonly urlWebhookRegulacao?: Maybe<Scalars['String']['output']>
}

export type CredenciaIntegracaoUserPasswordPayload = {
  readonly __typename?: 'CredenciaIntegracaoUserPasswordPayload'
  readonly password: Scalars['String']['output']
  readonly user: Scalars['String']['output']
}

export type CredencialIntegracaoInput = {
  readonly cpfCnpj: Scalars['String']['input']
  readonly email: Scalars['String']['input']
  readonly municipiosVinculados?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly nomeCredencial: Scalars['String']['input']
  readonly nomeResponsavel: Scalars['String']['input']
  readonly recursos: ReadonlyArray<RecursoIntegracaoEnum>
  readonly tipoPessoa: TipoPessoaEnum
  readonly urlWebhookRegulacao?: InputMaybe<Scalars['String']['input']>
}

export type CredencialIntegracaoPayload = {
  readonly __typename?: 'CredencialIntegracaoPayload'
  readonly content: ReadonlyArray<Maybe<CredenciaIntegracao>>
  readonly pageInfo: PageInfo
}

export type CredencialIntegracaoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteAtivas?: InputMaybe<Scalars['Boolean']['input']>
}

export enum Criancas0a9AnosComQuemFicaEnum {
  ADOLESCENTE = 'ADOLESCENTE',
  ADULTO_RESPONSAVEL = 'ADULTO_RESPONSAVEL',
  CRECHE = 'CRECHE',
  OUTRAS_CRIANCAS = 'OUTRAS_CRIANCAS',
  OUTRO = 'OUTRO',
  SOZINHA = 'SOZINHA',
}

export type CriarAgendamentoConsultaCompartilhadaInput = {
  readonly cidadao?: InputMaybe<Scalars['ID']['input']>
  readonly enviarEmailCidadao: Scalars['Boolean']['input']
  readonly horarioFinal: Scalars['Instant']['input']
  readonly horarioInicial: Scalars['Instant']['input']
  readonly lotacaoId: Scalars['ID']['input']
  readonly lotacaoParticipanteId: Scalars['ID']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
  readonly videochamadaUuid?: InputMaybe<Scalars['String']['input']>
}

export type CriarAgendamentoConsultaInput = {
  readonly cidadao: Scalars['ID']['input']
  readonly enviarEmailCidadao: Scalars['Boolean']['input']
  readonly horario: Scalars['Instant']['input']
  readonly horarioFinal?: InputMaybe<Scalars['Instant']['input']>
  readonly isForaUbs: Scalars['Boolean']['input']
  readonly localAtendimento?: InputMaybe<Scalars['ID']['input']>
  readonly lotacao: Scalars['ID']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type CriarAgendamentoReservaInput = {
  readonly especificacaoMotivoReserva?: InputMaybe<Scalars['String']['input']>
  readonly horarioFinal: Scalars['Instant']['input']
  readonly horarioInicial: Scalars['Instant']['input']
  readonly lotacaoAgendada: Scalars['ID']['input']
  readonly motivoReserva: MotivoAgendamentoReservaEnum
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type CriarSalaUnidadeSaudeInput = {
  readonly nome: Scalars['String']['input']
  readonly unidadeSaudeId: Scalars['ID']['input']
}

export type CriterioPontuadoVulnerabilidadeFamiliar = {
  readonly __typename?: 'CriterioPontuadoVulnerabilidadeFamiliar'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly numeroMoradores?: Maybe<Scalars['Int']['output']>
  readonly peso: Scalars['Int']['output']
  readonly resultado: Scalars['Int']['output']
}

export type CriteriosVulnerabilidadeFamiliar = {
  readonly __typename?: 'CriteriosVulnerabilidadeFamiliar'
  readonly criteriosInequivocos: ReadonlyArray<Scalars['String']['output']>
  readonly criteriosPontuados: ReadonlyArray<CriterioPontuadoVulnerabilidadeFamiliar>
  readonly criteriosSugestivos: ReadonlyArray<Scalars['String']['output']>
}

export enum CriticidadeAlergia {
  ALTA = 'ALTA',
  BAIXA = 'BAIXA',
  NAO_INFORMADA = 'NAO_INFORMADA',
}

export type CuidadoCompartilhado = {
  readonly __typename?: 'CuidadoCompartilhado'
  readonly actions?: Maybe<CuidadoCompartilhadoActions>
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly cboExecutanteAtual: Cbo
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly cidadao: Cidadao
  readonly cidadaoAceitaAtendTic: Scalars['Boolean']['output']
  readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
  readonly dataUltimaEvolucao: Scalars['Instant']['output']
  readonly discussao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly iniciadoEm: Scalars['Instant']['output']
  readonly isEmulti: Scalars['Boolean']['output']
  readonly lotacaoExecutanteAtual?: Maybe<Lotacao>
  readonly lotacaoSolicitante: Lotacao
  readonly primeiraEvolucao: CuidadoCompartilhadoEvolucao
  readonly prontuario: Prontuario
  readonly status: StatusCuidadoCompartilhadoEnum
  readonly tempoDecorridoUltimaEvolucao: Scalars['Long']['output']
  readonly topicoNotificacao?: Maybe<TopicoNotificacao>
  readonly ultimaEvolucao: CuidadoCompartilhadoEvolucao
  readonly unidadeSaudeExecutanteAtual: UnidadeSaude
}

export type CuidadoCompartilhadoActions = {
  readonly __typename?: 'CuidadoCompartilhadoActions'
  readonly discutirCasoExecutante?: Maybe<Action>
  readonly discutirCasoSolicitante?: Maybe<Action>
  readonly tornarseExecutante?: Maybe<Action>
  readonly visualizarDiscussao?: Maybe<Action>
}

export type CuidadoCompartilhadoEvolucao = {
  readonly __typename?: 'CuidadoCompartilhadoEvolucao'
  readonly agenda?: Maybe<Agendado>
  readonly cboExecutante: Cbo
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly codigoSequencialEvolucao: Scalars['Int']['output']
  readonly conduta: CondutaCuidadoCompartilhadoEnum
  readonly cuidadoCompartilhado: CuidadoCompartilhado
  readonly dataEvolucao: Scalars['Instant']['output']
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly enviarGarantiaAcesso?: Maybe<CondutaCuidadoCompartilhadoEnum>
  readonly id: Scalars['ID']['output']
  readonly lotacao: Lotacao
  readonly lotacaoAfetada?: Maybe<Lotacao>
  readonly lotacaoExecutante?: Maybe<Lotacao>
  readonly reclassificacaoPrioridade?: Maybe<ClassificacaoPrioridadeCuidadoEnum>
  readonly unidadeSaudeExecutante: UnidadeSaude
}

export type CuidadoCompartilhadoEvolucoesPayload = {
  readonly __typename?: 'CuidadoCompartilhadoEvolucoesPayload'
  readonly content: ReadonlyArray<Maybe<CuidadoCompartilhadoEvolucao>>
  readonly pageInfo: PageInfo
}

export type CuidadoCompartilhadoEvolucoesQueryInput = {
  readonly cuidadoCompartilhadoId: Scalars['ID']['input']
  readonly pageParams?: InputMaybe<PageParams>
}

export type CuidadoCompartilhadoFinalizacaoAutoPayload = {
  readonly __typename?: 'CuidadoCompartilhadoFinalizacaoAutoPayload'
  readonly content: ReadonlyArray<CuidadoFinalizacaoAuto>
  readonly pageInfo: PageInfo
}

export type CuidadoCompartilhadoPlanoInput = {
  readonly ciap?: InputMaybe<Scalars['ID']['input']>
  readonly cid10?: InputMaybe<Scalars['ID']['input']>
  readonly cidadaoAceitaAtendTic: Scalars['Boolean']['input']
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly discussao: Scalars['String']['input']
  readonly lotacaoExecutanteId: Scalars['ID']['input']
}

export enum CuidadoCompartilhadoQueryFilterEnum {
  EXECUTANTE = 'EXECUTANTE',
  GERENTE = 'GERENTE',
  SOLICITANTE = 'SOLICITANTE',
}

export type CuidadoFinalizacaoAuto = {
  readonly __typename?: 'CuidadoFinalizacaoAuto'
  readonly cuidadoCompartilhado: CuidadoCompartilhado
  readonly dataFinalizado: Scalars['Instant']['output']
  readonly dataReaberto?: Maybe<Scalars['Instant']['output']>
  readonly id: Scalars['ID']['output']
  readonly sequenciaEvolucao: Scalars['Int']['output']
}

export type CuidadosCompartilhadoPayload = {
  readonly __typename?: 'CuidadosCompartilhadoPayload'
  readonly content: ReadonlyArray<CuidadoCompartilhado>
  readonly pageInfo: PageInfo
}

export type CuidadosCompartilhadoQueryInput = {
  readonly cboId?: InputMaybe<Scalars['ID']['input']>
  readonly cuidadosCompartilhadoIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly dataFim?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly equipesIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly executadosPelaMinhaEquipe: Scalars['Boolean']['input']
  readonly executadosPorProfissionalId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId?: InputMaybe<Scalars['ID']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly solicitadosPelaMinhaEquipe: Scalars['Boolean']['input']
  readonly solicitadosPorProfissionalId?: InputMaybe<Scalars['ID']['input']>
  readonly somenteNaoLidos: Scalars['Boolean']['input']
  readonly somenteSemExecutante: Scalars['Boolean']['input']
  readonly somenteUnidadeAcesso: Scalars['Boolean']['input']
  readonly somenteUnidadeExecutante: Scalars['Boolean']['input']
  readonly somenteUnidadesBasicas: Scalars['Boolean']['input']
  readonly status?: InputMaybe<ReadonlyArray<StatusCuidadoCompartilhadoEnum>>
  readonly unidadeSaudeId?: InputMaybe<Scalars['ID']['input']>
}

export type DataUltimaConsultaOdontoGestanteQueryInput = {
  readonly cidadaoId: Scalars['ID']['input']
  readonly dataInicioGestacao: Scalars['LocalDate']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export type DateRangeInput = {
  readonly endDate: Scalars['LocalDate']['input']
  readonly startDate: Scalars['LocalDate']['input']
}

export enum DeficienciaEnum {
  AUDITIVA = 'AUDITIVA',
  FISICA = 'FISICA',
  INTELECTUAL_COGNITIVA = 'INTELECTUAL_COGNITIVA',
  OUTRA = 'OUTRA',
  TEA = 'TEA',
  VISUAL = 'VISUAL',
}

export type DefinirSenhaProvisoriaInput = {
  readonly novaSenha: Scalars['String']['input']
  readonly usuarioId: Scalars['Long']['input']
}

export type Dente = {
  readonly __typename?: 'Dente'
  readonly id: Scalars['ID']['output']
  readonly numero?: Maybe<Scalars['Int']['output']>
}

export type DesenvolvimentoInfantilConsolidado = {
  readonly __typename?: 'DesenvolvimentoInfantilConsolidado'
  readonly consultas?: Maybe<ConsultasDesenvolvimentoInfantil>
  readonly qtdMedicoesPesoAltura?: Maybe<Scalars['Long']['output']>
  readonly suplementacaoVitaminaA: SuplementacaoVitaminaADesenvolvimentoInfantil
  readonly vacinasAplicadas: ReadonlyArray<FatoVacinacaoVacina>
  readonly visitasDomiciliares?: Maybe<VisitasDomiciliaresDesenvolvimentoInfantil>
}

export type DesfechoAtendimento = {
  readonly __typename?: 'DesfechoAtendimento'
  readonly texto?: Maybe<Scalars['String']['output']>
}

export type DesfechoAtendimentoInput = {
  readonly atendimento?: InputMaybe<EncaminhamentoInternoInput>
  readonly manterCidadaoLista: Scalars['Boolean']['input']
}

export enum DesfechoUltimaGestacaoEnum {
  MAIS_10_ANOS = 'MAIS_10_ANOS',
  MENOS_1_ANO = 'MENOS_1_ANO',
  NAO_INFORMADO = 'NAO_INFORMADO',
}

export enum DesfechoVisitaEnum {
  AUSENTE = 'AUSENTE',
  VISITA_REALIZADA = 'VISITA_REALIZADA',
  VISITA_RECUSADA = 'VISITA_RECUSADA',
}

export type DetalhesAtivacao = {
  readonly __typename?: 'DetalhesAtivacao'
  readonly dataEvento: Scalars['Instant']['output']
  readonly profissional?: Maybe<Profissional>
}

export type DevolutivaCuidadoCompartilhadoInput = {
  readonly conduta: CondutaCuidadoCompartilhadoEnum
  readonly resposta: Scalars['String']['input']
}

export type DiaAgendaLotacao = {
  readonly __typename?: 'DiaAgendaLotacao'
  readonly data: Scalars['LocalDate']['output']
  readonly status: StatusDiaAgendaEnum
}

export enum DiaSemanaEnum {
  DOMINGO = 'DOMINGO',
  QUARTA = 'QUARTA',
  QUINTA = 'QUINTA',
  SABADO = 'SABADO',
  SEGUNDA = 'SEGUNDA',
  SEXTA = 'SEXTA',
  TERCA = 'TERCA',
}

export type DiabetesConsolidado = {
  readonly __typename?: 'DiabetesConsolidado'
  readonly cidadaoId?: Maybe<Scalars['Long']['output']>
  readonly dataUltimaConsulta?: Maybe<Scalars['LocalDate']['output']>
  readonly exames?: Maybe<ExamesDiabeteConsolidado>
  readonly qtdConsultas?: Maybe<Scalars['Long']['output']>
  readonly visitaDomiciliar?: Maybe<VisitaDomiciliarConsolidado>
}

export enum DimFaixaEtariaEnum {
  CINCO_A_NOVE_ANOS = 'CINCO_A_NOVE_ANOS',
  CINQUENTA_A_CINQUENTA_QUATRO_ANOS = 'CINQUENTA_A_CINQUENTA_QUATRO_ANOS',
  CINQUENTA_CINCO_A_CINQUENTA_NOVE_ANOS = 'CINQUENTA_CINCO_A_CINQUENTA_NOVE_ANOS',
  DEZ_A_QUATORZE_ANOS = 'DEZ_A_QUATORZE_ANOS',
  DOIS_ANOS = 'DOIS_ANOS',
  MENOS_DE_UM_ANO = 'MENOS_DE_UM_ANO',
  NAO_INFORMADO = 'NAO_INFORMADO',
  OITENTA_ANOS_OU_MAIS = 'OITENTA_ANOS_OU_MAIS',
  QUARENTA_A_QUARENTA_QUATRO_ANOS = 'QUARENTA_A_QUARENTA_QUATRO_ANOS',
  QUARENTA_CINCO_A_QUARENTA_NOVE_ANOS = 'QUARENTA_CINCO_A_QUARENTA_NOVE_ANOS',
  QUATRO_ANOS = 'QUATRO_ANOS',
  QUINZE_A_DEZENOVE_ANOS = 'QUINZE_A_DEZENOVE_ANOS',
  SESSENTA_A_SESSENTA_QUATRO_ANOS = 'SESSENTA_A_SESSENTA_QUATRO_ANOS',
  SESSENTA_CINCO_A_SESSENTA_NOVE_ANOS = 'SESSENTA_CINCO_A_SESSENTA_NOVE_ANOS',
  SETENTA_A_SETENTA_QUATRO_ANOS = 'SETENTA_A_SETENTA_QUATRO_ANOS',
  SETENTA_CINCO_A_SETENTA_NOVE_ANOS = 'SETENTA_CINCO_A_SETENTA_NOVE_ANOS',
  TRES_ANOS = 'TRES_ANOS',
  TRINTA_A_TRINTA_QUATRO_ANOS = 'TRINTA_A_TRINTA_QUATRO_ANOS',
  TRINTA_CINCO_A_TRINTA_NOVE_ANOS = 'TRINTA_CINCO_A_TRINTA_NOVE_ANOS',
  UM_ANO = 'UM_ANO',
  VINTE_A_VINTE_QUATRO_ANOS = 'VINTE_A_VINTE_QUATRO_ANOS',
  VINTE_CINCO_A_VINTE_NOVE_ANOS = 'VINTE_CINCO_A_VINTE_NOVE_ANOS',
}

export enum DimSexoEnum {
  FEMININO = 'FEMININO',
  INDETERMINADO = 'INDETERMINADO',
  MASCULINO = 'MASCULINO',
  NAO_INFORMADO = 'NAO_INFORMADO',
}

export type DimensaoAgrupadorFiltro = {
  readonly __typename?: 'DimensaoAgrupadorFiltro'
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoMunicipio?: Maybe<DimensaoMunicipio>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly id: Scalars['ID']['output']
}

export type DimensaoAgrupadorFiltroQueryInput = {
  readonly dimensaoEquipeId?: InputMaybe<Scalars['String']['input']>
  readonly dimensaoMunicipioId?: InputMaybe<Scalars['String']['input']>
  readonly dimensaoUnidadeSaudeId?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type DimensaoAgrupadorFiltroQueryPayload = {
  readonly __typename?: 'DimensaoAgrupadorFiltroQueryPayload'
  readonly content: ReadonlyArray<Maybe<DimensaoAgrupadorFiltro>>
  readonly pageInfo: PageInfo
}

export type DimensaoAleitamento = {
  readonly __typename?: 'DimensaoAleitamento'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoCategoriaProfissional = {
  readonly __typename?: 'DimensaoCategoriaProfissional'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoCategoriaProfissionalQueryInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type DimensaoCatmat = {
  readonly __typename?: 'DimensaoCatmat'
  readonly concentracao?: Maybe<Scalars['String']['output']>
  readonly dimensaoFormaFarmaceutica?: Maybe<DimensaoFormaFarmaceutica>
  readonly id: Scalars['ID']['output']
  readonly principioAtivo?: Maybe<Scalars['String']['output']>
}

export type DimensaoCbo = {
  readonly __typename?: 'DimensaoCbo'
  readonly cbo: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoCiap = {
  readonly __typename?: 'DimensaoCiap'
  readonly codigoCiap: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nomeCiap: Scalars['String']['output']
}

export type DimensaoCid10 = {
  readonly __typename?: 'DimensaoCid10'
  readonly codigoCid10: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nomeCid10: Scalars['String']['output']
}

export type DimensaoClassificacaoRiscoEncaminhamento = {
  readonly __typename?: 'DimensaoClassificacaoRiscoEncaminhamento'
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoCondicaoMaternal = {
  readonly __typename?: 'DimensaoCondicaoMaternal'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['Int']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoCondutaAd = {
  readonly __typename?: 'DimensaoCondutaAD'
  readonly conduta: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
}

export type DimensaoCondutaCuidado = {
  readonly __typename?: 'DimensaoCondutaCuidado'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nuIdentificador: Scalars['String']['output']
}

export type DimensaoCuidador = {
  readonly __typename?: 'DimensaoCuidador'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly numeroIdentificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoDesfechoVisita = {
  readonly __typename?: 'DimensaoDesfechoVisita'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly numeroIdentificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoDoseImunobiologico = {
  readonly __typename?: 'DimensaoDoseImunobiologico'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeApresentacao: Scalars['String']['output']
  readonly numeroIdentificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
  readonly sigla: Scalars['String']['output']
}

export type DimensaoEquipe = {
  readonly __typename?: 'DimensaoEquipe'
  readonly id: Scalars['ID']['output']
  readonly ine: Scalars['String']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoEquipeQueryInput = {
  readonly cnes?: InputMaybe<Scalars['String']['input']>
  readonly ibge?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type DimensaoEquipeQueryPayload = {
  readonly __typename?: 'DimensaoEquipeQueryPayload'
  readonly content: ReadonlyArray<Maybe<DimensaoEquipe>>
  readonly pageInfo: PageInfo
}

export type DimensaoEstrategiaVacinacao = {
  readonly __typename?: 'DimensaoEstrategiaVacinacao'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoFaixaEtaria = {
  readonly __typename?: 'DimensaoFaixaEtaria'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export type DimensaoFormaFarmaceutica = {
  readonly __typename?: 'DimensaoFormaFarmaceutica'
  readonly id: Scalars['ID']['output']
  readonly identificador?: Maybe<Scalars['String']['output']>
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly valido?: Maybe<Scalars['Boolean']['output']>
}

export type DimensaoGrauVulnerabilidadeIvcf = {
  readonly __typename?: 'DimensaoGrauVulnerabilidadeIvcf'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly nuIdentificador?: Maybe<Scalars['String']['output']>
}

export type DimensaoGrupoAtendimento = {
  readonly __typename?: 'DimensaoGrupoAtendimento'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly numeroIdentificador: Scalars['String']['output']
}

export type DimensaoImunobiologico = {
  readonly __typename?: 'DimensaoImunobiologico'
  readonly grupo: ReadonlyArray<GrupoImunobiologicoEnum>
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
  readonly nome: Scalars['String']['output']
  readonly sigla: Scalars['String']['output']
}

export type DimensaoInep = {
  readonly __typename?: 'DimensaoInep'
  readonly id: Scalars['ID']['output']
  readonly noEstabelecimento?: Maybe<Scalars['String']['output']>
  readonly nuIdentificador: Scalars['String']['output']
}

export type DimensaoLocalAplicacaoVacina = {
  readonly __typename?: 'DimensaoLocalAplicacaoVacina'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoLocalAtendimento = {
  readonly __typename?: 'DimensaoLocalAtendimento'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
}

export type DimensaoMchatRisco = {
  readonly __typename?: 'DimensaoMchatRisco'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
}

export type DimensaoModalidadeAd = {
  readonly __typename?: 'DimensaoModalidadeAD'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly numeroIdentificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoMunicipio = {
  readonly __typename?: 'DimensaoMunicipio'
  readonly ibge: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoMunicipiosQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type DimensaoMunicipiosQueryPayload = {
  readonly __typename?: 'DimensaoMunicipiosQueryPayload'
  readonly content: ReadonlyArray<Maybe<DimensaoMunicipio>>
  readonly pageInfo: PageInfo
}

export type DimensaoPrioridadeCuidado = {
  readonly __typename?: 'DimensaoPrioridadeCuidado'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nuIdentificador: Scalars['String']['output']
}

export type DimensaoProcedimento = {
  readonly __typename?: 'DimensaoProcedimento'
  readonly codigoProcedimento: Scalars['String']['output']
  readonly descricaoProcedimento: Scalars['String']['output']
  readonly dimensaoProcedimentoReferencia?: Maybe<DimensaoProcedimento>
  readonly id: Scalars['ID']['output']
}

export type DimensaoProfissional = {
  readonly __typename?: 'DimensaoProfissional'
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly nome?: Maybe<Scalars['String']['output']>
}

export type DimensaoRacionalidadeSaude = {
  readonly __typename?: 'DimensaoRacionalidadeSaude'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoSexo = {
  readonly __typename?: 'DimensaoSexo'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['Int']['output']
  readonly sigla: Scalars['String']['output']
}

export type DimensaoSituacaoProblema = {
  readonly __typename?: 'DimensaoSituacaoProblema'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['Int']['output']
}

export type DimensaoTempo = {
  readonly __typename?: 'DimensaoTempo'
  readonly dataRegistro: Scalars['LocalDate']['output']
  readonly id: Scalars['ID']['output']
}

export type DimensaoTipoAtividade = {
  readonly __typename?: 'DimensaoTipoAtividade'
  readonly descricaoCategoriaTipoAtividade?: Maybe<Scalars['String']['output']>
  readonly descricaoTipoAtividade: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly idCategoriaTipoAtividade?: Maybe<Scalars['ID']['output']>
  readonly nuIdentificador: Scalars['Int']['output']
}

export type DimensaoTipoGlicemia = {
  readonly __typename?: 'DimensaoTipoGlicemia'
  readonly descricao: Scalars['String']['output']
  readonly descricaoFiltro: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly numeroIdentificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export enum DimensaoTipoGlicemiaEnum {
  JEJUM = 'JEJUM',
  NAO_ESPECIFICADO = 'NAO_ESPECIFICADO',
  NAO_INFORMADO = 'NAO_INFORMADO',
  POSPRANDIAL = 'POSPRANDIAL',
  PREPRANDIAL = 'PREPRANDIAL',
}

export type DimensaoTipoOrigem = {
  readonly __typename?: 'DimensaoTipoOrigem'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoTipoParticipacaoAtendimento = {
  readonly __typename?: 'DimensaoTipoParticipacaoAtendimento'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export type DimensaoTurno = {
  readonly __typename?: 'DimensaoTurno'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly identificador: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
}

export type DimensaoUnidadeSaude = {
  readonly __typename?: 'DimensaoUnidadeSaude'
  readonly cnes: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DimensaoUnidadeSaudeQueryInput = {
  readonly ibge?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type DimensaoUnidadeSaudeQueryPayload = {
  readonly __typename?: 'DimensaoUnidadeSaudeQueryPayload'
  readonly content: ReadonlyArray<Maybe<DimensaoUnidadeSaude>>
  readonly pageInfo: PageInfo
}

export type DimensaoViaAdministracao = {
  readonly __typename?: 'DimensaoViaAdministracao'
  readonly id: Scalars['ID']['output']
  readonly nome?: Maybe<Scalars['String']['output']>
}

export type DimensaoViaAdministracaoVacina = {
  readonly __typename?: 'DimensaoViaAdministracaoVacina'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DisponibilidadeDadosClinicosHistorico = {
  readonly __typename?: 'DisponibilidadeDadosClinicosHistorico'
  readonly statusProcessamento: Scalars['Boolean']['output']
}

export enum DisponibilidadeHorusEnum {
  DESABILITADO = 'DESABILITADO',
  DESABILITADO_MANUAL = 'DESABILITADO_MANUAL',
  DISPONIVEL = 'DISPONIVEL',
  HABILITADO = 'HABILITADO',
  INDISPONIVEL = 'INDISPONIVEL',
  PARCIALMENTE_DISPONIVEL = 'PARCIALMENTE_DISPONIVEL',
  SEM_CONEXAO = 'SEM_CONEXAO',
  SUCESSO_CONEXAO = 'SUCESSO_CONEXAO',
}

export type DispositivoPainel = {
  readonly __typename?: 'DispositivoPainel'
  readonly dataPareamento: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DocumentosCidadaoQueryInput = {
  readonly cns?: InputMaybe<Scalars['String']['input']>
  readonly cpf?: InputMaybe<Scalars['String']['input']>
  readonly nisPisPasep?: InputMaybe<Scalars['String']['input']>
  readonly numeroDnv?: InputMaybe<Scalars['String']['input']>
}

export enum DoencaCardiacaAutorreferidoEnum {
  INSUFICIENCIA_CARDIACA = 'INSUFICIENCIA_CARDIACA',
  NAO_SABE = 'NAO_SABE',
  OUTRA = 'OUTRA',
}

export enum DoencaRespiratoriaAutorreferidoEnum {
  ASMA = 'ASMA',
  DPOC_ENFISEMA = 'DPOC_ENFISEMA',
  NAO_SABE_DOENCA_RESPIRATORIA = 'NAO_SABE_DOENCA_RESPIRATORIA',
  OUTRO_DOENCA_RESPIRATORIA = 'OUTRO_DOENCA_RESPIRATORIA',
}

export enum DoencaRinsAutorreferidoEnum {
  INSUFICIENCIA_RENAL = 'INSUFICIENCIA_RENAL',
  NAO_SABE = 'NAO_SABE',
  OUTRO = 'OUTRO',
}

export type DoseImunobiologico = {
  readonly __typename?: 'DoseImunobiologico'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeApresentacaoDose: Scalars['String']['output']
  readonly ordem: Scalars['Int']['output']
  readonly sigla: Scalars['String']['output']
}

export type DoseImunobiologicoQueryPayload = {
  readonly __typename?: 'DoseImunobiologicoQueryPayload'
  readonly content: ReadonlyArray<Maybe<DoseImunobiologico>>
  readonly pageInfo: PageInfo
}

export type DoseImunobiologicoVacinacaoQueryInput = {
  readonly estrategiaId?: InputMaybe<Scalars['ID']['input']>
  readonly grupoAlvoId?: InputMaybe<Scalars['ID']['input']>
  readonly imunobiologicoIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly isOnlyRevacinacao?: InputMaybe<Scalars['Boolean']['input']>
  readonly onlyCalendarioVacinal?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly semRegras?: InputMaybe<Scalars['Boolean']['input']>
  readonly sexo?: InputMaybe<SexoEnum>
}

export type Dsei = {
  readonly __typename?: 'Dsei'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type DseiInput = {
  readonly aldeiaId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly poloBaseId?: InputMaybe<Scalars['ID']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type DseiQueryPayload = {
  readonly __typename?: 'DseiQueryPayload'
  readonly content: ReadonlyArray<Maybe<Dsei>>
  readonly pageInfo: PageInfo
}

export type Dum = {
  readonly __typename?: 'Dum'
  readonly dum: Scalars['LocalDate']['output']
  readonly registradoEm: Scalars['LocalDate']['output']
}

export type DuracaoAgendamentoAtencaoDomDto = {
  readonly __typename?: 'DuracaoAgendamentoAtencaoDomDto'
  readonly duracaoAgendamento: Scalars['Int']['output']
}

export type DuracaoAgendamentoAtencaoDomInput = {
  readonly duracaoAgendamento: Scalars['Int']['input']
}

export type DuracaoAtendimentoPadraoMunicipio = {
  readonly __typename?: 'DuracaoAtendimentoPadraoMunicipio'
  readonly duracaoAtendimentoPadraoMunicipio: Scalars['Int']['output']
}

export type DuracaoAtendimentoPadraoMunicipioInput = {
  readonly duracaoAtendimentoPadraoMunicipio: Scalars['Int']['input']
}

export type EditarAgendamentoConsultaCompartilhadaInput = {
  readonly agendamentoId: Scalars['ID']['input']
  readonly enviarEmailCidadao: Scalars['Boolean']['input']
  readonly horarioFinal: Scalars['Instant']['input']
  readonly horarioInicial: Scalars['Instant']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
  readonly videochamadaUuid?: InputMaybe<Scalars['String']['input']>
}

export type EditarAgendamentoConsultaInput = {
  readonly agendamentoId: Scalars['ID']['input']
  readonly enviarEmailCidadao?: InputMaybe<Scalars['Boolean']['input']>
  readonly horario: Scalars['Instant']['input']
  readonly horarioFinal?: InputMaybe<Scalars['Instant']['input']>
  readonly isForaUbs: Scalars['Boolean']['input']
  readonly localAtendimento?: InputMaybe<Scalars['ID']['input']>
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type EditarAgendamentoReservaInput = {
  readonly agendamentoId: Scalars['ID']['input']
  readonly especificacaoMotivoReserva?: InputMaybe<Scalars['String']['input']>
  readonly horarioFinal: Scalars['Instant']['input']
  readonly horarioInicial: Scalars['Instant']['input']
  readonly motivoReserva: MotivoAgendamentoReservaEnum
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type EditarModeloRelatorioGerencialInput = {
  readonly id: Scalars['ID']['input']
  readonly modeloPersonalizado: ModeloPersonalizadoRelatorioGerencialInput
  readonly nome?: InputMaybe<Scalars['String']['input']>
  readonly tipoModulo: TipoModuloEnum
}

export type EncaminhamentoExterno = {
  readonly __typename?: 'EncaminhamentoExterno'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly tipo: TipoEncaminhamentoExternoEnum
}

export type EncaminhamentoExternoEspecializado = {
  readonly __typename?: 'EncaminhamentoExternoEspecializado'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
  readonly complemento?: Maybe<Scalars['String']['output']>
  readonly especialidadeSisreg: EspecialidadeSisreg
  readonly hipoteseDiagnosticoCiap?: Maybe<Ciap>
  readonly hipoteseDiagnosticoCid10?: Maybe<Cid10>
  readonly id: Scalars['ID']['output']
  readonly motivoEncaminhamento?: Maybe<Scalars['String']['output']>
  readonly observacoes?: Maybe<Scalars['String']['output']>
}

export type EncaminhamentoExternoEspecializadoQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly especialidadeId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodo?: InputMaybe<Period>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteMeus?: InputMaybe<Scalars['Boolean']['input']>
}

export type EncaminhamentoExternoEspecializadoQueryPayload = {
  readonly __typename?: 'EncaminhamentoExternoEspecializadoQueryPayload'
  readonly content: ReadonlyArray<Maybe<EncaminhamentoExternoEspecializado>>
  readonly pageInfo: PageInfo
}

export type EncaminhamentoExternoInput = {
  readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
  readonly complemento?: InputMaybe<Scalars['String']['input']>
  readonly especialidadeSisreg: Scalars['ID']['input']
  readonly hipoteseDiagnosticoCiap?: InputMaybe<Scalars['ID']['input']>
  readonly hipoteseDiagnosticoCid10?: InputMaybe<Scalars['ID']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly motivoEncaminhamento?: InputMaybe<Scalars['String']['input']>
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
}

export type EncaminhamentoExternoQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly periodo?: InputMaybe<Period>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteMeus?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoEncaminhamento?: InputMaybe<TipoEncaminhamentoExternoEnum>
}

export type EncaminhamentoInternoInput = {
  readonly agendado?: InputMaybe<Scalars['ID']['input']>
  readonly equipe?: InputMaybe<Scalars['ID']['input']>
  readonly responsavel?: InputMaybe<Scalars['ID']['input']>
  readonly tiposServico?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export type EncerrarGestacaoInput = {
  readonly dataDesfecho: Scalars['LocalDate']['input']
  readonly tipoGravidez?: InputMaybe<TipoGravidezEnum>
}

export type Endereco = {
  readonly __typename?: 'Endereco'
  readonly bairro?: Maybe<Scalars['String']['output']>
  readonly cep?: Maybe<Scalars['String']['output']>
  readonly complemento?: Maybe<Scalars['String']['output']>
  readonly logradouro?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly numero?: Maybe<Scalars['String']['output']>
  readonly pontoReferencia?: Maybe<Scalars['String']['output']>
  readonly semNumero?: Maybe<Scalars['Boolean']['output']>
  readonly tipoLogradouro?: Maybe<TipoLogradouro>
  readonly uf?: Maybe<Uf>
}

export type EnderecoIndigena = {
  readonly __typename?: 'EnderecoIndigena'
  readonly aldeiaResidencia?: Maybe<Aldeia>
  readonly dseiResidencia?: Maybe<Dsei>
  readonly municipio?: Maybe<Municipio>
  readonly numero?: Maybe<Scalars['String']['output']>
  readonly poloBaseResidencia?: Maybe<PoloBase>
  readonly uf?: Maybe<Uf>
}

export type EnderecoIndigenaInput = {
  readonly aldeiaResidenciaId: Scalars['ID']['input']
  readonly dseiResidenciaId: Scalars['ID']['input']
  readonly municipioId: Scalars['ID']['input']
  readonly numero: Scalars['String']['input']
  readonly poloBaseResidenciaId: Scalars['ID']['input']
  readonly ufId: Scalars['ID']['input']
}

export type EnderecoIndigenaTerritorioInput = {
  readonly aldeiaId: Scalars['Long']['input']
  readonly dseiId: Scalars['Long']['input']
  readonly municipioId: Scalars['Long']['input']
  readonly numero?: InputMaybe<Scalars['String']['input']>
  readonly poloBaseId: Scalars['Long']['input']
  readonly ufId: Scalars['Long']['input']
}

export type EnderecoInput = {
  readonly bairro?: InputMaybe<Scalars['String']['input']>
  readonly cep?: InputMaybe<Scalars['String']['input']>
  readonly complemento?: InputMaybe<Scalars['String']['input']>
  readonly logradouro?: InputMaybe<Scalars['String']['input']>
  readonly municipio?: InputMaybe<Scalars['String']['input']>
  readonly numero?: InputMaybe<Scalars['String']['input']>
  readonly pontoReferencia?: InputMaybe<Scalars['String']['input']>
  readonly semNumero?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoLogradouro?: InputMaybe<Scalars['String']['input']>
  readonly uf?: InputMaybe<Scalars['String']['input']>
}

export type EnderecoQueryPayload = {
  readonly __typename?: 'EnderecoQueryPayload'
  readonly bairro?: Maybe<Bairro>
  readonly cep: Scalars['String']['output']
  readonly logradouro?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly tipoLogradouro?: Maybe<TipoLogradouro>
  readonly uf?: Maybe<Uf>
}

export type EnderecoTerritorioInput = {
  readonly bairro: Scalars['String']['input']
  readonly cep: Scalars['String']['input']
  readonly complemento?: InputMaybe<Scalars['String']['input']>
  readonly logradouro: Scalars['String']['input']
  readonly municipioId: Scalars['Long']['input']
  readonly numero?: InputMaybe<Scalars['String']['input']>
  readonly pontoReferencia?: InputMaybe<Scalars['String']['input']>
  readonly semNumero?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoLogradouroId: Scalars['Long']['input']
  readonly ufId: Scalars['Long']['input']
}

export type EnviarGarantiaAcessoCuidadoCompartilhadoInput = {
  readonly motivo: Scalars['String']['input']
  readonly tipoAgendamento: CondutaCuidadoCompartilhadoEnum
}

export type Equipe = {
  readonly __typename?: 'Equipe'
  readonly area?: Maybe<Scalars['String']['output']>
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly emapsApoio: ReadonlyArray<Equipe>
  readonly equipesVinculadas: ReadonlyArray<Equipe>
  readonly id: Scalars['ID']['output']
  readonly ine: Scalars['String']['output']
  readonly isAD: Scalars['Boolean']['output']
  readonly nome: Scalars['String']['output']
  readonly tipoEquipe: TipoEquipe
  readonly unidadeSaude: UnidadeSaude
}

export type EquipeAdInput = {
  readonly descricaoTipoEquipe: Scalars['String']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EquipeAdPayload = {
  readonly __typename?: 'EquipeADPayload'
  readonly content: ReadonlyArray<Maybe<Equipe>>
  readonly pageInfo: PageInfo
}

export type EquipePayload = {
  readonly __typename?: 'EquipePayload'
  readonly content: ReadonlyArray<Maybe<Equipe>>
  readonly pageInfo: PageInfo
}

export type EquipesAdQueryInput = {
  readonly equipeId?: InputMaybe<Scalars['ID']['input']>
  readonly localidadeId?: InputMaybe<Scalars['ID']['input']>
  readonly mostrarEquipesRelacionadas?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EquipesListaCuidadoCompartilhadoQueryInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EquipesQueryInput = {
  readonly equipeId?: InputMaybe<Scalars['ID']['input']>
  readonly equipePrincipalId?: InputMaybe<Scalars['ID']['input']>
  readonly localidadeId?: InputMaybe<Scalars['ID']['input']>
  readonly mostrarInativas?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tiposEquipe?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly unidadeSaudeId?: InputMaybe<Scalars['ID']['input']>
}

export type Escolaridade = {
  readonly __typename?: 'Escolaridade'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export enum EscolaridadeEnum {
  ALFABETIZACAO_PARA_ADULTOS_MOBRAL_ETC = 'ALFABETIZACAO_PARA_ADULTOS_MOBRAL_ETC',
  CLASSE_ALFABETIZADA_CA = 'CLASSE_ALFABETIZADA_CA',
  CRECHE = 'CRECHE',
  ENSINO_FUNDAMENTAL_1_A_4_SERIES = 'ENSINO_FUNDAMENTAL_1_A_4_SERIES',
  ENSINO_FUNDAMENTAL_5_A_8_SERIES = 'ENSINO_FUNDAMENTAL_5_A_8_SERIES',
  ENSINO_FUNDAMENTAL_COMPLETO = 'ENSINO_FUNDAMENTAL_COMPLETO',
  ENSINO_FUNDAMENTAL_EJA_SERIES_INICIAIS_SUPLETIVO_1_A_4 = 'ENSINO_FUNDAMENTAL_EJA_SERIES_INICIAIS_SUPLETIVO_1_A_4',
  ENSINO_FUNDAMENTAL_EJA_SERIES_INICIAIS_SUPLETIVO_5_A_8 = 'ENSINO_FUNDAMENTAL_EJA_SERIES_INICIAIS_SUPLETIVO_5_A_8',
  ENSINO_FUNDAMENTAL_ESPECIAL = 'ENSINO_FUNDAMENTAL_ESPECIAL',
  ENSINO_MEDIO_EJA_SUPLETIVO = 'ENSINO_MEDIO_EJA_SUPLETIVO',
  ENSINO_MEDIO_ESPECIAL = 'ENSINO_MEDIO_ESPECIAL',
  ENSINO_MEDIO_MEDIO_2_CICLO = 'ENSINO_MEDIO_MEDIO_2_CICLO',
  NENHUM = 'NENHUM',
  PRE_ESCOLA_EXCETO_CA = 'PRE_ESCOLA_EXCETO_CA',
  SUPERIOR_APERFEICOAMENTO_ESPECIALIZACAO_MESTRADO_DOUTORADO = 'SUPERIOR_APERFEICOAMENTO_ESPECIALIZACAO_MESTRADO_DOUTORADO',
}

export type EscutaInicialAprovacaoInput = {
  readonly escutaInicialInput?: InputMaybe<EscutaInicialInput>
  readonly rascunho?: InputMaybe<Scalars['String']['input']>
}

export type EscutaInicialInput = {
  readonly agendamentoConsulta?: InputMaybe<AgendamentoConsultaAtendimentoInput>
  readonly ciapId: Scalars['ID']['input']
  readonly classificacaoRiscoEnum?: InputMaybe<ClassificacaoRisco>
  readonly desfecho?: InputMaybe<DesfechoAtendimentoInput>
  readonly id: Scalars['ID']['input']
  readonly imprimirEscuta?: InputMaybe<Scalars['Boolean']['input']>
  readonly medicoes?: InputMaybe<MedicoesInput>
  readonly motivoConsulta?: InputMaybe<Scalars['String']['input']>
  readonly procedimentos?: InputMaybe<ReadonlyArray<InputMaybe<ProcedimentoAtendimentoInput>>>
  readonly procedimentosAdministrativos?: InputMaybe<ReadonlyArray<InputMaybe<ProcedimentoAtendimentoInput>>>
}

export type EscutaOrPreAtendimentoOfAtendimentoInput = {
  readonly atendimentoId: Scalars['ID']['input']
  readonly dataAtendimentoProfissional: Scalars['LocalDate']['input']
}

export type EspecialidadeEsusReg = {
  readonly __typename?: 'EspecialidadeEsusReg'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type EspecialidadeSisreg = {
  readonly __typename?: 'EspecialidadeSisreg'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export type EspecialidadeSisregQueryInput = {
  readonly isAtendimentoOdonto?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EspecialidadeSisregQueryPayload = {
  readonly __typename?: 'EspecialidadeSisregQueryPayload'
  readonly content: ReadonlyArray<Maybe<EspecialidadeSisreg>>
  readonly pageInfo: PageInfo
}

export type EspecialidadesEsusQueryInput = {
  readonly filtroPadrao?: InputMaybe<Scalars['Boolean']['input']>
  readonly onlyOdontologico?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EspecialidadesEsusRegDto = {
  readonly __typename?: 'EspecialidadesEsusRegDto'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type EspecialidadesEsusRegQueryPayload = {
  readonly __typename?: 'EspecialidadesEsusRegQueryPayload'
  readonly content: ReadonlyArray<EspecialidadesEsusRegDto>
  readonly pageInfo: PageInfo
}

export type EsquemaCalendarioVacinalQueryInput = {
  readonly dataAtendimento: Scalars['Instant']['input']
  readonly dataNascimento: Scalars['LocalDate']['input']
  readonly gestante: Scalars['Boolean']['input']
  readonly grupoAlvo: GrupoAlvoVacinacaoEnum
  readonly sexo: SexoEnum
}

export type EstabelecimentosCuidadoCompartilhadoByCboIdQueryInput = {
  readonly cboCodigo2002: Scalars['String']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EstabelecimentosListaCuidadoCompartilhadoQueryInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly role: CuidadoCompartilhadoQueryFilterEnum
  readonly somenteSemExecutante: Scalars['Boolean']['input']
}

export type EstadoCivil = {
  readonly __typename?: 'EstadoCivil'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export enum EstadoCivilEnum {
  CASADO = 'CASADO',
  SEPARADO_JUDICIALMENTE = 'SEPARADO_JUDICIALMENTE',
  SOLTEIRO = 'SOLTEIRO',
  UNIAO_CONSENSUAL = 'UNIAO_CONSENSUAL',
  VIUVO = 'VIUVO',
}

export type Estagio = Acesso & {
  readonly __typename?: 'Estagio'
  readonly actions: AcessoActions
  readonly ativo: Scalars['Boolean']['output']
  readonly cbo: Cbo
  readonly dataFimVigencia: Scalars['LocalDate']['output']
  readonly dataInicioVigencia: Scalars['LocalDate']['output']
  readonly equipe?: Maybe<Equipe>
  readonly id: Scalars['ID']['output']
  readonly instituicaoEnsino?: Maybe<Scalars['String']['output']>
  readonly lotacaoSupervisora: Lotacao
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio: Municipio
  readonly nivelTecnico: Scalars['Boolean']['output']
  readonly perfis: ReadonlyArray<Perfil>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
  readonly unidadeSaude: UnidadeSaude
}

export type EstagioCreateInput = {
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly cboId: Scalars['ID']['input']
  readonly dataFimVigencia: Scalars['LocalDate']['input']
  readonly dataInicioVigencia: Scalars['LocalDate']['input']
  readonly equipeId?: InputMaybe<Scalars['ID']['input']>
  readonly instituicaoEnsino?: InputMaybe<Scalars['String']['input']>
  readonly lotacaoSupervisoraId: Scalars['ID']['input']
  readonly nivelTecnico: Scalars['Boolean']['input']
  readonly perfisId: ReadonlyArray<Scalars['ID']['input']>
  readonly profissionalId: Scalars['ID']['input']
  readonly unidadeSaudeId: Scalars['ID']['input']
}

export type EstagioUpdateInput = {
  readonly dataFimVigencia: Scalars['LocalDate']['input']
  readonly dataInicioVigencia: Scalars['LocalDate']['input']
  readonly id: Scalars['ID']['input']
  readonly instituicaoEnsino?: InputMaybe<Scalars['String']['input']>
  readonly perfisId: ReadonlyArray<Scalars['ID']['input']>
}

export type EstagiosQueryInput = {
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly filterByNomeOrCns?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly profissionalId?: InputMaybe<Scalars['Long']['input']>
}

export type EstagiosQueryPayload = {
  readonly __typename?: 'EstagiosQueryPayload'
  readonly content: ReadonlyArray<Estagio>
  readonly pageInfo: PageInfo
}

export type EstrategiaVacinacao = {
  readonly __typename?: 'EstrategiaVacinacao'
  readonly codigo: Scalars['String']['output']
  readonly estrategiaVacinacaoDbEnum: EstrategiaVacinacaoEnum
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeFiltro: Scalars['String']['output']
}

export enum EstrategiaVacinacaoEnum {
  BLOQUEIO = 'BLOQUEIO',
  CAMPANHA_INDISCRIMINADA = 'CAMPANHA_INDISCRIMINADA',
  CAMPANHA_SELETIVA = 'CAMPANHA_SELETIVA',
  ESPECIAL = 'ESPECIAL',
  INTENSIFICACAO = 'INTENSIFICACAO',
  MEV = 'MEV',
  MULTIVACINACAO = 'MULTIVACINACAO',
  PESQUISA = 'PESQUISA',
  POS_EXPOSICAO = 'POS_EXPOSICAO',
  PRE_EXPOSICAO = 'PRE_EXPOSICAO',
  REEXPOSICAO = 'REEXPOSICAO',
  ROTINA = 'ROTINA',
  SERVICO_PRIVADO = 'SERVICO_PRIVADO',
  SOROTERAPIA = 'SOROTERAPIA',
  VACINACAO_ESCOLAR = 'VACINACAO_ESCOLAR',
}

export type EstrategiasVacinacaoQueryInput = {
  readonly doseId?: InputMaybe<Scalars['ID']['input']>
  readonly imunobiologicoId?: InputMaybe<Scalars['ID']['input']>
  readonly outrosImunobiologicos?: InputMaybe<Scalars['Boolean']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly sexo?: InputMaybe<SexoEnum>
}

export enum EstratificacaoRisco {
  ALTO = 'ALTO',
  BAIXO = 'BAIXO',
  MODERADO = 'MODERADO',
  MUITO_ALTO = 'MUITO_ALTO',
}

export type Etnia = {
  readonly __typename?: 'Etnia'
  readonly codigoCadsus: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type EtniaPayload = {
  readonly __typename?: 'EtniaPayload'
  readonly content: ReadonlyArray<Maybe<Etnia>>
  readonly pageInfo: PageInfo
}

export type EtniaQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type EventoSdc = {
  readonly id: Scalars['ID']['output']
  readonly subtitulo?: Maybe<Scalars['String']['output']>
  readonly titulo?: Maybe<Scalars['String']['output']>
}

export type EvolucaoAlergia = {
  readonly __typename?: 'EvolucaoAlergia'
  readonly alergia?: Maybe<Alergia>
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly atualizadoEm: Scalars['Instant']['output']
  readonly criticidade: CriticidadeAlergia
  readonly dataInicio?: Maybe<Scalars['LocalDate']['output']>
  readonly grauCerteza: GrauCertezaAlergia
  readonly id: Scalars['ID']['output']
  readonly manifestacoes: ReadonlyArray<ManifestacaoAlergia>
  readonly manifestacoesLegado?: Maybe<Scalars['String']['output']>
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly possuiSubstanciaEspecificaCbara?: Maybe<Scalars['Boolean']['output']>
  readonly tipoReacao?: Maybe<TipoReacaoAlergia>
}

export type EvolucaoAvaliacao = {
  readonly __typename?: 'EvolucaoAvaliacao'
  readonly ciapsCids?: Maybe<ReadonlyArray<EvolucaoAvaliacaoCiapCid>>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly necessidadeDeProtese?: Maybe<Scalars['Boolean']['output']>
  readonly tiposVigilanciaBucal?: Maybe<ReadonlyArray<Maybe<VigilanciaEmSaudeBucalEnum>>>
}

export type EvolucaoAvaliacaoCiapCid = {
  readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly cid11?: Maybe<Cid11>
  readonly id: Scalars['ID']['output']
  readonly isCiapCidNaListaDeProblemas: Scalars['Boolean']['output']
  readonly nota?: Maybe<Scalars['String']['output']>
}

export type EvolucaoDente = {
  readonly __typename?: 'EvolucaoDente'
  readonly dente: Dente
  readonly id: Scalars['ID']['output']
  readonly odontograma?: Maybe<Odontograma>
  readonly situacaoCoroaBaixo?: Maybe<SituacaoCoroaEnum>
  readonly situacaoCoroaCentro?: Maybe<SituacaoCoroaEnum>
  readonly situacaoCoroaCima?: Maybe<SituacaoCoroaEnum>
  readonly situacaoCoroaDireita?: Maybe<SituacaoCoroaEnum>
  readonly situacaoCoroaEsquerda?: Maybe<SituacaoCoroaEnum>
  readonly situacoesFace?: Maybe<ReadonlyArray<SituacaoFaceEnum>>
  readonly situacoesRaiz?: Maybe<ReadonlyArray<SituacaoRaizEnum>>
}

export type EvolucaoDenteInput = {
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly parteBucal: ParteBucalEnum
  readonly procedimentos?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly situacaoCoroaBaixo?: InputMaybe<SituacaoCoroaEnum>
  readonly situacaoCoroaCentro?: InputMaybe<SituacaoCoroaEnum>
  readonly situacaoCoroaCima?: InputMaybe<SituacaoCoroaEnum>
  readonly situacaoCoroaDireita?: InputMaybe<SituacaoCoroaEnum>
  readonly situacaoCoroaEsquerda?: InputMaybe<SituacaoCoroaEnum>
  readonly situacoesFace?: InputMaybe<ReadonlyArray<InputMaybe<SituacaoFaceEnum>>>
  readonly situacoesRaiz?: InputMaybe<ReadonlyArray<InputMaybe<SituacaoRaizEnum>>>
}

export type EvolucaoObjetivo = {
  readonly __typename?: 'EvolucaoObjetivo'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly necessidadesEspeciais?: Maybe<Scalars['Boolean']['output']>
}

export type EvolucaoPlano = {
  readonly __typename?: 'EvolucaoPlano'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly intervencoesProcedimentos?: Maybe<ReadonlyArray<Maybe<EvolucaoPlanoCiap>>>
}

export type EvolucaoPlanoCiap = {
  readonly __typename?: 'EvolucaoPlanoCiap'
  readonly automatico?: Maybe<Scalars['Boolean']['output']>
  readonly ciap?: Maybe<Ciap>
  readonly id: Scalars['ID']['output']
  readonly nota?: Maybe<Scalars['String']['output']>
  readonly procedimento?: Maybe<Procedimento>
}

export type EvolucaoProblema = {
  readonly __typename?: 'EvolucaoProblema'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly atualizadoEm?: Maybe<Scalars['Instant']['output']>
  readonly dataFim?: Maybe<Scalars['LocalDate']['output']>
  readonly dataInicio?: Maybe<Scalars['LocalDate']['output']>
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly possuiCiap: Scalars['Boolean']['output']
  readonly possuiCid: Scalars['Boolean']['output']
  readonly possuiCid11: Scalars['Boolean']['output']
  readonly problema?: Maybe<Problema>
  readonly situacao: SituacaoProblema
}

export type EvolucaoProcedimentoOdonto = {
  readonly __typename?: 'EvolucaoProcedimentoOdonto'
  readonly atendimentoProfissionalOdonto: AtendimentoProfissionalOdonto
  readonly descricaoParteBucal?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly partesBucais?: Maybe<ReadonlyArray<ParteBucal>>
  readonly procedimentos?: Maybe<ReadonlyArray<Procedimento>>
}

export type EvolucaoProcedimentoOdontoInput = {
  readonly descricaoLocal?: InputMaybe<Scalars['String']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly parteBucal: ParteBucalEnum
  readonly procedimentos: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>
}

export type EvolucaoProcedimentoPayload = {
  readonly __typename?: 'EvolucaoProcedimentoPayload'
  readonly content?: Maybe<ReadonlyArray<Maybe<EvolucaoProcedimentoOdonto>>>
  readonly pageInfo?: Maybe<PageInfo>
}

export type EvolucaoSubjetivo = {
  readonly __typename?: 'EvolucaoSubjetivo'
  readonly acompanhadoEspecialidade?: Maybe<Scalars['String']['output']>
  readonly ciaps?: Maybe<ReadonlyArray<Maybe<EvolucaoSubjetivoCiap>>>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
}

export type EvolucaoSubjetivoCiap = {
  readonly __typename?: 'EvolucaoSubjetivoCiap'
  readonly ciap: Ciap
  readonly id: Scalars['ID']['output']
  readonly nota?: Maybe<Scalars['String']['output']>
}

export type EvolucoesProcedimentoOdontoInput = {
  readonly atendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tipoPartesBucais?: InputMaybe<ReadonlyArray<InputMaybe<TipoParteBucalEnum>>>
  readonly unpaged?: InputMaybe<Scalars['Boolean']['input']>
}

export type ExameBasicoConsolidado = {
  readonly __typename?: 'ExameBasicoConsolidado'
  readonly dataRealizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly valor?: Maybe<Scalars['String']['output']>
}

export type ExameCitopatologicoUteroPayload = {
  readonly __typename?: 'ExameCitopatologicoUteroPayload'
  readonly id: Scalars['ID']['output']
  readonly requisicaoExameId: Scalars['ID']['output']
  readonly respostas: ReadonlyArray<Maybe<RastreioCancerPerguntaRespostaDto>>
}

export enum ExameEspecificoEnum {
  CLEARANCE_DE_CREATINA = 'CLEARANCE_DE_CREATINA',
  COLESTEROL_HDL = 'COLESTEROL_HDL',
  COLESTEROL_LDL = 'COLESTEROL_LDL',
  COLESTEROL_TOTAL = 'COLESTEROL_TOTAL',
  DOSAGEM_DE_CREATINA = 'DOSAGEM_DE_CREATINA',
  EXAMES_IMAGEM_RMN = 'EXAMES_IMAGEM_RMN',
  EXAMES_IMAGEM_TC = 'EXAMES_IMAGEM_TC',
  EXAMES_IMAGEM_US = 'EXAMES_IMAGEM_US',
  FUNDOSCOPIA = 'FUNDOSCOPIA',
  HEMOGLOBINA_GLICADA = 'HEMOGLOBINA_GLICADA',
  PEATEAB = 'PEATEAB',
  PEATEST = 'PEATEST',
  PRENATAL = 'PRENATAL',
  PROVA_DO_LACO = 'PROVA_DO_LACO',
  TESTE_OLHINHO = 'TESTE_OLHINHO',
  TRIGLICERIDIOS = 'TRIGLICERIDIOS',
}

export type ExameFisicoInput = {
  readonly membroInferiorDireito?: InputMaybe<Scalars['String']['input']>
  readonly membroInferiorEsquerdo?: InputMaybe<Scalars['String']['input']>
  readonly olhoDireito?: InputMaybe<Scalars['String']['input']>
  readonly olhoEsquerdo?: InputMaybe<Scalars['String']['input']>
  readonly ouvidoDireito?: InputMaybe<Scalars['String']['input']>
  readonly ouvidoEsquerdo?: InputMaybe<Scalars['String']['input']>
  readonly pele?: InputMaybe<Scalars['String']['input']>
}

export enum ExameRealizadoPreNatalConsolidadoStatusEnum {
  NAO = 'NAO',
  NAO_SE_APLICA = 'NAO_SE_APLICA',
  SIM = 'SIM',
}

export type ExameRequisitadoInput = {
  readonly exameId: Scalars['ID']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
}

export type ExameZika = {
  readonly __typename?: 'ExameZika'
  readonly dataRealizacao: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly resultado: Scalars['String']['output']
}

export type ExamesDiabeteConsolidado = {
  readonly __typename?: 'ExamesDiabeteConsolidado'
  readonly dataAvaliacaoPes?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimaSolicitacaoHemoglobinaGlicada?: Maybe<Scalars['LocalDate']['output']>
  readonly hemoglobinaGlicada?: Maybe<ExameBasicoConsolidado>
}

export type ExamesPreNatalDto = {
  readonly __typename?: 'ExamesPreNatalDto'
  readonly codigoProcedimento: Scalars['String']['output']
  readonly nomeProcedimento: Scalars['String']['output']
  readonly procedimentoId: Scalars['Long']['output']
  readonly registrosNoTrimestre: Scalars['Int']['output']
  readonly status: AcompanhamentoPreNatalStatusExameEnum
  readonly ultimaDataResultado?: Maybe<Scalars['LocalDate']['output']>
}

export type ExamesPreNatalInput = {
  readonly dataInicioGestacao: Scalars['LocalDate']['input']
  readonly prontuarioId: Scalars['Long']['input']
  readonly sort?: InputMaybe<Scalars['String']['input']>
  readonly trimestreGestacional: TrimestreGestacional
}

export type ExamesPuerperioDto = {
  readonly __typename?: 'ExamesPuerperioDto'
  readonly codigoProcedimento: Scalars['String']['output']
  readonly nomeProcedimento: Scalars['String']['output']
  readonly procedimentoId: Scalars['Long']['output']
  readonly registros: Scalars['Int']['output']
  readonly ultimaDataRealizacao: Scalars['LocalDate']['output']
}

export type ExamesRealizadosPreNatalConsolidado = {
  readonly __typename?: 'ExamesRealizadosPreNatalConsolidado'
  readonly hepatiteBPrimeiroTrimestre?: Maybe<ExameRealizadoPreNatalConsolidadoStatusEnum>
  readonly hepatiteCPrimeiroTrimestre?: Maybe<ExameRealizadoPreNatalConsolidadoStatusEnum>
  readonly hivPrimeiroTrimestre?: Maybe<ExameRealizadoPreNatalConsolidadoStatusEnum>
  readonly hivTerceiroTrimestre?: Maybe<ExameRealizadoPreNatalConsolidadoStatusEnum>
  readonly sifilisPrimeiroTrimestre?: Maybe<ExameRealizadoPreNatalConsolidadoStatusEnum>
  readonly sifilisTerceiroTrimestre?: Maybe<ExameRealizadoPreNatalConsolidadoStatusEnum>
}

export type ExamesSdcDto = {
  readonly __typename?: 'ExamesSdcDto'
  readonly cid10?: Maybe<Cid10>
  readonly gruposProcedimentosSdcDto?: Maybe<ReadonlyArray<Maybe<GruposProcedimentosSdcDto>>>
  readonly justificativa?: Maybe<Scalars['String']['output']>
  readonly tipoExame: TipoExameEnum
}

export type ExcluirModeloRelatorioGerencialInput = {
  readonly id: Scalars['ID']['input']
  readonly tipoModulo: TipoModuloEnum
}

export type ExcluirPerfilPayload = {
  readonly __typename?: 'ExcluirPerfilPayload'
  readonly id: Scalars['ID']['output']
}

export type FaixaEtariaAcompanhamentoInput = {
  readonly faixaEtariaRange?: InputMaybe<FaixaEtariaInput>
  readonly tipoFaixaEtaria: FaixaEtariaEnum
}

export enum FaixaEtariaConsumoAlimentar {
  MAIOR_DOIS_ANOS = 'MAIOR_DOIS_ANOS',
  MAIOR_SEIS_MESES_MENOR_DOIS_ANOS = 'MAIOR_SEIS_MESES_MENOR_DOIS_ANOS',
  MENOR_SEIS_MESES = 'MENOR_SEIS_MESES',
}

export enum FaixaEtariaEnum {
  ADOLESCENTE = 'ADOLESCENTE',
  ADULTO = 'ADULTO',
  CRIANCA = 'CRIANCA',
  IDOSO = 'IDOSO',
  OUTRA = 'OUTRA',
  TODAS_FAIXAS = 'TODAS_FAIXAS',
}

export type FaixaEtariaInput = {
  readonly idadeMaxima?: InputMaybe<Scalars['Long']['input']>
  readonly idadeMinima?: InputMaybe<Scalars['Long']['input']>
  readonly tipoFaixaEtaria?: InputMaybe<AgeRangeType>
}

export type FaixaEtariaVacinacao = {
  readonly __typename?: 'FaixaEtariaVacinacao'
  readonly descricao: Scalars['String']['output']
  readonly diasFim: Scalars['Int']['output']
  readonly diasInicio: Scalars['Int']['output']
  readonly id: Scalars['ID']['output']
}

export type FaixaEtariaVacinacaoQueryInput = {
  readonly doseId: Scalars['ID']['input']
  readonly estrategiaId: Scalars['ID']['input']
  readonly imunobiologicoId: Scalars['ID']['input']
}

export type Familia = {
  readonly __typename?: 'Familia'
  readonly cidadaos: ReadonlyArray<Cidadao>
  readonly cidadaosTerritorioBasico: ReadonlyArray<CidadaoTerritorioBasico>
  readonly cnes: Scalars['String']['output']
  readonly cpfCnsResponsavel?: Maybe<Scalars['String']['output']>
  readonly equipe?: Maybe<Equipe>
  readonly id: Scalars['ID']['output']
  readonly imovel?: Maybe<ImovelDto>
  readonly ine: Scalars['String']['output']
  readonly isDomicilioAtivo: Scalars['Boolean']['output']
  readonly isFamiliaAindaReside: Scalars['Boolean']['output']
  readonly isInformacaoSuficiente: Scalars['Boolean']['output']
  readonly isResponsavelAindaReside: Scalars['Boolean']['output']
  readonly isResponsavelCadastrado: Scalars['Boolean']['output']
  readonly isResponsavelDeclarado: Scalars['Boolean']['output']
  readonly isResponsavelUnico: Scalars['Boolean']['output']
  readonly isResponsavelVivo: Scalars['Boolean']['output']
  readonly numeroMembros?: Maybe<Scalars['Int']['output']>
  readonly numeroProntuarioFamiliar?: Maybe<Scalars['String']['output']>
  readonly rendaFamiliar?: Maybe<RendaFamiliar>
  readonly resideDesde?: Maybe<Scalars['LocalDate']['output']>
  readonly responsavel?: Maybe<CidadaoTerritorioBasico>
  readonly vulnerabilidadeFamiliar?: Maybe<VulnerabilidadeFamiliar>
}

export type FamiliaCidadaosArgs = {
  input?: InputMaybe<CidadaosFamiliaInput>
}

export type FamiliaCidadaosTerritorioBasicoArgs = {
  input?: InputMaybe<CidadaosFamiliaInput>
}

export type FamiliaInput = {
  readonly cidadaos: ReadonlyArray<CidadaoTerritorioInput>
  readonly mudouSe?: InputMaybe<Scalars['Boolean']['input']>
  readonly numeroMembros?: InputMaybe<Scalars['Int']['input']>
  readonly numeroProntuarioFamiliar?: InputMaybe<Scalars['String']['input']>
  readonly rendaFamiliar?: InputMaybe<RendaFamiliar>
  readonly resideDesde?: InputMaybe<Scalars['LocalDate']['input']>
  readonly responsavelId: Scalars['ID']['input']
}

export type FamiliarAntecedentesInput = {
  readonly ciaps?: InputMaybe<ReadonlyArray<InputMaybe<AntecedenteFamiliarCiapInput>>>
}

export type FamiliasImovelInput = {
  readonly isDomicilioAtivo?: InputMaybe<Scalars['Boolean']['input']>
  readonly isFamiliaAindaReside?: InputMaybe<Scalars['Boolean']['input']>
  readonly isInformacaoSuficiente?: InputMaybe<Scalars['Boolean']['input']>
  readonly isResponsavelAindaReside?: InputMaybe<Scalars['Boolean']['input']>
  readonly isResponsavelCadastrado?: InputMaybe<Scalars['Boolean']['input']>
  readonly isResponsavelDeclarado?: InputMaybe<Scalars['Boolean']['input']>
  readonly isResponsavelUnico?: InputMaybe<Scalars['Boolean']['input']>
  readonly isResponsavelVivo?: InputMaybe<Scalars['Boolean']['input']>
}

export type FatoAppAtendimento = {
  readonly __typename?: 'FatoAppAtendimento'
  readonly campoAbertoAvaliacao?: Maybe<Scalars['String']['output']>
  readonly campoAbertoObjetivo?: Maybe<Scalars['String']['output']>
  readonly campoAbertoPlano?: Maybe<Scalars['String']['output']>
  readonly campoAbertoSubjetivo?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
}

export type FatoAtendDomProblemaCondicao = {
  readonly __typename?: 'FatoAtendDomProblemaCondicao'
  readonly dataFimProblema?: Maybe<Scalars['Instant']['output']>
  readonly dataInicioProblema?: Maybe<Scalars['Instant']['output']>
  readonly dimensaoCiap?: Maybe<DimensaoCiap>
  readonly dimensaoCid10?: Maybe<DimensaoCid10>
  readonly dimensaoSituacaoProblema?: Maybe<DimensaoSituacaoProblema>
  readonly id: Scalars['ID']['output']
}

export type FatoAtendDomProced = {
  readonly __typename?: 'FatoAtendDomProced'
  readonly dimensaoProcedimento: DimensaoProcedimento
  readonly id: Scalars['ID']['output']
  readonly nuUuidFicha: Scalars['String']['output']
}

export type FatoAtendIndividualEncaminhamentos = {
  readonly __typename?: 'FatoAtendIndividualEncaminhamentos'
  readonly dimensaoCboGuiaEncaminhamento?: Maybe<DimensaoCbo>
  readonly dimensaoCiap?: Maybe<DimensaoCiap>
  readonly dimensaoCid10?: Maybe<DimensaoCid10>
  readonly dimensaoClassificacaoRiscoEncaminhamento?: Maybe<DimensaoClassificacaoRiscoEncaminhamento>
  readonly dimensaoPrioridadeCuidado?: Maybe<DimensaoPrioridadeCuidado>
  readonly especialidadeSisreg?: Maybe<EspecialidadeSisreg>
  readonly id: Scalars['ID']['output']
}

export type FatoAtendOdontoProblemas = {
  readonly __typename?: 'FatoAtendOdontoProblemas'
  readonly dataFimProblema?: Maybe<Scalars['Instant']['output']>
  readonly dataInicioProblema?: Maybe<Scalars['Instant']['output']>
  readonly dimensaoCiap?: Maybe<DimensaoCiap>
  readonly dimensaoCid10?: Maybe<DimensaoCid10>
  readonly dimensaoSituacaoProblema?: Maybe<DimensaoSituacaoProblema>
  readonly id: Scalars['ID']['output']
}

export type FatoAtendOdontoProced = {
  readonly __typename?: 'FatoAtendOdontoProced'
  readonly dimensaoProcedimento: DimensaoProcedimento
  readonly id: Scalars['ID']['output']
  readonly quantidadeProcedimentos: Scalars['Int']['output']
}

export type FatoAtendimentoDomiciliar = {
  readonly __typename?: 'FatoAtendimentoDomiciliar'
  readonly condicoesAvaliadas: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly dimensaoCbo1?: Maybe<DimensaoCbo>
  readonly dimensaoCbo2?: Maybe<DimensaoCbo>
  readonly dimensaoCondutaAD?: Maybe<DimensaoCondutaAd>
  readonly dimensaoEquipe1?: Maybe<DimensaoEquipe>
  readonly dimensaoEquipe2?: Maybe<DimensaoEquipe>
  readonly dimensaoLocalAtendimento?: Maybe<DimensaoLocalAtendimento>
  readonly dimensaoModalidadeAD?: Maybe<DimensaoModalidadeAd>
  readonly dimensaoProfissional1?: Maybe<DimensaoProfissional>
  readonly dimensaoProfissional2?: Maybe<DimensaoProfissional>
  readonly dimensaoUnidadeSaude1?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoUnidadeSaude2?: Maybe<DimensaoUnidadeSaude>
  readonly fatosAtendDomProblemaCondicao?: Maybe<ReadonlyArray<Maybe<FatoAtendDomProblemaCondicao>>>
  readonly id: Scalars['ID']['output']
  readonly nuUuidFicha: Scalars['String']['output']
  readonly procedimentos?: Maybe<ReadonlyArray<Maybe<FatoAtendDomProced>>>
}

export type FatoAtendimentoIndividual = {
  readonly __typename?: 'FatoAtendimentoIndividual'
  readonly condutaDesfecho: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly dataFinalAtendimento: Scalars['Instant']['output']
  readonly dataInicialAtendimento: Scalars['Instant']['output']
  readonly dataNascimento: Scalars['Instant']['output']
  readonly dataRegistro?: Maybe<Scalars['Instant']['output']>
  readonly dimCboFinalizadorObs?: Maybe<DimensaoCbo>
  readonly dimEquipeFinalizadorObs?: Maybe<DimensaoEquipe>
  readonly dimProfFinalizadorObs?: Maybe<DimensaoProfissional>
  readonly dimTipoParticipacaoCidadao?: Maybe<DimensaoTipoParticipacaoAtendimento>
  readonly dimTipoParticipacaoProfConvidado?: Maybe<DimensaoTipoParticipacaoAtendimento>
  readonly dimUbsFinalizadorObs?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoAleitamento?: Maybe<DimensaoAleitamento>
  readonly dimensaoCbo1?: Maybe<DimensaoCbo>
  readonly dimensaoCbo2?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe1?: Maybe<DimensaoEquipe>
  readonly dimensaoEquipe2?: Maybe<DimensaoEquipe>
  readonly dimensaoLocalAtendimento?: Maybe<DimensaoLocalAtendimento>
  readonly dimensaoMchatRfRisco?: Maybe<DimensaoMchatRisco>
  readonly dimensaoMchatRisco?: Maybe<DimensaoMchatRisco>
  readonly dimensaoModalidadeAd?: Maybe<DimensaoModalidadeAd>
  readonly dimensaoMunicipio?: Maybe<DimensaoMunicipio>
  readonly dimensaoProfissional1?: Maybe<DimensaoProfissional>
  readonly dimensaoProfissional2?: Maybe<DimensaoProfissional>
  readonly dimensaoRacionalidadeSaude?: Maybe<DimensaoRacionalidadeSaude>
  readonly dimensaoSexo: DimensaoSexo
  readonly dimensaoTipoGlicemia?: Maybe<DimensaoTipoGlicemiaEnum>
  readonly dimensaoTurno: DimensaoTurno
  readonly dimensaoUnidadeSaude1?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoUnidadeSaude2?: Maybe<DimensaoUnidadeSaude>
  readonly dum?: Maybe<Scalars['Instant']['output']>
  readonly encaminhamentoServicoEspecializado?: Maybe<Scalars['Boolean']['output']>
  readonly encaminhamentos: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly encaminhamentosEspecializados?: Maybe<ReadonlyArray<FatoAtendIndividualEncaminhamentos>>
  readonly examesAvaliados?: Maybe<ReadonlyArray<Maybe<DimensaoProcedimento>>>
  readonly examesSolicitados?: Maybe<ReadonlyArray<Maybe<DimensaoProcedimento>>>
  readonly fatoAppAtendimento?: Maybe<FatoAppAtendimento>
  readonly filtroCiapMotivoConsulta?: Maybe<Scalars['String']['output']>
  readonly filtroCiapPlano?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly ivcf?: Maybe<FatoIvcf>
  readonly mchatPontuacao?: Maybe<Scalars['Int']['output']>
  readonly mchatRfPontuacao?: Maybe<Scalars['Int']['output']>
  readonly medicamentos?: Maybe<ReadonlyArray<Maybe<FatoAtendimentoIndividualMedicamentos>>>
  readonly nasfPolo: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly nuAltura?: Maybe<Scalars['Float']['output']>
  readonly nuCNS?: Maybe<Scalars['String']['output']>
  readonly nuCPFCidadao?: Maybe<Scalars['String']['output']>
  readonly nuCircAbdominal?: Maybe<Scalars['Float']['output']>
  readonly nuFreqCardiaca?: Maybe<Scalars['Int']['output']>
  readonly nuFreqRespiratoria?: Maybe<Scalars['Int']['output']>
  readonly nuGestasPrevias?: Maybe<Scalars['Int']['output']>
  readonly nuGlicemia?: Maybe<Scalars['Int']['output']>
  readonly nuIdadeGestacional?: Maybe<Scalars['Int']['output']>
  readonly nuImc?: Maybe<Scalars['Float']['output']>
  readonly nuPartos?: Maybe<Scalars['Int']['output']>
  readonly nuPerimPanturrilha?: Maybe<Scalars['Float']['output']>
  readonly nuPerimetroCefalico?: Maybe<Scalars['Float']['output']>
  readonly nuPeso?: Maybe<Scalars['Float']['output']>
  readonly nuPressaoDiastolica?: Maybe<Scalars['Int']['output']>
  readonly nuPressaoSistolica?: Maybe<Scalars['Int']['output']>
  readonly nuSaturacaoO2?: Maybe<Scalars['Int']['output']>
  readonly nuTemperatura?: Maybe<Scalars['Float']['output']>
  readonly nuUuidFicha: Scalars['String']['output']
  readonly problemas: ReadonlyArray<Maybe<FatoAtendimentoIndividualProblemas>>
  readonly resultadosExamesEspecificos?: Maybe<ReadonlyArray<Maybe<FatoAtendimentoIndividualExames>>>
  readonly solicitacoesOci?: Maybe<ReadonlyArray<FatoSolicitacaoOci>>
  readonly stFicouEmObservacao?: Maybe<Scalars['Boolean']['output']>
  readonly stGravidezPlanejada?: Maybe<Scalars['Boolean']['output']>
  readonly stNasf: Scalars['Boolean']['output']
  readonly stVacinacaoEmDia?: Maybe<Scalars['Boolean']['output']>
}

export type FatoAtendimentoIndividualExames = {
  readonly __typename?: 'FatoAtendimentoIndividualExames'
  readonly dataRealizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataResultado?: Maybe<Scalars['LocalDate']['output']>
  readonly dataResultadoData?: Maybe<Scalars['LocalDate']['output']>
  readonly dataSolicitacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dimensaoProcedimento?: Maybe<DimensaoProcedimento>
  readonly id: Scalars['ID']['output']
  readonly nuResultadoDia?: Maybe<Scalars['Int']['output']>
  readonly nuResultadoSemana?: Maybe<Scalars['Int']['output']>
  readonly nuResultadoValor?: Maybe<Scalars['Float']['output']>
  readonly resultadoExameEstruturadoQualitativo?: Maybe<OpcoesResultadoExameQualitativoEnum>
  readonly resultadoPuericultura?: Maybe<FichaComplementarZikaMicrocefaliaResultadoExameEnum>
}

export type FatoAtendimentoIndividualMedicamentos = {
  readonly __typename?: 'FatoAtendimentoIndividualMedicamentos'
  readonly dataInicioTratamento?: Maybe<Scalars['LocalDate']['output']>
  readonly dimensaoCatmat?: Maybe<DimensaoCatmat>
  readonly dimensaoViaAdministracao?: Maybe<DimensaoViaAdministracao>
  readonly dose?: Maybe<Scalars['String']['output']>
  readonly doseFrequencia?: Maybe<Scalars['Long']['output']>
  readonly doseUnica?: Maybe<Scalars['Boolean']['output']>
  readonly duracao?: Maybe<Scalars['Long']['output']>
  readonly frequenciaDose?: Maybe<Scalars['String']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly qtDoseManha?: Maybe<Scalars['String']['output']>
  readonly qtDoseNoite?: Maybe<Scalars['String']['output']>
  readonly qtDoseTarde?: Maybe<Scalars['String']['output']>
  readonly quantidade?: Maybe<Scalars['Long']['output']>
  readonly tipoFrequencia?: Maybe<TipoFrequencia>
  readonly unidadeFrequenciaDose?: Maybe<UnidadeMedidaTempoEnum>
  readonly unidadeMedidaDuracao?: Maybe<UnidadeMedidaTempoEnum>
  readonly usoContinuo?: Maybe<Scalars['Boolean']['output']>
}

export type FatoAtendimentoIndividualProblemas = {
  readonly __typename?: 'FatoAtendimentoIndividualProblemas'
  readonly dataFimProblema?: Maybe<Scalars['Instant']['output']>
  readonly dataInicioProblema?: Maybe<Scalars['Instant']['output']>
  readonly dimensaoCiap?: Maybe<DimensaoCiap>
  readonly dimensaoCid10?: Maybe<DimensaoCid10>
  readonly dimensaoSituacaoProblema?: Maybe<DimensaoSituacaoProblema>
  readonly id: Scalars['ID']['output']
}

export type FatoAtendimentoOdonto = {
  readonly __typename?: 'FatoAtendimentoOdonto'
  readonly conduta: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly dimTipoParticipacaoCidadao?: Maybe<DimensaoTipoParticipacaoAtendimento>
  readonly dimTipoParticipacaoProfConvidado?: Maybe<DimensaoTipoParticipacaoAtendimento>
  readonly dimensaoCbo1?: Maybe<DimensaoCbo>
  readonly dimensaoCbo2?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe1?: Maybe<DimensaoEquipe>
  readonly dimensaoEquipe2?: Maybe<DimensaoEquipe>
  readonly dimensaoLocalAtendimento?: Maybe<DimensaoLocalAtendimento>
  readonly dimensaoProfissional1?: Maybe<DimensaoProfissional>
  readonly dimensaoProfissional2?: Maybe<DimensaoProfissional>
  readonly dimensaoTipoGlicemia?: Maybe<DimensaoTipoGlicemiaEnum>
  readonly dimensaoUnidadeSaude1?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoUnidadeSaude2?: Maybe<DimensaoUnidadeSaude>
  readonly encaminhamento: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly exames?: Maybe<ReadonlyArray<Maybe<FatoAtendimentoOdontoExames>>>
  readonly fornecimento: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly id: Scalars['ID']['output']
  readonly isGestante?: Maybe<Scalars['Boolean']['output']>
  readonly isPacienteNecessidadesEspeciais: Scalars['Boolean']['output']
  readonly ivcf?: Maybe<FatoIvcf>
  readonly medicamentos?: Maybe<ReadonlyArray<Maybe<FatoAtendimentoOdontoMedicamentos>>>
  readonly nuAltura?: Maybe<Scalars['Float']['output']>
  readonly nuCircAbdominal?: Maybe<Scalars['Float']['output']>
  readonly nuFreqCardiaca?: Maybe<Scalars['Int']['output']>
  readonly nuFreqRespiratoria?: Maybe<Scalars['Int']['output']>
  readonly nuGlicemia?: Maybe<Scalars['Int']['output']>
  readonly nuImc?: Maybe<Scalars['Float']['output']>
  readonly nuPerimPanturrilha?: Maybe<Scalars['Float']['output']>
  readonly nuPerimetroCefalico?: Maybe<Scalars['Float']['output']>
  readonly nuPeso?: Maybe<Scalars['Float']['output']>
  readonly nuPressaoDiastolica?: Maybe<Scalars['Int']['output']>
  readonly nuPressaoSistolica?: Maybe<Scalars['Int']['output']>
  readonly nuSaturacaoO2?: Maybe<Scalars['Int']['output']>
  readonly nuTemperatura?: Maybe<Scalars['Float']['output']>
  readonly problemas?: Maybe<ReadonlyArray<Maybe<FatoAtendOdontoProblemas>>>
  readonly procedimentos?: Maybe<ReadonlyArray<Maybe<FatoAtendOdontoProced>>>
  readonly solicitacoesOci?: Maybe<ReadonlyArray<FatoSolicitacaoOci>>
  readonly vigilanciaSaudeBucal: ReadonlyArray<Maybe<Scalars['String']['output']>>
}

export type FatoAtendimentoOdontoExames = {
  readonly __typename?: 'FatoAtendimentoOdontoExames'
  readonly dataRealizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataResultado?: Maybe<Scalars['LocalDate']['output']>
  readonly dataResultadoData?: Maybe<Scalars['LocalDate']['output']>
  readonly dataSolicitacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dimensaoProcedimentoAvaliado?: Maybe<DimensaoProcedimento>
  readonly dimensaoProcedimentoSolicitado?: Maybe<DimensaoProcedimento>
  readonly id: Scalars['ID']['output']
  readonly nuResultadoDia?: Maybe<Scalars['Int']['output']>
  readonly nuResultadoSemana?: Maybe<Scalars['Int']['output']>
  readonly nuResultadoValor?: Maybe<Scalars['Float']['output']>
  readonly resultadoExameEstruturadoQualitativo?: Maybe<OpcoesResultadoExameQualitativoEnum>
  readonly resultadoPuericultura?: Maybe<FichaComplementarZikaMicrocefaliaResultadoExameEnum>
}

export type FatoAtendimentoOdontoMedicamentos = {
  readonly __typename?: 'FatoAtendimentoOdontoMedicamentos'
  readonly dataInicioTratamento?: Maybe<Scalars['LocalDate']['output']>
  readonly dimensaoCatmat?: Maybe<DimensaoCatmat>
  readonly dimensaoViaAdministracao?: Maybe<DimensaoViaAdministracao>
  readonly dose?: Maybe<Scalars['String']['output']>
  readonly doseFrequencia?: Maybe<Scalars['Long']['output']>
  readonly doseUnica?: Maybe<Scalars['Boolean']['output']>
  readonly duracao?: Maybe<Scalars['Long']['output']>
  readonly frequenciaDose?: Maybe<Scalars['String']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly qtDoseManha?: Maybe<Scalars['String']['output']>
  readonly qtDoseNoite?: Maybe<Scalars['String']['output']>
  readonly qtDoseTarde?: Maybe<Scalars['String']['output']>
  readonly quantidade?: Maybe<Scalars['Long']['output']>
  readonly tipoFrequencia?: Maybe<TipoFrequencia>
  readonly unidadeFrequenciaDose?: Maybe<UnidadeMedidaTempoEnum>
  readonly unidadeMedidaDuracao?: Maybe<UnidadeMedidaTempoEnum>
  readonly usoContinuo?: Maybe<Scalars['Boolean']['output']>
}

export type FatoAtividadeColetiva = {
  readonly __typename?: 'FatoAtividadeColetiva'
  readonly dataRegistro?: Maybe<Scalars['Instant']['output']>
  readonly descricaoOutraLocalidade?: Maybe<Scalars['String']['output']>
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoInep?: Maybe<DimensaoInep>
  readonly dimensaoMunicipio?: Maybe<DimensaoMunicipio>
  readonly dimensaoProcedimento?: Maybe<DimensaoProcedimento>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoTipoAtividade: DimensaoTipoAtividade
  readonly dimensaoTurno: DimensaoTurno
  readonly dimensaoUnddSadeAcdmSade?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly fatoAtividadeColetivaParticipantes?: Maybe<ReadonlyArray<FatoAtividadeColetivaParticipante>>
  readonly fatoAtividadeColetivaProfissionalParticipante?: Maybe<
    ReadonlyArray<FatoAtividadeColetivaProfissionalParticipante>
  >
  readonly id: Scalars['ID']['output']
  readonly nuAvaliacoesAlteradas?: Maybe<Scalars['Int']['output']>
  readonly nuParticipantes?: Maybe<Scalars['Int']['output']>
  readonly nuParticipantesRegistrados?: Maybe<Scalars['Int']['output']>
  readonly nuUuidFicha: Scalars['String']['output']
  readonly origem?: Maybe<OrigemDadoEnum>
  readonly praticasSaude?: Maybe<ReadonlyArray<Maybe<PraticaSaudeEnum>>>
  readonly publicoAlvo?: Maybe<ReadonlyArray<Maybe<PublicoAlvoEnum>>>
  readonly stPseEducacao: Scalars['Boolean']['output']
  readonly stPseSaude: Scalars['Boolean']['output']
  readonly temasReuniao?: Maybe<ReadonlyArray<Maybe<TemaReuniaoEnum>>>
  readonly temasSaude?: Maybe<ReadonlyArray<Maybe<TemaSaudeEnum>>>
}

export type FatoAtividadeColetivaParticipante = {
  readonly __typename?: 'FatoAtividadeColetivaParticipante'
  readonly dataRegistro?: Maybe<Scalars['Instant']['output']>
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoMunicipio?: Maybe<DimensaoMunicipio>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoSexo: DimensaoSexo
  readonly dimensaoTipoAtividade: DimensaoTipoAtividade
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly dtNascimentoParticipante: Scalars['Instant']['output']
  readonly fatoAtividadeColetiva: FatoAtividadeColetiva
  readonly fatoCidadaoPec?: Maybe<FatoCidadaoPec>
  readonly id: Scalars['ID']['output']
  readonly nuAlturaParticipante?: Maybe<Scalars['Float']['output']>
  readonly nuCnsParticipante?: Maybe<Scalars['String']['output']>
  readonly nuCpfParticipante?: Maybe<Scalars['String']['output']>
  readonly nuImcParticipante?: Maybe<Scalars['Float']['output']>
  readonly nuPesoParticipante?: Maybe<Scalars['Float']['output']>
  readonly nuUuidFicha: Scalars['String']['output']
  readonly pnctParticipante: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly stAvaliacaoAlterada?: Maybe<Scalars['Boolean']['output']>
  readonly stPnctAbandonouGrupo?: Maybe<Scalars['Boolean']['output']>
  readonly stPnctCessouHabitoFumar?: Maybe<Scalars['Boolean']['output']>
}

export type FatoAtividadeColetivaPayload = {
  readonly __typename?: 'FatoAtividadeColetivaPayload'
  readonly content: ReadonlyArray<FatoAtividadeColetiva>
  readonly pageInfo: PageInfo
}

export type FatoAtividadeColetivaProfissionalParticipante = {
  readonly __typename?: 'FatoAtividadeColetivaProfissionalParticipante'
  readonly dimensaoCboParticipante?: Maybe<DimensaoCbo>
  readonly dimensaoProfissionalParticipante?: Maybe<DimensaoProfissional>
  readonly id: Scalars['ID']['output']
}

export type FatoAvaliacaoElegibilidade = {
  readonly __typename?: 'FatoAvaliacaoElegibilidade'
  readonly cnsCuidador?: Maybe<Scalars['String']['output']>
  readonly conclusao?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly condicoesAvaliadas?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly cpfCuidador?: Maybe<Scalars['String']['output']>
  readonly dimensaoCbo1?: Maybe<DimensaoCbo>
  readonly dimensaoCbo2?: Maybe<DimensaoCbo>
  readonly dimensaoCid10Principal?: Maybe<DimensaoCid10>
  readonly dimensaoCid10SecundarioDois?: Maybe<DimensaoCid10>
  readonly dimensaoCid10SecundarioUm?: Maybe<DimensaoCid10>
  readonly dimensaoCuidador?: Maybe<DimensaoCuidador>
  readonly dimensaoEquipe1?: Maybe<DimensaoEquipe>
  readonly dimensaoEquipe2?: Maybe<DimensaoEquipe>
  readonly dimensaoModalidadeAD?: Maybe<DimensaoModalidadeAd>
  readonly dimensaoProfissional1?: Maybe<DimensaoProfissional>
  readonly dimensaoProfissional2?: Maybe<DimensaoProfissional>
  readonly dimensaoUnidadeSaude1?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoUnidadeSaude2?: Maybe<DimensaoUnidadeSaude>
  readonly id: Scalars['ID']['output']
  readonly isElegivel: Scalars['Boolean']['output']
  readonly nuUuidFicha: Scalars['String']['output']
  readonly procedenciaOrigem?: Maybe<Scalars['String']['output']>
}

export type FatoCidadaoPec = {
  readonly __typename?: 'FatoCidadaoPec'
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly cpf?: Maybe<Scalars['String']['output']>
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly dimensaoSexo?: Maybe<DimensaoSexo>
  readonly id: Scalars['ID']['output']
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
}

export type FatoCuidadoCompartilhado = {
  readonly __typename?: 'FatoCuidadoCompartilhado'
  readonly cnsCidadao?: Maybe<Scalars['String']['output']>
  readonly codigoSequencialEvolucao?: Maybe<Scalars['Int']['output']>
  readonly cpfCidadao?: Maybe<Scalars['String']['output']>
  readonly dataCriacaoCuidado?: Maybe<Scalars['Instant']['output']>
  readonly dataEvolucao?: Maybe<Scalars['Instant']['output']>
  readonly dataEvolucaoAnterior?: Maybe<Scalars['Instant']['output']>
  readonly dataNascimentoCidadao?: Maybe<Scalars['LocalDate']['output']>
  readonly dimCboEvolucao?: Maybe<DimensaoCbo>
  readonly dimCboExecutante?: Maybe<DimensaoCbo>
  readonly dimCboSolicitante?: Maybe<DimensaoCbo>
  readonly dimEquipeEvolucao?: Maybe<DimensaoEquipe>
  readonly dimEquipeExecutante?: Maybe<DimensaoEquipe>
  readonly dimEquipeSolicitante?: Maybe<DimensaoEquipe>
  readonly dimProfissionalEvolucao?: Maybe<DimensaoProfissional>
  readonly dimProfissionalExecutante?: Maybe<DimensaoProfissional>
  readonly dimProfissionalSolicitante?: Maybe<DimensaoProfissional>
  readonly dimReclassificacaoPrioridade?: Maybe<DimensaoPrioridadeCuidado>
  readonly dimUnidadeSaudeEvolucao?: Maybe<DimensaoUnidadeSaude>
  readonly dimUnidadeSaudeExecutante?: Maybe<DimensaoUnidadeSaude>
  readonly dimUnidadeSaudeSolicitante?: Maybe<DimensaoUnidadeSaude>
  readonly dimensaoCiap?: Maybe<DimensaoCiap>
  readonly dimensaoCid10?: Maybe<DimensaoCid10>
  readonly dimensaoCondutaCuidado?: Maybe<DimensaoCondutaCuidado>
  readonly dimensaoPrioridadeCuidado?: Maybe<DimensaoPrioridadeCuidado>
  readonly dimensaoSexo?: Maybe<DimensaoSexo>
  readonly dimensaoTurno?: Maybe<DimensaoTurno>
  readonly id: Scalars['ID']['output']
  readonly isExecutante?: Maybe<Scalars['Boolean']['output']>
}

export type FatoIvcf = {
  readonly __typename?: 'FatoIvcf'
  readonly dataResultado: Scalars['Instant']['output']
  readonly dimensaoCbo: DimensaoCbo
  readonly dimensaoGrauVulnerabilidadeIvcf: DimensaoGrauVulnerabilidadeIvcf
  readonly dimensaoProfissional: DimensaoProfissional
  readonly dimensoesAlteradas: Scalars['String']['output']
  readonly hasSgAlcancePreensaoPinca: Scalars['Boolean']['output']
  readonly hasSgAudicao: Scalars['Boolean']['output']
  readonly hasSgAvdBasica: Scalars['Boolean']['output']
  readonly hasSgAvdInstrumental: Scalars['Boolean']['output']
  readonly hasSgCapAerobicaMuscular: Scalars['Boolean']['output']
  readonly hasSgCognicao: Scalars['Boolean']['output']
  readonly hasSgComorbidade: Scalars['Boolean']['output']
  readonly hasSgContinencia: Scalars['Boolean']['output']
  readonly hasSgHumor: Scalars['Boolean']['output']
  readonly hasSgIdade: Scalars['Boolean']['output']
  readonly hasSgMarcha: Scalars['Boolean']['output']
  readonly hasSgPercepcaoSaude: Scalars['Boolean']['output']
  readonly hasSgVisao: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly resultado: Scalars['Int']['output']
  readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
}

export type FatoProcedAtend = {
  readonly __typename?: 'FatoProcedAtend'
  readonly dataRegistro: Scalars['Instant']['output']
  readonly dimensaoCbo: DimensaoCbo
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoLocalAtendimento?: Maybe<DimensaoLocalAtendimento>
  readonly dimensaoMunicipio: DimensaoMunicipio
  readonly dimensaoProfissional: DimensaoProfissional
  readonly dimensaoSexo: DimensaoSexo
  readonly dimensaoTipoGlicemia?: Maybe<DimensaoTipoGlicemiaEnum>
  readonly dimensaoTurno: DimensaoTurno
  readonly dimensaoUnidadeSaude: DimensaoUnidadeSaude
  readonly dtFinalAtendimento?: Maybe<Scalars['Instant']['output']>
  readonly dtInicialAtendimento?: Maybe<Scalars['Instant']['output']>
  readonly dtNascimento?: Maybe<Scalars['Instant']['output']>
  readonly fatoAppAtendimento?: Maybe<FatoAppAtendimento>
  readonly filtroCiapMotivoConsulta?: Maybe<Scalars['String']['output']>
  readonly filtroCiapPlano?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly ivcf?: Maybe<FatoIvcf>
  readonly nuAltura?: Maybe<Scalars['Float']['output']>
  readonly nuCircAbdominal?: Maybe<Scalars['Float']['output']>
  readonly nuCnsCidadao?: Maybe<Scalars['String']['output']>
  readonly nuCpfCidadao?: Maybe<Scalars['String']['output']>
  readonly nuFreqCardiaca?: Maybe<Scalars['Int']['output']>
  readonly nuFreqRespiratoria?: Maybe<Scalars['Int']['output']>
  readonly nuGlicemia?: Maybe<Scalars['Int']['output']>
  readonly nuImc?: Maybe<Scalars['Float']['output']>
  readonly nuPerimPanturrilha?: Maybe<Scalars['Float']['output']>
  readonly nuPerimetroCefalico?: Maybe<Scalars['Float']['output']>
  readonly nuPeso?: Maybe<Scalars['Float']['output']>
  readonly nuPressaoDiastolica?: Maybe<Scalars['Int']['output']>
  readonly nuPressaoSistolica?: Maybe<Scalars['Int']['output']>
  readonly nuSaturacaoO2?: Maybe<Scalars['Int']['output']>
  readonly nuTemperatura?: Maybe<Scalars['Float']['output']>
  readonly nuUuidFicha: Scalars['String']['output']
  readonly procedimentos?: Maybe<ReadonlyArray<DimensaoProcedimento>>
  readonly stEscutaInicial?: Maybe<Scalars['Boolean']['output']>
}

export type FatoSolicitacaoOci = {
  readonly __typename?: 'FatoSolicitacaoOci'
  readonly dimensaoProcedimento: DimensaoProcedimento
  readonly id: Scalars['ID']['output']
}

export type FatoVacinacao = {
  readonly __typename?: 'FatoVacinacao'
  readonly comunicanteHanseniase?: Maybe<Scalars['Boolean']['output']>
  readonly dataRegistro: Scalars['Instant']['output']
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoCondicaoMaternal?: Maybe<DimensaoCondicaoMaternal>
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoLocalAtendimento?: Maybe<DimensaoLocalAtendimento>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly fatosVacinacaoVacina?: Maybe<ReadonlyArray<FatoVacinacaoVacina>>
  readonly id: Scalars['ID']['output']
  readonly viajante?: Maybe<Scalars['Boolean']['output']>
}

export type FatoVacinacaoVacina = {
  readonly __typename?: 'FatoVacinacaoVacina'
  readonly anvisaNumeroRegistro?: Maybe<Scalars['String']['output']>
  readonly anvisaProtocoloEstudo?: Maybe<Scalars['String']['output']>
  readonly anvisaProtocoloVersao?: Maybe<Scalars['String']['output']>
  readonly dataRegistro: Scalars['Instant']['output']
  readonly dataRegistroVacinaAplicada: Scalars['Instant']['output']
  readonly dimensaoCboPrescritor?: Maybe<DimensaoCbo>
  readonly dimensaoCid10MotivoIndicacao?: Maybe<DimensaoCid10>
  readonly dimensaoDoseImunobiologico: DimensaoDoseImunobiologico
  readonly dimensaoEstrategiaVacinacao?: Maybe<DimensaoEstrategiaVacinacao>
  readonly dimensaoGrupoAtendimento: DimensaoGrupoAtendimento
  readonly dimensaoImunobiologico: DimensaoImunobiologico
  readonly dimensaoLocalAplicacao?: Maybe<DimensaoLocalAplicacaoVacina>
  readonly dimensaoUnidadeSaude: DimensaoUnidadeSaude
  readonly dimensaoViaAdministracao?: Maybe<DimensaoViaAdministracaoVacina>
  readonly fatoVacinacao: FatoVacinacao
  readonly id: Scalars['ID']['output']
  readonly isPesquisaClinica?: Maybe<Scalars['Boolean']['output']>
  readonly isRegistroAnterior: Scalars['Boolean']['output']
  readonly nomeFabricante?: Maybe<Scalars['String']['output']>
  readonly nomeLote?: Maybe<Scalars['String']['output']>
}

export type FatoVisitaDomiciliar = {
  readonly __typename?: 'FatoVisitaDomiciliar'
  readonly acompanhamento: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly altura?: Maybe<Scalars['Float']['output']>
  readonly anotacoes?: Maybe<Scalars['String']['output']>
  readonly buscaAtiva: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly cidadaoPec?: Maybe<FatoCidadaoPec>
  readonly cnsCidadao?: Maybe<Scalars['String']['output']>
  readonly controleAmbiental: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly cpfCidadao?: Maybe<Scalars['String']['output']>
  readonly dataNascimentoCidadao?: Maybe<Scalars['Instant']['output']>
  readonly dataVisita?: Maybe<Scalars['LocalDate']['output']>
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoDesfechoVisita: DimensaoDesfechoVisita
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoSexo?: Maybe<DimensaoSexo>
  readonly dimensaoTipoGlicemia?: Maybe<DimensaoTipoGlicemia>
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly id: Scalars['ID']['output']
  readonly ivcf?: Maybe<FatoIvcf>
  readonly latitude?: Maybe<Scalars['Float']['output']>
  readonly longitude?: Maybe<Scalars['Float']['output']>
  readonly medicaoGlicemia?: Maybe<Scalars['String']['output']>
  readonly medicaoPressaoArterial?: Maybe<Scalars['String']['output']>
  readonly motivoVisita: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly nuUuidFicha: Scalars['String']['output']
  readonly origem?: Maybe<OrigemDadoEnum>
  readonly peso?: Maybe<Scalars['Float']['output']>
  readonly stVisitaCompartilhada?: Maybe<Scalars['Boolean']['output']>
  readonly temperatura?: Maybe<Scalars['String']['output']>
  readonly tipoOrigem?: Maybe<DimensaoTipoOrigem>
  readonly tipoVisita?: Maybe<Scalars['Int']['output']>
  readonly turno?: Maybe<DimensaoTurno>
}

export type FatorRisco = AvaliacaoDesenvolvimento & {
  readonly __typename?: 'FatorRisco'
  readonly dataAvaliacao?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly status: StatusAvaliadoEnum
}

export type FechamentoAgenda = {
  readonly __typename?: 'FechamentoAgenda'
  readonly dataFinal?: Maybe<Scalars['LocalDate']['output']>
  readonly dataInicial?: Maybe<Scalars['LocalDate']['output']>
  readonly especifique?: Maybe<Scalars['String']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly motivo?: Maybe<Scalars['String']['output']>
}

export type FechamentoAgendaDiaQueryInput = {
  readonly dia: Scalars['LocalDate']['input']
  readonly lotacaoId: Scalars['ID']['input']
}

export type FechamentoAgendaInput = {
  readonly especifique?: InputMaybe<Scalars['String']['input']>
  readonly idLotacao: Scalars['ID']['input']
  readonly motivo: MotivoFechamentoEnum
  readonly periodo: Period
}

export type FechamentoAgendaQueryInput = {
  readonly idLotacao: Scalars['ID']['input']
  readonly pageParams?: InputMaybe<PageParams>
}

export type FechamentoAgendaQueryPayload = {
  readonly __typename?: 'FechamentoAgendaQueryPayload'
  readonly content: ReadonlyArray<Maybe<FechamentoAgenda>>
  readonly pageInfo: PageInfo
}

export type FichaCadastroDomiciliarDto = {
  readonly __typename?: 'FichaCadastroDomiciliarDto'
  readonly numeroMoradores?: Maybe<Scalars['Int']['output']>
  readonly tipoDomicilioId?: Maybe<Scalars['ID']['output']>
  readonly tipoLocalizacaoId?: Maybe<Scalars['ID']['output']>
}

export enum FichaComplementarZikaMicrocefaliaResultadoExameEnum {
  DUVIDOSO_OU_AUSENTE = 'DUVIDOSO_OU_AUSENTE',
  FUNDO_OLHO_ALTERADO = 'FUNDO_OLHO_ALTERADO',
  FUNDO_OLHO_NORMAL = 'FUNDO_OLHO_NORMAL',
  ORELHINHA_FALHOU = 'ORELHINHA_FALHOU',
  ORELHINHA_PASSOU = 'ORELHINHA_PASSOU',
  PRESENTE_BILATERAL = 'PRESENTE_BILATERAL',
  RESSONANCIA_INDETERMINADO = 'RESSONANCIA_INDETERMINADO',
  RESSONANCIA_NORMAL = 'RESSONANCIA_NORMAL',
  RESSONANCIA_OUTRAS_ALTERACOES = 'RESSONANCIA_OUTRAS_ALTERACOES',
  RESSONANCIA_SUGESTIVO_INFECCAO_CONGENITA = 'RESSONANCIA_SUGESTIVO_INFECCAO_CONGENITA',
  TOMOGRAFIA_INDETERMINADO = 'TOMOGRAFIA_INDETERMINADO',
  TOMOGRAFIA_NORMAL = 'TOMOGRAFIA_NORMAL',
  TOMOGRAFIA_OUTRAS_ALTERACOES = 'TOMOGRAFIA_OUTRAS_ALTERACOES',
  TOMOGRAFIA_SUGESTIVO_INFECCAO_CONGENITA = 'TOMOGRAFIA_SUGESTIVO_INFECCAO_CONGENITA',
  TRANSFONTANELA_INDETERMINADO = 'TRANSFONTANELA_INDETERMINADO',
  TRANSFONTANELA_NORMAL = 'TRANSFONTANELA_NORMAL',
  TRANSFONTANELA_OUTRAS_ALTERACOES = 'TRANSFONTANELA_OUTRAS_ALTERACOES',
  TRANSFONTANELA_SUGESTIVO_INFECCAO_CONGENITA = 'TRANSFONTANELA_SUGESTIVO_INFECCAO_CONGENITA',
}

export type FichaNotificacaoCasoSuspeito = {
  readonly __typename?: 'FichaNotificacaoCasoSuspeito'
  readonly id: Scalars['ID']['output']
  readonly nomeNotificacao: Scalars['String']['output']
}

export type FichaNotificacaoQueryInput = {
  readonly cidadaoDataNascimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly cidadaoId: Scalars['ID']['input']
  readonly cidadaoSexo: SexoEnum
  readonly dataAtendimento: Scalars['Instant']['input']
  readonly isIdentidadeGeneroInformada?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type FichaNotificacaoQueryPayload = {
  readonly __typename?: 'FichaNotificacaoQueryPayload'
  readonly content: ReadonlyArray<Maybe<FichaNotificacaoCasoSuspeito>>
  readonly pageInfo: PageInfo
}

export type FichasConcatenadasHistorico = {
  readonly __typename?: 'FichasConcatenadasHistorico'
  readonly uuidProcedimento?: Maybe<Scalars['String']['output']>
  readonly uuidZika?: Maybe<Scalars['String']['output']>
}

export type FiltroDocumentosCidadaoInput = {
  readonly cnsSet?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly cpfSet?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly dnvSet?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly nisSet?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
}

export type FinalizacaoAtendimentoInput = {
  readonly agendamentoConsultas?: InputMaybe<AgendamentoConsultasAtendimentoInput>
  readonly atendimentoCompartilhadoLotacaoId?: InputMaybe<Scalars['ID']['input']>
  readonly condutas?: InputMaybe<ReadonlyArray<InputMaybe<CondutaEnum>>>
  readonly condutasOdonto?: InputMaybe<ReadonlyArray<InputMaybe<TipoEncaminhamentoOdontoEnum>>>
  readonly desfechoAtendimento?: InputMaybe<DesfechoAtendimentoInput>
  readonly fichaNotificacaoCasoSuspeito?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly fornecimentosOdonto?: InputMaybe<ReadonlyArray<InputMaybe<FornecimentoOdontoEnum>>>
  readonly procedimentosAdministrativos?: InputMaybe<ReadonlyArray<InputMaybe<ProcedimentoAtendimentoInput>>>
  readonly racionalidadeEmSaude?: InputMaybe<RacionalidadeEmSaudeEnum>
  readonly tipoAtendimento?: InputMaybe<TipoAtendimentoEnum>
  readonly tipoConsultaOdonto?: InputMaybe<TipoConsultaOdontoEnum>
  readonly tipoParticipacaoCidadao?: InputMaybe<TipoParticipacaoAtendimentoEnum>
  readonly tipoParticipacaoProfissionalConvidado?: InputMaybe<TipoParticipacaoAtendimentoEnum>
}

export type FinalizarAtendimentoIndividualResponse = {
  readonly __typename?: 'FinalizarAtendimentoIndividualResponse'
  readonly agendamentosCriadosIds: ReadonlyArray<Scalars['ID']['output']>
  readonly atendProf: AtendimentoProfissional
}

export type FlagInfo = {
  readonly __typename?: 'FlagInfo'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly valor: Scalars['Boolean']['output']
}

export enum FonteIdadeGestacionalEnum {
  DUM = 'DUM',
  US = 'US',
}

export type FormaFarmaceutica = {
  readonly __typename?: 'FormaFarmaceutica'
  readonly ativo: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type FormaFarmaceuticaPayload = {
  readonly __typename?: 'FormaFarmaceuticaPayload'
  readonly content: ReadonlyArray<Maybe<FormaFarmaceutica>>
  readonly pageInfo: PageInfo
}

export type FormaFarmaceuticaQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum FornecimentoOdontoEnum {
  CREME_DENTAL = 'CREME_DENTAL',
  ESCOVA_DENTAL = 'ESCOVA_DENTAL',
  FIO_DENTAL = 'FIO_DENTAL',
}

export enum FrontendLogLevelEnum {
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  OFF = 'OFF',
  TRACE = 'TRACE',
  WARN = 'WARN',
}

export type FuncaoSocial = {
  readonly __typename?: 'FuncaoSocial'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeFiltro: Scalars['String']['output']
}

export type FuncaoSocialPayload = {
  readonly __typename?: 'FuncaoSocialPayload'
  readonly content: ReadonlyArray<FuncaoSocial>
  readonly pageInfo: PageInfo
}

export type FuncaoSocialQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type GarantiaAcessoAgendarConsultaInput = {
  readonly agendamentoConsultaCompartilhadaInput?: InputMaybe<CriarAgendamentoConsultaCompartilhadaInput>
  readonly agendamentoConsultaInput?: InputMaybe<AgendamentoConsultaAtendimentoInput>
  readonly garantiaAcessoId: Scalars['ID']['input']
}

export type GarantiaAcessoFilter = {
  readonly equipes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly isCuidadoCompartilhado: Scalars['Boolean']['input']
  readonly isGarantiaAcesso: Scalars['Boolean']['input']
  readonly lotacoesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly nomeCpfCns?: InputMaybe<Scalars['String']['input']>
  readonly ordenacao: GarantiaAcessoSortEnum
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodo?: InputMaybe<Period>
  readonly tiposAtendimento?: InputMaybe<ReadonlyArray<ListaEsperaTipoAtendimentoEnum>>
  readonly tiposServicoIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export type GarantiaAcessoItemCreateInput = {
  readonly cidadaoId: Scalars['ID']['input']
  readonly equipeId?: InputMaybe<Scalars['ID']['input']>
  readonly motivo: Scalars['String']['input']
  readonly tipoAtendimento?: InputMaybe<ListaEsperaTipoAtendimentoEnum>
  readonly tipoServico?: InputMaybe<Scalars['ID']['input']>
}

export type GarantiaAcessoItemDeleteInput = {
  readonly garantiaAcessoId: Scalars['ID']['input']
  readonly motivoSaida?: InputMaybe<ListaEsperaMotivoSaidaEnum>
  readonly observacaoSaida?: InputMaybe<Scalars['String']['input']>
  readonly tentativasContato?: InputMaybe<Scalars['Int']['input']>
}

export type GarantiaAcessoItemUpdateInput = {
  readonly equipeId?: InputMaybe<Scalars['ID']['input']>
  readonly garantiaAcessoId: Scalars['ID']['input']
  readonly motivo: Scalars['String']['input']
  readonly tipoAtendimento?: InputMaybe<ListaEsperaTipoAtendimentoEnum>
  readonly tipoServico?: InputMaybe<Scalars['ID']['input']>
}

export type GarantiaAcessoPayload = {
  readonly __typename?: 'GarantiaAcessoPayload'
  readonly content: ReadonlyArray<Maybe<ListaEspera>>
  readonly pageInfo: PageInfo
}

export enum GarantiaAcessoSortEnum {
  CLASSIFICACAO_DE_PRIORIDADE = 'CLASSIFICACAO_DE_PRIORIDADE',
  ORDEM_CHEGADA_CRESCENTE = 'ORDEM_CHEGADA_CRESCENTE',
  ORDEM_CHEGADA_DECRESCENTE = 'ORDEM_CHEGADA_DECRESCENTE',
}

export type GerarLinkSistemaExternoInput = {
  readonly cidadaoId?: InputMaybe<Scalars['ID']['input']>
  readonly providerId: Scalars['ID']['input']
  readonly sistemaExternoId: Scalars['ID']['input']
}

export type GerarRelatorioRndsCsvInput = {
  readonly endDate: Scalars['Instant']['input']
  readonly startDate: Scalars['Instant']['input']
  readonly statusEnvioRegistro?: InputMaybe<StatusRelatorioEnvioRndsEnum>
  readonly tipoRegistro: ReadonlyArray<TipoRegistroRndsEnum>
}

export type GerarUrlIframePayload = {
  readonly __typename?: 'GerarUrlIframePayload'
  readonly urlAssinada: Scalars['String']['output']
}

export type GestorEstadual = Acesso & {
  readonly __typename?: 'GestorEstadual'
  readonly actions: AcessoActions
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly perfis: ReadonlyArray<Maybe<Perfil>>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
  readonly uf: Uf
}

export type GestorMunicipal = Acesso & {
  readonly __typename?: 'GestorMunicipal'
  readonly actions: AcessoActions
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio: Municipio
  readonly perfis: ReadonlyArray<Maybe<Perfil>>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
}

export enum GrauCertezaAlergia {
  CONFIRMADO = 'CONFIRMADO',
  NAO_INFORMADO = 'NAO_INFORMADO',
  REFUTADO = 'REFUTADO',
  RESOLVIDO = 'RESOLVIDO',
  SUSPEITO = 'SUSPEITO',
}

export enum GrauParentescoEnum {
  CONJUGE_COMPANHEIRO = 'CONJUGE_COMPANHEIRO',
  ENTEADO = 'ENTEADO',
  FILHO = 'FILHO',
  GENRO_NORA = 'GENRO_NORA',
  IRMAO_IRMA = 'IRMAO_IRMA',
  NAO_PARENTE = 'NAO_PARENTE',
  NETO_BISNETO = 'NETO_BISNETO',
  OUTRO = 'OUTRO',
  PAI_MAE = 'PAI_MAE',
  SOGRO = 'SOGRO',
}

export enum GrauSatisfacaoUsuario {
  INDIFERENTE = 'INDIFERENTE',
  INSATISFEITO = 'INSATISFEITO',
  MUITO_INSATISFEITO = 'MUITO_INSATISFEITO',
  MUITO_SATISFEITO = 'MUITO_SATISFEITO',
  SATISFEITO = 'SATISFEITO',
}

export enum GrauSugestivoVulnerabilidadeFamiliar {
  BAIXA = 'BAIXA',
  HABITUAL = 'HABITUAL',
  MAXIMA = 'MAXIMA',
  MEDIA = 'MEDIA',
}

export enum GrupoAlvoBuscaAtivaVacinacaoEnum {
  ADOLESCENTES = 'ADOLESCENTES',
  ADULTOS = 'ADULTOS',
  CRIANCAS = 'CRIANCAS',
  GESTANTES_E_PUERPERAS = 'GESTANTES_E_PUERPERAS',
  IDOSOS = 'IDOSOS',
}

export enum GrupoAlvoVacinacaoEnum {
  ADOLESCENTE = 'ADOLESCENTE',
  ADULTO = 'ADULTO',
  ADULTO_MAIOR_IGUAL_30_ANOS = 'ADULTO_MAIOR_IGUAL_30_ANOS',
  CRIANCAS = 'CRIANCAS',
  CRIANCA_E_ADOLESCENTE = 'CRIANCA_E_ADOLESCENTE',
  GESTANTE = 'GESTANTE',
  IDOSO = 'IDOSO',
  MAIOR_IGUAL_10_ANOS = 'MAIOR_IGUAL_10_ANOS',
  TODOS = 'TODOS',
}

export type GrupoAtendimento = {
  readonly __typename?: 'GrupoAtendimento'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeFiltro: Scalars['String']['output']
  readonly stAtivo: Scalars['Boolean']['output']
}

export type GrupoCondicao = {
  readonly __typename?: 'GrupoCondicao'
  readonly ciaps?: Maybe<ReadonlyArray<Maybe<Ciap>>>
  readonly cids?: Maybe<ReadonlyArray<Maybe<Cid10>>>
  readonly grupo: GrupoCondicaoEnum
  readonly id: Scalars['ID']['output']
}

export enum GrupoCondicaoEnum {
  ASMA = 'ASMA',
  AVC = 'AVC',
  CANCER = 'CANCER',
  DENGUE = 'DENGUE',
  DESNUTRICAO = 'DESNUTRICAO',
  DIABETES = 'DIABETES',
  DOENCA_CARDIACA = 'DOENCA_CARDIACA',
  DPOC = 'DPOC',
  GRAVIDEZ = 'GRAVIDEZ',
  HANSENIASE = 'HANSENIASE',
  HIPERTENSAO_ARTERIAL = 'HIPERTENSAO_ARTERIAL',
  INFARTO = 'INFARTO',
  IST = 'IST',
  OBESIDADE = 'OBESIDADE',
  REABILITACAO = 'REABILITACAO',
  RINS = 'RINS',
  SAUDE_MENTAL = 'SAUDE_MENTAL',
  SAUDE_SEXUAL_E_REPRODUTIVA = 'SAUDE_SEXUAL_E_REPRODUTIVA',
  TABAGISMO = 'TABAGISMO',
  TUBERCULOSE = 'TUBERCULOSE',
  USUARIO_DE_ALCOOL = 'USUARIO_DE_ALCOOL',
  USUARIO_DE_OUTRAS_DROGAS = 'USUARIO_DE_OUTRAS_DROGAS',
}

export type GrupoCondicaoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type GrupoCondicaoQueryPayLoad = {
  readonly __typename?: 'GrupoCondicaoQueryPayLoad'
  readonly content: ReadonlyArray<Maybe<GrupoCondicao>>
  readonly pageInfo: PageInfo
}

export type GrupoExame = {
  readonly __typename?: 'GrupoExame'
  readonly hasProcedimentosInativos?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly idadeMaxima?: Maybe<Scalars['Int']['output']>
  readonly idadeMinima?: Maybe<Scalars['Int']['output']>
  readonly nome: Scalars['String']['output']
  readonly procedimentos?: Maybe<ReadonlyArray<Maybe<Procedimento>>>
  readonly quantidadeProcedimentos?: Maybe<Scalars['Int']['output']>
}

export type GrupoExameInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly nome: Scalars['String']['input']
  readonly procedimentos: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>
}

export type GrupoExameQueryInput = {
  readonly dataNascimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly pageParams?: InputMaybe<OptionalPageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly sexo?: InputMaybe<SexoEnum>
}

export enum GrupoImunobiologicoEnum {
  DIFTERIA_TETANO_PERTUSIS_HEPATITE_B_HAEMOPHILUS_INFLUENZA_B = 'DIFTERIA_TETANO_PERTUSIS_HEPATITE_B_HAEMOPHILUS_INFLUENZA_B',
  DTPA = 'DTPA',
  HPV = 'HPV',
  INFLUENZA = 'INFLUENZA',
  PNEUMOCOCICA = 'PNEUMOCOCICA',
  POLIOMELITE = 'POLIOMELITE',
  SARAMPO_CACHUMBA_RUBEOLA = 'SARAMPO_CACHUMBA_RUBEOLA',
}

export type GrupoMedicoesTipo = {
  readonly __typename?: 'GrupoMedicoesTipo'
  readonly medicoes: ReadonlyArray<ItemGrupoMedicoesTipo>
  readonly tipo: TipoMedicaoEnum
}

export type GrupoParticipanteAtividadeColetiva = {
  readonly __typename?: 'GrupoParticipanteAtividadeColetiva'
  readonly ativo: Scalars['Boolean']['output']
  readonly cidadaosParticipantes: ReadonlyArray<Cidadao>
  readonly dataAtualizacaoStatusAtivo: Scalars['Instant']['output']
  readonly dataUltimaAtualizacao: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly lotacaoAtualizacaoStatusAtivo: Lotacao
  readonly lotacoesEnvolvidas: ReadonlyArray<Lotacao>
  readonly nome: Scalars['String']['output']
  readonly quantidadeIntegrantes: Scalars['Int']['output']
  readonly tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
  readonly unidadeSaude: UnidadeSaude
}

export type GrupoParticipanteAtividadeColetivaInput = {
  readonly cidadaosParticipantesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly lotacoesEnvolvidasIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly nome: Scalars['String']['input']
  readonly tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
}

export type GrupoParticipanteAtividadeColetivaPayLoad = {
  readonly __typename?: 'GrupoParticipanteAtividadeColetivaPayLoad'
  readonly content: ReadonlyArray<GrupoParticipanteAtividadeColetiva>
  readonly pageInfo: PageInfo
}

export type GrupoParticipanteAtividadeColetivaQueryInput = {
  readonly equipesIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly isAtivo: Scalars['Boolean']['input']
  readonly isSomenteMeusGrupos: Scalars['Boolean']['input']
  readonly nomeGrupo?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly tipoGrupo?: InputMaybe<TipoGrupoParticipanteAtividadeColetivaEnum>
  readonly unidadesSaudeIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
}

export enum GrupoProcedimentoEnum {
  ACOES_COMPLEMENTARES_ATENCAO_SAUDE = 'ACOES_COMPLEMENTARES_ATENCAO_SAUDE',
  ACOES_PROMOCAO_PREVENCAO_SAUDE = 'ACOES_PROMOCAO_PREVENCAO_SAUDE',
  CIRURGICO = 'CIRURGICO',
  CLINICOS = 'CLINICOS',
  FINALIDADE_DIAGNOSTICA = 'FINALIDADE_DIAGNOSTICA',
  MEDICAMENTOS = 'MEDICAMENTOS',
  OFERTAS_CUIDADOS_INTEGRADOS = 'OFERTAS_CUIDADOS_INTEGRADOS',
  ORTESES_PROTESES_MATERIAIS = 'ORTESES_PROTESES_MATERIAIS',
  TRANSPLANTES_ORGAOS = 'TRANSPLANTES_ORGAOS',
}

export enum GrupoRisco {
  CARDIOVASCULAR = 'CARDIOVASCULAR',
  DENGUE = 'DENGUE',
  PRE_ECLAMPSIA = 'PRE_ECLAMPSIA',
}

export enum GrupoSdcDengueEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

export type GruposExameQueryPayload = {
  readonly __typename?: 'GruposExameQueryPayload'
  readonly content: ReadonlyArray<Maybe<GrupoExame>>
  readonly pageInfo: PageInfo
}

export type GruposProcedimentosSdcDto = {
  readonly __typename?: 'GruposProcedimentosSdcDto'
  readonly procedimentosSdcDto?: Maybe<ReadonlyArray<Maybe<ProcedimentoSdcDto>>>
  readonly titulo: Scalars['String']['output']
}

export type GuiaEncaminhamento = {
  readonly __typename?: 'GuiaEncaminhamento'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly cbo: Cbo
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly discussao: Scalars['String']['output']
  readonly especialidade: EspecialidadeEsusReg
  readonly id: Scalars['ID']['output']
  readonly prontuario: Prontuario
}

export enum HigienePessoalEnum {
  ACESSO_AO_SANITARIO = 'ACESSO_AO_SANITARIO',
  BANHO = 'BANHO',
  HIGIENE_BUCAL = 'HIGIENE_BUCAL',
  OUTROS_ACESSO_HIGIENE = 'OUTROS_ACESSO_HIGIENE',
}

export type HipertensaoConsolidado = {
  readonly __typename?: 'HipertensaoConsolidado'
  readonly dataUltimaConsulta?: Maybe<Scalars['LocalDate']['output']>
  readonly qtdConsulta?: Maybe<Scalars['Long']['output']>
  readonly qtdPressaoArterial?: Maybe<Scalars['Long']['output']>
  readonly visitaDomiciliar?: Maybe<VisitaDomiciliarConsolidado>
}

export type Historico = {
  readonly __typename?: 'Historico'
  readonly cbo?: Maybe<Cbo>
  readonly cboEstagio?: Maybe<Cbo>
  readonly cboExecutante?: Maybe<Scalars['String']['output']>
  readonly cboFinalizadorObservacao?: Maybe<Scalars['String']['output']>
  readonly cboSolicitante?: Maybe<Scalars['String']['output']>
  readonly ciapCodigo?: Maybe<Scalars['String']['output']>
  readonly ciapNome?: Maybe<Scalars['String']['output']>
  readonly cidCodigo?: Maybe<Scalars['String']['output']>
  readonly cidNome?: Maybe<Scalars['String']['output']>
  readonly classificacaoPrioridade?: Maybe<Scalars['String']['output']>
  readonly classificacaoRisco?: Maybe<ClassificacaoRisco>
  readonly cnsExecutante?: Maybe<Scalars['String']['output']>
  readonly cnsFinalizadorObservacao?: Maybe<Scalars['String']['output']>
  readonly cnsProfissional?: Maybe<Scalars['String']['output']>
  readonly cnsSolicitante?: Maybe<Scalars['String']['output']>
  readonly coSubtipoAtendimento?: Maybe<Scalars['Int']['output']>
  readonly codigoUnicoRegistro?: Maybe<Scalars['String']['output']>
  readonly condicoesAvaliadas: ReadonlyArray<Scalars['String']['output']>
  readonly condicoesVacinacao?: Maybe<CondicoesVacinacao>
  readonly conduta?: Maybe<Scalars['String']['output']>
  readonly cpfCnsCidadao?: Maybe<Scalars['String']['output']>
  readonly cuidadoCompartilhado?: Maybe<CuidadoCompartilhado>
  readonly cuidadoCompartilhadoEvolucao?: Maybe<CuidadoCompartilhadoEvolucao>
  readonly dadosClinicos?: Maybe<Scalars['String']['output']>
  readonly dataAtendimento?: Maybe<Scalars['Instant']['output']>
  readonly dataInativacao?: Maybe<Scalars['Instant']['output']>
  readonly dataUltimaRetificacao?: Maybe<Scalars['Instant']['output']>
  readonly equipe?: Maybe<Equipe>
  readonly estagiario?: Maybe<Profissional>
  readonly examesRealizadosZika?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly fichasConcatenadas?: Maybe<FichasConcatenadasHistorico>
  readonly fimAtendimentoObservacao?: Maybe<Scalars['Instant']['output']>
  readonly hasAlergia?: Maybe<Scalars['Boolean']['output']>
  readonly hasAnexoArquivo: Scalars['Boolean']['output']
  readonly hasAtestado?: Maybe<Scalars['Boolean']['output']>
  readonly hasCuidadoCompartilhado: Scalars['Boolean']['output']
  readonly hasEncaminhamento?: Maybe<Scalars['Boolean']['output']>
  readonly hasEncaminhamentoEspecializado?: Maybe<Scalars['Boolean']['output']>
  readonly hasGuiasEncaminhamentos: Scalars['Boolean']['output']
  readonly hasIvcf?: Maybe<Scalars['Boolean']['output']>
  readonly hasLembrete?: Maybe<Scalars['Boolean']['output']>
  readonly hasMarcadorConsumoAlimentar: Scalars['Boolean']['output']
  readonly hasMchat?: Maybe<Scalars['Boolean']['output']>
  readonly hasObservacao?: Maybe<Scalars['Boolean']['output']>
  readonly hasOrientacao?: Maybe<Scalars['Boolean']['output']>
  readonly hasPrescricaoMedicamento?: Maybe<Scalars['Boolean']['output']>
  readonly hasProcedimentoClinico?: Maybe<Scalars['Boolean']['output']>
  readonly hasResultadoExame?: Maybe<Scalars['Boolean']['output']>
  readonly hasSolicitacaoExame?: Maybe<Scalars['Boolean']['output']>
  readonly idAtendProcessado?: Maybe<Scalars['ID']['output']>
  readonly idAtendRecente?: Maybe<Scalars['ID']['output']>
  readonly idAtividadeColetiva?: Maybe<Scalars['ID']['output']>
  readonly idCidadao?: Maybe<Scalars['ID']['output']>
  readonly idCuidadoCompartilhado?: Maybe<Scalars['ID']['output']>
  readonly idCuidadoCompartilhadoEvolucao?: Maybe<Scalars['ID']['output']>
  readonly idadeGestacional?: Maybe<IdadeGestacional>
  readonly ineExecutante?: Maybe<Scalars['String']['output']>
  readonly ineFinalizadorObservacao?: Maybe<Scalars['String']['output']>
  readonly ineSolicitante?: Maybe<Scalars['String']['output']>
  readonly inicioAtendimentoObservacao?: Maybe<Scalars['Instant']['output']>
  readonly isAtendObsFinalizado?: Maybe<Scalars['Boolean']['output']>
  readonly isAtendRecente: Scalars['Boolean']['output']
  readonly isCancelado?: Maybe<Scalars['Boolean']['output']>
  readonly isInativo: Scalars['Boolean']['output']
  readonly isRetificado: Scalars['Boolean']['output']
  readonly isVersaoFichaRetificavel: Scalars['Boolean']['output']
  readonly nomeExecutante?: Maybe<Scalars['String']['output']>
  readonly nomeFinalizadorObservacao?: Maybe<Scalars['String']['output']>
  readonly nomeSolicitante?: Maybe<Scalars['String']['output']>
  readonly nomeUbsExecutante?: Maybe<Scalars['String']['output']>
  readonly nomeUbsSolicitante?: Maybe<Scalars['String']['output']>
  readonly origemAtendimento?: Maybe<OrigemDadoEnum>
  readonly profissional?: Maybe<Profissional>
  readonly reclassificacaoPrioridade?: Maybe<Scalars['String']['output']>
  readonly siglaEquipeExecutante?: Maybe<Scalars['String']['output']>
  readonly siglaEquipeSolicitante?: Maybe<Scalars['String']['output']>
  readonly tipoApresentacao?: Maybe<TipoRegistroHistoricoClinico>
  readonly tipoAtendProf?: Maybe<TipoAtendimentoProfissional>
  readonly tipoConsultaOdonto?: Maybe<TipoConsultaOdontoEnum>
  readonly turno?: Maybe<TurnoEnum>
  readonly ubsFinalizadorObservacao?: Maybe<Scalars['String']['output']>
  readonly unidadeSaude?: Maybe<UnidadeSaude>
}

export type HistoricoAcesso = {
  readonly __typename?: 'HistoricoAcesso'
  readonly cliente: Scalars['String']['output']
  readonly data: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly ip: Scalars['String']['output']
  readonly local: Scalars['String']['output']
  readonly sucesso: Scalars['Boolean']['output']
}

export type HistoricoAcessoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
}

export type HistoricoAcessoQueryPayload = {
  readonly __typename?: 'HistoricoAcessoQueryPayload'
  readonly content: ReadonlyArray<HistoricoAcesso>
  readonly pageInfo: PageInfo
}

export type HistoricoConsumoAlimentarDetail = {
  readonly __typename?: 'HistoricoConsumoAlimentarDetail'
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoLocalAtendimento?: Maybe<DimensaoLocalAtendimento>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly id: Scalars['ID']['output']
  readonly perguntasRespostas: ReadonlyArray<Maybe<PerguntasRespostasHistoricoConsumoAlimentar>>
  readonly perguntasRespostasOntem: ReadonlyArray<Maybe<PerguntasRespostasHistoricoConsumoAlimentar>>
  readonly questionario: Scalars['String']['output']
  readonly subtitle: Scalars['String']['output']
}

export type HistoricoDetailQueryInput = {
  readonly cpfOuCnsCidadao?: InputMaybe<Scalars['String']['input']>
  readonly idAtend?: InputMaybe<Scalars['ID']['input']>
  readonly isOrigemPec: Scalars['Boolean']['input']
  readonly uuidRegistro?: InputMaybe<Scalars['String']['input']>
}

export type HistoricoExportacaoFiltro = {
  readonly pageParams: PageParams
}

export type HistoricoFiltrosAvancadosQueryInput = {
  readonly cod2002Cbos?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly codCiaps2?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly codCids10?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly cpfProfissionais?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly exibirRegistrosInativos: Scalars['Boolean']['input']
  readonly ineEquipes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  readonly periodo?: InputMaybe<Period>
}

export type HistoricoPayload = {
  readonly __typename?: 'HistoricoPayload'
  readonly content: ReadonlyArray<Maybe<Historico>>
  readonly pageInfo: PageInfo
}

export enum HistoricoPeriodoExibicao {
  PERSONALIZADO = 'PERSONALIZADO',
  TODOS_ATENDIMENTOS = 'TODOS_ATENDIMENTOS',
  ULTIMOS_NOVENTA_DIAS = 'ULTIMOS_NOVENTA_DIAS',
  ULTIMOS_SESSENTA_DIAS = 'ULTIMOS_SESSENTA_DIAS',
  ULTIMOS_TRINTA_DIAS = 'ULTIMOS_TRINTA_DIAS',
  ULTIMO_ANO = 'ULTIMO_ANO',
}

export type HistoricoPrescricaoQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly usoContinuo?: InputMaybe<Scalars['Boolean']['input']>
}

export type HistoricoPrescricaoQueryPayload = {
  readonly __typename?: 'HistoricoPrescricaoQueryPayload'
  readonly content: ReadonlyArray<Maybe<AtendimentoProfissional>>
  readonly pageInfo: PageInfo
}

export type HistoricoQueryInput = {
  readonly cidadaoCpf?: InputMaybe<Scalars['String']['input']>
  readonly cidadaoId: Scalars['ID']['input']
  readonly equipeIne?: InputMaybe<Scalars['String']['input']>
  readonly excludeEscutaOrPreAtendimentoFromAtendProf?: InputMaybe<Scalars['ID']['input']>
  readonly filtrosAvancados: HistoricoFiltrosAvancadosQueryInput
  readonly pageParams?: InputMaybe<PageParams>
  readonly profissionalCpf?: InputMaybe<Scalars['String']['input']>
  readonly somenteMeusRegistros: Scalars['Boolean']['input']
  readonly sortDirection: Sort
  readonly tiposRegistro?: InputMaybe<ReadonlyArray<InputMaybe<TipoRegistroHistoricoClinico>>>
  readonly unidadeSaudeCnes?: InputMaybe<Scalars['String']['input']>
}

export type HistoricoZikaDetail = {
  readonly __typename?: 'HistoricoZikaDetail'
  readonly dimensaoCbo?: Maybe<DimensaoCbo>
  readonly dimensaoEquipe?: Maybe<DimensaoEquipe>
  readonly dimensaoProfissional?: Maybe<DimensaoProfissional>
  readonly dimensaoUnidadeSaude?: Maybe<DimensaoUnidadeSaude>
  readonly examesDeImagem: ReadonlyArray<Maybe<ExameZika>>
  readonly outrosExames: ReadonlyArray<Maybe<ExameZika>>
}

export type HorarioAgenda = {
  readonly __typename?: 'HorarioAgenda'
  readonly duracao: Scalars['Int']['output']
  readonly horario: Scalars['Instant']['output']
  readonly isOcupado: Scalars['Boolean']['output']
  readonly isReservadoAgendaOnline: Scalars['Boolean']['output']
}

export type HorariosAgendaQueryInput = {
  readonly agendamentosIdsDesconsiderar?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly dia: Scalars['LocalDate']['input']
  readonly isAtencaoDomiciliar?: Scalars['Boolean']['input']
  readonly lotacaoId: Scalars['ID']['input']
  readonly outraLotacaoIdVerificarDisponibilidade?: InputMaybe<Scalars['ID']['input']>
}

export type HorusFormDto = {
  readonly __typename?: 'HorusFormDto'
  readonly unidadePadrao: Scalars['Boolean']['output']
  readonly unidadeSaude: UnidadeSaude
}

export type IceServersConfig = {
  readonly __typename?: 'IceServersConfig'
  readonly password?: Maybe<Scalars['String']['output']>
  readonly urls: ReadonlyArray<Scalars['String']['output']>
  readonly user?: Maybe<Scalars['String']['output']>
}

export type IceServersConfigurationInput = {
  readonly userCpf: Scalars['String']['input']
}

export type IdadeGestacional = {
  readonly __typename?: 'IdadeGestacional'
  readonly dias: Scalars['Int']['output']
  readonly semanas: Scalars['Int']['output']
}

export enum IdentidadeGeneroEnum {
  HOMEM_CIS = 'HOMEM_CIS',
  HOMEM_TRANS = 'HOMEM_TRANS',
  MULHER_CIS = 'MULHER_CIS',
  MULHER_TRANS = 'MULHER_TRANS',
  NAO_BINARIO = 'NAO_BINARIO',
  OUTRO_IDENTIDADE_GENERO = 'OUTRO_IDENTIDADE_GENERO',
  TRANSGENERO = 'TRANSGENERO',
  TRAVESTI = 'TRAVESTI',
}

export type Iframe = {
  readonly __typename?: 'Iframe'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly providerId: Scalars['ID']['output']
}

export type IframesQueryInput = {
  readonly cidadaoId?: InputMaybe<Scalars['ID']['input']>
  readonly tipoAtendimentoProfissional?: InputMaybe<TipoAtendimentoProfissional>
  readonly tipoSistemaExterno?: InputMaybe<TipoSistemaExternoEnum>
}

export type ImoveisQueryInput = {
  readonly bairro?: InputMaybe<Scalars['String']['input']>
  readonly cep?: InputMaybe<Scalars['String']['input']>
  readonly cnes?: InputMaybe<Scalars['String']['input']>
  readonly complemento?: InputMaybe<Scalars['String']['input']>
  readonly foraDeArea?: InputMaybe<Scalars['Boolean']['input']>
  readonly ine?: InputMaybe<Scalars['String']['input']>
  readonly logradouro?: InputMaybe<Scalars['String']['input']>
  readonly microarea?: InputMaybe<Scalars['String']['input']>
  readonly municipioId?: InputMaybe<Scalars['ID']['input']>
  readonly numero?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly semNumero?: InputMaybe<Scalars['Boolean']['input']>
  readonly stAtivo?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoEndereco?: InputMaybe<TipoEnderecoEnum>
  readonly tipoLogradouroId?: InputMaybe<Scalars['ID']['input']>
  readonly ufId?: InputMaybe<Scalars['ID']['input']>
}

export type ImoveisQueryPayload = {
  readonly __typename?: 'ImoveisQueryPayload'
  readonly content: ReadonlyArray<Maybe<ImovelDto>>
  readonly pageInfo: PageInfo
}

export type ImovelDto = {
  readonly __typename?: 'ImovelDto'
  readonly aldeia?: Maybe<Aldeia>
  readonly animaisImovel?: Maybe<AnimaisImovel>
  readonly bairro?: Maybe<Scalars['String']['output']>
  readonly cbo?: Maybe<Cbo>
  readonly cep?: Maybe<Scalars['String']['output']>
  readonly complemento?: Maybe<Scalars['String']['output']>
  readonly condicoesMoradia: CondicoesMoradia
  readonly dataUltimaAtualizacao?: Maybe<Scalars['Instant']['output']>
  readonly dataUltimaVisita?: Maybe<Scalars['LocalDate']['output']>
  readonly descricaoMaterialParede?: Maybe<Scalars['String']['output']>
  readonly descricaoTipoDomicilio?: Maybe<Scalars['String']['output']>
  readonly dsei?: Maybe<Dsei>
  readonly equipe?: Maybe<Equipe>
  readonly familias: ReadonlyArray<Familia>
  readonly id: Scalars['ID']['output']
  readonly isCadastroCompleto?: Maybe<Scalars['Boolean']['output']>
  readonly latitude?: Maybe<Scalars['Float']['output']>
  readonly logradouro?: Maybe<Scalars['String']['output']>
  readonly longitude?: Maybe<Scalars['Float']['output']>
  readonly microarea?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly municipioAldeia?: Maybe<Municipio>
  readonly nomeInstituicaoPermanencia?: Maybe<Scalars['String']['output']>
  readonly numero?: Maybe<Scalars['String']['output']>
  readonly numeroMoradores?: Maybe<Scalars['Int']['output']>
  readonly numeroResidenciaIndigena?: Maybe<Scalars['String']['output']>
  readonly permissaoReterritorializar?: Maybe<Action>
  readonly poloBase?: Maybe<PoloBase>
  readonly pontoReferencia?: Maybe<Scalars['String']['output']>
  readonly possuiInconsistencia?: Maybe<Scalars['Boolean']['output']>
  readonly possuiOutrosProfsVinculados?: Maybe<Scalars['Boolean']['output']>
  readonly profissional?: Maybe<Profissional>
  readonly responsavelTecnico?: Maybe<ResponsavelTecnicoImovel>
  readonly semNumero?: Maybe<Scalars['Boolean']['output']>
  readonly stAtivo: Scalars['Boolean']['output']
  readonly statusForaArea?: Maybe<Scalars['Boolean']['output']>
  readonly statusMicroareaPoloBase?: Maybe<Scalars['Boolean']['output']>
  readonly statusRecusa?: Maybe<Scalars['Boolean']['output']>
  readonly telefoneContato?: Maybe<Scalars['String']['output']>
  readonly telefoneResidencial?: Maybe<Scalars['String']['output']>
  readonly tipoEndereco?: Maybe<TipoEnderecoEnum>
  readonly tipoImovel?: Maybe<TipoImovelEnum>
  readonly tipoLogradouro?: Maybe<TipoLogradouro>
  readonly uf?: Maybe<Uf>
  readonly ufAldeia?: Maybe<Uf>
  readonly ultimaFichaCadastrada?: Maybe<UltimaFichaCadastradaDto>
  readonly ultimaVisitaComAnotacao?: Maybe<FatoVisitaDomiciliar>
  readonly unidadeSaude: UnidadeSaude
  readonly uuidDomicilio: Scalars['ID']['output']
  readonly uuidUltimaFicha: Scalars['ID']['output']
}

export type ImovelDtoFamiliasArgs = {
  input?: InputMaybe<FamiliasImovelInput>
}

export type ImovelInput = {
  readonly animaisImovelInput?: InputMaybe<AnimaisImovelInput>
  readonly cbo2002: Scalars['String']['input']
  readonly cnes: Scalars['String']['input']
  readonly cns: Scalars['String']['input']
  readonly condicoesMoradiaInput?: InputMaybe<CondicoesMoradiaInput>
  readonly dataColeta: Scalars['LocalDate']['input']
  readonly endereco?: InputMaybe<EnderecoTerritorioInput>
  readonly enderecoIndigena?: InputMaybe<EnderecoIndigenaTerritorioInput>
  readonly familias?: InputMaybe<ReadonlyArray<InputMaybe<FamiliaInput>>>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly ine?: InputMaybe<Scalars['String']['input']>
  readonly instituicaoPermanenciaInput?: InputMaybe<InstituicaoPermanenciaInput>
  readonly microarea?: InputMaybe<Scalars['String']['input']>
  readonly microareaPoloBase?: InputMaybe<Scalars['Boolean']['input']>
  readonly numeroMoradores?: InputMaybe<Scalars['Int']['input']>
  readonly stAtivo: Scalars['Boolean']['input']
  readonly statusForaArea?: InputMaybe<Scalars['Boolean']['input']>
  readonly statusRecusa: Scalars['Boolean']['input']
  readonly telefoneContato?: InputMaybe<Scalars['String']['input']>
  readonly telefoneResidencial?: InputMaybe<Scalars['String']['input']>
  readonly tipoEndereco: TipoEnderecoEnum
  readonly tipoImovel: TipoImovelEnum
}

export type ImportacaoArquivo = {
  readonly __typename?: 'ImportacaoArquivo'
  readonly dataEvento?: Maybe<Scalars['Instant']['output']>
  readonly message?: Maybe<Scalars['String']['output']>
  readonly status: StatusImportacaoArquivo
}

export type ImportacaoBolsaFamilia = {
  readonly __typename?: 'ImportacaoBolsaFamilia'
  readonly complementar: Scalars['Boolean']['output']
  readonly dataImportacaoInicio: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly municipio: Municipio
  readonly profissionalResponsavel: Profissional
  readonly statusImportacao: StatusImportacaoBolsaFamiliaEnum
  readonly vigencia: Scalars['String']['output']
}

export type ImportacaoBolsaFamiliaPayload = {
  readonly __typename?: 'ImportacaoBolsaFamiliaPayload'
  readonly content: ReadonlyArray<ImportacaoBolsaFamilia>
  readonly pageInfo: PageInfo
}

export type ImportacaoBolsaFamiliaQueryInput = {
  readonly pageParams: PageParams
}

export type ImportacaoCnes = {
  readonly __typename?: 'ImportacaoCnes'
  readonly dataImportacao: Scalars['Instant']['output']
  readonly detalhes?: Maybe<Scalars['String']['output']>
  readonly equipesAtualizadas?: Maybe<Scalars['Int']['output']>
  readonly equipesNovas?: Maybe<Scalars['Int']['output']>
  readonly id: Scalars['ID']['output']
  readonly lotacoesAtualizadas?: Maybe<Scalars['Int']['output']>
  readonly lotacoesNovas?: Maybe<Scalars['Int']['output']>
  readonly municipio: Municipio
  readonly processo: Processo
  readonly profissionaisAtualizados?: Maybe<Scalars['Int']['output']>
  readonly profissionaisNovos?: Maybe<Scalars['Int']['output']>
  readonly profissional: Profissional
  readonly unidadesSaudeAtualizadas?: Maybe<Scalars['Int']['output']>
  readonly unidadesSaudeNovas?: Maybe<Scalars['Int']['output']>
  readonly vinculacoesEquipesAtualizadas?: Maybe<Scalars['Int']['output']>
  readonly vinculacoesEquipesNovas?: Maybe<Scalars['Int']['output']>
}

export type ImportacoesCnesQueryInput = {
  readonly municipioId?: InputMaybe<Scalars['Int']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type ImportacoesCnesQueryPayload = {
  readonly __typename?: 'ImportacoesCnesQueryPayload'
  readonly content: ReadonlyArray<Maybe<ImportacaoCnes>>
  readonly pageInfo: PageInfo
}

export type Imunobiologico = {
  readonly __typename?: 'Imunobiologico'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeFiltro: Scalars['String']['output']
  readonly sigla: Scalars['String']['output']
  readonly stAtivo: Scalars['Boolean']['output']
}

export type ImunobiologicoFabricante = {
  readonly __typename?: 'ImunobiologicoFabricante'
  readonly ativo: Scalars['Boolean']['output']
  readonly codigoRnds?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  /** @deprecated Foi removido o vínculo imunobiológico-fabricante, o atributo foi mantido devido a retrocompatibilidade entre o Pec e o e-SUS Vacinação */
  readonly idsImunobiologicos?: Maybe<ReadonlyArray<Maybe<Scalars['ID']['output']>>>
  readonly nome: Scalars['String']['output']
  readonly nomeFiltro: Scalars['String']['output']
}

export type ImunobiologicoFabricanteQueryInput = {
  readonly pageParams?: InputMaybe<OptionalPageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly showOnlyAtivos?: InputMaybe<Scalars['Boolean']['input']>
}

export type ImunobiologicoFabricanteQueryPayload = {
  readonly __typename?: 'ImunobiologicoFabricanteQueryPayload'
  readonly content: ReadonlyArray<Maybe<ImunobiologicoFabricante>>
  readonly pageInfo: PageInfo
}

export type ImunobiologicoQueryInput = {
  readonly grupoAlvoId?: InputMaybe<Scalars['ID']['input']>
  readonly isOnlyCovid?: InputMaybe<Scalars['Boolean']['input']>
  readonly onlyCalendarioVacinal?: InputMaybe<Scalars['Boolean']['input']>
  readonly outrosImunobiologicos?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly semRegras?: InputMaybe<Scalars['Boolean']['input']>
  readonly sexo?: InputMaybe<SexoEnum>
}

export type ImunobiologicoQueryPayload = {
  readonly __typename?: 'ImunobiologicoQueryPayload'
  readonly content: ReadonlyArray<Maybe<Imunobiologico>>
  readonly pageInfo: PageInfo
}

export type InativarAtendimentoInput = {
  readonly atendimentoProfissionalId: Scalars['ID']['input']
  readonly historicoCabecalhoId?: InputMaybe<Scalars['ID']['input']>
  readonly justificativa?: InputMaybe<Scalars['String']['input']>
}

export type IndicesAcompanhamentoMicroarea = {
  readonly __typename?: 'IndicesAcompanhamentoMicroarea'
  readonly quantidadeDomiciliosAvaliados: Scalars['Long']['output']
  readonly quantidadeDomiciliosVisitados: Scalars['Long']['output']
  readonly quantidadeImoveisAtualizados: Scalars['Long']['output']
  readonly quantidadeImoveisCadastroCompleto: Scalars['Long']['output']
  readonly totalImoveisAtualizados: Scalars['Long']['output']
  readonly totalImoveisNaoRecusados: Scalars['Long']['output']
}

export type Inep = {
  readonly __typename?: 'Inep'
  readonly dsInep: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nomeEstabelecimento: Scalars['String']['output']
}

export type InepPayload = {
  readonly __typename?: 'InepPayload'
  readonly content: ReadonlyArray<Maybe<Inep>>
  readonly pageInfo: PageInfo
}

export type InepQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type Info = {
  readonly __typename?: 'Info'
  readonly anexoArquivosEnabled: Scalars['Boolean']['output']
  readonly ativado: Scalars['Boolean']['output']
  readonly buscaCidadaoPorPropriedadesEnabled: Scalars['Boolean']['output']
  readonly cadastroDomiciliarViaCdsEnabled: Scalars['Boolean']['output']
  readonly cadastroIndividualViaCdsEnabled: Scalars['Boolean']['output']
  readonly commit: Scalars['String']['output']
  readonly competenciaSigtap: Scalars['String']['output']
  readonly dataAtivacaoAssinaturaEletronica?: Maybe<Scalars['LocalDate']['output']>
  readonly databaseSchemaVersion: Scalars['String']['output']
  readonly databaseVendor: Scalars['String']['output']
  readonly firebaseEnabled: Scalars['Boolean']['output']
  readonly flags: ReadonlyArray<FlagInfo>
  readonly frontendLogLevel: FrontendLogLevelEnum
  readonly govBREnabled: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly internetHabilitada: Scalars['Boolean']['output']
  readonly isPrescricaoDigitalEnabled: Scalars['Boolean']['output']
  readonly linkInstalacao?: Maybe<Scalars['String']['output']>
  readonly oldPecConnected: Scalars['Boolean']['output']
  readonly recursosDisponiveis: Scalars['String']['output']
  readonly rocksdbEnabled: Scalars['Boolean']['output']
  readonly sentry: SentryConfig
  readonly smtpConfigurado: Scalars['Boolean']['output']
  readonly tipoInstalacao?: Maybe<TipoInstalacao>
  readonly treinamento: Scalars['Boolean']['output']
  readonly uuid: Scalars['String']['output']
  readonly versao: Scalars['String']['output']
  readonly versaoTransporte: Scalars['String']['output']
}

export type InfoCadastroEnvioInput = {
  readonly linkInstalacao?: InputMaybe<Scalars['String']['input']>
  readonly nomeInstalacao?: InputMaybe<Scalars['String']['input']>
  readonly senhaInstalacao?: InputMaybe<Scalars['String']['input']>
}

export type InformacoesObstetricasInput = {
  readonly abortos?: InputMaybe<Scalars['Int']['input']>
  readonly desfechoUltimaGestacao?: InputMaybe<DesfechoUltimaGestacaoEnum>
  readonly filhosVivos?: InputMaybe<Scalars['Int']['input']>
  readonly gestaPrevias?: InputMaybe<Scalars['Int']['input']>
  readonly nascidosVivos?: InputMaybe<Scalars['Int']['input']>
  readonly natimortos?: InputMaybe<Scalars['Int']['input']>
  readonly obitoAntesPrimeiraSemana?: InputMaybe<Scalars['Int']['input']>
  readonly obitoAposPrimeiraSemana?: InputMaybe<Scalars['Int']['input']>
  readonly partos?: InputMaybe<Scalars['Int']['input']>
  readonly partosCesareas?: InputMaybe<Scalars['Int']['input']>
  readonly partosDomiciliares?: InputMaybe<Scalars['Int']['input']>
  readonly partosVaginais?: InputMaybe<Scalars['Int']['input']>
  readonly recemNascidoAbaixo?: InputMaybe<Scalars['Int']['input']>
  readonly recemNascidoAcima?: InputMaybe<Scalars['Int']['input']>
}

export type InformacoesPuerperioDto = {
  readonly __typename?: 'InformacoesPuerperioDto'
  readonly dataInicioGestacao?: Maybe<Scalars['LocalDate']['output']>
  readonly preNatal?: Maybe<PreNatal>
}

export type InformacoesSocioEconomicas = {
  readonly __typename?: 'InformacoesSocioEconomicas'
  readonly id: Scalars['ID']['output']
  readonly statusAlimentosAcabaramAntesTerDinheiroComprarMais?: Maybe<Scalars['Boolean']['output']>
  readonly statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou?: Maybe<Scalars['Boolean']['output']>
}

export type InformacoesSocioEconomicasDw = {
  readonly __typename?: 'InformacoesSocioEconomicasDW'
  readonly alimentosAcabaramSemDinheiro?: Maybe<Scalars['Boolean']['output']>
  readonly comeuPoucoPorFaltaDeDinheiro?: Maybe<Scalars['Boolean']['output']>
  readonly dataRegistro: Scalars['LocalDate']['output']
}

export type InformacoesSocioEconomicasInput = {
  readonly statusAlimentosAcabaramAntesTerDinheiroComprarMais: Scalars['Boolean']['input']
  readonly statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou: Scalars['Boolean']['input']
}

export type InformacoesSociodemograficas = {
  readonly __typename?: 'InformacoesSociodemograficas'
  readonly criancas0a9anosComQuemFica?: Maybe<ReadonlyArray<Criancas0a9AnosComQuemFicaEnum>>
  readonly deficiencias?: Maybe<ReadonlyArray<DeficienciaEnum>>
  readonly frequentaCuidadorTradicional?: Maybe<Scalars['Boolean']['output']>
  readonly frequentaEscolaOuCreche?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly isAtendimentoSocioeducativo?: Maybe<Scalars['Boolean']['output']>
  readonly isMembroComunidadeTradicional?: Maybe<Scalars['Boolean']['output']>
  readonly participaAlgumGrupoComunitario?: Maybe<Scalars['Boolean']['output']>
  readonly possuiDeficiencia?: Maybe<Scalars['Boolean']['output']>
  readonly possuiPlanoSaudePrivado?: Maybe<Scalars['Boolean']['output']>
  readonly povoComunidadeTradicional?: Maybe<PovoComunidadeTradicionalEnum>
  readonly situacaoMercadoTrabalho?: Maybe<SituacaoMercadoTrabalhoEnum>
  readonly tempoAtendimentoSocioeducativo?: Maybe<TempoAtendimentoSocioeducativoCidadaoEnum>
  readonly tipoAtendimentoSocioeducativo?: Maybe<TipoAtendimentoCidadaoEnum>
}

export type InformacoesSociodemograficasInput = {
  readonly criancas0a9anosComQuemFica?: InputMaybe<ReadonlyArray<Criancas0a9AnosComQuemFicaEnum>>
  readonly deficiencias?: InputMaybe<ReadonlyArray<DeficienciaEnum>>
  readonly desejaInformarIdentidadeGenero?: InputMaybe<Scalars['Boolean']['input']>
  readonly desejaInformarOrientacaoSexual?: InputMaybe<Scalars['Boolean']['input']>
  readonly escolaridade?: InputMaybe<EscolaridadeEnum>
  readonly frequentaCuidadorTradicional?: InputMaybe<Scalars['Boolean']['input']>
  readonly frequentaEscolaOuCreche?: InputMaybe<Scalars['Boolean']['input']>
  readonly identidadeGenero?: InputMaybe<IdentidadeGeneroEnum>
  readonly isAtendimentoSocioeducativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly isMembroComunidadeTradicional?: InputMaybe<Scalars['Boolean']['input']>
  readonly ocupacaoCbo2002?: InputMaybe<Scalars['String']['input']>
  readonly orientacaoSexual?: InputMaybe<OrientacaoSexualEnum>
  readonly participaAlgumGrupoComunitario?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiDeficiencia?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiPlanoSaudePrivado?: InputMaybe<Scalars['Boolean']['input']>
  readonly povoComunidadeTradicional?: InputMaybe<PovoComunidadeTradicionalEnum>
  readonly situacaoMercadoTrabalho?: InputMaybe<SituacaoMercadoTrabalhoEnum>
  readonly tempoAtendimentoSocioeducativo?: InputMaybe<TempoAtendimentoSocioeducativoCidadaoEnum>
  readonly tipoAtendimentoSocioeducativo?: InputMaybe<TipoAtendimentoCidadaoEnum>
}

export type IniciarVideochamadaInput = {
  readonly termoCidadaoAceito?: InputMaybe<Scalars['Boolean']['input']>
  readonly termoProfissionalAceito?: InputMaybe<Scalars['Boolean']['input']>
  readonly videochamadaUuid?: InputMaybe<Scalars['String']['input']>
}

export type InscricoesTopicosNotificacaoQueryInput = {
  readonly acessoId: Scalars['ID']['input']
  readonly tiposTopicos: ReadonlyArray<TipoTopicoNotificacaoEnum>
}

export type InstalacaoInput = {
  readonly dadosInstalacao?: InputMaybe<ConfiguracaoDadosServidorInput>
  readonly novaSenha?: InputMaybe<Scalars['String']['input']>
  readonly profissional?: InputMaybe<ProfissionalInput>
  readonly tipoInstalacao?: InputMaybe<TipoInstalacao>
}

export type InstituicaoPermanenciaInput = {
  readonly nomeInstituicaoPermanencia?: InputMaybe<Scalars['String']['input']>
  readonly possuiOutrosProfissionaisVinculados?: InputMaybe<Scalars['Boolean']['input']>
  readonly responsavelTecnico: ResponsavelTecnicoInput
}

export type InterconsultaAgendamentoCuidadoCompartilhadoInput = {
  readonly cidadaoPresente?: InputMaybe<Scalars['Boolean']['input']>
  readonly horarioFinal: Scalars['Instant']['input']
  readonly horarioInicial: Scalars['Instant']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
  readonly videochamadaUuid?: InputMaybe<Scalars['String']['input']>
}

export type IsLotacaoActiveInput = {
  readonly cbo2002: Scalars['String']['input']
  readonly cnes: Scalars['String']['input']
  readonly cns: Scalars['String']['input']
  readonly ine?: InputMaybe<Scalars['String']['input']>
  readonly userLocalidadeId: Scalars['Long']['input']
}

export type ItemGrupoMedicoesTipo = {
  readonly __typename?: 'ItemGrupoMedicoesTipo'
  readonly dataMedicao: Scalars['Instant']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly valor: Scalars['String']['output']
}

export type Ivcf = {
  readonly __typename?: 'Ivcf'
  readonly aplicacao: ReadonlyArray<Maybe<IvcfAplicacao>>
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly dataResultado: Scalars['Instant']['output']
  readonly dimensoesAlteradas: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly prontuario: Prontuario
  readonly resultado: Scalars['Long']['output']
  readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
}

export type IvcfAplicacao = {
  readonly __typename?: 'IvcfAplicacao'
  readonly id: Scalars['ID']['output']
  readonly pergunta: IvcfPerguntaEnum
  readonly resposta: Scalars['Boolean']['output']
}

export type IvcfInput = {
  readonly aplicacao: ReadonlyArray<IvcfPerguntaRespostaInput>
}

export enum IvcfPerguntaEnum {
  ALCANCE_PREENSAO_PINCA_PERGUNTA_1 = 'ALCANCE_PREENSAO_PINCA_PERGUNTA_1',
  ALCANCE_PREENSAO_PINCA_PERGUNTA_2 = 'ALCANCE_PREENSAO_PINCA_PERGUNTA_2',
  AUDICAO_PERGUNTA_1 = 'AUDICAO_PERGUNTA_1',
  AVD_BASICA_PERGUNTA_1 = 'AVD_BASICA_PERGUNTA_1',
  AVD_INSTRUMENTAL_PERGUNTA_1 = 'AVD_INSTRUMENTAL_PERGUNTA_1',
  AVD_INSTRUMENTAL_PERGUNTA_2 = 'AVD_INSTRUMENTAL_PERGUNTA_2',
  AVD_INSTRUMENTAL_PERGUNTA_3 = 'AVD_INSTRUMENTAL_PERGUNTA_3',
  CAPACIDADE_PERGUNTA_1 = 'CAPACIDADE_PERGUNTA_1',
  CAPACIDADE_PERGUNTA_3 = 'CAPACIDADE_PERGUNTA_3',
  CAPACIDADE_PERGUNTA_4 = 'CAPACIDADE_PERGUNTA_4',
  CAPACIDADE_PERGUNTA_5 = 'CAPACIDADE_PERGUNTA_5',
  COGNICAO_PERGUNTA_1 = 'COGNICAO_PERGUNTA_1',
  COGNICAO_PERGUNTA_2 = 'COGNICAO_PERGUNTA_2',
  COGNICAO_PERGUNTA_3 = 'COGNICAO_PERGUNTA_3',
  COMORBIDADE_PERGUNTA_1 = 'COMORBIDADE_PERGUNTA_1',
  COMORBIDADE_PERGUNTA_2 = 'COMORBIDADE_PERGUNTA_2',
  COMORBIDADE_PERGUNTA_3 = 'COMORBIDADE_PERGUNTA_3',
  CONTINENCIA_PERGUNTA_1 = 'CONTINENCIA_PERGUNTA_1',
  HUMOR_PERGUNTA_1 = 'HUMOR_PERGUNTA_1',
  HUMOR_PERGUNTA_2 = 'HUMOR_PERGUNTA_2',
  MARCHA_PERGUNTA_1 = 'MARCHA_PERGUNTA_1',
  MARCHA_PERGUNTA_2 = 'MARCHA_PERGUNTA_2',
  PERCEPCAO_SAUDE_PERGUNTA_1 = 'PERCEPCAO_SAUDE_PERGUNTA_1',
  VISAO_PERGUNTA_1 = 'VISAO_PERGUNTA_1',
}

export type IvcfPerguntaRespostaInput = {
  readonly pergunta: IvcfPerguntaEnum
  readonly resposta?: InputMaybe<Scalars['Boolean']['input']>
}

export enum IvcfSubgrupoPerguntaEnum {
  ALCANCE_PREENSAO_PINCA = 'ALCANCE_PREENSAO_PINCA',
  AUDICAO = 'AUDICAO',
  AVD_BASICA = 'AVD_BASICA',
  AVD_INSTRUMENTAL = 'AVD_INSTRUMENTAL',
  CAPACIDADE_AEROBICA_MUSCULAR = 'CAPACIDADE_AEROBICA_MUSCULAR',
  COGNICAO = 'COGNICAO',
  COMORBIDADE_MULTIPLA = 'COMORBIDADE_MULTIPLA',
  CONTINENCIA_ESFINCTERIANA = 'CONTINENCIA_ESFINCTERIANA',
  HUMOR = 'HUMOR',
  IDADE = 'IDADE',
  MARCHA = 'MARCHA',
  PERCEPCAO_SAUDE = 'PERCEPCAO_SAUDE',
  VISAO = 'VISAO',
}

export type JustificativaCancelamentoAgendado = {
  readonly __typename?: 'JustificativaCancelamentoAgendado'
  readonly data: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly justificativa?: Maybe<Scalars['String']['output']>
  readonly responsavel?: Maybe<LotacaoOuEstagio>
}

export enum JustificativaCancelarAgendamentoEnum {
  CIDADAO_CANCELOU = 'CIDADAO_CANCELOU',
  JUSTIFICATIVA_AUTOMATICA_PROFISSIONAL = 'JUSTIFICATIVA_AUTOMATICA_PROFISSIONAL',
  LICENCA_MEDICA = 'LICENCA_MEDICA',
  OUTRA = 'OUTRA',
  REUNIAO_NAO_PROGRAMADA = 'REUNIAO_NAO_PROGRAMADA',
}

export enum JustificativaNaoPossuiCpfEnum {
  CRIANCAS_SEM_DOCUMENTACAO_EMITIDA = 'CRIANCAS_SEM_DOCUMENTACAO_EMITIDA',
  DOCUMENTO_PERDIDO = 'DOCUMENTO_PERDIDO',
  ESTRANGEIRO = 'ESTRANGEIRO',
  ESTRANGEIRO_RESIDENTE_SEM_CPF = 'ESTRANGEIRO_RESIDENTE_SEM_CPF',
  INCONSCIENTE_OU_SEM_LUCIDEZ = 'INCONSCIENTE_OU_SEM_LUCIDEZ',
  INTERNACAO_COMPULSORIA = 'INTERNACAO_COMPULSORIA',
  MEMBRO_COMUNIDADE_AFASTADA = 'MEMBRO_COMUNIDADE_AFASTADA',
  OUTRA = 'OUTRA',
  PESSOA_INDOCUMENTADA = 'PESSOA_INDOCUMENTADA',
  POPULACAO_MIGRANTE_REFUGIADA_EM_REGULARIZACAO = 'POPULACAO_MIGRANTE_REFUGIADA_EM_REGULARIZACAO',
  RECEM_NASCIDO_SEM_REGISTRO = 'RECEM_NASCIDO_SEM_REGISTRO',
  RECUSA_CULTURA_OU_RELIGIOSA = 'RECUSA_CULTURA_OU_RELIGIOSA',
  SITUACAO_DE_RUA = 'SITUACAO_DE_RUA',
  SITUACOES_CALAMIDADE_DESASTRE = 'SITUACOES_CALAMIDADE_DESASTRE',
}

export type JustificativaVisualizarProntuarioInput = {
  readonly justificativa: Scalars['String']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export type Lembrete = {
  readonly __typename?: 'Lembrete'
  readonly historicoLembrete: ReadonlyArray<Maybe<LembreteEvolucao>>
  readonly id: Scalars['ID']['output']
  readonly profissionalCriador: Profissional
  readonly ultimoLembrete: LembreteEvolucao
}

export type LembreteEvolucao = {
  readonly __typename?: 'LembreteEvolucao'
  readonly ativo: Scalars['Boolean']['output']
  readonly data: Scalars['Instant']['output']
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly lotacao: Lotacao
  readonly visibilidadeLembrete: VisibilidadeLembreteEnum
}

export type LembreteProfissional = {
  readonly __typename?: 'LembreteProfissional'
  readonly dataExibirNovamente?: Maybe<Scalars['Instant']['output']>
  readonly dataVisualizado?: Maybe<Scalars['Instant']['output']>
  readonly id: Scalars['ID']['output']
  readonly identificadorLembrete: LembreteProfissionalIdentificadorEnum
  readonly visualizado?: Maybe<Scalars['Boolean']['output']>
}

export enum LembreteProfissionalIdentificadorEnum {
  CARD_LEMBRETE_PROFISSIONAL_CIDADAO = 'CARD_LEMBRETE_PROFISSIONAL_CIDADAO',
  MODAL_ASSINADOR_RNDS_SEM_VINCULO = 'MODAL_ASSINADOR_RNDS_SEM_VINCULO',
  TOUR_LEMBRETE_PROFISSIONAL_CIDADAO = 'TOUR_LEMBRETE_PROFISSIONAL_CIDADAO',
}

export type LembreteProfissionalInput = {
  readonly atorPapelId?: InputMaybe<Scalars['ID']['input']>
  readonly identificador: LembreteProfissionalIdentificadorEnum
  readonly usuarioId?: InputMaybe<Scalars['ID']['input']>
}

export type LembreteSaveInput = {
  readonly ativo: Scalars['Boolean']['input']
  readonly descricao: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly visibilidadeLembrete: VisibilidadeLembreteEnum
}

export type LembretesQueryInput = {
  readonly prontuarioId: Scalars['ID']['input']
  readonly somenteMeus?: InputMaybe<Scalars['Boolean']['input']>
}

export type LicencaMaternidadePlanoInput = {
  readonly assinadoDigitalmente: Scalars['Boolean']['input']
  readonly cpfCns?: InputMaybe<Scalars['String']['input']>
  readonly descricao: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly naoPossui?: InputMaybe<Scalars['Boolean']['input']>
}

export type ListaEspera = {
  readonly __typename?: 'ListaEspera'
  readonly cidadao?: Maybe<Cidadao>
  readonly cuidadoCompartilhadoEvolucao?: Maybe<CuidadoCompartilhadoEvolucao>
  readonly dataEntrada?: Maybe<Scalars['Instant']['output']>
  readonly dataSaida?: Maybe<Scalars['Instant']['output']>
  readonly equipe?: Maybe<Equipe>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly motivoEspera?: Maybe<Scalars['String']['output']>
  readonly qtdCidadaoPresente?: Maybe<Scalars['Int']['output']>
  readonly tipoAtendimento?: Maybe<ListaEsperaTipoAtendimentoEnum>
  readonly tipoServico?: Maybe<TipoServico>
  readonly unidadeSaude?: Maybe<UnidadeSaude>
}

export enum ListaEsperaMotivoSaidaEnum {
  ATENDIDO_OUTRO_ESTABELECIMENTO = 'ATENDIDO_OUTRO_ESTABELECIMENTO',
  ATENDIMENTO_AGENDADO = 'ATENDIMENTO_AGENDADO',
  MUDOU_TERRITORIO = 'MUDOU_TERRITORIO',
  NAO_RESPONDEU_TENTATIVAS_CONTATO = 'NAO_RESPONDEU_TENTATIVAS_CONTATO',
  OBITO = 'OBITO',
  OUTROS = 'OUTROS',
}

export enum ListaEsperaTipoAtendimentoEnum {
  CONSULTA_EMULTI = 'CONSULTA_EMULTI',
  CONSULTA_ENFERMAGEM = 'CONSULTA_ENFERMAGEM',
  CONSULTA_MEDICA = 'CONSULTA_MEDICA',
  CONSULTA_ODONTOLOGICA = 'CONSULTA_ODONTOLOGICA',
}

export type ListaMedicamento = {
  readonly __typename?: 'ListaMedicamento'
  readonly id: Scalars['ID']['output']
  readonly tipo: Scalars['String']['output']
  readonly tipoReceita: TipoReceitaEnum
}

export type ListaMedicamentoAtivoConcluidoQueryInput = {
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly dataAtendimento?: InputMaybe<Scalars['Instant']['input']>
  readonly dataMinimaFimTratamento?: InputMaybe<Scalars['Instant']['input']>
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<OptionalPageParams>
  readonly periodoInicioTratamento?: InputMaybe<Period>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tipoAcompanhamento?: InputMaybe<TipoAcompanhamentoEnum>
  readonly usoContinuo?: InputMaybe<Scalars['Boolean']['input']>
}

export type ListaMedicamentoAtivoConcluidoQueryPayload = {
  readonly __typename?: 'ListaMedicamentoAtivoConcluidoQueryPayload'
  readonly content: ReadonlyArray<Maybe<ReceitaMedicamento>>
  readonly pageInfo: PageInfo
}

export enum ListaMedicamentoEnum {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  ANTIMICROBIANOS = 'ANTIMICROBIANOS',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  COMUNS = 'COMUNS',
  D1 = 'D1',
  D2 = 'D2',
}

export type ListaRegulacaoQueryInput = {
  readonly equipeIne?: InputMaybe<Scalars['String']['input']>
  readonly filtro?: InputMaybe<Scalars['String']['input']>
  readonly lotacoesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly ordem?: InputMaybe<OrdemRegulacaoEnum>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodo?: InputMaybe<Period>
  readonly somenteNaoLidos?: InputMaybe<Scalars['Boolean']['input']>
  readonly statusRegulacao?: InputMaybe<ReadonlyArray<StatusRegulacaoEnum>>
  readonly tipoRegulacao?: InputMaybe<ReadonlyArray<TipoRegulacaoEnum>>
  readonly unidadeSaudeCnes?: InputMaybe<Scalars['String']['input']>
}

export type ListaRegulacaoQueryPayload = {
  readonly __typename?: 'ListaRegulacaoQueryPayload'
  readonly content: ReadonlyArray<Regulacao>
  readonly pageInfo: PageInfo
}

export type LocalAplicacao = {
  readonly __typename?: 'LocalAplicacao'
  readonly codigoRnds?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly versaoMaximaTransport?: Maybe<Scalars['String']['output']>
  readonly versaoMinimaTransport?: Maybe<Scalars['String']['output']>
}

export type LocalAplicacaoQueryInput = {
  readonly maxTransportVersion?: InputMaybe<Scalars['String']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly viaAdministracaoId: Scalars['ID']['input']
}

export type LocalAtendimento = {
  readonly __typename?: 'LocalAtendimento'
  readonly id: Scalars['ID']['output']
  readonly localAtendimentoExibicao?: Maybe<Scalars['String']['output']>
}

export type LocalAtendimentoPayload = {
  readonly __typename?: 'LocalAtendimentoPayload'
  readonly content: ReadonlyArray<LocalAtendimento>
  readonly pageInfo: PageInfo
}

export type LocalAtendimentoQueryInput = {
  readonly excludeUbs?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type LocalOcorrencia = {
  readonly __typename?: 'LocalOcorrencia'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeFiltro: Scalars['String']['output']
}

export type LocalOcorrenciaPayload = {
  readonly __typename?: 'LocalOcorrenciaPayload'
  readonly content: ReadonlyArray<LocalOcorrencia>
  readonly pageInfo: PageInfo
}

export type LocalOcorrenciaQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type LocalidadeCnesDesatualizadoDto = {
  readonly __typename?: 'LocalidadeCnesDesatualizadoDto'
  readonly instalacaoCentral?: Maybe<Scalars['String']['output']>
  readonly instalacaoLocal?: Maybe<Scalars['String']['output']>
}

export type LoginInput = {
  readonly force?: InputMaybe<Scalars['Boolean']['input']>
  readonly password: Scalars['String']['input']
  readonly username: Scalars['String']['input']
}

export type LoginPayload = {
  readonly __typename?: 'LoginPayload'
  readonly dataExpiracaoRefreshToken?: Maybe<Scalars['Instant']['output']>
  readonly refreshToken?: Maybe<Scalars['String']['output']>
  readonly success: Scalars['Boolean']['output']
}

export type Logradouro = {
  readonly __typename?: 'Logradouro'
  readonly bairro: Bairro
  readonly cep: Scalars['String']['output']
  readonly dne: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomeExibicao: Scalars['String']['output']
  readonly nomePreposicao: Scalars['String']['output']
  readonly tipoLogradouro: TipoLogradouro
  readonly tituloPatente?: Maybe<TituloPatente>
}

export type LogradouroInput = {
  readonly bairroId?: InputMaybe<Scalars['ID']['input']>
  readonly municipioId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tipoLogradouroId?: InputMaybe<Scalars['ID']['input']>
}

export type LogradouroQueryPayload = {
  readonly __typename?: 'LogradouroQueryPayload'
  readonly content: ReadonlyArray<Maybe<Logradouro>>
  readonly pageInfo: PageInfo
}

export type LogradouroTerritorioDto = {
  readonly __typename?: 'LogradouroTerritorioDto'
  readonly aldeia?: Maybe<Aldeia>
  readonly bairro?: Maybe<Scalars['String']['output']>
  readonly cep?: Maybe<Scalars['String']['output']>
  readonly dsei?: Maybe<Dsei>
  readonly id: Scalars['String']['output']
  readonly logradouro?: Maybe<Scalars['String']['output']>
  readonly municipio?: Maybe<Municipio>
  readonly municipioAldeia?: Maybe<Municipio>
  readonly numeroImoveis: Scalars['Int']['output']
  readonly poloBase?: Maybe<PoloBase>
  readonly tipoEndereco: TipoEnderecoEnum
  readonly tipoLogradouroDne?: Maybe<Scalars['String']['output']>
  readonly tipoLogradouroId?: Maybe<Scalars['ID']['output']>
  readonly tipoLogradouroNome?: Maybe<Scalars['String']['output']>
}

export type LogradourosTerritorioQueryPayload = {
  readonly __typename?: 'LogradourosTerritorioQueryPayload'
  readonly content: ReadonlyArray<LogradouroTerritorioDto>
  readonly pageInfo: PageInfo
}

export type Lotacao = Acesso & {
  readonly __typename?: 'Lotacao'
  readonly actions: LotacaoActions
  readonly ativo: Scalars['Boolean']['output']
  readonly atualizaPerfil?: Maybe<Scalars['Boolean']['output']>
  readonly cbo: Cbo
  readonly configuracaoAgenda?: Maybe<ConfiguracaoAgendaLotacao>
  readonly equipe?: Maybe<Equipe>
  readonly gradeConfiguracaoAgendaOnline?: Maybe<ConfiguracaoAgendaOnlineLotacao>
  readonly hasAgendaFechada: Scalars['Boolean']['output']
  readonly hasAgendamentoFuturo?: Maybe<Scalars['Boolean']['output']>
  readonly hasConfiguracaoAgenda?: Maybe<Scalars['Boolean']['output']>
  readonly hasConfiguracaoAgendaOnline?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly importada: Scalars['Boolean']['output']
  readonly moduloInicial?: Maybe<Scalars['String']['output']>
  readonly municipio: Municipio
  readonly perfis?: Maybe<ReadonlyArray<Maybe<Perfil>>>
  readonly profissional: Profissional
  readonly tipo: TipoAcesso
  readonly unidadeSaude: UnidadeSaude
}

export type LotacaoHasAgendaFechadaArgs = {
  date: Scalars['LocalDate']['input']
}

export type LotacaoActions = BaseAcessoActions & {
  readonly __typename?: 'LotacaoActions'
  readonly permissaoAtivacaoInativacao: Action
  readonly permissaoConfigurarAgenda: Action
  readonly permissaoConfigurarAgendaOnline: Action
  readonly permissaoEdicao: Action
  readonly permissaoExclusao: Action
  readonly permissaoFecharAgenda: Action
}

export type LotacaoAgendamentoConflitanteInput = {
  readonly horario: Scalars['Instant']['input']
  readonly lotacaoId: Scalars['ID']['input']
}

export type LotacaoInput = {
  readonly ativo: Scalars['Boolean']['input']
  readonly atualizaPerfil: Scalars['Boolean']['input']
  readonly cbo: Scalars['ID']['input']
  readonly equipe?: InputMaybe<Scalars['ID']['input']>
  readonly perfis: ReadonlyArray<Scalars['ID']['input']>
  readonly profissional: Scalars['ID']['input']
  readonly unidadeSaude: Scalars['ID']['input']
}

export type LotacaoOuEstagio = Estagio | Lotacao

export type LotacaoQueryPayload = {
  readonly __typename?: 'LotacaoQueryPayload'
  readonly content: ReadonlyArray<Maybe<Lotacao>>
  readonly pageInfo: PageInfo
}

export type LotacoesAgendaFixadaInput = {
  readonly excludeProfissionaisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type LotacoesAgendaInput = {
  readonly cbosAcesso?: InputMaybe<ReadonlyArray<AcessoCbo>>
  readonly excludeProfissionaisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly includeEquipesComVinculo?: InputMaybe<Scalars['Boolean']['input']>
  readonly incluirInativasComAgendamentosFuturos?: InputMaybe<Scalars['Boolean']['input']>
  readonly isAgendaAd: Scalars['Boolean']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteCadastrarAgendamento?: InputMaybe<Scalars['Boolean']['input']>
}

export type LotacoesAndEstagiosInput = {
  readonly apenasAps?: InputMaybe<Scalars['Boolean']['input']>
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly canWriteAtendimento?: InputMaybe<Scalars['Boolean']['input']>
  readonly canWriteAtividadeColetiva?: InputMaybe<Scalars['Boolean']['input']>
  readonly canWriteCadastroDomiciliar?: InputMaybe<Scalars['Boolean']['input']>
  readonly canWriteCadastroIndividual?: InputMaybe<Scalars['Boolean']['input']>
  readonly canWriteCidadaoTerritorioIndigena?: InputMaybe<Scalars['Boolean']['input']>
  readonly canWriteRegistroTardio?: InputMaybe<Scalars['Boolean']['input']>
  readonly cbo?: InputMaybe<Scalars['String']['input']>
  readonly equipe?: InputMaybe<Scalars['String']['input']>
  readonly equipeVinculadaId?: InputMaybe<Scalars['ID']['input']>
  readonly excludeProfissionaisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly excluirEsbEmulti?: InputMaybe<Scalars['Boolean']['input']>
  readonly includeEstagios?: InputMaybe<Scalars['Boolean']['input']>
  readonly maxResults?: InputMaybe<Scalars['Int']['input']>
  readonly municipioId?: InputMaybe<Scalars['ID']['input']>
  readonly nivelSuperior?: InputMaybe<Scalars['Boolean']['input']>
  readonly possuiAgendaCadastrada?: InputMaybe<Scalars['Boolean']['input']>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly semEquipe?: InputMaybe<Scalars['Boolean']['input']>
  readonly unidadeSaude?: InputMaybe<Scalars['String']['input']>
}

export type LotacoesComRegulacoesQueryInput = {
  readonly nomeProfissional?: InputMaybe<Scalars['String']['input']>
}

export type LotacoesCuidadoCompartilhadoByEstabelecimentoIdQueryInput = {
  readonly cboId?: InputMaybe<Scalars['ID']['input']>
  readonly equipeExecutanteId?: InputMaybe<Scalars['ID']['input']>
  readonly equipeSolicitanteId?: InputMaybe<Scalars['ID']['input']>
  readonly estabelecimentoId: Scalars['ID']['input']
  readonly excludeProfissionaisIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly isTrocaExecutante?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<OptionalPageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type LoteEnvio = {
  readonly __typename?: 'LoteEnvio'
  readonly dataCriacao: Scalars['Instant']['output']
  readonly historicoExportacao: LoteHistoricoExportacaoPayload
  readonly id: Scalars['ID']['output']
  readonly nodos?: Maybe<ReadonlyArray<Maybe<NodoLoteEnvio>>>
  readonly quantidadeFichas: Scalars['Int']['output']
  readonly statusEnvio: StatusEnvio
}

export type LoteEnvioHistoricoExportacaoArgs = {
  filtro: HistoricoExportacaoFiltro
}

export type LoteHistoricoExportacao = {
  readonly __typename?: 'LoteHistoricoExportacao'
  readonly dataExportacao: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly nomeProfissional: Scalars['String']['output']
}

export type LoteHistoricoExportacaoPayload = {
  readonly __typename?: 'LoteHistoricoExportacaoPayload'
  readonly content: ReadonlyArray<Maybe<LoteHistoricoExportacao>>
  readonly pageInfo: PageInfo
}

export type LoteImunobiologico = {
  readonly __typename?: 'LoteImunobiologico'
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly fabricante?: Maybe<ImunobiologicoFabricante>
  readonly id: Scalars['ID']['output']
  readonly imunobiologico?: Maybe<Imunobiologico>
  readonly lote?: Maybe<Scalars['String']['output']>
  readonly validade?: Maybe<Scalars['LocalDate']['output']>
}

export type LoteImunobiologicoInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly idFabricante?: InputMaybe<Scalars['ID']['input']>
  readonly idImunobiologico: Scalars['ID']['input']
  readonly lote: Scalars['String']['input']
  readonly nomeFabricante?: InputMaybe<Scalars['String']['input']>
  readonly validade: Scalars['LocalDate']['input']
}

export type LoteImunobiologicoQueryInput = {
  readonly filtroImunoFabricante?: InputMaybe<Scalars['String']['input']>
  readonly imunobiologicoId?: InputMaybe<Scalars['ID']['input']>
  readonly mostrarLotesInativos?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
}

export type LoteImunobiologicoVacinacaoInput = {
  readonly dataValidade?: InputMaybe<Scalars['LocalDate']['input']>
  readonly fabricanteId?: InputMaybe<Scalars['String']['input']>
  readonly fabricanteNome?: InputMaybe<Scalars['String']['input']>
  readonly loteNome?: InputMaybe<Scalars['String']['input']>
}

export type LotesEnvioFiltro = {
  readonly dataCriacaoFim?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataCriacaoInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly idLote?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly statusEnvio?: InputMaybe<ReadonlyArray<InputMaybe<StatusEnvio>>>
}

export type LotesEnvioPayload = {
  readonly __typename?: 'LotesEnvioPayload'
  readonly content: ReadonlyArray<Maybe<LoteEnvio>>
  readonly pageInfo: PageInfo
}

export type LotesImunobiologicoQueryPayload = {
  readonly __typename?: 'LotesImunobiologicoQueryPayload'
  readonly content: ReadonlyArray<Maybe<LoteImunobiologico>>
  readonly pageInfo: PageInfo
}

export type MChat = {
  readonly __typename?: 'MChat'
  readonly aplicacao: ReadonlyArray<MchatAplicacao>
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly dataResultado: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly isMchatRf: Scalars['Boolean']['output']
  readonly pontuacao: Scalars['Int']['output']
  readonly prontuario: Prontuario
  readonly risco: MChatRiscoEnum
}

export type MChatInput = {
  readonly aplicacaoMChatR?: InputMaybe<ReadonlyArray<MChatPerguntaRespostaInput>>
  readonly aplicacaoMChatRf?: InputMaybe<ReadonlyArray<MChatRfPerguntaRespostaInput>>
  readonly mChatRelacionadoId?: InputMaybe<Scalars['Long']['input']>
}

export enum MChatPerguntaEnum {
  PERGUNTA_01 = 'PERGUNTA_01',
  PERGUNTA_01_01 = 'PERGUNTA_01_01',
  PERGUNTA_01_02 = 'PERGUNTA_01_02',
  PERGUNTA_01_03 = 'PERGUNTA_01_03',
  PERGUNTA_01_04 = 'PERGUNTA_01_04',
  PERGUNTA_01_05 = 'PERGUNTA_01_05',
  PERGUNTA_01_06 = 'PERGUNTA_01_06',
  PERGUNTA_01_07 = 'PERGUNTA_01_07',
  PERGUNTA_01_08 = 'PERGUNTA_01_08',
  PERGUNTA_01_09 = 'PERGUNTA_01_09',
  PERGUNTA_02 = 'PERGUNTA_02',
  PERGUNTA_02_01 = 'PERGUNTA_02_01',
  PERGUNTA_02_02 = 'PERGUNTA_02_02',
  PERGUNTA_02_03 = 'PERGUNTA_02_03',
  PERGUNTA_02_04 = 'PERGUNTA_02_04',
  PERGUNTA_03 = 'PERGUNTA_03',
  PERGUNTA_03_01 = 'PERGUNTA_03_01',
  PERGUNTA_03_02 = 'PERGUNTA_03_02',
  PERGUNTA_03_03 = 'PERGUNTA_03_03',
  PERGUNTA_03_04 = 'PERGUNTA_03_04',
  PERGUNTA_03_05 = 'PERGUNTA_03_05',
  PERGUNTA_03_06 = 'PERGUNTA_03_06',
  PERGUNTA_03_07 = 'PERGUNTA_03_07',
  PERGUNTA_03_08 = 'PERGUNTA_03_08',
  PERGUNTA_03_09 = 'PERGUNTA_03_09',
  PERGUNTA_03_10 = 'PERGUNTA_03_10',
  PERGUNTA_03_11 = 'PERGUNTA_03_11',
  PERGUNTA_03_12 = 'PERGUNTA_03_12',
  PERGUNTA_04 = 'PERGUNTA_04',
  PERGUNTA_04_01 = 'PERGUNTA_04_01',
  PERGUNTA_04_02 = 'PERGUNTA_04_02',
  PERGUNTA_04_03 = 'PERGUNTA_04_03',
  PERGUNTA_04_04 = 'PERGUNTA_04_04',
  PERGUNTA_04_05 = 'PERGUNTA_04_05',
  PERGUNTA_05 = 'PERGUNTA_05',
  PERGUNTA_05_01 = 'PERGUNTA_05_01',
  PERGUNTA_05_02 = 'PERGUNTA_05_02',
  PERGUNTA_05_03 = 'PERGUNTA_05_03',
  PERGUNTA_05_04 = 'PERGUNTA_05_04',
  PERGUNTA_05_05 = 'PERGUNTA_05_05',
  PERGUNTA_05_06 = 'PERGUNTA_05_06',
  PERGUNTA_05_07 = 'PERGUNTA_05_07',
  PERGUNTA_05_08 = 'PERGUNTA_05_08',
  PERGUNTA_05_09 = 'PERGUNTA_05_09',
  PERGUNTA_06 = 'PERGUNTA_06',
  PERGUNTA_06_01 = 'PERGUNTA_06_01',
  PERGUNTA_06_02 = 'PERGUNTA_06_02',
  PERGUNTA_06_03 = 'PERGUNTA_06_03',
  PERGUNTA_06_04 = 'PERGUNTA_06_04',
  PERGUNTA_06_05 = 'PERGUNTA_06_05',
  PERGUNTA_06_06 = 'PERGUNTA_06_06',
  PERGUNTA_07 = 'PERGUNTA_07',
  PERGUNTA_07_01 = 'PERGUNTA_07_01',
  PERGUNTA_07_02 = 'PERGUNTA_07_02',
  PERGUNTA_07_03 = 'PERGUNTA_07_03',
  PERGUNTA_07_04 = 'PERGUNTA_07_04',
  PERGUNTA_07_05 = 'PERGUNTA_07_05',
  PERGUNTA_07_06 = 'PERGUNTA_07_06',
  PERGUNTA_07_07 = 'PERGUNTA_07_07',
  PERGUNTA_08 = 'PERGUNTA_08',
  PERGUNTA_08_01 = 'PERGUNTA_08_01',
  PERGUNTA_08_02 = 'PERGUNTA_08_02',
  PERGUNTA_08_03 = 'PERGUNTA_08_03',
  PERGUNTA_08_04 = 'PERGUNTA_08_04',
  PERGUNTA_08_05 = 'PERGUNTA_08_05',
  PERGUNTA_08_06 = 'PERGUNTA_08_06',
  PERGUNTA_08_07 = 'PERGUNTA_08_07',
  PERGUNTA_08_08 = 'PERGUNTA_08_08',
  PERGUNTA_08_09 = 'PERGUNTA_08_09',
  PERGUNTA_08_10 = 'PERGUNTA_08_10',
  PERGUNTA_08_11 = 'PERGUNTA_08_11',
  PERGUNTA_09 = 'PERGUNTA_09',
  PERGUNTA_09_01 = 'PERGUNTA_09_01',
  PERGUNTA_09_02 = 'PERGUNTA_09_02',
  PERGUNTA_09_03 = 'PERGUNTA_09_03',
  PERGUNTA_09_04 = 'PERGUNTA_09_04',
  PERGUNTA_09_05 = 'PERGUNTA_09_05',
  PERGUNTA_09_06 = 'PERGUNTA_09_06',
  PERGUNTA_09_07 = 'PERGUNTA_09_07',
  PERGUNTA_09_08 = 'PERGUNTA_09_08',
  PERGUNTA_10 = 'PERGUNTA_10',
  PERGUNTA_10_01 = 'PERGUNTA_10_01',
  PERGUNTA_10_02 = 'PERGUNTA_10_02',
  PERGUNTA_10_03 = 'PERGUNTA_10_03',
  PERGUNTA_10_04 = 'PERGUNTA_10_04',
  PERGUNTA_10_05 = 'PERGUNTA_10_05',
  PERGUNTA_10_06 = 'PERGUNTA_10_06',
  PERGUNTA_10_07 = 'PERGUNTA_10_07',
  PERGUNTA_10_08 = 'PERGUNTA_10_08',
  PERGUNTA_10_09 = 'PERGUNTA_10_09',
  PERGUNTA_11 = 'PERGUNTA_11',
  PERGUNTA_11_01 = 'PERGUNTA_11_01',
  PERGUNTA_11_02 = 'PERGUNTA_11_02',
  PERGUNTA_11_03 = 'PERGUNTA_11_03',
  PERGUNTA_11_04 = 'PERGUNTA_11_04',
  PERGUNTA_11_05 = 'PERGUNTA_11_05',
  PERGUNTA_11_06 = 'PERGUNTA_11_06',
  PERGUNTA_11_07 = 'PERGUNTA_11_07',
  PERGUNTA_11_08 = 'PERGUNTA_11_08',
  PERGUNTA_12 = 'PERGUNTA_12',
  PERGUNTA_12_01 = 'PERGUNTA_12_01',
  PERGUNTA_12_02 = 'PERGUNTA_12_02',
  PERGUNTA_12_03 = 'PERGUNTA_12_03',
  PERGUNTA_12_04 = 'PERGUNTA_12_04',
  PERGUNTA_12_05 = 'PERGUNTA_12_05',
  PERGUNTA_12_06 = 'PERGUNTA_12_06',
  PERGUNTA_12_07 = 'PERGUNTA_12_07',
  PERGUNTA_12_08 = 'PERGUNTA_12_08',
  PERGUNTA_12_09 = 'PERGUNTA_12_09',
  PERGUNTA_12_10 = 'PERGUNTA_12_10',
  PERGUNTA_12_11 = 'PERGUNTA_12_11',
  PERGUNTA_12_12 = 'PERGUNTA_12_12',
  PERGUNTA_12_13 = 'PERGUNTA_12_13',
  PERGUNTA_12_14 = 'PERGUNTA_12_14',
  PERGUNTA_12_15 = 'PERGUNTA_12_15',
  PERGUNTA_12_16 = 'PERGUNTA_12_16',
  PERGUNTA_12_17 = 'PERGUNTA_12_17',
  PERGUNTA_12_18 = 'PERGUNTA_12_18',
  PERGUNTA_13 = 'PERGUNTA_13',
  PERGUNTA_13_01 = 'PERGUNTA_13_01',
  PERGUNTA_13_02 = 'PERGUNTA_13_02',
  PERGUNTA_14 = 'PERGUNTA_14',
  PERGUNTA_14_01 = 'PERGUNTA_14_01',
  PERGUNTA_14_02 = 'PERGUNTA_14_02',
  PERGUNTA_14_03 = 'PERGUNTA_14_03',
  PERGUNTA_14_04 = 'PERGUNTA_14_04',
  PERGUNTA_14_05 = 'PERGUNTA_14_05',
  PERGUNTA_14_06 = 'PERGUNTA_14_06',
  PERGUNTA_14_07 = 'PERGUNTA_14_07',
  PERGUNTA_14_08 = 'PERGUNTA_14_08',
  PERGUNTA_14_09 = 'PERGUNTA_14_09',
  PERGUNTA_14_10 = 'PERGUNTA_14_10',
  PERGUNTA_15 = 'PERGUNTA_15',
  PERGUNTA_15_01 = 'PERGUNTA_15_01',
  PERGUNTA_15_02 = 'PERGUNTA_15_02',
  PERGUNTA_15_03 = 'PERGUNTA_15_03',
  PERGUNTA_15_04 = 'PERGUNTA_15_04',
  PERGUNTA_15_05 = 'PERGUNTA_15_05',
  PERGUNTA_15_06 = 'PERGUNTA_15_06',
  PERGUNTA_15_07 = 'PERGUNTA_15_07',
  PERGUNTA_15_08 = 'PERGUNTA_15_08',
  PERGUNTA_16 = 'PERGUNTA_16',
  PERGUNTA_16_01 = 'PERGUNTA_16_01',
  PERGUNTA_16_02 = 'PERGUNTA_16_02',
  PERGUNTA_16_03 = 'PERGUNTA_16_03',
  PERGUNTA_16_04 = 'PERGUNTA_16_04',
  PERGUNTA_16_05 = 'PERGUNTA_16_05',
  PERGUNTA_16_06 = 'PERGUNTA_16_06',
  PERGUNTA_16_07 = 'PERGUNTA_16_07',
  PERGUNTA_17 = 'PERGUNTA_17',
  PERGUNTA_17_01 = 'PERGUNTA_17_01',
  PERGUNTA_17_02 = 'PERGUNTA_17_02',
  PERGUNTA_17_03 = 'PERGUNTA_17_03',
  PERGUNTA_17_04 = 'PERGUNTA_17_04',
  PERGUNTA_17_05 = 'PERGUNTA_17_05',
  PERGUNTA_17_06 = 'PERGUNTA_17_06',
  PERGUNTA_18 = 'PERGUNTA_18',
  PERGUNTA_18_01 = 'PERGUNTA_18_01',
  PERGUNTA_18_02 = 'PERGUNTA_18_02',
  PERGUNTA_18_03 = 'PERGUNTA_18_03',
  PERGUNTA_18_04 = 'PERGUNTA_18_04',
  PERGUNTA_18_05 = 'PERGUNTA_18_05',
  PERGUNTA_18_06 = 'PERGUNTA_18_06',
  PERGUNTA_18_07 = 'PERGUNTA_18_07',
  PERGUNTA_19 = 'PERGUNTA_19',
  PERGUNTA_19_01 = 'PERGUNTA_19_01',
  PERGUNTA_19_02 = 'PERGUNTA_19_02',
  PERGUNTA_19_03 = 'PERGUNTA_19_03',
  PERGUNTA_19_04 = 'PERGUNTA_19_04',
  PERGUNTA_20 = 'PERGUNTA_20',
  PERGUNTA_20_01 = 'PERGUNTA_20_01',
  PERGUNTA_20_02 = 'PERGUNTA_20_02',
  PERGUNTA_20_03 = 'PERGUNTA_20_03',
  PERGUNTA_20_04 = 'PERGUNTA_20_04',
  PERGUNTA_20_05 = 'PERGUNTA_20_05',
  PERGUNTA_20_06 = 'PERGUNTA_20_06',
}

export enum MChatPerguntaOpcaoEnum {
  AJUDA = 'AJUDA',
  AUDICAO_ABAIXO = 'AUDICAO_ABAIXO',
  AUDICAO_NORMAL = 'AUDICAO_NORMAL',
  INTERESSE = 'INTERESSE',
  NAO_DEFINITIVO = 'NAO_DEFINITIVO',
}

export type MChatPerguntaRespostaInput = {
  readonly pergunta: MChatPerguntaEnum
  readonly stPassou?: InputMaybe<Scalars['Boolean']['input']>
}

export type MChatRfPerguntaRespostaInput = {
  readonly outros?: InputMaybe<Scalars['String']['input']>
  readonly pergunta: MChatPerguntaEnum
  readonly perguntaOpcao?: InputMaybe<MChatPerguntaOpcaoEnum>
  readonly stResposta?: InputMaybe<Scalars['Boolean']['input']>
}

export enum MChatRiscoEnum {
  BAIXO = 'BAIXO',
  ELEVADO = 'ELEVADO',
  MEDIO = 'MEDIO',
  NEGATIVO = 'NEGATIVO',
  POSITIVO = 'POSITIVO',
}

export type ManifestacaoAlergia = {
  readonly __typename?: 'ManifestacaoAlergia'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sinonimo?: Maybe<Scalars['String']['output']>
}

export type ManifestacaoAlergiaQueryPayload = {
  readonly __typename?: 'ManifestacaoAlergiaQueryPayload'
  readonly content: ReadonlyArray<ManifestacaoAlergia>
  readonly pageInfo: PageInfo
}

export type ManifestacoesAlergiaQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type MarcadorConsumoAlimentar = {
  readonly __typename?: 'MarcadorConsumoAlimentar'
  readonly categoria: FaixaEtariaConsumoAlimentar
  readonly id: Scalars['ID']['output']
  readonly respostas: ReadonlyArray<RespostaMarcadoresConsumoAlimentar>
}

export type MarcadoresConsumoAlimentarInput = {
  readonly faixaEtaria: FaixaEtariaConsumoAlimentar
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly respostas: ReadonlyArray<RespostaMarcadoresConsumoAlimentarInput>
}

export type MarcoDesenvolvimento = AvaliacaoDesenvolvimento & {
  readonly __typename?: 'MarcoDesenvolvimento'
  readonly alcancadoComAnos?: Maybe<Scalars['Int']['output']>
  readonly alcancadoComMeses?: Maybe<Scalars['Int']['output']>
  readonly dataAvaliacao?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao: Scalars['String']['output']
  readonly descricaoFaixaEtaria?: Maybe<Scalars['String']['output']>
  readonly faixaEtariaEnum?: Maybe<NeuroFaixaEtariaEnum>
  readonly faixaEtariaFim?: Maybe<Scalars['Int']['output']>
  readonly faixaEtariaInicio?: Maybe<Scalars['Int']['output']>
  readonly hint?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly status: StatusAvaliadoEnum
}

export type MarcoDesenvolvimentoLoadInput = {
  readonly dataReferencia: Scalars['LocalDate']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export type MchatAplicacao = {
  readonly __typename?: 'MchatAplicacao'
  readonly id: Scalars['ID']['output']
  readonly outros?: Maybe<Scalars['String']['output']>
  readonly pergunta: MChatPerguntaEnum
  readonly perguntaOpcao?: Maybe<MChatPerguntaOpcaoEnum>
  readonly stPassou?: Maybe<Scalars['Boolean']['output']>
}

export type Medicamento = {
  readonly __typename?: 'Medicamento'
  readonly concentracao?: Maybe<Scalars['String']['output']>
  readonly formaFarmaceutica?: Maybe<FormaFarmaceutica>
  readonly id: Scalars['ID']['output']
  readonly medicamentoCatmat?: Maybe<MedicamentoCatmat>
  readonly principioAtivo: Scalars['String']['output']
  readonly principioAtivoFiltro?: Maybe<Scalars['String']['output']>
  readonly unidadeFornecimento?: Maybe<Scalars['String']['output']>
}

export type MedicamentoCatmat = {
  readonly __typename?: 'MedicamentoCatmat'
  readonly ativo: Scalars['Boolean']['output']
  readonly codigoCatMat?: Maybe<Scalars['String']['output']>
  readonly codigoObm?: Maybe<Scalars['String']['output']>
  readonly codigoRename?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly medicamento: Medicamento
  readonly principioAtivo: PrincipioAtivo
  readonly unidadeFornecimento: UnidadeMedida
  readonly unidadeMedidaDose?: Maybe<UnidadeMedida>
  readonly volume?: Maybe<Scalars['String']['output']>
}

export type MedicamentoCatmatQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type MedicamentoCatmatQueryPayload = {
  readonly __typename?: 'MedicamentoCatmatQueryPayload'
  readonly content: ReadonlyArray<Maybe<MedicamentoCatmat>>
  readonly pageInfo: PageInfo
}

export type MedicamentoInterromperInput = {
  readonly id: Scalars['ID']['input']
  readonly justificativa: Scalars['String']['input']
}

export type MedicamentoPlanoInput = {
  readonly codigoPrescricaoDigital?: InputMaybe<Scalars['String']['input']>
  readonly dataFimTratamento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicioTratamento: Scalars['LocalDate']['input']
  readonly doseUnica: Scalars['Boolean']['input']
  readonly duracao?: InputMaybe<Scalars['Int']['input']>
  readonly escalaDuracao?: InputMaybe<UnidadeMedidaTempoEnum>
  readonly frequenciaDose?: InputMaybe<Scalars['Int']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly intervaloDose?: InputMaybe<Scalars['Int']['input']>
  readonly medicamentoId?: InputMaybe<Scalars['ID']['input']>
  readonly medicamentoRegistroManual?: InputMaybe<RegistroManualMedicamentoInput>
  readonly motivoPrescricao?: InputMaybe<MotivoPrescricaoInput>
  readonly posologia: Scalars['String']['input']
  readonly qtDose?: InputMaybe<Scalars['String']['input']>
  readonly qtDoseManha?: InputMaybe<Scalars['String']['input']>
  readonly qtDoseNoite?: InputMaybe<Scalars['String']['input']>
  readonly qtDoseTarde?: InputMaybe<Scalars['String']['input']>
  readonly quantidade: Scalars['Int']['input']
  readonly quantidadePeriodoFrequenciaTurno?: InputMaybe<Scalars['Int']['input']>
  readonly receitaUsoContinuoGrupoId?: InputMaybe<Scalars['ID']['input']>
  readonly recomendacoes?: InputMaybe<Scalars['String']['input']>
  readonly tipoFrequencia?: InputMaybe<TipoFrequencia>
  readonly tipoReceita: TipoReceitaEnum
  readonly turno?: InputMaybe<TurnoEnum>
  readonly unidadeMedidaDose: Scalars['ID']['input']
  readonly unidadeMedidaTempoFrequenciaTurno?: InputMaybe<UnidadeMedidaTempoEnum>
  readonly usoContinuo: Scalars['Boolean']['input']
  readonly viaAdministracao: Scalars['ID']['input']
}

export type MedicamentoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type MedicamentoQueryPayload = {
  readonly __typename?: 'MedicamentoQueryPayload'
  readonly content: ReadonlyArray<Maybe<Medicamento>>
  readonly pageInfo: PageInfo
}

export type Medicao = {
  readonly __typename?: 'Medicao'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly dataMedicao: Scalars['Instant']['output']
  readonly dum?: Maybe<Scalars['LocalDate']['output']>
  readonly id: Scalars['ID']['output']
  readonly medicaoAnterior?: Maybe<Scalars['Boolean']['output']>
  readonly membroInferiorDireito?: Maybe<Scalars['String']['output']>
  readonly membroInferiorEsquerdo?: Maybe<Scalars['String']['output']>
  readonly olhoDireito?: Maybe<Scalars['String']['output']>
  readonly olhoEsquerdo?: Maybe<Scalars['String']['output']>
  readonly ouvidoDireito?: Maybe<Scalars['String']['output']>
  readonly ouvidoEsquerdo?: Maybe<Scalars['String']['output']>
  readonly pele?: Maybe<Scalars['String']['output']>
  readonly perimetroPanturrilha?: Maybe<Scalars['Float']['output']>
  readonly tipoGlicemia?: Maybe<TipoGlicemia>
  readonly unidadeForcaMuscMaoDireita?: Maybe<TipoUnidadeForcaMuscular>
  readonly unidadeForcaMuscMaoEsquerda?: Maybe<TipoUnidadeForcaMuscular>
  readonly valorAltura?: Maybe<Scalars['Float']['output']>
  readonly valorAlturaUterina?: Maybe<Scalars['String']['output']>
  readonly valorBatimentoCardiacoFetal?: Maybe<Scalars['String']['output']>
  readonly valorBatimentoCardiacoFetal2?: Maybe<Scalars['String']['output']>
  readonly valorCircunferenciaAbdominal?: Maybe<Scalars['Float']['output']>
  readonly valorForcaMuscMaoDireita?: Maybe<Scalars['String']['output']>
  readonly valorForcaMuscMaoEsquerda?: Maybe<Scalars['String']['output']>
  readonly valorFrequenciaCardiaca?: Maybe<Scalars['Int']['output']>
  readonly valorFrequenciaRespiratoria?: Maybe<Scalars['Int']['output']>
  readonly valorGlicemia?: Maybe<Scalars['Int']['output']>
  readonly valorImc?: Maybe<Scalars['Float']['output']>
  readonly valorPerimetroCefalico?: Maybe<Scalars['Float']['output']>
  readonly valorPeso?: Maybe<Scalars['Float']['output']>
  readonly valorPressaoArterial?: Maybe<Scalars['String']['output']>
  readonly valorSaturacaoO2?: Maybe<Scalars['Int']['output']>
  readonly valorTemperatura?: Maybe<Scalars['Float']['output']>
  readonly valorVacinacaoEmDia?: Maybe<Scalars['Boolean']['output']>
}

export type MedicoesInput = {
  readonly altura?: InputMaybe<Scalars['Float']['input']>
  readonly circunferenciaAbdominal?: InputMaybe<Scalars['Float']['input']>
  readonly dataMedicao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dum?: InputMaybe<Scalars['LocalDate']['input']>
  readonly exameFisico?: InputMaybe<ExameFisicoInput>
  readonly frequenciaCardiaca?: InputMaybe<Scalars['Int']['input']>
  readonly frequenciaRespiratoria?: InputMaybe<Scalars['Int']['input']>
  readonly glicemia?: InputMaybe<Scalars['Int']['input']>
  readonly perimetroCefalico?: InputMaybe<Scalars['Float']['input']>
  readonly perimetroPanturrilha?: InputMaybe<Scalars['Float']['input']>
  readonly peso?: InputMaybe<Scalars['Float']['input']>
  readonly pressaoArterialDiastolica?: InputMaybe<Scalars['Int']['input']>
  readonly pressaoArterialSistolica?: InputMaybe<Scalars['Int']['input']>
  readonly saturacaoO2?: InputMaybe<Scalars['Int']['input']>
  readonly temperatura?: InputMaybe<Scalars['Float']['input']>
  readonly tipoGlicemia?: InputMaybe<TipoGlicemia>
  readonly unidadeForcaMuscMaoDireita?: InputMaybe<TipoUnidadeForcaMuscular>
  readonly unidadeForcaMuscMaoEsquerda?: InputMaybe<TipoUnidadeForcaMuscular>
  readonly vacinacaoEmDia?: InputMaybe<Scalars['Boolean']['input']>
  readonly valorForcaMuscMaoDireita?: InputMaybe<Scalars['Float']['input']>
  readonly valorForcaMuscMaoEsquerda?: InputMaybe<Scalars['Float']['input']>
}

export type MedicoesPreNatalConsolidado = {
  readonly __typename?: 'MedicoesPreNatalConsolidado'
  readonly qtdMedicoesAlturaUterina?: Maybe<Scalars['Long']['output']>
  readonly qtdMedicoesPesoAltura?: Maybe<Scalars['Long']['output']>
  readonly qtdMedicoesPressaoArterial?: Maybe<Scalars['Long']['output']>
}

export type MedicoesQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
  readonly ultimoRegistroComPeso?: InputMaybe<Scalars['Boolean']['input']>
}

export type MesAgendaLotacao = {
  readonly __typename?: 'MesAgendaLotacao'
  readonly dias: ReadonlyArray<DiaAgendaLotacao>
  readonly id: Scalars['ID']['output']
}

export type MesAgendaQueryInput = {
  readonly ano: Scalars['Int']['input']
  readonly lotacaoId: Scalars['ID']['input']
  readonly mes: Scalars['Int']['input']
}

export type MobileAppItemError = {
  readonly __typename?: 'MobileAppItemError'
  readonly error: Scalars['String']['output']
  readonly uuid: Scalars['String']['output']
}

export type MobileAppRequestVacinacaoInput = {
  readonly responsavel: MobileAppResponsavelInput
  readonly vacinacoes?: InputMaybe<ReadonlyArray<MobileAppVacinacaoInput>>
}

export type MobileAppResponsavelInput = {
  readonly applicationUuid?: InputMaybe<Scalars['String']['input']>
  readonly cpf: Scalars['String']['input']
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly fone?: InputMaybe<Scalars['String']['input']>
  readonly nome?: InputMaybe<Scalars['String']['input']>
  readonly versaoSistema?: InputMaybe<Scalars['String']['input']>
}

export type MobileAppResponseVacinacao = {
  readonly __typename?: 'MobileAppResponseVacinacao'
  readonly error?: Maybe<Scalars['String']['output']>
  readonly errors?: Maybe<ReadonlyArray<Maybe<MobileAppItemError>>>
}

export type MobileAppVacinaInput = {
  readonly anvisaNumeroRegistro?: InputMaybe<Scalars['String']['input']>
  readonly anvisaProtocoloEstudo?: InputMaybe<Scalars['String']['input']>
  readonly anvisaProtocoloVersao?: InputMaybe<Scalars['String']['input']>
  readonly cboPrescritor?: InputMaybe<Scalars['String']['input']>
  readonly cid10MotivoIndicacao?: InputMaybe<Scalars['String']['input']>
  readonly coRndsFabricante?: InputMaybe<Scalars['String']['input']>
  readonly dose: Scalars['Long']['input']
  readonly estrategia?: InputMaybe<Scalars['Long']['input']>
  readonly fabricante?: InputMaybe<Scalars['String']['input']>
  readonly grupoAtendimento?: InputMaybe<Scalars['Long']['input']>
  readonly imunobiologico: Scalars['Long']['input']
  readonly localAplicacao?: InputMaybe<Scalars['Long']['input']>
  readonly lote?: InputMaybe<Scalars['String']['input']>
  readonly pesquisaClinica?: InputMaybe<Scalars['Boolean']['input']>
  readonly viaAdministracao?: InputMaybe<Scalars['Long']['input']>
}

export type MobileAppVacinacaoInput = {
  readonly cnsCidadao?: InputMaybe<Scalars['String']['input']>
  readonly comunicanteHanseniase?: InputMaybe<Scalars['Boolean']['input']>
  readonly condicaoMaternal?: InputMaybe<Scalars['Long']['input']>
  readonly cpfCidadao?: InputMaybe<Scalars['String']['input']>
  /** @deprecated usar dataHorarioFimAtendimento por causa da v2.1 do aplicativo */
  readonly dataHoraFinalAtendimento?: InputMaybe<Scalars['LocalTime']['input']>
  /** @deprecated usar dataHorarioInicioAtendimento por causa da v2.1 do aplicativo */
  readonly dataHoraInicialAtendimento?: InputMaybe<Scalars['LocalTime']['input']>
  readonly dataHorarioFimAtendimento?: InputMaybe<Scalars['LocalDateTime']['input']>
  readonly dataHorarioInicioAtendimento?: InputMaybe<Scalars['LocalDateTime']['input']>
  readonly dataNascimento: Scalars['LocalDate']['input']
  readonly gestante?: InputMaybe<Scalars['Boolean']['input']>
  readonly header: UnicaLotacaoHeaderInput
  readonly justificativaNaoPossuiCpf?: InputMaybe<JustificativaNaoPossuiCpfEnum>
  readonly localAtendimento: Scalars['Long']['input']
  readonly naoPossuiCpf?: InputMaybe<Scalars['Boolean']['input']>
  readonly numProntuario?: InputMaybe<Scalars['String']['input']>
  readonly puerpera?: InputMaybe<Scalars['Boolean']['input']>
  readonly sexo: Scalars['Long']['input']
  readonly turno: Scalars['Long']['input']
  readonly uuid: Scalars['String']['input']
  /** @deprecated será utilizado até o lançamento da v3.0 do aplicativo, depois ficará deprecated e será removido, em favor do uso do vacinas */
  readonly vacina?: InputMaybe<MobileAppVacinaInput>
  readonly vacinas?: InputMaybe<ReadonlyArray<InputMaybe<MobileAppVacinaInput>>>
  readonly versao: VersaoTransportInput
  readonly viajante: Scalars['Boolean']['input']
}

export type ModeloPersonalizado = {
  readonly __typename?: 'ModeloPersonalizado'
  readonly atorPapelCriador: Acesso
  readonly id: Scalars['ID']['output']
  readonly isPublico: Scalars['Boolean']['output']
  readonly modelo: Scalars['String']['output']
  readonly nome: Scalars['String']['output']
  readonly tipoModulo: TipoModuloEnum
}

export type ModeloPersonalizadoRelatorioGerencial = {
  readonly __typename?: 'ModeloPersonalizadoRelatorioGerencial'
  readonly atorPapelCriadorId: Scalars['ID']['output']
  readonly id: Scalars['ID']['output']
  readonly isPublico: Scalars['Boolean']['output']
  readonly modelo: ModeloRelatorioGerencial
  readonly nome: Scalars['String']['output']
  readonly tipoModulo: TipoModuloEnum
}

export type ModeloPersonalizadoRelatorioGerencialInput = {
  readonly aggregator: AggregatorRelatorioGerencialEnum
  readonly campos: ReadonlyArray<CampoSalvoRelatorioGerencialInput>
  readonly ciapIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly cidIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly gruposCondicoesIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly opcaoSelecionada?: InputMaybe<OpcaoSelecionadaRelatorioGerencialEnum>
  readonly tipoAgrupamento?: InputMaybe<TipoAgrupamentoRelatorioGerencialEnum>
  readonly unidadePeriodo?: InputMaybe<UnidadePeriodoRelatorioGerencialEnum>
}

export type ModeloPersonalizadoSelect = {
  readonly __typename?: 'ModeloPersonalizadoSelect'
  readonly id: Scalars['ID']['output']
  readonly isPublico: Scalars['Boolean']['output']
  readonly nome: Scalars['String']['output']
}

export type ModeloRelatorioGerencial = {
  readonly __typename?: 'ModeloRelatorioGerencial'
  readonly aggregator: AggregatorRelatorioGerencialEnum
  readonly campos: ReadonlyArray<CampoSalvoRelatorioGerencial>
  readonly ciaps: ReadonlyArray<Ciap>
  readonly cids: ReadonlyArray<Cid10>
  readonly gruposCondicoes: ReadonlyArray<GrupoCondicao>
  readonly opcaoSelecionada?: Maybe<OpcaoSelecionadaRelatorioGerencialEnum>
  readonly tipoAgrupamento?: Maybe<TipoAgrupamentoRelatorioGerencialEnum>
  readonly unidadePeriodo?: Maybe<UnidadePeriodoRelatorioGerencialEnum>
}

export enum MotivoAgendamentoReservaEnum {
  ATENDIMENTO_EXTERNO = 'ATENDIMENTO_EXTERNO',
  ATIVIDADE_COLETIVA = 'ATIVIDADE_COLETIVA',
  OUTRO = 'OUTRO',
  REUNIAO = 'REUNIAO',
}

export type MotivoConsultaInput = {
  readonly ciap: Scalars['ID']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
}

export enum MotivoFechamentoEnum {
  ATESTADO = 'ATESTADO',
  CURSO = 'CURSO',
  FERIAS = 'FERIAS',
  LICENCA = 'LICENCA',
  OUTRO = 'OUTRO',
  REUNIAO = 'REUNIAO',
}

export type MotivoPrescricaoInput = {
  readonly motivoId?: InputMaybe<Scalars['ID']['input']>
  readonly tipoMotivo?: InputMaybe<TipoMotivoPrescricaoEnum>
}

export type Municipio = {
  readonly __typename?: 'Municipio'
  readonly bairros: ReadonlyArray<Maybe<Bairro>>
  readonly ibge?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly uf: Uf
}

export type MunicipioResponsavelFiltroInput = {
  readonly mostrarInativos: Scalars['Boolean']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type MunicipioResponsavelInput = {
  readonly localidade: Scalars['ID']['input']
  readonly profissional: Scalars['ID']['input']
}

export type MunicipioResponsavelQueryPayload = {
  readonly __typename?: 'MunicipioResponsavelQueryPayload'
  readonly content: ReadonlyArray<Maybe<AdministradorMunicipal>>
  readonly pageInfo: PageInfo
}

export type MunicipioResponsavelUpdateInput = {
  readonly ativo: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
}

export type MunicipiosQueryInput = {
  readonly aldeiaId?: InputMaybe<Scalars['ID']['input']>
  readonly ativo?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly ufId?: InputMaybe<Scalars['ID']['input']>
}

export type MunicipiosQueryPayload = {
  readonly __typename?: 'MunicipiosQueryPayload'
  readonly content: ReadonlyArray<Maybe<Municipio>>
  readonly pageInfo: PageInfo
}

export type Mutation = {
  readonly __typename?: 'Mutation'
  readonly aceitarSolicitacao: Scalars['Boolean']['output']
  readonly aceitarTermosUso?: Maybe<Usuario>
  readonly acessoConecteSus: Scalars['String']['output']
  readonly adicionarCidadaoGarantiaAcesso: Scalars['ID']['output']
  readonly adicionarCidadaoGarantiaAcessoCeo: Scalars['ID']['output']
  readonly adicionarUnidadeConsultaHorus: UnidadeSaude
  readonly agendarConsultaGarantiaAcesso: Scalars['ID']['output']
  readonly alterarAtivacaoAcesso: Scalars['Boolean']['output']
  readonly alterarBuscaCidadaoPorPropriedades: ConfiguracaoBuscaCidadaoPorPropriedades
  readonly alterarCadsus?: Maybe<ConfiguracaoCadsus>
  readonly alterarConfiguracaoAnexoArquivos: ConfiguracaoAnexoArquivos
  readonly alterarConfiguracaoCadastroDomiciliarViaCds: ConfiguracaoFeatureStateDto
  readonly alterarConfiguracaoCadastroIndividualViaCds: ConfiguracaoFeatureStateDto
  readonly alterarConfiguracaoPrescricaoDigital: ConfiguracaoPrescricaoDigital
  readonly alterarConfiguracaoVideochamadas: ConfiguracaoVideochamadas
  readonly alterarDadosServidor?: Maybe<ConfiguracaoDadosServidorFormDto>
  readonly alterarDuracaoCbo?: Maybe<CboMunicipio>
  readonly alterarDuracaoPadraoAtendimento: DuracaoAtendimentoPadraoMunicipio
  readonly alterarHorarioGeracaoLotesProcessamentoFichas: Scalars['LocalTime']['output']
  readonly alterarHorus?: Maybe<ConfiguracaoHorus>
  readonly alterarLotacao: Lotacao
  readonly alterarNumeroTentativasLogin?: Maybe<ConfiguracaoTentativasLogin>
  readonly alterarPeriodoInatividade?: Maybe<ConfiguracaoPeriodoInatividade>
  readonly alterarPeriodoRedefinicaoSenha?: Maybe<ConfiguracaoRedefinicaoSenha>
  readonly alterarQtdRequisicoes?: Maybe<ConfiguracaoPerformance>
  readonly alterarSenhaAtual?: Maybe<Usuario>
  readonly alterarServidorSMTP?: Maybe<ServidorSmtp>
  readonly alterarTipoServico?: Maybe<TipoServico>
  readonly alterarUnidadePadraoHorus: UnidadeSaude
  readonly alternarInternet?: Maybe<ConfiguracaoInternet>
  readonly alternarTransmissaoLink: Scalars['ID']['output']
  readonly ativarAgendaOnline?: Maybe<AgendaOnline>
  readonly ativarPerfil: Perfil
  readonly ativarTipoServico: RlUnidadeSaudeTipoServicoIds
  readonly atualizarContatoCidadao: ContatoCidadao
  readonly atualizarEmailCidadao: ContatoCidadao
  readonly atualizarEnderecoTerritorio: Scalars['Boolean']['output']
  readonly atualizarMunicipioResponsavel: AdministradorMunicipal
  readonly atualizarPerfil: Perfil
  readonly auditCancelarAcompanhamentoCondicaoSaude: Scalars['Boolean']['output']
  readonly auditGerarDeclaracaoComparecimento?: Maybe<Scalars['Boolean']['output']>
  readonly auditImpressaoEscutaInicial?: Maybe<Scalars['ID']['output']>
  readonly auditaImpressaoOrientacao?: Maybe<Scalars['ID']['output']>
  readonly autorizarMunicipio: AdministradorMunicipal
  readonly cadastrarEnderecoEnvio: CadastroEnderecoEnvioDto
  readonly cancelarAgendamento: Scalars['Boolean']['output']
  readonly cancelarAtendimento: Atendimento
  readonly cancelarCidadaoNaoAguardou: Atendimento
  readonly cancelarSolicitacaoEntradaVideochamada: Scalars['Boolean']['output']
  readonly cancelarSolicitacaoEnvio: Scalars['Boolean']['output']
  readonly chamarPainel: Scalars['Boolean']['output']
  readonly compartilharVideochamada: Scalars['Boolean']['output']
  readonly concluirConfiguracaoMunicipio: AdministradorMunicipal
  readonly createCidadaoCadsus: Scalars['ID']['output']
  readonly createEstagio: Estagio
  readonly criarLotacao: Lotacao
  readonly criarPerfil: Perfil
  readonly criarSalaUnidadeSaude: SalaUnidadeSaude
  readonly definirModuloInicial: Acesso
  readonly definirSenhaProvisoria: Scalars['Boolean']['output']
  readonly deleteEstagio: Scalars['ID']['output']
  readonly denifinirNovoAdministrador?: Maybe<Scalars['Boolean']['output']>
  readonly desabilitarConexaoSMTP: Scalars['Boolean']['output']
  readonly desabilitarPainelChamadas: Scalars['Boolean']['output']
  readonly desativarAgendaOnline?: Maybe<AgendaOnline>
  readonly desativarConfiguracaoAgendaOnlineLotacao: Scalars['Boolean']['output']
  readonly desativarTipoServico: RlUnidadeSaudeTipoServicoIds
  readonly disponibilizarCbo?: Maybe<CboMunicipio>
  readonly editarAgendamentoConsulta: Scalars['ID']['output']
  readonly editarAgendamentoConsultaCompartilhada: Scalars['ID']['output']
  readonly editarAgendamentoReserva: ReadonlyArray<Scalars['ID']['output']>
  readonly editarAtendimento: Atendimento
  readonly editarCidadaoGarantiaAcesso: Scalars['ID']['output']
  readonly editarModeloPersonalizadoRelatorioGerencial?: Maybe<ModeloPersonalizado>
  readonly editarRegistroTardio: Atendimento
  readonly encerrarMinhasVideochamadas: Scalars['Boolean']['output']
  readonly encerrarVideochamada: Scalars['Boolean']['output']
  readonly enviarAtendimentoParaRetificacao: Scalars['Boolean']['output']
  readonly excluirAcesso: Scalars['ID']['output']
  readonly excluirAtendimento: Scalars['ID']['output']
  readonly excluirAtestadoModelo: Scalars['ID']['output']
  readonly excluirAtividadeColetiva: Scalars['Long']['output']
  readonly excluirCidadao: Scalars['ID']['output']
  readonly excluirCidadaoAtendimentoDomiciliar: Scalars['ID']['output']
  readonly excluirConfigAtendimentoDom: Scalars['ID']['output']
  readonly excluirConfiguracaoAgendaLotacao: Scalars['Boolean']['output']
  readonly excluirConfiguracaoCertificado: Scalars['ID']['output']
  readonly excluirFechamento?: Maybe<Scalars['ID']['output']>
  readonly excluirGrupoExame: Scalars['ID']['output']
  readonly excluirGrupoParticipanteAtividadeColetiva: Scalars['ID']['output']
  readonly excluirLotacao: Scalars['ID']['output']
  readonly excluirLoteImunobiologico?: Maybe<Scalars['ID']['output']>
  readonly excluirModeloPersonalizadoRelatorioGerencial?: Maybe<Scalars['Boolean']['output']>
  readonly excluirMunicipioResponsavel: Scalars['ID']['output']
  readonly excluirPerfil: ExcluirPerfilPayload
  readonly excluirProfissional: Scalars['ID']['output']
  readonly excluirTipoServico?: Maybe<Scalars['ID']['output']>
  readonly excluirTransmissaoLink: Scalars['ID']['output']
  readonly excluirVinculacaoServico?: Maybe<Scalars['Boolean']['output']>
  readonly exibirNotificacaoNovidades: Usuario
  readonly fixarAgenda: Scalars['Boolean']['output']
  readonly forcarRedefinirSenhas?: Maybe<ConfiguracaoRedefinicaoSenha>
  readonly gerarChaveAtivacaoAgendaOnline: Scalars['String']['output']
  readonly gerarLinkSistemaExterno?: Maybe<Scalars['String']['output']>
  readonly gerarLote: Scalars['Boolean']['output']
  readonly gerarRelatorioRndsCsv?: Maybe<Scalars['Boolean']['output']>
  readonly habilitarPainelChamadas: Scalars['Boolean']['output']
  readonly inativarAtendimento: Scalars['Boolean']['output']
  readonly inativarCredencialIntegracao: CredenciaIntegracao
  readonly inativarPerfil: Perfil
  readonly inativarSistemaExterno: SistemaExterno
  readonly informarCidadaoNaoAguardou: Atendimento
  readonly informarFaltaCidadao: Scalars['Boolean']['output']
  readonly iniciarUnificacaoBase: Scalars['Boolean']['output']
  readonly iniciarVideochamada: Scalars['String']['output']
  readonly inserirMunicipioResponsavel: AdministradorMunicipal
  readonly inserirTransmissaoLink: Scalars['ID']['output']
  readonly instalar: Scalars['Boolean']['output']
  readonly login: LoginPayload
  readonly logout?: Maybe<Sessao>
  readonly marcarBundlesComoNaoEnviado: Scalars['Boolean']['output']
  readonly marcarNotificacaoComoLida: Scalars['Boolean']['output']
  readonly marcarVisualizadoLembreteProfissional: LembreteProfissional
  readonly negarSolicitacao: Scalars['Boolean']['output']
  readonly notifyConexaoVideochamadaFalhou: Scalars['Boolean']['output']
  readonly notifyEntradaParticipanteVideochamada: Scalars['Boolean']['output']
  readonly notifySaidaDonoVideochamada: Scalars['Boolean']['output']
  readonly notifyVideochamadaLotada: Scalars['Boolean']['output']
  readonly parearDispositivoPainel: Scalars['Boolean']['output']
  readonly processAuditoria?: Maybe<Scalars['Boolean']['output']>
  readonly processarCidadaosTerritorio: Scalars['Boolean']['output']
  readonly processarTerritorio: Scalars['Boolean']['output']
  readonly reagendarLembreteProfissional: LembreteProfissional
  readonly realizarAtendimentoIndividual: Atendimento
  readonly realizarAtendimentoVacinacao: Atendimento
  readonly realizarEscutaInicial: Atendimento
  readonly reativarCidadao: Cidadao
  readonly recusarCadastro: Scalars['Boolean']['output']
  readonly redefinirSenha: Scalars['Boolean']['output']
  readonly redefinirSenhaAdminInstalacao: Scalars['Boolean']['output']
  readonly refazLoginExpirado?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly refreshTokenLogin: LoginPayload
  readonly removerAgendaFixada: Scalars['Boolean']['output']
  readonly removerCidadaoGarantiaAcesso: Scalars['ID']['output']
  readonly removerDispositivoPainel: Scalars['ID']['output']
  readonly removerFaltaCidadao: Scalars['Boolean']['output']
  readonly removerProcessoAssincrono: Scalars['Boolean']['output']
  readonly removerSalaUnidadeSaude: Scalars['ID']['output']
  readonly removerTodosProcessosAssincronos: Scalars['Boolean']['output']
  readonly removerUnidadeConsultaHorus: UnidadeSaude
  readonly responderPesquisaSatisfacao: Usuario
  readonly responderSolicitacaoEntradaVideochamada: Scalars['Boolean']['output']
  readonly reterritorializar: Scalars['Boolean']['output']
  readonly retificarAtendimento: Scalars['Long']['output']
  readonly retificarAtendimentoVacinacao: Scalars['Long']['output']
  readonly salvarAgendamentoConsulta: Scalars['ID']['output']
  readonly salvarAgendamentoConsultaCompartilhada: Scalars['ID']['output']
  readonly salvarAgendamentoReserva: ReadonlyArray<Scalars['ID']['output']>
  readonly salvarAtendimento: Atendimento
  readonly salvarAtendimentoIndividual: FinalizarAtendimentoIndividualResponse
  readonly salvarAtendimentoIndividualParaAprovacao: Scalars['Boolean']['output']
  readonly salvarAtendimentoVacinacao?: Maybe<AtendimentoVacinacao>
  readonly salvarAtendimentoVacinacaoParaAprovacao: Scalars['Boolean']['output']
  readonly salvarAtestadoModelo: AtestadoModelo
  readonly salvarAtividadeColetiva: Scalars['Long']['output']
  readonly salvarBatchVacinacao: MobileAppResponseVacinacao
  readonly salvarCidadao: Cidadao
  readonly salvarCidadaoAtencaoDomiciliar: AtencaoDomiciliarCidadao
  readonly salvarConfigAtendimentoDomTipoApoio: ConfiguracoesAtendimentosDomiciliares
  readonly salvarConfigAtendimentoDomTipoPodeAtender: ConfiguracoesAtendimentosDomiciliares
  readonly salvarConfiguracaoAgendaLotacao: Scalars['Boolean']['output']
  readonly salvarConfiguracaoAgendaOnlineLotacao: Scalars['Boolean']['output']
  readonly salvarConfiguracaoCertificado: ConfiguracaoCertificado
  readonly salvarConfiguracaoHorariosMunicipio?: Maybe<ConfiguracaoAgendaMunicipal>
  readonly salvarCredencialIntegracao: SalvarCredencialIntegracaoPayload
  readonly salvarCuidadoCompartilhado: CuidadoCompartilhado
  readonly salvarDuracaoAgendamentoAtencaoDom: DuracaoAgendamentoAtencaoDomDto
  readonly salvarEscutaInicial: AtendimentoProfissional
  readonly salvarEscutaInicialParaAprovacao: Scalars['Boolean']['output']
  readonly salvarFechamento?: Maybe<FechamentoAgenda>
  readonly salvarGrupoExame: GrupoExame
  readonly salvarGrupoParticipanteAtividadeColetiva: Scalars['ID']['output']
  readonly salvarImovel: Scalars['Boolean']['output']
  readonly salvarJustificativaAutomaticaVisualizarEscutaInicial: Scalars['ID']['output']
  readonly salvarJustificativaVisualizarProntuario: Scalars['ID']['output']
  readonly salvarLoteImunobiologico?: Maybe<LoteImunobiologico>
  readonly salvarModeloPersonalizadoRelatorioGerencial?: Maybe<ModeloPersonalizado>
  readonly salvarOutroAcesso: Acesso
  readonly salvarProfissional: Profissional
  readonly salvarProfissionalContraChave: Profissional
  readonly salvarRegistroTardio: Atendimento
  readonly salvarSistemaExterno: SalvarSistemaExternoPayload
  readonly salvarTipoServico?: Maybe<TipoServico>
  readonly salvarVinculacaoServico?: Maybe<Scalars['Boolean']['output']>
  readonly selecionarAcesso?: Maybe<Sessao>
  readonly setStatusLoteImunobiologico?: Maybe<Scalars['ID']['output']>
  readonly solicitarEntradaVideochamada: ParticipanteVideochamada
  readonly solicitarRecuperarSenha: Scalars['Boolean']['output']
  readonly solicitarRedefinicaoSenha: QrCode
  readonly testarConexaoAgendaOnline: TesteConexao
  readonly testarConexaoInternet?: Maybe<ConfiguracaoInternet>
  readonly testarConexaoLinkTransmissao: ResultadoTesteConexao
  readonly tornarLotacaoAtualResponsavelAtendimentoObservacao: Scalars['ID']['output']
  readonly tornarseExecutanteCuidadoCompartilhado: CuidadoCompartilhado
  readonly unificaCadastros: Scalars['Boolean']['output']
  readonly updateEstagio: Estagio
  readonly updateStatusAtivoGrupoParticipanteAtividadeColetiva: Scalars['ID']['output']
  readonly updateTransmissaoLink: Scalars['ID']['output']
  readonly validaContraChave: Scalars['Boolean']['output']
  readonly validarConfiguracaoCertificado: ReadonlyArray<Maybe<ServicosCertificadoEnum>>
  readonly visualizarCuidadoCompartilhado: Scalars['ID']['output']
  readonly visualizarNovidades: Scalars['Boolean']['output']
  readonly visualizarTodasNotificacoesByTipoTopico: Scalars['Long']['output']
}

export type MutationAceitarSolicitacaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationAcessoConecteSusArgs = {
  input: AcessoConecteSusInput
}

export type MutationAdicionarCidadaoGarantiaAcessoArgs = {
  input: GarantiaAcessoItemCreateInput
}

export type MutationAdicionarCidadaoGarantiaAcessoCeoArgs = {
  input: GarantiaAcessoItemCreateInput
}

export type MutationAdicionarUnidadeConsultaHorusArgs = {
  input: UnidadeConsultaHorusIds
}

export type MutationAgendarConsultaGarantiaAcessoArgs = {
  input: GarantiaAcessoAgendarConsultaInput
}

export type MutationAlterarAtivacaoAcessoArgs = {
  id: Scalars['ID']['input']
}

export type MutationAlterarBuscaCidadaoPorPropriedadesArgs = {
  habilitado: Scalars['Boolean']['input']
}

export type MutationAlterarCadsusArgs = {
  alterarCadsusInput: AlterarCadsusInput
}

export type MutationAlterarConfiguracaoAnexoArquivosArgs = {
  input: AlterarConfiguracaoAnexoArquivosInput
}

export type MutationAlterarConfiguracaoCadastroDomiciliarViaCdsArgs = {
  habilitado: Scalars['Boolean']['input']
}

export type MutationAlterarConfiguracaoCadastroIndividualViaCdsArgs = {
  habilitado: Scalars['Boolean']['input']
}

export type MutationAlterarConfiguracaoPrescricaoDigitalArgs = {
  input: AlterarConfiguracaoPrescricaoDigitalInput
}

export type MutationAlterarConfiguracaoVideochamadasArgs = {
  input: AlterarConfiguracaoVideochamadasInput
}

export type MutationAlterarDadosServidorArgs = {
  input: ConfiguracaoDadosServidorInput
}

export type MutationAlterarDuracaoCboArgs = {
  input: CboDuracaoFormInput
}

export type MutationAlterarDuracaoPadraoAtendimentoArgs = {
  duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput
}

export type MutationAlterarHorarioGeracaoLotesProcessamentoFichasArgs = {
  horario: Scalars['LocalTime']['input']
}

export type MutationAlterarHorusArgs = {
  alterarHorusInput: AlterarHorusInput
}

export type MutationAlterarLotacaoArgs = {
  input: AlterarLotacaoInput
}

export type MutationAlterarNumeroTentativasLoginArgs = {
  tentativas?: InputMaybe<Scalars['Int']['input']>
}

export type MutationAlterarPeriodoInatividadeArgs = {
  periodo?: InputMaybe<Scalars['Int']['input']>
}

export type MutationAlterarPeriodoRedefinicaoSenhaArgs = {
  periodo?: InputMaybe<Scalars['Int']['input']>
}

export type MutationAlterarQtdRequisicoesArgs = {
  qtdRequisicoesSimultaneas?: InputMaybe<Scalars['Int']['input']>
}

export type MutationAlterarSenhaAtualArgs = {
  input: AlterarSenhaAtualInput
}

export type MutationAlterarServidorSmtpArgs = {
  input: ConfiguracaoSmtpInput
}

export type MutationAlterarTipoServicoArgs = {
  input: TipoServicoUpdateInput
}

export type MutationAlterarUnidadePadraoHorusArgs = {
  input: UnidadeConsultaHorusIds
}

export type MutationAlternarInternetArgs = {
  habilitado?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationAlternarTransmissaoLinkArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarAgendaOnlineArgs = {
  ativacaoAgendaOnlineInput: AtivacaoAgendaOnlineInput
}

export type MutationAtivarPerfilArgs = {
  id: Scalars['ID']['input']
}

export type MutationAtivarTipoServicoArgs = {
  unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput
}

export type MutationAtualizarContatoCidadaoArgs = {
  input: AtualizarContatoCidadaoInput
}

export type MutationAtualizarEmailCidadaoArgs = {
  input: AtualizarEmailCidadaoInput
}

export type MutationAtualizarEnderecoTerritorioArgs = {
  input: AtualizarEnderecoTerritorioInput
}

export type MutationAtualizarMunicipioResponsavelArgs = {
  input: MunicipioResponsavelUpdateInput
}

export type MutationAtualizarPerfilArgs = {
  input: PerfilInput
}

export type MutationAuditCancelarAcompanhamentoCondicaoSaudeArgs = {
  input: AcompanhamentoCondicaoSaudeQueryInput
}

export type MutationAuditGerarDeclaracaoComparecimentoArgs = {
  atendimentoId: Scalars['ID']['input']
}

export type MutationAuditImpressaoEscutaInicialArgs = {
  atendProfId: Scalars['ID']['input']
}

export type MutationAuditaImpressaoOrientacaoArgs = {
  atendimentoId?: InputMaybe<Scalars['ID']['input']>
  orientacaoId?: InputMaybe<Scalars['ID']['input']>
  prontuarioId: Scalars['ID']['input']
}

export type MutationAutorizarMunicipioArgs = {
  input?: InputMaybe<AutorizarMunicipioInput>
}

export type MutationCadastrarEnderecoEnvioArgs = {
  input: InfoCadastroEnvioInput
}

export type MutationCancelarAgendamentoArgs = {
  input: CancelarAgendamentoInput
}

export type MutationCancelarAtendimentoArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationCancelarCidadaoNaoAguardouArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationCancelarSolicitacaoEntradaVideochamadaArgs = {
  input: CancelarSolicitacaoEntradaVideochamadaInput
}

export type MutationCancelarSolicitacaoEnvioArgs = {
  input: CancelarSolicitacaoEnvioInput
}

export type MutationChamarPainelArgs = {
  input: ChamarPainelInput
}

export type MutationCompartilharVideochamadaArgs = {
  input: CompartilharVideochamadaInput
}

export type MutationCreateCidadaoCadsusArgs = {
  input: SincronizaCidadaoCadsusInput
}

export type MutationCreateEstagioArgs = {
  input: EstagioCreateInput
}

export type MutationCriarLotacaoArgs = {
  input: LotacaoInput
}

export type MutationCriarPerfilArgs = {
  input: PerfilInput
}

export type MutationCriarSalaUnidadeSaudeArgs = {
  input: CriarSalaUnidadeSaudeInput
}

export type MutationDefinirModuloInicialArgs = {
  input: SelecionarModuloInicialInput
}

export type MutationDefinirSenhaProvisoriaArgs = {
  input: DefinirSenhaProvisoriaInput
}

export type MutationDeleteEstagioArgs = {
  estagioId: Scalars['ID']['input']
}

export type MutationDenifinirNovoAdministradorArgs = {
  input: ValidateNovoAdminInput
}

export type MutationDesabilitarPainelChamadasArgs = {
  unidadeSaudeId: Scalars['ID']['input']
}

export type MutationDesativarConfiguracaoAgendaOnlineLotacaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationDesativarTipoServicoArgs = {
  unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput
}

export type MutationDisponibilizarCboArgs = {
  input: CboDisponibilizarFormInput
}

export type MutationEditarAgendamentoConsultaArgs = {
  input: EditarAgendamentoConsultaInput
}

export type MutationEditarAgendamentoConsultaCompartilhadaArgs = {
  input: EditarAgendamentoConsultaCompartilhadaInput
}

export type MutationEditarAgendamentoReservaArgs = {
  input: EditarAgendamentoReservaInput
}

export type MutationEditarAtendimentoArgs = {
  input?: InputMaybe<AtendimentoEditInput>
}

export type MutationEditarCidadaoGarantiaAcessoArgs = {
  input: GarantiaAcessoItemUpdateInput
}

export type MutationEditarModeloPersonalizadoRelatorioGerencialArgs = {
  input: EditarModeloRelatorioGerencialInput
}

export type MutationEditarRegistroTardioArgs = {
  input: RegistroTardioInput
}

export type MutationEncerrarVideochamadaArgs = {
  videochamadaUuid: Scalars['String']['input']
}

export type MutationEnviarAtendimentoParaRetificacaoArgs = {
  atendimentoId: Scalars['ID']['input']
}

export type MutationExcluirAcessoArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirAtendimentoArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationExcluirAtestadoModeloArgs = {
  idModelo: Scalars['ID']['input']
}

export type MutationExcluirAtividadeColetivaArgs = {
  atividadeColetivaId: Scalars['Long']['input']
}

export type MutationExcluirCidadaoArgs = {
  cidadaoId: Scalars['ID']['input']
}

export type MutationExcluirCidadaoAtendimentoDomiciliarArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirConfigAtendimentoDomArgs = {
  idConfig: Scalars['ID']['input']
}

export type MutationExcluirConfiguracaoAgendaLotacaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirConfiguracaoCertificadoArgs = {
  configuracaoCertificadoId: Scalars['ID']['input']
}

export type MutationExcluirFechamentoArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirGrupoExameArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirGrupoParticipanteAtividadeColetivaArgs = {
  grupoParticipanteAtividadeColetivaId: Scalars['ID']['input']
}

export type MutationExcluirLotacaoArgs = {
  lotacaoId: Scalars['ID']['input']
}

export type MutationExcluirLoteImunobiologicoArgs = {
  idLote: Scalars['ID']['input']
}

export type MutationExcluirModeloPersonalizadoRelatorioGerencialArgs = {
  input: ExcluirModeloRelatorioGerencialInput
}

export type MutationExcluirMunicipioResponsavelArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirPerfilArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirProfissionalArgs = {
  profissionalId: Scalars['ID']['input']
}

export type MutationExcluirTipoServicoArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirTransmissaoLinkArgs = {
  id: Scalars['ID']['input']
}

export type MutationExcluirVinculacaoServicoArgs = {
  referenciaId: Scalars['Long']['input']
}

export type MutationFixarAgendaArgs = {
  lotacaoId: Scalars['ID']['input']
}

export type MutationGerarLinkSistemaExternoArgs = {
  input: GerarLinkSistemaExternoInput
}

export type MutationGerarRelatorioRndsCsvArgs = {
  input: GerarRelatorioRndsCsvInput
}

export type MutationHabilitarPainelChamadasArgs = {
  unidadeSaudeId: Scalars['ID']['input']
}

export type MutationInativarAtendimentoArgs = {
  input: InativarAtendimentoInput
}

export type MutationInativarCredencialIntegracaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarPerfilArgs = {
  id: Scalars['ID']['input']
}

export type MutationInativarSistemaExternoArgs = {
  id: Scalars['ID']['input']
}

export type MutationInformarCidadaoNaoAguardouArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationInformarFaltaCidadaoArgs = {
  agendamentoId: Scalars['ID']['input']
}

export type MutationIniciarVideochamadaArgs = {
  input: IniciarVideochamadaInput
}

export type MutationInserirMunicipioResponsavelArgs = {
  input: MunicipioResponsavelInput
}

export type MutationInserirTransmissaoLinkArgs = {
  form: TransmissaoLinkInsertDto
}

export type MutationInstalarArgs = {
  input: InstalacaoInput
}

export type MutationLoginArgs = {
  input: LoginInput
}

export type MutationMarcarBundlesComoNaoEnviadoArgs = {
  atendProfId: Scalars['ID']['input']
}

export type MutationMarcarNotificacaoComoLidaArgs = {
  codigoExterno: Scalars['ID']['input']
  tipoTopico: TipoTopicoNotificacaoEnum
}

export type MutationMarcarVisualizadoLembreteProfissionalArgs = {
  id: Scalars['ID']['input']
}

export type MutationNegarSolicitacaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationNotifyConexaoVideochamadaFalhouArgs = {
  videochamadaUuid: Scalars['String']['input']
}

export type MutationNotifyEntradaParticipanteVideochamadaArgs = {
  nomeParticipante: Scalars['String']['input']
  participanteId: Scalars['ID']['input']
  videochamadaUuid: Scalars['String']['input']
}

export type MutationNotifySaidaDonoVideochamadaArgs = {
  videochamadaUuid: Scalars['String']['input']
}

export type MutationNotifyVideochamadaLotadaArgs = {
  lotada: Scalars['Boolean']['input']
  videochamadaUuid: Scalars['String']['input']
}

export type MutationParearDispositivoPainelArgs = {
  input: ParearDispositivoPainelInput
}

export type MutationProcessAuditoriaArgs = {
  input: AuditoriaInput
}

export type MutationProcessarCidadaosTerritorioArgs = {
  cidadaosIds: ReadonlyArray<Scalars['ID']['input']>
}

export type MutationProcessarTerritorioArgs = {
  imovelId: Scalars['ID']['input']
}

export type MutationReagendarLembreteProfissionalArgs = {
  input: ReagendarLembreteProfissionalInput
}

export type MutationRealizarAtendimentoIndividualArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationRealizarAtendimentoVacinacaoArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationRealizarEscutaInicialArgs = {
  atendimento: Scalars['ID']['input']
}

export type MutationReativarCidadaoArgs = {
  cidadaoId: Scalars['ID']['input']
}

export type MutationRecusarCadastroArgs = {
  cidadaoId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationRedefinirSenhaArgs = {
  input: RedefinirSenhaInput
}

export type MutationRedefinirSenhaAdminInstalacaoArgs = {
  input: RedefinirSenhaAdminInstalacaoInput
}

export type MutationRefazLoginExpiradoArgs = {
  senha: Scalars['String']['input']
}

export type MutationRefreshTokenLoginArgs = {
  token: Scalars['String']['input']
}

export type MutationRemoverAgendaFixadaArgs = {
  lotacaoId: Scalars['ID']['input']
}

export type MutationRemoverCidadaoGarantiaAcessoArgs = {
  input: GarantiaAcessoItemDeleteInput
}

export type MutationRemoverDispositivoPainelArgs = {
  id: Scalars['ID']['input']
}

export type MutationRemoverFaltaCidadaoArgs = {
  agendamentoId: Scalars['ID']['input']
}

export type MutationRemoverProcessoAssincronoArgs = {
  asyncProcessingName?: InputMaybe<AsyncProcessingNameEnum>
}

export type MutationRemoverSalaUnidadeSaudeArgs = {
  id: Scalars['ID']['input']
}

export type MutationRemoverUnidadeConsultaHorusArgs = {
  input: UnidadeConsultaHorusIds
}

export type MutationResponderPesquisaSatisfacaoArgs = {
  input: RespostaPesquisa
}

export type MutationResponderSolicitacaoEntradaVideochamadaArgs = {
  input: ResponderSolicitacaoEntradaVideochamadaInput
}

export type MutationReterritorializarArgs = {
  input: ReterritorializarInput
}

export type MutationRetificarAtendimentoArgs = {
  input: RetificacaoAtendimentoInput
}

export type MutationRetificarAtendimentoVacinacaoArgs = {
  input: RetificacaoAtendimentoVacinacaoInput
}

export type MutationSalvarAgendamentoConsultaArgs = {
  input: CriarAgendamentoConsultaInput
}

export type MutationSalvarAgendamentoConsultaCompartilhadaArgs = {
  input: CriarAgendamentoConsultaCompartilhadaInput
}

export type MutationSalvarAgendamentoReservaArgs = {
  input: CriarAgendamentoReservaInput
}

export type MutationSalvarAtendimentoArgs = {
  input: AtendimentoInput
}

export type MutationSalvarAtendimentoIndividualArgs = {
  input: AtendimentoIndividualInput
}

export type MutationSalvarAtendimentoIndividualParaAprovacaoArgs = {
  input: AtendimentoIndividualAprovacaoInput
}

export type MutationSalvarAtendimentoVacinacaoArgs = {
  input: AtendimentoVacinacaoInput
}

export type MutationSalvarAtendimentoVacinacaoParaAprovacaoArgs = {
  input: AtendimentoVacinacaoAprovacaoInput
}

export type MutationSalvarAtestadoModeloArgs = {
  input: AtestadoModeloInput
}

export type MutationSalvarAtividadeColetivaArgs = {
  input: AtividadeColetivaInput
}

export type MutationSalvarBatchVacinacaoArgs = {
  input: MobileAppRequestVacinacaoInput
}

export type MutationSalvarCidadaoArgs = {
  input: CidadaoInput
}

export type MutationSalvarCidadaoAtencaoDomiciliarArgs = {
  input: AtencaoDomiciliarCidadaoInput
}

export type MutationSalvarConfigAtendimentoDomTipoApoioArgs = {
  input: ConfigAtendimentoDomInput
}

export type MutationSalvarConfigAtendimentoDomTipoPodeAtenderArgs = {
  input: ConfigAtendimentoDomInput
}

export type MutationSalvarConfiguracaoAgendaLotacaoArgs = {
  configuracaoAgendaLotacaoInput: ConfiguracaoAgendaLotacaoInput
}

export type MutationSalvarConfiguracaoAgendaOnlineLotacaoArgs = {
  configuracaoAgendaOnlineLotacaoInput: ConfiguracaoAgendaOnlineLotacaoInput
}

export type MutationSalvarConfiguracaoCertificadoArgs = {
  configuracaoCertificadoInput: ConfiguracaoCertificadoInput
}

export type MutationSalvarConfiguracaoHorariosMunicipioArgs = {
  configuracaoAgendaMunicipalInput?: InputMaybe<ConfiguracaoAgendaMunicipalInput>
}

export type MutationSalvarCredencialIntegracaoArgs = {
  input: CredencialIntegracaoInput
}

export type MutationSalvarCuidadoCompartilhadoArgs = {
  input: SalvarCuidadoCompartilhadoInput
}

export type MutationSalvarDuracaoAgendamentoAtencaoDomArgs = {
  input: DuracaoAgendamentoAtencaoDomInput
}

export type MutationSalvarEscutaInicialArgs = {
  input: EscutaInicialInput
}

export type MutationSalvarEscutaInicialParaAprovacaoArgs = {
  input: EscutaInicialAprovacaoInput
}

export type MutationSalvarFechamentoArgs = {
  input: FechamentoAgendaInput
}

export type MutationSalvarGrupoExameArgs = {
  input: GrupoExameInput
}

export type MutationSalvarGrupoParticipanteAtividadeColetivaArgs = {
  input: GrupoParticipanteAtividadeColetivaInput
}

export type MutationSalvarImovelArgs = {
  input: ImovelInput
}

export type MutationSalvarJustificativaAutomaticaVisualizarEscutaInicialArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type MutationSalvarJustificativaVisualizarProntuarioArgs = {
  input: JustificativaVisualizarProntuarioInput
}

export type MutationSalvarLoteImunobiologicoArgs = {
  input: LoteImunobiologicoInput
}

export type MutationSalvarModeloPersonalizadoRelatorioGerencialArgs = {
  input: SalvarModeloRelatorioGerencialInput
}

export type MutationSalvarOutroAcessoArgs = {
  input: OutroAcessoInput
}

export type MutationSalvarProfissionalArgs = {
  input: ProfissionalInput
}

export type MutationSalvarProfissionalContraChaveArgs = {
  input: ProfissionalContraChaveInput
}

export type MutationSalvarRegistroTardioArgs = {
  input: RegistroTardioInput
}

export type MutationSalvarSistemaExternoArgs = {
  input: SalvarSistemaExternoInput
}

export type MutationSalvarTipoServicoArgs = {
  input: TipoServicoInput
}

export type MutationSalvarVinculacaoServicoArgs = {
  input: SalvarVinculacaoServicoInput
}

export type MutationSelecionarAcessoArgs = {
  input: SelecionarAcessoInput
}

export type MutationSetStatusLoteImunobiologicoArgs = {
  input: LoteImunobiologicoInput
  status?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSolicitarEntradaVideochamadaArgs = {
  input: SolicitarEntradaVideochamadaInput
}

export type MutationSolicitarRecuperarSenhaArgs = {
  input?: InputMaybe<SolicitarRecuperacaoSenhaInput>
}

export type MutationSolicitarRedefinicaoSenhaArgs = {
  input: SolicitarRecuperacaoSenhaInput
}

export type MutationTestarConexaoLinkTransmissaoArgs = {
  id: Scalars['ID']['input']
}

export type MutationTornarLotacaoAtualResponsavelAtendimentoObservacaoArgs = {
  atendimentoId: Scalars['ID']['input']
}

export type MutationTornarseExecutanteCuidadoCompartilhadoArgs = {
  id: Scalars['ID']['input']
}

export type MutationUnificaCadastrosArgs = {
  input: UnificacaoCadastroInput
}

export type MutationUpdateEstagioArgs = {
  input: EstagioUpdateInput
}

export type MutationUpdateStatusAtivoGrupoParticipanteAtividadeColetivaArgs = {
  ativo: Scalars['Boolean']['input']
  grupoParticipanteAtividadeColetivaId: Scalars['ID']['input']
}

export type MutationUpdateTransmissaoLinkArgs = {
  form: TransmissaoLinkUpdateDto
}

export type MutationValidaContraChaveArgs = {
  input?: InputMaybe<AutorizarMunicipioInput>
}

export type MutationValidarConfiguracaoCertificadoArgs = {
  configuracaoCertificadoInput: ConfiguracaoCertificadoInput
}

export type MutationVisualizarCuidadoCompartilhadoArgs = {
  input: VisualizarCuidadoCompartilhadoInput
}

export type MutationVisualizarTodasNotificacoesByTipoTopicoArgs = {
  tipoTopico: TipoTopicoNotificacaoEnum
}

export type Nacionalidade = {
  readonly __typename?: 'Nacionalidade'
  readonly id: Scalars['ID']['output']
  readonly nacionalidadeDbEnum: NacionalidadeEnum
  readonly nome: Scalars['String']['output']
}

export enum NacionalidadeEnum {
  BRASILEIRA = 'BRASILEIRA',
  ESTRANGEIRA = 'ESTRANGEIRA',
  NATURALIZADA = 'NATURALIZADA',
}

export type NeuroAlteracaoFenotipicaDetalhe = {
  readonly __typename?: 'NeuroAlteracaoFenotipicaDetalhe'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
}

export type NeuroAlteracaoFenotipicaEvolucao = {
  readonly __typename?: 'NeuroAlteracaoFenotipicaEvolucao'
  readonly alteracaoFenotipicaDetalhe?: Maybe<NeuroAlteracaoFenotipicaDetalhe>
  readonly id: Scalars['ID']['output']
  readonly statusAvaliacao?: Maybe<StatusAvaliadoEnum>
}

export type NeuroFaixaEtaria = {
  readonly __typename?: 'NeuroFaixaEtaria'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
}

export enum NeuroFaixaEtariaEnum {
  MES_1 = 'MES_1',
  MES_2 = 'MES_2',
  MES_3_AO_4 = 'MES_3_AO_4',
  MES_5_AO_6 = 'MES_5_AO_6',
  MES_7_AO_9 = 'MES_7_AO_9',
  MES_10_AO_12 = 'MES_10_AO_12',
  MES_13_AO_15 = 'MES_13_AO_15',
  MES_16_AO_18 = 'MES_16_AO_18',
  MES_19_AO_24 = 'MES_19_AO_24',
  MES_25_AO_30 = 'MES_25_AO_30',
  MES_31_AO_36 = 'MES_31_AO_36',
  MES_37_AO_42 = 'MES_37_AO_42',
  MES_43_AO_48 = 'MES_43_AO_48',
  MES_49_AO_54 = 'MES_49_AO_54',
  MES_55_AO_60 = 'MES_55_AO_60',
  MES_61_AO_66 = 'MES_61_AO_66',
  MES_67_AO_72 = 'MES_67_AO_72',
  PRIMEIROS_15_DIAS = 'PRIMEIROS_15_DIAS',
}

export type NeuroFatorRiscoDetalhe = {
  readonly __typename?: 'NeuroFatorRiscoDetalhe'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
}

export type NeuroFatorRiscoEvolucao = {
  readonly __typename?: 'NeuroFatorRiscoEvolucao'
  readonly fatorRiscoDetalhe?: Maybe<NeuroFatorRiscoDetalhe>
  readonly id: Scalars['ID']['output']
  readonly statusAvaliacao?: Maybe<StatusAvaliadoEnum>
}

export type NeuroMarcoDetalhe = {
  readonly __typename?: 'NeuroMarcoDetalhe'
  readonly faixaEtaria?: Maybe<NeuroFaixaEtaria>
  readonly id: Scalars['ID']['output']
  readonly titulo?: Maybe<Scalars['String']['output']>
}

export type NeuroMarcoEvolucao = {
  readonly __typename?: 'NeuroMarcoEvolucao'
  readonly anosIdadeRegistro?: Maybe<Scalars['Int']['output']>
  readonly id: Scalars['ID']['output']
  readonly marcoDetalhe?: Maybe<NeuroMarcoDetalhe>
  readonly mesesIdadeRegistro?: Maybe<Scalars['Int']['output']>
  readonly statusAvaliacao?: Maybe<StatusAvaliadoEnum>
}

export enum NivelDetalheSerieHistoricaEnum {
  CATEGORIA_PROFISSIONAL = 'CATEGORIA_PROFISSIONAL',
  EQUIPE = 'EQUIPE',
  MUNICIPIO = 'MUNICIPIO',
  PROFISSIONAL = 'PROFISSIONAL',
  UNIDADE_SAUDE = 'UNIDADE_SAUDE',
}

export enum NivelProducaoEnum {
  MINHAS_PRODUCOES = 'MINHAS_PRODUCOES',
  MINHA_EQUIPE = 'MINHA_EQUIPE',
}

export type NodoLoteEnvio = {
  readonly __typename?: 'NodoLoteEnvio'
  readonly dataEnvio?: Maybe<Scalars['Instant']['output']>
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly nodeNome: Scalars['String']['output']
  readonly statusEnvio: StatusEnvio
}

export type NomesInstalacoesUnificacaoDto = {
  readonly __typename?: 'NomesInstalacoesUnificacaoDto'
  readonly nomeInstalacaoCentral?: Maybe<Scalars['String']['output']>
  readonly nomesInstalacoesUnificadas?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
}

export type NomesProfissionaisAgendamentosConflitantes = {
  readonly __typename?: 'NomesProfissionaisAgendamentosConflitantes'
  readonly horarioAgendamentoConflitante: Scalars['Instant']['output']
  readonly nomesProfissionais: ReadonlyArray<Scalars['String']['output']>
}

export type ObjetivoInput = {
  readonly anexoArquivos?: InputMaybe<ReadonlyArray<AnexoArquivoInput>>
  readonly ivcf?: InputMaybe<IvcfInput>
  readonly marcadoresConsumoAlimentar?: InputMaybe<MarcadoresConsumoAlimentarInput>
  readonly medicoes?: InputMaybe<MedicoesInput>
  readonly necessidadesEspeciais?: InputMaybe<Scalars['Boolean']['input']>
  readonly puericultura?: InputMaybe<PuericulturaInput>
  readonly resultadosExame?: InputMaybe<ReadonlyArray<ResultadoExameInput>>
  readonly texto?: InputMaybe<Scalars['String']['input']>
}

export type Odontograma = {
  readonly __typename?: 'Odontograma'
  readonly aparelho?: Maybe<Scalars['Boolean']['output']>
  readonly atendimentoProfissionalOdonto: AtendimentoProfissionalOdonto
  readonly contencao?: Maybe<Scalars['Boolean']['output']>
  readonly evolucoesDente?: Maybe<ReadonlyArray<Maybe<EvolucaoDente>>>
  readonly id: Scalars['ID']['output']
  readonly proteseTotalInferior?: Maybe<Scalars['Boolean']['output']>
  readonly proteseTotalSuperior?: Maybe<Scalars['Boolean']['output']>
}

export type OdontogramasPayload = {
  readonly __typename?: 'OdontogramasPayload'
  readonly content: ReadonlyArray<Maybe<Odontograma>>
  readonly pageInfo: PageInfo
}

export type OdontogramasQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId?: InputMaybe<Scalars['ID']['input']>
}

export type OdontologiaInput = {
  readonly aparelho?: InputMaybe<Scalars['Boolean']['input']>
  readonly contencao?: InputMaybe<Scalars['Boolean']['input']>
  readonly evolucoesDente?: InputMaybe<ReadonlyArray<InputMaybe<EvolucaoDenteInput>>>
  readonly evolucoesProcedimentoOdonto?: InputMaybe<ReadonlyArray<InputMaybe<EvolucaoProcedimentoOdontoInput>>>
  readonly periodontia?: InputMaybe<PeriodontiaInput>
  readonly proteseTotalInferior?: InputMaybe<Scalars['Boolean']['input']>
  readonly proteseTotalSuperior?: InputMaybe<Scalars['Boolean']['input']>
  readonly tecidosMoles?: InputMaybe<ReadonlyArray<InputMaybe<TecidoMoleInput>>>
}

export enum OpcaoSelecionadaRelatorioGerencialEnum {
  OUTRO = 'OUTRO',
  PRIMEIRA = 'PRIMEIRA',
  SEGUNDA = 'SEGUNDA',
  TERCEIRA = 'TERCEIRA',
}

export enum OpcaoTipoPerguntaEnum {
  ALMOCO = 'ALMOCO',
  AMASSADA = 'AMASSADA',
  CAFE_DA_MANHA = 'CAFE_DA_MANHA',
  CEIA = 'CEIA',
  DUAS_VEZES = 'DUAS_VEZES',
  EM_PEDACOS = 'EM_PEDACOS',
  JANTAR = 'JANTAR',
  LANCHE_DA_MANHA = 'LANCHE_DA_MANHA',
  LANCHE_DA_TARDE = 'LANCHE_DA_TARDE',
  LIQUIDIFICADA = 'LIQUIDIFICADA',
  NAO = 'NAO',
  NAO_SABE = 'NAO_SABE',
  PASSADA_NA_PENEIRA = 'PASSADA_NA_PENEIRA',
  SIM = 'SIM',
  SO_O_CALDO = 'SO_O_CALDO',
  TRES_VEZES_OU_MAIS = 'TRES_VEZES_OU_MAIS',
  UMA_VEZ = 'UMA_VEZ',
}

export enum OpcoesResultadoExameQualitativoEnum {
  PROVA_LACO_INCONCLUSIVO = 'PROVA_LACO_INCONCLUSIVO',
  PROVA_LACO_NEGATIVO = 'PROVA_LACO_NEGATIVO',
  PROVA_LACO_POSITIVO = 'PROVA_LACO_POSITIVO',
}

export type OptionalPageParams = {
  readonly page?: InputMaybe<PageParams>
  readonly unpaged?: InputMaybe<Scalars['Boolean']['input']>
}

export enum OrdemListaAtendimentoEnum {
  CLASSIFICACAO_RISCO = 'CLASSIFICACAO_RISCO',
  ORDEM_CHEGADA_CRESCENTE = 'ORDEM_CHEGADA_CRESCENTE',
  ORDEM_CHEGADA_DECRESCENTE = 'ORDEM_CHEGADA_DECRESCENTE',
}

export enum OrdemRegulacaoEnum {
  ATUALIZACOES_REGULACAO_MAIS_ANTIGAS = 'ATUALIZACOES_REGULACAO_MAIS_ANTIGAS',
  ATUALIZACOES_REGULACAO_MAIS_RECENTES = 'ATUALIZACOES_REGULACAO_MAIS_RECENTES',
  PRIORIDADE_CRESCENTE = 'PRIORIDADE_CRESCENTE',
  PRIORIDADE_DECRESCENTE = 'PRIORIDADE_DECRESCENTE',
  SOLICITACOES_MAIS_ANTIGAS = 'SOLICITACOES_MAIS_ANTIGAS',
  SOLICITACOES_MAIS_RECENTES = 'SOLICITACOES_MAIS_RECENTES',
}

export type Orientacao = {
  readonly __typename?: 'Orientacao'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export type OrientacaoPlanoInput = {
  readonly descricao: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
}

export type OrientacaoQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export enum OrientacaoSexualEnum {
  ASSEXUAL = 'ASSEXUAL',
  BISSEXUAL = 'BISSEXUAL',
  GAY = 'GAY',
  HETEROSSEXUAL = 'HETEROSSEXUAL',
  HOMOSSEXUAL = 'HOMOSSEXUAL',
  LESBICA = 'LESBICA',
  OUTRO_ORIENTACAO_SEXUAL = 'OUTRO_ORIENTACAO_SEXUAL',
  PANSEXUAL = 'PANSEXUAL',
}

export enum OrigemAgendamentoEnum {
  ATENCAO_DOMICILIAR = 'ATENCAO_DOMICILIAR',
  MEUDIGISUS = 'MEUDIGISUS',
  PEC = 'PEC',
  PEC_AUTOMATICO = 'PEC_AUTOMATICO',
}

export enum OrigemAlimentacaoEnum {
  DOACAO_DE_POPULAR = 'DOACAO_DE_POPULAR',
  DOACAO_GRUPO_RELIGIOSO = 'DOACAO_GRUPO_RELIGIOSO',
  DOACAO_RESTAURANTE = 'DOACAO_RESTAURANTE',
  OUTROS_ORIGEM_ALIMENTACAO = 'OUTROS_ORIGEM_ALIMENTACAO',
  RESTAURANTE_POPULAR = 'RESTAURANTE_POPULAR',
}

export enum OrigemDadoEnum {
  AC = 'AC',
  AD = 'AD',
  APP_VACINACAO = 'APP_VACINACAO',
  CDS = 'CDS',
  PEC = 'PEC',
  RAS_PEC = 'RAS_PEC',
  RES = 'RES',
  SISTEMA_TERCEIRO = 'SISTEMA_TERCEIRO',
  TERRITORIO = 'TERRITORIO',
}

export type OutroAcessoInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly municipio?: InputMaybe<Scalars['ID']['input']>
  readonly perfis: ReadonlyArray<Scalars['ID']['input']>
  readonly profissional: Scalars['ID']['input']
  readonly tipo: TipoAcesso
  readonly uf?: InputMaybe<Scalars['ID']['input']>
}

export type PageInfo = {
  readonly __typename?: 'PageInfo'
  readonly first: Scalars['Boolean']['output']
  readonly last: Scalars['Boolean']['output']
  readonly number: Scalars['Int']['output']
  readonly numberOfElements: Scalars['Int']['output']
  readonly size: Scalars['Int']['output']
  readonly sort?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly totalElements: Scalars['Int']['output']
  readonly totalPages: Scalars['Int']['output']
}

export type PageParams = {
  readonly fetchPageInfo?: InputMaybe<Scalars['Boolean']['input']>
  readonly page?: InputMaybe<Scalars['Int']['input']>
  readonly size?: InputMaybe<Scalars['Int']['input']>
  readonly sort?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
}

export type Pais = {
  readonly __typename?: 'Pais'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type PaisQueryInput = {
  readonly omiteBrasil?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type PaisQueryPayload = {
  readonly __typename?: 'PaisQueryPayload'
  readonly content: ReadonlyArray<Maybe<Pais>>
  readonly pageInfo: PageInfo
}

export type ParearDispositivoPainelInput = {
  readonly nome: Scalars['String']['input']
  readonly pinUsuario: Scalars['String']['input']
  readonly unidadeSaudeId: Scalars['ID']['input']
}

export type ParteBucal = {
  readonly __typename?: 'ParteBucal'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly parteBucalEnum: ParteBucalEnum
  readonly tipoParteBucal: TipoParteBucalEnum
}

export enum ParteBucalEnum {
  AMIDALA = 'AMIDALA',
  ARCADA_INFERIOR = 'ARCADA_INFERIOR',
  ARCADA_SUPERIOR = 'ARCADA_SUPERIOR',
  ARTICULACAO_TEMPORO_MANDIBULAS = 'ARTICULACAO_TEMPORO_MANDIBULAS',
  ASSOALHO_BUCAL = 'ASSOALHO_BUCAL',
  BOCA = 'BOCA',
  COMISSURA_LABIAL = 'COMISSURA_LABIAL',
  DENTE_11 = 'DENTE_11',
  DENTE_12 = 'DENTE_12',
  DENTE_13 = 'DENTE_13',
  DENTE_14 = 'DENTE_14',
  DENTE_15 = 'DENTE_15',
  DENTE_16 = 'DENTE_16',
  DENTE_17 = 'DENTE_17',
  DENTE_18 = 'DENTE_18',
  DENTE_21 = 'DENTE_21',
  DENTE_22 = 'DENTE_22',
  DENTE_23 = 'DENTE_23',
  DENTE_24 = 'DENTE_24',
  DENTE_25 = 'DENTE_25',
  DENTE_26 = 'DENTE_26',
  DENTE_27 = 'DENTE_27',
  DENTE_28 = 'DENTE_28',
  DENTE_31 = 'DENTE_31',
  DENTE_32 = 'DENTE_32',
  DENTE_33 = 'DENTE_33',
  DENTE_34 = 'DENTE_34',
  DENTE_35 = 'DENTE_35',
  DENTE_36 = 'DENTE_36',
  DENTE_37 = 'DENTE_37',
  DENTE_38 = 'DENTE_38',
  DENTE_41 = 'DENTE_41',
  DENTE_42 = 'DENTE_42',
  DENTE_43 = 'DENTE_43',
  DENTE_44 = 'DENTE_44',
  DENTE_45 = 'DENTE_45',
  DENTE_46 = 'DENTE_46',
  DENTE_47 = 'DENTE_47',
  DENTE_48 = 'DENTE_48',
  DENTE_51 = 'DENTE_51',
  DENTE_52 = 'DENTE_52',
  DENTE_53 = 'DENTE_53',
  DENTE_54 = 'DENTE_54',
  DENTE_55 = 'DENTE_55',
  DENTE_61 = 'DENTE_61',
  DENTE_62 = 'DENTE_62',
  DENTE_63 = 'DENTE_63',
  DENTE_64 = 'DENTE_64',
  DENTE_65 = 'DENTE_65',
  DENTE_71 = 'DENTE_71',
  DENTE_72 = 'DENTE_72',
  DENTE_73 = 'DENTE_73',
  DENTE_74 = 'DENTE_74',
  DENTE_75 = 'DENTE_75',
  DENTE_81 = 'DENTE_81',
  DENTE_82 = 'DENTE_82',
  DENTE_83 = 'DENTE_83',
  DENTE_84 = 'DENTE_84',
  DENTE_85 = 'DENTE_85',
  DENTE_SUPRANUMERARIO = 'DENTE_SUPRANUMERARIO',
  FRENULO_LABIAL = 'FRENULO_LABIAL',
  FRENULO_LINGUAL = 'FRENULO_LINGUAL',
  GENGIVA = 'GENGIVA',
  GLANDULAS_SALIVARES = 'GLANDULAS_SALIVARES',
  LABIO_INFERIOR = 'LABIO_INFERIOR',
  LABIO_SUPERIOR = 'LABIO_SUPERIOR',
  LINGUA = 'LINGUA',
  MANDIBULA = 'MANDIBULA',
  MAXILA = 'MAXILA',
  MUCOSA_ALVEOLAR = 'MUCOSA_ALVEOLAR',
  MUCOSA_JUGAL = 'MUCOSA_JUGAL',
  OUTROS = 'OUTROS',
  PALATO_DURO = 'PALATO_DURO',
  PALATO_MOLE = 'PALATO_MOLE',
  REGIAO_RETROMOLAR = 'REGIAO_RETROMOLAR',
  SEXTANTE_S1 = 'SEXTANTE_S1',
  SEXTANTE_S2 = 'SEXTANTE_S2',
  SEXTANTE_S3 = 'SEXTANTE_S3',
  SEXTANTE_S4 = 'SEXTANTE_S4',
  SEXTANTE_S5 = 'SEXTANTE_S5',
  SEXTANTE_S6 = 'SEXTANTE_S6',
  UVULA = 'UVULA',
}

export type PartesBucaisPayload = {
  readonly __typename?: 'PartesBucaisPayload'
  readonly content: ReadonlyArray<Maybe<ParteBucal>>
  readonly pageInfo: PageInfo
}

export type PartesBucaisQueryInput = {
  readonly pageParams?: InputMaybe<OptionalPageParams>
  readonly procedimentos?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly tiposPartesBucais?: InputMaybe<ReadonlyArray<InputMaybe<TipoParteBucalEnum>>>
}

export type ParticipanteVideochamada = {
  readonly __typename?: 'ParticipanteVideochamada'
  readonly cpf: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type PedidoEnvioBase = {
  readonly __typename?: 'PedidoEnvioBase'
  readonly chaveAutenticacao?: Maybe<Scalars['String']['output']>
  readonly dataFimUnificacao?: Maybe<Scalars['Instant']['output']>
  readonly dataSolicitacao: Scalars['Instant']['output']
  readonly id?: Maybe<Scalars['ID']['output']>
  readonly linkInstalacao: Scalars['String']['output']
  readonly loginAtivo: Scalars['Boolean']['output']
  readonly nomeInstalacao: Scalars['String']['output']
  readonly status: StatusPedidoEnvioEnum
}

export type Perfil = {
  readonly __typename?: 'Perfil'
  readonly actions: PerfilActions
  readonly ativo: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly perfilPadrao?: Maybe<Scalars['String']['output']>
  readonly recursos: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly tipoPerfil: TipoAcesso
}

export type PerfilActions = {
  readonly __typename?: 'PerfilActions'
  readonly excluir: Action
}

export type PerfilInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly nome: Scalars['String']['input']
  readonly recursos?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>
  readonly tipoPerfil: TipoAcesso
}

export type PerfisQueryInput = {
  readonly mostrarInativos?: InputMaybe<Scalars['Boolean']['input']>
  readonly mostrarQualquerLocalidade?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tipoAcesso?: InputMaybe<TipoAcesso>
}

export type PerfisQueryPayload = {
  readonly __typename?: 'PerfisQueryPayload'
  readonly content: ReadonlyArray<Maybe<Perfil>>
  readonly pageInfo: PageInfo
}

export type PerguntaCuidadoCompartilhadoInput = {
  readonly pergunta: Scalars['String']['input']
}

export enum PerguntaSaidaCadastroEnum {
  SAIDA_CIDADAO_MUDANCA_TERRITORIO = 'SAIDA_CIDADAO_MUDANCA_TERRITORIO',
  SAIDA_CIDADAO_OBITO = 'SAIDA_CIDADAO_OBITO',
}

export enum PerguntasQuestionarioEnum {
  AGUA_CHA = 'AGUA_CHA',
  ARROZ_BATATA_INHAME_AIPIM = 'ARROZ_BATATA_INHAME_AIPIM',
  BEBIDAS_ADOCADAS_6MESES_2ANOS = 'BEBIDAS_ADOCADAS_6MESES_2ANOS',
  BEBIDAS_ADOCADAS_MAIOR_2ANOS = 'BEBIDAS_ADOCADAS_MAIOR_2ANOS',
  BISCOITO_RECHEADO_DOCES_GULOSEIMAS_6MESES_2ANOS = 'BISCOITO_RECHEADO_DOCES_GULOSEIMAS_6MESES_2ANOS',
  BISCOITO_RECHEADO_DOCES_GULOSEIMAS_MAIOR_2ANOS = 'BISCOITO_RECHEADO_DOCES_GULOSEIMAS_MAIOR_2ANOS',
  CARNE = 'CARNE',
  COMIDA_SAL = 'COMIDA_SAL',
  CRIANCA_ONTEM_TOMOU_LEITE_PEITO = 'CRIANCA_ONTEM_TOMOU_LEITE_PEITO',
  CRIANCA_ONTEM_TOMOU_LEITE_PEITO_2 = 'CRIANCA_ONTEM_TOMOU_LEITE_PEITO_2',
  FEIJAO_6MESES_2ANOS = 'FEIJAO_6MESES_2ANOS',
  FEIJAO_MAIOR_2ANOS = 'FEIJAO_MAIOR_2ANOS',
  FIGADO = 'FIGADO',
  FORMULA_INFANTIL = 'FORMULA_INFANTIL',
  FRUTA = 'FRUTA',
  FRUTAS_FRESCAS = 'FRUTAS_FRESCAS',
  HAMBURGUER_E_OU_EMBUTIDOS_6MESES_2ANOS = 'HAMBURGUER_E_OU_EMBUTIDOS_6MESES_2ANOS',
  HAMBURGUER_E_OU_EMBUTIDOS_MAIOR_2ANOS = 'HAMBURGUER_E_OU_EMBUTIDOS_MAIOR_2ANOS',
  IOGURTE = 'IOGURTE',
  LEGUMES = 'LEGUMES',
  LEITE_VACA = 'LEITE_VACA',
  MACARRAO_INSTANTANEO_SALGADINHOS_PACOTES_6MESES_2ANOS = 'MACARRAO_INSTANTANEO_SALGADINHOS_PACOTES_6MESES_2ANOS',
  MACARRAO_INSTANTANEO_SALGADINHO_BISCOITO_MAIOR_2ANOS = 'MACARRAO_INSTANTANEO_SALGADINHO_BISCOITO_MAIOR_2ANOS',
  MINGAU = 'MINGAU',
  MINGAU_COM_LEITE = 'MINGAU_COM_LEITE',
  ONTEM_CRIANCA_COMEU_COMIDA_SAL = 'ONTEM_CRIANCA_COMEU_COMIDA_SAL',
  ONTEM_CRIANCA_COMEU_FRUTA_INTEIRA_PEDACO_AMASSADA = 'ONTEM_CRIANCA_COMEU_FRUTA_INTEIRA_PEDACO_AMASSADA',
  OUTROS_ALIMENTOS_BEBIDAS = 'OUTROS_ALIMENTOS_BEBIDAS',
  OUTRO_LEITE_NAO_LEITE_PEITO = 'OUTRO_LEITE_NAO_LEITE_PEITO',
  QUAIS_REFEICOES_VOCE_FEZ_LONGO_DIA = 'QUAIS_REFEICOES_VOCE_FEZ_LONGO_DIA',
  SE_SIM_ESSA_COMIDA_FOI_OFERECIDA = 'SE_SIM_ESSA_COMIDA_FOI_OFERECIDA',
  SE_SIM_QUANTAS_VEZES_COMIDA_SAL = 'SE_SIM_QUANTAS_VEZES_COMIDA_SAL',
  SE_SIM_QUANTAS_VEZES_FRUTA = 'SE_SIM_QUANTAS_VEZES_FRUTA',
  SUCO_FRUTA = 'SUCO_FRUTA',
  VEGETAL_OU_FRUTA_ALARANJADA = 'VEGETAL_OU_FRUTA_ALARANJADA',
  VERDURAS_LEGUMES = 'VERDURAS_LEGUMES',
  VERDURA_FOLHA = 'VERDURA_FOLHA',
  VOCE_COSTUME_REALIZAR_REFEICOES_ASSISTINDO_TV = 'VOCE_COSTUME_REALIZAR_REFEICOES_ASSISTINDO_TV',
}

export type PerguntasRespostasHistoricoConsumoAlimentar = {
  readonly __typename?: 'PerguntasRespostasHistoricoConsumoAlimentar'
  readonly pergunta: Scalars['String']['output']
  readonly respostas: ReadonlyArray<Maybe<Scalars['String']['output']>>
}

export type Period = {
  readonly endDate?: InputMaybe<Scalars['LocalDate']['input']>
  readonly startDate?: InputMaybe<Scalars['LocalDate']['input']>
}

export type PeriodoAusencia = {
  readonly __typename?: 'PeriodoAusencia'
  readonly dtAusencia: Scalars['LocalDate']['output']
  readonly dtRetorno?: Maybe<Scalars['LocalDate']['output']>
  readonly id: Scalars['ID']['output']
}

export enum PeriodoCadastroIndividualEnum {
  DOZE_MESES = 'DOZE_MESES',
  SEIS_MESES = 'SEIS_MESES',
}

export enum PeriodoEnum {
  PRIMEIRO_PERIODO = 'PRIMEIRO_PERIODO',
  QUARTO_PERIODO = 'QUARTO_PERIODO',
  SEGUNDO_PERIODO = 'SEGUNDO_PERIODO',
  TERCEIRO_PERIODO = 'TERCEIRO_PERIODO',
}

export type PeriodoGestacao = {
  readonly __typename?: 'PeriodoGestacao'
  readonly fim?: Maybe<Scalars['LocalDate']['output']>
  readonly id: Scalars['ID']['output']
  readonly inicio: Scalars['LocalDate']['output']
}

export type PeriodoGestacional = {
  readonly __typename?: 'PeriodoGestacional'
  readonly dataInicioGestacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataProvavelPartoEcografica?: Maybe<Scalars['LocalDate']['output']>
  readonly fonteIdadeGestacional?: Maybe<FonteIdadeGestacionalEnum>
  readonly hasDppEcoChanged: Scalars['Boolean']['output']
  readonly hasIgEcoChanged: Scalars['Boolean']['output']
  readonly idadeGestacionalCronologicaEmDias?: Maybe<Scalars['Int']['output']>
  readonly idadeGestacionalEcograficaEmDias?: Maybe<Scalars['Int']['output']>
}

export type PeriodoGestacionalQueryInput = {
  readonly dataAtendimento: Scalars['LocalDate']['input']
  readonly dum: Scalars['LocalDate']['input']
  readonly dumAtendimentoAtual?: InputMaybe<Scalars['LocalDate']['input']>
  readonly fonteIgAtendimentoAtual?: InputMaybe<FonteIdadeGestacionalEnum>
  readonly prontuarioId: Scalars['ID']['input']
  readonly resultadosExamesPreNatalAtendimentoAtual?: InputMaybe<ReadonlyArray<ResultadoExamePreNatalInput>>
}

export type PeriodontiaInput = {
  readonly evolucoes?: InputMaybe<ReadonlyArray<EvolucaoProcedimentoOdontoInput>>
  readonly observacaoPeriogramaCompleto?: InputMaybe<Scalars['String']['input']>
  readonly periogramaCompleto?: InputMaybe<ReadonlyArray<PeriogramaCompletoInput>>
  readonly periogramaSimplificado?: InputMaybe<PeriogramaSimplificadoInput>
}

export type PeriogramaCompleto = {
  readonly __typename?: 'PeriogramaCompleto'
  readonly atendimentoProfissionalOdonto: AtendimentoProfissionalOdonto
  readonly dente: ParteBucal
  readonly excluido: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly lesaoDeFurca?: Maybe<Scalars['String']['output']>
  readonly mobilidade?: Maybe<Scalars['String']['output']>
  readonly placaDInterna?: Maybe<Scalars['Boolean']['output']>
  readonly placaDVestibular?: Maybe<Scalars['Boolean']['output']>
  readonly placaMInterna?: Maybe<Scalars['Boolean']['output']>
  readonly placaMVestibular?: Maybe<Scalars['Boolean']['output']>
  readonly placaVInterna?: Maybe<Scalars['Boolean']['output']>
  readonly placaVVestibular?: Maybe<Scalars['Boolean']['output']>
  readonly profundidadeInterna?: Maybe<Scalars['String']['output']>
  readonly profundidadeVestibular?: Maybe<Scalars['String']['output']>
  readonly recessaoInterna?: Maybe<Scalars['String']['output']>
  readonly recessaoVestibular?: Maybe<Scalars['String']['output']>
  readonly sangramentoDInterna?: Maybe<Scalars['Boolean']['output']>
  readonly sangramentoDVestibular?: Maybe<Scalars['Boolean']['output']>
  readonly sangramentoMInterna?: Maybe<Scalars['Boolean']['output']>
  readonly sangramentoMVestibular?: Maybe<Scalars['Boolean']['output']>
  readonly sangramentoVInterna?: Maybe<Scalars['Boolean']['output']>
  readonly sangramentoVVestibular?: Maybe<Scalars['Boolean']['output']>
}

export type PeriogramaCompletoInput = {
  readonly dente: ParteBucalEnum
  readonly excluido: Scalars['Boolean']['input']
  readonly lesaoDeFurca?: InputMaybe<Scalars['String']['input']>
  readonly mobilidade?: InputMaybe<Scalars['String']['input']>
  readonly placaDInterna?: InputMaybe<Scalars['Boolean']['input']>
  readonly placaDVestibular?: InputMaybe<Scalars['Boolean']['input']>
  readonly placaMInterna?: InputMaybe<Scalars['Boolean']['input']>
  readonly placaMVestibular?: InputMaybe<Scalars['Boolean']['input']>
  readonly placaVInterna?: InputMaybe<Scalars['Boolean']['input']>
  readonly placaVVestibular?: InputMaybe<Scalars['Boolean']['input']>
  readonly profundidadeInterna?: InputMaybe<Scalars['String']['input']>
  readonly profundidadeVestibular?: InputMaybe<Scalars['String']['input']>
  readonly recessaoInterna?: InputMaybe<Scalars['String']['input']>
  readonly recessaoVestibular?: InputMaybe<Scalars['String']['input']>
  readonly sangramentoDInterna?: InputMaybe<Scalars['Boolean']['input']>
  readonly sangramentoDVestibular?: InputMaybe<Scalars['Boolean']['input']>
  readonly sangramentoMInterna?: InputMaybe<Scalars['Boolean']['input']>
  readonly sangramentoMVestibular?: InputMaybe<Scalars['Boolean']['input']>
  readonly sangramentoVInterna?: InputMaybe<Scalars['Boolean']['input']>
  readonly sangramentoVVestibular?: InputMaybe<Scalars['Boolean']['input']>
}

export type PeriogramaCompletoQueryInput = {
  readonly atendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export type PeriogramaSimplificado = {
  readonly __typename?: 'PeriogramaSimplificado'
  readonly atendimentoProfissionalOdonto: AtendimentoProfissionalOdonto
  readonly avaliacaoSextante1: Scalars['String']['output']
  readonly avaliacaoSextante2: Scalars['String']['output']
  readonly avaliacaoSextante3: Scalars['String']['output']
  readonly avaliacaoSextante4: Scalars['String']['output']
  readonly avaliacaoSextante5: Scalars['String']['output']
  readonly avaliacaoSextante6: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
}

export type PeriogramaSimplificadoInput = {
  readonly avaliacaoSextante1: Scalars['String']['input']
  readonly avaliacaoSextante2: Scalars['String']['input']
  readonly avaliacaoSextante3: Scalars['String']['input']
  readonly avaliacaoSextante4: Scalars['String']['input']
  readonly avaliacaoSextante5: Scalars['String']['input']
  readonly avaliacaoSextante6: Scalars['String']['input']
  readonly observacao?: InputMaybe<Scalars['String']['input']>
}

export type PeriogramaSimplificadoPayload = {
  readonly __typename?: 'PeriogramaSimplificadoPayload'
  readonly content: ReadonlyArray<Maybe<PeriogramaSimplificado>>
  readonly pageInfo: PageInfo
}

export type PeriogramaSimplificadoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId: Scalars['ID']['input']
}

export enum PesoAutorreferidoEnum {
  ABAIXO_DO_PESO = 'ABAIXO_DO_PESO',
  ACIMA_DO_PESO = 'ACIMA_DO_PESO',
  PESO_ADEQUADO = 'PESO_ADEQUADO',
}

export type PessoaIdosaConsolidado = {
  readonly __typename?: 'PessoaIdosaConsolidado'
  readonly cidadaoId?: Maybe<Scalars['Long']['output']>
  readonly quantidadeMedicoesSimultaneasPesoAltura?: Maybe<Scalars['Long']['output']>
  readonly vacinasAplicadas: ReadonlyArray<FatoVacinacaoVacina>
  readonly visitaDomiciliar?: Maybe<VisitaDomiciliarConsolidado>
}

export type PessoalAntecedentesInput = {
  readonly cirurgiasInternacoes?: InputMaybe<ReadonlyArray<InputMaybe<AntecedenteCirurgiaInternacaoInput>>>
  readonly informacoesObstetricas?: InputMaybe<InformacoesObstetricasInput>
  readonly puericultura?: InputMaybe<PrenatalPartoNascimentoInput>
  readonly texto?: InputMaybe<Scalars['String']['input']>
}

export type PlanoInput = {
  readonly atestado?: InputMaybe<AtestadoPlanoInput>
  readonly ciaps?: InputMaybe<ReadonlyArray<InputMaybe<CiapPlanoInput>>>
  readonly compartilhamentosCuidado?: InputMaybe<ReadonlyArray<CompartilhamentoCuidadoPlanoInput>>
  readonly cuidadosCompartilhado?: InputMaybe<ReadonlyArray<CuidadoCompartilhadoPlanoInput>>
  readonly encaminhamentosExternos?: InputMaybe<ReadonlyArray<TipoEncaminhamentoExternoEnum>>
  readonly encaminhamentosExternosEspecializados?: InputMaybe<ReadonlyArray<EncaminhamentoExternoInput>>
  readonly isObservacao?: InputMaybe<Scalars['Boolean']['input']>
  readonly odontologia?: InputMaybe<OdontologiaInput>
  readonly orientacoes?: InputMaybe<ReadonlyArray<InputMaybe<OrientacaoPlanoInput>>>
  readonly prescricaoMedicamento?: InputMaybe<PrescricaoMedicamentoPlanoInput>
  readonly procedimentos?: InputMaybe<ReadonlyArray<InputMaybe<ProcedimentosPlanoInput>>>
  readonly solicitacoesExame?: InputMaybe<ReadonlyArray<SolicitacaoExameInput>>
  readonly texto?: InputMaybe<Scalars['String']['input']>
}

export type PoloBase = {
  readonly __typename?: 'PoloBase'
  readonly dsei: Dsei
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type PoloBaseInput = {
  readonly aldeiaId?: InputMaybe<Scalars['ID']['input']>
  readonly dseiId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type PoloBaseQueryPayload = {
  readonly __typename?: 'PoloBaseQueryPayload'
  readonly content: ReadonlyArray<Maybe<PoloBase>>
  readonly pageInfo: PageInfo
}

export enum PosicaoCampoRelatorioGerencialEnum {
  COLUNA = 'COLUNA',
  FILTRO = 'FILTRO',
  LINHA = 'LINHA',
}

export type PossuiAtendimentosNaoFinalizadosInput = {
  readonly endDate: Scalars['Instant']['input']
  readonly isRegistroTardio: Scalars['Boolean']['input']
  readonly startDate: Scalars['Instant']['input']
}

export type PossuiTratamentoConcluidoQueryInput = {
  readonly dataAtendimento: Scalars['Instant']['input']
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export enum PovoComunidadeTradicionalEnum {
  ACAMPADA = 'ACAMPADA',
  AGROEXTRATIVISTAS = 'AGROEXTRATIVISTAS',
  ANDIROBEIRAS = 'ANDIROBEIRAS',
  ASSENTADA = 'ASSENTADA',
  CAATINGUEIROS = 'CAATINGUEIROS',
  CAICARAS = 'CAICARAS',
  CAMPONESES = 'CAMPONESES',
  CASTANHEIRAS = 'CASTANHEIRAS',
  CATADORES_DE_MANGABA = 'CATADORES_DE_MANGABA',
  CERRADO = 'CERRADO',
  CIGANOS = 'CIGANOS',
  COMUNIDADES_FUNDO_FECHO_PASTO = 'COMUNIDADES_FUNDO_FECHO_PASTO',
  EXTRATIVISTAS = 'EXTRATIVISTAS',
  FAXINALENSES = 'FAXINALENSES',
  GERAIZEIROS = 'GERAIZEIROS',
  ISQUEIROS = 'ISQUEIROS',
  JANGADEIROS = 'JANGADEIROS',
  MARISQUEIROS = 'MARISQUEIROS',
  MORROQUIANOS = 'MORROQUIANOS',
  OUTROS = 'OUTROS',
  PANTANEIROS = 'PANTANEIROS',
  PESCADORES_ARTESANAIS = 'PESCADORES_ARTESANAIS',
  POMERANOS = 'POMERANOS',
  POPULACOES_ATINGIDAS_POR_BARRAGENS = 'POPULACOES_ATINGIDAS_POR_BARRAGENS',
  POVOS_DE_TERREIRO_MATRIZ_AFRICANA = 'POVOS_DE_TERREIRO_MATRIZ_AFRICANA',
  POVOS_INDIGENAS = 'POVOS_INDIGENAS',
  POVOS_QUILOMBOLAS = 'POVOS_QUILOMBOLAS',
  QUEBRADEIRAS_COCO_BABACU = 'QUEBRADEIRAS_COCO_BABACU',
  RETIREIROS = 'RETIREIROS',
  RIBEIRINHOS = 'RIBEIRINHOS',
  SERINGUEIROS = 'SERINGUEIROS',
  TRABALHADORES_RURAIS_ASSALARIADOS = 'TRABALHADORES_RURAIS_ASSALARIADOS',
  TRABALHADORES_RURAIS_TEMPORARIOS = 'TRABALHADORES_RURAIS_TEMPORARIOS',
  VARJEIROS = 'VARJEIROS',
  VAZANTEIROS = 'VAZANTEIROS',
}

export enum PraticaSaudeEnum {
  ANTROPOMETRIA = 'ANTROPOMETRIA',
  APLICACAO_TOPICA_DE_FLUOR = 'APLICACAO_TOPICA_DE_FLUOR',
  DESENVOLVIMENTO_DA_LINGUAGEM = 'DESENVOLVIMENTO_DA_LINGUAGEM',
  ESCOVACAO_DENTAL_SUPERVISIONADA = 'ESCOVACAO_DENTAL_SUPERVISIONADA',
  OUTRAS = 'OUTRAS',
  OUTRO_PROCEDIMENTO_COLETIVO = 'OUTRO_PROCEDIMENTO_COLETIVO',
  PRATICAS_CORPORAIS_ATIVIDADE_FISICA = 'PRATICAS_CORPORAIS_ATIVIDADE_FISICA',
  PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_1 = 'PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_1',
  PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_2 = 'PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_2',
  PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_3 = 'PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_3',
  PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_4 = 'PROGRAMA_NACIONAL_CONTROLE_TABAGISMO_4',
  SAUDE_AUDITIVA = 'SAUDE_AUDITIVA',
  SAUDE_OCULAR = 'SAUDE_OCULAR',
  VERIFICACAO_DA_SITUACAO_VACINAL = 'VERIFICACAO_DA_SITUACAO_VACINAL',
}

export type PreNatal = {
  readonly __typename?: 'PreNatal'
  readonly altoRisco: Scalars['Boolean']['output']
  readonly dataDesfecho?: Maybe<Scalars['LocalDate']['output']>
  readonly fonteIdadeGestacional?: Maybe<FonteIdadeGestacionalEnum>
  readonly gravidezPlanejada?: Maybe<Scalars['Boolean']['output']>
  readonly id: Scalars['ID']['output']
  readonly problema: Problema
  readonly tipoGravidez?: Maybe<TipoGravidez>
  readonly ultimaDum?: Maybe<Scalars['LocalDate']['output']>
}

export type PreNatalInput = {
  readonly alturaUterina?: InputMaybe<Scalars['Int']['input']>
  readonly batimentoCardiacoFetal?: InputMaybe<Scalars['Int']['input']>
  readonly batimentoCardiacoFetal2?: InputMaybe<Scalars['Int']['input']>
  readonly edema?: InputMaybe<TipoEdemaEnum>
  readonly fonteIdadeGestacional?: InputMaybe<FonteIdadeGestacionalEnum>
  readonly gravidezPlanejada?: InputMaybe<Scalars['Boolean']['input']>
  readonly movimentacaoFetal?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoGravidez?: InputMaybe<TipoGravidezEnum>
}

export type PreNatalPuerperioConsolidado = {
  readonly __typename?: 'PreNatalPuerperioConsolidado'
  readonly altoRiscoGestacional?: Maybe<Scalars['Boolean']['output']>
  readonly atendimentosPreNatalPuerperio?: Maybe<AtendimentosPreNatalPuerperioConsolidado>
  readonly dppCronologica?: Maybe<Scalars['LocalDate']['output']>
  readonly dppEcografica?: Maybe<Scalars['LocalDate']['output']>
  readonly examesRealizadosPreNatal?: Maybe<ExamesRealizadosPreNatalConsolidado>
  readonly fonteIdadeGestacional?: Maybe<FonteIdadeGestacionalEnum>
  readonly idadeGestacionalCronologicaEmDias?: Maybe<Scalars['Long']['output']>
  readonly idadeGestacionalEcograficaEmDias?: Maybe<Scalars['Long']['output']>
  readonly medicoesPreNatal?: Maybe<MedicoesPreNatalConsolidado>
  readonly ultimaDum?: Maybe<Scalars['LocalDate']['output']>
  readonly vacinasAplicadas: ReadonlyArray<FatoVacinacaoVacina>
  readonly visitasDomiciliares?: Maybe<VisitasDomiciliaresPreNatalPuerperioConsolidado>
}

export type PrenatalPartoNascimentoInput = {
  readonly altura?: InputMaybe<Scalars['Float']['input']>
  readonly apgarDecimoMinuto?: InputMaybe<Scalars['Int']['input']>
  readonly apgarPrimeiroMinuto?: InputMaybe<Scalars['Int']['input']>
  readonly apgarQuintoMinuto?: InputMaybe<Scalars['Int']['input']>
  readonly idadeGestacionalEmDias?: InputMaybe<Scalars['Int']['input']>
  readonly idadeGestacionalEmSemanas?: InputMaybe<Scalars['Int']['input']>
  readonly perimetroCefalico?: InputMaybe<Scalars['Float']['input']>
  readonly peso?: InputMaybe<Scalars['Float']['input']>
  readonly tipoGravidez?: InputMaybe<TipoGravidezEnum>
  readonly tipoParto?: InputMaybe<TipoPartoEnum>
}

export type PrescricaoMedicamentoPlanoInput = {
  readonly medicamentos: ReadonlyArray<InputMaybe<MedicamentoPlanoInput>>
}

export type PrescricaoSdcDto = {
  readonly __typename?: 'PrescricaoSdcDto'
  readonly medicamentos: ReadonlyArray<ReceitaMedicamentoSdcDto>
  readonly titulo: Scalars['String']['output']
}

export type PrincipioAtivo = {
  readonly __typename?: 'PrincipioAtivo'
  readonly id: Scalars['ID']['output']
  readonly listaMaterial: ListaMedicamento
  readonly nome: Scalars['String']['output']
}

export enum PrioridadeRegulacaoEnum {
  ALTA = 'ALTA',
  BAIXA = 'BAIXA',
  MEDIA = 'MEDIA',
  MUITO_ALTA = 'MUITO_ALTA',
  NAO_INFORMADA = 'NAO_INFORMADA',
  NAO_URGENTE = 'NAO_URGENTE',
}

export type Problema = {
  readonly __typename?: 'Problema'
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly cid11?: Maybe<Cid11>
  readonly descricaoOutro?: Maybe<Scalars['String']['output']>
  readonly evolucaoAvaliacaoCiapCid?: Maybe<EvolucaoAvaliacaoCiapCid>
  readonly evolucoes: ReadonlyArray<EvolucaoProblema>
  readonly id: Scalars['ID']['output']
  readonly situacao: SituacaoProblema
  readonly ultimaEvolucao: EvolucaoProblema
}

export type ProblemaByCiapCidQueryInput = {
  readonly ciapId?: InputMaybe<Scalars['ID']['input']>
  readonly cidId?: InputMaybe<Scalars['ID']['input']>
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
  readonly situacoes?: InputMaybe<ReadonlyArray<InputMaybe<SituacaoProblema>>>
}

export type ProblemaCondicaoSdcInput = {
  readonly ciap2?: InputMaybe<Scalars['String']['input']>
  readonly cid10?: InputMaybe<Scalars['String']['input']>
  readonly situacaoProblema?: InputMaybe<SituacaoProblema>
}

export type ProblemaQueryInput = {
  readonly includeInicioNull?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodoInicioProblema?: InputMaybe<Period>
  readonly prontuarioId: Scalars['ID']['input']
  readonly situacoes?: InputMaybe<ReadonlyArray<SituacaoProblema>>
}

export type ProblemaQueryPayload = {
  readonly __typename?: 'ProblemaQueryPayload'
  readonly content: ReadonlyArray<Problema>
  readonly pageInfo: PageInfo
}

export type ProblemasECondicoesInput = {
  readonly automatico: Scalars['Boolean']['input']
  readonly ciapId?: InputMaybe<Scalars['ID']['input']>
  readonly cid11Id?: InputMaybe<Scalars['ID']['input']>
  readonly cidId?: InputMaybe<Scalars['ID']['input']>
  readonly dataFim?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly situacao?: InputMaybe<SituacaoProblema>
}

export type ProblemasFaltantesLpcQueryInput = {
  readonly prontuarioId: Scalars['ID']['input']
}

export type Procedimento = {
  readonly __typename?: 'Procedimento'
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly codigo: Scalars['String']['output']
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly idadeAplicavel?: Maybe<Scalars['Boolean']['output']>
  readonly idadeMaxima?: Maybe<Scalars['Int']['output']>
  readonly idadeMinima?: Maybe<Scalars['Int']['output']>
  readonly procedimentoReferencia?: Maybe<Procedimento>
  readonly sexo?: Maybe<SexoEnum>
  readonly tipoProcedimento?: Maybe<TipoProcedimentoEnum>
}

export type ProcedimentoAtendimentoInput = {
  readonly automatico?: InputMaybe<Scalars['Boolean']['input']>
  readonly cid10PrincipalId?: InputMaybe<Scalars['ID']['input']>
  readonly id: Scalars['ID']['input']
}

export type ProcedimentoFiltroInput = {
  readonly cboIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly dataAtendimento: Scalars['LocalDate']['input']
  readonly dataNascimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly filtrarProcedimentosOdonto?: InputMaybe<Scalars['Boolean']['input']>
  readonly gruposProcedimento?: InputMaybe<ReadonlyArray<InputMaybe<GrupoProcedimentoEnum>>>
  readonly sexo?: InputMaybe<SexoEnum>
  readonly subGruposProcedimento?: InputMaybe<ReadonlyArray<SubGrupoProcedimentoEnum>>
  readonly tipoExame?: InputMaybe<TipoExameEnum>
  readonly tipoProcedimento?: InputMaybe<TipoProcedimentoEnum>
}

export type ProcedimentoHistoricoDto = {
  readonly __typename?: 'ProcedimentoHistoricoDto'
  readonly categoriaProblema: CategoriaProblemaEnum
  readonly codigo?: Maybe<Scalars['String']['output']>
  readonly descricao: Scalars['String']['output']
}

export type ProcedimentoOdontoQueryInput = {
  readonly dataAtendimento: Scalars['LocalDate']['input']
  readonly dataNascimento: Scalars['LocalDate']['input']
  readonly pageParams?: InputMaybe<PageParams>
  readonly parteBucal?: InputMaybe<ParteBucalEnum>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type ProcedimentoQueryInput = {
  readonly filtro: ProcedimentoFiltroInput
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type ProcedimentoSdcDto = {
  readonly __typename?: 'ProcedimentoSdcDto'
  readonly exameSolicitado?: Maybe<Procedimento>
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly previamentePrescrito: Scalars['Boolean']['output']
}

export type ProcedimentosPlanoInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly isAutomatico?: InputMaybe<Scalars['Boolean']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly procedimentoId: Scalars['ID']['input']
}

export type ProcedimentosQueryPayload = {
  readonly __typename?: 'ProcedimentosQueryPayload'
  readonly content: ReadonlyArray<Maybe<Procedimento>>
  readonly pageInfo: PageInfo
}

export enum ProcessamentoStatusEnum {
  EM_PROCESSAMENTO = 'EM_PROCESSAMENTO',
  ERRO = 'ERRO',
  PROCESSADO = 'PROCESSADO',
}

export type ProcessarTerritorioInput = {
  readonly cidadaosIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly imovelId?: InputMaybe<Scalars['ID']['input']>
}

export type Processo = {
  readonly __typename?: 'Processo'
  readonly id: Scalars['ID']['output']
  readonly status: StatusProcesso
}

export type ProfissionaisAdQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type ProfissionaisInconsistenciaQueryPayload = {
  readonly __typename?: 'ProfissionaisInconsistenciaQueryPayload'
  readonly content: ReadonlyArray<Maybe<TransmissaoRecebimentoLoteDto>>
  readonly pageInfo: PageInfo
}

export type ProfissionaisListaCuidadoCompartilhadoQueryInput = {
  readonly isProfissionaisSolicitantes: Scalars['Boolean']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly role: CuidadoCompartilhadoQueryFilterEnum
  readonly somenteSemExecutante?: InputMaybe<Scalars['Boolean']['input']>
}

export type ProfissionaisQueryInput = {
  readonly cboId?: InputMaybe<Scalars['ID']['input']>
  readonly equipesId?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
  readonly mostrarSemLotacaoAtiva?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly unidadeSaudeId?: InputMaybe<Scalars['ID']['input']>
}

export type ProfissionaisQueryPayload = {
  readonly __typename?: 'ProfissionaisQueryPayload'
  readonly content: ReadonlyArray<Maybe<Profissional>>
  readonly pageInfo: PageInfo
}

export type ProfissionaisRelatorioInconsistenciaQueryInput = {
  readonly dataFim: Scalars['LocalDate']['input']
  readonly dataInicio: Scalars['LocalDate']['input']
  readonly nomeProfissional?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
}

export type ProfissionaisSugestaoAgendamento = {
  readonly __typename?: 'ProfissionaisSugestaoAgendamento'
  readonly odontologico?: Maybe<Lotacao>
  readonly preNatal?: Maybe<Lotacao>
}

export type Profissional = {
  readonly __typename?: 'Profissional'
  readonly acessos?: Maybe<ReadonlyArray<Acesso>>
  readonly actions: ProfissionalActions
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly conselhoClasse?: Maybe<ConselhoClasse>
  readonly cpf: Scalars['String']['output']
  readonly dataNascimento?: Maybe<Scalars['LocalDate']['output']>
  readonly email?: Maybe<Scalars['String']['output']>
  readonly endereco?: Maybe<Endereco>
  readonly estagios: ReadonlyArray<Estagio>
  readonly id: Scalars['ID']['output']
  readonly lotacoes: ReadonlyArray<Lotacao>
  readonly nome: Scalars['String']['output']
  readonly nomeCivil: Scalars['String']['output']
  readonly nomeSocial?: Maybe<Scalars['String']['output']>
  readonly numeroConselhoClasse?: Maybe<Scalars['String']['output']>
  readonly sexo?: Maybe<Scalars['String']['output']>
  readonly telefone?: Maybe<Scalars['String']['output']>
  readonly ufEmissoraConselhoClasse?: Maybe<Uf>
  readonly usuario: Usuario
}

export type ProfissionalAcessosArgs = {
  input?: InputMaybe<AcessosConnectionInput>
}

export type ProfissionalActions = {
  readonly __typename?: 'ProfissionalActions'
  readonly redefinirSenha: Action
}

export type ProfissionalContraChaveInput = {
  readonly contraChave: Scalars['String']['input']
  readonly novaSenha: Scalars['String']['input']
  readonly profissional: ProfissionalInput
}

export type ProfissionalInput = {
  readonly cns?: InputMaybe<Scalars['String']['input']>
  readonly conselhoClasse?: InputMaybe<Scalars['String']['input']>
  readonly cpf: Scalars['String']['input']
  readonly dataNascimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly endereco?: InputMaybe<EnderecoInput>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly nomeCivil: Scalars['String']['input']
  readonly nomeSocial?: InputMaybe<Scalars['String']['input']>
  readonly numeroConselhoClasse?: InputMaybe<Scalars['String']['input']>
  readonly sexo?: InputMaybe<Scalars['String']['input']>
  readonly telefone?: InputMaybe<Scalars['String']['input']>
  readonly ufEmissoraConselhoClasse?: InputMaybe<Scalars['String']['input']>
}

export type Prontuario = {
  readonly __typename?: 'Prontuario'
  readonly atendimentos: ReadonlyArray<Atendimento>
  readonly cidadao?: Maybe<Cidadao>
  readonly gestacoes?: Maybe<ReadonlyArray<PeriodoGestacao>>
  readonly id: Scalars['ID']['output']
  readonly preNatalAtivo?: Maybe<PreNatal>
  readonly problemas: ReadonlyArray<Problema>
  readonly puerpera?: Maybe<Scalars['Boolean']['output']>
}

export type ProximaDoseAprazamento = {
  readonly __typename?: 'ProximaDoseAprazamento'
  readonly diasAprazamento?: Maybe<Scalars['Int']['output']>
  readonly proximaDoseId?: Maybe<Scalars['ID']['output']>
  readonly proximaDoseNome?: Maybe<Scalars['String']['output']>
  readonly proximaDoseSigla?: Maybe<Scalars['String']['output']>
}

export type ProximaDoseAprazamentoQueryInput = {
  readonly doseId: Scalars['ID']['input']
  readonly estrategiaId: Scalars['ID']['input']
  readonly imunobiologicoId: Scalars['ID']['input']
}

export enum PublicoAlvoEnum {
  ADOLESCENTE = 'ADOLESCENTE',
  ADOLESCENTE_ATENDIMENTO_SOCIOEDUCATIVO_MEIO_ABERTO = 'ADOLESCENTE_ATENDIMENTO_SOCIOEDUCATIVO_MEIO_ABERTO',
  ADOLESCENTE_ATENDIMENTO_SOCIOEDUCATIVO_MEIO_FECHADO = 'ADOLESCENTE_ATENDIMENTO_SOCIOEDUCATIVO_MEIO_FECHADO',
  COMUNIDADE_EM_GERAL = 'COMUNIDADE_EM_GERAL',
  CRIANCA_0_A_3_ANOS = 'CRIANCA_0_A_3_ANOS',
  CRIANCA_4_A_5_ANOS = 'CRIANCA_4_A_5_ANOS',
  CRIANCA_6_A_11_ANOS = 'CRIANCA_6_A_11_ANOS',
  FAMILIARES = 'FAMILIARES',
  GESTANTE = 'GESTANTE',
  HOMEM = 'HOMEM',
  MULHER = 'MULHER',
  OUTROS = 'OUTROS',
  PESSOAS_COM_DOENCAS_CRONICAS = 'PESSOAS_COM_DOENCAS_CRONICAS',
  PESSOAS_COM_SOFRIMENTO_TRANSTORNO_MENTAL = 'PESSOAS_COM_SOFRIMENTO_TRANSTORNO_MENTAL',
  PESSOA_IDOSA = 'PESSOA_IDOSA',
  PROFISSIONAL_DE_EDUCACAO = 'PROFISSIONAL_DE_EDUCACAO',
  USUARIO_DE_ALCOOL = 'USUARIO_DE_ALCOOL',
  USUARIO_DE_OUTRAS_DROGAS = 'USUARIO_DE_OUTRAS_DROGAS',
  USUARIO_DE_TABACO = 'USUARIO_DE_TABACO',
}

export type PuericulturaInput = {
  readonly alteracoesFenotipicas?: InputMaybe<ReadonlyArray<AvaliacaoDesenvolvimentoInput>>
  readonly fatoresRisco?: InputMaybe<ReadonlyArray<AvaliacaoDesenvolvimentoInput>>
  readonly mChat?: InputMaybe<MChatInput>
  readonly marcosDesenvolvimento?: InputMaybe<ReadonlyArray<AvaliacaoDesenvolvimentoInput>>
  readonly prenatalPartoNascimento?: InputMaybe<PrenatalPartoNascimentoInput>
  readonly tipoAleitamento?: InputMaybe<TipoAleitamentoMaternoEnum>
}

export type QrCode = {
  readonly __typename?: 'QRCode'
  readonly base64PngImage: Scalars['String']['output']
  readonly value: Scalars['String']['output']
}

export type QuadroRelatorioExameItem = {
  readonly __typename?: 'QuadroRelatorioExameItem'
  readonly descricao: Scalars['String']['output']
  readonly quantidadeAvaliada: Scalars['Int']['output']
  readonly quantidadeSolicitada: Scalars['Int']['output']
}

export type QuadroRelatorioFaixaEtariaItem = {
  readonly __typename?: 'QuadroRelatorioFaixaEtariaItem'
  readonly descricao: Scalars['String']['output']
  readonly id: DimFaixaEtariaEnum
  readonly quantidadeHomens: Scalars['Int']['output']
  readonly quantidadeIndeterminado: Scalars['Int']['output']
  readonly quantidadeMulheres: Scalars['Int']['output']
  readonly quantidadeNaoInformado: Scalars['Int']['output']
}

export type QuadroRelatorioItem = {
  readonly __typename?: 'QuadroRelatorioItem'
  readonly descricao: Scalars['String']['output']
  readonly quantidade: Scalars['Int']['output']
}

export enum QuantidadeAlimentacaoDiariaEnum {
  DUAS_A_3_POR_DIA = 'DUAS_A_3_POR_DIA',
  MAIS_DE_3 = 'MAIS_DE_3',
  UMA_POR_DIA = 'UMA_POR_DIA',
}

export type QuantidadeStatusEnvioRndsDto = {
  readonly __typename?: 'QuantidadeStatusEnvioRndsDto'
  readonly qtdDadosInvalidos?: Maybe<Scalars['Long']['output']>
  readonly qtdEnviado?: Maybe<Scalars['Long']['output']>
  readonly qtdErro?: Maybe<Scalars['Long']['output']>
  readonly qtdFalhaConexao?: Maybe<Scalars['Long']['output']>
  readonly qtdNaoEnviado?: Maybe<Scalars['Long']['output']>
}

export type Query = {
  readonly __typename?: 'Query'
  readonly absenteismos?: Maybe<ReadonlyArray<Absenteismo>>
  readonly acesso: Acesso
  readonly acessoHasCbosDisponiveisVinculacaoEquipe: Scalars['Boolean']['output']
  readonly acessoHasVinculacaoEquipeNasf: Scalars['Boolean']['output']
  readonly acompanhamentoCidadaosVinculados: AcompanhamentoCidadaosVinculadosPayload
  readonly acompanhamentoCondicaoSaude: AcompanhamentoCondicaoSaudeQueryPayload
  readonly acompanhamentoPreNatalExames: ReadonlyArray<ExamesPreNatalDto>
  readonly acompanhamentoPreNatalVacinacao?: Maybe<VacinasPreNatal>
  readonly acompanhamentoPuerperioExames: AcompanhamentoPuerperioExamesPayload
  readonly acompanhamentoPuerperioVisitasDomiciliares: AcompanhamentosVisitasDomiciliaresPayload
  readonly administradoresGerais: ReadonlyArray<AdministradorGeral>
  readonly administradoresMunicipais: ReadonlyArray<AdministradorMunicipal>
  readonly agendaEmConflito: Scalars['Boolean']['output']
  readonly agendado: Agendado
  readonly agendados: AgendadoQueryPayload
  readonly aldeias: AldeiaQueryPayload
  readonly alergia?: Maybe<Alergia>
  readonly alergias: AlergiaQueryPayload
  readonly alteracoesFenotipicas?: Maybe<ReadonlyArray<AlteracaoFenotipica>>
  readonly anexoArquivos: ConfiguracaoAnexoArquivos
  readonly antecedente?: Maybe<Antecedente>
  readonly aplicacoesMedicamento: AplicacaoMedicamentoPayload
  readonly arquivosAnexadosNoProntuario: ReadonlyArray<ArquivoAtendimentoProfissional>
  readonly arquivosTemporarios?: Maybe<ArquivoTemporarioQueryPayload>
  readonly asyncProcessingStatus?: Maybe<AsyncProcessingStatus>
  readonly atendimento: Atendimento
  readonly atendimentoIndividual: AtendimentoProfissional
  readonly atendimentos: AtendimentosPayload
  readonly atendimentosDoDia: AtendimentosProfissionalPayload
  readonly atendimentosFinalizados: AtendimentosProfissionalPayload
  readonly atendimentosProfUltimaGestacao?: Maybe<ReadonlyArray<Maybe<AtendimentoProfissional>>>
  readonly atendimentosProfissional: AtendimentosProfissionalPayload
  readonly atestado: Atestado
  readonly atestadoModelo: AtestadoModelo
  readonly atestadoModelos: ReadonlyArray<Maybe<AtestadoModelo>>
  readonly atestados: AtestadoQueryPayload
  readonly atividadeColetiva: AtividadeColetiva
  readonly atividadesColetivas: AtividadeColetivaPayload
  readonly auditoriaHistorico: AuditoriaHistoricoPayload
  readonly auditoriaTipoEvento: ReadonlyArray<Maybe<AuditoriaTipoEvento>>
  readonly auditoriaTipoRegistroAfetado: ReadonlyArray<Maybe<AuditoriaTipoRegistroAfetado>>
  readonly autorizacaoRetiradaAbsorventeByCidadaoId: AutorizacaoRetiradaAbsorventeQueryPayload
  readonly avancada: ConfiguracaoAvancada
  readonly bairros: BairroQueryPayload
  readonly bundlesFhirComAssinaturaPendente: ReadonlyArray<BundleFhirComAssinaturaPendente>
  readonly buscaAtivaVacinacao: BuscaAtivaVacinacaoPayload
  readonly buscaCidadaoCadsusAtualizado: Scalars['ID']['output']
  readonly buscaCidadaoCadsusAtualizadoForcado: Scalars['ID']['output']
  readonly buscaCidadaosCadsus: Scalars['String']['output']
  readonly buscaCidadaosCadsusCompletoPolling?: Maybe<BuscaCidadaosCadsusResultDto>
  readonly cadastrosDuplicados: CidadaoUnificacaoBasePayload
  readonly categoriasMedicamentos: ReadonlyArray<CategoriaMedicamento>
  readonly categoriasProfissionalRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly cboGrupo: ReadonlyArray<CboGrupo>
  readonly cboList?: Maybe<ReadonlyArray<Cbo>>
  readonly cbos: CbosQueryPayload
  readonly cbosListaCuidadoCompartilhado: ReadonlyArray<Cbo>
  readonly cbosPrescritoresRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly cbosRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly cbosTrocaExecutante: CboPayload
  readonly cbosVinculacoesServico: CbosCuidadoCompartilhadoPayload
  readonly certificados: CertificadoPayload
  readonly chaveByCpf: Scalars['String']['output']
  readonly ciaps: CiapQueryPayLoad
  readonly ciapsByCodigos: ReadonlyArray<Ciap>
  readonly cid10List?: Maybe<ReadonlyArray<Cid10>>
  readonly cid10MotivosIndicacoesRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly cidadao: Cidadao
  readonly cidadaoAD: AtencaoDomiciliarCidadao
  readonly cidadaos: CidadaosPayload
  readonly cidadaosAD: CidadaosAdQueryPayload
  readonly cidadaosByDocumentos: ReadonlyArray<Cidadao>
  readonly cidadaosCombo: ReadonlyArray<Maybe<CidadaoBasico>>
  readonly cidadaosComboByCns: ReadonlyArray<Maybe<CidadaoBasico>>
  readonly cidadaosComboByCpf: ReadonlyArray<Maybe<CidadaoBasico>>
  readonly cidadaosComboByDataNascimento: ReadonlyArray<Maybe<CidadaoBasico>>
  readonly cidadaosComboByNome: ReadonlyArray<Maybe<CidadaoBasico>>
  readonly cidadaosTerritorio: ReadonlyArray<CidadaoTerritorio>
  readonly cids: Cid10QueryPayLoad
  readonly cids11: Cid11QueryPayLoad
  readonly cnsJaCadastrado: Scalars['Boolean']['output']
  readonly compartilhamentosCuidadoPlano: ReadonlyArray<CompartilhamentoCuidadoPlanoDto>
  readonly condicaoMaternalRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly condicoesAutorreferidas: ReadonlyArray<Maybe<CondicaoAutorreferida>>
  readonly condutasRelatorioGerencialCuidadoCompartilhado?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly conexao: ConfiguracaoConexao
  readonly configuracaoCertificadoHabilitado?: Maybe<ConfiguracaoCertificado>
  readonly configuracaoHorariosMunicipio: ConfiguracaoAgendaMunicipal
  readonly configuracoesAtencaoDom: ConfiguracoesAtencaoDom
  readonly conselhosClasse: ConselhoClassePayload
  readonly consultaEstoqueHorus: Scalars['String']['output']
  readonly contatoCidadao: ContatoCidadao
  readonly contraChaveAtivacaoMunicipio?: Maybe<Scalars['String']['output']>
  readonly cpfJaCadastrado: Scalars['Boolean']['output']
  readonly credenciaisIntegracao: CredencialIntegracaoPayload
  readonly credencialIntegracao: CredenciaIntegracao
  readonly cuidadoCompartilhado?: Maybe<CuidadoCompartilhado>
  readonly cuidadoCompartilhadoEvolucao?: Maybe<CuidadoCompartilhadoEvolucao>
  readonly cuidadoCompartilhadoEvolucoes: CuidadoCompartilhadoEvolucoesPayload
  readonly cuidadoCompartilhadoFinalizacoes: CuidadoCompartilhadoFinalizacaoAutoPayload
  readonly cuidadosCompartilhado: CuidadosCompartilhadoPayload
  readonly dataLimiteAlterarSenha?: Maybe<Scalars['Instant']['output']>
  readonly dataUltimaConsultaOdontoGestante?: Maybe<Scalars['LocalDate']['output']>
  readonly dataUltimoProcessamento?: Maybe<Scalars['Instant']['output']>
  readonly deficienciasRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly diasDaSemanaRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly dimensaoAgrupadorFiltro: DimensaoAgrupadorFiltroQueryPayload
  readonly dimensaoCategoriaProfissional: ReadonlyArray<Maybe<DimensaoCategoriaProfissional>>
  readonly dimensaoEquipe: DimensaoEquipeQueryPayload
  readonly dimensaoMunicipios: DimensaoMunicipiosQueryPayload
  readonly dimensaoUnidadeSaude: DimensaoUnidadeSaudeQueryPayload
  readonly disponibilidadeDadosClinicosHistorico: DisponibilidadeDadosClinicosHistorico
  readonly dispositivosPareadosUnidadeSaude: ReadonlyArray<DispositivoPainel>
  readonly doseImunobiologicoVacinacao: DoseImunobiologicoQueryPayload
  readonly dosesImunobiologicosRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly dseis: DseiQueryPayload
  readonly duracaoAtendimentoPadraoMunicipio?: Maybe<DuracaoAtendimentoPadraoMunicipio>
  readonly encaminhamentoEspecializado: EncaminhamentoExternoEspecializado
  readonly encaminhamentos: ReadonlyArray<EncaminhamentoExterno>
  readonly encaminhamentosEspecializados: EncaminhamentoExternoEspecializadoQueryPayload
  readonly endereco?: Maybe<EnderecoQueryPayload>
  readonly equipe: Equipe
  readonly equipes: EquipePayload
  readonly equipesAD: EquipePayload
  readonly equipesAtencaoDom: EquipeAdPayload
  readonly equipesListaCuidadoCompartilhado: ReadonlyArray<Equipe>
  readonly equipesRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly equipesVinculadas: EquipePayload
  readonly escutaInicialDetail?: Maybe<AtendimentoProfissional>
  readonly escutaOrPreAtendimentoOfAtendimento?: Maybe<Scalars['ID']['output']>
  readonly especialidadesEsusReg: EspecialidadesEsusRegQueryPayload
  readonly especialidadesSisreg: EspecialidadeSisregQueryPayload
  readonly esquemaCalendarioVacinal: ReadonlyArray<BaseCalendarioVacinal>
  readonly estabelecimentosCuidadoCompartilhado: UnidadeSaudePayload
  readonly estabelecimentosListaCuidadoCompartilhado: ReadonlyArray<UnidadeSaude>
  readonly estagio: Estagio
  readonly estagios?: Maybe<EstagiosQueryPayload>
  readonly estrategiasRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly estrategiasVacinacao: ReadonlyArray<EstrategiaVacinacao>
  readonly etnias: EtniaPayload
  readonly etniasRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly eventosSdc: ReadonlyArray<SdcPayload>
  readonly evolucoesProcedimentoOdonto: EvolucaoProcedimentoPayload
  readonly evolucoesRegulacao: ReadonlyArray<RegulacaoEvolucao>
  readonly examesRelatorioGerencialExames?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly existeProblemaResolvido: Scalars['Boolean']['output']
  readonly existemAlergiasResolvidasRefutadas: Scalars['Boolean']['output']
  readonly existemFichasParaProcessar: Scalars['Boolean']['output']
  readonly fabricantesImunobiologico: ImunobiologicoFabricanteQueryPayload
  readonly faixaEtariaVacinacao?: Maybe<ReadonlyArray<Maybe<FaixaEtariaVacinacao>>>
  readonly faixasEtariaRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly fatoAtividadeColetiva?: Maybe<FatoAtividadeColetiva>
  readonly fatoAtividadesColetivas: FatoAtividadeColetivaPayload
  readonly fatoresRisco?: Maybe<ReadonlyArray<FatorRisco>>
  readonly fechamentoDia?: Maybe<FechamentoAgenda>
  readonly fechamentos: FechamentoAgendaQueryPayload
  readonly fichasNotificacao: FichaNotificacaoQueryPayload
  readonly formasFarmaceuticas: FormaFarmaceuticaPayload
  readonly frequenciasAlimentacaoRelatorioGerencialCadastroIndividual?: Maybe<
    ReadonlyArray<Scalars['String']['output']>
  >
  readonly funcoesSociais: FuncaoSocialPayload
  readonly garantiaAcessoByUnidadeSaudeId: GarantiaAcessoPayload
  readonly garantiaAcessoItemById: ListaEspera
  readonly gestoresEstaduais: ReadonlyArray<GestorEstadual>
  readonly gestoresMunicipais: ReadonlyArray<GestorMunicipal>
  readonly grupoByEnum: GrupoCondicao
  readonly grupoExame: GrupoExame
  readonly grupoParticipanteAtividadeColetiva: GrupoParticipanteAtividadeColetiva
  readonly grupos: GrupoCondicaoQueryPayLoad
  readonly gruposAtendimento: ReadonlyArray<GrupoAtendimento>
  readonly gruposExame: GruposExameQueryPayload
  readonly gruposParticipantesAtividadeColetiva: GrupoParticipanteAtividadeColetivaPayLoad
  readonly hasAgendaFixada: Scalars['Boolean']['output']
  readonly hasAgendamentoFuturo?: Maybe<Scalars['Boolean']['output']>
  readonly hasConfiguracaoAgenda?: Maybe<Scalars['Boolean']['output']>
  readonly hasDocumentosDuplicados: Scalars['Boolean']['output']
  readonly hasEquipesVinculadas: Scalars['Boolean']['output']
  readonly hasIframes: Scalars['Boolean']['output']
  readonly hasMunicipioAtivo: Scalars['Boolean']['output']
  readonly hasProblemasGestacao?: Maybe<Scalars['Boolean']['output']>
  readonly hasPuericultura: Scalars['Boolean']['output']
  readonly hasVacinaAtrasada: Scalars['Boolean']['output']
  readonly historico: HistoricoPayload
  readonly historicoAcessos: HistoricoAcessoQueryPayload
  readonly historicoAtendimentoDomiciliar?: Maybe<FatoAtendimentoDomiciliar>
  readonly historicoAtendimentoIndividualDw?: Maybe<FatoAtendimentoIndividual>
  readonly historicoAtendimentoOdontoDw?: Maybe<FatoAtendimentoOdonto>
  readonly historicoAtendimentoPec?: Maybe<AtendimentoProfissional>
  readonly historicoAtividadeColetiva?: Maybe<FatoAtividadeColetivaParticipante>
  readonly historicoConsumoAlimentarDetail?: Maybe<HistoricoConsumoAlimentarDetail>
  readonly historicoCuidadoCompartilhadoDw?: Maybe<FatoCuidadoCompartilhado>
  readonly historicoElegibilidadeDetail?: Maybe<FatoAvaliacaoElegibilidade>
  readonly historicoPrescricao: HistoricoPrescricaoQueryPayload
  readonly historicoProcedimentoDw?: Maybe<FatoProcedAtend>
  readonly historicoVacinacaoDw: FatoVacinacao
  readonly historicoVacinacaoPec: AtendimentoVacinacao
  readonly historicoVisitaDomiciliar?: Maybe<FatoVisitaDomiciliar>
  readonly historicoZikaDetail?: Maybe<HistoricoZikaDetail>
  readonly horariosAgenda: ReadonlyArray<HorarioAgenda>
  readonly horariosRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly iceServersConfiguration: IceServersConfig
  readonly identidadesGeneroRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly iframes: ReadonlyArray<Maybe<Iframe>>
  readonly imoveis: ImoveisQueryPayload
  readonly imoveisPermissaoAtualizar: TotalImoveisPermissao
  readonly imovel?: Maybe<ImovelDto>
  readonly importacaoCnes: ImportacaoCnes
  readonly importacoesBolsaFamilia: ImportacaoBolsaFamiliaPayload
  readonly importacoesCnes: ImportacoesCnesQueryPayload
  readonly imunobiologicos: ImunobiologicoQueryPayload
  readonly imunobiologicosRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly ineps: InepPayload
  readonly info: Info
  readonly informacoesPuerperio: InformacoesPuerperioDto
  readonly inscricoesTopicosNotificacao: ReadonlyArray<TopicoNotificacao>
  readonly isAgendaFixada: Scalars['Boolean']['output']
  readonly isAnexoArquivoEverEnabled: Scalars['Boolean']['output']
  readonly isCredencialIntegracaoRegulacaoJaCriada: Scalars['Boolean']['output']
  readonly isDiretorioAnexoArquivosValido: Scalars['Boolean']['output']
  readonly isLotacaoActive: Scalars['Boolean']['output']
  readonly isPainelChamadasHabilitado: Scalars['Boolean']['output']
  readonly isParticipantePermitidoVideochamada: Scalars['Boolean']['output']
  readonly isProcessamentoTerritorioRunning: Scalars['Boolean']['output']
  readonly isTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServico: Scalars['Boolean']['output']
  readonly lembreteProfissional: LembreteProfissional
  readonly lembretes: ReadonlyArray<Maybe<Lembrete>>
  readonly listaMedicamento: ListaMedicamentoAtivoConcluidoQueryPayload
  readonly listaRegulacao: ListaRegulacaoQueryPayload
  readonly listagemCidadaos: CidadaosPayload
  readonly loadHorarioGeracaoLotesProcessamentoFichas?: Maybe<Scalars['LocalTime']['output']>
  readonly locaisAplicacao: ReadonlyArray<LocalAplicacao>
  readonly locaisOcorrencia: LocalOcorrenciaPayload
  readonly localAplicacaoRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly localAtendimento: LocalAtendimentoPayload
  readonly logradouros: LogradouroQueryPayload
  readonly lotacao: Lotacao
  readonly lotacoesAgenda?: Maybe<LotacaoQueryPayload>
  readonly lotacoesAndEstagios: ReadonlyArray<Acesso>
  readonly lotacoesComRegulacoes: ReadonlyArray<Lotacao>
  readonly lotacoesCuidadoCompartilhado: LotacaoQueryPayload
  readonly lotacoesFixadasAgenda: ReadonlyArray<Lotacao>
  readonly loteEnvio: LoteEnvio
  readonly loteHasCadastro?: Maybe<Scalars['Boolean']['output']>
  readonly lotesEnvio: LotesEnvioPayload
  readonly lotesImunobiologico: LotesImunobiologicoQueryPayload
  readonly manifestacoesAlergia: ManifestacaoAlergiaQueryPayload
  readonly marcadorConsumoAlimentar?: Maybe<MarcadorConsumoAlimentar>
  readonly marcosDesenvolvimento?: Maybe<ReadonlyArray<MarcoDesenvolvimento>>
  readonly medicamentos: MedicamentoQueryPayload
  readonly medicamentosCatmat: MedicamentoCatmatQueryPayload
  readonly medicoes: ReadonlyArray<Medicao>
  readonly mesAgenda: MesAgendaLotacao
  readonly mesesRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly microareas: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly microareasImoveis: ReadonlyArray<Scalars['String']['output']>
  readonly modeloPersonalizadoRelatorioGerencialById?: Maybe<ModeloPersonalizadoRelatorioGerencial>
  readonly modelosPersonalizadosByTipoModulo: ReadonlyArray<ModeloPersonalizadoSelect>
  readonly municipios: MunicipiosQueryPayload
  readonly municipiosRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly municipiosResponsaveis: MunicipioResponsavelQueryPayload
  readonly nacionalidadesRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly nomesInstalacoes?: Maybe<NomesInstalacoesUnificacaoDto>
  readonly nomesOutrosProfissionaisAgendamentosConflitantes: ReadonlyArray<NomesProfissionaisAgendamentosConflitantes>
  readonly ocupacoesRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly odontograma: Odontograma
  readonly odontogramas: OdontogramasPayload
  readonly orientacoes: ReadonlyArray<Maybe<Orientacao>>
  readonly orientacoesSexuaisRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly origensAlimentacaoRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly origensRelatorioGerencialExames?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly paises: PaisQueryPayload
  readonly partesBucais: PartesBucaisPayload
  readonly pedidoEnvioBaseAtivo?: Maybe<PedidoEnvioBase>
  readonly pedidosEnvioBase?: Maybe<ReadonlyArray<Maybe<PedidoEnvioBase>>>
  readonly perfil?: Maybe<Perfil>
  readonly perfis: PerfisQueryPayload
  readonly periodoGestacional: PeriodoGestacional
  readonly periogramasCompleto: ReadonlyArray<Maybe<PeriogramaCompleto>>
  readonly periogramasSimplificados: PeriogramaSimplificadoPayload
  readonly planosDeCuidado: ReadonlyArray<AtendimentoObservacaoPlanoCuidado>
  readonly polosBases: PoloBaseQueryPayload
  readonly possuiAgendamentoMesmoProfissionalDataFutura: ReadonlyArray<AgendamentoMesmoProfissionalDataFutura>
  readonly possuiAtendimentosNaoFinalizados?: Maybe<Scalars['Boolean']['output']>
  readonly possuiTratamentoConcluido: Scalars['Boolean']['output']
  readonly presenteOutroAtendimentoNaLista?: Maybe<Scalars['Boolean']['output']>
  readonly primeirasRespostasRelatorioGerencialCuidadoCompartilhado?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly principiosAtivosAlergias: ReadonlyArray<PrincipioAtivo>
  readonly prioridadesRelatorioGerencialCuidadoCompartilhado?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly problema?: Maybe<Problema>
  readonly problemaByCiapCid?: Maybe<Problema>
  readonly problemas: ProblemaQueryPayload
  readonly problemasFaltantesLPC: ReadonlyArray<Maybe<CiapCidSugestao>>
  readonly procedimentos: ProcedimentosQueryPayload
  readonly procedimentosAutomaticos: ReadonlyArray<Maybe<Procedimento>>
  readonly procedimentosEvolucaoOdonto: ProcedimentosQueryPayload
  readonly processamentoStatus?: Maybe<ProcessamentoStatusEnum>
  readonly profissionais: ProfissionaisQueryPayload
  readonly profissionaisAD: ProfissionaisQueryPayload
  readonly profissionaisListaCuidadoCompartilhado: ReadonlyArray<Profissional>
  readonly profissionaisRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly profissionaisRelatorioInconsistencia: ProfissionaisInconsistenciaQueryPayload
  readonly profissional: Profissional
  readonly profissionalByCpfContraChave?: Maybe<Profissional>
  readonly proximaDoseAprazamentoAutomatico?: Maybe<ProximaDoseAprazamento>
  readonly racasCoresRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly realizadoPorRelatorioGerencialCuidadoCompartilhado?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly recuperarSenhaBloqueado: Scalars['Boolean']['output']
  readonly recursos: ReadonlyArray<Scalars['String']['output']>
  readonly recursosByAtorPapelId: ReadonlyArray<Scalars['String']['output']>
  readonly registroAvaliacaoPuericultura: RegistroAvaliacaoPuericultura
  readonly registrosAplicadosVacinacao?: Maybe<ReadonlyArray<RegistroAplicado>>
  readonly registrosDoseVacinacao?: Maybe<ReadonlyArray<Maybe<RegistroDose>>>
  readonly registrosMChat?: Maybe<ReadonlyArray<MChat>>
  readonly regrasVacinaisValidasUltimaVersao: ReadonlyArray<RegraVacinal>
  readonly regulacao?: Maybe<Regulacao>
  readonly relatorioProducaoAtendimentoDomiciliar: RelatorioProducaoAtendimentoDomiciliar
  readonly relatorioProducaoAtendimentoIndividual: RelatorioProducaoAtendimentoIndividual
  readonly relatorioProducaoAtendimentoOdonto: RelatorioProducaoAtendimentoOdonto
  readonly relatorioProducaoAtividadeColetiva: RelatorioProducaoAtividadeColetiva
  readonly relatorioProducaoProcedimentosIndividualizados: RelatorioProducaoProcedimentosIndividualizados
  readonly relatorioProducaoVacinacao: RelatorioProducaoVacinacao
  readonly relatorioProducaoVisitaDomiciliarTerritorial: RelatorioProducaoVisitaDomiciliarTerritorial
  readonly responsaveisCriancaRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly resultadosExame: ResultadosExamePayload
  readonly resumoEnviosRnds: QuantidadeStatusEnvioRndsDto
  readonly riscos: ReadonlyArray<Risco>
  readonly salasUnidadeSaude: ReadonlyArray<SalaUnidadeSaude>
  readonly seguranca: ConfiguracaoSeguranca
  readonly serieHistorica: ReadonlyArray<SerieHistoricaPayload>
  readonly serverTime: Scalars['Instant']['output']
  readonly serverTimezoneOffset: Scalars['Int']['output']
  readonly servidores: ConfiguracaoServidoresFormDto
  readonly sessao?: Maybe<Sessao>
  readonly sexosRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly simNaoNaoInformadoRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly simNaoRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly sincronizacaoCadsusPolling?: Maybe<SincronizacaoCadsusResultDto>
  readonly sistemaExterno: SistemaExterno
  readonly sistemasExternos: SistemaExternoPayload
  readonly situacoesTrabalhoRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly solicitacoesExame: SolicitacoesExamePayload
  readonly solicitacoesExamePaged: SolicitacoesExamePayload
  readonly statusConexaoRnds: StatusConexaoRndsEnum
  readonly substanciasCbaraAlergia: SubstanciaCbaraAlergiaQueryPayload
  readonly sugestoesDatas: SugestoesDatas
  readonly sugestoesProfissionais: ProfissionaisSugestaoAgendamento
  readonly tecidosMoles: TecidosMolesPayload
  readonly tempoEntreAgendamentoEConsultaRelatorioGerencialAbsenteismo?: Maybe<
    ReadonlyArray<Scalars['String']['output']>
  >
  readonly temposDeEsperaRelatorioGerencialCuidadoCompartilhado?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly temposDeRespostaRelatorioGerencialCuidadoCompartilhado?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly temposSituacaoRuaRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly territorioEquipe: TerritorioEquipeDto
  readonly territorioLogradouro: ReadonlyArray<ImovelDto>
  readonly territorioMicroarea: TerritorioMicroarea
  readonly tipoAleitamentoMaterno: AleitamentoMaterno
  readonly tipoRegistroHistorico?: Maybe<ReadonlyArray<Maybe<TipoRegistroHistoricoClinico>>>
  readonly tiposCondicaoPesoRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposDeAtendimentoRelatorioGerencialAtendimento?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposDeConsultaRelatorioGerencialAtendimento?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposDeFaltaRelatorioGerencialAbsenteismo?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposDoencaCardiacaRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposDoencaRespiratoriaRelatorioGerencialCadastroIndividual?: Maybe<
    ReadonlyArray<Scalars['String']['output']>
  >
  readonly tiposEscolaridadeRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposHigienePessoalRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposLogradouro: TipoLogradouroQueryPayload
  readonly tiposOrigemDadoTransporte: ReadonlyArray<TipoOrigemDadoTransporte>
  readonly tiposParentescoRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposProblemaRenalRelatorioGerencialCadastroIndividual?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposProducaoRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly tiposReceitaProibidos: ReadonlyArray<TipoReceitaEnum>
  readonly tiposServico: TipoServicoQueryPayload
  readonly todasVinculacoesEquipeEmulti: TodasVinculacoesEquipesPayload
  readonly topicoNotificacao?: Maybe<TopicoNotificacao>
  readonly transmissao: Transmissao
  /** @deprecated use transmissao.links */
  readonly transmissaoLink: TransmissaoLinksPayload
  readonly transmissaoRecebimentoCnes: TransmissaoRecebimentoCnesPayload
  readonly transmissaoRecebimentoCnesDetailItems: ReadonlyArray<Maybe<TransmissaoRecebimentoCnesDetailItem>>
  readonly transmissaoRecebimentoLotes: TransmissaoRecebimentoQueryPayload
  readonly turnosRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly ultimaAvaliacaoMultidimensional?: Maybe<Scalars['Instant']['output']>
  readonly ultimaSolicitacaoCitopatologicoUtero?: Maybe<ExameCitopatologicoUteroPayload>
  readonly ultimaVacinaAprazada?: Maybe<UltimaVacina>
  readonly ultimasMedicoesDiasAnteriores: ReadonlyArray<GrupoMedicoesTipo>
  readonly ultimasMedicoesDoDia: ReadonlyArray<GrupoMedicoesTipo>
  readonly ultimasTresVacinasAplicadas?: Maybe<ReadonlyArray<Maybe<UltimaVacina>>>
  readonly ultimoAcesso?: Maybe<HistoricoAcesso>
  readonly ultimoArquivoTemporarioProntoEmProcessamento?: Maybe<ArquivoTemporario>
  readonly ultimoAtendimentoProfissionalCidadao?: Maybe<AtendimentoProfissional>
  readonly ultimoAtendimentoProfissionalComMCAByProntuarioId?: Maybe<AtendimentoProfissional>
  readonly ultimoAtendimentoPuericultura: AtendimentoPuericultura
  readonly ultimoIvcf: UltimoIvcfDto
  readonly ultimoMChatR?: Maybe<MChat>
  readonly ultimoMChatRf?: Maybe<MChat>
  readonly ultimosCincoArquivosTemporarios: ReadonlyArray<ArquivoTemporario>
  readonly unidadeSaude: UnidadeSaude
  readonly unidadeSaudeTiposServico: UnidadeSaudeTiposServicoPayload
  readonly unidadesConsultaHorus: ReadonlyArray<Maybe<HorusFormDto>>
  readonly unidadesMedida: UnidadeMedidaPayload
  readonly unidadesSaude: UnidadeSaudePayload
  readonly unidadesSaudeByGarantiaAcessoCidadao: ReadonlyArray<UnidadeSaude>
  readonly unidadesSaudeByTipoVinculacaoServico: ReadonlyArray<UnidadeSaude>
  readonly unidadesSaudeRelatorioGerencial?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly unificacoesBase?: Maybe<ReadonlyArray<Maybe<UnificacaoBase>>>
  readonly unificacoesCidadao?: Maybe<ReadonlyArray<Maybe<UnificacoesCidadao>>>
  readonly validatePermissaoNovoAdmin: Scalars['Boolean']['output']
  readonly validateResetAdmin: Scalars['Boolean']['output']
  readonly viaAdmLocalAplicacaoVacina: ReadonlyArray<ViaAdmLocalAplicacaoVacina>
  readonly viaAdministracaoRelatorioGerencialVacinacao?: Maybe<ReadonlyArray<Scalars['String']['output']>>
  readonly viasAdministracaoVacina: ReadonlyArray<ViaAdministracao>
  readonly videochamada?: Maybe<Videochamada>
  readonly vigenciaMaisRecente?: Maybe<VigenciaBolsaFamilia>
  readonly vinculacaoServico?: Maybe<VinculacaoServicoDto>
  readonly vinculacoesServico: VinculacaoServicosPayload
  readonly visita?: Maybe<FatoVisitaDomiciliar>
  readonly visitas: VisitasQueryPayload
}

export type QueryAbsenteismosArgs = {
  input: RelatorioGerencialAbsenteismoInput
}

export type QueryAcessoArgs = {
  id: Scalars['ID']['input']
}

export type QueryAcompanhamentoCidadaosVinculadosArgs = {
  input: AcompanhamentoCidadaosVinculadosFilterInput
}

export type QueryAcompanhamentoCondicaoSaudeArgs = {
  input: AcompanhamentoCondicaoSaudeQueryInput
}

export type QueryAcompanhamentoPreNatalExamesArgs = {
  input: ExamesPreNatalInput
}

export type QueryAcompanhamentoPreNatalVacinacaoArgs = {
  input: AcompanhamentosVacinacaoInput
}

export type QueryAcompanhamentoPuerperioExamesArgs = {
  input: AcompanhamentosProntuarioInput
}

export type QueryAcompanhamentoPuerperioVisitasDomiciliaresArgs = {
  input: AcompanhamentosVisitasDomiciliaresInput
}

export type QueryAgendaEmConflitoArgs = {
  lotacaoId: Scalars['ID']['input']
}

export type QueryAgendadoArgs = {
  id: Scalars['ID']['input']
}

export type QueryAgendadosArgs = {
  input: AgendadosQueryInput
}

export type QueryAldeiasArgs = {
  input: AldeiaInput
}

export type QueryAlergiaArgs = {
  id: Scalars['ID']['input']
}

export type QueryAlergiasArgs = {
  input: AlergiasQueryInput
}

export type QueryAlteracoesFenotipicasArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryAntecedenteArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryAplicacoesMedicamentoArgs = {
  input?: InputMaybe<AplicacaoMedicamentoQueryInput>
}

export type QueryArquivosAnexadosNoProntuarioArgs = {
  prontuarioId: Scalars['Long']['input']
}

export type QueryArquivosTemporariosArgs = {
  input: ArquivoTemporarioPagingQueryInput
}

export type QueryAsyncProcessingStatusArgs = {
  asyncProcessingName: AsyncProcessingNameEnum
}

export type QueryAtendimentoArgs = {
  id: Scalars['ID']['input']
}

export type QueryAtendimentoIndividualArgs = {
  id: Scalars['ID']['input']
}

export type QueryAtendimentosArgs = {
  input: AtendimentosQueryInput
}

export type QueryAtendimentosDoDiaArgs = {
  id: Scalars['ID']['input']
}

export type QueryAtendimentosFinalizadosArgs = {
  input: AtendimentosFinalizadosInput
}

export type QueryAtendimentosProfUltimaGestacaoArgs = {
  onlyProblemaAtivo?: InputMaybe<Scalars['Boolean']['input']>
  prontuarioId: Scalars['ID']['input']
}

export type QueryAtendimentosProfissionalArgs = {
  input: AtendimentosProfissionalQueryInput
}

export type QueryAtestadoArgs = {
  id: Scalars['ID']['input']
}

export type QueryAtestadoModeloArgs = {
  id: Scalars['ID']['input']
}

export type QueryAtestadosArgs = {
  input?: InputMaybe<AtestadoQueryInput>
}

export type QueryAtividadeColetivaArgs = {
  atividadeColetivaId: Scalars['Long']['input']
}

export type QueryAtividadesColetivasArgs = {
  input: AtividadeColetivaQueryInput
}

export type QueryAuditoriaHistoricoArgs = {
  input: AuditoriaHistoricoQueryInput
}

export type QueryAutorizacaoRetiradaAbsorventeByCidadaoIdArgs = {
  id: Scalars['ID']['input']
}

export type QueryBairrosArgs = {
  input: BairroInput
}

export type QueryBundlesFhirComAssinaturaPendenteArgs = {
  atendProfId: Scalars['ID']['input']
}

export type QueryBuscaAtivaVacinacaoArgs = {
  input: BuscaAtivaVacinacaoInput
}

export type QueryBuscaCidadaoCadsusAtualizadoArgs = {
  buscaCidadaoCadsusInput: BuscaCidadaoCadsusInput
}

export type QueryBuscaCidadaoCadsusAtualizadoForcadoArgs = {
  buscaCidadaoCadsusInput: BuscaCidadaoCadsusInput
}

export type QueryBuscaCidadaosCadsusArgs = {
  filtro: BuscaListaCidadaoCadsusInput
}

export type QueryBuscaCidadaosCadsusCompletoPollingArgs = {
  uuid: Scalars['String']['input']
}

export type QueryCadastrosDuplicadosArgs = {
  input: CidadaoUnificacaoBaseInput
}

export type QueryCategoriasProfissionalRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryCboGrupoArgs = {
  acessoCbo?: InputMaybe<AcessoCbo>
}

export type QueryCbosArgs = {
  input: CbosQueryInput
}

export type QueryCbosListaCuidadoCompartilhadoArgs = {
  input: CbosListaCuidadoCompartilhadoQueryInput
}

export type QueryCbosPrescritoresRelatorioGerencialVacinacaoArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryCbosRelatorioGerencialArgs = {
  input?: InputMaybe<Scalars['String']['input']>
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryCbosTrocaExecutanteArgs = {
  input: CbosTrocaExecutanteCuidadoCompartilhadoQueryInput
}

export type QueryCbosVinculacoesServicoArgs = {
  input: CbosCuidadoCompartilhadoQueryInput
}

export type QueryCertificadosArgs = {
  input: CertificadoQueryInput
}

export type QueryChaveByCpfArgs = {
  cpf: Scalars['String']['input']
}

export type QueryCiapsArgs = {
  input: CiapQueryInput
}

export type QueryCiapsByCodigosArgs = {
  input: CiapByCodigosQueryInput
}

export type QueryCid10MotivosIndicacoesRelatorioGerencialVacinacaoArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryCidadaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryCidadaoAdArgs = {
  input: Scalars['ID']['input']
}

export type QueryCidadaosArgs = {
  input: CidadaosQueryInput
}

export type QueryCidadaosAdArgs = {
  input: CidadaosAdQueryInput
}

export type QueryCidadaosByDocumentosArgs = {
  input: FiltroDocumentosCidadaoInput
}

export type QueryCidadaosComboArgs = {
  atencaoDomiciliar?: Scalars['Boolean']['input']
  equipeResponsavelId?: InputMaybe<Scalars['ID']['input']>
  input: CidadaosComboQueryInput
}

export type QueryCidadaosComboByCnsArgs = {
  input: CidadaosComboQueryInput
}

export type QueryCidadaosComboByCpfArgs = {
  input: CidadaosComboQueryInput
}

export type QueryCidadaosComboByDataNascimentoArgs = {
  input: CidadaosComboQueryInput
}

export type QueryCidadaosComboByNomeArgs = {
  input: CidadaosComboQueryInput
}

export type QueryCidadaosTerritorioArgs = {
  cidadaosIds: ReadonlyArray<Scalars['ID']['input']>
}

export type QueryCidsArgs = {
  input: Cid10QueryInput
}

export type QueryCids11Args = {
  input: Cid11QueryInput
}

export type QueryCnsJaCadastradoArgs = {
  cns?: InputMaybe<Scalars['String']['input']>
}

export type QueryCompartilhamentosCuidadoPlanoArgs = {
  input: CompartilhamentoCuidadoPlanoQueryInput
}

export type QueryCondicoesAutorreferidasArgs = {
  cidadaoId: Scalars['ID']['input']
}

export type QueryConselhosClasseArgs = {
  input: ConselhoClasseQueryInput
}

export type QueryConsultaEstoqueHorusArgs = {
  input: ConsultaEstoqueHorusQueryInput
}

export type QueryContatoCidadaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryCpfJaCadastradoArgs = {
  cpf?: InputMaybe<Scalars['String']['input']>
}

export type QueryCredenciaisIntegracaoArgs = {
  input: CredencialIntegracaoQueryInput
}

export type QueryCredencialIntegracaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryCuidadoCompartilhadoArgs = {
  id: Scalars['ID']['input']
}

export type QueryCuidadoCompartilhadoEvolucaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryCuidadoCompartilhadoEvolucoesArgs = {
  input: CuidadoCompartilhadoEvolucoesQueryInput
}

export type QueryCuidadoCompartilhadoFinalizacoesArgs = {
  input: CuidadoCompartilhadoEvolucoesQueryInput
}

export type QueryCuidadosCompartilhadoArgs = {
  input: CuidadosCompartilhadoQueryInput
}

export type QueryDataLimiteAlterarSenhaArgs = {
  login?: InputMaybe<Scalars['String']['input']>
}

export type QueryDataUltimaConsultaOdontoGestanteArgs = {
  filter: DataUltimaConsultaOdontoGestanteQueryInput
}

export type QueryDiasDaSemanaRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryDimensaoAgrupadorFiltroArgs = {
  input: DimensaoAgrupadorFiltroQueryInput
}

export type QueryDimensaoCategoriaProfissionalArgs = {
  input: DimensaoCategoriaProfissionalQueryInput
}

export type QueryDimensaoEquipeArgs = {
  input: DimensaoEquipeQueryInput
}

export type QueryDimensaoMunicipiosArgs = {
  input: DimensaoMunicipiosQueryInput
}

export type QueryDimensaoUnidadeSaudeArgs = {
  input: DimensaoUnidadeSaudeQueryInput
}

export type QueryDispositivosPareadosUnidadeSaudeArgs = {
  unidadeSaudeId: Scalars['ID']['input']
}

export type QueryDoseImunobiologicoVacinacaoArgs = {
  input?: InputMaybe<DoseImunobiologicoVacinacaoQueryInput>
}

export type QueryDosesImunobiologicosRelatorioGerencialVacinacaoArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryDseisArgs = {
  input: DseiInput
}

export type QueryEncaminhamentoEspecializadoArgs = {
  id: Scalars['ID']['input']
}

export type QueryEncaminhamentosArgs = {
  input?: InputMaybe<EncaminhamentoExternoQueryInput>
}

export type QueryEncaminhamentosEspecializadosArgs = {
  input?: InputMaybe<EncaminhamentoExternoEspecializadoQueryInput>
}

export type QueryEnderecoArgs = {
  cep: Scalars['String']['input']
}

export type QueryEquipeArgs = {
  id: Scalars['ID']['input']
}

export type QueryEquipesArgs = {
  input: EquipesQueryInput
}

export type QueryEquipesAdArgs = {
  input: EquipesAdQueryInput
}

export type QueryEquipesAtencaoDomArgs = {
  input?: InputMaybe<EquipeAdInput>
}

export type QueryEquipesListaCuidadoCompartilhadoArgs = {
  input: EquipesListaCuidadoCompartilhadoQueryInput
}

export type QueryEquipesRelatorioGerencialArgs = {
  input?: InputMaybe<Scalars['String']['input']>
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryEquipesVinculadasArgs = {
  input: EquipesQueryInput
}

export type QueryEscutaInicialDetailArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryEscutaOrPreAtendimentoOfAtendimentoArgs = {
  input: EscutaOrPreAtendimentoOfAtendimentoInput
}

export type QueryEspecialidadesEsusRegArgs = {
  input: EspecialidadesEsusQueryInput
}

export type QueryEspecialidadesSisregArgs = {
  input?: InputMaybe<EspecialidadeSisregQueryInput>
}

export type QueryEsquemaCalendarioVacinalArgs = {
  input: EsquemaCalendarioVacinalQueryInput
}

export type QueryEstabelecimentosCuidadoCompartilhadoArgs = {
  input: EstabelecimentosCuidadoCompartilhadoByCboIdQueryInput
}

export type QueryEstabelecimentosListaCuidadoCompartilhadoArgs = {
  input: EstabelecimentosListaCuidadoCompartilhadoQueryInput
}

export type QueryEstagioArgs = {
  id: Scalars['ID']['input']
}

export type QueryEstagiosArgs = {
  input?: InputMaybe<EstagiosQueryInput>
}

export type QueryEstrategiasVacinacaoArgs = {
  input: EstrategiasVacinacaoQueryInput
}

export type QueryEtniasArgs = {
  input: EtniaQueryInput
}

export type QueryEtniasRelatorioGerencialCadastroIndividualArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryEventosSdcArgs = {
  input: SdcInput
}

export type QueryEvolucoesProcedimentoOdontoArgs = {
  input: EvolucoesProcedimentoOdontoInput
}

export type QueryEvolucoesRegulacaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryExamesRelatorioGerencialExamesArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryExisteProblemaResolvidoArgs = {
  input: Scalars['ID']['input']
}

export type QueryExistemAlergiasResolvidasRefutadasArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryFabricantesImunobiologicoArgs = {
  input: ImunobiologicoFabricanteQueryInput
}

export type QueryFaixaEtariaVacinacaoArgs = {
  input?: InputMaybe<FaixaEtariaVacinacaoQueryInput>
}

export type QueryFaixasEtariaRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryFatoAtividadeColetivaArgs = {
  input: Scalars['ID']['input']
}

export type QueryFatoAtividadesColetivasArgs = {
  input: AtividadeColetivaQueryInput
}

export type QueryFatoresRiscoArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryFechamentoDiaArgs = {
  input?: InputMaybe<FechamentoAgendaDiaQueryInput>
}

export type QueryFechamentosArgs = {
  input?: InputMaybe<FechamentoAgendaQueryInput>
}

export type QueryFichasNotificacaoArgs = {
  input: FichaNotificacaoQueryInput
}

export type QueryFormasFarmaceuticasArgs = {
  input: FormaFarmaceuticaQueryInput
}

export type QueryFuncoesSociaisArgs = {
  input: FuncaoSocialQueryInput
}

export type QueryGarantiaAcessoByUnidadeSaudeIdArgs = {
  input: GarantiaAcessoFilter
}

export type QueryGarantiaAcessoItemByIdArgs = {
  input: Scalars['ID']['input']
}

export type QueryGrupoByEnumArgs = {
  input: GrupoCondicaoEnum
}

export type QueryGrupoExameArgs = {
  id: Scalars['ID']['input']
}

export type QueryGrupoParticipanteAtividadeColetivaArgs = {
  grupoParticipanteAtividadeColetivaId: Scalars['ID']['input']
}

export type QueryGruposArgs = {
  input: GrupoCondicaoQueryInput
}

export type QueryGruposAtendimentoArgs = {
  inputQuery?: InputMaybe<Scalars['String']['input']>
  onlyAtivos?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryGruposExameArgs = {
  input: GrupoExameQueryInput
}

export type QueryGruposParticipantesAtividadeColetivaArgs = {
  input?: InputMaybe<GrupoParticipanteAtividadeColetivaQueryInput>
}

export type QueryHasAgendamentoFuturoArgs = {
  input: CidadaoPossuiAgendamentoFuturoQueryInput
}

export type QueryHasConfiguracaoAgendaArgs = {
  lotacaoId: Scalars['ID']['input']
}

export type QueryHasDocumentosDuplicadosArgs = {
  unificacaoBaseId: Scalars['ID']['input']
}

export type QueryHasEquipesVinculadasArgs = {
  equipePrincipalId: Scalars['ID']['input']
}

export type QueryHasIframesArgs = {
  input?: InputMaybe<IframesQueryInput>
}

export type QueryHasProblemasGestacaoArgs = {
  id: Scalars['Long']['input']
}

export type QueryHasPuericulturaArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryHasVacinaAtrasadaArgs = {
  input: VacinacaoUltimaVacinaInput
}

export type QueryHistoricoArgs = {
  input: HistoricoQueryInput
}

export type QueryHistoricoAcessosArgs = {
  input: HistoricoAcessoQueryInput
}

export type QueryHistoricoAtendimentoDomiciliarArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoAtendimentoIndividualDwArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoAtendimentoOdontoDwArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoAtendimentoPecArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoAtividadeColetivaArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoConsumoAlimentarDetailArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoCuidadoCompartilhadoDwArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoElegibilidadeDetailArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoPrescricaoArgs = {
  input: HistoricoPrescricaoQueryInput
}

export type QueryHistoricoProcedimentoDwArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoVacinacaoDwArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoVacinacaoPecArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoVisitaDomiciliarArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHistoricoZikaDetailArgs = {
  input: HistoricoDetailQueryInput
}

export type QueryHorariosAgendaArgs = {
  input: HorariosAgendaQueryInput
}

export type QueryHorariosRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryIceServersConfigurationArgs = {
  input: IceServersConfigurationInput
}

export type QueryIframesArgs = {
  input?: InputMaybe<IframesQueryInput>
}

export type QueryImoveisArgs = {
  input: ImoveisQueryInput
}

export type QueryImoveisPermissaoAtualizarArgs = {
  input: TerritorioMicroareaQueryInput
}

export type QueryImovelArgs = {
  imovelId: Scalars['ID']['input']
}

export type QueryImportacaoCnesArgs = {
  id: Scalars['ID']['input']
}

export type QueryImportacoesBolsaFamiliaArgs = {
  input: ImportacaoBolsaFamiliaQueryInput
}

export type QueryImportacoesCnesArgs = {
  input: ImportacoesCnesQueryInput
}

export type QueryImunobiologicosArgs = {
  input: ImunobiologicoQueryInput
}

export type QueryImunobiologicosRelatorioGerencialVacinacaoArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryInepsArgs = {
  input: InepQueryInput
}

export type QueryInformacoesPuerperioArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryInscricoesTopicosNotificacaoArgs = {
  input: InscricoesTopicosNotificacaoQueryInput
}

export type QueryIsAgendaFixadaArgs = {
  lotacaoId: Scalars['ID']['input']
}

export type QueryIsDiretorioAnexoArquivosValidoArgs = {
  diretorio: Scalars['String']['input']
}

export type QueryIsLotacaoActiveArgs = {
  isLotacaoActiveInput: IsLotacaoActiveInput
}

export type QueryIsPainelChamadasHabilitadoArgs = {
  unidadeSaudeId: Scalars['ID']['input']
}

export type QueryIsParticipantePermitidoVideochamadaArgs = {
  input?: InputMaybe<VerificarParticipantePermitidoVideochamadaInput>
}

export type QueryIsProcessamentoTerritorioRunningArgs = {
  token: Scalars['ID']['input']
}

export type QueryIsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoArgs = {
  tipoCoMs: Scalars['Long']['input']
}

export type QueryLembreteProfissionalArgs = {
  input: LembreteProfissionalInput
}

export type QueryLembretesArgs = {
  input: LembretesQueryInput
}

export type QueryListaMedicamentoArgs = {
  input: ListaMedicamentoAtivoConcluidoQueryInput
}

export type QueryListaRegulacaoArgs = {
  input: ListaRegulacaoQueryInput
}

export type QueryListagemCidadaosArgs = {
  input: CidadaosQueryInput
}

export type QueryLocaisAplicacaoArgs = {
  input: LocalAplicacaoQueryInput
}

export type QueryLocaisOcorrenciaArgs = {
  input: LocalOcorrenciaQueryInput
}

export type QueryLocalAplicacaoRelatorioGerencialVacinacaoArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryLocalAtendimentoArgs = {
  input: LocalAtendimentoQueryInput
}

export type QueryLogradourosArgs = {
  input: LogradouroInput
}

export type QueryLotacaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryLotacoesAgendaArgs = {
  input?: InputMaybe<LotacoesAgendaInput>
}

export type QueryLotacoesAndEstagiosArgs = {
  input?: InputMaybe<LotacoesAndEstagiosInput>
}

export type QueryLotacoesComRegulacoesArgs = {
  input: LotacoesComRegulacoesQueryInput
}

export type QueryLotacoesCuidadoCompartilhadoArgs = {
  input: LotacoesCuidadoCompartilhadoByEstabelecimentoIdQueryInput
}

export type QueryLotacoesFixadasAgendaArgs = {
  input: LotacoesAgendaFixadaInput
}

export type QueryLoteEnvioArgs = {
  idLote: Scalars['ID']['input']
}

export type QueryLoteHasCadastroArgs = {
  input: LoteImunobiologicoInput
}

export type QueryLotesEnvioArgs = {
  input: LotesEnvioFiltro
}

export type QueryLotesImunobiologicoArgs = {
  input?: InputMaybe<LoteImunobiologicoQueryInput>
}

export type QueryManifestacoesAlergiaArgs = {
  input?: InputMaybe<ManifestacoesAlergiaQueryInput>
}

export type QueryMarcadorConsumoAlimentarArgs = {
  atendProfId: Scalars['ID']['input']
}

export type QueryMarcosDesenvolvimentoArgs = {
  input: MarcoDesenvolvimentoLoadInput
}

export type QueryMedicamentosArgs = {
  input: MedicamentoQueryInput
}

export type QueryMedicamentosCatmatArgs = {
  input: MedicamentoCatmatQueryInput
}

export type QueryMedicoesArgs = {
  input: MedicoesQueryInput
}

export type QueryMesAgendaArgs = {
  input?: InputMaybe<MesAgendaQueryInput>
}

export type QueryMesesRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryMicroareasArgs = {
  equipeResponsavelId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryMicroareasImoveisArgs = {
  input: TerritorioEquipeQueryInput
}

export type QueryModeloPersonalizadoRelatorioGerencialByIdArgs = {
  id: Scalars['ID']['input']
}

export type QueryModelosPersonalizadosByTipoModuloArgs = {
  tipoModulo: TipoModuloEnum
}

export type QueryMunicipiosArgs = {
  input: MunicipiosQueryInput
}

export type QueryMunicipiosRelatorioGerencialArgs = {
  input?: InputMaybe<Scalars['String']['input']>
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryMunicipiosResponsaveisArgs = {
  input: MunicipioResponsavelFiltroInput
}

export type QueryNomesOutrosProfissionaisAgendamentosConflitantesArgs = {
  input: AgendamentoConflitanteInput
}

export type QueryOcupacoesRelatorioGerencialCadastroIndividualArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryOdontogramaArgs = {
  id: Scalars['ID']['input']
}

export type QueryOdontogramasArgs = {
  input: OdontogramasQueryInput
}

export type QueryOrientacoesArgs = {
  input: OrientacaoQueryInput
}

export type QueryPaisesArgs = {
  input: PaisQueryInput
}

export type QueryPartesBucaisArgs = {
  input?: InputMaybe<PartesBucaisQueryInput>
}

export type QueryPerfilArgs = {
  id: Scalars['ID']['input']
}

export type QueryPerfisArgs = {
  input: PerfisQueryInput
}

export type QueryPeriodoGestacionalArgs = {
  input: PeriodoGestacionalQueryInput
}

export type QueryPeriogramasCompletoArgs = {
  input: PeriogramaCompletoQueryInput
}

export type QueryPeriogramasSimplificadosArgs = {
  input: PeriogramaSimplificadoQueryInput
}

export type QueryPlanosDeCuidadoArgs = {
  atendProfId: Scalars['ID']['input']
}

export type QueryPolosBasesArgs = {
  input: PoloBaseInput
}

export type QueryPossuiAgendamentoMesmoProfissionalDataFuturaArgs = {
  input: AgendamentoConflitanteInput
}

export type QueryPossuiAtendimentosNaoFinalizadosArgs = {
  input?: InputMaybe<PossuiAtendimentosNaoFinalizadosInput>
}

export type QueryPossuiTratamentoConcluidoArgs = {
  input: PossuiTratamentoConcluidoQueryInput
}

export type QueryPresenteOutroAtendimentoNaListaArgs = {
  input: CidadaoPresenteOutroAtendimentoNaListaQueryInput
}

export type QueryPrincipiosAtivosAlergiasArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryProblemaArgs = {
  id: Scalars['ID']['input']
}

export type QueryProblemaByCiapCidArgs = {
  input: ProblemaByCiapCidQueryInput
}

export type QueryProblemasArgs = {
  input: ProblemaQueryInput
}

export type QueryProblemasFaltantesLpcArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryProcedimentosArgs = {
  input: ProcedimentoQueryInput
}

export type QueryProcedimentosEvolucaoOdontoArgs = {
  input?: InputMaybe<ProcedimentoOdontoQueryInput>
}

export type QueryProfissionaisArgs = {
  input: ProfissionaisQueryInput
}

export type QueryProfissionaisAdArgs = {
  equipeFilter: EquipesAdQueryInput
  profissionalFilter: ProfissionaisAdQueryInput
}

export type QueryProfissionaisListaCuidadoCompartilhadoArgs = {
  input: ProfissionaisListaCuidadoCompartilhadoQueryInput
}

export type QueryProfissionaisRelatorioGerencialArgs = {
  input?: InputMaybe<Scalars['String']['input']>
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryProfissionaisRelatorioInconsistenciaArgs = {
  filtro: ProfissionaisRelatorioInconsistenciaQueryInput
}

export type QueryProfissionalArgs = {
  id: Scalars['ID']['input']
}

export type QueryProfissionalByCpfContraChaveArgs = {
  input: CpfContraChaveInput
}

export type QueryProximaDoseAprazamentoAutomaticoArgs = {
  input: ProximaDoseAprazamentoQueryInput
}

export type QueryRecursosArgs = {
  tipoAcesso?: InputMaybe<TipoAcesso>
}

export type QueryRecursosByAtorPapelIdArgs = {
  atorPapelId: Scalars['ID']['input']
}

export type QueryRegistrosAplicadosVacinacaoArgs = {
  input: RegistrosAplicadosVacinacaoInput
}

export type QueryRegistrosDoseVacinacaoArgs = {
  input: RegistrosDoseVacinacaoInput
}

export type QueryRegistrosMChatArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryRegrasVacinaisValidasUltimaVersaoArgs = {
  input?: InputMaybe<RegrasVacinaisQueryInput>
}

export type QueryRegulacaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryRelatorioProducaoAtendimentoDomiciliarArgs = {
  input: RelatorioProducaoAtendimentoDomiciliarQueryInput
}

export type QueryRelatorioProducaoAtendimentoIndividualArgs = {
  input: RelatorioProducaoAtendimentoIndividualQueryInput
}

export type QueryRelatorioProducaoAtendimentoOdontoArgs = {
  input: RelatorioProducaoAtendimentoOdontoQueryInput
}

export type QueryRelatorioProducaoAtividadeColetivaArgs = {
  input: RelatorioProducaoAtividadeColetivaQueryInput
}

export type QueryRelatorioProducaoProcedimentosIndividualizadosArgs = {
  input: RelatorioProducaoProcedimentosIndividualizadosQueryInput
}

export type QueryRelatorioProducaoVacinacaoArgs = {
  input: RelatorioProducaoVacinacaoQueryInput
}

export type QueryRelatorioProducaoVisitaDomiciliarTerritorialArgs = {
  input: RelatorioProducaoVisitaDomiciliarTerritorialQueryInput
}

export type QueryResultadosExameArgs = {
  input: ResultadosExameQueryInput
}

export type QueryResumoEnviosRndsArgs = {
  input: TipoRegistroRndsEnum
}

export type QueryRiscosArgs = {
  input: RiscoInput
}

export type QuerySalasUnidadeSaudeArgs = {
  unidadeSaudeId: Scalars['ID']['input']
}

export type QuerySerieHistoricaArgs = {
  input: SerieHistoricaQueryInput
}

export type QuerySexosRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QuerySimNaoNaoInformadoRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QuerySimNaoRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QuerySincronizacaoCadsusPollingArgs = {
  uuid: Scalars['String']['input']
}

export type QuerySistemaExternoArgs = {
  id: Scalars['ID']['input']
}

export type QuerySistemasExternosArgs = {
  input: SistemaExternoQueryInput
}

export type QuerySolicitacoesExameArgs = {
  input: SolicitacoesExameQueryInput
}

export type QuerySolicitacoesExamePagedArgs = {
  input: SolicitacoesExameQueryInput
}

export type QuerySubstanciasCbaraAlergiaArgs = {
  input: SubstanciasCbaraAlergiaQueryInput
}

export type QuerySugestoesDatasArgs = {
  input: SugestoesDatasInput
}

export type QuerySugestoesProfissionaisArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryTecidosMolesArgs = {
  input: TecidosMolesQueryInput
}

export type QueryTerritorioEquipeArgs = {
  input: TerritorioEquipeQueryInput
}

export type QueryTerritorioLogradouroArgs = {
  input: TerritorioMicroareaQueryInput
}

export type QueryTerritorioMicroareaArgs = {
  input: TerritorioMicroareaQueryInput
}

export type QueryTipoAleitamentoMaternoArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryTipoRegistroHistoricoArgs = {
  input?: InputMaybe<TipoRegistroHistoricoClinicoQueryInput>
}

export type QueryTiposLogradouroArgs = {
  input: TipoLogradouroInput
}

export type QueryTiposProducaoRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryTiposServicoArgs = {
  input: TipoServicoQueryInput
}

export type QueryTodasVinculacoesEquipeEmultiArgs = {
  input: TodasVinculacoesEquipesInput
}

export type QueryTopicoNotificacaoArgs = {
  id: Scalars['ID']['input']
}

export type QueryTransmissaoLinkArgs = {
  input: TransmissaoLinkPagingQueryFiltroDto
}

export type QueryTransmissaoRecebimentoCnesArgs = {
  input: TransmissaoRecebimentoCnesFiltro
}

export type QueryTransmissaoRecebimentoCnesDetailItemsArgs = {
  input: TransmissaoRecebimentoCnesDetailFiltro
}

export type QueryTransmissaoRecebimentoLotesArgs = {
  input: TransmissaoRecebimentoLoteFiltro
}

export type QueryTurnosRelatorioGerencialArgs = {
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryUltimaAvaliacaoMultidimensionalArgs = {
  input: AcompanhamentoIdosoQueryInput
}

export type QueryUltimaSolicitacaoCitopatologicoUteroArgs = {
  prontuarioId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUltimaVacinaAprazadaArgs = {
  input: VacinacaoUltimaVacinaInput
}

export type QueryUltimasMedicoesDiasAnterioresArgs = {
  filtro: UltimasMedicoesInput
}

export type QueryUltimasMedicoesDoDiaArgs = {
  filtro: UltimasMedicoesInput
}

export type QueryUltimasTresVacinasAplicadasArgs = {
  input: VacinacaoUltimaVacinaInput
}

export type QueryUltimoArquivoTemporarioProntoEmProcessamentoArgs = {
  input: ArquivoTemporarioQueryInput
}

export type QueryUltimoAtendimentoProfissionalCidadaoArgs = {
  input?: InputMaybe<UltimoAtendimentoProfissionalFinalizadoQueryInput>
}

export type QueryUltimoAtendimentoProfissionalComMcaByProntuarioIdArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryUltimoAtendimentoPuericulturaArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryUltimoIvcfArgs = {
  input: AcompanhamentoIdosoQueryInput
}

export type QueryUltimoMChatRArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryUltimoMChatRfArgs = {
  prontuarioId: Scalars['ID']['input']
}

export type QueryUltimosCincoArquivosTemporariosArgs = {
  arquivoIdentificador: ArquivoTemporarioIdentificadorEnum
}

export type QueryUnidadeSaudeArgs = {
  id: Scalars['ID']['input']
}

export type QueryUnidadeSaudeTiposServicoArgs = {
  input: UnidadeSaudeTipoServicoQueryInput
}

export type QueryUnidadesConsultaHorusArgs = {
  id: Scalars['ID']['input']
}

export type QueryUnidadesMedidaArgs = {
  input?: InputMaybe<UnidadeMedidaQueryInput>
}

export type QueryUnidadesSaudeArgs = {
  input: UnidadesSaudeQueryInput
}

export type QueryUnidadesSaudeByGarantiaAcessoCidadaoArgs = {
  input: UnidadesSaudeByGarantiaAcessoCidadaoInput
}

export type QueryUnidadesSaudeByTipoVinculacaoServicoArgs = {
  input: UnidadesSaudeByTipoVinculacaoServicoInput
}

export type QueryUnidadesSaudeRelatorioGerencialArgs = {
  input?: InputMaybe<Scalars['String']['input']>
  tipoModulo?: InputMaybe<TipoModuloEnum>
}

export type QueryUnificacoesCidadaoArgs = {
  cidadaoId: Scalars['ID']['input']
}

export type QueryValidatePermissaoNovoAdminArgs = {
  input: ValidateNovoAdminInput
}

export type QueryValidateResetAdminArgs = {
  input: CpfContraChaveInput
}

export type QueryViaAdmLocalAplicacaoVacinaArgs = {
  input?: InputMaybe<ViaAdmLocalAplicacaoQueryInput>
}

export type QueryViaAdministracaoRelatorioGerencialVacinacaoArgs = {
  input?: InputMaybe<Scalars['String']['input']>
}

export type QueryViasAdministracaoVacinaArgs = {
  inputQuery?: InputMaybe<Scalars['String']['input']>
}

export type QueryVideochamadaArgs = {
  uuid: Scalars['String']['input']
}

export type QueryVinculacaoServicoArgs = {
  referenciaId: Scalars['Long']['input']
}

export type QueryVinculacoesServicoArgs = {
  input: VinculacaoServicosInput
}

export type QueryVisitaArgs = {
  id: Scalars['ID']['input']
}

export type QueryVisitasArgs = {
  input: VisitasQueryInput
}

export type RacaCor = {
  readonly __typename?: 'RacaCor'
  readonly codigoCadsus: Scalars['String']['output']
  readonly codigoMS: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly racaCorDbEnum: RacaCorDbEnum
}

export enum RacaCorDbEnum {
  AMARELA = 'AMARELA',
  BRANCA = 'BRANCA',
  INDIGENA = 'INDIGENA',
  PARDA = 'PARDA',
  PRETA = 'PRETA',
  SEM_INFORMACAO = 'SEM_INFORMACAO',
}

export enum RacionalidadeEmSaudeEnum {
  ANTROPOSOFIA_APLICADA_A_SAUDE = 'ANTROPOSOFIA_APLICADA_A_SAUDE',
  AYUVEDA = 'AYUVEDA',
  FITOTERAPIA = 'FITOTERAPIA',
  HOMEOPATIA = 'HOMEOPATIA',
  MEDICINA_TRADICIONAL_CHINESA = 'MEDICINA_TRADICIONAL_CHINESA',
  OUTRA = 'OUTRA',
}

export type RastreioCancerInput = {
  readonly data?: InputMaybe<Scalars['LocalDate']['input']>
  readonly descricao?: InputMaybe<Scalars['String']['input']>
  readonly opcao?: InputMaybe<RastreioCancerPerguntaOpcaoEnum>
  readonly pergunta: RastreioCancerPerguntaDbEnum
}

export enum RastreioCancerPerguntaDbEnum {
  PERGUNTA_CITO_01_01 = 'PERGUNTA_CITO_01_01',
  PERGUNTA_CITO_01_02 = 'PERGUNTA_CITO_01_02',
  PERGUNTA_CITO_01_03 = 'PERGUNTA_CITO_01_03',
  PERGUNTA_CITO_01_04 = 'PERGUNTA_CITO_01_04',
  PERGUNTA_CITO_01_05 = 'PERGUNTA_CITO_01_05',
  PERGUNTA_CITO_01_06 = 'PERGUNTA_CITO_01_06',
  PERGUNTA_CITO_01_07 = 'PERGUNTA_CITO_01_07',
  PERGUNTA_CITO_01_08 = 'PERGUNTA_CITO_01_08',
  PERGUNTA_CITO_01_09 = 'PERGUNTA_CITO_01_09',
  PERGUNTA_CITO_01_10 = 'PERGUNTA_CITO_01_10',
  PERGUNTA_CITO_01_11 = 'PERGUNTA_CITO_01_11',
  PERGUNTA_CITO_01_12 = 'PERGUNTA_CITO_01_12',
  PERGUNTA_CITO_02_01 = 'PERGUNTA_CITO_02_01',
  PERGUNTA_CITO_02_02 = 'PERGUNTA_CITO_02_02',
  PERGUNTA_CITO_03_01 = 'PERGUNTA_CITO_03_01',
  PERGUNTA_CITO_03_02 = 'PERGUNTA_CITO_03_02',
  PERGUNTA_CITO_03_03 = 'PERGUNTA_CITO_03_03',
  PERGUNTA_CITO_03_04 = 'PERGUNTA_CITO_03_04',
  PERGUNTA_CITO_03_05 = 'PERGUNTA_CITO_03_05',
  PERGUNTA_MAMO_01_01 = 'PERGUNTA_MAMO_01_01',
  PERGUNTA_MAMO_01_02 = 'PERGUNTA_MAMO_01_02',
  PERGUNTA_MAMO_01_03 = 'PERGUNTA_MAMO_01_03',
  PERGUNTA_MAMO_01_04 = 'PERGUNTA_MAMO_01_04',
  PERGUNTA_MAMO_01_05 = 'PERGUNTA_MAMO_01_05',
  PERGUNTA_MAMO_01_06 = 'PERGUNTA_MAMO_01_06',
  PERGUNTA_MAMO_01_07 = 'PERGUNTA_MAMO_01_07',
  PERGUNTA_MAMO_01_08 = 'PERGUNTA_MAMO_01_08',
  PERGUNTA_MAMO_01_09 = 'PERGUNTA_MAMO_01_09',
  PERGUNTA_MAMO_02_01 = 'PERGUNTA_MAMO_02_01',
  PERGUNTA_MAMO_02_02 = 'PERGUNTA_MAMO_02_02',
  PERGUNTA_MAMO_02_03 = 'PERGUNTA_MAMO_02_03',
  PERGUNTA_MAMO_02_04 = 'PERGUNTA_MAMO_02_04',
  PERGUNTA_MAMO_02_05 = 'PERGUNTA_MAMO_02_05',
  PERGUNTA_MAMO_02_06 = 'PERGUNTA_MAMO_02_06',
  PERGUNTA_MAMO_02_07 = 'PERGUNTA_MAMO_02_07',
  PERGUNTA_MAMO_02_08 = 'PERGUNTA_MAMO_02_08',
  PERGUNTA_MAMO_02_09 = 'PERGUNTA_MAMO_02_09',
  PERGUNTA_MAMO_02_10 = 'PERGUNTA_MAMO_02_10',
  PERGUNTA_MAMO_02_11 = 'PERGUNTA_MAMO_02_11',
  PERGUNTA_MAMO_02_12 = 'PERGUNTA_MAMO_02_12',
  PERGUNTA_MAMO_02_13 = 'PERGUNTA_MAMO_02_13',
  PERGUNTA_MAMO_02_14 = 'PERGUNTA_MAMO_02_14',
  PERGUNTA_MAMO_02_15 = 'PERGUNTA_MAMO_02_15',
  PERGUNTA_MAMO_02_16 = 'PERGUNTA_MAMO_02_16',
  PERGUNTA_MAMO_02_17 = 'PERGUNTA_MAMO_02_17',
  PERGUNTA_MAMO_02_18 = 'PERGUNTA_MAMO_02_18',
  PERGUNTA_MAMO_02_19 = 'PERGUNTA_MAMO_02_19',
  PERGUNTA_MAMO_02_20 = 'PERGUNTA_MAMO_02_20',
  PERGUNTA_MAMO_02_21 = 'PERGUNTA_MAMO_02_21',
  PERGUNTA_MAMO_02_22 = 'PERGUNTA_MAMO_02_22',
  PERGUNTA_MAMO_02_23 = 'PERGUNTA_MAMO_02_23',
  PERGUNTA_MAMO_02_24 = 'PERGUNTA_MAMO_02_24',
  PERGUNTA_MAMO_02_25 = 'PERGUNTA_MAMO_02_25',
  PERGUNTA_MAMO_02_26 = 'PERGUNTA_MAMO_02_26',
  PERGUNTA_MAMO_02_27 = 'PERGUNTA_MAMO_02_27',
  PERGUNTA_MAMO_02_28 = 'PERGUNTA_MAMO_02_28',
  PERGUNTA_MAMO_02_29 = 'PERGUNTA_MAMO_02_29',
  PERGUNTA_MAMO_02_30 = 'PERGUNTA_MAMO_02_30',
  PERGUNTA_MAMO_02_31 = 'PERGUNTA_MAMO_02_31',
  PERGUNTA_MAMO_02_32 = 'PERGUNTA_MAMO_02_32',
  PERGUNTA_MAMO_02_33 = 'PERGUNTA_MAMO_02_33',
  PERGUNTA_MAMO_02_34 = 'PERGUNTA_MAMO_02_34',
  PERGUNTA_MAMO_02_35 = 'PERGUNTA_MAMO_02_35',
  PERGUNTA_MAMO_02_36 = 'PERGUNTA_MAMO_02_36',
  PERGUNTA_MAMO_02_37 = 'PERGUNTA_MAMO_02_37',
  PERGUNTA_MAMO_02_38 = 'PERGUNTA_MAMO_02_38',
  PERGUNTA_MAMO_02_39 = 'PERGUNTA_MAMO_02_39',
  PERGUNTA_MAMO_03_01 = 'PERGUNTA_MAMO_03_01',
  PERGUNTA_MAMO_03_02 = 'PERGUNTA_MAMO_03_02',
  PERGUNTA_MAMO_04_01 = 'PERGUNTA_MAMO_04_01',
  PERGUNTA_MAMO_04_02 = 'PERGUNTA_MAMO_04_02',
  PERGUNTA_MAMO_04_03 = 'PERGUNTA_MAMO_04_03',
  PERGUNTA_MAMO_04_04 = 'PERGUNTA_MAMO_04_04',
  PERGUNTA_MAMO_04_05 = 'PERGUNTA_MAMO_04_05',
  PERGUNTA_MAMO_05_01 = 'PERGUNTA_MAMO_05_01',
  PERGUNTA_MAMO_05_02 = 'PERGUNTA_MAMO_05_02',
  PERGUNTA_MAMO_05_03 = 'PERGUNTA_MAMO_05_03',
  PERGUNTA_MAMO_05_04 = 'PERGUNTA_MAMO_05_04',
  PERGUNTA_MAMO_05_05 = 'PERGUNTA_MAMO_05_05',
  PERGUNTA_MAMO_06_01 = 'PERGUNTA_MAMO_06_01',
  PERGUNTA_MAMO_06_02 = 'PERGUNTA_MAMO_06_02',
  PERGUNTA_MAMO_06_03 = 'PERGUNTA_MAMO_06_03',
  PERGUNTA_MAMO_06_04 = 'PERGUNTA_MAMO_06_04',
  PERGUNTA_MAMO_06_05 = 'PERGUNTA_MAMO_06_05',
  PERGUNTA_MAMO_06_06 = 'PERGUNTA_MAMO_06_06',
  PERGUNTA_MAMO_06_07 = 'PERGUNTA_MAMO_06_07',
  PERGUNTA_MAMO_06_08 = 'PERGUNTA_MAMO_06_08',
  PERGUNTA_MAMO_07_01 = 'PERGUNTA_MAMO_07_01',
  PERGUNTA_MAMO_07_02 = 'PERGUNTA_MAMO_07_02',
  PERGUNTA_MAMO_07_03 = 'PERGUNTA_MAMO_07_03',
  PERGUNTA_MAMO_07_04 = 'PERGUNTA_MAMO_07_04',
  PERGUNTA_MAMO_08_01 = 'PERGUNTA_MAMO_08_01',
  PERGUNTA_MAMO_08_02 = 'PERGUNTA_MAMO_08_02',
  PERGUNTA_MAMO_08_03 = 'PERGUNTA_MAMO_08_03',
  PERGUNTA_MAMO_08_04 = 'PERGUNTA_MAMO_08_04',
  PERGUNTA_MAMO_08_05 = 'PERGUNTA_MAMO_08_05',
  PERGUNTA_MAMO_08_06 = 'PERGUNTA_MAMO_08_06',
  PERGUNTA_MAMO_08_07 = 'PERGUNTA_MAMO_08_07',
  PERGUNTA_MAMO_09_01 = 'PERGUNTA_MAMO_09_01',
  PERGUNTA_MAMO_09_02 = 'PERGUNTA_MAMO_09_02',
  PERGUNTA_MAMO_09_03 = 'PERGUNTA_MAMO_09_03',
  PERGUNTA_MAMO_09_04 = 'PERGUNTA_MAMO_09_04',
  PERGUNTA_MAMO_09_05 = 'PERGUNTA_MAMO_09_05',
}

export enum RastreioCancerPerguntaOpcaoEnum {
  ALTERADO = 'ALTERADO',
  AMBAS = 'AMBAS',
  AUSENTE = 'AUSENTE',
  AXILAR = 'AXILAR',
  COLO_UTERO_NAO_VISUALIZADO = 'COLO_UTERO_NAO_VISUALIZADO',
  CRISTALINA = 'CRISTALINA',
  DIAGNOSTICO = 'DIAGNOSTICO',
  DIREITA = 'DIREITA',
  ESQUERDA = 'ESQUERDA',
  HEMORRAGICA = 'HEMORRAGICA',
  NAO = 'NAO',
  NAO_INFORMADO = 'NAO_INFORMADO',
  NAO_NAO_SABE_NAO_LEMBRA = 'NAO_NAO_SABE_NAO_LEMBRA',
  NAO_NAO_SABE_NAO_LEMBRA_NAO_ESTA_NA_MENOPAUSA = 'NAO_NAO_SABE_NAO_LEMBRA_NAO_ESTA_NA_MENOPAUSA',
  NAO_SABE = 'NAO_SABE',
  NORMAL = 'NORMAL',
  NUNCA_FEZ_PREVENTIVO_ANTERIORMENTE = 'NUNCA_FEZ_PREVENTIVO_ANTERIORMENTE',
  NUNCA_FORAM_EXAMINADAS_ANTERIORMENTE = 'NUNCA_FORAM_EXAMINADAS_ANTERIORMENTE',
  OUTRAS_SITUACOES_IMUNOSSUPRESSAO = 'OUTRAS_SITUACOES_IMUNOSSUPRESSAO',
  PA = 'PA',
  PACIENTE_JA_TRATADO_CANCER_MAMA = 'PACIENTE_JA_TRATADO_CANCER_MAMA',
  PESSOA_VIVENDO_COM_HIV = 'PESSOA_VIVENDO_COM_HIV',
  POPULACAO_ALVO = 'POPULACAO_ALVO',
  POPULACAO_RISCO_ELEVADO_HISTORIA_FAMILIAR = 'POPULACAO_RISCO_ELEVADO_HISTORIA_FAMILIAR',
  QIL = 'QIL',
  QIM = 'QIM',
  QSL = 'QSL',
  QSM = 'QSM',
  RASTREAMENTO = 'RASTREAMENTO',
  REPETICAO = 'REPETICAO',
  RRA = 'RRA',
  SEGUIMENTO = 'SEGUIMENTO',
  SIM = 'SIM',
  SIM_MAMA_DIREITA = 'SIM_MAMA_DIREITA',
  SIM_MAMA_ESQUERDA = 'SIM_MAMA_ESQUERDA',
  SIM_PAPANICOLAU = 'SIM_PAPANICOLAU',
  SUPRACLAVICULAR = 'SUPRACLAVICULAR',
  UQ_INF = 'UQ_INF',
  UQ_LAT = 'UQ_LAT',
  UQ_MED = 'UQ_MED',
  UQ_SUP = 'UQ_SUP',
}

export type RastreioCancerPerguntaRespostaDto = {
  readonly __typename?: 'RastreioCancerPerguntaRespostaDto'
  readonly data?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly opcao?: Maybe<RastreioCancerPerguntaOpcaoEnum>
  readonly pergunta: RastreioCancerPerguntaDbEnum
}

export type ReagendarLembreteProfissionalInput = {
  readonly dataExibirNovamente: Scalars['Instant']['input']
  readonly id: Scalars['ID']['input']
}

export type ReceitaMedicamento = {
  readonly __typename?: 'ReceitaMedicamento'
  readonly aplicacaoMedicamento: AplicacaoMedicamento
  readonly atendProf?: Maybe<AtendimentoProfissional>
  readonly ciap?: Maybe<Ciap>
  readonly cid10?: Maybe<Cid10>
  readonly codigoPrescricaoDigital?: Maybe<Scalars['String']['output']>
  readonly dose?: Maybe<Scalars['String']['output']>
  readonly doseUnica?: Maybe<Scalars['Boolean']['output']>
  readonly dtFimTratamento?: Maybe<Scalars['Instant']['output']>
  readonly dtInicioTratamento?: Maybe<Scalars['Instant']['output']>
  readonly dtInterrupcao?: Maybe<Scalars['Instant']['output']>
  readonly frequenciaDose?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly justificativaInterrupcao?: Maybe<Scalars['String']['output']>
  readonly medicamento: Medicamento
  readonly medidaTempoFrequencia?: Maybe<UnidadeMedidaTempoEnum>
  readonly medidaTempoTratamento?: Maybe<UnidadeMedidaTempoEnum>
  readonly posologia: Scalars['String']['output']
  readonly qtDose?: Maybe<Scalars['String']['output']>
  readonly qtDoseManha?: Maybe<Scalars['String']['output']>
  readonly qtDoseNoite?: Maybe<Scalars['String']['output']>
  readonly qtDoseTarde?: Maybe<Scalars['String']['output']>
  readonly qtDuracaoTratamento?: Maybe<Scalars['Int']['output']>
  readonly qtPeriodoFrequencia?: Maybe<Scalars['Int']['output']>
  readonly quantidadeReceitada: Scalars['Int']['output']
  readonly receitaUsoContinuoGrupo?: Maybe<ReceitaMedicamento>
  readonly recomendacoes?: Maybe<Scalars['String']['output']>
  readonly registroManual?: Maybe<Scalars['Boolean']['output']>
  readonly tipoFrequenciaDose?: Maybe<TipoFrequencia>
  readonly tipoReceita?: Maybe<TipoReceitaEnum>
  readonly tratamentoInterrompido?: Maybe<Scalars['Boolean']['output']>
  readonly unidadeMedidaDose?: Maybe<UnidadeMedida>
  readonly usoContinuo?: Maybe<Scalars['Boolean']['output']>
}

export type ReceitaMedicamentoSdcDto = {
  readonly __typename?: 'ReceitaMedicamentoSdcDto'
  readonly aplicacaoMedicamento: AplicacaoMedicamento
  readonly codigoMotivoPrescricao?: Maybe<Scalars['String']['output']>
  readonly duracaoTratamentoEmDias?: Maybe<Scalars['Int']['output']>
  readonly idMotivoPrescricao?: Maybe<Scalars['Long']['output']>
  readonly intervaloFrequencia?: Maybe<Scalars['Int']['output']>
  readonly medicamentoCatmat?: Maybe<MedicamentoCatmat>
  readonly medidaTempoFrequencia?: Maybe<UnidadeMedidaTempoEnum>
  readonly motivoRestricaoPrescricao?: Maybe<Scalars['String']['output']>
  readonly nomeMotivoPrescricao?: Maybe<Scalars['String']['output']>
  readonly posologia: Scalars['String']['output']
  readonly prescrever: Scalars['Boolean']['output']
  readonly quantidadeDose?: Maybe<Scalars['String']['output']>
  readonly quantidadeReceitada: Scalars['Int']['output']
  readonly recomendacoes?: Maybe<Scalars['String']['output']>
  readonly tipoFrequenciaDose?: Maybe<TipoFrequencia>
  readonly tipoMotivoPrescricao?: Maybe<Scalars['String']['output']>
  readonly unidadeMedidaDose?: Maybe<UnidadeMedida>
}

export enum RecursoIntegracaoEnum {
  RECEBIMENTO_EXTERNO_FICHAS = 'RECEBIMENTO_EXTERNO_FICHAS',
  REGULACAO = 'REGULACAO',
}

export type RedefinirSenhaAdminInstalacaoInput = {
  readonly contraChave?: InputMaybe<Scalars['String']['input']>
  readonly cpf?: InputMaybe<Scalars['String']['input']>
  readonly novaSenha: Scalars['String']['input']
}

export type RedefinirSenhaInput = {
  readonly novaSenha: Scalars['String']['input']
  readonly token: Scalars['String']['input']
  readonly usuario: Scalars['String']['input']
}

export type ReferenceMonth = {
  readonly month: Scalars['Int']['input']
  readonly year: Scalars['Int']['input']
}

export type RegistroAplicado = {
  readonly __typename?: 'RegistroAplicado'
  readonly dataAplicacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataAprazamento?: Maybe<Scalars['LocalDate']['output']>
  readonly dataRegistroAprazamento?: Maybe<Scalars['Instant']['output']>
  readonly doseId: Scalars['ID']['output']
  readonly doseNome: Scalars['String']['output']
  readonly doseNomeApresentacao: Scalars['String']['output']
  readonly doseOrdem: Scalars['Int']['output']
  readonly doseSigla: Scalars['String']['output']
  readonly estrategiaId?: Maybe<Scalars['ID']['output']>
  readonly imunobiologicoId: Scalars['ID']['output']
  readonly imunobiologicoNome: Scalars['String']['output']
  readonly imunobiologicoSigla: Scalars['String']['output']
  readonly isRegistroAnterior?: Maybe<Scalars['Boolean']['output']>
  readonly quantidadeAplicacoes: Scalars['Int']['output']
}

export type RegistroAvaliacaoPuericultura = {
  readonly __typename?: 'RegistroAvaliacaoPuericultura'
  readonly ciap: Ciap
  readonly cid10: Cid10
}

export type RegistroDose = {
  readonly __typename?: 'RegistroDose'
  readonly anvisaNumeroRegistro?: Maybe<Scalars['String']['output']>
  readonly anvisaProtocoloEstudo?: Maybe<Scalars['String']['output']>
  readonly anvisaProtocoloVersao?: Maybe<Scalars['String']['output']>
  readonly cbo?: Maybe<Scalars['String']['output']>
  readonly cboPrescritor?: Maybe<Scalars['String']['output']>
  readonly cid10MotivoIndicacao?: Maybe<Scalars['String']['output']>
  readonly cid10MotivoIndicacaoCodigoCid?: Maybe<Scalars['String']['output']>
  readonly condicaoMaternal?: Maybe<CondicaoMaternalDbEnum>
  readonly dataAplicacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataAprazamento?: Maybe<Scalars['LocalDate']['output']>
  readonly dataRegistro?: Maybe<Scalars['Instant']['output']>
  readonly dataValidadeLote?: Maybe<Scalars['LocalDate']['output']>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly doseNome?: Maybe<Scalars['String']['output']>
  readonly doseSigla?: Maybe<Scalars['String']['output']>
  readonly estrategia?: Maybe<Scalars['String']['output']>
  readonly estrategiaId?: Maybe<Scalars['ID']['output']>
  readonly fabricante?: Maybe<Scalars['String']['output']>
  readonly grupoAtendimento?: Maybe<Scalars['String']['output']>
  readonly isAplicacaoEquivalente?: Maybe<Scalars['Boolean']['output']>
  readonly isAplicadoExterior?: Maybe<Scalars['Boolean']['output']>
  readonly isComunicanteHanseniase?: Maybe<Scalars['Boolean']['output']>
  readonly isPesquisaClinica?: Maybe<Scalars['Boolean']['output']>
  readonly isRegistroAnterior?: Maybe<Scalars['Boolean']['output']>
  readonly isViajante?: Maybe<Scalars['Boolean']['output']>
  readonly localAplicacao?: Maybe<Scalars['String']['output']>
  readonly lote?: Maybe<Scalars['String']['output']>
  readonly origemDados?: Maybe<OrigemDadoEnum>
  readonly profissional?: Maybe<Scalars['String']['output']>
  readonly tipoCdsOrigem?: Maybe<Scalars['Long']['output']>
  readonly tipoOrigemDadoTransp?: Maybe<Scalars['Long']['output']>
  readonly unidadeSaude?: Maybe<Scalars['String']['output']>
  readonly viaAdministracao?: Maybe<Scalars['String']['output']>
}

export type RegistroManualMedicamentoInput = {
  readonly concentracao?: InputMaybe<Scalars['String']['input']>
  readonly formaFarmaceutica: Scalars['ID']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly medicamentoText?: InputMaybe<Scalars['String']['input']>
  readonly unidadeFornecimento: Scalars['String']['input']
}

export type RegistroObitoInput = {
  readonly dataObito: Scalars['LocalDate']['input']
  readonly numeroDeclaracaoObito?: InputMaybe<Scalars['String']['input']>
}

export type RegistroTardioInput = {
  readonly atendimentoId?: InputMaybe<Scalars['ID']['input']>
  readonly atorPapelId: Scalars['ID']['input']
  readonly cidadaoId: Scalars['ID']['input']
  readonly dataHorarioAtendimento: Scalars['Instant']['input']
  readonly justificativa?: InputMaybe<RegistroTardioJustificativaEnum>
  readonly localAtendimentoId: Scalars['ID']['input']
}

export enum RegistroTardioJustificativaEnum {
  COMPUTADOR_INOPERANTE = 'COMPUTADOR_INOPERANTE',
  FALTA_ENERGIA_ELETRICA = 'FALTA_ENERGIA_ELETRICA',
  OUTRO = 'OUTRO',
  PEC_INDISPONIVEL = 'PEC_INDISPONIVEL',
}

export type RegistroVacinacao = {
  readonly __typename?: 'RegistroVacinacao'
  readonly anvisaNumeroRegistro?: Maybe<Scalars['String']['output']>
  readonly anvisaProtocoloEstudo?: Maybe<Scalars['String']['output']>
  readonly anvisaProtocoloVersao?: Maybe<Scalars['String']['output']>
  readonly cboPrescritor?: Maybe<Cbo>
  readonly cid10MotivoIndicacao?: Maybe<Cid10>
  readonly dataAplicacao?: Maybe<Scalars['Instant']['output']>
  readonly dataAprazamento?: Maybe<Scalars['Instant']['output']>
  readonly doseImunobiologico: DoseImunobiologico
  readonly estrategiaVacinacao?: Maybe<EstrategiaVacinacao>
  readonly grupoAtendimento?: Maybe<GrupoAtendimento>
  readonly id: Scalars['ID']['output']
  readonly imunobiologico: Imunobiologico
  readonly isAplicadoExterior?: Maybe<Scalars['Boolean']['output']>
  readonly isPesquisaClinica?: Maybe<Scalars['Boolean']['output']>
  readonly isRegistroAnterior?: Maybe<Scalars['Boolean']['output']>
  readonly localAplicacaoVacinacao?: Maybe<LocalAplicacao>
  readonly loteImunobiologico?: Maybe<LoteImunobiologico>
  readonly observacoes?: Maybe<Scalars['String']['output']>
  readonly tipoRegistroVacinacao: TipoRegistroVacinacao
  readonly uuid?: Maybe<Scalars['String']['output']>
  readonly vacinacao: AtendimentoVacinacao
  readonly viaAdministracao?: Maybe<ViaAdministracao>
}

export type RegistroVacinacaoInput = {
  readonly anvisaNumeroRegistro?: InputMaybe<Scalars['String']['input']>
  readonly anvisaProtocoloEstudo?: InputMaybe<Scalars['String']['input']>
  readonly anvisaProtocoloVersao?: InputMaybe<Scalars['String']['input']>
  readonly cboPrescritorId?: InputMaybe<Scalars['Long']['input']>
  readonly cid10MotivoIndicacaoId?: InputMaybe<Scalars['Long']['input']>
  readonly dataAplicacao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataAprazamento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly doseImunobiologicoId: Scalars['ID']['input']
  readonly estrategiaVacinacao?: InputMaybe<EstrategiaVacinacaoEnum>
  readonly grupoAtendimentoId?: InputMaybe<Scalars['ID']['input']>
  readonly imunobiologicoId: Scalars['ID']['input']
  readonly isAplicadoExterior?: InputMaybe<Scalars['Boolean']['input']>
  readonly isCadastrarNovoLote: Scalars['Boolean']['input']
  readonly isPesquisaClinica?: InputMaybe<Scalars['Boolean']['input']>
  readonly isPesquisaEstrategia?: InputMaybe<Scalars['Boolean']['input']>
  readonly isRegistroAnterior: Scalars['Boolean']['input']
  readonly localAplicacaoVacinacaoId?: InputMaybe<Scalars['ID']['input']>
  readonly loteImunobiologicoCadastro?: InputMaybe<LoteImunobiologicoVacinacaoInput>
  readonly loteImunobiologicoId?: InputMaybe<Scalars['ID']['input']>
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
  readonly tipoRegistroVacinacao: TipoRegistroVacinacaoEnum
  readonly viaAdministracaoId?: InputMaybe<Scalars['ID']['input']>
}

export type RegistrosAplicadosVacinacaoInput = {
  readonly atendimentoProfissionalIdExcluir?: InputMaybe<Scalars['ID']['input']>
  readonly cidadaoId: Scalars['ID']['input']
  readonly cpf?: InputMaybe<Scalars['String']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export type RegistrosDoseVacinacaoInput = {
  readonly atendimentoProfissionalIdExcluir?: InputMaybe<Scalars['ID']['input']>
  readonly cidadaoId: Scalars['ID']['input']
  readonly cpf?: InputMaybe<Scalars['String']['input']>
  readonly doseId: Scalars['ID']['input']
  readonly hasDoseEquivalenteOnly?: InputMaybe<Scalars['Boolean']['input']>
  readonly imunobiologicoId: Scalars['ID']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export type RegraVacinal = {
  readonly __typename?: 'RegraVacinal'
  readonly dose: DoseImunobiologico
  readonly estrategia: EstrategiaVacinacao
  readonly id: Scalars['ID']['output']
  readonly imunobiologico: Imunobiologico
  readonly versaoMaximaTransport?: Maybe<Scalars['String']['output']>
  readonly versaoMinimaTransport?: Maybe<Scalars['String']['output']>
}

export type RegrasVacinaisQueryInput = {
  readonly maxTransportVersion: Scalars['String']['input']
}

export type Regulacao = {
  readonly __typename?: 'Regulacao'
  readonly exame?: Maybe<ResultadoExame>
  readonly guiaEncaminhamento?: Maybe<GuiaEncaminhamento>
  readonly id: Scalars['ID']['output']
  readonly lotacao: Lotacao
  readonly prontuario: Prontuario
  readonly tipoRegulacao: TipoRegulacaoEnum
  readonly topicoNotificacao?: Maybe<TopicoNotificacao>
  readonly ultimaEvolucao: RegulacaoEvolucao
  readonly uuid: Scalars['String']['output']
}

export type RegulacaoEvolucao = {
  readonly __typename?: 'RegulacaoEvolucao'
  readonly dataEvolucao: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly prioridade: PrioridadeRegulacaoEnum
  readonly regulacao: Regulacao
  readonly statusRegulacao: StatusRegulacaoEnum
}

export enum RelacaoCidadaoCuidador {
  AVO = 'AVO',
  CONJUGE_COMPANHEIRO = 'CONJUGE_COMPANHEIRO',
  FILHO_ENTEADO = 'FILHO_ENTEADO',
  IRMAO = 'IRMAO',
  NAO_POSSUI = 'NAO_POSSUI',
  NETO = 'NETO',
  OUTRO = 'OUTRO',
  PAI_MAE = 'PAI_MAE',
}

export type RelatorioGerencialAbsenteismoInput = {
  readonly dateRange: DateRangeInput
  readonly periodUnit: UnidadePeriodoRelatorioGerencialEnum
}

export type RelatorioProducaoAtendimentoDomiciliar = {
  readonly __typename?: 'RelatorioProducaoAtendimentoDomiciliar'
  readonly faixaEtaria: ReadonlyArray<Maybe<QuadroRelatorioFaixaEtariaItem>>
  readonly localAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sexo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly tipoAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoAtendimentoDomiciliarQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export type RelatorioProducaoAtendimentoIndividual = {
  readonly __typename?: 'RelatorioProducaoAtendimentoIndividual'
  readonly examesSolicitadosAvaliados: ReadonlyArray<Maybe<QuadroRelatorioExameItem>>
  readonly examesTriagemNeonatal: ReadonlyArray<Maybe<QuadroRelatorioExameItem>>
  readonly faixaEtaria: ReadonlyArray<Maybe<QuadroRelatorioFaixaEtariaItem>>
  readonly localAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly outrosExamesSolicitadosAvaliadosSigtap: ReadonlyArray<Maybe<QuadroRelatorioExameItem>>
  readonly problemasCondicoesAvaliadas: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly problemasCondicoesAvaliadasDoencasTransmissiveis: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly problemasCondicoesAvaliadasOutrosCiap: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly problemasCondicoesAvaliadasOutrosCid: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sexo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly tipoAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoAtendimentoIndividualQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export type RelatorioProducaoAtendimentoOdonto = {
  readonly __typename?: 'RelatorioProducaoAtendimentoOdonto'
  readonly faixaEtaria: ReadonlyArray<Maybe<QuadroRelatorioFaixaEtariaItem>>
  readonly localAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly outrosProcedimentos: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly procedimentos: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sexo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly tipoAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoAtendimentoOdontoQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export type RelatorioProducaoAtividadeColetiva = {
  readonly __typename?: 'RelatorioProducaoAtividadeColetiva'
  readonly atividade: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly programaSaudeEscola: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly publicoAlvo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly temasReuniao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly temasSaude: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoAtividadeColetivaQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export type RelatorioProducaoProcedimentosIndividualizados = {
  readonly __typename?: 'RelatorioProducaoProcedimentosIndividualizados'
  readonly faixaEtaria: ReadonlyArray<Maybe<QuadroRelatorioFaixaEtariaItem>>
  readonly localAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly outrosProcedimentosSigtap: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly procedimentosAdministracaoMedicamentos: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly procedimentosPequenasCirurgias: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly procedimentosTesteRapido: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sexo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoProcedimentosIndividualizadosQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export type RelatorioProducaoVacinacao = {
  readonly __typename?: 'RelatorioProducaoVacinacao'
  readonly faixaEtaria: ReadonlyArray<Maybe<QuadroRelatorioFaixaEtariaItem>>
  readonly localAtendimento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sexo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoVacinacaoQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export type RelatorioProducaoVisitaDomiciliarTerritorial = {
  readonly __typename?: 'RelatorioProducaoVisitaDomiciliarTerritorial'
  readonly antropometria: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly desfecho: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly faixaEtaria: ReadonlyArray<Maybe<QuadroRelatorioFaixaEtariaItem>>
  readonly glicemia: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly motivoVisitaAcompanhamento: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly motivoVisitaControleAmbientalVetorial: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly motivoVisitaGeral: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly resumoProducao: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sexo: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly sinaisVitais: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly tipoImovel: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly turno: ReadonlyArray<Maybe<QuadroRelatorioItem>>
  readonly visitaCompartilhada: ReadonlyArray<Maybe<QuadroRelatorioItem>>
}

export type RelatorioProducaoVisitaDomiciliarTerritorialQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
}

export enum RendaFamiliar {
  ACIMA_4_SALARIOS_MINIMOS = 'ACIMA_4_SALARIOS_MINIMOS',
  AUSENCIA_RENDA = 'AUSENCIA_RENDA',
  _1_2_SALARIO_MINIMO = '_1_2_SALARIO_MINIMO',
  _1_4_SALARIO_MINIMO = '_1_4_SALARIO_MINIMO',
  _1_SALARIO_MINIMO = '_1_SALARIO_MINIMO',
  _2_SALARIOS_MINIMOS = '_2_SALARIOS_MINIMOS',
  _3_SALARIOS_MINIMOS = '_3_SALARIOS_MINIMOS',
  _4_SALARIOS_MINIMOS = '_4_SALARIOS_MINIMOS',
}

export type ResponderSolicitacaoEntradaVideochamadaInput = {
  readonly participanteId: Scalars['String']['input']
  readonly resposta: RespostaSolicitacaoEntradaVideochamadaEnum
  readonly videochamadaUuid: Scalars['String']['input']
}

export type ResponsavelTecnicoImovel = {
  readonly __typename?: 'ResponsavelTecnicoImovel'
  readonly cargo?: Maybe<Scalars['String']['output']>
  readonly cns?: Maybe<Scalars['String']['output']>
  readonly contato?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type ResponsavelTecnicoInput = {
  readonly cargo?: InputMaybe<Scalars['String']['input']>
  readonly cns?: InputMaybe<Scalars['String']['input']>
  readonly contato?: InputMaybe<Scalars['String']['input']>
  readonly nome: Scalars['String']['input']
}

export type RespostaMarcadoresConsumoAlimentar = {
  readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
  readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
  readonly pergunta: PerguntasQuestionarioEnum
}

export type RespostaMarcadoresConsumoAlimentarInput = {
  readonly opcoesSelecionadas: ReadonlyArray<InputMaybe<OpcaoTipoPerguntaEnum>>
  readonly pergunta: PerguntasQuestionarioEnum
}

export type RespostaPesquisa = {
  readonly enviaMunicipio?: InputMaybe<Scalars['Boolean']['input']>
  readonly grauSatisfacao?: InputMaybe<GrauSatisfacaoUsuario>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly tipoResposta?: InputMaybe<TipoRespostaPesquisa>
}

export enum RespostaSolicitacaoEntradaVideochamadaEnum {
  ACEITA = 'ACEITA',
  NEGADA = 'NEGADA',
  TIMEOUT = 'TIMEOUT',
  VIDEOCHAMADA_LOTADA = 'VIDEOCHAMADA_LOTADA',
}

export type ResultadoExame = {
  readonly __typename?: 'ResultadoExame'
  readonly atendimentoProfissionalResultado?: Maybe<AtendimentoProfissional>
  readonly atendimentoProfissionalSolicitacao?: Maybe<AtendimentoProfissional>
  readonly conferido?: Maybe<Scalars['Boolean']['output']>
  readonly dataRealizacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataResultado?: Maybe<Scalars['LocalDate']['output']>
  readonly dataSolicitacao?: Maybe<Scalars['LocalDate']['output']>
  readonly especifico?: Maybe<ResultadoExameEspecifico>
  readonly exame: Procedimento
  readonly id: Scalars['ID']['output']
  readonly observacao?: Maybe<Scalars['String']['output']>
  readonly resultado?: Maybe<Scalars['String']['output']>
  readonly solicitacao?: Maybe<SolicitacaoExame>
}

export type ResultadoExameConsolidado = {
  readonly __typename?: 'ResultadoExameConsolidado'
  readonly dataAvaliacao?: Maybe<Scalars['LocalDate']['output']>
  readonly exameId: Scalars['ID']['output']
  readonly exameRequisitado?: Maybe<ResultadoExame>
}

export type ResultadoExameEspecializadoInput = {
  readonly dpp?: InputMaybe<Scalars['LocalDate']['input']>
  readonly fichaComplementarPuericultura?: InputMaybe<FichaComplementarZikaMicrocefaliaResultadoExameEnum>
  readonly igDias?: InputMaybe<Scalars['Int']['input']>
  readonly igSemanas?: InputMaybe<Scalars['Int']['input']>
  readonly procedimento: ExameEspecificoEnum
  readonly resultadoExameEstruturadoQualitativo?: InputMaybe<OpcoesResultadoExameQualitativoEnum>
  readonly valor?: InputMaybe<Scalars['Float']['input']>
}

export type ResultadoExameEspecifico = {
  readonly __typename?: 'ResultadoExameEspecifico'
  readonly dpp?: Maybe<Scalars['LocalDate']['output']>
  readonly exameEspecificoEnum: ExameEspecificoEnum
  readonly id: Scalars['ID']['output']
  readonly igDias?: Maybe<Scalars['Int']['output']>
  readonly igSemanas?: Maybe<Scalars['Int']['output']>
  readonly resultadoExameEstruturadoQualitativoEnum?: Maybe<OpcoesResultadoExameQualitativoEnum>
  readonly resultadoExamePuericulturaEnum?: Maybe<FichaComplementarZikaMicrocefaliaResultadoExameEnum>
  readonly valor?: Maybe<Scalars['Float']['output']>
}

export type ResultadoExameInput = {
  readonly dataRealizacao: Scalars['LocalDate']['input']
  readonly dataResultado?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataSolicitacao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly especifico?: InputMaybe<ResultadoExameEspecializadoInput>
  readonly exameId?: InputMaybe<Scalars['ID']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly resultado?: InputMaybe<Scalars['String']['input']>
}

export type ResultadoExamePreNatalInput = {
  readonly dataProvavelParto?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataRealizacao?: InputMaybe<Scalars['LocalDate']['input']>
  readonly idadeGestacionalDias?: InputMaybe<Scalars['Int']['input']>
  readonly idadeGestacionalSemanas?: InputMaybe<Scalars['Int']['input']>
}

export type ResultadoExameSdcInput = {
  readonly dataRealizacao: Scalars['LocalDate']['input']
  readonly valor?: InputMaybe<Scalars['Float']['input']>
}

export type ResultadoTesteConexao = {
  readonly __typename?: 'ResultadoTesteConexao'
  readonly link: TransmissaoLink
  readonly validationDescription: Scalars['String']['output']
}

export type ResultadosExameFiltroInput = {
  readonly apenasExamesSemResultado?: InputMaybe<Scalars['Boolean']['input']>
  readonly dataInicial?: InputMaybe<Scalars['LocalDate']['input']>
  readonly gruposProcedimento?: InputMaybe<ReadonlyArray<GrupoProcedimentoEnum>>
  readonly procedimentoAtivo?: InputMaybe<Scalars['Boolean']['input']>
  readonly procedimentoId?: InputMaybe<Scalars['ID']['input']>
  readonly subGruposProcedimento?: InputMaybe<ReadonlyArray<SubGrupoProcedimentoEnum>>
}

export type ResultadosExamePayload = {
  readonly __typename?: 'ResultadosExamePayload'
  readonly content: ReadonlyArray<Maybe<ResultadoExame>>
  readonly pageInfo: PageInfo
}

export type ResultadosExameQueryInput = {
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly filtro?: InputMaybe<ResultadosExameFiltroInput>
  readonly pageParams?: InputMaybe<OptionalPageParams>
  readonly prontuarioId: Scalars['ID']['input']
}

export type ReterritorializarInput = {
  readonly imoveisId: ReadonlyArray<Scalars['ID']['input']>
  readonly lotacaoId: Scalars['ID']['input']
  readonly novaMicroarea: Scalars['String']['input']
  readonly progressToken: Scalars['String']['input']
}

export type RetificacaoAtendimentoInput = {
  readonly atendimentoRetificadoInput: AtendimentoIndividualInput
  readonly inativarAtendimentoInput: InativarAtendimentoInput
}

export type RetificacaoAtendimentoVacinacaoInput = {
  readonly atendimentoVacinacaoRetificadoInput: AtendimentoVacinacaoInput
  readonly inativarAtendimentoInput: InativarAtendimentoInput
}

export type Risco = {
  readonly __typename?: 'Risco'
  readonly descricaoOrigem?: Maybe<Scalars['String']['output']>
  readonly estratificacao?: Maybe<EstratificacaoRisco>
  readonly grupo?: Maybe<GrupoRisco>
  readonly origem?: Maybe<Scalars['String']['output']>
}

export type RiscoInput = {
  readonly ativo: Scalars['Boolean']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export enum RiscoVulnerabilidadeIvcfEnum {
  ALTO = 'ALTO',
  BAIXO = 'BAIXO',
  MODERADO = 'MODERADO',
}

export type RlUnidadeSaudeTipoServicoIds = {
  readonly __typename?: 'RlUnidadeSaudeTipoServicoIds'
  readonly tipoServicoId: Scalars['ID']['output']
  readonly unidadeSaudeId: Scalars['ID']['output']
}

export type SalaUnidadeSaude = {
  readonly __typename?: 'SalaUnidadeSaude'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type SalvarCredencialIntegracaoPayload = {
  readonly __typename?: 'SalvarCredencialIntegracaoPayload'
  readonly credencialIntegracao: CredenciaIntegracao
  readonly userPassword: CredenciaIntegracaoUserPasswordPayload
}

export type SalvarCuidadoCompartilhadoInput = {
  readonly agendamento?: InputMaybe<AgendamentoCuidadoCompartilhadoInput>
  readonly cuidadoCompartilhadoId: Scalars['ID']['input']
  readonly devolutiva?: InputMaybe<DevolutivaCuidadoCompartilhadoInput>
  readonly enviarGarantiaAcesso?: InputMaybe<EnviarGarantiaAcessoCuidadoCompartilhadoInput>
  readonly interconsulta?: InputMaybe<InterconsultaAgendamentoCuidadoCompartilhadoInput>
  readonly pergunta?: InputMaybe<PerguntaCuidadoCompartilhadoInput>
  readonly reclassificacaoPrioridade?: InputMaybe<ClassificacaoPrioridadeCuidadoEnum>
  readonly sugestaoAgendamentoGrupo?: InputMaybe<SugestaoAgendamentoGrupoCuidadoCompartilhadoInput>
  readonly trocaExecutante?: InputMaybe<TrocaExecutanteCuidadoCompartilhadoInput>
}

export type SalvarModeloRelatorioGerencialInput = {
  readonly isPublico: Scalars['Boolean']['input']
  readonly modeloPersonalizado: ModeloPersonalizadoRelatorioGerencialInput
  readonly nome: Scalars['String']['input']
  readonly tipoModulo: TipoModuloEnum
}

export type SalvarSistemaExternoInput = {
  readonly cpfCnpj: Scalars['String']['input']
  readonly email: Scalars['String']['input']
  readonly municipioIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly nome: Scalars['String']['input']
  readonly nomeResponsavel: Scalars['String']['input']
  readonly perfilIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly tipo: TipoSistemaExternoEnum
  readonly tipoPessoa: TipoPessoaEnum
  readonly url: Scalars['String']['input']
}

export type SalvarSistemaExternoPayload = {
  readonly __typename?: 'SalvarSistemaExternoPayload'
  readonly chaveAssinatura: Scalars['String']['output']
}

export type SalvarVinculacaoServicoInput = {
  readonly referenciaId: Scalars['ID']['input']
  readonly vinculacoesId: ReadonlyArray<Scalars['ID']['input']>
}

export type SaudeBucalConsolidado = {
  readonly __typename?: 'SaudeBucalConsolidado'
  readonly cidadaoId: Scalars['ID']['output']
  readonly escovacaoSupervisionadaEmAc?: Maybe<Scalars['LocalDate']['output']>
  readonly exodontiasDentesRealizadas?: Maybe<Scalars['Long']['output']>
  readonly procedimentoPreventivos?: Maybe<Scalars['Long']['output']>
  readonly ultimoAtendimentoPrimeiraConsultaProgramada?: Maybe<AtendimentoProfissional>
  readonly ultimoAtendimentoTratamentoConcluido?: Maybe<AtendimentoProfissionalOdonto>
  readonly ultimoTratamentoRestauradorAtraumatico?: Maybe<AtendimentoProfissionalOdonto>
}

export type SaudeMulherConsolidado = {
  readonly __typename?: 'SaudeMulherConsolidado'
  readonly cidadaoId: Scalars['ID']['output']
  readonly hepatiteB?: Maybe<Scalars['LocalDate']['output']>
  readonly hepatiteC?: Maybe<Scalars['LocalDate']['output']>
  readonly hiv?: Maybe<Scalars['LocalDate']['output']>
  readonly sifilis?: Maybe<Scalars['LocalDate']['output']>
  readonly ultimaAvaliacaoCancerColoUtero?: Maybe<ResultadoExameConsolidado>
  readonly ultimaAvaliacaoCancerMama?: Maybe<ResultadoExameConsolidado>
  readonly ultimaConsulta?: Maybe<AtendimentoProfissional>
  readonly ultimaRealizacaoCancerMama?: Maybe<ResultadoExameConsolidado>
  readonly ultimaSolicitacaoCancerColoUtero?: Maybe<ResultadoExameConsolidado>
  readonly ultimaSolicitacaoCancerMama?: Maybe<ResultadoExameConsolidado>
  readonly vacinasAplicadas: ReadonlyArray<FatoVacinacaoVacina>
}

export type SdcFatorVerificadoDto = {
  readonly __typename?: 'SdcFatorVerificadoDto'
  readonly fatorRisco: Scalars['String']['output']
  readonly ondeSistemaVerifica: Scalars['String']['output']
}

export type SdcFatoresVerificadosDto = {
  readonly __typename?: 'SdcFatoresVerificadosDto'
  readonly descricao: Scalars['String']['output']
  readonly fatores: ReadonlyArray<SdcFatorVerificadoDto>
}

export type SdcInput = {
  readonly colesterolTotalRecente?: InputMaybe<ResultadoExameSdcInput>
  readonly dataInicioAtendimentoProfissional?: InputMaybe<Scalars['LocalDate']['input']>
  readonly grupoDengue?: InputMaybe<GrupoSdcDengueEnum>
  readonly imcUltimas24Horas?: InputMaybe<Scalars['Float']['input']>
  readonly isAtendimentoPreNatal?: InputMaybe<Scalars['Boolean']['input']>
  readonly isGravidezMultipla?: InputMaybe<Scalars['Boolean']['input']>
  readonly isRegistroTardio?: InputMaybe<Scalars['Boolean']['input']>
  readonly pesoUltimas24Horas?: InputMaybe<Scalars['Float']['input']>
  readonly pressaoArterialSistolica?: InputMaybe<Scalars['String']['input']>
  readonly problemaCondicaoSdcInput?: InputMaybe<ReadonlyArray<ProblemaCondicaoSdcInput>>
  readonly prontuarioId: Scalars['ID']['input']
  readonly tipoAtendimento?: InputMaybe<TipoAtendimentoProfissional>
}

export type SdcPayload = AlertaSdc | CondutaSdc

export type SelecionarAcessoInput = {
  readonly id: Scalars['ID']['input']
}

export type SelecionarModuloInicialInput = {
  readonly moduloInicial: Scalars['String']['input']
}

export type SemanasDiasInput = {
  readonly dias?: InputMaybe<Scalars['Int']['input']>
  readonly semanas?: InputMaybe<Scalars['Int']['input']>
}

export type SentryConfig = {
  readonly __typename?: 'SentryConfig'
  readonly dsn?: Maybe<Scalars['String']['output']>
  readonly enabled: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
}

export type SerieHistoricaAgrupamento = {
  readonly __typename?: 'SerieHistoricaAgrupamento'
  readonly codigo?: Maybe<Scalars['Int']['output']>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly identificacao?: Maybe<Scalars['String']['output']>
}

export type SerieHistoricaConsolidado = {
  readonly __typename?: 'SerieHistoricaConsolidado'
  readonly competencia: Scalars['Int']['output']
  readonly numConsolidados: Scalars['Int']['output']
}

export type SerieHistoricaPayload = {
  readonly __typename?: 'SerieHistoricaPayload'
  readonly agrupamento1: SerieHistoricaAgrupamento
  readonly agrupamento2?: Maybe<SerieHistoricaAgrupamento>
  readonly agrupamento3?: Maybe<SerieHistoricaAgrupamento>
  readonly consolidadosPorCompetencia?: Maybe<ReadonlyArray<Maybe<SerieHistoricaConsolidado>>>
  readonly totalConsolidados?: Maybe<Scalars['Int']['output']>
}

export type SerieHistoricaQueryInput = {
  readonly dimCategoriaProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimEquipe?: InputMaybe<Scalars['ID']['input']>
  readonly dimMunicipio?: InputMaybe<Scalars['ID']['input']>
  readonly dimProfissional?: InputMaybe<Scalars['ID']['input']>
  readonly dimUnidadeSaude?: InputMaybe<Scalars['ID']['input']>
  readonly dimsFaixaEtaria?: InputMaybe<ReadonlyArray<InputMaybe<DimFaixaEtariaEnum>>>
  readonly dimsSexo?: InputMaybe<ReadonlyArray<InputMaybe<DimSexoEnum>>>
  readonly fim: Scalars['LocalDate']['input']
  readonly inicio: Scalars['LocalDate']['input']
  readonly nivelDetalhe: NivelDetalheSerieHistoricaEnum
  readonly producaoUsuario?: InputMaybe<NivelProducaoEnum>
  readonly tipoRelatorio: TipoSerieHistoricaEnum
}

export enum ServicosCertificadoEnum {
  CADSUS = 'CADSUS',
  PDM = 'PDM',
  RNDS = 'RNDS',
}

export type ServidorSmtp = {
  readonly __typename?: 'ServidorSMTP'
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly dataRegistro?: Maybe<Scalars['Instant']['output']>
  readonly email?: Maybe<Scalars['String']['output']>
  readonly endereco?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly porta?: Maybe<Scalars['String']['output']>
  readonly senha?: Maybe<Scalars['String']['output']>
  readonly usuario?: Maybe<Scalars['String']['output']>
}

export type Sessao = {
  readonly __typename?: 'Sessao'
  readonly acesso?: Maybe<Acesso>
  readonly expDateAccessTokenGovBr?: Maybe<Scalars['Instant']['output']>
  readonly id: Scalars['ID']['output']
  readonly profissional: Profissional
  readonly recursos?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly sessionProvider: SessionProviderEnum
  readonly timeout: Scalars['Int']['output']
}

export enum SessionEventType {
  LOGGED_IN_ANOTHER_SESSION = 'LOGGED_IN_ANOTHER_SESSION',
}

export enum SessionProviderEnum {
  GOVBR = 'GOVBR',
  PEC = 'PEC',
}

export enum SexoEnum {
  AMBOS = 'AMBOS',
  FEMININO = 'FEMININO',
  IGNORADO = 'IGNORADO',
  INDETERMINADO = 'INDETERMINADO',
  MASCULINO = 'MASCULINO',
  NAO_INFORMADO = 'NAO_INFORMADO',
}

export type SinanNotificacaoEvolucao = {
  readonly __typename?: 'SinanNotificacaoEvolucao'
  readonly id: Scalars['ID']['output']
  readonly notificacao: FichaNotificacaoCasoSuspeito
}

export type SincronizaCidadaoCadsusInput = {
  readonly cidadao: Scalars['ID']['input']
  readonly nomeSocialAntigo?: InputMaybe<Scalars['String']['input']>
  readonly telefoneCelularAntigo?: InputMaybe<Scalars['String']['input']>
  readonly telefoneContatoAntigo?: InputMaybe<Scalars['String']['input']>
  readonly telefoneResidencialAntigo?: InputMaybe<Scalars['String']['input']>
  readonly uuid: Scalars['String']['input']
}

export type SincronizacaoCadsusResultDto = {
  readonly __typename?: 'SincronizacaoCadsusResultDto'
  readonly camposAlterados?: Maybe<ReadonlyArray<Maybe<CampoAlteradoCadsus>>>
  readonly cidadaoCadsus?: Maybe<CidadaoCadsus>
  readonly cidadaoLocal?: Maybe<Cidadao>
  readonly cidadaosDuplicados?: Maybe<ReadonlyArray<Maybe<CidadaoDuplicadoDto>>>
  readonly cpfAntigo?: Maybe<Scalars['String']['output']>
  readonly errors?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>
  readonly result?: Maybe<SincronizacaoCadsusResultEnum>
  readonly usuario?: Maybe<Scalars['ID']['output']>
  readonly uuid: Scalars['String']['output']
}

export enum SincronizacaoCadsusResultEnum {
  DUPLICIDADE_CNS_ATIVOS = 'DUPLICIDADE_CNS_ATIVOS',
  DUPLICIDADE_CNS_INATIVOS = 'DUPLICIDADE_CNS_INATIVOS',
  DUPLICIDADE_CPF_ATIVOS = 'DUPLICIDADE_CPF_ATIVOS',
  DUPLICIDADE_CPF_INATIVOS = 'DUPLICIDADE_CPF_INATIVOS',
  ERRO = 'ERRO',
  ERRO_AUTENTICACAO = 'ERRO_AUTENTICACAO',
  ERRO_BUSCA_SEM_RETORNO = 'ERRO_BUSCA_SEM_RETORNO',
  ERRO_CADSUS_DESABILITADO = 'ERRO_CADSUS_DESABILITADO',
  ERRO_CERTIFICADO_DESABILITADO = 'ERRO_CERTIFICADO_DESABILITADO',
  ERRO_SEM_CONEXAO = 'ERRO_SEM_CONEXAO',
  LENTO = 'LENTO',
  NAO_ENVIADO_SEXO_INDETERMINADO = 'NAO_ENVIADO_SEXO_INDETERMINADO',
  POSSUI_PRONTUARIO = 'POSSUI_PRONTUARIO',
  SUCESSO = 'SUCESSO',
  VALIDACAO_APENAS_NOME = 'VALIDACAO_APENAS_NOME',
  VALIDACAO_APENAS_NOME_MAE = 'VALIDACAO_APENAS_NOME_MAE',
  VALIDACAO_COM_CNS = 'VALIDACAO_COM_CNS',
  VALIDACAO_NOME_MAE_MINIMO_DUAS_PALAVRAS = 'VALIDACAO_NOME_MAE_MINIMO_DUAS_PALAVRAS',
  VALIDACAO_NOME_MINIMO_DUAS_PALAVRAS = 'VALIDACAO_NOME_MINIMO_DUAS_PALAVRAS',
  VALIDACAO_OBRIGATORIO_NOME_OU_NOME_MAE = 'VALIDACAO_OBRIGATORIO_NOME_OU_NOME_MAE',
  VALIDACAO_SEM_CNS = 'VALIDACAO_SEM_CNS',
}

export type SistemaExterno = {
  readonly __typename?: 'SistemaExterno'
  readonly ativo: Scalars['Boolean']['output']
  readonly cpfCnpj: Scalars['String']['output']
  readonly dataCriacao: Scalars['Instant']['output']
  readonly dataInativacao?: Maybe<Scalars['Instant']['output']>
  readonly email: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly municipios: ReadonlyArray<Municipio>
  readonly nome: Scalars['String']['output']
  readonly nomeResponsavel: Scalars['String']['output']
  readonly perfis: ReadonlyArray<Perfil>
  readonly tipo: TipoSistemaExternoEnum
  readonly tipoPessoa: TipoPessoaEnum
  readonly url: Scalars['String']['output']
}

export type SistemaExternoPayload = {
  readonly __typename?: 'SistemaExternoPayload'
  readonly content: ReadonlyArray<Maybe<SistemaExterno>>
  readonly pageInfo: PageInfo
}

export type SistemaExternoQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteAtivos?: InputMaybe<Scalars['Boolean']['input']>
}

export enum SituacaoAgendadoEnum {
  AGENDADO = 'AGENDADO',
  ATENDIMENTO_REALIZADO = 'ATENDIMENTO_REALIZADO',
  CANCELADO = 'CANCELADO',
  CIDADAO_PRESENTE_NA_UNIDADE = 'CIDADAO_PRESENTE_NA_UNIDADE',
  EXCLUIDO = 'EXCLUIDO',
  NAO_AGUARDOU = 'NAO_AGUARDOU',
  NAO_COMPARECEU = 'NAO_COMPARECEU',
}

export enum SituacaoCoroaEnum {
  A_SER_TRATADO = 'A_SER_TRATADO',
  NENHUM = 'NENHUM',
  TRATADO = 'TRATADO',
}

export type SituacaoDeRua = {
  readonly __typename?: 'SituacaoDeRua'
  readonly grauParentescoVisitaFamiliar?: Maybe<Scalars['String']['output']>
  readonly higienePessoal?: Maybe<ReadonlyArray<HigienePessoalEnum>>
  readonly id: Scalars['ID']['output']
  readonly instituicaoAcompanhamento?: Maybe<Scalars['String']['output']>
  readonly origemAlimentacao?: Maybe<ReadonlyArray<OrigemAlimentacaoEnum>>
  readonly possuiReferenciaFamiliar?: Maybe<Scalars['Boolean']['output']>
  readonly quantidadeAlimentacaoDiaria?: Maybe<QuantidadeAlimentacaoDiariaEnum>
  readonly recebeAlgumBeneficio?: Maybe<Scalars['Boolean']['output']>
  readonly stAcessoHigienePessoal?: Maybe<Scalars['Boolean']['output']>
  readonly stAcompanhadoOutraInstituicao?: Maybe<Scalars['Boolean']['output']>
  readonly stSituacaoDeRua?: Maybe<Scalars['Boolean']['output']>
  readonly stVisitaFamiliarComFrequencia?: Maybe<Scalars['Boolean']['output']>
  readonly tempoSituacaoDeRua?: Maybe<TempoSituacaoDeRuaEnum>
}

export type SituacaoDeRuaInput = {
  readonly grauParentescoVisitaFamiliar?: InputMaybe<Scalars['String']['input']>
  readonly higienePessoal?: InputMaybe<ReadonlyArray<HigienePessoalEnum>>
  readonly instituicaoAcompanhamento?: InputMaybe<Scalars['String']['input']>
  readonly origemAlimentacao?: InputMaybe<ReadonlyArray<OrigemAlimentacaoEnum>>
  readonly possuiReferenciaFamiliar?: InputMaybe<Scalars['Boolean']['input']>
  readonly quantidadeAlimentacaoDiaria?: InputMaybe<QuantidadeAlimentacaoDiariaEnum>
  readonly recebeAlgumBeneficio?: InputMaybe<Scalars['Boolean']['input']>
  readonly stAcessoHigienePessoal?: InputMaybe<Scalars['Boolean']['input']>
  readonly stAcompanhadoOutraInstituicao?: InputMaybe<Scalars['Boolean']['input']>
  readonly stVisitaFamiliarComFrequencia?: InputMaybe<Scalars['Boolean']['input']>
  readonly tempoSituacaoDeRua?: InputMaybe<TempoSituacaoDeRuaEnum>
}

export enum SituacaoFaceEnum {
  AUSENTE = 'AUSENTE',
  CALCULO_DENTAL = 'CALCULO_DENTAL',
  CARIADO = 'CARIADO',
  COROA = 'COROA',
  EXTRACAO_INDICADA = 'EXTRACAO_INDICADA',
  EXTRAIDO = 'EXTRAIDO',
  FRATURA = 'FRATURA',
  HIGIDO = 'HIGIDO',
  HIGIDO_SELADO = 'HIGIDO_SELADO',
  INCLUSO = 'INCLUSO',
  MANCHA_BRANCA_ATIVA = 'MANCHA_BRANCA_ATIVA',
  MANTENEDOR_ESPACO = 'MANTENEDOR_ESPACO',
  NENHUM = 'NENHUM',
  PILAR = 'PILAR',
  PROTESE_CORONARIA_UNITARIA = 'PROTESE_CORONARIA_UNITARIA',
  PROTESE_PARCIAL_REMOVIVEL = 'PROTESE_PARCIAL_REMOVIVEL',
  PROTESE_TEMPORARIA = 'PROTESE_TEMPORARIA',
  PROTESE_TOTAL = 'PROTESE_TOTAL',
  RESTAURADO = 'RESTAURADO',
  RESTAURADO_COM_CARIE = 'RESTAURADO_COM_CARIE',
  RESTO_RADICULAR = 'RESTO_RADICULAR',
  RETRACAO_GENGIVAL = 'RETRACAO_GENGIVAL',
  SELANTE_INDICADO = 'SELANTE_INDICADO',
}

export enum SituacaoMercadoTrabalhoEnum {
  APOSENTADO_PENSIONISTA = 'APOSENTADO_PENSIONISTA',
  ASSALARIADO_COM_CARTEIRA_TRABALHO = 'ASSALARIADO_COM_CARTEIRA_TRABALHO',
  ASSALARIADO_SEM_CARTEIRA_TRABALHO = 'ASSALARIADO_SEM_CARTEIRA_TRABALHO',
  AUTONOMO_COM_PREVIDENCIA_SOCIAL = 'AUTONOMO_COM_PREVIDENCIA_SOCIAL',
  AUTONOMO_SEM_PREVIDENCIA_SOCIAL = 'AUTONOMO_SEM_PREVIDENCIA_SOCIAL',
  DESEMPREGADO = 'DESEMPREGADO',
  EMPREGADOR = 'EMPREGADOR',
  NAO_TRABALHA = 'NAO_TRABALHA',
  OUTRO = 'OUTRO',
  SERVIDOR_PUBLICO_MILITAR = 'SERVIDOR_PUBLICO_MILITAR',
}

export enum SituacaoProblema {
  ATIVO = 'ATIVO',
  LATENTE = 'LATENTE',
  RESOLVIDO = 'RESOLVIDO',
}

export enum SituacaoRaizEnum {
  CARIE_DE_RAIZ = 'CARIE_DE_RAIZ',
  CARIE_DE_RAIZ_TRATADA = 'CARIE_DE_RAIZ_TRATADA',
  ENDODONTIA = 'ENDODONTIA',
  ENDODONTIA_TRATADA = 'ENDODONTIA_TRATADA',
  IMPLANTE = 'IMPLANTE',
  LESAO_DE_FURCA = 'LESAO_DE_FURCA',
  LESAO_DE_FURCA_TRATADA = 'LESAO_DE_FURCA_TRATADA',
  NENHUM = 'NENHUM',
  NUCLEO_METALICO_FUNDIDO = 'NUCLEO_METALICO_FUNDIDO',
}

export enum SituacaoSincronizacaoAgendaOnlineEnum {
  AGUARDANDO_ELEGIBILIDADE_CADASTRO_CIDADAO = 'AGUARDANDO_ELEGIBILIDADE_CADASTRO_CIDADAO',
  AGUARDANDO_SINCRONIZACAO = 'AGUARDANDO_SINCRONIZACAO',
  AGUARDANDO_SINCRONIZACAO_ATUALIZACAO = 'AGUARDANDO_SINCRONIZACAO_ATUALIZACAO',
  ANTERIOR_ATIVACAO_AGENDA_ONLINE = 'ANTERIOR_ATIVACAO_AGENDA_ONLINE',
  INELEGIVEL = 'INELEGIVEL',
  REGISTRO_INCONSISTENTE = 'REGISTRO_INCONSISTENTE',
  SINCRONIZADO = 'SINCRONIZADO',
}

export type SolicitacaoExame = {
  readonly __typename?: 'SolicitacaoExame'
  readonly atendimentoProfissional: AtendimentoProfissional
  readonly cid10?: Maybe<Cid10>
  readonly data: Scalars['LocalDate']['output']
  readonly exames: ReadonlyArray<ResultadoExame>
  readonly id: Scalars['ID']['output']
  readonly justificativa: Scalars['String']['output']
  readonly observacoes?: Maybe<Scalars['String']['output']>
  readonly solicitacaoCitopatologico?: Maybe<SolicitacaoExameCitopatologico>
  readonly tipoExame: TipoExameEnum
}

export type SolicitacaoExameCitopatologico = {
  readonly __typename?: 'SolicitacaoExameCitopatologico'
  readonly id: Scalars['ID']['output']
  readonly questoes: ReadonlyArray<Maybe<SolicitacaoExameCitopatologicoQuestao>>
}

export type SolicitacaoExameCitopatologicoQuestao = {
  readonly __typename?: 'SolicitacaoExameCitopatologicoQuestao'
  readonly id: Scalars['ID']['output']
  readonly pergunta: RastreioCancerPerguntaDbEnum
  readonly resposta: Scalars['String']['output']
}

export type SolicitacaoExameInput = {
  readonly cid10?: InputMaybe<Scalars['ID']['input']>
  readonly examesRequisitados: ReadonlyArray<ExameRequisitadoInput>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly justificativa: Scalars['String']['input']
  readonly observacoes?: InputMaybe<Scalars['String']['input']>
  readonly rastreioCancer?: InputMaybe<ReadonlyArray<InputMaybe<RastreioCancerInput>>>
  readonly tipoExame: TipoExameEnum
  readonly tipoRastreioCancer?: InputMaybe<TipoRastreioCancerEnum>
}

export type SolicitacaoFraldasGeriatricasPlanoInput = {
  readonly assinadoDigitalmente: Scalars['Boolean']['input']
  readonly cid10Id?: InputMaybe<Scalars['ID']['input']>
  readonly cpfCns?: InputMaybe<Scalars['String']['input']>
  readonly descricao: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly naoPossui?: InputMaybe<Scalars['Boolean']['input']>
  readonly tamanhoFralda: TamanhoFraldaGeriatricaEnum
  readonly unidadesPorDia: Scalars['Int']['input']
}

export type SolicitacoesExamePayload = {
  readonly __typename?: 'SolicitacoesExamePayload'
  readonly content: ReadonlyArray<SolicitacaoExame>
  readonly pageInfo: PageInfo
}

export type SolicitacoesExameQueryInput = {
  readonly cboId?: InputMaybe<Scalars['ID']['input']>
  readonly dataFim?: InputMaybe<Scalars['LocalDate']['input']>
  readonly dataInicio?: InputMaybe<Scalars['LocalDate']['input']>
  readonly editAtendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly profissionalId?: InputMaybe<Scalars['ID']['input']>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteMinhasSolicitacoes?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoExame?: InputMaybe<TipoExameEnum>
}

export type SolicitarEntradaVideochamadaInput = {
  readonly cpfParticipante?: InputMaybe<Scalars['String']['input']>
  readonly nomeParticipante?: InputMaybe<Scalars['String']['input']>
  readonly termoProfissionalAceito: Scalars['Boolean']['input']
  readonly videochamadaUuid: Scalars['String']['input']
}

export type SolicitarRecuperacaoSenhaInput = {
  readonly usuario: Scalars['String']['input']
}

export enum Sort {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum StatusAssinatura {
  ASSINADO = 'ASSINADO',
  ERRO_ASSINATURA = 'ERRO_ASSINATURA',
}

export enum StatusAtendimento {
  AGUARDANDO_ATENDIMENTO = 'AGUARDANDO_ATENDIMENTO',
  AGUARDANDO_OBSERVACAO = 'AGUARDANDO_OBSERVACAO',
  ATENDIMENTO_REALIZADO = 'ATENDIMENTO_REALIZADO',
  EM_ATENDIMENTO = 'EM_ATENDIMENTO',
  EM_ESCUTA_INICIAL = 'EM_ESCUTA_INICIAL',
  EM_OBSERVACAO = 'EM_OBSERVACAO',
  EVADIU_OBSERVACAO = 'EVADIU_OBSERVACAO',
  NAO_AGUARDOU = 'NAO_AGUARDOU',
}

export enum StatusAtendimentoProfissional {
  ATENDIMENTO_FINALIZADO = 'ATENDIMENTO_FINALIZADO',
  EM_ATENDIMENTO = 'EM_ATENDIMENTO',
}

export enum StatusAutorizacaoAbsorvente {
  ERRO = 'ERRO',
  NAO_PERMITIDO = 'NAO_PERMITIDO',
  OK = 'OK',
}

export enum StatusAvaliadoEnum {
  AUSENTE = 'AUSENTE',
  NAO_AVALIADO = 'NAO_AVALIADO',
  PRESENTE = 'PRESENTE',
  PRESENTE_COM_ATRASO = 'PRESENTE_COM_ATRASO',
}

export enum StatusConexaoRndsEnum {
  CERTIFICADO_EXPIRADO = 'CERTIFICADO_EXPIRADO',
  CERTIFICADO_INVALIDO = 'CERTIFICADO_INVALIDO',
  CERTIFICADO_NAO_ENCONTRADO = 'CERTIFICADO_NAO_ENCONTRADO',
  CONEXAO_BEM_SUCEDIDA = 'CONEXAO_BEM_SUCEDIDA',
  SEM_CONEXAO = 'SEM_CONEXAO',
}

export enum StatusCuidadoCompartilhadoEnum {
  AGUARDANDO = 'AGUARDANDO',
  FINALIZADO_OBITO = 'FINALIZADO_OBITO',
  RESPONDIDO = 'RESPONDIDO',
}

export enum StatusDiaAgendaEnum {
  DISPONIVEL = 'DISPONIVEL',
  INDISPONIVEL = 'INDISPONIVEL',
}

export enum StatusDocumentosCidadao {
  DOCUMENTOS_DUPLICADOS = 'DOCUMENTOS_DUPLICADOS',
  MANUALMENTE_UNIFICADO = 'MANUALMENTE_UNIFICADO',
  SEM_CORRESPONDENCIA = 'SEM_CORRESPONDENCIA',
}

export enum StatusEnvio {
  ENVIANDO = 'ENVIANDO',
  NAO_ENVIADO = 'NAO_ENVIADO',
  PARCIALMENTE_ENVIADO = 'PARCIALMENTE_ENVIADO',
  TOTALMENTE_ENVIADO = 'TOTALMENTE_ENVIADO',
}

export enum StatusFichaEnum {
  ENVIADA = 'ENVIADA',
  NAO_ENVIADA = 'NAO_ENVIADA',
  RASCUNHO = 'RASCUNHO',
}

export enum StatusImportacaoArquivo {
  CONCLUIDO = 'CONCLUIDO',
  ERRO = 'ERRO',
  IMPORTANDO = 'IMPORTANDO',
  PROCESSAMENTO_DUPLICADO_CONCLUIDO = 'PROCESSAMENTO_DUPLICADO_CONCLUIDO',
  SEM_RESULTADO = 'SEM_RESULTADO',
}

export enum StatusImportacaoBolsaFamiliaEnum {
  EM_PROGRESSO = 'EM_PROGRESSO',
  FALHA = 'FALHA',
  FINALIZADO = 'FINALIZADO',
}

export enum StatusPareamentoDispositivoPainelEnum {
  AGUARDANDO = 'AGUARDANDO',
  INVALIDO = 'INVALIDO',
  PAREADO = 'PAREADO',
}

export enum StatusPedidoEnvioEnum {
  AGUARDANDO_APROVACAO = 'AGUARDANDO_APROVACAO',
  APROVADO = 'APROVADO',
  CANCELADO = 'CANCELADO',
  ENVIANDO_CDS = 'ENVIANDO_CDS',
  ENVIANDO_CIDADAOS = 'ENVIANDO_CIDADAOS',
  ENVIANDO_PROFISSIONAIS = 'ENVIANDO_PROFISSIONAIS',
  ENVIO_COMPLETO = 'ENVIO_COMPLETO',
  ERRO_CIDADAOS = 'ERRO_CIDADAOS',
  ERRO_ESTAGIOS = 'ERRO_ESTAGIOS',
  ERRO_FINALIZACAO = 'ERRO_FINALIZACAO',
  ERRO_LOTACOES_ENVOLVIDAS = 'ERRO_LOTACOES_ENVOLVIDAS',
  ERRO_PROFISSIONAIS = 'ERRO_PROFISSIONAIS',
  ERRO_RESERVAS = 'ERRO_RESERVAS',
  ERRO_VERSAO = 'ERRO_VERSAO',
  FINALIZANDO_UNIFICACAO_BASE = 'FINALIZANDO_UNIFICACAO_BASE',
  RECUSADO = 'RECUSADO',
  SALVANDO_ESTAGIOS = 'SALVANDO_ESTAGIOS',
  SALVANDO_LOTACOES_ENVOLVIDAS = 'SALVANDO_LOTACOES_ENVOLVIDAS',
  SALVANDO_RESERVAS = 'SALVANDO_RESERVAS',
}

export enum StatusProcesso {
  AGUARDANDO = 'AGUARDANDO',
  CONCLUIDO = 'CONCLUIDO',
  EM_EXECUCAO = 'EM_EXECUCAO',
  ERRO = 'ERRO',
  INTERROMPIDO = 'INTERROMPIDO',
}

export enum StatusProcessoAuditoria {
  ERRO_INESPERADO = 'ERRO_INESPERADO',
  ERRO_MUITAS_REVISOES = 'ERRO_MUITAS_REVISOES',
  ERRO_PDF_NAO_SUPORTADO = 'ERRO_PDF_NAO_SUPORTADO',
  ERRO_PROCESSO_EXECUTANDO = 'ERRO_PROCESSO_EXECUTANDO',
  ERRO_SEM_DADOS = 'ERRO_SEM_DADOS',
  PROCESSADO = 'PROCESSADO',
  PROCESSANDO = 'PROCESSANDO',
}

export enum StatusRegulacaoEnum {
  AGENDAMENTO_CANCELADO = 'AGENDAMENTO_CANCELADO',
  AGENDAMENTO_COM_FALTA = 'AGENDAMENTO_COM_FALTA',
  AGENDAMENTO_CONFIRMADO = 'AGENDAMENTO_CONFIRMADO',
  ATENDIMENTO_AGENDADO = 'ATENDIMENTO_AGENDADO',
  DEVOLVIDO_PELA_REGULACAO = 'DEVOLVIDO_PELA_REGULACAO',
  NEGADA_PELA_REGULACAO = 'NEGADA_PELA_REGULACAO',
  PENDENTE_DE_AGENDAMENTO = 'PENDENTE_DE_AGENDAMENTO',
  PENDENTE_DE_REGULACAO = 'PENDENTE_DE_REGULACAO',
  SOLICITACAO_CANCELADA = 'SOLICITACAO_CANCELADA',
  SOLICITADA = 'SOLICITADA',
}

export enum StatusRelatorioEnvioRndsEnum {
  ENVIADOS_SUCESSO = 'ENVIADOS_SUCESSO',
  TENTATIVAS_ERROS = 'TENTATIVAS_ERROS',
}

export enum StatusRevisaoAtendimento {
  AGUARDANDO_RETIFICACAO = 'AGUARDANDO_RETIFICACAO',
  AGUARDANDO_REVISAO = 'AGUARDANDO_REVISAO',
  EM_RETIFICACAO = 'EM_RETIFICACAO',
  EM_REVISAO = 'EM_REVISAO',
}

export enum StatusUnificacaoBaseEnum {
  AGUARDANDO_AVALIACAO = 'AGUARDANDO_AVALIACAO',
  AGUARDANDO_ENVIO_BASE = 'AGUARDANDO_ENVIO_BASE',
  AGUARDANDO_FINALIZACAO = 'AGUARDANDO_FINALIZACAO',
  BASE_UNIFICADA = 'BASE_UNIFICADA',
  CANCELADA = 'CANCELADA',
  ERRO = 'ERRO',
  ERRO_VERSAO = 'ERRO_VERSAO',
  REPROVADA = 'REPROVADA',
  UNIFICANDO_BASES = 'UNIFICANDO_BASES',
}

export enum StatusVacinacaoEnum {
  APLICADA = 'APLICADA',
  ATRASADA = 'ATRASADA',
  NO_PRAZO = 'NO_PRAZO',
}

export enum StatusVideochamadaEnum {
  AGUARDANDO_INICIO = 'AGUARDANDO_INICIO',
  ATIVA = 'ATIVA',
  ATIVA_SEM_DONO = 'ATIVA_SEM_DONO',
  CANCELADA = 'CANCELADA',
  ENCERRADA = 'ENCERRADA',
  LOTADA = 'LOTADA',
  NAO_ENCONTRADA = 'NAO_ENCONTRADA',
}

export enum SubGrupoProcedimentoEnum {
  ACOES_COLETIVAS_INDIVIDUAIS_EM_SAUDE = 'ACOES_COLETIVAS_INDIVIDUAIS_EM_SAUDE',
  ACOES_RELACIONADAS_AO_ATENDIMENTO = 'ACOES_RELACIONADAS_AO_ATENDIMENTO',
  ACOES_RELACIONADAS_AO_ESTABELECIMENTO = 'ACOES_RELACIONADAS_AO_ESTABELECIMENTO',
  ACOES_RELACIONADAS_DOACAO_DE_ORGAOS_TECIDOS_PARA_TRANSPLANTE = 'ACOES_RELACIONADAS_DOACAO_DE_ORGAOS_TECIDOS_PARA_TRANSPLANTE',
  ACOMPANHAMENTO_INTERCORRENCIAS_PRE_POS_TRANSPLANTE = 'ACOMPANHAMENTO_INTERCORRENCIAS_PRE_POS_TRANSPLANTE',
  ANESTESIOLOGIA = 'ANESTESIOLOGIA',
  ATENCAO_EM_CARDIOLOGIA = 'ATENCAO_EM_CARDIOLOGIA',
  ATENCAO_EM_OFTALMOLOGIA = 'ATENCAO_EM_OFTALMOLOGIA',
  ATENCAO_EM_ONCOLOGIA = 'ATENCAO_EM_ONCOLOGIA',
  ATENCAO_EM_ORTOPEDIA = 'ATENCAO_EM_ORTOPEDIA',
  ATENCAO_EM_OTORRINOLARINGOLOGIA = 'ATENCAO_EM_OTORRINOLARINGOLOGIA',
  AUTORIZACAO_REGULACAO = 'AUTORIZACAO_REGULACAO',
  AVALIACAO_DE_MORTE_ENCEFALICA = 'AVALIACAO_DE_MORTE_ENCEFALICA',
  BUCOMAXILOFACIAL = 'BUCOMAXILOFACIAL',
  CIRURGIA_DAS_VIAS_AEREAS_SUPERIORES_FACE_CABECA_PESCOCO = 'CIRURGIA_DAS_VIAS_AEREAS_SUPERIORES_FACE_CABECA_PESCOCO',
  CIRURGIA_DE_GLANDULAS_ENDOCRINAS = 'CIRURGIA_DE_GLANDULAS_ENDOCRINAS',
  CIRURGIA_DE_MAMA = 'CIRURGIA_DE_MAMA',
  CIRURGIA_DO_APARELHO_CIRCULATORIO = 'CIRURGIA_DO_APARELHO_CIRCULATORIO',
  CIRURGIA_DO_APARELHO_DA_VISAO = 'CIRURGIA_DO_APARELHO_DA_VISAO',
  CIRURGIA_DO_APARELHO_DIGESTIVO_ORGAOS_ANEXOS_PAREDE_ABDOMINAL = 'CIRURGIA_DO_APARELHO_DIGESTIVO_ORGAOS_ANEXOS_PAREDE_ABDOMINAL',
  CIRURGIA_DO_APARELHO_GENITURINARIO = 'CIRURGIA_DO_APARELHO_GENITURINARIO',
  CIRURGIA_DO_SISTEMA_NERVOSO_CENTRAL_PERIFERICO = 'CIRURGIA_DO_SISTEMA_NERVOSO_CENTRAL_PERIFERICO',
  CIRURGIA_DO_SISTEMA_OSTEOMUSCULAR = 'CIRURGIA_DO_SISTEMA_OSTEOMUSCULAR',
  CIRURGIA_EM_NEFROLOGIA = 'CIRURGIA_EM_NEFROLOGIA',
  CIRURGIA_EM_ONCOLOGIA = 'CIRURGIA_EM_ONCOLOGIA',
  CIRURGIA_OBSTETRICA = 'CIRURGIA_OBSTETRICA',
  CIRURGIA_REPARADORA = 'CIRURGIA_REPARADORA',
  CIRURGIA_TORACICA = 'CIRURGIA_TORACICA',
  COLETA_DE_MATERIAL = 'COLETA_DE_MATERIAL',
  COLETA_EXAMES_PARA_DOACAO_DE_ORGAOS_TECIDOS_CELULAS_TRANSPLANTE = 'COLETA_EXAMES_PARA_DOACAO_DE_ORGAOS_TECIDOS_CELULAS_TRANSPLANTE',
  COMPONENTE_ESPECIALIZADO_DA_ASSISTENCIA_FARMACEUTICA = 'COMPONENTE_ESPECIALIZADO_DA_ASSISTENCIA_FARMACEUTICA',
  CONSULTAS_ATENDIMENTOS = 'CONSULTAS_ATENDIMENTOS',
  CONSULTAS_ATENDIMENTOS_ACOMPANHAMENTOS = 'CONSULTAS_ATENDIMENTOS_ACOMPANHAMENTOS',
  CUIDADOS_PALIATIVOS = 'CUIDADOS_PALIATIVOS',
  DIAGNOSTICO_EM_LABORATORIO_CLINICO = 'DIAGNOSTICO_EM_LABORATORIO_CLINICO',
  DIAGNOSTICO_EM_VIGILANCIA_EPIDEMIOLOGICA_AMBIENTAL = 'DIAGNOSTICO_EM_VIGILANCIA_EPIDEMIOLOGICA_AMBIENTAL',
  DIAGNOSTICO_POR_ANATOMIA_PATOLOGICA_CITOPATOLOGIA = 'DIAGNOSTICO_POR_ANATOMIA_PATOLOGICA_CITOPATOLOGIA',
  DIAGNOSTICO_POR_ENDOSCOPIA = 'DIAGNOSTICO_POR_ENDOSCOPIA',
  DIAGNOSTICO_POR_MEDICINA_NUCLEAR_IN_VIVO = 'DIAGNOSTICO_POR_MEDICINA_NUCLEAR_IN_VIVO',
  DIAGNOSTICO_POR_RADIOLOGIA = 'DIAGNOSTICO_POR_RADIOLOGIA',
  DIAGNOSTICO_POR_RADIOLOGIA_INTERVENCIONISTA = 'DIAGNOSTICO_POR_RADIOLOGIA_INTERVENCIONISTA',
  DIAGNOSTICO_POR_RESSONANCIA_MAGNETICA = 'DIAGNOSTICO_POR_RESSONANCIA_MAGNETICA',
  DIAGNOSTICO_POR_TESTE_RAPIDO = 'DIAGNOSTICO_POR_TESTE_RAPIDO',
  DIAGNOSTICO_POR_TOMOGRAFIA = 'DIAGNOSTICO_POR_TOMOGRAFIA',
  DIAGNOSTICO_POR_ULTRASONOGRAFIA = 'DIAGNOSTICO_POR_ULTRASONOGRAFIA',
  DIAGNOSTICO_PROCEDIMENTOS_ESPECIAIS_HEMOTERAPIA = 'DIAGNOSTICO_PROCEDIMENTOS_ESPECIAIS_HEMOTERAPIA',
  FISIOTERAPIA = 'FISIOTERAPIA',
  HEMOTERAPIA = 'HEMOTERAPIA',
  MEDICAMENTOS_DE_AMBITO_HOSPITALAR_URGENCIA = 'MEDICAMENTOS_DE_AMBITO_HOSPITALAR_URGENCIA',
  MEDICAMENTOS_DE_DISPENSACAO_EXCEPCIONAL = 'MEDICAMENTOS_DE_DISPENSACAO_EXCEPCIONAL',
  MEDICAMENTOS_ESTRATEGICOS = 'MEDICAMENTOS_ESTRATEGICOS',
  METODOS_DIAGNOSTICOS_EM_ESPECIALIDADES = 'METODOS_DIAGNOSTICOS_EM_ESPECIALIDADES',
  ORTESES_PROTESES_MATERIAIS_ESPECIAIS_NAO_RELACIONADOS_AO_ATO_CIRURGICO = 'ORTESES_PROTESES_MATERIAIS_ESPECIAIS_NAO_RELACIONADOS_AO_ATO_CIRURGICO',
  ORTESES_PROTESES_MATERIAIS_ESPECIAIS_RELACIONADOS_AO_ATO_CIRURGICO = 'ORTESES_PROTESES_MATERIAIS_ESPECIAIS_RELACIONADOS_AO_ATO_CIRURGICO',
  OUTRAS_CIRURGIAS = 'OUTRAS_CIRURGIAS',
  PARTO_NASCIMENTO = 'PARTO_NASCIMENTO',
  PEQUENAS_CIRURGIAS_CIRURGIAS_PELE_TECIDO_SUBCUTANEO_MUCOSA = 'PEQUENAS_CIRURGIAS_CIRURGIAS_PELE_TECIDO_SUBCUTANEO_MUCOSA',
  PROCESSAMENTO_DE_TECIDOS_PARA_TRANSPLANTE = 'PROCESSAMENTO_DE_TECIDOS_PARA_TRANSPLANTE',
  TELESSAUDE = 'TELESSAUDE',
  TERAPIAS_ESPECIALIZADAS = 'TERAPIAS_ESPECIALIZADAS',
  TRANSPLANTE_DE_ORGAOS_TECIDOS_CELULAS = 'TRANSPLANTE_DE_ORGAOS_TECIDOS_CELULAS',
  TRATAMENTOS_CLINICOS_OUTRAS_ESPECIALIDADES = 'TRATAMENTOS_CLINICOS_OUTRAS_ESPECIALIDADES',
  TRATAMENTOS_ODONTOLOGICOS = 'TRATAMENTOS_ODONTOLOGICOS',
  TRATAMENTO_DE_LESOES_ENVENENAMENTOS_OUTROS_DECORRENTES_CAUSAS_EXTERNAS = 'TRATAMENTO_DE_LESOES_ENVENENAMENTOS_OUTROS_DECORRENTES_CAUSAS_EXTERNAS',
  TRATAMENTO_EM_NEFROLOGIA = 'TRATAMENTO_EM_NEFROLOGIA',
  TRATAMENTO_EM_ONCOLOGIA = 'TRATAMENTO_EM_ONCOLOGIA',
  VIGILANCIA_EM_SAUDE = 'VIGILANCIA_EM_SAUDE',
}

export type SubjetivoInput = {
  readonly motivos?: InputMaybe<ReadonlyArray<MotivoConsultaInput>>
  readonly texto?: InputMaybe<Scalars['String']['input']>
}

export type SubstanciaCbaraAlergia = {
  readonly __typename?: 'SubstanciaCbaraAlergia'
  readonly categoria: CategoriaSubstanciaAlergia
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sinonimos?: Maybe<Scalars['String']['output']>
}

export type SubstanciaCbaraAlergiaQueryPayload = {
  readonly __typename?: 'SubstanciaCbaraAlergiaQueryPayload'
  readonly content: ReadonlyArray<SubstanciaCbaraAlergia>
  readonly pageInfo: PageInfo
}

export type SubstanciaEspecificaAlergia = {
  readonly __typename?: 'SubstanciaEspecificaAlergia'
  readonly categoria: CategoriaSubstanciaAlergia
  readonly coPrincipioAtivo?: Maybe<Scalars['Long']['output']>
  readonly coSubstanciaEspecifica: Scalars['Long']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sigla?: Maybe<Scalars['String']['output']>
  readonly sinonimos?: Maybe<Scalars['String']['output']>
}

export type SubstanciasCbaraAlergiaQueryInput = {
  readonly categoria: CategoriaSubstanciaAlergia
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum SubtipoAtendimentoHistoricoClinico {
  ATENDIMENTO_GRUPO = 'ATENDIMENTO_GRUPO',
  AVALIACAO_PROCEDIMENTO_COLETIVO = 'AVALIACAO_PROCEDIMENTO_COLETIVO',
  CIDADAOS_MAIORES_2_ANOS = 'CIDADAOS_MAIORES_2_ANOS',
  CIDADAO_AUSENTE = 'CIDADAO_AUSENTE',
  CONSULTA = 'CONSULTA',
  CONSULTA_AGENDADA_ODONTO = 'CONSULTA_AGENDADA_ODONTO',
  CONSULTA_DIA = 'CONSULTA_DIA',
  CONSULTA_DIA_ODONTO = 'CONSULTA_DIA_ODONTO',
  CONSULTA_MANUTENCAO = 'CONSULTA_MANUTENCAO',
  CONSULTA_PROGRAMADA_CUIDADO_CONTINUADO = 'CONSULTA_PROGRAMADA_CUIDADO_CONTINUADO',
  CONSULTA_RETORNO = 'CONSULTA_RETORNO',
  CRIANCAS_6_A_23_MESES = 'CRIANCAS_6_A_23_MESES',
  CRIANCAS_MENORES_6_MESES = 'CRIANCAS_MENORES_6_MESES',
  EDUCACAO_SAUDE = 'EDUCACAO_SAUDE',
  ESCUTA_INICIAL_ORIENTACAO = 'ESCUTA_INICIAL_ORIENTACAO',
  MOBILIZACAO_SOCIAL = 'MOBILIZACAO_SOCIAL',
  NAO_PROGRAMADA = 'NAO_PROGRAMADA',
  PRIMEIRA_CONSULTA = 'PRIMEIRA_CONSULTA',
  PROGRAMADA = 'PROGRAMADA',
  REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE = 'REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE',
  REUNIAO_DE_EQUIPE = 'REUNIAO_DE_EQUIPE',
  REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL = 'REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL',
  URGENCIA = 'URGENCIA',
  URGENCIA_ODONTO = 'URGENCIA_ODONTO',
  VISITA_DOMICILIAR_POS_OBITO = 'VISITA_DOMICILIAR_POS_OBITO',
  VISITA_REALIZADA = 'VISITA_REALIZADA',
  VISITA_RECUSADA = 'VISITA_RECUSADA',
}

export type SubtipoUnidadeSaude = {
  readonly __typename?: 'SubtipoUnidadeSaude'
  readonly codigoMs?: Maybe<Scalars['String']['output']>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly tipoUnidadeSaude: TipoUnidadeSaude
}

export type SugestaoAgendamentoGrupoCuidadoCompartilhadoInput = {
  readonly observacao: Scalars['String']['input']
}

export type SugestoesDatas = {
  readonly __typename?: 'SugestoesDatas'
  readonly odontologica: ReadonlyArray<Scalars['LocalDate']['output']>
  readonly preNatal: ReadonlyArray<Scalars['LocalDate']['output']>
}

export type SugestoesDatasInput = {
  readonly dataAtendimento: Scalars['LocalDate']['input']
  readonly idadeGestacionalEmDias: Scalars['Int']['input']
  readonly prontuarioId: Scalars['ID']['input']
}

export type SuplementacaoVitaminaADesenvolvimentoInfantil = {
  readonly __typename?: 'SuplementacaoVitaminaADesenvolvimentoInfantil'
  readonly dataUltimaSuplementacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dosesDe6a11Meses: Scalars['Long']['output']
  readonly dosesDe12a23Meses: Scalars['Long']['output']
  readonly dosesDe24a59Meses: Scalars['Long']['output']
}

export enum TamanhoFraldaGeriatricaEnum {
  G = 'G',
  GG = 'GG',
  M = 'M',
  P = 'P',
  XG = 'XG',
}

export type TecidoMole = {
  readonly __typename?: 'TecidoMole'
  readonly atendimentoProfissionalOdonto: AtendimentoProfissionalOdonto
  readonly caracteristicasLesao?: Maybe<ReadonlyArray<CaracteristicaLesao>>
  readonly cid10?: Maybe<Cid10>
  readonly descricaoSintomatologia?: Maybe<Scalars['String']['output']>
  readonly evolucaoProcedimentoOdonto?: Maybe<EvolucaoProcedimentoOdonto>
  readonly id: Scalars['ID']['output']
  readonly parteBucal: ParteBucal
}

export type TecidoMoleInput = {
  readonly caracteristicasLesao?: InputMaybe<ReadonlyArray<CaracteristicaLesaoEnum>>
  readonly cid10?: InputMaybe<Scalars['ID']['input']>
  readonly descricaoSintomatologia?: InputMaybe<Scalars['String']['input']>
  readonly observacao?: InputMaybe<Scalars['String']['input']>
  readonly parteBucal: ParteBucalEnum
  readonly procedimentos?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>
}

export type TecidosMolesPayload = {
  readonly __typename?: 'TecidosMolesPayload'
  readonly content?: Maybe<ReadonlyArray<Maybe<TecidoMole>>>
  readonly pageInfo?: Maybe<PageInfo>
}

export type TecidosMolesQueryInput = {
  readonly atendProfId?: InputMaybe<Scalars['ID']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly prontuarioId: Scalars['ID']['input']
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum TemaReuniaoEnum {
  DIAGNOSTICO_DO_TERRITORIO_MONITORAMENTO_DO_TERRITORIO = 'DIAGNOSTICO_DO_TERRITORIO_MONITORAMENTO_DO_TERRITORIO',
  DISCUSSAO_DE_CASO_PROJETO_TERAPEUTICO_SINGULAR = 'DISCUSSAO_DE_CASO_PROJETO_TERAPEUTICO_SINGULAR',
  EDUCACAO_PERMANENTE = 'EDUCACAO_PERMANENTE',
  OUTROS = 'OUTROS',
  PLANEJAMENTO_MONITORAMENTO_DAS_ACOES_DA_EQUIPE = 'PLANEJAMENTO_MONITORAMENTO_DAS_ACOES_DA_EQUIPE',
  PROCESSOS_DE_TRABALHO = 'PROCESSOS_DE_TRABALHO',
  QUESTOES_ADMINISTRATIVAS_FUNCIONAMENTO = 'QUESTOES_ADMINISTRATIVAS_FUNCIONAMENTO',
  VIGILANCIA_EM_SAUDE = 'VIGILANCIA_EM_SAUDE',
}

export enum TemaSaudeEnum {
  ACOES_COMBATE_AEDES_AEGYPTI = 'ACOES_COMBATE_AEDES_AEGYPTI',
  AGRAVOS_E_DOENCAS_NEGLIGENCIADAS = 'AGRAVOS_E_DOENCAS_NEGLIGENCIADAS',
  ALIMENTACAO_COMPLEMENTAR_SAUDAVEL = 'ALIMENTACAO_COMPLEMENTAR_SAUDAVEL',
  ALIMENTACAO_SAUDAVEL = 'ALIMENTACAO_SAUDAVEL',
  AMAMENTACAO = 'AMAMENTACAO',
  AUTOCUIDADO_DE_PESSOAS_COM_DOENCAS_CRONICAS = 'AUTOCUIDADO_DE_PESSOAS_COM_DOENCAS_CRONICAS',
  CIDADANIA_E_DIREITOS_HUMANOS = 'CIDADANIA_E_DIREITOS_HUMANOS',
  ENVELHECIMENTO_CLIMATERIO_ANDROPAUSA_ETC = 'ENVELHECIMENTO_CLIMATERIO_ANDROPAUSA_ETC',
  OUTROS = 'OUTROS',
  PLANTAS_MEDICINAIS_FITOTERAPIA = 'PLANTAS_MEDICINAIS_FITOTERAPIA',
  PREVENCAO_AO_USO_DE_ALCOOL_TABACO_E_OUTRAS_DROGAS = 'PREVENCAO_AO_USO_DE_ALCOOL_TABACO_E_OUTRAS_DROGAS',
  PREVENCAO_DA_VIOLENCIA_E_PROMOCAO_DA_CULTURA_DA_PAZ = 'PREVENCAO_DA_VIOLENCIA_E_PROMOCAO_DA_CULTURA_DA_PAZ',
  SAUDE_AMBIENTAL = 'SAUDE_AMBIENTAL',
  SAUDE_BUCAL = 'SAUDE_BUCAL',
  SAUDE_DO_TRABALHADOR = 'SAUDE_DO_TRABALHADOR',
  SAUDE_MENTAL = 'SAUDE_MENTAL',
  SAUDE_SEXUAL_E_REPRODUTIVA = 'SAUDE_SEXUAL_E_REPRODUTIVA',
  SEMANA_SAUDE_NA_ESCOLA = 'SEMANA_SAUDE_NA_ESCOLA',
}

export enum TempoAtendimentoSocioeducativoCidadaoEnum {
  DOIS_A_TRES_ANOS = 'DOIS_A_TRES_ANOS',
  SEIS_A_DOZE_MESES = 'SEIS_A_DOZE_MESES',
  SEIS_MESES = 'SEIS_MESES',
  UM_A_DOIS_ANOS = 'UM_A_DOIS_ANOS',
}

export enum TempoSituacaoDeRuaEnum {
  MAIS_DE_5_ANOS = 'MAIS_DE_5_ANOS',
  MENOS_6_MESES = 'MENOS_6_MESES',
  SEIS_A_12_MESES = 'SEIS_A_12_MESES',
  UM_A_5_ANOS = 'UM_A_5_ANOS',
}

export type TerraIndigena = {
  readonly __typename?: 'TerraIndigena'
  readonly dtExtincao: Scalars['LocalDate']['output']
  readonly dtInclusao: Scalars['LocalDate']['output']
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly stAtivo: Scalars['Boolean']['output']
}

export type TerritorioEquipeDto = {
  readonly __typename?: 'TerritorioEquipeDto'
  readonly hasInativos: Scalars['Boolean']['output']
  readonly microareas: ReadonlyArray<Maybe<Scalars['String']['output']>>
  readonly poloBase?: Maybe<PoloBase>
}

export type TerritorioEquipeQueryInput = {
  readonly aldeiaId?: InputMaybe<Scalars['ID']['input']>
  readonly bairro?: InputMaybe<Scalars['String']['input']>
  readonly cep?: InputMaybe<Scalars['String']['input']>
  readonly cnes: Scalars['String']['input']
  readonly dseiId?: InputMaybe<Scalars['ID']['input']>
  readonly ine: Scalars['String']['input']
  readonly logradouro?: InputMaybe<Scalars['String']['input']>
  readonly poloBaseId?: InputMaybe<Scalars['ID']['input']>
  readonly stAtivo?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoEndereco?: InputMaybe<TipoEnderecoEnum>
  readonly tipoLogradouroId?: InputMaybe<Scalars['ID']['input']>
}

export type TerritorioMicroarea = {
  readonly __typename?: 'TerritorioMicroarea'
  readonly id: Scalars['String']['output']
  readonly indices: IndicesAcompanhamentoMicroarea
  readonly logradouros: LogradourosTerritorioQueryPayload
}

export type TerritorioMicroareaQueryInput = {
  readonly aldeiaId?: InputMaybe<Scalars['ID']['input']>
  readonly animaisImovel?: InputMaybe<AnimaisImovelInput>
  readonly bairro?: InputMaybe<Scalars['String']['input']>
  readonly cep?: InputMaybe<Scalars['String']['input']>
  readonly cnes?: InputMaybe<Scalars['String']['input']>
  readonly complemento?: InputMaybe<Scalars['String']['input']>
  readonly condicoesMoradia?: InputMaybe<CondicoesMoradiaInput>
  readonly dseiId?: InputMaybe<Scalars['ID']['input']>
  readonly ine?: InputMaybe<Scalars['String']['input']>
  readonly isCadastroAtualizadoMenosDeUmAno?: InputMaybe<Scalars['Boolean']['input']>
  readonly isCadastroCompleto?: InputMaybe<Scalars['Boolean']['input']>
  readonly isCadastroRecusado?: InputMaybe<Scalars['Boolean']['input']>
  readonly isImovelVisitadoMenosDeUmMes?: InputMaybe<Scalars['Boolean']['input']>
  readonly logradouro?: InputMaybe<Scalars['String']['input']>
  readonly microarea?: InputMaybe<Scalars['String']['input']>
  readonly municipioAldeiaId?: InputMaybe<Scalars['Long']['input']>
  readonly municipioId?: InputMaybe<Scalars['Long']['input']>
  readonly numero?: InputMaybe<Scalars['String']['input']>
  readonly numeroResidenciaIndigena?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly poloBaseId?: InputMaybe<Scalars['ID']['input']>
  readonly possuiInconsistencia?: InputMaybe<Scalars['Boolean']['input']>
  readonly semComplemento?: InputMaybe<Scalars['Boolean']['input']>
  readonly semNumero?: InputMaybe<Scalars['Boolean']['input']>
  readonly stAtivo?: InputMaybe<Scalars['Boolean']['input']>
  readonly tipoDomicilio?: InputMaybe<TipoDomicilioEnum>
  readonly tipoEndereco: TipoEnderecoEnum
  readonly tipoImovel?: InputMaybe<TipoImovelEnum>
  readonly tipoLogradouroId?: InputMaybe<Scalars['ID']['input']>
  readonly ufAldeiaId?: InputMaybe<Scalars['Long']['input']>
  readonly ufId?: InputMaybe<Scalars['Long']['input']>
  readonly useFilterLikeDiacritics?: InputMaybe<Scalars['Boolean']['input']>
}

export type TesteConexao = {
  readonly __typename?: 'TesteConexao'
  readonly dataEvento: Scalars['Instant']['output']
  readonly sucesso: Scalars['Boolean']['output']
}

export enum TipoAbastecimentoAguaEnum {
  CAPTACAO_DIRETA_POCO = 'CAPTACAO_DIRETA_POCO',
  CAPTACAO_DIRETA_RIO = 'CAPTACAO_DIRETA_RIO',
  CARRO_PIPA = 'CARRO_PIPA',
  CHAFARIZ = 'CHAFARIZ',
  CISTERNA = 'CISTERNA',
  OUTRO = 'OUTRO',
  POCO_NASCENTE_DOMICILIO = 'POCO_NASCENTE_DOMICILIO',
  REDE_ENCANADA = 'REDE_ENCANADA',
  REDE_ENCANADA_ATE_O_DOMICILIO_SESAI = 'REDE_ENCANADA_ATE_O_DOMICILIO_SESAI',
}

export enum TipoAcesso {
  ADMINISTRADOR_GERAL = 'ADMINISTRADOR_GERAL',
  ADMINISTRADOR_MUNICIPAL = 'ADMINISTRADOR_MUNICIPAL',
  ESTAGIO = 'ESTAGIO',
  GESTOR_ESTADUAL = 'GESTOR_ESTADUAL',
  GESTOR_MUNICIPAL = 'GESTOR_MUNICIPAL',
  LOTACAO = 'LOTACAO',
}

export enum TipoAcessoDomicilioEnum {
  CHAO_BATIDO = 'CHAO_BATIDO',
  FLUVIAL = 'FLUVIAL',
  OUTRO = 'OUTRO',
  PAVIMENTO = 'PAVIMENTO',
}

export enum TipoAcompanhamentoEnum {
  PRE_NATAL = 'PRE_NATAL',
  PUERPERIO = 'PUERPERIO',
}

export enum TipoAgendamentoEnum {
  CONSULTA = 'CONSULTA',
  RESERVA = 'RESERVA',
}

export enum TipoAgrupamentoRelatorioGerencialEnum {
  PESSOAS = 'PESSOAS',
  REGISTROS = 'REGISTROS',
}

export enum TipoAleitamentoMaternoEnum {
  COMPLEMENTADO = 'COMPLEMENTADO',
  EXCLUSIVO = 'EXCLUSIVO',
  INEXISTENTE = 'INEXISTENTE',
  PREDOMINANTE = 'PREDOMINANTE',
}

export type TipoArea = {
  readonly __typename?: 'TipoArea'
  readonly id: Scalars['ID']['output']
  readonly registroAtivo: Scalars['Boolean']['output']
  readonly tipoArea: Scalars['String']['output']
}

export enum TipoArquivoEnum {
  CSV = 'CSV',
  PDF = 'PDF',
}

export enum TipoAtendimentoCidadaoEnum {
  INTERNACAO = 'INTERNACAO',
  INTERNACAO_PROVISORIA = 'INTERNACAO_PROVISORIA',
  LIBERDADE_ASSISTIDA = 'LIBERDADE_ASSISTIDA',
  PRESTACAO_SERVICO_COMUNIDADE = 'PRESTACAO_SERVICO_COMUNIDADE',
  SEMILIBERDADE = 'SEMILIBERDADE',
}

export enum TipoAtendimentoEnum {
  CONSULTA = 'CONSULTA',
  CONSULTA_AGENDADA_CUIDADO_CONTINUADO = 'CONSULTA_AGENDADA_CUIDADO_CONTINUADO',
  CONSULTA_NO_DIA = 'CONSULTA_NO_DIA',
  URGENCIA = 'URGENCIA',
}

export enum TipoAtendimentoPainelChamadaEnum {
  ACOLHIMENTO = 'ACOLHIMENTO',
  ATENDIMENTO = 'ATENDIMENTO',
}

export enum TipoAtendimentoProfissional {
  ATENDIMENTO_DOMICILIAR = 'ATENDIMENTO_DOMICILIAR',
  ATENDIMENTO_ODONTOLOGICO = 'ATENDIMENTO_ODONTOLOGICO',
  ATENDIMENTO_PROCEDIMENTOS = 'ATENDIMENTO_PROCEDIMENTOS',
  AVALIACAO_ELEGIBILIDADE = 'AVALIACAO_ELEGIBILIDADE',
  CONSULTA = 'CONSULTA',
  ESCUTA_INICIAL = 'ESCUTA_INICIAL',
  OBSERVACAO = 'OBSERVACAO',
  PRE_NATAL = 'PRE_NATAL',
  PUERICULTURA = 'PUERICULTURA',
  PUERPERIO = 'PUERPERIO',
  VACINACAO = 'VACINACAO',
  ZIKA = 'ZIKA',
}

export enum TipoAtestadoEnum {
  EM_BRANCO = 'EM_BRANCO',
  LICENCA_MATERNIDADE = 'LICENCA_MATERNIDADE',
  PADRAO = 'PADRAO',
  PERSONALIZADO = 'PERSONALIZADO',
  SOLICITACAO_FRALDAS_GERIATRICAS = 'SOLICITACAO_FRALDAS_GERIATRICAS',
}

export enum TipoAtividadeEnum {
  ATENDIMENTO_EM_GRUPO = 'ATENDIMENTO_EM_GRUPO',
  AVALIACAO_PROCEDIMENTO_COLETIVO = 'AVALIACAO_PROCEDIMENTO_COLETIVO',
  EDUCACAO_EM_SAUDE = 'EDUCACAO_EM_SAUDE',
  MOBILIZACAO_SOCIAL = 'MOBILIZACAO_SOCIAL',
  REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE = 'REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE',
  REUNIAO_DE_EQUIPE = 'REUNIAO_DE_EQUIPE',
  REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL = 'REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL',
}

export enum TipoCondutaSdcEnum {
  BOTAO = 'BOTAO',
  MODAL = 'MODAL',
}

export enum TipoConsultaOdontoEnum {
  CONSULTA_DE_MANUTENCAO = 'CONSULTA_DE_MANUTENCAO',
  CONSULTA_DE_RETORNO = 'CONSULTA_DE_RETORNO',
  PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA = 'PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA',
}

export enum TipoDestinoLixoEnum {
  CEU_ABERTO = 'CEU_ABERTO',
  COLETADO = 'COLETADO',
  ENTERRADO = 'ENTERRADO',
  OUTRO = 'OUTRO',
  QUEIMADO = 'QUEIMADO',
  QUEIMADO_ENTERRADO = 'QUEIMADO_ENTERRADO',
}

export enum TipoDomicilioEnum {
  APARTAMENTO = 'APARTAMENTO',
  CASA = 'CASA',
  COMODO = 'COMODO',
  IMPROVISADO = 'IMPROVISADO',
  MALOCA = 'MALOCA',
  OUTRO = 'OUTRO',
}

export enum TipoEdemaEnum {
  DOIS_POSITIVOS = 'DOIS_POSITIVOS',
  NEGATIVO = 'NEGATIVO',
  POSITIVO = 'POSITIVO',
  TRES_POSITIVOS = 'TRES_POSITIVOS',
}

export enum TipoEncaminhamentoExternoEnum {
  CAPS = 'CAPS',
  INTERNACAO_HOSPITALAR = 'INTERNACAO_HOSPITALAR',
  INTERSETORIAL = 'INTERSETORIAL',
  SERVICO_ATENCAO_DOMICILIAR = 'SERVICO_ATENCAO_DOMICILIAR',
  SERVICO_ESPECIALIZADO = 'SERVICO_ESPECIALIZADO',
  URGENCIA = 'URGENCIA',
}

export enum TipoEncaminhamentoOdontoEnum {
  AGENDAMENTO_P_EMULTI = 'AGENDAMENTO_P_EMULTI',
  AGENDAMENTO_P_GRUPOS = 'AGENDAMENTO_P_GRUPOS',
  AGENDAMENTO_P_NASF = 'AGENDAMENTO_P_NASF',
  AGENDAMENTO_P_OUTROS_PROFISSIONAIS_AB = 'AGENDAMENTO_P_OUTROS_PROFISSIONAIS_AB',
  ALTA_DO_EPISODIO = 'ALTA_DO_EPISODIO',
  CIRURGIA_BMF = 'CIRURGIA_BMF',
  ENDODONTIA = 'ENDODONTIA',
  ESTOMATOLOGIA = 'ESTOMATOLOGIA',
  IMPLANTODONTIA = 'IMPLANTODONTIA',
  NAO_SE_APLICA = 'NAO_SE_APLICA',
  ODONTOPEDIATRIA = 'ODONTOPEDIATRIA',
  ORTODONTIA_ORTOPEDIA = 'ORTODONTIA_ORTOPEDIA',
  OUTROS = 'OUTROS',
  PACIENTES_COM_NECESSIDADES_ESPECIAIS = 'PACIENTES_COM_NECESSIDADES_ESPECIAIS',
  PERIODONTIA = 'PERIODONTIA',
  PROTESE_DENTARIA = 'PROTESE_DENTARIA',
  RADIOLOGIA = 'RADIOLOGIA',
  RETORNO_PARA_CONSULTA_AGENDADA = 'RETORNO_PARA_CONSULTA_AGENDADA',
  TRATAMENTO_CONCLUIDO = 'TRATAMENTO_CONCLUIDO',
}

export enum TipoEnderecoEnum {
  ACAMPAMENTO = 'ACAMPAMENTO',
  ALDEIA = 'ALDEIA',
  LOGRADOURO = 'LOGRADOURO',
}

export type TipoEquipe = {
  readonly __typename?: 'TipoEquipe'
  readonly codigoMs?: Maybe<Scalars['String']['output']>
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly isExibeProblemasObrigatoriosAdicionarLPC: Scalars['Boolean']['output']
  readonly nome: Scalars['String']['output']
  readonly sigla: Scalars['String']['output']
}

export enum TipoEscoamentoSanitarioEnum {
  CEU_ABERTO = 'CEU_ABERTO',
  DIRETO_PARA_RIO_LAGO_MAR = 'DIRETO_PARA_RIO_LAGO_MAR',
  FOSSA_RUDIMENTAR = 'FOSSA_RUDIMENTAR',
  FOSSA_SEPTICA = 'FOSSA_SEPTICA',
  OUTRO = 'OUTRO',
  REDE_COLETORA_ESGOTO_PLUVIAL = 'REDE_COLETORA_ESGOTO_PLUVIAL',
}

export enum TipoEstabelecimentoEnum {
  CEO = 'CEO',
  POLICLINICA = 'POLICLINICA',
  UBS = 'UBS',
  UPA = 'UPA',
}

export type TipoExame = {
  readonly __typename?: 'TipoExame'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sexo: SexoEnum
  readonly tipoExameEnum: TipoExameEnum
}

export enum TipoExameEnum {
  ALTO_CUSTO = 'ALTO_CUSTO',
  COMUM = 'COMUM',
  OCI = 'OCI',
}

export enum TipoFiltroLpcEnum {
  SOMENTE_ATIVOS_LPC = 'SOMENTE_ATIVOS_LPC',
  SOMENTE_NAO_INCLUIDOS_LPC = 'SOMENTE_NAO_INCLUIDOS_LPC',
  TODOS = 'TODOS',
}

export enum TipoFrequencia {
  FRACIONADO = 'FRACIONADO',
  FREQUENCIA = 'FREQUENCIA',
  INTERVALO = 'INTERVALO',
  TURNO = 'TURNO',
}

export enum TipoGlicemia {
  JEJUM = 'JEJUM',
  NAO_ESPECIFICADO = 'NAO_ESPECIFICADO',
  POSPRANDIAL = 'POSPRANDIAL',
  PREPRANDIAL = 'PREPRANDIAL',
}

export type TipoGravidez = {
  readonly __typename?: 'TipoGravidez'
  readonly descricao?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly tipoGravidez?: Maybe<TipoGravidezEnum>
}

export enum TipoGravidezEnum {
  DUPLA_GEMELAR = 'DUPLA_GEMELAR',
  IGNORADA = 'IGNORADA',
  TRIPLA_OU_MAIS = 'TRIPLA_OU_MAIS',
  UNICA = 'UNICA',
}

export enum TipoGrupoParticipanteAtividadeColetivaEnum {
  ATIVIDADE_EM_SAUDE = 'ATIVIDADE_EM_SAUDE',
  REUNIAO = 'REUNIAO',
}

export enum TipoImovelEnum {
  ABRIGO = 'ABRIGO',
  CASAI = 'CASAI',
  COMERCIO = 'COMERCIO',
  CRECHE = 'CRECHE',
  DELEGACIA = 'DELEGACIA',
  DOMICILIO = 'DOMICILIO',
  ESCOLA = 'ESCOLA',
  ESTABELECIMENTO_RELIGIOSO = 'ESTABELECIMENTO_RELIGIOSO',
  INSTITUICAO_LONGA_PERMANENCIA_PARA_IDOSOS = 'INSTITUICAO_LONGA_PERMANENCIA_PARA_IDOSOS',
  OUTROS = 'OUTROS',
  PONTO_ESTRATEGICO = 'PONTO_ESTRATEGICO',
  TERRENO_BALDIO = 'TERRENO_BALDIO',
  UNIDADE_MEDIDA_SOCIOEDUCATIVA = 'UNIDADE_MEDIDA_SOCIOEDUCATIVA',
  UNIDADE_PRISIONAL = 'UNIDADE_PRISIONAL',
}

export enum TipoInstalacao {
  CENTRALIZADORA = 'CENTRALIZADORA',
  PRONTUARIO = 'PRONTUARIO',
}

export enum TipoLocalNascimentoEnum {
  ALDEIA = 'ALDEIA',
  MUNICIPIO = 'MUNICIPIO',
}

export enum TipoLocalizacaoEnum {
  PERIURBANA = 'PERIURBANA',
  RURAL = 'RURAL',
  URBANA = 'URBANA',
}

export type TipoLogradouro = {
  readonly __typename?: 'TipoLogradouro'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly numeroDne: Scalars['String']['output']
}

export type TipoLogradouroInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type TipoLogradouroQueryPayload = {
  readonly __typename?: 'TipoLogradouroQueryPayload'
  readonly content: ReadonlyArray<Maybe<TipoLogradouro>>
  readonly pageInfo: PageInfo
}

export enum TipoMaterialParedeEnum {
  ALVENARIA_COM_REVESTIMENTO = 'ALVENARIA_COM_REVESTIMENTO',
  ALVENARINA_SEM_REVESTIMENTO = 'ALVENARINA_SEM_REVESTIMENTO',
  MADEIRA_APARELHADA = 'MADEIRA_APARELHADA',
  MATERIAL_APROVEITADO = 'MATERIAL_APROVEITADO',
  OUTRO = 'OUTRO',
  OUTROS_CAULE_PALMEIRA = 'OUTROS_CAULE_PALMEIRA',
  OUTROS_LONA = 'OUTROS_LONA',
  OUTROS_MISTO_DIFERENTES_MATERIAIS = 'OUTROS_MISTO_DIFERENTES_MATERIAIS',
  OUTROS_SEM_PAREDE = 'OUTROS_SEM_PAREDE',
  PALHA = 'PALHA',
  TAIPA_COM_REVESTIMENTO = 'TAIPA_COM_REVESTIMENTO',
  TAIPA_SEM_REVESTIMENTO = 'TAIPA_SEM_REVESTIMENTO',
}

export enum TipoMedicaoEnum {
  ALTURA = 'ALTURA',
  ALTURA_UTERINA = 'ALTURA_UTERINA',
  CIRCUNFERENCIA_ABDOMINAL = 'CIRCUNFERENCIA_ABDOMINAL',
  DUM = 'DUM',
  FREQUENCIA_CARDIACA = 'FREQUENCIA_CARDIACA',
  FREQUENCIA_RESPIRATORIA = 'FREQUENCIA_RESPIRATORIA',
  GLICEMIA = 'GLICEMIA',
  IMC = 'IMC',
  PERIMETRO_CEFALICO = 'PERIMETRO_CEFALICO',
  PERIMETRO_PANTURRILHA = 'PERIMETRO_PANTURRILHA',
  PESO = 'PESO',
  PRESSAO_ARTERIAL = 'PRESSAO_ARTERIAL',
  SATURACAO_O2 = 'SATURACAO_O2',
  TEMPERATURA = 'TEMPERATURA',
}

export enum TipoModuloEnum {
  RELATORIO_GERENCIAL_ABSENTEISMO = 'RELATORIO_GERENCIAL_ABSENTEISMO',
  RELATORIO_GERENCIAL_ATENDIMENTO = 'RELATORIO_GERENCIAL_ATENDIMENTO',
  RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL = 'RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL',
  RELATORIO_GERENCIAL_CUIDADO_COMPARTILHADO = 'RELATORIO_GERENCIAL_CUIDADO_COMPARTILHADO',
  RELATORIO_GERENCIAL_EXAMES = 'RELATORIO_GERENCIAL_EXAMES',
  RELATORIO_GERENCIAL_VACINACAO = 'RELATORIO_GERENCIAL_VACINACAO',
}

export enum TipoMotivoPrescricaoEnum {
  CIAP2 = 'CIAP2',
  CID10 = 'CID10',
}

export type TipoOrigemDadoTransporte = {
  readonly __typename?: 'TipoOrigemDadoTransporte'
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
}

export enum TipoOrigemEnergiaEletricaEnum {
  CONCESSIONARIA = 'CONCESSIONARIA',
  FOTOVOLTAICA_COMUNITARIA = 'FOTOVOLTAICA_COMUNITARIA',
  FOTOVOLTAICA_INDIVIDUAL = 'FOTOVOLTAICA_INDIVIDUAL',
  GERADOR_COMUNITARIO = 'GERADOR_COMUNITARIO',
  GERADOR_INDIVIDUAL = 'GERADOR_INDIVIDUAL',
}

export enum TipoParteBucalEnum {
  ARCADA = 'ARCADA',
  DENTE = 'DENTE',
  OUTRO = 'OUTRO',
  SEXTANTE = 'SEXTANTE',
  SUPRANUMERARIO = 'SUPRANUMERARIO',
  TECIDO_MOLE = 'TECIDO_MOLE',
}

export enum TipoParticipacaoAtendimentoEnum {
  CHAMADA_DE_VIDEO = 'CHAMADA_DE_VIDEO',
  CHAMADA_DE_VOZ = 'CHAMADA_DE_VOZ',
  EMAIL = 'EMAIL',
  MENSAGEM = 'MENSAGEM',
  NAO_PARTICIPOU = 'NAO_PARTICIPOU',
  OUTROS = 'OUTROS',
  PRESENCIAL = 'PRESENCIAL',
}

export enum TipoPartoEnum {
  CESAREO = 'CESAREO',
  FORCEPS = 'FORCEPS',
  NORMAL = 'NORMAL',
}

export enum TipoPessoaEnum {
  FISICA = 'FISICA',
  JURIDICA = 'JURIDICA',
}

export enum TipoPosseTerraEnum {
  ARRENDATARIO = 'ARRENDATARIO',
  ASSENTADO = 'ASSENTADO',
  BENEFICIARIO_BANCO_TERRA = 'BENEFICIARIO_BANCO_TERRA',
  COMODATARIO = 'COMODATARIO',
  NAO_SE_APLICA = 'NAO_SE_APLICA',
  PARCEIRO = 'PARCEIRO',
  POSSEIRO = 'POSSEIRO',
  PROPRIETARIO = 'PROPRIETARIO',
  TERRA_INDIGENA_DEMARCADA = 'TERRA_INDIGENA_DEMARCADA',
  TERRA_NAO_DEMARCADA = 'TERRA_NAO_DEMARCADA',
}

export enum TipoProcedimentoEnum {
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  CLINICO = 'CLINICO',
  GRUPO = 'GRUPO',
  OPME = 'OPME',
}

export enum TipoRastreioCancerEnum {
  CITOPATOLOGICO = 'CITOPATOLOGICO',
  MAMOGRAFIA = 'MAMOGRAFIA',
}

export enum TipoReacaoAlergia {
  ALERGIA = 'ALERGIA',
  INTOLERANCIA = 'INTOLERANCIA',
}

export enum TipoReceitaEnum {
  COMUM = 'COMUM',
  ESPECIAL = 'ESPECIAL',
  ESPECIAL_AMARELA = 'ESPECIAL_AMARELA',
  ESPECIAL_AZUL = 'ESPECIAL_AZUL',
  ESPECIAL_BRANCA = 'ESPECIAL_BRANCA',
}

export enum TipoRegistroHistoricoClinico {
  ATENDIMENTO_DOMICILIAR = 'ATENDIMENTO_DOMICILIAR',
  ATENDIMENTO_ODONTOLOGICO = 'ATENDIMENTO_ODONTOLOGICO',
  ATENDIMENTO_PROCEDIMENTOS = 'ATENDIMENTO_PROCEDIMENTOS',
  ATIVIDADE_COLETIVA = 'ATIVIDADE_COLETIVA',
  AVALIACAO_ELEGIBILIDADE = 'AVALIACAO_ELEGIBILIDADE',
  CONSULTA = 'CONSULTA',
  CONSUMO_ALIMENTAR = 'CONSUMO_ALIMENTAR',
  CUIDADO_COMPARTILHADO = 'CUIDADO_COMPARTILHADO',
  ESCUTA_INICIAL = 'ESCUTA_INICIAL',
  OBSERVACAO = 'OBSERVACAO',
  PRE_ATENDIMENTO = 'PRE_ATENDIMENTO',
  PRE_NATAL = 'PRE_NATAL',
  PUERICULTURA = 'PUERICULTURA',
  PUERPERIO = 'PUERPERIO',
  VACINACAO = 'VACINACAO',
  VISITA_DOMICILIAR = 'VISITA_DOMICILIAR',
  ZIKA = 'ZIKA',
}

export type TipoRegistroHistoricoClinicoQueryInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum TipoRegistroRndsEnum {
  ATENDIMENTO_INDIVIDUAL = 'ATENDIMENTO_INDIVIDUAL',
  PRESCRICAO_MEDICAMENTO = 'PRESCRICAO_MEDICAMENTO',
  VACINA = 'VACINA',
}

export type TipoRegistroVacinacao = {
  readonly __typename?: 'TipoRegistroVacinacao'
  readonly id: Scalars['ID']['output']
  readonly identificador: TipoRegistroVacinacaoEnum
  readonly nome: Scalars['String']['output']
}

export enum TipoRegistroVacinacaoEnum {
  APLICACAO = 'APLICACAO',
  APRAZAMENTO = 'APRAZAMENTO',
}

export enum TipoRegulacaoEnum {
  GUIA_ENCAMINHAMENTO = 'GUIA_ENCAMINHAMENTO',
  SOLICITACAO_EXAME_ALTO_CUSTO = 'SOLICITACAO_EXAME_ALTO_CUSTO',
  SOLICITACAO_EXAME_COMUM = 'SOLICITACAO_EXAME_COMUM',
  SOLICITACAO_EXAME_OCI = 'SOLICITACAO_EXAME_OCI',
}

export enum TipoRespostaPesquisa {
  ENVIADO = 'ENVIADO',
  FECHADO = 'FECHADO',
  NAO_RESPONDIDO = 'NAO_RESPONDIDO',
}

export enum TipoSanguineoEnum {
  AB_NEGATIVO = 'AB_NEGATIVO',
  AB_POSITIVO = 'AB_POSITIVO',
  A_NEGATIVO = 'A_NEGATIVO',
  A_POSITIVO = 'A_POSITIVO',
  B_NEGATIVO = 'B_NEGATIVO',
  B_POSITIVO = 'B_POSITIVO',
  O_NEGATIVO = 'O_NEGATIVO',
  O_POSITIVO = 'O_POSITIVO',
}

export enum TipoSerieHistoricaEnum {
  ATENDIMENTO_DOMICILIAR = 'ATENDIMENTO_DOMICILIAR',
  ATENDIMENTO_INDIVIDUAL = 'ATENDIMENTO_INDIVIDUAL',
  ATENDIMENTO_ODONTOLOGICO = 'ATENDIMENTO_ODONTOLOGICO',
  ATIVIDADE_COLETIVA = 'ATIVIDADE_COLETIVA',
  PROCEDIMENTO_INDIVIDUALIZADO = 'PROCEDIMENTO_INDIVIDUALIZADO',
  VACINACAO = 'VACINACAO',
  VISITA_DOMICILIAR = 'VISITA_DOMICILIAR',
}

export type TipoServico = {
  readonly __typename?: 'TipoServico'
  readonly id: Scalars['ID']['output']
  readonly municipio?: Maybe<Municipio>
  readonly nome: Scalars['String']['output']
}

export type TipoServicoInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly nome: Scalars['String']['input']
  readonly tiposEstabelecimento: ReadonlyArray<InputMaybe<TipoEstabelecimentoEnum>>
}

export enum TipoServicoPadraoEnum {
  ADM_MEDICAMENTO = 'ADM_MEDICAMENTO',
  AGENDADO = 'AGENDADO',
  CURATIVO = 'CURATIVO',
  DEMANDA_ESPONTANEA = 'DEMANDA_ESPONTANEA',
  ESCUTA_INICIAL = 'ESCUTA_INICIAL',
  EXAMES = 'EXAMES',
  NEBULIZACAO = 'NEBULIZACAO',
  ODONTOLOGIA = 'ODONTOLOGIA',
  PROCEDIMENTOS = 'PROCEDIMENTOS',
  VACINA = 'VACINA',
}

export type TipoServicoQueryInput = {
  readonly includeInterno?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly unidadeSaudeSessao?: InputMaybe<Scalars['Boolean']['input']>
}

export type TipoServicoQueryPayload = {
  readonly __typename?: 'TipoServicoQueryPayload'
  readonly content: ReadonlyArray<Maybe<TipoServico>>
  readonly pageInfo: PageInfo
}

export type TipoServicoUpdateInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly nome: Scalars['String']['input']
}

export enum TipoSistemaExternoEnum {
  ATENDIMENTO = 'ATENDIMENTO',
  MENU_LATERAL = 'MENU_LATERAL',
}

export enum TipoSituacaoMoradiaEnum {
  ALUGADO = 'ALUGADO',
  ARRENDADO = 'ARRENDADO',
  CEDIDO = 'CEDIDO',
  FINANCIADO = 'FINANCIADO',
  OCUPACAO = 'OCUPACAO',
  OUTRO = 'OUTRO',
  PROPRIO = 'PROPRIO',
  SITUACAO_DE_RUA = 'SITUACAO_DE_RUA',
  TEMPORARIA = 'TEMPORARIA',
}

export type TipoTerra = {
  readonly __typename?: 'TipoTerra'
  readonly id: Scalars['ID']['output']
  readonly registroAtivo: Scalars['Boolean']['output']
  readonly tipoTerra: Scalars['String']['output']
}

export enum TipoTopicoNotificacaoEnum {
  CUIDADO_COMPARTILHADO = 'CUIDADO_COMPARTILHADO',
  REGULACAO_ASSISTENCIAL = 'REGULACAO_ASSISTENCIAL',
}

export enum TipoTratamentoAguaEnum {
  CLORACAO_INTRADOMICILIAR = 'CLORACAO_INTRADOMICILIAR',
  CLORADA = 'CLORADA',
  FERVIDA = 'FERVIDA',
  FILTRACAO_BARRO = 'FILTRACAO_BARRO',
  FILTRACAO_OUTRO = 'FILTRACAO_OUTRO',
  FILTRADA = 'FILTRADA',
  MINERAL = 'MINERAL',
  SEM_TRATAMENTO = 'SEM_TRATAMENTO',
}

export enum TipoUnidadeForcaMuscular {
  GRAMAFORCA = 'GRAMAFORCA',
  LIBRAFORCA = 'LIBRAFORCA',
  NEWTON = 'NEWTON',
  QUILOGRAMAFORCA = 'QUILOGRAMAFORCA',
}

export type TipoUnidadeSaude = {
  readonly __typename?: 'TipoUnidadeSaude'
  readonly codigoMs: Scalars['Long']['output']
  readonly descricao: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly isTipoAps: Scalars['Boolean']['output']
}

export enum TipoUnidadeSaudeEnum {
  CENTRAL_DE_ABASTECIMENTO = 'CENTRAL_DE_ABASTECIMENTO',
  CENTRAL_DE_GESTAO_EM_SAUDE = 'CENTRAL_DE_GESTAO_EM_SAUDE',
  CENTRAL_DE_NOTIFICACAO_CAPTACAO_E_DISTRIB_DE_ORGAOS_ESTADUAL = 'CENTRAL_DE_NOTIFICACAO_CAPTACAO_E_DISTRIB_DE_ORGAOS_ESTADUAL',
  CENTRAL_DE_REGULACAO_DE_SERVICOS_DE_SAUDE = 'CENTRAL_DE_REGULACAO_DE_SERVICOS_DE_SAUDE',
  CENTRAL_DE_REGULACAO_DO_ACESSO = 'CENTRAL_DE_REGULACAO_DO_ACESSO',
  CENTRAL_DE_REGULACAO_MEDICA_DAS_URGENCIAS = 'CENTRAL_DE_REGULACAO_MEDICA_DAS_URGENCIAS',
  CENTRO_DE_APOIO_A_SAUDE_DA_FAMILIA = 'CENTRO_DE_APOIO_A_SAUDE_DA_FAMILIA',
  CENTRO_DE_ATENCAO_HEMOTERAPIA_E_OU_HEMATOLOGICA = 'CENTRO_DE_ATENCAO_HEMOTERAPIA_E_OU_HEMATOLOGICA',
  CENTRO_DE_ATENCAO_PSICOSSOCIAL = 'CENTRO_DE_ATENCAO_PSICOSSOCIAL',
  CENTRO_DE_IMUNIZACAO = 'CENTRO_DE_IMUNIZACAO',
  CENTRO_DE_PARTO_NORMAL_ISOLADO = 'CENTRO_DE_PARTO_NORMAL_ISOLADO',
  CENTRO_DE_SAUDE_UNIDADE_BASICA = 'CENTRO_DE_SAUDE_UNIDADE_BASICA',
  CLINICA_CENTRO_DE_ESPECIALIDADE = 'CLINICA_CENTRO_DE_ESPECIALIDADE',
  CONSULTORIO_ISOLADO = 'CONSULTORIO_ISOLADO',
  COOPERATIVA_OU_EMPRESA_DE_CESSAO_DE_TRABALHADORES_NA_SAUDE = 'COOPERATIVA_OU_EMPRESA_DE_CESSAO_DE_TRABALHADORES_NA_SAUDE',
  FARMACIA = 'FARMACIA',
  HOSPITAL_DIA_ISOLADO = 'HOSPITAL_DIA_ISOLADO',
  HOSPITAL_ESPECIALIZADO = 'HOSPITAL_ESPECIALIZADO',
  HOSPITAL_GERAL = 'HOSPITAL_GERAL',
  LABORATORIO_CENTRAL_DE_SAUDE_PUBLICA_LACEN = 'LABORATORIO_CENTRAL_DE_SAUDE_PUBLICA_LACEN',
  LABORATORIO_DE_SAUDE_PUBLICA = 'LABORATORIO_DE_SAUDE_PUBLICA',
  OFICINA_ORTOPEDICA = 'OFICINA_ORTOPEDICA',
  OUTROS = 'OUTROS',
  POLICLINICA = 'POLICLINICA',
  POLO_ACADEMIA_DA_SAUDE = 'POLO_ACADEMIA_DA_SAUDE',
  POLO_DE_PREVENCAO_DE_DOENCAS_E_AGRAVOS_E_PROMOCAO_DA_SAUDE = 'POLO_DE_PREVENCAO_DE_DOENCAS_E_AGRAVOS_E_PROMOCAO_DA_SAUDE',
  POSTO_DE_SAUDE = 'POSTO_DE_SAUDE',
  PRONTO_ATENDIMENTO = 'PRONTO_ATENDIMENTO',
  PRONTO_SOCORRO_ESPECIALIZADO = 'PRONTO_SOCORRO_ESPECIALIZADO',
  PRONTO_SOCORRO_GERAL = 'PRONTO_SOCORRO_GERAL',
  SERVICO_DE_ATENCAO_DOMICILIAR_ISOLADO_HOME_CARE = 'SERVICO_DE_ATENCAO_DOMICILIAR_ISOLADO_HOME_CARE',
  TELESSAUDE = 'TELESSAUDE',
  UNIDADE_DE_APOIO_DIAGNOSE_E_TERAPIA_SADT_ISOLADO = 'UNIDADE_DE_APOIO_DIAGNOSE_E_TERAPIA_SADT_ISOLADO',
  UNIDADE_DE_ATENCAO_A_SAUDE_INDIGENA = 'UNIDADE_DE_ATENCAO_A_SAUDE_INDIGENA',
  UNIDADE_DE_ATENCAO_EM_REGIME_RESIDENCIAL = 'UNIDADE_DE_ATENCAO_EM_REGIME_RESIDENCIAL',
  UNIDADE_DE_VIGILANCIA_EM_SAUDE = 'UNIDADE_DE_VIGILANCIA_EM_SAUDE',
  UNIDADE_MISTA = 'UNIDADE_MISTA',
  UNIDADE_MOVEL_DE_NIVEL_PRE_HOSPITALAR_NA_AREA_DE_URGENCIA = 'UNIDADE_MOVEL_DE_NIVEL_PRE_HOSPITALAR_NA_AREA_DE_URGENCIA',
  UNIDADE_MOVEL_FLUVIAL = 'UNIDADE_MOVEL_FLUVIAL',
  UNIDADE_MOVEL_TERRESTRE = 'UNIDADE_MOVEL_TERRESTRE',
}

export enum TipoVisualizacaoBuscaAtivaVacinacaoEnum {
  CALENDARIO_VACINAL = 'CALENDARIO_VACINAL',
  COVID_19 = 'COVID_19',
}

export type TituloPatente = {
  readonly __typename?: 'TituloPatente'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
}

export type TodasVinculacoesEquipeDto = {
  readonly __typename?: 'TodasVinculacoesEquipeDto'
  readonly equipeEmulti: Equipe
  readonly quantidadeVinculacoes: Scalars['Int']['output']
  readonly vinculacoesPorEstabelecimento: ReadonlyArray<VinculacaoEquipePorEstabelecimentoDto>
}

export type TodasVinculacoesEquipesInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type TodasVinculacoesEquipesPayload = {
  readonly __typename?: 'TodasVinculacoesEquipesPayload'
  readonly content: ReadonlyArray<TodasVinculacoesEquipeDto>
  readonly pageInfo: PageInfo
}

export type TopicoNotificacao = {
  readonly __typename?: 'TopicoNotificacao'
  readonly codigoTopicoExterno: Scalars['Int']['output']
  readonly dataCriacao: Scalars['Instant']['output']
  readonly dataUltimaAtualizacao: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly statusNotificarLido?: Maybe<Scalars['Boolean']['output']>
  readonly statusNotificarVisto?: Maybe<Scalars['Boolean']['output']>
  readonly tipoTopico: TipoTopicoNotificacaoEnum
}

export type TotalImoveisPermissao = {
  readonly __typename?: 'TotalImoveisPermissao'
  readonly totalImoveis: Scalars['Int']['output']
  readonly totalImoveisPermitidos: Scalars['Int']['output']
}

export type Transmissao = {
  readonly __typename?: 'Transmissao'
  readonly id: Scalars['ID']['output']
  readonly importacaoArquivo: ImportacaoArquivo
  readonly links?: Maybe<TransmissaoLinksPayload>
}

export type TransmissaoLinksArgs = {
  input: TransmissaoLinksConnectionInput
}

export type TransmissaoLink = {
  readonly __typename?: 'TransmissaoLink'
  readonly actions: TransmissaoLinkActions
  readonly ativo: Scalars['Boolean']['output']
  readonly dataTesteConexao?: Maybe<Scalars['Instant']['output']>
  readonly hostname: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly name: Scalars['String']['output']
  readonly statusConexao?: Maybe<Scalars['Boolean']['output']>
}

export type TransmissaoLinkActions = {
  readonly __typename?: 'TransmissaoLinkActions'
  readonly alternarAtivacao: Action
  readonly editar: Action
  readonly excluir: Action
}

export type TransmissaoLinkInsertDto = {
  readonly hostname?: InputMaybe<Scalars['String']['input']>
  readonly name: Scalars['String']['input']
}

export type TransmissaoLinkPagingQueryFiltroDto = {
  readonly mostrarInativos?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type TransmissaoLinkUpdateDto = {
  readonly hostname?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly name: Scalars['String']['input']
}

export type TransmissaoLinksConnectionInput = {
  readonly mostrarInativos?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type TransmissaoLinksPayload = {
  readonly __typename?: 'TransmissaoLinksPayload'
  readonly content: ReadonlyArray<Maybe<TransmissaoLink>>
  readonly pageInfo: PageInfo
}

export type TransmissaoRecebimentoCnesDetailFiltro = {
  readonly anoRecebimento: Scalars['Int']['input']
  readonly mesRecebimento: Scalars['Int']['input']
  readonly numCnes: Scalars['String']['input']
}

export type TransmissaoRecebimentoCnesDetailItem = {
  readonly __typename?: 'TransmissaoRecebimentoCnesDetailItem'
  readonly nomeEstabelecimento?: Maybe<Scalars['String']['output']>
  readonly quantidade: Scalars['Int']['output']
  readonly tipoFicha: Scalars['String']['output']
}

export type TransmissaoRecebimentoCnesDto = {
  readonly __typename?: 'TransmissaoRecebimentoCnesDto'
  readonly anoRecebimento: Scalars['Int']['output']
  readonly estabelecimentoOrigem?: Maybe<Scalars['String']['output']>
  readonly fichasRecebidas: Scalars['Int']['output']
  readonly mesRecebimento: Scalars['Int']['output']
  readonly numCnes: Scalars['String']['output']
}

export type TransmissaoRecebimentoCnesFiltro = {
  readonly competencia?: InputMaybe<ReferenceMonth>
  readonly estabelecimentoOrigem?: InputMaybe<Scalars['String']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type TransmissaoRecebimentoCnesPayload = {
  readonly __typename?: 'TransmissaoRecebimentoCnesPayload'
  readonly content: ReadonlyArray<Maybe<TransmissaoRecebimentoCnesDto>>
  readonly pageInfo: PageInfo
}

export type TransmissaoRecebimentoLoteCountsDto = {
  readonly __typename?: 'TransmissaoRecebimentoLoteCountsDto'
  readonly fichasInvalidas: Scalars['Int']['output']
  readonly fichasRepetidas: Scalars['Int']['output']
  readonly fichasValidas: Scalars['Int']['output']
  readonly totalFichas: Scalars['Int']['output']
}

export type TransmissaoRecebimentoLoteDto = {
  readonly __typename?: 'TransmissaoRecebimentoLoteDto'
  readonly counts: TransmissaoRecebimentoLoteCountsDto
  readonly cpfResponsavel: Scalars['String']['output']
  readonly credencialIntegracao?: Maybe<CredenciaIntegracao>
  readonly data: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly numeroLote?: Maybe<Scalars['String']['output']>
  readonly origemLote: TipoOrigemDadoTransporte
  readonly possuiInconsistencia: Scalars['Boolean']['output']
  readonly processado?: Maybe<Scalars['Boolean']['output']>
  readonly responsavel: Scalars['String']['output']
}

export type TransmissaoRecebimentoLoteFiltro = {
  readonly origensLote?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Long']['input']>>>
  readonly pageParams?: InputMaybe<PageParams>
  readonly periodo?: InputMaybe<Period>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type TransmissaoRecebimentoQueryPayload = {
  readonly __typename?: 'TransmissaoRecebimentoQueryPayload'
  readonly content: ReadonlyArray<Maybe<TransmissaoRecebimentoLoteDto>>
  readonly pageInfo: PageInfo
}

export enum TrimestreGestacional {
  FORA_PERIODO = 'FORA_PERIODO',
  PRIMEIRO_TRIMESTRE = 'PRIMEIRO_TRIMESTRE',
  SEGUNDO_TRIMESTRE = 'SEGUNDO_TRIMESTRE',
  TERCEIRO_TRIMESTRE = 'TERCEIRO_TRIMESTRE',
}

export type TrocaExecutanteCuidadoCompartilhadoInput = {
  readonly lotacaoExecutanteId: Scalars['ID']['input']
  readonly motivo: Scalars['String']['input']
}

export enum TurnoEnum {
  MANHA = 'MANHA',
  NOITE = 'NOITE',
  TARDE = 'TARDE',
}

export type Uf = {
  readonly __typename?: 'UF'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly sigla: Scalars['String']['output']
}

export type UltimaFichaCadastradaDto = {
  readonly __typename?: 'UltimaFichaCadastradaDto'
  readonly id: Scalars['ID']['output']
  readonly isProcessado: Scalars['Boolean']['output']
  readonly uuidFichaOrigem?: Maybe<Scalars['String']['output']>
}

export type UltimaVacina = {
  readonly __typename?: 'UltimaVacina'
  readonly dataAplicacao?: Maybe<Scalars['LocalDate']['output']>
  readonly dataAprazamento?: Maybe<Scalars['LocalDate']['output']>
  readonly doseNomeApresentacao?: Maybe<Scalars['String']['output']>
  readonly imunobiologicoNome?: Maybe<Scalars['String']['output']>
}

export type UltimasMedicoesInput = {
  readonly data?: InputMaybe<Scalars['Instant']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export type UltimoAtendimentoProfissionalFinalizadoQueryInput = {
  readonly cidadaoId: Scalars['ID']['input']
  readonly onlyAtendimentosEvoluemProntuario?: InputMaybe<Scalars['Boolean']['input']>
}

export type UltimoIvcfDto = {
  readonly __typename?: 'UltimoIvcfDto'
  readonly fatoIvcf?: Maybe<FatoIvcf>
  readonly id: Scalars['ID']['output']
  readonly ivcf?: Maybe<Ivcf>
}

export type UnicaLotacaoHeaderInput = {
  readonly cbo: Scalars['String']['input']
  readonly cnes: Scalars['String']['input']
  readonly cns: Scalars['String']['input']
  /** @deprecated usar dataHorarioInicioAtendimento por causa da v2.1 do aplicativo */
  readonly dataAtendimento?: InputMaybe<Scalars['LocalDate']['input']>
  readonly ibge: Scalars['String']['input']
  readonly ine?: InputMaybe<Scalars['String']['input']>
}

export type UnidadeConsultaHorusIds = {
  readonly unidadeConsultaId: Scalars['ID']['input']
  readonly unidadeSaudeId: Scalars['ID']['input']
}

export type UnidadeMedida = {
  readonly __typename?: 'UnidadeMedida'
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly nomePlural: Scalars['String']['output']
}

export type UnidadeMedidaPayload = {
  readonly __typename?: 'UnidadeMedidaPayload'
  readonly content: ReadonlyArray<Maybe<UnidadeMedida>>
  readonly pageInfo: PageInfo
}

export type UnidadeMedidaQueryInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export enum UnidadeMedidaTempoEnum {
  DIAS = 'DIAS',
  INDETERMINADO = 'INDETERMINADO',
  MESES = 'MESES',
  NAO_INFORMADO = 'NAO_INFORMADO',
  SEMANAS = 'SEMANAS',
}

export enum UnidadePeriodoRelatorioGerencialEnum {
  DIA = 'DIA',
  MES = 'MES',
  SEMANA = 'SEMANA',
}

export type UnidadeSaude = {
  readonly __typename?: 'UnidadeSaude'
  readonly actions: UnidadeSaudeActions
  readonly ativo?: Maybe<Scalars['Boolean']['output']>
  readonly cnes: Scalars['String']['output']
  readonly cnpj?: Maybe<Scalars['String']['output']>
  readonly complexidades?: Maybe<ReadonlyArray<Maybe<Complexidade>>>
  readonly email?: Maybe<Scalars['String']['output']>
  readonly endereco?: Maybe<Endereco>
  readonly fax?: Maybe<Scalars['String']['output']>
  readonly hasVinculacaoServico: Scalars['Boolean']['output']
  readonly id: Scalars['ID']['output']
  readonly isEstabelecimentoAtencaoPrimaria: Scalars['Boolean']['output']
  readonly nome?: Maybe<Scalars['String']['output']>
  readonly subtipo?: Maybe<SubtipoUnidadeSaude>
  readonly telefone1?: Maybe<Scalars['String']['output']>
  readonly telefone2?: Maybe<Scalars['String']['output']>
  readonly tipo: TipoUnidadeSaude
  readonly tipoEstabelecimento: TipoEstabelecimentoEnum
}

export type UnidadeSaudeActions = {
  readonly __typename?: 'UnidadeSaudeActions'
  readonly permissaoAtivarInativarTipoServico: Action
  readonly permissaoConexaoHorus: Action
  readonly permissaoPainelChamadas: Action
}

export type UnidadeSaudePayload = {
  readonly __typename?: 'UnidadeSaudePayload'
  readonly content: ReadonlyArray<Maybe<UnidadeSaude>>
  readonly pageInfo: PageInfo
}

export type UnidadeSaudeTipoServico = {
  readonly __typename?: 'UnidadeSaudeTipoServico'
  readonly ativo: Scalars['Boolean']['output']
  readonly tipoServico: TipoServico
}

export type UnidadeSaudeTipoServicoFormInput = {
  readonly tipoServicoId: Scalars['ID']['input']
  readonly unidadeSaudeId: Scalars['ID']['input']
}

export type UnidadeSaudeTipoServicoQueryInput = {
  readonly mostrarInativos?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly unidadeSaudeId: Scalars['ID']['input']
}

export type UnidadeSaudeTiposServicoPayload = {
  readonly __typename?: 'UnidadeSaudeTiposServicoPayload'
  readonly content: ReadonlyArray<Maybe<UnidadeSaudeTipoServico>>
  readonly pageInfo: PageInfo
}

export type UnidadesSaudeByGarantiaAcessoCidadaoInput = {
  readonly cidadaoId: Scalars['ID']['input']
  readonly tipoAtendimento?: InputMaybe<ListaEsperaTipoAtendimentoEnum>
  readonly tipoServico?: InputMaybe<Scalars['ID']['input']>
}

export type UnidadesSaudeByTipoVinculacaoServicoInput = {
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly tipoEstabelecimento: VinculacaoServicoTipoEstabelecimentoEnum
}

export type UnidadesSaudeQueryInput = {
  readonly mostrarInativas?: InputMaybe<Scalars['Boolean']['input']>
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
  readonly somenteUnidadesPermitidas?: InputMaybe<Scalars['Boolean']['input']>
}

export type UnificacaoBase = {
  readonly __typename?: 'UnificacaoBase'
  readonly chave?: Maybe<Scalars['String']['output']>
  readonly dataFimUnificacao?: Maybe<Scalars['Instant']['output']>
  readonly dataSolicitacao: Scalars['Instant']['output']
  readonly id: Scalars['ID']['output']
  readonly idInstalacao?: Maybe<Scalars['String']['output']>
  readonly nomeInstalacao: Scalars['String']['output']
  readonly offsetCidadao: Scalars['Int']['output']
  readonly offsetProfissional: Scalars['Int']['output']
  readonly status?: Maybe<StatusUnificacaoBaseEnum>
}

export enum UnificacaoBaseOrigemBroadcastEnum {
  ENVIO = 'ENVIO',
  LOGIN = 'LOGIN',
  RECEBIMENTO = 'RECEBIMENTO',
  RECUSA = 'RECUSA',
}

export type UnificacaoCadastroInput = {
  readonly idCidadaoMaster: Scalars['ID']['input']
  readonly idCidadaos: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>
}

export type UnificacoesCidadao = {
  readonly __typename?: 'UnificacoesCidadao'
  readonly cidadaos?: Maybe<ReadonlyArray<Maybe<Cidadao>>>
  readonly dataUnificacao?: Maybe<Scalars['Instant']['output']>
  readonly id: Scalars['ID']['output']
  readonly nomeProfissional?: Maybe<Scalars['String']['output']>
}

export type Usuario = {
  readonly __typename?: 'Usuario'
  readonly aceitouTermoTeleinterconsulta: Scalars['Boolean']['output']
  readonly aceitouTermosUso: Scalars['Boolean']['output']
  readonly bloqueado: Scalars['Boolean']['output']
  readonly forcarTrocaSenha: Scalars['Boolean']['output']
  readonly hashId: Scalars['String']['output']
  readonly id: Scalars['ID']['output']
  readonly mostrarPesquisaSatisfacao: Scalars['Boolean']['output']
  readonly notificaNovidadesVersao: Scalars['Boolean']['output']
  readonly visualizouNovidades: Scalars['Boolean']['output']
}

export type VacinacaoUltimaVacinaInput = {
  readonly dataAtendimento?: InputMaybe<Scalars['Instant']['input']>
  readonly idProntuario?: InputMaybe<Scalars['ID']['input']>
}

export type VacinasPreNatal = {
  readonly __typename?: 'VacinasPreNatal'
  readonly ultimaVacinaAplicadaCovid?: Maybe<AcompanhamentoPreNatalVacinacao>
  readonly ultimaVacinaAprazadaCovid?: Maybe<AcompanhamentoPreNatalVacinacao>
  readonly vacinasAplicadas?: Maybe<ReadonlyArray<AcompanhamentoPreNatalVacinacao>>
  readonly vacinasAprazadas?: Maybe<ReadonlyArray<AcompanhamentoPreNatalVacinacao>>
}

export type ValidateNovoAdminInput = {
  readonly contraChave: Scalars['String']['input']
  readonly cpf: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
}

export enum ValidationState {
  ERRO_COMUNICACAO = 'ERRO_COMUNICACAO',
  SUCESSO_COMUNICACAO = 'SUCESSO_COMUNICACAO',
  UBS_COM_HORUS = 'UBS_COM_HORUS',
  UBS_SEM_HORUS = 'UBS_SEM_HORUS',
}

export type VerificarParticipantePermitidoVideochamadaInput = {
  readonly participanteId: Scalars['String']['input']
  readonly videochamadaUuid: Scalars['String']['input']
}

export type VersaoTransportInput = {
  readonly major: Scalars['Int']['input']
  readonly minor: Scalars['Int']['input']
  readonly revision: Scalars['Int']['input']
}

export type ViaAdmLocalAplicacaoQueryInput = {
  readonly maxTransportVersion?: InputMaybe<Scalars['String']['input']>
}

export type ViaAdmLocalAplicacaoVacina = {
  readonly __typename?: 'ViaAdmLocalAplicacaoVacina'
  readonly locaisAplicacao: ReadonlyArray<LocalAplicacao>
  readonly viaAdministracao: ViaAdministracao
}

export type ViaAdministracao = {
  readonly __typename?: 'ViaAdministracao'
  readonly codigoRnds?: Maybe<Scalars['String']['output']>
  readonly id: Scalars['ID']['output']
  readonly nome: Scalars['String']['output']
  readonly versaoMaximaTransport?: Maybe<Scalars['String']['output']>
  readonly versaoMinimaTransport?: Maybe<Scalars['String']['output']>
}

export type Videochamada = {
  readonly __typename?: 'Videochamada'
  readonly agendamento?: Maybe<Agendado>
  readonly dataFim?: Maybe<Scalars['Instant']['output']>
  readonly dataInicio?: Maybe<Scalars['Instant']['output']>
  readonly id: Scalars['ID']['output']
  readonly owner?: Maybe<Acesso>
  readonly status: StatusVideochamadaEnum
  readonly uuid: Scalars['String']['output']
}

export type VigenciaBolsaFamilia = {
  readonly __typename?: 'VigenciaBolsaFamilia'
  readonly id: Scalars['ID']['output']
  readonly vigencia: Scalars['String']['output']
}

export enum VigilanciaEmSaudeBucalEnum {
  ABSCESSO_DENTO_ALVEOLAR = 'ABSCESSO_DENTO_ALVEOLAR',
  ALTERACAO_EM_TECIDOS_MOLES = 'ALTERACAO_EM_TECIDOS_MOLES',
  DOR_DE_DENTE = 'DOR_DE_DENTE',
  FENDAS_OU_FISSURAS_LABIO_PALATAIS = 'FENDAS_OU_FISSURAS_LABIO_PALATAIS',
  FLUOROSE_DENTARIA_MODERADA_OU_SEVERA = 'FLUOROSE_DENTARIA_MODERADA_OU_SEVERA',
  NAO_IDENTIFICADO = 'NAO_IDENTIFICADO',
  TRAUMATISMO_DENTO_ALVEOLAR = 'TRAUMATISMO_DENTO_ALVEOLAR',
}

export type VigilanciaSaudeBucalInput = {
  readonly necessidadeProtese?: InputMaybe<Scalars['Boolean']['input']>
  readonly tiposVigilancia: ReadonlyArray<VigilanciaEmSaudeBucalEnum>
}

export type VinculacaoCidadaoFamiliaInput = {
  readonly cpfCnsResponsavelFamiliar?: InputMaybe<Scalars['String']['input']>
  readonly grauParentescoResponsavelFamiliar?: InputMaybe<GrauParentescoEnum>
  readonly isResponsavelFamiliar: Scalars['Boolean']['input']
}

export type VinculacaoCidadaoTerritorioInput = {
  readonly cbo2002: Scalars['String']['input']
  readonly cnes: Scalars['String']['input']
  readonly cns: Scalars['String']['input']
  readonly foraDeArea?: InputMaybe<Scalars['Boolean']['input']>
  readonly ine?: InputMaybe<Scalars['String']['input']>
  readonly microarea?: InputMaybe<Scalars['String']['input']>
  readonly saidaTerritorio?: InputMaybe<Scalars['Boolean']['input']>
}

export type VinculacaoEquipePorEstabelecimentoDto = {
  readonly __typename?: 'VinculacaoEquipePorEstabelecimentoDto'
  readonly equipes: ReadonlyArray<Equipe>
  readonly estabelecimento: UnidadeSaude
}

export type VinculacaoServicoDto = {
  readonly __typename?: 'VinculacaoServicoDto'
  readonly quantidadeVinculacoes: Scalars['Int']['output']
  readonly referencia: UnidadeSaude
  readonly vinculacoes: ReadonlyArray<UnidadeSaude>
}

export enum VinculacaoServicoTipoEstabelecimentoEnum {
  REFERENCIA = 'REFERENCIA',
  VINCULADOS = 'VINCULADOS',
}

export type VinculacaoServicosInput = {
  readonly pageParams?: InputMaybe<PageParams>
  readonly query?: InputMaybe<Scalars['String']['input']>
}

export type VinculacaoServicosPayload = {
  readonly __typename?: 'VinculacaoServicosPayload'
  readonly content: ReadonlyArray<VinculacaoServicoDto>
  readonly pageInfo: PageInfo
}

export enum VisibilidadeLembreteEnum {
  PUBLICO = 'PUBLICO',
  SOMENTE_EU = 'SOMENTE_EU',
}

export type VisitaDomiciliarConsolidado = {
  readonly __typename?: 'VisitaDomiciliarConsolidado'
  readonly dataUltimasVisitasDomiciliares?: Maybe<ReadonlyArray<Maybe<Scalars['LocalDate']['output']>>>
  readonly qtdVisitasDomiciliares?: Maybe<Scalars['Long']['output']>
}

export type VisitasDomiciliaresDesenvolvimentoInfantil = {
  readonly __typename?: 'VisitasDomiciliaresDesenvolvimentoInfantil'
  readonly dataPrimeiraVisita?: Maybe<Scalars['LocalDate']['output']>
  readonly dataSegundaVisita?: Maybe<Scalars['LocalDate']['output']>
  readonly qtdVisitasDomiciliares?: Maybe<Scalars['Long']['output']>
}

export type VisitasDomiciliaresPreNatalPuerperioConsolidado = {
  readonly __typename?: 'VisitasDomiciliaresPreNatalPuerperioConsolidado'
  readonly visitasDomiciliaresPreNatal?: Maybe<Scalars['Long']['output']>
  readonly visitasDomiciliaresPuerperio?: Maybe<Scalars['Long']['output']>
}

export type VisitasQueryInput = {
  readonly desfecho?: InputMaybe<DesfechoVisitaEnum>
  readonly imovelId: Scalars['ID']['input']
  readonly pageParams?: InputMaybe<PageParams>
}

export type VisitasQueryPayload = {
  readonly __typename?: 'VisitasQueryPayload'
  readonly content: ReadonlyArray<FatoVisitaDomiciliar>
  readonly pageInfo: PageInfo
}

export type VisualizarCuidadoCompartilhadoInput = {
  readonly cuidadoCompartilhadoId: Scalars['ID']['input']
  readonly isDiscutirCaso: Scalars['Boolean']['input']
  readonly justificativa?: InputMaybe<Scalars['String']['input']>
  readonly prontuarioId: Scalars['ID']['input']
}

export type VulnerabilidadeFamiliar = {
  readonly __typename?: 'VulnerabilidadeFamiliar'
  readonly classificacao: ClassificacaoVulnerabilidadeFamiliar
  readonly classificacaoSubestimada?: Maybe<Scalars['Boolean']['output']>
  readonly criterios: CriteriosVulnerabilidadeFamiliar
  readonly escore?: Maybe<Scalars['Int']['output']>
  readonly grauSugestivo?: Maybe<GrauSugestivoVulnerabilidadeFamiliar>
  readonly id: Scalars['ID']['output']
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = {
  readonly __typename?: 'Mutation'
  readonly logout?: {
    readonly __typename?: 'Sessao'
    readonly id: string
    readonly timeout: number
    readonly expDateAccessTokenGovBr?: any | null
    readonly recursos?: ReadonlyArray<string | null> | null
    readonly sessionProvider: SessionProviderEnum
    readonly acesso?:
      | {
          readonly __typename?: 'AdministradorGeral'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio?: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          } | null
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'AdministradorMunicipal'
          readonly autorizado: boolean
          readonly habilitado: boolean
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
            readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            readonly tipo: {
              readonly __typename?: 'TipoUnidadeSaude'
              readonly id: string
              readonly codigoMs: any
              readonly isTipoAps: boolean
            }
            readonly subtipo?: {
              readonly __typename?: 'SubtipoUnidadeSaude'
              readonly id: string
              readonly codigoMs?: string | null
            } | null
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
              readonly nome: string
              readonly sigla: string
              readonly codigoMs?: string | null
            }
          } | null
          readonly lotacaoSupervisora: {
            readonly __typename: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly numeroConselhoClasse?: string | null
              readonly conselhoClasse?: {
                readonly __typename?: 'ConselhoClasse'
                readonly id: string
                readonly sigla: string
              } | null
              readonly ufEmissoraConselhoClasse?: {
                readonly __typename?: 'UF'
                readonly id: string
                readonly nome: string
                readonly sigla: string
              } | null
            }
            readonly municipio: {
              readonly __typename?: 'Municipio'
              readonly id: string
              readonly nome: string
              readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          }
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis: ReadonlyArray<{ readonly __typename?: 'Perfil'; readonly id: string; readonly nome: string }>
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      | {
          readonly __typename?: 'GestorEstadual'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio?: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          } | null
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'GestorMunicipal'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
            readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            readonly isEstabelecimentoAtencaoPrimaria: boolean
            readonly tipo: {
              readonly __typename?: 'TipoUnidadeSaude'
              readonly id: string
              readonly codigoMs: any
              readonly isTipoAps: boolean
            }
            readonly subtipo?: {
              readonly __typename?: 'SubtipoUnidadeSaude'
              readonly id: string
              readonly codigoMs?: string | null
            } | null
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
              readonly nome: string
              readonly sigla: string
              readonly codigoMs?: string | null
            }
          } | null
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis?: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null> | null
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      | null
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly cpf: string
      readonly cns?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly numeroConselhoClasse?: string | null
      readonly conselhoClasse?: {
        readonly __typename?: 'ConselhoClasse'
        readonly id: string
        readonly sigla: string
        readonly descricao?: string | null
      } | null
      readonly ufEmissoraConselhoClasse?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
      readonly usuario: {
        readonly __typename?: 'Usuario'
        readonly id: string
        readonly aceitouTermosUso: boolean
        readonly aceitouTermoTeleinterconsulta: boolean
        readonly forcarTrocaSenha: boolean
        readonly visualizouNovidades: boolean
        readonly mostrarPesquisaSatisfacao: boolean
        readonly notificaNovidadesVersao: boolean
        readonly hashId: string
      }
      readonly acessos?: ReadonlyArray<
        | { readonly __typename?: 'AdministradorGeral'; readonly id: string; readonly tipo: TipoAcesso }
        | {
            readonly __typename?: 'AdministradorMunicipal'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
          }
        | {
            readonly __typename?: 'Estagio'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly lotacaoSupervisora: {
              readonly __typename?: 'Lotacao'
              readonly id: string
              readonly profissional: {
                readonly __typename?: 'Profissional'
                readonly id: string
                readonly nome: string
              }
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        | {
            readonly __typename?: 'GestorEstadual'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string }
          }
        | {
            readonly __typename?: 'GestorMunicipal'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
          }
        | {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
      > | null
    }
  } | null
}

export type RecursosByAtorPapelIdQueryVariables = Exact<{
  atorPapelId: Scalars['ID']['input']
}>

export type RecursosByAtorPapelIdQuery = {
  readonly __typename?: 'Query'
  readonly recursosByAtorPapelId: ReadonlyArray<string>
}

export type SessaoQueryVariables = Exact<{ [key: string]: never }>

export type SessaoQuery = {
  readonly __typename?: 'Query'
  readonly sessao?: {
    readonly __typename?: 'Sessao'
    readonly id: string
    readonly timeout: number
    readonly expDateAccessTokenGovBr?: any | null
    readonly recursos?: ReadonlyArray<string | null> | null
    readonly sessionProvider: SessionProviderEnum
    readonly acesso?:
      | {
          readonly __typename?: 'AdministradorGeral'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio?: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          } | null
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'AdministradorMunicipal'
          readonly autorizado: boolean
          readonly habilitado: boolean
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
            readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            readonly tipo: {
              readonly __typename?: 'TipoUnidadeSaude'
              readonly id: string
              readonly codigoMs: any
              readonly isTipoAps: boolean
            }
            readonly subtipo?: {
              readonly __typename?: 'SubtipoUnidadeSaude'
              readonly id: string
              readonly codigoMs?: string | null
            } | null
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
              readonly nome: string
              readonly sigla: string
              readonly codigoMs?: string | null
            }
          } | null
          readonly lotacaoSupervisora: {
            readonly __typename: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly numeroConselhoClasse?: string | null
              readonly conselhoClasse?: {
                readonly __typename?: 'ConselhoClasse'
                readonly id: string
                readonly sigla: string
              } | null
              readonly ufEmissoraConselhoClasse?: {
                readonly __typename?: 'UF'
                readonly id: string
                readonly nome: string
                readonly sigla: string
              } | null
            }
            readonly municipio: {
              readonly __typename?: 'Municipio'
              readonly id: string
              readonly nome: string
              readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          }
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis: ReadonlyArray<{ readonly __typename?: 'Perfil'; readonly id: string; readonly nome: string }>
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      | {
          readonly __typename?: 'GestorEstadual'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio?: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          } | null
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'GestorMunicipal'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null>
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly moduloInicial?: string | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
            readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            readonly isEstabelecimentoAtencaoPrimaria: boolean
            readonly tipo: {
              readonly __typename?: 'TipoUnidadeSaude'
              readonly id: string
              readonly codigoMs: any
              readonly isTipoAps: boolean
            }
            readonly subtipo?: {
              readonly __typename?: 'SubtipoUnidadeSaude'
              readonly id: string
              readonly codigoMs?: string | null
            } | null
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
              readonly nome: string
              readonly sigla: string
              readonly codigoMs?: string | null
            }
          } | null
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
          readonly perfis?: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
          } | null> | null
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      | null
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly cpf: string
      readonly cns?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly numeroConselhoClasse?: string | null
      readonly conselhoClasse?: {
        readonly __typename?: 'ConselhoClasse'
        readonly id: string
        readonly sigla: string
        readonly descricao?: string | null
      } | null
      readonly ufEmissoraConselhoClasse?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
      readonly usuario: {
        readonly __typename?: 'Usuario'
        readonly id: string
        readonly aceitouTermosUso: boolean
        readonly aceitouTermoTeleinterconsulta: boolean
        readonly forcarTrocaSenha: boolean
        readonly visualizouNovidades: boolean
        readonly mostrarPesquisaSatisfacao: boolean
        readonly notificaNovidadesVersao: boolean
        readonly hashId: string
      }
      readonly acessos?: ReadonlyArray<
        | { readonly __typename?: 'AdministradorGeral'; readonly id: string; readonly tipo: TipoAcesso }
        | {
            readonly __typename?: 'AdministradorMunicipal'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
          }
        | {
            readonly __typename?: 'Estagio'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly lotacaoSupervisora: {
              readonly __typename?: 'Lotacao'
              readonly id: string
              readonly profissional: {
                readonly __typename?: 'Profissional'
                readonly id: string
                readonly nome: string
              }
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        | {
            readonly __typename?: 'GestorEstadual'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string }
          }
        | {
            readonly __typename?: 'GestorMunicipal'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
          }
        | {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly tipo: TipoAcesso
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
      > | null
    }
  } | null
}

export type SessaoDataFragment = {
  readonly __typename?: 'Sessao'
  readonly id: string
  readonly timeout: number
  readonly expDateAccessTokenGovBr?: any | null
  readonly recursos?: ReadonlyArray<string | null> | null
  readonly sessionProvider: SessionProviderEnum
  readonly acesso?:
    | {
        readonly __typename?: 'AdministradorGeral'
        readonly id: string
        readonly tipo: TipoAcesso
        readonly moduloInicial?: string | null
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
        } | null>
      }
    | {
        readonly __typename?: 'AdministradorMunicipal'
        readonly autorizado: boolean
        readonly habilitado: boolean
        readonly id: string
        readonly tipo: TipoAcesso
        readonly moduloInicial?: string | null
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
        } | null>
      }
    | {
        readonly __typename?: 'Estagio'
        readonly id: string
        readonly tipo: TipoAcesso
        readonly moduloInicial?: string | null
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
          readonly tipoEstabelecimento: TipoEstabelecimentoEnum
          readonly tipo: {
            readonly __typename?: 'TipoUnidadeSaude'
            readonly id: string
            readonly codigoMs: any
            readonly isTipoAps: boolean
          }
          readonly subtipo?: {
            readonly __typename?: 'SubtipoUnidadeSaude'
            readonly id: string
            readonly codigoMs?: string | null
          } | null
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
          readonly tipoEquipe: {
            readonly __typename?: 'TipoEquipe'
            readonly id: string
            readonly descricao?: string | null
            readonly nome: string
            readonly sigla: string
            readonly codigoMs?: string | null
          }
        } | null
        readonly lotacaoSupervisora: {
          readonly __typename: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly numeroConselhoClasse?: string | null
            readonly conselhoClasse?: {
              readonly __typename?: 'ConselhoClasse'
              readonly id: string
              readonly sigla: string
            } | null
            readonly ufEmissoraConselhoClasse?: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            } | null
          }
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
          }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
        readonly perfis: ReadonlyArray<{ readonly __typename?: 'Perfil'; readonly id: string; readonly nome: string }>
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
          readonly actions?: {
            readonly __typename?: 'CboActions'
            readonly cadastroDomiciliar: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly cadastroIndividual: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly atividadeColetiva: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          } | null
        }
      }
    | {
        readonly __typename?: 'GestorEstadual'
        readonly id: string
        readonly tipo: TipoAcesso
        readonly moduloInicial?: string | null
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
        } | null>
      }
    | {
        readonly __typename?: 'GestorMunicipal'
        readonly id: string
        readonly tipo: TipoAcesso
        readonly moduloInicial?: string | null
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
        } | null>
      }
    | {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly tipo: TipoAcesso
        readonly moduloInicial?: string | null
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
          readonly tipoEstabelecimento: TipoEstabelecimentoEnum
          readonly isEstabelecimentoAtencaoPrimaria: boolean
          readonly tipo: {
            readonly __typename?: 'TipoUnidadeSaude'
            readonly id: string
            readonly codigoMs: any
            readonly isTipoAps: boolean
          }
          readonly subtipo?: {
            readonly __typename?: 'SubtipoUnidadeSaude'
            readonly id: string
            readonly codigoMs?: string | null
          } | null
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
          readonly tipoEquipe: {
            readonly __typename?: 'TipoEquipe'
            readonly id: string
            readonly descricao?: string | null
            readonly nome: string
            readonly sigla: string
            readonly codigoMs?: string | null
          }
        } | null
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
        readonly perfis?: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
        } | null> | null
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
          readonly actions?: {
            readonly __typename?: 'CboActions'
            readonly cadastroDomiciliar: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly cadastroIndividual: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly atividadeColetiva: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          } | null
        }
      }
    | null
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly cpf: string
    readonly cns?: string | null
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly numeroConselhoClasse?: string | null
    readonly conselhoClasse?: {
      readonly __typename?: 'ConselhoClasse'
      readonly id: string
      readonly sigla: string
      readonly descricao?: string | null
    } | null
    readonly ufEmissoraConselhoClasse?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
    readonly usuario: {
      readonly __typename?: 'Usuario'
      readonly id: string
      readonly aceitouTermosUso: boolean
      readonly aceitouTermoTeleinterconsulta: boolean
      readonly forcarTrocaSenha: boolean
      readonly visualizouNovidades: boolean
      readonly mostrarPesquisaSatisfacao: boolean
      readonly notificaNovidadesVersao: boolean
      readonly hashId: string
    }
    readonly acessos?: ReadonlyArray<
      | { readonly __typename?: 'AdministradorGeral'; readonly id: string; readonly tipo: TipoAcesso }
      | {
          readonly __typename?: 'AdministradorMunicipal'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
        }
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly lotacaoSupervisora: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      | {
          readonly __typename?: 'GestorEstadual'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string }
        }
      | {
          readonly __typename?: 'GestorMunicipal'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
    > | null
  }
}

export type AcessoAdministradorMunicipalFragment = {
  readonly __typename?: 'AdministradorMunicipal'
  readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
}

export type AcessoGestorEstadualFragment = {
  readonly __typename?: 'GestorEstadual'
  readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string }
}

export type AcessoGestorMunicipalFragment = {
  readonly __typename?: 'GestorMunicipal'
  readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
}

export type AcessoLotacaoFragment = {
  readonly __typename?: 'Lotacao'
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
  } | null
  readonly unidadeSaude: { readonly __typename?: 'UnidadeSaude'; readonly id: string; readonly nome?: string | null }
  readonly cbo: {
    readonly __typename?: 'Cbo'
    readonly id: string
    readonly nome: string
    readonly cbo2002: string
    readonly actions?: {
      readonly __typename?: 'CboActions'
      readonly cadastroDomiciliar: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly cadastroIndividual: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly atividadeColetiva: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    } | null
  }
}

export type AcessoEstagioFragment = {
  readonly __typename?: 'Estagio'
  readonly lotacaoSupervisora: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
  }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
  } | null
  readonly unidadeSaude: { readonly __typename?: 'UnidadeSaude'; readonly id: string; readonly nome?: string | null }
  readonly cbo: {
    readonly __typename?: 'Cbo'
    readonly id: string
    readonly nome: string
    readonly cbo2002: string
    readonly actions?: {
      readonly __typename?: 'CboActions'
      readonly cadastroDomiciliar: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly cadastroIndividual: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly atividadeColetiva: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    } | null
  }
}

export type TipoEquipeFragment = {
  readonly __typename?: 'Equipe'
  readonly tipoEquipe: {
    readonly __typename?: 'TipoEquipe'
    readonly id: string
    readonly descricao?: string | null
    readonly nome: string
    readonly sigla: string
    readonly codigoMs?: string | null
  }
}

export type Cbo_Estagio_Fragment = {
  readonly __typename?: 'Estagio'
  readonly cbo: {
    readonly __typename?: 'Cbo'
    readonly id: string
    readonly nome: string
    readonly cbo2002: string
    readonly actions?: {
      readonly __typename?: 'CboActions'
      readonly cadastroDomiciliar: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly cadastroIndividual: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly atividadeColetiva: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    } | null
  }
}

export type Cbo_Lotacao_Fragment = {
  readonly __typename?: 'Lotacao'
  readonly cbo: {
    readonly __typename?: 'Cbo'
    readonly id: string
    readonly nome: string
    readonly cbo2002: string
    readonly actions?: {
      readonly __typename?: 'CboActions'
      readonly cadastroDomiciliar: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly cadastroIndividual: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly atividadeColetiva: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    } | null
  }
}

export type CboFragment = Cbo_Estagio_Fragment | Cbo_Lotacao_Fragment

export type EnderecoQueryVariables = Exact<{
  cep: Scalars['String']['input']
}>

export type EnderecoQuery = {
  readonly __typename?: 'Query'
  readonly endereco?: {
    readonly __typename?: 'EnderecoQueryPayload'
    readonly logradouro?: string | null
    readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
    readonly uf?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
    readonly tipoLogradouro?: {
      readonly __typename?: 'TipoLogradouro'
      readonly id: string
      readonly nome: string
      readonly numeroDne: string
    } | null
    readonly bairro?: { readonly __typename?: 'Bairro'; readonly id: string; readonly nome: string } | null
  } | null
}

export type AldeiaSelectFieldQueryVariables = Exact<{
  input: AldeiaInput
}>

export type AldeiaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly aldeias: {
    readonly __typename?: 'AldeiaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Aldeia'
      readonly id: string
      readonly nome: string
      readonly poloBase: {
        readonly __typename?: 'PoloBase'
        readonly id: string
        readonly nome: string
        readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
      }
      readonly municipio: ReadonlyArray<{
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      }>
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AlergiaSelectFieldQueryVariables = Exact<{
  filtro: AlergiasQueryInput
}>

export type AlergiaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly alergias: {
    readonly __typename?: 'AlergiaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Alergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
      readonly substanciaEspecificaLegado?: string | null
      readonly substanciaEspecifica?: {
        readonly __typename?: 'SubstanciaEspecificaAlergia'
        readonly sigla?: string | null
        readonly id: string
        readonly coSubstanciaEspecifica: any
        readonly coPrincipioAtivo?: any | null
        readonly categoria: CategoriaSubstanciaAlergia
        readonly nome: string
      } | null
      readonly ultimaEvolucao: {
        readonly __typename?: 'EvolucaoAlergia'
        readonly id: string
        readonly dataInicio?: any | null
        readonly manifestacoesLegado?: string | null
        readonly possuiSubstanciaEspecificaCbara?: boolean | null
        readonly manifestacoes: ReadonlyArray<{
          readonly __typename?: 'ManifestacaoAlergia'
          readonly id: string
          readonly nome: string
          readonly sinonimo?: string | null
        }>
      }
    }>
  }
}

export type BairroSelectFieldQueryVariables = Exact<{
  input: BairroInput
}>

export type BairroSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly bairros: {
    readonly __typename?: 'BairroQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Bairro'
      readonly id: string
      readonly nome: string
      readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CategoriaProfissionalRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type CategoriaProfissionalRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly categoriasProfissionalRelatorioGerencial?: ReadonlyArray<string> | null
}

export type CboRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
  input?: InputMaybe<Scalars['String']['input']>
}>

export type CboRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cbosRelatorioGerencial?: ReadonlyArray<string> | null
}

export type DiaDaSemanaRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type DiaDaSemanaRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly diasDaSemanaRelatorioGerencial?: ReadonlyArray<string> | null
}

export type EquipeRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
  input?: InputMaybe<Scalars['String']['input']>
}>

export type EquipeRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly equipesRelatorioGerencial?: ReadonlyArray<string> | null
}

export type FaixaEtariaRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type FaixaEtariaRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly faixasEtariaRelatorioGerencial?: ReadonlyArray<string> | null
}

export type HorarioRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type HorarioRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly horariosRelatorioGerencial?: ReadonlyArray<string> | null
}

export type MesRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type MesRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly mesesRelatorioGerencial?: ReadonlyArray<string> | null
}

export type MunicipioRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
  input?: InputMaybe<Scalars['String']['input']>
}>

export type MunicipioRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly municipiosRelatorioGerencial?: ReadonlyArray<string> | null
}

export type ProfissionalRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
  input?: InputMaybe<Scalars['String']['input']>
}>

export type ProfissionalRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly profissionaisRelatorioGerencial?: ReadonlyArray<string> | null
}

export type SexoRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type SexoRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly sexosRelatorioGerencial?: ReadonlyArray<string> | null
}

export type SimNaoNaoInformadoRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type SimNaoNaoInformadoRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly simNaoNaoInformadoRelatorioGerencial?: ReadonlyArray<string> | null
}

export type SimNaoRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type SimNaoRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly simNaoRelatorioGerencial?: ReadonlyArray<string> | null
}

export type TipoProducaoRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type TipoProducaoRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposProducaoRelatorioGerencial?: ReadonlyArray<string> | null
}

export type TurnoRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
}>

export type TurnoRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly turnosRelatorioGerencial?: ReadonlyArray<string> | null
}

export type UnidadeSaudeRelatorioGerencialSelectFieldQueryVariables = Exact<{
  tipoModulo?: InputMaybe<TipoModuloEnum>
  input?: InputMaybe<Scalars['String']['input']>
}>

export type UnidadeSaudeRelatorioGerencialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly unidadesSaudeRelatorioGerencial?: ReadonlyArray<string> | null
}

export type TempoEntreAgendamentoEConsultaSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TempoEntreAgendamentoEConsultaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tempoEntreAgendamentoEConsultaRelatorioGerencialAbsenteismo?: ReadonlyArray<string> | null
}

export type TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TipoDeFaltaRelatorioGerencialAbsenteismoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposDeFaltaRelatorioGerencialAbsenteismo?: ReadonlyArray<string> | null
}

export type TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TipoDeAtendimentoRelatorioGerencialAtendimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposDeAtendimentoRelatorioGerencialAtendimento?: ReadonlyArray<string> | null
}

export type TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TipoDeConsultaRelatorioGerencialAtendimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposDeConsultaRelatorioGerencialAtendimento?: ReadonlyArray<string> | null
}

export type DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type DeficienciaRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly deficienciasRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type EtniaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type EtniaRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly etniasRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type FrequenciaAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly frequenciasAlimentacaoRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type IdentidadeGeneroRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly identidadesGeneroRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type NacionalidadeRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly nacionalidadesRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type OcupacaoRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly ocupacoesRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type OrientacaoSexualRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly orientacoesSexuaisRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type OrigemAlimentacaoRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly origensAlimentacaoRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type RacaCorRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type RacaCorRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly racasCoresRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type ResponsavelCriancaRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly responsaveisCriancaRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type SituacaoTrabalhoRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly situacoesTrabalhoRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TempoSituacaoRuaRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly temposSituacaoRuaRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoCondicaoPesoRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposCondicaoPesoRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoDoencaCardiacaRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposDoencaCardiacaRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoDoencaRespiratoriaRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposDoencaRespiratoriaRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoEscolaridadeRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposEscolaridadeRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoHigienePessoalRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposHigienePessoalRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoParentescoRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposParentescoRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TipoProblemaRenalRelatorioGerencialCadastroIndividualSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposProblemaRenalRelatorioGerencialCadastroIndividual?: ReadonlyArray<string> | null
}

export type CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type CondutaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly condutasRelatorioGerencialCuidadoCompartilhado?: ReadonlyArray<string> | null
}

export type PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type PrimeiraRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly primeirasRespostasRelatorioGerencialCuidadoCompartilhado?: ReadonlyArray<string> | null
}

export type PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type PrioridadeRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly prioridadesRelatorioGerencialCuidadoCompartilhado?: ReadonlyArray<string> | null
}

export type RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type RealizadoPorRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly realizadoPorRelatorioGerencialCuidadoCompartilhado?: ReadonlyArray<string> | null
}

export type TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TempoDeEsperaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly temposDeEsperaRelatorioGerencialCuidadoCompartilhado?: ReadonlyArray<string> | null
}

export type TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  [key: string]: never
}>

export type TempoDeRespostaRelatorioGerencialCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly temposDeRespostaRelatorioGerencialCuidadoCompartilhado?: ReadonlyArray<string> | null
}

export type ExamesRelatorioGerencialExameSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type ExamesRelatorioGerencialExameSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly examesRelatorioGerencialExames?: ReadonlyArray<string> | null
}

export type OrigemRelatorioGerencialExameSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type OrigemRelatorioGerencialExameSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly origensRelatorioGerencialExames?: ReadonlyArray<string> | null
}

export type CboPrescritorRelatorioGerencialVacinacaoSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type CboPrescritorRelatorioGerencialVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cbosPrescritoresRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cid10MotivosIndicacoesRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables = Exact<{ [key: string]: never }>

export type CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryQuery = {
  readonly __typename?: 'Query'
  readonly condicaoMaternalRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly dosesImunobiologicosRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type EstrategiaRelatorioGerencialVacinacaoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type EstrategiaRelatorioGerencialVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly estrategiasRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>
}>

export type ImunobiologicoRelatorioGerencialVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly imunobiologicosRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables = Exact<{ [key: string]: never }>

export type LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryQuery = {
  readonly __typename?: 'Query'
  readonly localAplicacaoRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQueryVariables = Exact<{ [key: string]: never }>

export type ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryQuery = {
  readonly __typename?: 'Query'
  readonly viaAdministracaoRelatorioGerencialVacinacao?: ReadonlyArray<string> | null
}

export type CboCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: CbosCuidadoCompartilhadoQueryInput
}>

export type CboCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cbosVinculacoesServico: {
    readonly __typename?: 'CbosCuidadoCompartilhadoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CbosCuidadoCompartilhadoDto'
      readonly isVinculado?: boolean | null
      readonly isCuidado?: boolean | null
      readonly isGuia?: boolean | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CboSelectFieldQueryVariables = Exact<{
  input: CbosQueryInput
}>

export type CboSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cbos: {
    readonly __typename?: 'CbosQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CboMunicipio'
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CiapCid10SelectFieldQueryVariables = Exact<{
  inputCiap: CiapQueryInput
  inputCid10: Cid10QueryInput
}>

export type CiapCid10SelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly ciaps: {
    readonly __typename?: 'CiapQueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
  readonly cids: {
    readonly __typename?: 'Cid10QueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AntecedenteCiapSelectFieldQueryVariables = Exact<{
  input: CiapQueryInput
}>

export type AntecedenteCiapSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly ciaps: {
    readonly __typename?: 'CiapQueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CiapSelectFieldQueryVariables = Exact<{
  input: CiapQueryInput
  fetchCID10Encaminhamento: Scalars['Boolean']['input']
}>

export type CiapSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly ciaps: {
    readonly __typename?: 'CiapQueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
      readonly inclui?: string | null
      readonly exclui?: string | null
      readonly cid10Encaminhamento?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
      } | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type Cid11SelectFieldQueryVariables = Exact<{
  input: Cid11QueryInput
}>

export type Cid11SelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cids11: {
    readonly __typename?: 'Cid11QueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cid11'
      readonly id: string
      readonly codigo: string
      readonly nome: string
      readonly ativo: boolean
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CidSelectFieldQueryVariables = Exact<{
  input: Cid10QueryInput
  fetchCiapsRelacionadas: Scalars['Boolean']['input']
}>

export type CidSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cids: {
    readonly __typename?: 'Cid10QueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
      readonly ativo?: boolean | null
      readonly ciapsRelacionadas?: ReadonlyArray<{ readonly __typename?: 'Ciap'; readonly id: string } | null> | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CidadaoAtendimentoPorCpfSelectFieldQueryVariables = Exact<{
  input: CidadaosComboQueryInput
}>

export type CidadaoAtendimentoPorCpfSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosComboByCpf: ReadonlyArray<{
    readonly __typename?: 'CidadaoBasico'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly nomeTradicional?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly presenteListaAtendimento?: boolean | null
  } | null>
}

export type CidadaoAtendimentoPorDataNascimentoSelectFieldQueryVariables = Exact<{
  input: CidadaosComboQueryInput
}>

export type CidadaoAtendimentoPorDataNascimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosComboByDataNascimento: ReadonlyArray<{
    readonly __typename?: 'CidadaoBasico'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly nomeTradicional?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly presenteListaAtendimento?: boolean | null
  } | null>
}

export type CidadaoAtendimentoPorNomeSelectFieldQueryVariables = Exact<{
  input: CidadaosComboQueryInput
}>

export type CidadaoAtendimentoPorNomeSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosComboByNome: ReadonlyArray<{
    readonly __typename?: 'CidadaoBasico'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly nomeTradicional?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly presenteListaAtendimento?: boolean | null
  } | null>
}

export type CidadaoAtendimentoSelectFieldQueryVariables = Exact<{
  input: CidadaosComboQueryInput
  emAtencaoDomiciliar: Scalars['Boolean']['input']
  equipeResponsavelId?: InputMaybe<Scalars['ID']['input']>
  retrieveContato: Scalars['Boolean']['input']
}>

export type CidadaoAtendimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosCombo: ReadonlyArray<{
    readonly __typename?: 'CidadaoBasico'
    readonly isCidadaoAusente?: boolean | null
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly nomeTradicional?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly presenteListaAtendimento?: boolean | null
    readonly contato?: {
      readonly __typename?: 'ContatoCidadao'
      readonly id: string
      readonly telefoneCelular?: string | null
      readonly email?: string | null
    } | null
  } | null>
}

export type CidadaoSelectFieldQueryVariables = Exact<{
  input: CidadaosQueryInput
}>

export type CidadaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaos: {
    readonly __typename?: 'CidadaosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly nomeTradicional?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nomeMae?: string | null
      readonly dataNascimento?: any | null
      readonly sexo: SexoEnum
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly dataObito?: any | null
      readonly unificado?: boolean | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ConselhoClasseSelectQueryVariables = Exact<{
  input: ConselhoClasseQueryInput
}>

export type ConselhoClasseSelectQuery = {
  readonly __typename?: 'Query'
  readonly conselhosClasse: {
    readonly __typename?: 'ConselhoClassePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ConselhoClasse'
      readonly id: string
      readonly descricao?: string | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type DoseImunobiologicoVacinacaoSelectFieldQueryVariables = Exact<{
  input: DoseImunobiologicoVacinacaoQueryInput
}>

export type DoseImunobiologicoVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly doseImunobiologicoVacinacao: {
    readonly __typename?: 'DoseImunobiologicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'DoseImunobiologico'
      readonly id: string
      readonly sigla: string
      readonly nome: string
      readonly nomeApresentacaoDose: string
      readonly ordem: number
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type DseiSelectFieldQueryVariables = Exact<{
  input: DseiInput
}>

export type DseiSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly dseis: {
    readonly __typename?: 'DseiQueryPayload'
    readonly content: ReadonlyArray<{ readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type EquipeAdSelectFieldQueryVariables = Exact<{
  input: EquipesAdQueryInput
}>

export type EquipeAdSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly equipesAD: {
    readonly __typename?: 'EquipePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type EquipeSelectFieldQueryVariables = Exact<{
  input: EquipesQueryInput
}>

export type EquipeSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly equipes: {
    readonly __typename?: 'EquipePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly ativo?: boolean | null
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type EspecialidadeSisregSelectFieldQueryVariables = Exact<{
  input: EspecialidadeSisregQueryInput
}>

export type EspecialidadeSisregSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly especialidadesSisreg: {
    readonly __typename?: 'EspecialidadeSisregQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'EspecialidadeSisreg'
      readonly id: string
      readonly descricao: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type EspecialidadesEsusRegSelectFieldQueryVariables = Exact<{
  input: EspecialidadesEsusQueryInput
}>

export type EspecialidadesEsusRegSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly especialidadesEsusReg: {
    readonly __typename?: 'EspecialidadesEsusRegQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'EspecialidadesEsusRegDto'
      readonly id: string
      readonly nome: string
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type EstrategiaVacinacaoSelectFieldQueryVariables = Exact<{
  input: EstrategiasVacinacaoQueryInput
}>

export type EstrategiaVacinacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly estrategiasVacinacao: ReadonlyArray<{
    readonly __typename?: 'EstrategiaVacinacao'
    readonly id: string
    readonly codigo: string
    readonly nome: string
    readonly estrategiaVacinacaoDbEnum: EstrategiaVacinacaoEnum
  }>
}

export type EtniaSelectFieldQueryVariables = Exact<{
  input: EtniaQueryInput
}>

export type EtniaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly etnias: {
    readonly __typename?: 'EtniaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Etnia'
      readonly id: string
      readonly nome: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables = Exact<{
  input: FichaNotificacaoQueryInput
}>

export type FichaNotificacaoCasoSuspeitoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly fichasNotificacao: {
    readonly __typename?: 'FichaNotificacaoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FichaNotificacaoCasoSuspeito'
      readonly id: string
      readonly nomeNotificacao: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type FormaFarmaceuticaSelectFieldQueryVariables = Exact<{
  input: FormaFarmaceuticaQueryInput
}>

export type FormaFarmaceuticaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly formasFarmaceuticas: {
    readonly __typename?: 'FormaFarmaceuticaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FormaFarmaceutica'
      readonly id: string
      readonly nome: string
    } | null>
  }
}

export type FuncaoSocialSelectFieldQueryVariables = Exact<{
  input: FuncaoSocialQueryInput
}>

export type FuncaoSocialSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly funcoesSociais: {
    readonly __typename?: 'FuncaoSocialPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FuncaoSocial'
      readonly id: string
      readonly nome: string
    }>
  }
}

export type GrupoAtendimentoSelectFieldQueryVariables = Exact<{
  inputQuery?: InputMaybe<Scalars['String']['input']>
  onlyAtivos?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GrupoAtendimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly gruposAtendimento: ReadonlyArray<{
    readonly __typename?: 'GrupoAtendimento'
    readonly id: string
    readonly nome: string
  }>
}

export type GrupoCondicaoSelectFieldQueryVariables = Exact<{
  inputGrupo: GrupoCondicaoQueryInput
}>

export type GrupoCondicaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly grupos: {
    readonly __typename?: 'GrupoCondicaoQueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'GrupoCondicao'
      readonly id: string
      readonly grupo: GrupoCondicaoEnum
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null> | null
      readonly cids?: ReadonlyArray<{
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null> | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HorarioAgendaSelectFieldQueryVariables = Exact<{
  input: HorariosAgendaQueryInput
}>

export type HorarioAgendaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly horariosAgenda: ReadonlyArray<{
    readonly __typename?: 'HorarioAgenda'
    readonly horario: any
    readonly duracao: number
    readonly isOcupado: boolean
    readonly isReservadoAgendaOnline: boolean
  }>
}

export type InepSelectFieldQueryVariables = Exact<{
  input: InepQueryInput
}>

export type InepSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly ineps: {
    readonly __typename?: 'InepPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Inep'
      readonly id: string
      readonly dsInep: string
      readonly nomeEstabelecimento: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type LocalAplicacaoSelectFieldQueryVariables = Exact<{
  input: LocalAplicacaoQueryInput
}>

export type LocalAplicacaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly locaisAplicacao: ReadonlyArray<{
    readonly __typename?: 'LocalAplicacao'
    readonly id: string
    readonly nome: string
  }>
}

export type LocalAtendimentoSelectFieldQueryVariables = Exact<{
  filtro: LocalAtendimentoQueryInput
}>

export type LocalAtendimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly localAtendimento: {
    readonly __typename?: 'LocalAtendimentoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'LocalAtendimento'
      readonly id: string
      readonly localAtendimentoExibicao?: string | null
    }>
  }
}

export type LocalOcorrenciaSelectFieldQueryVariables = Exact<{
  input: LocalOcorrenciaQueryInput
}>

export type LocalOcorrenciaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly locaisOcorrencia: {
    readonly __typename?: 'LocalOcorrenciaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'LocalOcorrencia'
      readonly id: string
      readonly nome: string
    }>
  }
}

export type LogradouroSelectFieldQueryVariables = Exact<{
  input: LogradouroInput
}>

export type LogradouroSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly logradouros: {
    readonly __typename?: 'LogradouroQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Logradouro'
      readonly id: string
      readonly nome: string
      readonly nomeExibicao: string
      readonly cep: string
      readonly tituloPatente?: {
        readonly __typename?: 'TituloPatente'
        readonly id: string
        readonly nome: string
      } | null
      readonly bairro: {
        readonly __typename?: 'Bairro'
        readonly id: string
        readonly nome: string
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
        }
      }
      readonly tipoLogradouro: { readonly __typename?: 'TipoLogradouro'; readonly id: string; readonly nome: string }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HasAgendaFixadaQueryVariables = Exact<{ [key: string]: never }>

export type HasAgendaFixadaQuery = { readonly __typename?: 'Query'; readonly hasAgendaFixada: boolean }

export type IsAgendaFixadaQueryVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
}>

export type IsAgendaFixadaQuery = { readonly __typename?: 'Query'; readonly isAgendaFixada: boolean }

export type LotacaoAgendaSelectFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly ativo: boolean
  readonly importada: boolean
  readonly hasConfiguracaoAgenda?: boolean | null
  readonly hasConfiguracaoAgendaOnline?: boolean | null
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf: string
    readonly email?: string | null
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly tipoEquipe: { readonly __typename?: 'TipoEquipe'; readonly id: string; readonly descricao?: string | null }
  } | null
}

export type LotacaoAgendaSelectQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type LotacaoAgendaSelectQuery = {
  readonly __typename?: 'Query'
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly ativo: boolean
    readonly importada: boolean
    readonly hasConfiguracaoAgenda?: boolean | null
    readonly hasConfiguracaoAgendaOnline?: boolean | null
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf: string
      readonly email?: string | null
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly descricao?: string | null
      }
    } | null
  }
}

export type LotacoesAgendaSelectQueryVariables = Exact<{
  input: LotacoesAgendaInput
  inputAgendaFixada: LotacoesAgendaFixadaInput
  apenasFixadas: Scalars['Boolean']['input']
  semFixadas: Scalars['Boolean']['input']
}>

export type LotacoesAgendaSelectQuery = {
  readonly __typename?: 'Query'
  readonly lotacoesAgenda?: {
    readonly __typename?: 'LotacaoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly importada: boolean
      readonly hasConfiguracaoAgenda?: boolean | null
      readonly hasConfiguracaoAgendaOnline?: boolean | null
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
        readonly email?: string | null
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly descricao?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  } | null
  readonly lotacoesFixadasAgenda?: ReadonlyArray<{
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly ativo: boolean
    readonly importada: boolean
    readonly hasConfiguracaoAgenda?: boolean | null
    readonly hasConfiguracaoAgendaOnline?: boolean | null
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf: string
      readonly email?: string | null
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly descricao?: string | null
      }
    } | null
  }>
}

export type LotacaoAndEstagioSelectFieldQueryVariables = Exact<{
  input: LotacoesAndEstagiosInput
}>

export type LotacaoAndEstagioSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly lotacoesAndEstagios: ReadonlyArray<
    | { readonly __typename?: 'AdministradorGeral'; readonly id: string }
    | { readonly __typename?: 'AdministradorMunicipal'; readonly id: string }
    | {
        readonly __typename?: 'Estagio'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly cpf: string
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
        } | null
        readonly lotacaoSupervisora: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeSocial?: string | null
            readonly cpf: string
          }
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
          readonly actions?: {
            readonly __typename?: 'CboActions'
            readonly cadastroDomiciliar: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly cadastroIndividual: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly atividadeColetiva: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          } | null
        }
      }
    | { readonly __typename?: 'GestorEstadual'; readonly id: string }
    | { readonly __typename?: 'GestorMunicipal'; readonly id: string }
    | {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly cpf: string
          readonly email?: string | null
          readonly cns?: string | null
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
          readonly isAD: boolean
        } | null
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
          readonly actions?: {
            readonly __typename?: 'CboActions'
            readonly cadastroDomiciliar: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly cadastroIndividual: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly atividadeColetiva: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          } | null
        }
      }
  >
}

export type LotacoesComRegulacoesSelectFieldQueryVariables = Exact<{
  input: LotacoesComRegulacoesQueryInput
}>

export type LotacoesComRegulacoesSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly lotacoesComRegulacoes: ReadonlyArray<{
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly ativo: boolean
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly cpf: string
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
    } | null
  }>
}

export type LoteImunobiologicoSelectFieldQueryVariables = Exact<{
  input: LoteImunobiologicoQueryInput
}>

export type LoteImunobiologicoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly lotesImunobiologico: {
    readonly __typename?: 'LotesImunobiologicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'LoteImunobiologico'
      readonly id: string
      readonly lote?: string | null
      readonly validade?: any | null
      readonly fabricante?: {
        readonly __typename?: 'ImunobiologicoFabricante'
        readonly id: string
        readonly nome: string
      } | null
    } | null>
  }
}

export type ManifestacaoAlergiaSelectFieldQueryVariables = Exact<{
  filtro: ManifestacoesAlergiaQueryInput
}>

export type ManifestacaoAlergiaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly manifestacoesAlergia: {
    readonly __typename?: 'ManifestacaoAlergiaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ManifestacaoAlergia'
      readonly id: string
      readonly nome: string
      readonly sinonimo?: string | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type MedicamentoCatmatSelectFieldQueryVariables = Exact<{
  input: MedicamentoCatmatQueryInput
}>

export type MedicamentoCatmatSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly medicamentosCatmat: {
    readonly __typename?: 'MedicamentoCatmatQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'MedicamentoCatmat'
      readonly id: string
      readonly volume?: string | null
      readonly codigoCatMat?: string | null
      readonly codigoObm?: string | null
      readonly codigoRename?: string | null
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly unidadeFornecimento?: string | null
        readonly concentracao?: string | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly unidadeFornecimento: {
        readonly __typename?: 'UnidadeMedida'
        readonly id: string
        readonly nome: string
        readonly nomePlural: string
      }
      readonly principioAtivo: {
        readonly __typename?: 'PrincipioAtivo'
        readonly id: string
        readonly nome: string
        readonly listaMaterial: {
          readonly __typename?: 'ListaMedicamento'
          readonly id: string
          readonly tipo: string
          readonly tipoReceita: TipoReceitaEnum
        }
      }
      readonly unidadeMedidaDose?: {
        readonly __typename?: 'UnidadeMedida'
        readonly id: string
        readonly nome: string
        readonly nomePlural: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type MedicamentosQueryVariables = Exact<{
  input: MedicamentoQueryInput
}>

export type MedicamentosQuery = {
  readonly __typename?: 'Query'
  readonly medicamentos: {
    readonly __typename?: 'MedicamentoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Medicamento'
      readonly id: string
      readonly principioAtivo: string
      readonly concentracao?: string | null
      readonly unidadeFornecimento?: string | null
      readonly formaFarmaceutica?: {
        readonly __typename?: 'FormaFarmaceutica'
        readonly id: string
        readonly nome: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type MicroareaImovelSelectFieldQueryVariables = Exact<{
  input: TerritorioEquipeQueryInput
}>

export type MicroareaImovelSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly microareasImoveis: ReadonlyArray<string>
}

export type MicroareasSelectFieldQueryVariables = Exact<{
  equipeResponsavelId?: InputMaybe<Scalars['ID']['input']>
}>

export type MicroareasSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly microareas: ReadonlyArray<string | null>
}

export type MunicipioSelectFieldQueryVariables = Exact<{
  input: MunicipiosQueryInput
}>

export type MunicipioSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly municipios: {
    readonly __typename?: 'MunicipiosQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly ibge?: string | null
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type PaisSelectFieldQueryVariables = Exact<{
  input: PaisQueryInput
}>

export type PaisSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly paises: {
    readonly __typename?: 'PaisQueryPayload'
    readonly content: ReadonlyArray<{ readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type PerfilSelectFieldQueryVariables = Exact<{
  input: PerfisQueryInput
}>

export type PerfilSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly perfis: {
    readonly __typename?: 'PerfisQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Perfil'
      readonly id: string
      readonly nome: string
      readonly ativo: boolean
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type PoloBaseSelectFieldQueryVariables = Exact<{
  input: PoloBaseInput
}>

export type PoloBaseSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly polosBases: {
    readonly __typename?: 'PoloBaseQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'PoloBase'
      readonly id: string
      readonly nome: string
      readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProblemaCondicaoFragment = {
  readonly __typename?: 'Problema'
  readonly id: string
  readonly situacao: SituacaoProblema
  readonly descricaoOutro?: string | null
  readonly ciap?: {
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  } | null
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly cid11?: {
    readonly __typename?: 'Cid11'
    readonly id: string
    readonly codigo: string
    readonly nome: string
    readonly ativo: boolean
  } | null
  readonly ultimaEvolucao: {
    readonly __typename?: 'EvolucaoProblema'
    readonly id: string
    readonly dataInicio?: any | null
    readonly dataFim?: any | null
    readonly situacao: SituacaoProblema
    readonly observacao?: string | null
    readonly atualizadoEm?: any | null
  }
  readonly evolucaoAvaliacaoCiapCid?: { readonly __typename?: 'EvolucaoAvaliacaoCiapCid'; readonly id: string } | null
}

export type ProcedimentoOdontoSelectFieldQueryVariables = Exact<{
  input: ProcedimentoOdontoQueryInput
}>

export type ProcedimentoOdontoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly procedimentosEvolucaoOdonto: {
    readonly __typename?: 'ProcedimentosQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProcedimentoSelectFieldQueryVariables = Exact<{
  input: ProcedimentoQueryInput
}>

export type ProcedimentoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly procedimentos: {
    readonly __typename?: 'ProcedimentosQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Procedimento'
      readonly idadeMinima?: number | null
      readonly idadeMaxima?: number | null
      readonly idadeAplicavel?: boolean | null
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProfissionaisRelatorioInconsistenciaQueryVariables = Exact<{
  filtro: ProfissionaisRelatorioInconsistenciaQueryInput
}>

export type ProfissionaisRelatorioInconsistenciaQuery = {
  readonly __typename?: 'Query'
  readonly profissionaisRelatorioInconsistencia: {
    readonly __typename?: 'ProfissionaisInconsistenciaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TransmissaoRecebimentoLoteDto'
      readonly responsavel: string
      readonly cpfResponsavel: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProfissionalAdSelectFieldQueryVariables = Exact<{
  inputEquipe: EquipesAdQueryInput
  inputProf: ProfissionaisAdQueryInput
}>

export type ProfissionalAdSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly profissionaisAD: {
    readonly __typename?: 'ProfissionaisQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProfissionalSelectQueryVariables = Exact<{
  input: ProfissionaisQueryInput
}>

export type ProfissionalSelectQuery = {
  readonly __typename?: 'Query'
  readonly profissionais: {
    readonly __typename?: 'ProfissionaisQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf: string
      readonly cns?: string | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ResponsavelFamiliarSelectFieldQueryVariables = Exact<{
  input: CidadaosComboQueryInput
}>

export type ResponsavelFamiliarSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosCombo: ReadonlyArray<{
    readonly __typename?: 'CidadaoBasico'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly uuidUltimaFicha?: string | null
    readonly statusResponsavelFamiliar?: boolean | null
  } | null>
}

export type SubstanciaAlergiaSelectFieldQueryVariables = Exact<{
  filtro: SubstanciasCbaraAlergiaQueryInput
}>

export type SubstanciaAlergiaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly substanciasCbaraAlergia: {
    readonly __typename?: 'SubstanciaCbaraAlergiaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'SubstanciaCbaraAlergia'
      readonly id: string
      readonly categoria: CategoriaSubstanciaAlergia
      readonly nome: string
      readonly sinonimos?: string | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type TipoEventoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TipoEventoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly auditoriaTipoEvento: ReadonlyArray<{
    readonly __typename?: 'AuditoriaTipoEvento'
    readonly id: string
    readonly nome: string
  } | null>
}

export type TipoLogradouroSelectFieldQueryVariables = Exact<{
  input: TipoLogradouroInput
}>

export type TipoLogradouroSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposLogradouro: {
    readonly __typename?: 'TipoLogradouroQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TipoLogradouro'
      readonly id: string
      readonly nome: string
      readonly numeroDne: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type TipoRegistroAfetadoSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TipoRegistroAfetadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly auditoriaTipoRegistroAfetado: ReadonlyArray<{
    readonly __typename?: 'AuditoriaTipoRegistroAfetado'
    readonly id: string
    readonly nome: string
  } | null>
}

export type TipoRegistroSelectFieldQueryVariables = Exact<{
  input: TipoRegistroHistoricoClinicoQueryInput
}>

export type TipoRegistroSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tipoRegistroHistorico?: ReadonlyArray<TipoRegistroHistoricoClinico | null> | null
}

export type TipoServicoSelectFieldQueryVariables = Exact<{
  input: TipoServicoQueryInput
}>

export type TipoServicoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposServico: {
    readonly __typename?: 'TipoServicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TipoServico'
      readonly id: string
      readonly nome: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type TiposOrigemDadoTransporteSelectFieldQueryVariables = Exact<{ [key: string]: never }>

export type TiposOrigemDadoTransporteSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly tiposOrigemDadoTransporte: ReadonlyArray<{
    readonly __typename?: 'TipoOrigemDadoTransporte'
    readonly id: string
    readonly descricao: string
  }>
}

export type UnidadeMedidaSelectFieldQueryVariables = Exact<{
  input: UnidadeMedidaQueryInput
}>

export type UnidadeMedidaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly unidadesMedida: {
    readonly __typename?: 'UnidadeMedidaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'UnidadeMedida'
      readonly id: string
      readonly nome: string
      readonly nomePlural: string
    } | null>
  }
}

export type UnidadesSaudeSelectFieldQueryVariables = Exact<{
  input: UnidadesSaudeQueryInput
}>

export type UnidadesSaudeSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly unidadesSaude: {
    readonly __typename?: 'UnidadeSaudePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
      readonly ativo?: boolean | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ViaAdministracaoSelectFieldQueryVariables = Exact<{
  input: AplicacaoMedicamentoQueryInput
}>

export type ViaAdministracaoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly aplicacoesMedicamento: {
    readonly __typename?: 'AplicacaoMedicamentoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AplicacaoMedicamento'
      readonly id: string
      readonly nome: string
    } | null>
  }
}

export type ViaAdministracaoVacinaSelectFieldQueryVariables = Exact<{
  inputQuery?: InputMaybe<Scalars['String']['input']>
}>

export type ViaAdministracaoVacinaSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly viasAdministracaoVacina: ReadonlyArray<{
    readonly __typename?: 'ViaAdministracao'
    readonly id: string
    readonly nome: string
  }>
}

export type CompartilharVideochamadaMutationVariables = Exact<{
  input: CompartilharVideochamadaInput
}>

export type CompartilharVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly compartilharVideochamada: boolean
}

export type FlagsQueryVariables = Exact<{ [key: string]: never }>

export type FlagsQuery = {
  readonly __typename?: 'Query'
  readonly info: {
    readonly __typename?: 'Info'
    readonly id: string
    readonly flags: ReadonlyArray<{
      readonly __typename?: 'FlagInfo'
      readonly id: string
      readonly nome: string
      readonly valor: boolean
    }>
  }
}

export type AlergiaFragment = {
  readonly __typename?: 'Alergia'
  readonly id: string
  readonly criticidade: CriticidadeAlergia
  readonly tipoReacao?: TipoReacaoAlergia | null
  readonly grauCerteza: GrauCertezaAlergia
  readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
  readonly substanciaEspecificaLegado?: string | null
}

export type CboBasicoFragment = {
  readonly __typename?: 'Cbo'
  readonly id: string
  readonly nome: string
  readonly cbo2002: string
}

export type CidadaoBasicoFragment = {
  readonly __typename?: 'CidadaoBasico'
  readonly id: string
  readonly nome: string
  readonly nomeSocial?: string | null
  readonly nomeTradicional?: string | null
  readonly cpf?: string | null
  readonly cns?: string | null
  readonly nomeMae?: string | null
  readonly dataNascimento?: any | null
  readonly presenteListaAtendimento?: boolean | null
}

export type EncaminhamentoExternoEspecializadoFragment = {
  readonly __typename?: 'EncaminhamentoExternoEspecializado'
  readonly id: string
  readonly motivoEncaminhamento?: string | null
  readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
  readonly complemento?: string | null
  readonly observacoes?: string | null
  readonly especialidadeSisreg: {
    readonly __typename?: 'EspecialidadeSisreg'
    readonly id: string
    readonly descricao: string
  }
  readonly hipoteseDiagnosticoCid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly hipoteseDiagnosticoCiap?: {
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  } | null
  readonly atendimentoProfissional: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly iniciadoEm: any
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string }
    }
  }
}

export type EquipeBasicoFragment = {
  readonly __typename?: 'Equipe'
  readonly id: string
  readonly ine: string
  readonly nome: string
}

export type LotacaoAtendimentoCompartilhadoFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf: string
  }
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly isAD: boolean
  } | null
}

export type LotacaoBasicoFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly ativo: boolean
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf: string
    readonly cns?: string | null
  }
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
  } | null
}

export type MunicipioFragment = {
  readonly __typename?: 'Municipio'
  readonly id: string
  readonly ibge?: string | null
  readonly nome: string
  readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
}

export type PageInfoFragment = {
  readonly __typename?: 'PageInfo'
  readonly number: number
  readonly size: number
  readonly totalPages: number
  readonly totalElements: number
  readonly sort?: ReadonlyArray<string | null> | null
  readonly first: boolean
  readonly last: boolean
  readonly numberOfElements: number
}

export type PoloBaseFragment = {
  readonly __typename?: 'PoloBase'
  readonly id: string
  readonly nome: string
  readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
}

export type ProcedimentoFragment = {
  readonly __typename?: 'Procedimento'
  readonly id: string
  readonly descricao: string
  readonly codigo: string
  readonly ativo?: boolean | null
  readonly procedimentoReferencia?: {
    readonly __typename?: 'Procedimento'
    readonly id: string
    readonly descricao: string
    readonly codigo: string
    readonly ativo?: boolean | null
  } | null
}

export type ProfissionalBasicoFragment = {
  readonly __typename?: 'Profissional'
  readonly id: string
  readonly nome: string
  readonly nomeSocial?: string | null
  readonly cpf: string
  readonly cns?: string | null
}

export type ResultadoExameFragment = {
  readonly __typename?: 'ResultadoExame'
  readonly id: string
  readonly dataResultado?: any | null
  readonly dataRealizacao?: any | null
  readonly dataSolicitacao?: any | null
  readonly conferido?: boolean | null
  readonly observacao?: string | null
  readonly resultado?: string | null
  readonly exame: {
    readonly __typename?: 'Procedimento'
    readonly id: string
    readonly descricao: string
    readonly codigo: string
    readonly ativo?: boolean | null
    readonly procedimentoReferencia?: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
    } | null
  }
  readonly solicitacao?: {
    readonly __typename?: 'SolicitacaoExame'
    readonly id: string
    readonly data: any
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      }
    }
  } | null
  readonly especifico?: {
    readonly __typename?: 'ResultadoExameEspecifico'
    readonly id: string
    readonly exameEspecificoEnum: ExameEspecificoEnum
    readonly valor?: number | null
    readonly igDias?: number | null
    readonly igSemanas?: number | null
    readonly dpp?: any | null
    readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
    readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
  } | null
  readonly atendimentoProfissionalResultado?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    }
  } | null
}

export type SolicitacaoExameFragment = {
  readonly __typename?: 'SolicitacaoExame'
  readonly id: string
  readonly data: any
  readonly tipoExame: TipoExameEnum
  readonly justificativa: string
  readonly observacoes?: string | null
  readonly exames: ReadonlyArray<{
    readonly __typename?: 'ResultadoExame'
    readonly id: string
    readonly conferido?: boolean | null
    readonly observacao?: string | null
    readonly solicitacao?: { readonly __typename?: 'SolicitacaoExame'; readonly id: string; readonly data: any } | null
    readonly exame: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    }
  }>
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
    readonly ciapsRelacionadas?: ReadonlyArray<{ readonly __typename?: 'Ciap'; readonly id: string } | null> | null
  } | null
  readonly atendimentoProfissional: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    }
  }
  readonly solicitacaoCitopatologico?: {
    readonly __typename?: 'SolicitacaoExameCitopatologico'
    readonly id: string
    readonly questoes: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExameCitopatologicoQuestao'
      readonly id: string
      readonly pergunta: RastreioCancerPerguntaDbEnum
      readonly resposta: string
    } | null>
  } | null
}

export type SubstanciaEspecificaAlergiaFragment = {
  readonly __typename?: 'SubstanciaEspecificaAlergia'
  readonly id: string
  readonly coSubstanciaEspecifica: any
  readonly coPrincipioAtivo?: any | null
  readonly categoria: CategoriaSubstanciaAlergia
  readonly nome: string
}

export type UnidadeSaudeBasicoFragment = {
  readonly __typename?: 'UnidadeSaude'
  readonly id: string
  readonly nome?: string | null
  readonly cnes: string
}

export type AsyncProcessingStatusQueryVariables = Exact<{
  asyncProcessingName: AsyncProcessingNameEnum
}>

export type AsyncProcessingStatusQuery = {
  readonly __typename?: 'Query'
  readonly asyncProcessingStatus?: {
    readonly __typename?: 'AsyncProcessingStatus'
    readonly isStarted: boolean
    readonly isFinished: boolean
    readonly errorMessage?: string | null
  } | null
}

export type RemoverProcessoAssincronoMutationVariables = Exact<{
  asyncProcessingName: AsyncProcessingNameEnum
}>

export type RemoverProcessoAssincronoMutation = {
  readonly __typename?: 'Mutation'
  readonly removerProcessoAssincrono: boolean
}

export type RemoverTodosProcessosAssincronosMutationVariables = Exact<{ [key: string]: never }>

export type RemoverTodosProcessosAssincronosMutation = {
  readonly __typename?: 'Mutation'
  readonly removerTodosProcessosAssincronos: boolean
}

export type ConfiguracoesQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracoesQuery = {
  readonly __typename?: 'Query'
  readonly info: {
    readonly __typename?: 'Info'
    readonly id: string
    readonly smtpConfigurado: boolean
    readonly internetHabilitada: boolean
    readonly govBREnabled: boolean
    readonly versao: string
    readonly buscaCidadaoPorPropriedadesEnabled: boolean
    readonly oldPecConnected: boolean
    readonly firebaseEnabled: boolean
    readonly ativado: boolean
    readonly treinamento: boolean
    readonly isPrescricaoDigitalEnabled: boolean
    readonly dataAtivacaoAssinaturaEletronica?: any | null
    readonly rocksdbEnabled: boolean
    readonly tipoInstalacao?: TipoInstalacao | null
    readonly cadastroDomiciliarViaCdsEnabled: boolean
    readonly cadastroIndividualViaCdsEnabled: boolean
    readonly anexoArquivosEnabled: boolean
    readonly frontendLogLevel: FrontendLogLevelEnum
    readonly linkInstalacao?: string | null
    readonly sentry: {
      readonly __typename?: 'SentryConfig'
      readonly id: string
      readonly enabled: boolean
      readonly dsn?: string | null
    }
  }
}

export type LembreteProfissionalByInputQueryVariables = Exact<{
  input: LembreteProfissionalInput
}>

export type LembreteProfissionalByInputQuery = {
  readonly __typename?: 'Query'
  readonly lembreteProfissional: {
    readonly __typename?: 'LembreteProfissional'
    readonly id: string
    readonly visualizado?: boolean | null
    readonly dataExibirNovamente?: any | null
    readonly dataVisualizado?: any | null
    readonly identificadorLembrete: LembreteProfissionalIdentificadorEnum
  }
}

export type MarcarVisualizadoLembreteProfissionalMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type MarcarVisualizadoLembreteProfissionalMutation = {
  readonly __typename?: 'Mutation'
  readonly marcarVisualizadoLembreteProfissional: {
    readonly __typename?: 'LembreteProfissional'
    readonly id: string
    readonly visualizado?: boolean | null
    readonly dataExibirNovamente?: any | null
    readonly dataVisualizado?: any | null
    readonly identificadorLembrete: LembreteProfissionalIdentificadorEnum
  }
}

export type ReagendarLembreteProfissionalMutationVariables = Exact<{
  input: ReagendarLembreteProfissionalInput
}>

export type ReagendarLembreteProfissionalMutation = {
  readonly __typename?: 'Mutation'
  readonly reagendarLembreteProfissional: {
    readonly __typename?: 'LembreteProfissional'
    readonly id: string
    readonly visualizado?: boolean | null
    readonly dataExibirNovamente?: any | null
    readonly dataVisualizado?: any | null
    readonly identificadorLembrete: LembreteProfissionalIdentificadorEnum
  }
}

export type InscricoesTopicosNotificacaoQueryVariables = Exact<{
  input: InscricoesTopicosNotificacaoQueryInput
}>

export type InscricoesTopicosNotificacaoQuery = {
  readonly __typename?: 'Query'
  readonly inscricoesTopicosNotificacao: ReadonlyArray<{
    readonly __typename?: 'TopicoNotificacao'
    readonly id: string
    readonly tipoTopico: TipoTopicoNotificacaoEnum
    readonly codigoTopicoExterno: number
    readonly statusNotificarLido?: boolean | null
    readonly statusNotificarVisto?: boolean | null
    readonly dataUltimaAtualizacao: any
  }>
}

export type DefinirModuloInicialMutationVariables = Exact<{
  input: SelecionarModuloInicialInput
}>

export type DefinirModuloInicialMutation = {
  readonly __typename?: 'Mutation'
  readonly definirModuloInicial:
    | { readonly __typename?: 'AdministradorGeral'; readonly id: string; readonly moduloInicial?: string | null }
    | { readonly __typename?: 'AdministradorMunicipal'; readonly id: string; readonly moduloInicial?: string | null }
    | { readonly __typename?: 'Estagio'; readonly id: string; readonly moduloInicial?: string | null }
    | { readonly __typename?: 'GestorEstadual'; readonly id: string; readonly moduloInicial?: string | null }
    | { readonly __typename?: 'GestorMunicipal'; readonly id: string; readonly moduloInicial?: string | null }
    | { readonly __typename?: 'Lotacao'; readonly id: string; readonly moduloInicial?: string | null }
}

export type AcompanhamentoCidadaosVinculadosQueryVariables = Exact<{
  input: AcompanhamentoCidadaosVinculadosFilterInput
}>

export type AcompanhamentoCidadaosVinculadosQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCidadaosVinculados: {
    readonly __typename?: 'AcompanhamentoCidadaosVinculadosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCidadaosVinculados'
      readonly id: string
      readonly nomeCidadao: string
      readonly dataNascimentoCidadao?: any | null
      readonly sexoIdentidadeGeneroCidadao: string
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly dataUltimaAtualizacaoCidadao?: any | null
      readonly telefoneResidencial?: string | null
      readonly idade: string
      readonly endereco: string
      readonly equipe: string
      readonly microarea: string
      readonly origem: string
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AcompanhamentoCidadaosVinculadosProcessamentoQueryVariables = Exact<{ [key: string]: never }>

export type AcompanhamentoCidadaosVinculadosProcessamentoQuery = {
  readonly __typename?: 'Query'
  readonly processamentoStatus?: ProcessamentoStatusEnum | null
}

export type AuditCancelarBuscaCidadaoListagemMutationVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type AuditCancelarBuscaCidadaoListagemMutation = {
  readonly __typename?: 'Mutation'
  readonly auditCancelarAcompanhamentoCondicaoSaude: boolean
}

export type BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemDesenvolvimentoInfantilQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly desenvolvimentoInfantil?: {
            readonly __typename?: 'DesenvolvimentoInfantilConsolidado'
            readonly qtdMedicoesPesoAltura?: any | null
            readonly visitasDomiciliares?: {
              readonly __typename?: 'VisitasDomiciliaresDesenvolvimentoInfantil'
              readonly dataPrimeiraVisita?: any | null
              readonly dataSegundaVisita?: any | null
              readonly qtdVisitasDomiciliares?: any | null
            } | null
            readonly consultas?: {
              readonly __typename?: 'ConsultasDesenvolvimentoInfantil'
              readonly qtdConsultas?: any | null
              readonly dataPrimeiraConsulta?: any | null
            } | null
            readonly vacinasAplicadas: ReadonlyArray<{
              readonly __typename?: 'FatoVacinacaoVacina'
              readonly dataRegistroVacinaAplicada: any
              readonly dimensaoImunobiologico: {
                readonly __typename?: 'DimensaoImunobiologico'
                readonly id: string
                readonly nome: string
                readonly sigla: string
                readonly grupo: ReadonlyArray<GrupoImunobiologicoEnum>
              }
              readonly dimensaoDoseImunobiologico: {
                readonly __typename?: 'DimensaoDoseImunobiologico'
                readonly id: string
                readonly sigla: string
                readonly ordem: number
              }
            }>
            readonly suplementacaoVitaminaA: {
              readonly __typename?: 'SuplementacaoVitaminaADesenvolvimentoInfantil'
              readonly dataUltimaSuplementacao?: any | null
              readonly dosesDe6a11Meses: any
              readonly dosesDe12a23Meses: any
              readonly dosesDe24a59Meses: any
            }
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemDiabetesQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemDiabetesQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly prontuario?: {
          readonly __typename?: 'Prontuario'
          readonly id: string
          readonly problemas: ReadonlyArray<{
            readonly __typename?: 'Problema'
            readonly id: string
            readonly ultimaEvolucao: {
              readonly __typename?: 'EvolucaoProblema'
              readonly id: string
              readonly situacao: SituacaoProblema
            }
            readonly ciap?: {
              readonly __typename?: 'Ciap'
              readonly id: string
              readonly gruposCondicao?: ReadonlyArray<{
                readonly __typename?: 'GrupoCondicao'
                readonly id: string
                readonly grupo: GrupoCondicaoEnum
              }> | null
            } | null
            readonly cid10?: {
              readonly __typename?: 'Cid10'
              readonly id: string
              readonly gruposCondicao?: ReadonlyArray<{
                readonly __typename?: 'GrupoCondicao'
                readonly id: string
                readonly grupo: GrupoCondicaoEnum
              }> | null
            } | null
          }>
        } | null
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly diabetes?: {
            readonly __typename?: 'DiabetesConsolidado'
            readonly dataUltimaConsulta?: any | null
            readonly qtdConsultas?: any | null
            readonly visitaDomiciliar?: {
              readonly __typename?: 'VisitaDomiciliarConsolidado'
              readonly dataUltimasVisitasDomiciliares?: ReadonlyArray<any | null> | null
              readonly qtdVisitasDomiciliares?: any | null
            } | null
            readonly exames?: {
              readonly __typename?: 'ExamesDiabeteConsolidado'
              readonly dataUltimaSolicitacaoHemoglobinaGlicada?: any | null
              readonly dataAvaliacaoPes?: any | null
              readonly hemoglobinaGlicada?: {
                readonly __typename?: 'ExameBasicoConsolidado'
                readonly valor?: string | null
                readonly dataRealizacao?: any | null
              } | null
            } | null
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemGeralQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemGeralQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemGestantePuerperaQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemGestantePuerperaQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly preNatalPuerperio?: {
            readonly __typename?: 'PreNatalPuerperioConsolidado'
            readonly altoRiscoGestacional?: boolean | null
            readonly idadeGestacionalEcograficaEmDias?: any | null
            readonly idadeGestacionalCronologicaEmDias?: any | null
            readonly ultimaDum?: any | null
            readonly dppCronologica?: any | null
            readonly dppEcografica?: any | null
            readonly fonteIdadeGestacional?: FonteIdadeGestacionalEnum | null
            readonly medicoesPreNatal?: {
              readonly __typename?: 'MedicoesPreNatalConsolidado'
              readonly qtdMedicoesPressaoArterial?: any | null
              readonly qtdMedicoesPesoAltura?: any | null
              readonly qtdMedicoesAlturaUterina?: any | null
            } | null
            readonly atendimentosPreNatalPuerperio?: {
              readonly __typename?: 'AtendimentosPreNatalPuerperioConsolidado'
              readonly consultasPrimeirasDozeSemanas?: any | null
              readonly consultasPreNatalGestacao?: any | null
              readonly consultasOdontologicasGestacao?: any | null
              readonly consultasPuerperio?: any | null
              readonly dataUltimaConsultaPreNatal?: any | null
              readonly dataUltimaConsultaPuerperio?: any | null
            } | null
            readonly examesRealizadosPreNatal?: {
              readonly __typename?: 'ExamesRealizadosPreNatalConsolidado'
              readonly sifilisPrimeiroTrimestre?: ExameRealizadoPreNatalConsolidadoStatusEnum | null
              readonly sifilisTerceiroTrimestre?: ExameRealizadoPreNatalConsolidadoStatusEnum | null
              readonly hivPrimeiroTrimestre?: ExameRealizadoPreNatalConsolidadoStatusEnum | null
              readonly hivTerceiroTrimestre?: ExameRealizadoPreNatalConsolidadoStatusEnum | null
              readonly hepatiteBPrimeiroTrimestre?: ExameRealizadoPreNatalConsolidadoStatusEnum | null
              readonly hepatiteCPrimeiroTrimestre?: ExameRealizadoPreNatalConsolidadoStatusEnum | null
            } | null
            readonly visitasDomiciliares?: {
              readonly __typename?: 'VisitasDomiciliaresPreNatalPuerperioConsolidado'
              readonly visitasDomiciliaresPreNatal?: any | null
              readonly visitasDomiciliaresPuerperio?: any | null
            } | null
            readonly vacinasAplicadas: ReadonlyArray<{
              readonly __typename?: 'FatoVacinacaoVacina'
              readonly dataRegistroVacinaAplicada: any
              readonly dimensaoImunobiologico: {
                readonly __typename?: 'DimensaoImunobiologico'
                readonly id: string
                readonly nome: string
                readonly sigla: string
                readonly grupo: ReadonlyArray<GrupoImunobiologicoEnum>
              }
              readonly dimensaoDoseImunobiologico: {
                readonly __typename?: 'DimensaoDoseImunobiologico'
                readonly id: string
                readonly sigla: string
                readonly ordem: number
              }
            }>
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemHipertensaoQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemHipertensaoQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly prontuario?: {
          readonly __typename?: 'Prontuario'
          readonly id: string
          readonly problemas: ReadonlyArray<{
            readonly __typename?: 'Problema'
            readonly id: string
            readonly ultimaEvolucao: {
              readonly __typename?: 'EvolucaoProblema'
              readonly id: string
              readonly situacao: SituacaoProblema
            }
            readonly ciap?: {
              readonly __typename?: 'Ciap'
              readonly id: string
              readonly gruposCondicao?: ReadonlyArray<{
                readonly __typename?: 'GrupoCondicao'
                readonly id: string
                readonly grupo: GrupoCondicaoEnum
              }> | null
            } | null
            readonly cid10?: {
              readonly __typename?: 'Cid10'
              readonly id: string
              readonly gruposCondicao?: ReadonlyArray<{
                readonly __typename?: 'GrupoCondicao'
                readonly id: string
                readonly grupo: GrupoCondicaoEnum
              }> | null
            } | null
          }>
        } | null
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly hipertensao?: {
            readonly __typename?: 'HipertensaoConsolidado'
            readonly qtdPressaoArterial?: any | null
            readonly qtdConsulta?: any | null
            readonly dataUltimaConsulta?: any | null
            readonly visitaDomiciliar?: {
              readonly __typename?: 'VisitaDomiciliarConsolidado'
              readonly dataUltimasVisitasDomiciliares?: ReadonlyArray<any | null> | null
              readonly qtdVisitasDomiciliares?: any | null
            } | null
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemPessoaIdosaQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemPessoaIdosaQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly ivcf?: {
        readonly __typename?: 'AcompanhamentoCondicaoSaudeIvcfDto'
        readonly riscoVulnerabilidade?: RiscoVulnerabilidadeIvcfEnum | null
        readonly dataResultado?: any | null
        readonly subgrupo?: ReadonlyArray<IvcfSubgrupoPerguntaEnum | null> | null
      } | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly pessoaIdosa?: {
            readonly __typename?: 'PessoaIdosaConsolidado'
            readonly quantidadeMedicoesSimultaneasPesoAltura?: any | null
            readonly visitaDomiciliar?: {
              readonly __typename?: 'VisitaDomiciliarConsolidado'
              readonly dataUltimasVisitasDomiciliares?: ReadonlyArray<any | null> | null
              readonly qtdVisitasDomiciliares?: any | null
            } | null
            readonly vacinasAplicadas: ReadonlyArray<{
              readonly __typename?: 'FatoVacinacaoVacina'
              readonly dataRegistroVacinaAplicada: any
              readonly dimensaoImunobiologico: {
                readonly __typename?: 'DimensaoImunobiologico'
                readonly id: string
                readonly nome: string
                readonly sigla: string
                readonly grupo: ReadonlyArray<GrupoImunobiologicoEnum>
              }
              readonly dimensaoDoseImunobiologico: {
                readonly __typename?: 'DimensaoDoseImunobiologico'
                readonly id: string
                readonly sigla: string
                readonly ordem: number
              }
            }>
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemProblemasFragment = {
  readonly __typename?: 'Prontuario'
  readonly id: string
  readonly problemas: ReadonlyArray<{
    readonly __typename?: 'Problema'
    readonly id: string
    readonly ultimaEvolucao: {
      readonly __typename?: 'EvolucaoProblema'
      readonly id: string
      readonly situacao: SituacaoProblema
    }
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly gruposCondicao?: ReadonlyArray<{
        readonly __typename?: 'GrupoCondicao'
        readonly id: string
        readonly grupo: GrupoCondicaoEnum
      }> | null
    } | null
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly gruposCondicao?: ReadonlyArray<{
        readonly __typename?: 'GrupoCondicao'
        readonly id: string
        readonly grupo: GrupoCondicaoEnum
      }> | null
    } | null
  }>
}

export type BuscaCidadaoListagemSaudeBucalQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemSaudeBucalQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly saudeBucal?: {
            readonly __typename?: 'SaudeBucalConsolidado'
            readonly cidadaoId: string
            readonly escovacaoSupervisionadaEmAc?: any | null
            readonly procedimentoPreventivos?: any | null
            readonly exodontiasDentesRealizadas?: any | null
            readonly ultimoAtendimentoPrimeiraConsultaProgramada?: {
              readonly __typename?: 'AtendimentoProfissional'
              readonly id: string
              readonly iniciadoEm: any
            } | null
            readonly ultimoAtendimentoTratamentoConcluido?: {
              readonly __typename?: 'AtendimentoProfissionalOdonto'
              readonly id: string
              readonly atendimentoProfissional: {
                readonly __typename?: 'AtendimentoProfissional'
                readonly id: string
                readonly iniciadoEm: any
              }
            } | null
            readonly ultimoTratamentoRestauradorAtraumatico?: {
              readonly __typename?: 'AtendimentoProfissionalOdonto'
              readonly id: string
              readonly atendimentoProfissional: {
                readonly __typename?: 'AtendimentoProfissional'
                readonly id: string
                readonly iniciadoEm: any
              }
            } | null
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type BuscaCidadaoListagemTematicaSaudeMulherQueryVariables = Exact<{
  input: AcompanhamentoCondicaoSaudeQueryInput
}>

export type BuscaCidadaoListagemTematicaSaudeMulherQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoCondicaoSaude: {
    readonly __typename?: 'AcompanhamentoCondicaoSaudeQueryPayload'
    readonly cidsConsiderados?: ReadonlyArray<string> | null
    readonly ciapsConsiderados?: ReadonlyArray<string> | null
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoCondicaoSaudeDto'
      readonly cidadaoId: string
      readonly dataNascimentoCidadao?: any | null
      readonly nomeCidadao?: string | null
      readonly nomeSocialCidadao?: string | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly microarea?: string | null
      readonly ultimaMedicaoPressaoArterial?: string | null
      readonly dataUltimoAtendimentoMedico?: any | null
      readonly dataUltimoAtendimentoEnfermagem?: any | null
      readonly dataUltimaVisitaDomiciliar?: any | null
      readonly dataUltimoAtendimentoOdontologico?: any | null
      readonly ultimaMedicaoPeso?: string | null
      readonly ultimaMedicaoAltura?: string | null
      readonly dataUltimaMedicaoPesoAltura?: any | null
      readonly dataUltimaMedicaoPressaoArterial?: any | null
      readonly sexoCidadao?: SexoEnum | null
      readonly identidadeGeneroCidadao?: IdentidadeGeneroEnum | null
      readonly racaCorCidadao?: string | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly cidadaoConsolidado?: {
          readonly __typename?: 'CidadaoConsolidado'
          readonly saudeMulher?: {
            readonly __typename?: 'SaudeMulherConsolidado'
            readonly cidadaoId: string
            readonly hiv?: any | null
            readonly sifilis?: any | null
            readonly hepatiteB?: any | null
            readonly hepatiteC?: any | null
            readonly ultimaConsulta?: {
              readonly __typename?: 'AtendimentoProfissional'
              readonly id: string
              readonly iniciadoEm: any
            } | null
            readonly ultimaAvaliacaoCancerMama?: {
              readonly __typename?: 'ResultadoExameConsolidado'
              readonly exameId: string
              readonly dataAvaliacao?: any | null
            } | null
            readonly ultimaRealizacaoCancerMama?: {
              readonly __typename?: 'ResultadoExameConsolidado'
              readonly exameId: string
              readonly exameRequisitado?: {
                readonly __typename?: 'ResultadoExame'
                readonly id: string
                readonly dataRealizacao?: any | null
              } | null
            } | null
            readonly ultimaSolicitacaoCancerMama?: {
              readonly __typename?: 'ResultadoExameConsolidado'
              readonly exameId: string
              readonly exameRequisitado?: {
                readonly __typename?: 'ResultadoExame'
                readonly id: string
                readonly dataSolicitacao?: any | null
              } | null
            } | null
            readonly ultimaAvaliacaoCancerColoUtero?: {
              readonly __typename?: 'ResultadoExameConsolidado'
              readonly exameId: string
              readonly dataAvaliacao?: any | null
              readonly exameRequisitado?: {
                readonly __typename?: 'ResultadoExame'
                readonly id: string
                readonly dataResultado?: any | null
                readonly exame: {
                  readonly __typename?: 'Procedimento'
                  readonly id: string
                  readonly descricao: string
                }
              } | null
            } | null
            readonly ultimaSolicitacaoCancerColoUtero?: {
              readonly __typename?: 'ResultadoExameConsolidado'
              readonly exameId: string
              readonly exameRequisitado?: {
                readonly __typename?: 'ResultadoExame'
                readonly id: string
                readonly dataSolicitacao?: any | null
                readonly exame: {
                  readonly __typename?: 'Procedimento'
                  readonly id: string
                  readonly descricao: string
                }
              } | null
            } | null
            readonly vacinasAplicadas: ReadonlyArray<{
              readonly __typename?: 'FatoVacinacaoVacina'
              readonly dataRegistroVacinaAplicada: any
              readonly dimensaoImunobiologico: {
                readonly __typename?: 'DimensaoImunobiologico'
                readonly id: string
                readonly nome: string
                readonly sigla: string
                readonly grupo: ReadonlyArray<GrupoImunobiologicoEnum>
              }
              readonly dimensaoDoseImunobiologico: {
                readonly __typename?: 'DimensaoDoseImunobiologico'
                readonly id: string
                readonly sigla: string
                readonly ordem: number
              }
            }>
          } | null
        } | null
        readonly beneficiarioBolsaFamilia: {
          readonly __typename?: 'BeneficiarioBolsaFamilia'
          readonly id: string
          readonly isBeneficiario: boolean
          readonly vigencia?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type VacinaAplicadaCidadaoConsolidadoFragment = {
  readonly __typename?: 'FatoVacinacaoVacina'
  readonly dataRegistroVacinaAplicada: any
  readonly dimensaoImunobiologico: {
    readonly __typename?: 'DimensaoImunobiologico'
    readonly id: string
    readonly nome: string
    readonly sigla: string
    readonly grupo: ReadonlyArray<GrupoImunobiologicoEnum>
  }
  readonly dimensaoDoseImunobiologico: {
    readonly __typename?: 'DimensaoDoseImunobiologico'
    readonly id: string
    readonly sigla: string
    readonly ordem: number
  }
}

export type SalvarApoioEmapEmadMutationVariables = Exact<{
  input: ConfigAtendimentoDomInput
}>

export type SalvarApoioEmapEmadMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarConfigAtendimentoDomTipoApoio: {
    readonly __typename?: 'ConfiguracoesAtendimentosDomiciliares'
    readonly id: string
  }
}

export type SalvarPodeAtenderEmadMutationVariables = Exact<{
  input: ConfigAtendimentoDomInput
}>

export type SalvarPodeAtenderEmadMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarConfigAtendimentoDomTipoPodeAtender: {
    readonly __typename?: 'ConfiguracoesAtendimentosDomiciliares'
    readonly id: string
  }
}

export type ConfiguracoesAtencaoDomQueryVariables = Exact<{
  input?: InputMaybe<ConfiguracoesAtendimentosDomInput>
}>

export type ConfiguracoesAtencaoDomQuery = {
  readonly __typename?: 'Query'
  readonly configuracoesAtencaoDom: {
    readonly __typename?: 'ConfiguracoesAtencaoDom'
    readonly duracao: number
    readonly emadsAtendemEmads: {
      readonly __typename?: 'ConfiguracoesAtendimentosDomPayload'
      readonly content: ReadonlyArray<{
        readonly __typename?: 'ConfiguracoesAtendimentosDomiciliares'
        readonly id: string
        readonly identificadorNacionalEquipePai: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        }
        readonly identificadorNacionalEquipeFilho: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        }
      } | null>
      readonly pageInfo: {
        readonly __typename?: 'PageInfo'
        readonly number: number
        readonly size: number
        readonly totalPages: number
        readonly totalElements: number
        readonly sort?: ReadonlyArray<string | null> | null
        readonly first: boolean
        readonly last: boolean
        readonly numberOfElements: number
      }
    }
    readonly emapsApoiamEmads: {
      readonly __typename?: 'ConfiguracoesAtendimentosDomPayload'
      readonly content: ReadonlyArray<{
        readonly __typename?: 'ConfiguracoesAtendimentosDomiciliares'
        readonly id: string
        readonly identificadorNacionalEquipePai: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        }
        readonly identificadorNacionalEquipeFilho: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        }
      } | null>
      readonly pageInfo: {
        readonly __typename?: 'PageInfo'
        readonly number: number
        readonly size: number
        readonly totalPages: number
        readonly totalElements: number
        readonly sort?: ReadonlyArray<string | null> | null
        readonly first: boolean
        readonly last: boolean
        readonly numberOfElements: number
      }
    }
  }
}

export type EquipesAtencaoDomQueryVariables = Exact<{
  input?: InputMaybe<EquipeAdInput>
}>

export type EquipesAtencaoDomQuery = {
  readonly __typename?: 'Query'
  readonly equipesAtencaoDom: {
    readonly __typename?: 'EquipeADPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ExcluirConfigAtendimentoDomMutationVariables = Exact<{
  idConfig: Scalars['ID']['input']
}>

export type ExcluirConfigAtendimentoDomMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirConfigAtendimentoDom: string
}

export type SalvarDuracaoAgendamentoAdMutationVariables = Exact<{
  input: DuracaoAgendamentoAtencaoDomInput
}>

export type SalvarDuracaoAgendamentoAdMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarDuracaoAgendamentoAtencaoDom: {
    readonly __typename?: 'DuracaoAgendamentoAtencaoDomDto'
    readonly duracaoAgendamento: number
  }
}

export type CidadaoAdLoadQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type CidadaoAdLoadQuery = {
  readonly __typename?: 'Query'
  readonly cidadaoAD: {
    readonly __typename?: 'AtencaoDomiciliarCidadao'
    readonly id: string
    readonly modalidade?: AtencaoDomiciliarModalidade | null
    readonly procedencia?: AtencaoDomiciliarOrigem | null
    readonly procedenciaEspecificacao?: string | null
    readonly condutaDesfecho?: AtencaoDomiciliarCondutaDesfecho | null
    readonly dataAdmissao?: any | null
    readonly dataSaida?: any | null
    readonly dataObito?: any | null
    readonly dataAgendado?: any | null
    readonly dataUltimaVisita?: any | null
    readonly numeroDocumentoObito?: string | null
    readonly cidadao?: {
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly nome: string
      readonly dataNascimento?: any | null
      readonly nomeMae?: string | null
      readonly nomeSocial?: string | null
      readonly nomeResponsavel?: string | null
      readonly dtNascimentoResponsavel?: any | null
      readonly cpfCnsResponsavel?: string | null
      readonly naoPossuiCuidador?: boolean | null
      readonly cpfCnsCuidador?: string | null
      readonly nomeCuidador?: string | null
      readonly dtNascimentoCuidador?: any | null
      readonly tipoCuidador?: RelacaoCidadaoCuidador | null
      readonly sexo: SexoEnum
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly dataObito?: any | null
    } | null
    readonly cidadaoAdEmObito?: {
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly dataObito?: any | null
      } | null
    } | null
    readonly cidadaosAdEmPosObito?: ReadonlyArray<{
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
      } | null
    } | null> | null
    readonly cid10Principal?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly nome: string
      readonly codigo: string
    } | null
    readonly cid10Secundario1?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly nome: string
      readonly codigo: string
    } | null
    readonly cid10Secundario2?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly nome: string
      readonly codigo: string
    } | null
    readonly actions: {
      readonly __typename?: 'AtencaoDomiciliarCidadaoActions'
      readonly permissaoEditarAD: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    }
  }
}

export type CidadaoAdSaveMutationVariables = Exact<{
  input: AtencaoDomiciliarCidadaoInput
}>

export type CidadaoAdSaveMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarCidadaoAtencaoDomiciliar: { readonly __typename?: 'AtencaoDomiciliarCidadao'; readonly id: string }
}

export type EquipeCidadaoAdListaQueryVariables = Exact<{
  input: CidadaosAdQueryInput
}>

export type EquipeCidadaoAdListaQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosAD: {
    readonly __typename?: 'CidadaosAdQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly cidadao?: { readonly __typename?: 'Cidadao'; readonly id: string } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null>
  }
}

export type CidadaoAdExcluirMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoAdExcluirMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirCidadaoAtendimentoDomiciliar: string
}

export type ListaAdTableQueryVariables = Exact<{
  input: CidadaosAdQueryInput
}>

export type ListaAdTableQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosAD: {
    readonly __typename?: 'CidadaosAdQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly modalidade?: AtencaoDomiciliarModalidade | null
      readonly condutaDesfecho?: AtencaoDomiciliarCondutaDesfecho | null
      readonly dataAgendado?: any | null
      readonly dataUltimaVisita?: any | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly nomeSocial?: string | null
        readonly prontuario?: { readonly __typename?: 'Prontuario'; readonly id: string } | null
      } | null
      readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
      readonly actions: {
        readonly __typename?: 'AtencaoDomiciliarCidadaoActions'
        readonly permissaoEditarAD: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly adEncerrado: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly permissaoExcluirAD: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CidadaoAdSelectFieldQueryVariables = Exact<{
  input: CidadaosAdQueryInput
}>

export type CidadaoAdSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosAD: {
    readonly __typename?: 'CidadaosAdQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly nomeMae?: string | null
        readonly dataObito?: any | null
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CidadaoListaAdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoListaAdQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
  }
}

export type CidadaoListaAdSelectFieldQueryVariables = Exact<{
  input: CidadaosComboQueryInput
  emAtencaoDomiciliar: Scalars['Boolean']['input']
}>

export type CidadaoListaAdSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosCombo: ReadonlyArray<{
    readonly __typename?: 'CidadaoBasico'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly equipeAtendimentoAd?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
  } | null>
}

export type AgendamentoFragment = {
  readonly __typename?: 'Agendado'
  readonly id: string
  readonly horarioInicial: any
  readonly horarioFinal: any
  readonly dataCriacao?: any | null
  readonly origem?: OrigemAgendamentoEnum | null
  readonly observacao?: string | null
  readonly situacao: SituacaoAgendadoEnum
  readonly situacaoSincronizacao: SituacaoSincronizacaoAgendaOnlineEnum
  readonly isForaUbs: boolean
  readonly isAtencaoDomiciliar: boolean
  readonly tipoAgendamento: TipoAgendamentoEnum
  readonly enviouEmailCidadao: boolean
  readonly cidadao?: {
    readonly __typename?: 'CidadaoBasico'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly contato?: {
      readonly __typename?: 'ContatoCidadao'
      readonly id: string
      readonly email?: string | null
    } | null
  } | null
  readonly localAtendimento?: {
    readonly __typename?: 'LocalAtendimento'
    readonly id: string
    readonly localAtendimentoExibicao?: string | null
  } | null
}

export type AgendamentosDiaLotacaoQueryVariables = Exact<{
  input: AgendadosQueryInput
}>

export type AgendamentosDiaLotacaoQuery = {
  readonly __typename?: 'Query'
  readonly agendados: {
    readonly __typename?: 'AgendadoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Agendado'
      readonly tipoAgendamento: TipoAgendamentoEnum
      readonly isAtencaoDomiciliar: boolean
      readonly motivoReserva?: MotivoAgendamentoReservaEnum | null
      readonly outroMotivoReserva?: string | null
      readonly id: string
      readonly horarioInicial: any
      readonly horarioFinal: any
      readonly dataCriacao?: any | null
      readonly origem?: OrigemAgendamentoEnum | null
      readonly observacao?: string | null
      readonly situacao: SituacaoAgendadoEnum
      readonly situacaoSincronizacao: SituacaoSincronizacaoAgendaOnlineEnum
      readonly isForaUbs: boolean
      readonly enviouEmailCidadao: boolean
      readonly cidadao?: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly contato?: {
          readonly __typename?: 'ContatoCidadao'
          readonly id: string
          readonly telefoneResidencial?: string | null
          readonly telefoneCelular?: string | null
          readonly telefoneContato?: string | null
          readonly email?: string | null
        } | null
      } | null
      readonly atendimento?: {
        readonly __typename?: 'Atendimento'
        readonly id: string
        readonly statusAtendimento: StatusAtendimento
        readonly possuiAtendimentosProfissionais: boolean
      } | null
      readonly agendamentoPrincipal?: {
        readonly __typename?: 'Agendado'
        readonly id: string
        readonly lotacaoAgendada: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly email?: string | null
            readonly nome: string
          }
        }
      } | null
      readonly lotacaoParticipante?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly email?: string | null
        }
      } | null
      readonly videochamada?: {
        readonly __typename?: 'Videochamada'
        readonly id: string
        readonly uuid: string
      } | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    }>
  }
}

export type LotacaoAssociadaAgendamentoFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly ativo: boolean
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
    readonly tipoEquipe: { readonly __typename?: 'TipoEquipe'; readonly id: string; readonly descricao?: string | null }
  } | null
}

export type EstagioAssociadoAgendamentoFragment = {
  readonly __typename?: 'Estagio'
  readonly id: string
  readonly ativo: boolean
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
    readonly tipoEquipe: { readonly __typename?: 'TipoEquipe'; readonly id: string; readonly descricao?: string | null }
  } | null
}

export type ConfiguracaoHorariosAgendaLotacaoQueryVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
  isAtencaoDomiciliar: Scalars['Boolean']['input']
  isAgendaAtiva: Scalars['Boolean']['input']
}>

export type ConfiguracaoHorariosAgendaLotacaoQuery = {
  readonly __typename?: 'Query'
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly configuracaoAgenda?: {
      readonly __typename?: 'ConfiguracaoAgendaLotacao'
      readonly duracaoAgendamento?: number | null
      readonly configuracaoHorarioAgenda?: {
        readonly __typename?: 'ConfiguracaoHorarioAgenda'
        readonly configuracaoDiasSemana?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoDiaSemana'
          readonly diaSemana: DiaSemanaEnum
          readonly periodos?: ReadonlyArray<{
            readonly __typename?: 'ConfiguracaoPeriodo'
            readonly horarioInicial?: string | null
            readonly horarioFinal?: string | null
          }> | null
        }> | null
      }
    } | null
    readonly gradeConfiguracaoAgendaOnline?: {
      readonly __typename?: 'ConfiguracaoAgendaOnlineLotacao'
      readonly diasLiberacaoReserva: any
      readonly configuracoesSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoSemanaAgendaOnline'
        readonly diaSemana: DiaSemanaEnum
        readonly configuracoes: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoHorarioAgendaOnline'
          readonly horario: string
          readonly ativo: boolean
        } | null>
      }> | null
    } | null
  }
  readonly conexao?: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
}

export type FechamentoAgendaDiaQueryVariables = Exact<{
  input: FechamentoAgendaDiaQueryInput
}>

export type FechamentoAgendaDiaQuery = {
  readonly __typename?: 'Query'
  readonly fechamentoDia?: {
    readonly __typename?: 'FechamentoAgenda'
    readonly id?: string | null
    readonly dataInicial?: any | null
    readonly dataFinal?: any | null
    readonly motivo?: string | null
    readonly especifique?: string | null
  } | null
}

export type AgendaAuthorizationQueryVariables = Exact<{
  equipeId: Scalars['ID']['input']
  isAd: Scalars['Boolean']['input']
}>

export type AgendaAuthorizationQuery = {
  readonly __typename?: 'Query'
  readonly equipe: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly emapsApoio?: ReadonlyArray<{ readonly __typename?: 'Equipe'; readonly id: string }>
    readonly equipesVinculadas: ReadonlyArray<{ readonly __typename?: 'Equipe'; readonly id: string }>
  }
}

export type AgendamentosConflitantesQueryVariables = Exact<{
  input: AgendamentoConflitanteInput
}>

export type AgendamentosConflitantesQuery = {
  readonly __typename?: 'Query'
  readonly nomesOutrosProfissionaisAgendamentosConflitantes: ReadonlyArray<{
    readonly __typename?: 'NomesProfissionaisAgendamentosConflitantes'
    readonly nomesProfissionais: ReadonlyArray<string>
    readonly horarioAgendamentoConflitante: any
  }>
  readonly possuiAgendamentoMesmoProfissionalDataFutura: ReadonlyArray<{
    readonly __typename?: 'AgendamentoMesmoProfissionalDataFutura'
    readonly profissionalId: string
    readonly dataFutura: any
  }>
}

export type CidadaoCadastroAgendamentoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoCadastroAgendamentoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly telefoneCelular?: string | null
    readonly email?: string | null
    readonly faleceu?: boolean | null
  }
}

export type EditarAgendadoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type EditarAgendadoQuery = {
  readonly __typename?: 'Query'
  readonly agendado: {
    readonly __typename?: 'Agendado'
    readonly id: string
    readonly horarioInicial: any
    readonly horarioFinal: any
    readonly motivoReserva?: MotivoAgendamentoReservaEnum | null
    readonly outroMotivoReserva?: string | null
    readonly observacao?: string | null
    readonly lotacaoAgendada: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly descricao?: string | null
        }
      } | null
    }
    readonly localAtendimento?: {
      readonly __typename?: 'LocalAtendimento'
      readonly id: string
      readonly localAtendimentoExibicao?: string | null
    } | null
    readonly cidadao?: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly contato?: {
        readonly __typename?: 'ContatoCidadao'
        readonly id: string
        readonly email?: string | null
        readonly telefoneCelular?: string | null
      } | null
    } | null
    readonly agendamentoParticipante?: {
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly lotacaoAgendada: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly ativo: boolean
        readonly importada: boolean
        readonly hasConfiguracaoAgenda?: boolean | null
        readonly hasConfiguracaoAgendaOnline?: boolean | null
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly cpf: string
          readonly email?: string | null
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
          readonly tipoEquipe: {
            readonly __typename?: 'TipoEquipe'
            readonly id: string
            readonly descricao?: string | null
          }
        } | null
      }
    } | null
    readonly videochamada?: { readonly __typename?: 'Videochamada'; readonly id: string; readonly uuid: string } | null
  }
}

export type EditarAgendamentoConsultaCompartilhadaMutationVariables = Exact<{
  input: EditarAgendamentoConsultaCompartilhadaInput
}>

export type EditarAgendamentoConsultaCompartilhadaMutation = {
  readonly __typename?: 'Mutation'
  readonly editarAgendamentoConsultaCompartilhada: string
}

export type EditarAgendamentoConsultaMutationVariables = Exact<{
  input: EditarAgendamentoConsultaInput
}>

export type EditarAgendamentoConsultaMutation = {
  readonly __typename?: 'Mutation'
  readonly editarAgendamentoConsulta: string
}

export type EditarAgendamentoReservaMutationVariables = Exact<{
  input: EditarAgendamentoReservaInput
}>

export type EditarAgendamentoReservaMutation = {
  readonly __typename?: 'Mutation'
  readonly editarAgendamentoReserva: ReadonlyArray<string>
}

export type SalvarAgendamentoConsultaCompartilhadaMutationVariables = Exact<{
  input: CriarAgendamentoConsultaCompartilhadaInput
}>

export type SalvarAgendamentoConsultaCompartilhadaMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAgendamentoConsultaCompartilhada: string
}

export type SalvarAgendamentoConsultaMutationVariables = Exact<{
  input: CriarAgendamentoConsultaInput
}>

export type SalvarAgendamentoConsultaMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAgendamentoConsulta: string
}

export type SalvarAgendamentoReservaMutationVariables = Exact<{
  input: CriarAgendamentoReservaInput
}>

export type SalvarAgendamentoReservaMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAgendamentoReserva: ReadonlyArray<string>
}

export type AgendamentosCidadaoPagedQueryVariables = Exact<{
  input: AgendadosQueryInput
}>

export type AgendamentosCidadaoPagedQuery = {
  readonly __typename?: 'Query'
  readonly agendados: {
    readonly __typename?: 'AgendadoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly horarioInicial: any
      readonly horarioFinal: any
      readonly dataCriacao?: any | null
      readonly origem?: OrigemAgendamentoEnum | null
      readonly observacao?: string | null
      readonly situacao: SituacaoAgendadoEnum
      readonly situacaoSincronizacao: SituacaoSincronizacaoAgendaOnlineEnum
      readonly isForaUbs: boolean
      readonly isAtencaoDomiciliar: boolean
      readonly tipoAgendamento: TipoAgendamentoEnum
      readonly enviouEmailCidadao: boolean
      readonly lotacaoAgendada: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly ativo: boolean
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
          readonly tipoEquipe: {
            readonly __typename?: 'TipoEquipe'
            readonly id: string
            readonly descricao?: string | null
          }
        } | null
      }
      readonly responsavelCriador?:
        | {
            readonly __typename?: 'Estagio'
            readonly id: string
            readonly ativo: boolean
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeSocial?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
              readonly tipoEquipe: {
                readonly __typename?: 'TipoEquipe'
                readonly id: string
                readonly descricao?: string | null
              }
            } | null
          }
        | {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly ativo: boolean
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeSocial?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
              readonly tipoEquipe: {
                readonly __typename?: 'TipoEquipe'
                readonly id: string
                readonly descricao?: string | null
              }
            } | null
          }
        | null
      readonly justificativaCancelamento?: {
        readonly __typename?: 'JustificativaCancelamentoAgendado'
        readonly id: string
        readonly justificativa?: string | null
        readonly data: any
        readonly responsavel?:
          | {
              readonly __typename?: 'Estagio'
              readonly id: string
              readonly ativo: boolean
              readonly profissional: {
                readonly __typename?: 'Profissional'
                readonly id: string
                readonly nome: string
                readonly nomeSocial?: string | null
              }
              readonly cbo: {
                readonly __typename?: 'Cbo'
                readonly id: string
                readonly nome: string
                readonly cbo2002: string
              }
              readonly equipe?: {
                readonly __typename?: 'Equipe'
                readonly id: string
                readonly nome: string
                readonly ine: string
                readonly tipoEquipe: {
                  readonly __typename?: 'TipoEquipe'
                  readonly id: string
                  readonly descricao?: string | null
                }
              } | null
            }
          | {
              readonly __typename?: 'Lotacao'
              readonly id: string
              readonly ativo: boolean
              readonly profissional: {
                readonly __typename?: 'Profissional'
                readonly id: string
                readonly nome: string
                readonly nomeSocial?: string | null
              }
              readonly cbo: {
                readonly __typename?: 'Cbo'
                readonly id: string
                readonly nome: string
                readonly cbo2002: string
              }
              readonly equipe?: {
                readonly __typename?: 'Equipe'
                readonly id: string
                readonly nome: string
                readonly ine: string
                readonly tipoEquipe: {
                  readonly __typename?: 'TipoEquipe'
                  readonly id: string
                  readonly descricao?: string | null
                }
              } | null
            }
          | null
      } | null
      readonly agendamentoPrincipal?: {
        readonly __typename?: 'Agendado'
        readonly id: string
        readonly lotacaoAgendada: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly ativo: boolean
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
            }
          } | null
        }
      } | null
      readonly lotacaoParticipante?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly ativo: boolean
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
          readonly tipoEquipe: {
            readonly __typename?: 'TipoEquipe'
            readonly id: string
            readonly descricao?: string | null
          }
        } | null
      } | null
      readonly cidadao?: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly contato?: {
          readonly __typename?: 'ContatoCidadao'
          readonly id: string
          readonly email?: string | null
        } | null
      } | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
}

export type LotacaoConfiguracaoAgendaQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type LotacaoConfiguracaoAgendaQuery = {
  readonly __typename?: 'Query'
  readonly hasConfiguracaoAgenda?: boolean | null
}

export type CancelarAgendamentoMutationVariables = Exact<{
  input: CancelarAgendamentoInput
}>

export type CancelarAgendamentoMutation = { readonly __typename?: 'Mutation'; readonly cancelarAgendamento: boolean }

export type DataCriacaoAgendadoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DataCriacaoAgendadoQuery = {
  readonly __typename?: 'Query'
  readonly agendado: { readonly __typename?: 'Agendado'; readonly id: string; readonly dataCriacao?: any | null }
}

export type FixarAgendaMutationVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
}>

export type FixarAgendaMutation = { readonly __typename?: 'Mutation'; readonly fixarAgenda: boolean }

export type InformarFaltaCidadaoMutationVariables = Exact<{
  agendamentoId: Scalars['ID']['input']
}>

export type InformarFaltaCidadaoMutation = { readonly __typename?: 'Mutation'; readonly informarFaltaCidadao: boolean }

export type InserirListaAtendimentoMutationVariables = Exact<{
  input: AtendimentoInput
}>

export type InserirListaAtendimentoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtendimento: { readonly __typename?: 'Atendimento'; readonly id: string }
}

export type RemoverAgendaFixadaMutationVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
}>

export type RemoverAgendaFixadaMutation = { readonly __typename?: 'Mutation'; readonly removerAgendaFixada: boolean }

export type RemoverFaltaCidadaoMutationMutationVariables = Exact<{
  agendamentoId: Scalars['ID']['input']
}>

export type RemoverFaltaCidadaoMutationMutation = {
  readonly __typename?: 'Mutation'
  readonly removerFaltaCidadao: boolean
}

export type RemoverListaAtendimentoMutationVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type RemoverListaAtendimentoMutation = { readonly __typename?: 'Mutation'; readonly excluirAtendimento: string }

export type MesAgendaQueryVariables = Exact<{
  input: MesAgendaQueryInput
}>

export type MesAgendaQuery = {
  readonly __typename?: 'Query'
  readonly mesAgenda: {
    readonly __typename?: 'MesAgendaLotacao'
    readonly id: string
    readonly dias: ReadonlyArray<{
      readonly __typename?: 'DiaAgendaLotacao'
      readonly data: any
      readonly status: StatusDiaAgendaEnum
    }>
  }
}

export type LotacaoAgendaActionsQueryVariables = Exact<{
  acessoId: Scalars['ID']['input']
  lotacaoId: Scalars['ID']['input']
}>

export type LotacaoAgendaActionsQuery = {
  readonly __typename?: 'Query'
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly actions: {
      readonly __typename?: 'LotacaoActions'
      readonly permissaoConfigurarAgenda: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly permissaoConfigurarAgendaOnline: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
      readonly permissaoFecharAgenda: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    }
  }
  readonly lotacaoSelecionada: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly hasAgendamentoFuturo?: boolean | null
  }
}

export type DetalhesAgendamentoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DetalhesAgendamentoQuery = {
  readonly __typename?: 'Query'
  readonly agendado: {
    readonly __typename?: 'Agendado'
    readonly id: string
    readonly dataCriacao?: any | null
    readonly agendamentoPrincipal?: {
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly cidadao?: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly dataNascimento?: any | null
        readonly contato?: {
          readonly __typename?: 'ContatoCidadao'
          readonly id: string
          readonly telefoneResidencial?: string | null
          readonly telefoneCelular?: string | null
          readonly telefoneContato?: string | null
        } | null
      } | null
      readonly lotacaoAgendada: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
        } | null
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly email?: string | null
        }
      }
    } | null
    readonly cidadao?: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly dataNascimento?: any | null
      readonly contato?: {
        readonly __typename?: 'ContatoCidadao'
        readonly id: string
        readonly telefoneResidencial?: string | null
        readonly telefoneCelular?: string | null
        readonly telefoneContato?: string | null
      } | null
    } | null
    readonly lotacaoParticipante?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    } | null
    readonly videochamada?: { readonly __typename?: 'Videochamada'; readonly id: string; readonly uuid: string } | null
    readonly responsavelCriador?:
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly ativo: boolean
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
            }
          } | null
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly ativo: boolean
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
            }
          } | null
        }
      | null
    readonly lotacaoAgendada: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly descricao?: string | null
        }
      } | null
    }
  }
}

export type AlterarSenhaMutationVariables = Exact<{
  input: AlterarSenhaAtualInput
}>

export type AlterarSenhaMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarSenhaAtual?: {
    readonly __typename?: 'Usuario'
    readonly id: string
    readonly forcarTrocaSenha: boolean
  } | null
}

export type DataLimiteAlterarSenhaQueryVariables = Exact<{
  login?: InputMaybe<Scalars['String']['input']>
}>

export type DataLimiteAlterarSenhaQuery = {
  readonly __typename?: 'Query'
  readonly dataLimiteAlterarSenha?: any | null
}

export type ArquivosTemporariosPagedQueryVariables = Exact<{
  input: ArquivoTemporarioPagingQueryInput
}>

export type ArquivosTemporariosPagedQuery = {
  readonly __typename?: 'Query'
  readonly arquivosTemporarios?: {
    readonly __typename?: 'ArquivoTemporarioQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ArquivoTemporario'
      readonly id: string
      readonly dataInicioGerado: any
      readonly status: ArquivoTemporarioStatusEnum
      readonly identificador: ArquivoTemporarioIdentificadorEnum
      readonly formato: ArquivoTemporarioFormatoEnum
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  } | null
}

export type UltimoArquivoTemporarioProntoEmProcessamentoQueryVariables = Exact<{
  input: ArquivoTemporarioQueryInput
}>

export type UltimoArquivoTemporarioProntoEmProcessamentoQuery = {
  readonly __typename?: 'Query'
  readonly ultimoArquivoTemporarioProntoEmProcessamento?: {
    readonly __typename?: 'ArquivoTemporario'
    readonly id: string
    readonly dataInicioGerado: any
    readonly status: ArquivoTemporarioStatusEnum
    readonly identificador: ArquivoTemporarioIdentificadorEnum
    readonly formato: ArquivoTemporarioFormatoEnum
  } | null
}

export type UltimosCincoArquivosTemporariosQueryVariables = Exact<{
  input: ArquivoTemporarioIdentificadorEnum
}>

export type UltimosCincoArquivosTemporariosQuery = {
  readonly __typename?: 'Query'
  readonly ultimosCincoArquivosTemporarios: ReadonlyArray<{
    readonly __typename?: 'ArquivoTemporario'
    readonly id: string
    readonly dataInicioGerado: any
    readonly status: ArquivoTemporarioStatusEnum
    readonly identificador: ArquivoTemporarioIdentificadorEnum
    readonly formato: ArquivoTemporarioFormatoEnum
  }>
}

export type AtendimentosFinalizadosQueryVariables = Exact<{
  input: AtendimentosFinalizadosInput
}>

export type AtendimentosFinalizadosQuery = {
  readonly __typename?: 'Query'
  readonly atendimentosFinalizados: {
    readonly __typename?: 'AtendimentosProfissionalPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly tipo: TipoAtendimentoProfissional
      readonly finalizadoEm?: any | null
      readonly isAtendRecente: boolean
      readonly codigoUnicoRegistro: string
      readonly atendimento?: {
        readonly __typename?: 'Atendimento'
        readonly id: string
        readonly cidadao: {
          readonly __typename?: 'CidadaoBasico'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly cpf?: string | null
          readonly cns?: string | null
          readonly dataNascimento?: any | null
        }
      } | null
      readonly assinaturaEletronicaAtend?: {
        readonly __typename?: 'AssinaturaEletronica'
        readonly id: string
        readonly dtAssinatura: any
        readonly status: StatusAssinatura
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AgendadoAtendimentoFormQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AgendadoAtendimentoFormQuery = {
  readonly __typename?: 'Query'
  readonly agendado: {
    readonly __typename?: 'Agendado'
    readonly id: string
    readonly lotacaoAgendada: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly cbo2002: string }
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        }
      } | null
    }
  }
}

export type AgendamentosDiaQueryVariables = Exact<{
  input: AgendadosQueryInput
}>

export type AgendamentosDiaQuery = {
  readonly __typename?: 'Query'
  readonly agendados: {
    readonly __typename?: 'AgendadoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly horarioInicial: any
      readonly lotacaoAgendada: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
      readonly lotacaoParticipante?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      } | null
    }>
  }
}

export type AtendimentoIndividualViewQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type AtendimentoIndividualViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly tipo: TipoAtendimentoProfissional
    readonly tipoAtendimento?: TipoAtendimentoEnum | null
    readonly iniciadoEm: any
    readonly finalizadoEm?: any | null
    readonly rascunho?: string | null
    readonly estagio?: { readonly __typename?: 'Estagio'; readonly id: string } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cns?: string | null
        readonly cpf: string
        readonly numeroConselhoClasse?: string | null
        readonly conselhoClasse?: {
          readonly __typename?: 'ConselhoClasse'
          readonly id: string
          readonly sigla: string
          readonly descricao?: string | null
        } | null
        readonly ufEmissoraConselhoClasse?: {
          readonly __typename?: 'UF'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        } | null
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly municipio: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly isExibeProblemasObrigatoriosAdicionarLPC: boolean
        }
      } | null
    }
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly responsaveis: ReadonlyArray<{
          readonly __typename?: 'AtendimentoObservacaoResponsavel'
          readonly id: string
          readonly atendeuComoResponsavel: boolean
          readonly responsavel: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly cpf: string
            }
          }
        }>
        readonly ultimoResponsavelObservacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      }
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly iniciadoEm: any
      readonly statusRevisaoAtendimento?: StatusRevisaoAtendimento | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
      readonly agendado?: {
        readonly __typename?: 'Agendado'
        readonly id: string
        readonly lotacaoAgendada: { readonly __typename?: 'Lotacao'; readonly id: string }
        readonly lotacaoParticipante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        } | null
        readonly agendamentoPrincipal?: {
          readonly __typename?: 'Agendado'
          readonly id: string
          readonly lotacaoAgendada: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly cpf: string
            }
          }
        } | null
        readonly videochamada?: { readonly __typename?: 'Videochamada'; readonly id: string } | null
      } | null
      readonly tiposServico?: ReadonlyArray<{ readonly __typename?: 'TipoServico'; readonly id: string } | null> | null
      readonly cidadao: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
        readonly nomeMae?: string | null
        readonly area?: string | null
        readonly microArea?: string | null
        readonly desejaInformarIdentidadeGenero?: boolean | null
        readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
        readonly stCompartilhaProntuario?: boolean | null
        readonly ultimaDum?: { readonly __typename?: 'Dum'; readonly dum: any; readonly registradoEm: any } | null
        readonly contato?: {
          readonly __typename?: 'ContatoCidadao'
          readonly id: string
          readonly email?: string | null
        } | null
      }
      readonly prontuario: {
        readonly __typename?: 'Prontuario'
        readonly id: string
        readonly puerpera?: boolean | null
        readonly gestacoes?: ReadonlyArray<{
          readonly __typename?: 'PeriodoGestacao'
          readonly id: string
          readonly inicio: any
          readonly fim?: any | null
        }> | null
        readonly preNatalAtivo?: {
          readonly __typename?: 'PreNatal'
          readonly id: string
          readonly gravidezPlanejada?: boolean | null
          readonly ultimaDum?: any | null
          readonly altoRisco: boolean
          readonly fonteIdadeGestacional?: FonteIdadeGestacionalEnum | null
          readonly tipoGravidez?: {
            readonly __typename?: 'TipoGravidez'
            readonly id: string
            readonly descricao?: string | null
            readonly tipoGravidez?: TipoGravidezEnum | null
          } | null
          readonly problema: {
            readonly __typename?: 'Problema'
            readonly id: string
            readonly ultimaEvolucao: {
              readonly __typename?: 'EvolucaoProblema'
              readonly id: string
              readonly dataInicio?: any | null
            }
          }
        } | null
      }
    } | null
  }
}

export type CiapCidAtendimentoQueryVariables = Exact<{
  inputCiap: CiapQueryInput
  inputCid10: Cid10QueryInput
}>

export type CiapCidAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly ciaps: {
    readonly __typename?: 'CiapQueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
      readonly inclui?: string | null
      readonly exclui?: string | null
    }>
  }
  readonly cids: {
    readonly __typename?: 'Cid10QueryPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null>
  }
}

export type ProcedimentosAutomaticosQueryVariables = Exact<{ [key: string]: never }>

export type ProcedimentosAutomaticosQuery = {
  readonly __typename?: 'Query'
  readonly procedimentosAutomaticos: ReadonlyArray<{
    readonly __typename?: 'Procedimento'
    readonly idadeMinima?: number | null
    readonly idadeMaxima?: number | null
    readonly sexo?: SexoEnum | null
    readonly id: string
    readonly descricao: string
    readonly codigo: string
    readonly ativo?: boolean | null
    readonly procedimentoReferencia?: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
    } | null
  } | null>
}

export type RegistroAvaliacaoPuericulturaQueryVariables = Exact<{ [key: string]: never }>

export type RegistroAvaliacaoPuericulturaQuery = {
  readonly __typename?: 'Query'
  readonly registroAvaliacaoPuericultura: {
    readonly __typename?: 'RegistroAvaliacaoPuericultura'
    readonly ciap: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    }
    readonly cid10: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    }
  }
}

export type SalvarAtendimentoIndividualMutationVariables = Exact<{
  input: AtendimentoIndividualInput
}>

export type SalvarAtendimentoIndividualMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtendimentoIndividual: {
    readonly __typename?: 'FinalizarAtendimentoIndividualResponse'
    readonly agendamentosCriadosIds: ReadonlyArray<string>
    readonly atendProf: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
  }
}

export type SalvarAtendimentoIndividualParaAprovacaoMutationVariables = Exact<{
  input: AtendimentoIndividualAprovacaoInput
}>

export type SalvarAtendimentoIndividualParaAprovacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtendimentoIndividualParaAprovacao: boolean
}

export type AtendimentoObservacaoViewQueryVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type AtendimentoObservacaoViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly atendimentoProfissional?: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
      readonly tipoAtendimento?: TipoAtendimentoEnum | null
      readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
      readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
      readonly atestados?: ReadonlyArray<{
        readonly __typename?: 'Atestado'
        readonly id: string
        readonly descricao?: string | null
        readonly tipo?: TipoAtestadoEnum | null
        readonly assinadoDigitalmente: boolean
      }> | null
      readonly encaminhamentosEspecializados?: ReadonlyArray<{
        readonly __typename?: 'EncaminhamentoExternoEspecializado'
        readonly id: string
        readonly motivoEncaminhamento?: string | null
        readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
        readonly complemento?: string | null
        readonly observacoes?: string | null
        readonly especialidadeSisreg: {
          readonly __typename?: 'EspecialidadeSisreg'
          readonly id: string
          readonly descricao: string
        }
        readonly hipoteseDiagnosticoCid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly hipoteseDiagnosticoCiap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly iniciadoEm: any
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string }
          }
        }
      } | null> | null
      readonly guiasEncaminhamento?: ReadonlyArray<{
        readonly __typename?: 'GuiaEncaminhamento'
        readonly id: string
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly discussao: string
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly especialidade: {
          readonly __typename?: 'EspecialidadeEsusReg'
          readonly id: string
          readonly nome: string
        }
      }> | null
      readonly orientacoes?: ReadonlyArray<{
        readonly __typename?: 'Orientacao'
        readonly id: string
        readonly descricao: string
      } | null> | null
      readonly requisicoesExames?: ReadonlyArray<{
        readonly __typename?: 'SolicitacaoExame'
        readonly id: string
        readonly data: any
        readonly tipoExame: TipoExameEnum
        readonly justificativa: string
        readonly observacoes?: string | null
        readonly exames: ReadonlyArray<{
          readonly __typename?: 'ResultadoExame'
          readonly id: string
          readonly conferido?: boolean | null
          readonly observacao?: string | null
          readonly solicitacao?: {
            readonly __typename?: 'SolicitacaoExame'
            readonly id: string
            readonly data: any
          } | null
          readonly exame: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
            readonly procedimentoReferencia?: {
              readonly __typename?: 'Procedimento'
              readonly id: string
              readonly descricao: string
              readonly codigo: string
              readonly ativo?: boolean | null
            } | null
          }
        }>
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ciapsRelacionadas?: ReadonlyArray<{
            readonly __typename?: 'Ciap'
            readonly id: string
          } | null> | null
        } | null
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
        readonly solicitacaoCitopatologico?: {
          readonly __typename?: 'SolicitacaoExameCitopatologico'
          readonly id: string
          readonly questoes: ReadonlyArray<{
            readonly __typename?: 'SolicitacaoExameCitopatologicoQuestao'
            readonly id: string
            readonly pergunta: RastreioCancerPerguntaDbEnum
            readonly resposta: string
          } | null>
        } | null
      }> | null
      readonly solicitacoesOci?: ReadonlyArray<{
        readonly __typename?: 'SolicitacaoExame'
        readonly id: string
        readonly data: any
        readonly tipoExame: TipoExameEnum
        readonly justificativa: string
        readonly observacoes?: string | null
        readonly exames: ReadonlyArray<{
          readonly __typename?: 'ResultadoExame'
          readonly id: string
          readonly conferido?: boolean | null
          readonly observacao?: string | null
          readonly solicitacao?: {
            readonly __typename?: 'SolicitacaoExame'
            readonly id: string
            readonly data: any
          } | null
          readonly exame: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
            readonly procedimentoReferencia?: {
              readonly __typename?: 'Procedimento'
              readonly id: string
              readonly descricao: string
              readonly codigo: string
              readonly ativo?: boolean | null
            } | null
          }
        }>
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ciapsRelacionadas?: ReadonlyArray<{
            readonly __typename?: 'Ciap'
            readonly id: string
          } | null> | null
        } | null
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
        readonly solicitacaoCitopatologico?: {
          readonly __typename?: 'SolicitacaoExameCitopatologico'
          readonly id: string
          readonly questoes: ReadonlyArray<{
            readonly __typename?: 'SolicitacaoExameCitopatologicoQuestao'
            readonly id: string
            readonly pergunta: RastreioCancerPerguntaDbEnum
            readonly resposta: string
          } | null>
        } | null
      }> | null
      readonly examesResultados?: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly dataResultado?: any | null
        readonly dataRealizacao?: any | null
        readonly dataSolicitacao?: any | null
        readonly conferido?: boolean | null
        readonly observacao?: string | null
        readonly resultado?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
        readonly solicitacao?: {
          readonly __typename?: 'SolicitacaoExame'
          readonly id: string
          readonly data: any
          readonly atendimentoProfissional: {
            readonly __typename?: 'AtendimentoProfissional'
            readonly id: string
            readonly lotacao: {
              readonly __typename?: 'Lotacao'
              readonly id: string
              readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
              readonly unidadeSaude: {
                readonly __typename?: 'UnidadeSaude'
                readonly id: string
                readonly nome?: string | null
              }
              readonly profissional: {
                readonly __typename?: 'Profissional'
                readonly id: string
                readonly nome: string
              }
            }
          }
        } | null
        readonly especifico?: {
          readonly __typename?: 'ResultadoExameEspecifico'
          readonly id: string
          readonly exameEspecificoEnum: ExameEspecificoEnum
          readonly valor?: number | null
          readonly igDias?: number | null
          readonly igSemanas?: number | null
          readonly dpp?: any | null
          readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
          readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
        } | null
        readonly atendimentoProfissionalResultado?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        } | null
      } | null> | null
      readonly receitaMedicamento?: ReadonlyArray<{
        readonly __typename?: 'ReceitaMedicamento'
        readonly id: string
        readonly quantidadeReceitada: number
        readonly recomendacoes?: string | null
        readonly qtDose?: string | null
        readonly frequenciaDose?: string | null
        readonly posologia: string
        readonly tipoFrequenciaDose?: TipoFrequencia | null
        readonly qtPeriodoFrequencia?: number | null
        readonly medidaTempoFrequencia?: UnidadeMedidaTempoEnum | null
        readonly qtDuracaoTratamento?: number | null
        readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
        readonly usoContinuo?: boolean | null
        readonly registroManual?: boolean | null
        readonly doseUnica?: boolean | null
        readonly tipoReceita?: TipoReceitaEnum | null
        readonly tratamentoInterrompido?: boolean | null
        readonly justificativaInterrupcao?: string | null
        readonly dtInterrupcao?: any | null
        readonly codigoPrescricaoDigital?: string | null
        readonly unidadeMedidaDose?: {
          readonly __typename?: 'UnidadeMedida'
          readonly id: string
          readonly nome: string
          readonly nomePlural: string
        } | null
        readonly receitaUsoContinuoGrupo?: {
          readonly __typename?: 'ReceitaMedicamento'
          readonly id: string
          readonly dtInicioTratamento?: any | null
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly ativo?: boolean | null
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly aplicacaoMedicamento: {
          readonly __typename?: 'AplicacaoMedicamento'
          readonly id: string
          readonly nome: string
        }
        readonly medicamento: {
          readonly __typename?: 'Medicamento'
          readonly id: string
          readonly concentracao?: string | null
          readonly principioAtivo: string
          readonly principioAtivoFiltro?: string | null
          readonly unidadeFornecimento?: string | null
          readonly formaFarmaceutica?: {
            readonly __typename?: 'FormaFarmaceutica'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          } | null
          readonly medicamentoCatmat?: {
            readonly __typename?: 'MedicamentoCatmat'
            readonly id: string
            readonly ativo: boolean
            readonly volume?: string | null
            readonly codigoCatMat?: string | null
            readonly codigoRename?: string | null
            readonly unidadeFornecimento: {
              readonly __typename?: 'UnidadeMedida'
              readonly id: string
              readonly nome: string
              readonly nomePlural: string
            }
            readonly principioAtivo: {
              readonly __typename?: 'PrincipioAtivo'
              readonly id: string
              readonly nome: string
              readonly listaMaterial: {
                readonly __typename?: 'ListaMedicamento'
                readonly id: string
                readonly tipo: string
                readonly tipoReceita: TipoReceitaEnum
              }
            }
          } | null
        }
      } | null> | null
      readonly evolucaoProblema?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoProblema'
        readonly id: string
        readonly situacao: SituacaoProblema
        readonly observacao?: string | null
        readonly possuiCid: boolean
        readonly possuiCiap: boolean
        readonly dataInicio?: any | null
        readonly dataFim?: any | null
        readonly atualizadoEm?: any | null
        readonly problema?: {
          readonly __typename?: 'Problema'
          readonly id: string
          readonly situacao: SituacaoProblema
          readonly descricaoOutro?: string | null
          readonly ciap?: {
            readonly __typename?: 'Ciap'
            readonly id: string
            readonly codigo: string
            readonly descricao: string
          } | null
          readonly cid10?: {
            readonly __typename?: 'Cid10'
            readonly id: string
            readonly codigo: string
            readonly nome: string
          } | null
          readonly cid11?: {
            readonly __typename?: 'Cid11'
            readonly id: string
            readonly codigo: string
            readonly nome: string
            readonly ativo: boolean
          } | null
          readonly ultimaEvolucao: {
            readonly __typename?: 'EvolucaoProblema'
            readonly id: string
            readonly dataInicio?: any | null
            readonly dataFim?: any | null
            readonly situacao: SituacaoProblema
            readonly observacao?: string | null
            readonly atualizadoEm?: any | null
          }
          readonly evolucaoAvaliacaoCiapCid?: {
            readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
            readonly id: string
          } | null
        } | null
      } | null> | null
      readonly evolucaoSubjetivo?: {
        readonly __typename?: 'EvolucaoSubjetivo'
        readonly id: string
        readonly descricao?: string | null
        readonly ciaps?: ReadonlyArray<{
          readonly __typename?: 'EvolucaoSubjetivoCiap'
          readonly id: string
          readonly nota?: string | null
          readonly ciap: {
            readonly __typename?: 'Ciap'
            readonly id: string
            readonly codigo: string
            readonly descricao: string
          }
        } | null> | null
      } | null
      readonly evolucaoAvaliacao?: {
        readonly __typename?: 'EvolucaoAvaliacao'
        readonly id: string
        readonly descricao?: string | null
        readonly ciapsCids?: ReadonlyArray<{
          readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
          readonly id: string
          readonly nota?: string | null
          readonly isCiapCidNaListaDeProblemas: boolean
          readonly ciap?: {
            readonly __typename?: 'Ciap'
            readonly id: string
            readonly codigo: string
            readonly descricao: string
          } | null
          readonly cid10?: {
            readonly __typename?: 'Cid10'
            readonly id: string
            readonly codigo: string
            readonly nome: string
          } | null
          readonly cid11?: {
            readonly __typename?: 'Cid11'
            readonly id: string
            readonly codigo: string
            readonly nome: string
            readonly ativo: boolean
          } | null
        }> | null
      } | null
      readonly evolucaoObjetivo?: {
        readonly __typename?: 'EvolucaoObjetivo'
        readonly id: string
        readonly descricao?: string | null
      } | null
      readonly evolucaoPlano?: {
        readonly __typename?: 'EvolucaoPlano'
        readonly id: string
        readonly descricao?: string | null
        readonly intervencoesProcedimentos?: ReadonlyArray<{
          readonly __typename?: 'EvolucaoPlanoCiap'
          readonly id: string
          readonly nota?: string | null
          readonly ciap?: {
            readonly __typename?: 'Ciap'
            readonly id: string
            readonly codigo: string
            readonly descricao: string
          } | null
          readonly procedimento?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
            readonly procedimentoReferencia?: {
              readonly __typename?: 'Procedimento'
              readonly id: string
              readonly descricao: string
              readonly codigo: string
              readonly ativo?: boolean | null
            } | null
          } | null
        } | null> | null
      } | null
      readonly notificacoesCasoSuspeito?: ReadonlyArray<{
        readonly __typename?: 'SinanNotificacaoEvolucao'
        readonly id: string
        readonly notificacao: {
          readonly __typename?: 'FichaNotificacaoCasoSuspeito'
          readonly id: string
          readonly nomeNotificacao: string
        }
      } | null> | null
      readonly lotacaoAtendimentoCompartilhado?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly cpf: string
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
          readonly isAD: boolean
        } | null
      } | null
      readonly procedimentosAtendimento?: ReadonlyArray<{
        readonly __typename?: 'AtendimentoProcedimento'
        readonly id: string
        readonly automatico?: boolean | null
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        }
      } | null> | null
      readonly marcadorConsumoAlimentar?: {
        readonly __typename?: 'MarcadorConsumoAlimentar'
        readonly id: string
        readonly categoria: FaixaEtariaConsumoAlimentar
        readonly respostas: ReadonlyArray<{
          readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
          readonly pergunta: PerguntasQuestionarioEnum
          readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
        }>
      } | null
    } | null
  }
}

export type ResponsavelAtendimentoObservacaoFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly cpf: string
  }
}

export type SalvarAtendimentoVacinacaoParaAprovacaoMutationVariables = Exact<{
  input: AtendimentoVacinacaoAprovacaoInput
}>

export type SalvarAtendimentoVacinacaoParaAprovacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtendimentoVacinacaoParaAprovacao: boolean
}

export type AtendimentoVacinacaoViewQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type AtendimentoVacinacaoViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly tipo: TipoAtendimentoProfissional
    readonly iniciadoEm: any
    readonly rascunho?: string | null
    readonly estagio?: { readonly __typename?: 'Estagio'; readonly id: string } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly cpf: string
        readonly cns?: string | null
        readonly nome: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly municipio: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      }
    }
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly iniciadoEm: any
      readonly statusAtendimento: StatusAtendimento
      readonly statusRevisaoAtendimento?: StatusRevisaoAtendimento | null
      readonly isRegistroTardio: boolean
      readonly agendado?: {
        readonly __typename?: 'Agendado'
        readonly id: string
        readonly lotacaoAgendada: { readonly __typename?: 'Lotacao'; readonly id: string }
      } | null
      readonly cidadao: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
        readonly nomeMae?: string | null
        readonly area?: string | null
        readonly microArea?: string | null
        readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
        readonly stCompartilhaProntuario?: boolean | null
      }
      readonly tiposServico?: ReadonlyArray<{ readonly __typename?: 'TipoServico'; readonly id: string } | null> | null
      readonly prontuario: {
        readonly __typename?: 'Prontuario'
        readonly id: string
        readonly puerpera?: boolean | null
        readonly gestacoes?: ReadonlyArray<{
          readonly __typename?: 'PeriodoGestacao'
          readonly id: string
          readonly inicio: any
          readonly fim?: any | null
        }> | null
        readonly preNatalAtivo?: {
          readonly __typename?: 'PreNatal'
          readonly id: string
          readonly ultimaDum?: any | null
        } | null
      }
    } | null
  }
}

export type EsquemaCalendarioVacinalQueryVariables = Exact<{
  input: EsquemaCalendarioVacinalQueryInput
}>

export type EsquemaCalendarioVacinalQuery = {
  readonly __typename?: 'Query'
  readonly esquemaCalendarioVacinal: ReadonlyArray<{
    readonly __typename?: 'BaseCalendarioVacinal'
    readonly id: string
    readonly descricaoImunobiologico: string
    readonly idadeRecomendada?: string | null
    readonly mostrarNoCalendarioDoGrupo: boolean
    readonly ordemImuno: number
    readonly imunobiologico: {
      readonly __typename?: 'Imunobiologico'
      readonly id: string
      readonly sigla: string
      readonly nome: string
    }
    readonly dose: {
      readonly __typename?: 'DoseImunobiologico'
      readonly id: string
      readonly nomeApresentacaoDose: string
      readonly sigla: string
      readonly nome: string
      readonly ordem: number
    }
    readonly faixaEtaria: {
      readonly __typename?: 'FaixaEtariaVacinacao'
      readonly id: string
      readonly diasInicio: number
      readonly diasFim: number
      readonly descricao: string
    }
  }>
}

export type FaixaEtariaVacinacaoQueryVariables = Exact<{
  input: FaixaEtariaVacinacaoQueryInput
}>

export type FaixaEtariaVacinacaoQuery = {
  readonly __typename?: 'Query'
  readonly faixaEtariaVacinacao?: ReadonlyArray<{
    readonly __typename?: 'FaixaEtariaVacinacao'
    readonly id: string
    readonly diasInicio: number
    readonly diasFim: number
    readonly descricao: string
  } | null> | null
}

export type HasVacinaAtrasadaQueryVariables = Exact<{
  input: VacinacaoUltimaVacinaInput
}>

export type HasVacinaAtrasadaQuery = { readonly __typename?: 'Query'; readonly hasVacinaAtrasada: boolean }

export type ProximaDoseAprazamentoQueryVariables = Exact<{
  input: ProximaDoseAprazamentoQueryInput
}>

export type ProximaDoseAprazamentoQuery = {
  readonly __typename?: 'Query'
  readonly proximaDoseAprazamentoAutomatico?: {
    readonly __typename?: 'ProximaDoseAprazamento'
    readonly diasAprazamento?: number | null
    readonly proximaDoseId?: string | null
    readonly proximaDoseSigla?: string | null
    readonly proximaDoseNome?: string | null
  } | null
}

export type RegistrosAplicadosVacinacaoQueryVariables = Exact<{
  input: RegistrosAplicadosVacinacaoInput
}>

export type RegistrosAplicadosVacinacaoQuery = {
  readonly __typename?: 'Query'
  readonly registrosAplicadosVacinacao?: ReadonlyArray<{
    readonly __typename?: 'RegistroAplicado'
    readonly imunobiologicoId: string
    readonly imunobiologicoSigla: string
    readonly imunobiologicoNome: string
    readonly doseId: string
    readonly doseNomeApresentacao: string
    readonly doseNome: string
    readonly doseSigla: string
    readonly dataAprazamento?: any | null
    readonly dataAplicacao?: any | null
    readonly quantidadeAplicacoes: number
    readonly dataRegistroAprazamento?: any | null
    readonly estrategiaId?: string | null
    readonly isRegistroAnterior?: boolean | null
  }> | null
}

export type RetificarAtendimentoVacinacaoMutationVariables = Exact<{
  input: RetificacaoAtendimentoVacinacaoInput
}>

export type RetificarAtendimentoVacinacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly retificarAtendimentoVacinacao: any
}

export type SalvarAtendimentoVacinacaoMutationVariables = Exact<{
  input: AtendimentoVacinacaoInput
}>

export type SalvarAtendimentoVacinacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtendimentoVacinacao?: {
    readonly __typename?: 'AtendimentoVacinacao'
    readonly id: string
    readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
  } | null
}

export type UltimaVacinaAprazadaQueryVariables = Exact<{
  input: VacinacaoUltimaVacinaInput
}>

export type UltimaVacinaAprazadaQuery = {
  readonly __typename?: 'Query'
  readonly ultimaVacinaAprazada?: {
    readonly __typename?: 'UltimaVacina'
    readonly imunobiologicoNome?: string | null
    readonly dataAprazamento?: any | null
    readonly doseNomeApresentacao?: string | null
  } | null
}

export type UltimasTresVacinasAplicadasQueryVariables = Exact<{
  input: VacinacaoUltimaVacinaInput
}>

export type UltimasTresVacinasAplicadasQuery = {
  readonly __typename?: 'Query'
  readonly ultimasTresVacinasAplicadas?: ReadonlyArray<{
    readonly __typename?: 'UltimaVacina'
    readonly imunobiologicoNome?: string | null
    readonly dataAplicacao?: any | null
    readonly doseNomeApresentacao?: string | null
  } | null> | null
}

export type MedicoesPacEmAtendimentoObservacaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type MedicoesPacEmAtendimentoObservacaoQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
      readonly medicaoAnterior?: boolean | null
    } | null> | null
  }
}

export type AcessoConectesusRndsMutationVariables = Exact<{
  input: AcessoConecteSusInput
}>

export type AcessoConectesusRndsMutation = { readonly __typename?: 'Mutation'; readonly acessoConecteSus: string }

export type AtendimentoProfissionalViewQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type AtendimentoProfissionalViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly tipo: TipoAtendimentoProfissional
    readonly lotacao: { readonly __typename?: 'Lotacao'; readonly id: string }
    readonly estagio?: { readonly __typename?: 'Estagio'; readonly id: string } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly statusAtendimento: StatusAtendimento
      readonly isRegistroTardio: boolean
    } | null
  }
}

export type AtendimentoViewQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtendimentoViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly statusAtendimento: StatusAtendimento
    readonly isRegistroTardio: boolean
    readonly atendimentoProfissional?: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly tipo: TipoAtendimentoProfissional
      readonly lotacao: { readonly __typename?: 'Lotacao'; readonly id: string }
      readonly estagio?: { readonly __typename?: 'Estagio'; readonly id: string } | null
    } | null
  }
}

export type CancelarAtendimentoMutationVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type CancelarAtendimentoMutation = {
  readonly __typename?: 'Mutation'
  readonly cancelarAtendimento: { readonly __typename?: 'Atendimento'; readonly id: string }
}

export type RascunhoAtendimentoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RascunhoAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly atendimentoProfissional?: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly rascunho?: string | null
    } | null
  }
}

export type RegistrosDoseVacinacaoQueryVariables = Exact<{
  input: RegistrosDoseVacinacaoInput
}>

export type RegistrosDoseVacinacaoQuery = {
  readonly __typename?: 'Query'
  readonly registrosDoseVacinacao?: ReadonlyArray<{
    readonly __typename?: 'RegistroDose'
    readonly lote?: string | null
    readonly viaAdministracao?: string | null
    readonly localAplicacao?: string | null
    readonly doseNome?: string | null
    readonly doseSigla?: string | null
    readonly estrategia?: string | null
    readonly estrategiaId?: string | null
    readonly dataAplicacao?: any | null
    readonly dataAprazamento?: any | null
    readonly dataRegistro?: any | null
    readonly dataValidadeLote?: any | null
    readonly profissional?: string | null
    readonly grupoAtendimento?: string | null
    readonly descricao?: string | null
    readonly fabricante?: string | null
    readonly cbo?: string | null
    readonly condicaoMaternal?: CondicaoMaternalDbEnum | null
    readonly isViajante?: boolean | null
    readonly isComunicanteHanseniase?: boolean | null
    readonly unidadeSaude?: string | null
    readonly origemDados?: OrigemDadoEnum | null
    readonly isRegistroAnterior?: boolean | null
    readonly isAplicadoExterior?: boolean | null
    readonly isAplicacaoEquivalente?: boolean | null
    readonly cid10MotivoIndicacao?: string | null
    readonly cid10MotivoIndicacaoCodigoCid?: string | null
    readonly cboPrescritor?: string | null
    readonly isPesquisaClinica?: boolean | null
    readonly anvisaProtocoloEstudo?: string | null
    readonly anvisaProtocoloVersao?: string | null
    readonly anvisaNumeroRegistro?: string | null
  } | null> | null
}

export type AcompanhamentoPreNatalCidadaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AcompanhamentoPreNatalCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly tipoSanguineoEnum?: TipoSanguineoEnum | null
    readonly prontuario?: {
      readonly __typename?: 'Prontuario'
      readonly id: string
      readonly preNatalAtivo?: {
        readonly __typename?: 'PreNatal'
        readonly id: string
        readonly altoRisco: boolean
        readonly gravidezPlanejada?: boolean | null
        readonly ultimaDum?: any | null
        readonly tipoGravidez?: {
          readonly __typename?: 'TipoGravidez'
          readonly id: string
          readonly descricao?: string | null
        } | null
      } | null
      readonly gestacoes?: ReadonlyArray<{
        readonly __typename?: 'PeriodoGestacao'
        readonly id: string
        readonly inicio: any
        readonly fim?: any | null
      }> | null
    } | null
  }
}

export type AcompanhamentoPreNatalExamesQueryVariables = Exact<{
  input: ExamesPreNatalInput
}>

export type AcompanhamentoPreNatalExamesQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoPreNatalExames: ReadonlyArray<{
    readonly __typename?: 'ExamesPreNatalDto'
    readonly procedimentoId: any
    readonly nomeProcedimento: string
    readonly codigoProcedimento: string
    readonly ultimaDataResultado?: any | null
    readonly status: AcompanhamentoPreNatalStatusExameEnum
    readonly registrosNoTrimestre: number
  }>
}

export type AcompanhamentoPreNatalVacinacaoQueryVariables = Exact<{
  input: AcompanhamentosVacinacaoInput
}>

export type AcompanhamentoPreNatalVacinacaoQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoPreNatalVacinacao?: {
    readonly __typename?: 'VacinasPreNatal'
    readonly vacinasAplicadas?: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoPreNatalVacinacao'
      readonly idadeGestacionalEmSemanasAplicacao?: any | null
      readonly vacina: {
        readonly __typename?: 'AcompanhamentoPreNatalVacina'
        readonly idImuno?: any | null
        readonly nomeImuno: string
        readonly siglaDoseImuno?: string | null
        readonly dataRegistro?: any | null
      }
    }> | null
    readonly vacinasAprazadas?: ReadonlyArray<{
      readonly __typename?: 'AcompanhamentoPreNatalVacinacao'
      readonly idadeGestacionalEmSemanasAplicacao?: any | null
      readonly vacina: {
        readonly __typename?: 'AcompanhamentoPreNatalVacina'
        readonly idImuno?: any | null
        readonly nomeImuno: string
        readonly siglaDoseImuno?: string | null
        readonly dataRegistro?: any | null
      }
    }> | null
    readonly ultimaVacinaAplicadaCovid?: {
      readonly __typename?: 'AcompanhamentoPreNatalVacinacao'
      readonly idadeGestacionalEmSemanasAplicacao?: any | null
      readonly vacina: {
        readonly __typename?: 'AcompanhamentoPreNatalVacina'
        readonly idImuno?: any | null
        readonly nomeImuno: string
        readonly siglaDoseImuno?: string | null
        readonly dataRegistro?: any | null
      }
    } | null
    readonly ultimaVacinaAprazadaCovid?: {
      readonly __typename?: 'AcompanhamentoPreNatalVacinacao'
      readonly idadeGestacionalEmSemanasAplicacao?: any | null
      readonly vacina: {
        readonly __typename?: 'AcompanhamentoPreNatalVacina'
        readonly idImuno?: any | null
        readonly nomeImuno: string
        readonly siglaDoseImuno?: string | null
        readonly dataRegistro?: any | null
      }
    } | null
  } | null
}

export type AcompanhamentoUltimosContatosQueryVariables = Exact<{
  input: HistoricoQueryInput
}>

export type AcompanhamentoUltimosContatosQuery = {
  readonly __typename?: 'Query'
  readonly historico: {
    readonly __typename?: 'HistoricoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Historico'
      readonly codigoUnicoRegistro?: string | null
      readonly origemAtendimento?: OrigemDadoEnum | null
      readonly dataAtendimento?: any | null
      readonly tipoAtendProf?: TipoAtendimentoProfissional | null
      readonly tipoApresentacao?: TipoRegistroHistoricoClinico | null
      readonly isAtendRecente: boolean
      readonly idAtendRecente?: string | null
      readonly hasMarcadorConsumoAlimentar: boolean
      readonly hasObservacao?: boolean | null
      readonly ciapNome?: string | null
      readonly ciapCodigo?: string | null
      readonly cidNome?: string | null
      readonly cidCodigo?: string | null
      readonly classificacaoPrioridade?: string | null
      readonly reclassificacaoPrioridade?: string | null
      readonly conduta?: string | null
      readonly cnsSolicitante?: string | null
      readonly nomeSolicitante?: string | null
      readonly cboSolicitante?: string | null
      readonly ineSolicitante?: string | null
      readonly siglaEquipeSolicitante?: string | null
      readonly nomeUbsSolicitante?: string | null
      readonly cnsExecutante?: string | null
      readonly nomeExecutante?: string | null
      readonly cboExecutante?: string | null
      readonly ineExecutante?: string | null
      readonly siglaEquipeExecutante?: string | null
      readonly nomeUbsExecutante?: string | null
      readonly profissional?: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      } | null
      readonly cbo?: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly cuidadoCompartilhado?: {
        readonly __typename?: 'CuidadoCompartilhado'
        readonly id: string
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly lotacaoSolicitante: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        }
      } | null
      readonly cuidadoCompartilhadoEvolucao?: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly id: string
        readonly conduta: CondutaCuidadoCompartilhadoEnum
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly reclassificacaoPrioridade?: ClassificacaoPrioridadeCuidadoEnum | null
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AcompanhamentoPreNatalVacinaFragmentFragment = {
  readonly __typename?: 'AcompanhamentoPreNatalVacinacao'
  readonly idadeGestacionalEmSemanasAplicacao?: any | null
  readonly vacina: {
    readonly __typename?: 'AcompanhamentoPreNatalVacina'
    readonly idImuno?: any | null
    readonly nomeImuno: string
    readonly siglaDoseImuno?: string | null
    readonly dataRegistro?: any | null
  }
}

export type AcompanhamentoPuerperioAtividadesColetivasQueryVariables = Exact<{
  input: AtividadeColetivaQueryInput
  cidadaoId: Scalars['Long']['input']
}>

export type AcompanhamentoPuerperioAtividadesColetivasQuery = {
  readonly __typename?: 'Query'
  readonly atividadesColetivas: {
    readonly __typename?: 'AtividadeColetivaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtividadeColetiva'
      readonly id: string
      readonly uuid: string
      readonly dataAtividade: any
      readonly tipoAtividade: TipoAtividadeEnum
      readonly turno: TurnoEnum
      readonly lotacaoResponsavel: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
      }
      readonly participante?: {
        readonly __typename?: 'AtividadeColetivaRegistroParticipante'
        readonly id: string
        readonly cidadao?: {
          readonly __typename?: 'Cidadao'
          readonly id: string
          readonly cpf?: string | null
          readonly cns?: string | null
          readonly nomeSocial?: string | null
        } | null
      } | null
      readonly observacao?: {
        readonly __typename?: 'AtividadeColetivaObservacaoCidadao'
        readonly id: string
        readonly cidadao: {
          readonly __typename?: 'Cidadao'
          readonly id: string
          readonly cpf?: string | null
          readonly cns?: string | null
          readonly nomeSocial?: string | null
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AcompanhamentoPuerperioExamesQueryVariables = Exact<{
  input: AcompanhamentosProntuarioInput
}>

export type AcompanhamentoPuerperioExamesQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoPuerperioExames: {
    readonly __typename?: 'AcompanhamentoPuerperioExamesPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ExamesPuerperioDto'
      readonly procedimentoId: any
      readonly nomeProcedimento: string
      readonly codigoProcedimento: string
      readonly ultimaDataRealizacao: any
      readonly registros: number
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AcompanhamentoPuerperioMedicoesQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  ultimoRegistroComPeso?: InputMaybe<Scalars['Boolean']['input']>
}>

export type AcompanhamentoPuerperioMedicoesQuery = {
  readonly __typename?: 'Query'
  readonly medicoes: ReadonlyArray<{
    readonly __typename?: 'Medicao'
    readonly id: string
    readonly dataMedicao: any
    readonly valorPeso?: number | null
    readonly valorAltura?: number | null
    readonly valorPressaoArterial?: string | null
    readonly medicaoAnterior?: boolean | null
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      }
    }
  }>
}

export type AcompanhamentoPuerperioVisitasDomiciliaresQueryVariables = Exact<{
  input: AcompanhamentosVisitasDomiciliaresInput
}>

export type AcompanhamentoPuerperioVisitasDomiciliaresQuery = {
  readonly __typename?: 'Query'
  readonly acompanhamentoPuerperioVisitasDomiciliares: {
    readonly __typename?: 'AcompanhamentosVisitasDomiciliaresPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FatoVisitaDomiciliar'
      readonly id: string
      readonly nuUuidFicha: string
      readonly dataVisita?: any | null
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly origem?: OrigemDadoEnum | null
      readonly turno?: { readonly __typename?: 'DimensaoTurno'; readonly id: string; readonly descricao: string } | null
      readonly dimensaoDesfechoVisita: {
        readonly __typename?: 'DimensaoDesfechoVisita'
        readonly id: string
        readonly descricao: string
      }
      readonly dimensaoProfissional?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly nome?: string | null
      } | null
      readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
      readonly dimensaoEquipe?: {
        readonly __typename?: 'DimensaoEquipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type InformacoesPuerperioQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type InformacoesPuerperioQuery = {
  readonly __typename?: 'Query'
  readonly informacoesPuerperio: {
    readonly __typename?: 'InformacoesPuerperioDto'
    readonly dataInicioGestacao?: any | null
    readonly preNatal?: {
      readonly __typename?: 'PreNatal'
      readonly id: string
      readonly altoRisco: boolean
      readonly dataDesfecho?: any | null
      readonly ultimaDum?: any | null
      readonly fonteIdadeGestacional?: FonteIdadeGestacionalEnum | null
      readonly tipoGravidez?: {
        readonly __typename?: 'TipoGravidez'
        readonly id: string
        readonly descricao?: string | null
      } | null
    } | null
  }
}

export type AlergiasModalQueryVariables = Exact<{
  filtro: AlergiasQueryInput
}>

export type AlergiasModalQuery = {
  readonly __typename?: 'Query'
  readonly alergias: {
    readonly __typename?: 'AlergiaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Alergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
      readonly substanciaEspecificaLegado?: string | null
      readonly substanciaEspecifica?: {
        readonly __typename?: 'SubstanciaEspecificaAlergia'
        readonly sigla?: string | null
        readonly id: string
        readonly coSubstanciaEspecifica: any
        readonly coPrincipioAtivo?: any | null
        readonly categoria: CategoriaSubstanciaAlergia
        readonly nome: string
      } | null
      readonly ultimaEvolucao: {
        readonly __typename?: 'EvolucaoAlergia'
        readonly id: string
        readonly dataInicio?: any | null
        readonly manifestacoesLegado?: string | null
        readonly possuiSubstanciaEspecificaCbara?: boolean | null
        readonly atualizadoEm: any
        readonly manifestacoes: ReadonlyArray<{
          readonly __typename?: 'ManifestacaoAlergia'
          readonly id: string
          readonly nome: string
          readonly sinonimo?: string | null
        }>
      }
      readonly evolucoes: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAlergia'
        readonly id: string
        readonly tipoReacao?: TipoReacaoAlergia | null
        readonly criticidade: CriticidadeAlergia
        readonly grauCerteza: GrauCertezaAlergia
        readonly dataInicio?: any | null
        readonly manifestacoesLegado?: string | null
        readonly atualizadoEm: any
        readonly observacao?: string | null
        readonly possuiSubstanciaEspecificaCbara?: boolean | null
        readonly manifestacoes: ReadonlyArray<{
          readonly __typename?: 'ManifestacaoAlergia'
          readonly id: string
          readonly nome: string
        }>
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
      }>
    }>
  }
}

export type LembretesModalQueryVariables = Exact<{
  lembretesQueryInput: LembretesQueryInput
}>

export type LembretesModalQuery = {
  readonly __typename?: 'Query'
  readonly lembretes: ReadonlyArray<{
    readonly __typename?: 'Lembrete'
    readonly id: string
    readonly historicoLembrete: ReadonlyArray<{
      readonly __typename?: 'LembreteEvolucao'
      readonly id: string
      readonly visibilidadeLembrete: VisibilidadeLembreteEnum
      readonly ativo: boolean
      readonly descricao: string
      readonly data: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    } | null>
    readonly profissionalCriador: { readonly __typename?: 'Profissional'; readonly id: string }
  } | null>
}

export type ExisteProblemaResolvidoQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type ExisteProblemaResolvidoQuery = { readonly __typename?: 'Query'; readonly existeProblemaResolvido: boolean }

export type ProblemasModalQueryVariables = Exact<{
  filtro: ProblemaQueryInput
  cid11Enable?: Scalars['Boolean']['input']
}>

export type ProblemasModalQuery = {
  readonly __typename?: 'Query'
  readonly problemas: {
    readonly __typename?: 'ProblemaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Problema'
      readonly id: string
      readonly situacao: SituacaoProblema
      readonly descricaoOutro?: string | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid11?: {
        readonly __typename?: 'Cid11'
        readonly id: string
        readonly codigo: string
        readonly nome: string
        readonly ativo: boolean
      } | null
      readonly ultimaEvolucao: {
        readonly __typename?: 'EvolucaoProblema'
        readonly id: string
        readonly dataInicio?: any | null
        readonly dataFim?: any | null
        readonly atualizadoEm?: any | null
        readonly situacao: SituacaoProblema
        readonly observacao?: string | null
      }
      readonly evolucaoAvaliacaoCiapCid?: {
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
      } | null
      readonly evolucoes: ReadonlyArray<{
        readonly __typename?: 'EvolucaoProblema'
        readonly id: string
        readonly dataInicio?: any | null
        readonly dataFim?: any | null
        readonly situacao: SituacaoProblema
        readonly observacao?: string | null
        readonly atualizadoEm?: any | null
        readonly possuiCiap: boolean
        readonly possuiCid: boolean
        readonly possuiCid11: boolean
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
      }>
    }>
  }
}

export type ProblemasModalSimplificadoQueryVariables = Exact<{
  filtro: ProblemaQueryInput
}>

export type ProblemasModalSimplificadoQuery = {
  readonly __typename?: 'Query'
  readonly problemas: {
    readonly __typename?: 'ProblemaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Problema'
      readonly id: string
      readonly situacao: SituacaoProblema
      readonly descricaoOutro?: string | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid11?: {
        readonly __typename?: 'Cid11'
        readonly id: string
        readonly codigo: string
        readonly nome: string
        readonly ativo: boolean
      } | null
      readonly ultimaEvolucao: {
        readonly __typename?: 'EvolucaoProblema'
        readonly id: string
        readonly dataInicio?: any | null
        readonly dataFim?: any | null
        readonly situacao: SituacaoProblema
        readonly observacao?: string | null
        readonly atualizadoEm?: any | null
      }
      readonly evolucaoAvaliacaoCiapCid?: {
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
      } | null
    }>
  }
}

export type MedicamentoUsoModalQueryVariables = Exact<{
  input: ListaMedicamentoAtivoConcluidoQueryInput
}>

export type MedicamentoUsoModalQuery = {
  readonly __typename?: 'Query'
  readonly listaMedicamento: {
    readonly __typename?: 'ListaMedicamentoAtivoConcluidoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly usoContinuo?: boolean | null
      readonly posologia: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly tipoReceita?: TipoReceitaEnum | null
      readonly recomendacoes?: string | null
      readonly tratamentoInterrompido?: boolean | null
      readonly justificativaInterrupcao?: string | null
      readonly dtInterrupcao?: any | null
      readonly registroManual?: boolean | null
      readonly doseUnica?: boolean | null
      readonly dose?: string | null
      readonly qtDose?: string | null
      readonly qtDoseManha?: string | null
      readonly qtDoseTarde?: string | null
      readonly qtDoseNoite?: string | null
      readonly tipoFrequenciaDose?: TipoFrequencia | null
      readonly frequenciaDose?: string | null
      readonly qtPeriodoFrequencia?: number | null
      readonly medidaTempoFrequencia?: UnidadeMedidaTempoEnum | null
      readonly qtDuracaoTratamento?: number | null
      readonly quantidadeReceitada: number
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly principioAtivoFiltro?: string | null
        readonly concentracao?: string | null
        readonly unidadeFornecimento?: string | null
        readonly medicamentoCatmat?: {
          readonly __typename?: 'MedicamentoCatmat'
          readonly id: string
          readonly codigoCatMat?: string | null
          readonly codigoRename?: string | null
          readonly volume?: string | null
          readonly unidadeFornecimento: {
            readonly __typename?: 'UnidadeMedida'
            readonly id: string
            readonly nome: string
            readonly nomePlural: string
          }
          readonly principioAtivo: {
            readonly __typename?: 'PrincipioAtivo'
            readonly id: string
            readonly nome: string
            readonly listaMaterial: {
              readonly __typename?: 'ListaMedicamento'
              readonly id: string
              readonly tipoReceita: TipoReceitaEnum
              readonly tipo: string
            }
          }
        } | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly aplicacaoMedicamento: {
        readonly __typename?: 'AplicacaoMedicamento'
        readonly id: string
        readonly nome: string
      }
      readonly atendProf?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly versaoAnterior?: boolean | null
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      } | null
      readonly receitaUsoContinuoGrupo?: {
        readonly __typename?: 'ReceitaMedicamento'
        readonly id: string
        readonly dtInicioTratamento?: any | null
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly ativo?: boolean | null
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly unidadeMedidaDose?: {
        readonly __typename?: 'UnidadeMedida'
        readonly id: string
        readonly nome: string
        readonly nomePlural: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type MedicoesAtendimentosAnterioresQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  ultimoRegistroComPeso?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MedicoesAtendimentosAnterioresQuery = {
  readonly __typename?: 'Query'
  readonly medicoes: ReadonlyArray<{
    readonly __typename?: 'Medicao'
    readonly id: string
    readonly dataMedicao: any
    readonly dum?: any | null
    readonly valorPeso?: number | null
    readonly valorAltura?: number | null
    readonly valorFrequenciaCardiaca?: number | null
    readonly valorPressaoArterial?: string | null
    readonly valorPerimetroCefalico?: number | null
    readonly valorFrequenciaRespiratoria?: number | null
    readonly valorTemperatura?: number | null
    readonly valorSaturacaoO2?: number | null
    readonly valorGlicemia?: number | null
    readonly tipoGlicemia?: TipoGlicemia | null
    readonly valorImc?: number | null
    readonly perimetroPanturrilha?: number | null
    readonly valorCircunferenciaAbdominal?: number | null
    readonly medicaoAnterior?: boolean | null
    readonly valorAlturaUterina?: string | null
    readonly valorForcaMuscMaoDireita?: string | null
    readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
    readonly valorForcaMuscMaoEsquerda?: string | null
    readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      }
    }
  }>
  readonly medicoesNoNascimento?: {
    readonly __typename?: 'Antecedente'
    readonly id: string
    readonly peso?: string | null
    readonly altura?: string | null
    readonly perimetroCefalico?: string | null
    readonly dataUltimaAtualizacao?: any | null
  } | null
}

export type AcompanhamentoPreNatalQueryVariables = Exact<{
  input: Scalars['ID']['input']
  onlyProblemaAtivo?: InputMaybe<Scalars['Boolean']['input']>
}>

export type AcompanhamentoPreNatalQuery = {
  readonly __typename?: 'Query'
  readonly atendimentosProfUltimaGestacao?: ReadonlyArray<{
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly iniciadoEm: any
    readonly atendimentoProfissionalPreNatal?: {
      readonly __typename?: 'AtendimentoProfissionalPreNatal'
      readonly id: string
      readonly movimentacaoFetal?: boolean | null
      readonly tipoEdema?: TipoEdemaEnum | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly dataMedicao: any
      readonly valorBatimentoCardiacoFetal?: string | null
      readonly valorBatimentoCardiacoFetal2?: string | null
      readonly dum?: any | null
      readonly valorAlturaUterina?: string | null
      readonly valorPressaoArterial?: string | null
      readonly valorPeso?: number | null
      readonly valorGlicemia?: number | null
      readonly medicaoAnterior?: boolean | null
    } | null> | null
  } | null> | null
}

export type HistoricoResultadosExamesQueryVariables = Exact<{
  input: ResultadosExameQueryInput
}>

export type HistoricoResultadosExamesQuery = {
  readonly __typename?: 'Query'
  readonly resultadosExame: {
    readonly __typename?: 'ResultadosExamePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly resultado?: string | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly dataSolicitacao?: any | null
      readonly conferido?: boolean | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly solicitacao?: {
        readonly __typename?: 'SolicitacaoExame'
        readonly id: string
        readonly data: any
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
      } | null
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
      readonly atendimentoProfissionalResultado?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      } | null
    } | null>
  }
}

export type BeneficiarioBolsaFamiliaFragment = {
  readonly __typename?: 'Cidadao'
  readonly beneficiarioBolsaFamilia: {
    readonly __typename?: 'BeneficiarioBolsaFamilia'
    readonly id: string
    readonly isBeneficiario: boolean
    readonly vigencia?: string | null
  }
}

export type IsBeneficiarioBolsaFamiliaQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type IsBeneficiarioBolsaFamiliaQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly beneficiarioBolsaFamilia: {
      readonly __typename?: 'BeneficiarioBolsaFamilia'
      readonly id: string
      readonly isBeneficiario: boolean
    }
  }
}

export type DadosEscutaPreAtendimentoQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type DadosEscutaPreAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly finalizadoEm?: any | null
    readonly classificacaoRisco?: ClassificacaoRisco | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly tipoProcedimento?: TipoProcedimentoEnum | null
      }
    } | null> | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
    }
  } | null
}

export type EscutaPreAtendimentoMaisRecenteQueryVariables = Exact<{
  input: EscutaOrPreAtendimentoOfAtendimentoInput
}>

export type EscutaPreAtendimentoMaisRecenteQuery = {
  readonly __typename?: 'Query'
  readonly escutaOrPreAtendimentoOfAtendimento?: string | null
}

export type CuidadoCompartilhadoDwFragment = {
  readonly __typename?: 'Historico'
  readonly ciapNome?: string | null
  readonly ciapCodigo?: string | null
  readonly cidNome?: string | null
  readonly cidCodigo?: string | null
  readonly classificacaoPrioridade?: string | null
  readonly reclassificacaoPrioridade?: string | null
  readonly conduta?: string | null
  readonly cnsSolicitante?: string | null
  readonly nomeSolicitante?: string | null
  readonly cboSolicitante?: string | null
  readonly ineSolicitante?: string | null
  readonly siglaEquipeSolicitante?: string | null
  readonly nomeUbsSolicitante?: string | null
  readonly cnsExecutante?: string | null
  readonly nomeExecutante?: string | null
  readonly cboExecutante?: string | null
  readonly ineExecutante?: string | null
  readonly siglaEquipeExecutante?: string | null
  readonly nomeUbsExecutante?: string | null
}

export type DadosUltimosContatosQueryVariables = Exact<{
  input: HistoricoQueryInput
}>

export type DadosUltimosContatosQuery = {
  readonly __typename?: 'Query'
  readonly historico: {
    readonly __typename?: 'HistoricoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Historico'
      readonly codigoUnicoRegistro?: string | null
      readonly origemAtendimento?: OrigemDadoEnum | null
      readonly dataAtendimento?: any | null
      readonly turno?: TurnoEnum | null
      readonly tipoAtendProf?: TipoAtendimentoProfissional | null
      readonly tipoApresentacao?: TipoRegistroHistoricoClinico | null
      readonly isCancelado?: boolean | null
      readonly coSubtipoAtendimento?: number | null
      readonly classificacaoRisco?: ClassificacaoRisco | null
      readonly dadosClinicos?: string | null
      readonly condicoesAvaliadas: ReadonlyArray<string>
      readonly examesRealizadosZika?: ReadonlyArray<string | null> | null
      readonly tipoConsultaOdonto?: TipoConsultaOdontoEnum | null
      readonly isAtendRecente: boolean
      readonly idAtendRecente?: string | null
      readonly idAtividadeColetiva?: string | null
      readonly idCidadao?: string | null
      readonly cpfCnsCidadao?: string | null
      readonly hasObservacao?: boolean | null
      readonly hasCuidadoCompartilhado: boolean
      readonly ciapNome?: string | null
      readonly ciapCodigo?: string | null
      readonly cidNome?: string | null
      readonly cidCodigo?: string | null
      readonly classificacaoPrioridade?: string | null
      readonly reclassificacaoPrioridade?: string | null
      readonly conduta?: string | null
      readonly cnsSolicitante?: string | null
      readonly nomeSolicitante?: string | null
      readonly cboSolicitante?: string | null
      readonly ineSolicitante?: string | null
      readonly siglaEquipeSolicitante?: string | null
      readonly nomeUbsSolicitante?: string | null
      readonly cnsExecutante?: string | null
      readonly nomeExecutante?: string | null
      readonly cboExecutante?: string | null
      readonly ineExecutante?: string | null
      readonly siglaEquipeExecutante?: string | null
      readonly nomeUbsExecutante?: string | null
      readonly idadeGestacional?: {
        readonly __typename?: 'IdadeGestacional'
        readonly dias: number
        readonly semanas: number
      } | null
      readonly cuidadoCompartilhado?: {
        readonly __typename?: 'CuidadoCompartilhado'
        readonly id: string
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly lotacaoSolicitante: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        }
      } | null
      readonly cuidadoCompartilhadoEvolucao?: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly id: string
        readonly conduta: CondutaCuidadoCompartilhadoEnum
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly reclassificacaoPrioridade?: ClassificacaoPrioridadeCuidadoEnum | null
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      } | null
    } | null>
  }
}

export type VideochamadaAtendimentoQueryVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type VideochamadaAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly agendado?: {
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly lotacaoAgendada: { readonly __typename?: 'Lotacao'; readonly id: string }
      readonly lotacaoParticipante?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly email?: string | null
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        } | null
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      } | null
      readonly videochamada?: {
        readonly __typename?: 'Videochamada'
        readonly id: string
        readonly uuid: string
      } | null
    } | null
  }
}

export type FolhaRostoVulnerabilidadeFamiliarQueryVariables = Exact<{
  input: CidadaosQueryInput
}>

export type FolhaRostoVulnerabilidadeFamiliarQuery = {
  readonly __typename?: 'Query'
  readonly cidadaos: {
    readonly __typename?: 'CidadaosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly familias: ReadonlyArray<{
        readonly __typename?: 'Familia'
        readonly id: string
        readonly vulnerabilidadeFamiliar?: {
          readonly __typename?: 'VulnerabilidadeFamiliar'
          readonly id: string
          readonly classificacao: ClassificacaoVulnerabilidadeFamiliar
          readonly grauSugestivo?: GrauSugestivoVulnerabilidadeFamiliar | null
          readonly escore?: number | null
          readonly classificacaoSubestimada?: boolean | null
          readonly criterios: {
            readonly __typename?: 'CriteriosVulnerabilidadeFamiliar'
            readonly criteriosInequivocos: ReadonlyArray<string>
            readonly criteriosSugestivos: ReadonlyArray<string>
            readonly criteriosPontuados: ReadonlyArray<{
              readonly __typename?: 'CriterioPontuadoVulnerabilidadeFamiliar'
              readonly id: string
              readonly descricao: string
              readonly numeroMoradores?: number | null
              readonly peso: number
              readonly resultado: number
            }>
          }
        } | null
        readonly imovel?: {
          readonly __typename?: 'ImovelDto'
          readonly id: string
          readonly possuiInconsistencia?: boolean | null
        } | null
      }>
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AlertasSdcQueryVariables = Exact<{
  input: SdcInput
}>

export type AlertasSdcQuery = {
  readonly __typename?: 'Query'
  readonly eventosSdc: ReadonlyArray<
    | {
        readonly __typename?: 'AlertaSdc'
        readonly id: string
        readonly titulo?: string | null
        readonly subtitulo?: string | null
        readonly acompanhamento?: string | null
        readonly exames?: string | null
        readonly tituloMedicamentos?: string | null
        readonly medicamentos?: string | null
        readonly recomendacoes?: string | null
        readonly tituloRetorno?: string | null
        readonly retorno?: string | null
        readonly tituloOrientacoes?: string | null
        readonly orientacoes?: string | null
        readonly conteudoPersonalizado?: string | null
        readonly tituloReferencias?: string | null
        readonly referencias?: ReadonlyArray<string> | null
        readonly notificar: boolean
        readonly conjuntoFatoresSdc?: {
          readonly __typename?: 'ConjuntoFatoresSdcDto'
          readonly fatoresNaoVerificadosSdc: string
          readonly fatoresVerificadosSdc: {
            readonly __typename?: 'SdcFatoresVerificadosDto'
            readonly descricao: string
            readonly fatores: ReadonlyArray<{
              readonly __typename?: 'SdcFatorVerificadoDto'
              readonly fatorRisco: string
              readonly ondeSistemaVerifica: string
            }>
          }
        } | null
        readonly riscos?: ReadonlyArray<{
          readonly __typename?: 'Risco'
          readonly estratificacao?: EstratificacaoRisco | null
          readonly origem?: string | null
          readonly descricaoOrigem?: string | null
          readonly grupo?: GrupoRisco | null
        }> | null
      }
    | {
        readonly __typename?: 'CondutaSdc'
        readonly id: string
        readonly titulo?: string | null
        readonly subtitulo?: string | null
        readonly diferencial?: string | null
        readonly tipo: TipoCondutaSdcEnum
        readonly observacao?: string | null
        readonly grupoDengue?: GrupoSdcDengueEnum | null
        readonly prescricoes: ReadonlyArray<{
          readonly __typename?: 'PrescricaoSdcDto'
          readonly titulo: string
          readonly medicamentos: ReadonlyArray<{
            readonly __typename?: 'ReceitaMedicamentoSdcDto'
            readonly posologia: string
            readonly medidaTempoFrequencia?: UnidadeMedidaTempoEnum | null
            readonly quantidadeReceitada: number
            readonly recomendacoes?: string | null
            readonly quantidadeDose?: string | null
            readonly tipoFrequenciaDose?: TipoFrequencia | null
            readonly intervaloFrequencia?: number | null
            readonly duracaoTratamentoEmDias?: number | null
            readonly prescrever: boolean
            readonly motivoRestricaoPrescricao?: string | null
            readonly tipoMotivoPrescricao?: string | null
            readonly idMotivoPrescricao?: any | null
            readonly codigoMotivoPrescricao?: string | null
            readonly nomeMotivoPrescricao?: string | null
            readonly medicamentoCatmat?: {
              readonly __typename?: 'MedicamentoCatmat'
              readonly id: string
              readonly volume?: string | null
              readonly codigoCatMat?: string | null
              readonly codigoRename?: string | null
              readonly medicamento: {
                readonly __typename?: 'Medicamento'
                readonly id: string
                readonly principioAtivo: string
                readonly unidadeFornecimento?: string | null
                readonly concentracao?: string | null
                readonly formaFarmaceutica?: {
                  readonly __typename?: 'FormaFarmaceutica'
                  readonly id: string
                  readonly nome: string
                } | null
              }
              readonly unidadeFornecimento: {
                readonly __typename?: 'UnidadeMedida'
                readonly id: string
                readonly nome: string
                readonly nomePlural: string
              }
              readonly principioAtivo: {
                readonly __typename?: 'PrincipioAtivo'
                readonly id: string
                readonly nome: string
                readonly listaMaterial: {
                  readonly __typename?: 'ListaMedicamento'
                  readonly id: string
                  readonly tipo: string
                  readonly tipoReceita: TipoReceitaEnum
                }
              }
              readonly unidadeMedidaDose?: {
                readonly __typename?: 'UnidadeMedida'
                readonly id: string
                readonly nome: string
                readonly nomePlural: string
              } | null
            } | null
            readonly aplicacaoMedicamento: {
              readonly __typename?: 'AplicacaoMedicamento'
              readonly id: string
              readonly nome: string
            }
            readonly unidadeMedidaDose?: {
              readonly __typename?: 'UnidadeMedida'
              readonly id: string
              readonly nome: string
              readonly nomePlural: string
            } | null
          }>
        }>
        readonly examesSdc?: {
          readonly __typename?: 'ExamesSdcDto'
          readonly tipoExame: TipoExameEnum
          readonly justificativa?: string | null
          readonly gruposProcedimentosSdcDto?: ReadonlyArray<{
            readonly __typename?: 'GruposProcedimentosSdcDto'
            readonly titulo: string
            readonly procedimentosSdcDto?: ReadonlyArray<{
              readonly __typename?: 'ProcedimentoSdcDto'
              readonly observacao?: string | null
              readonly previamentePrescrito: boolean
              readonly exameSolicitado?: {
                readonly __typename?: 'Procedimento'
                readonly id: string
                readonly descricao: string
                readonly codigo: string
                readonly ativo?: boolean | null
                readonly procedimentoReferencia?: {
                  readonly __typename?: 'Procedimento'
                  readonly id: string
                  readonly descricao: string
                  readonly codigo: string
                  readonly ativo?: boolean | null
                } | null
              } | null
            } | null> | null
          } | null> | null
          readonly cid10?: {
            readonly __typename?: 'Cid10'
            readonly id: string
            readonly codigo: string
            readonly nome: string
          } | null
        } | null
        readonly atestadosSdc: ReadonlyArray<{
          readonly __typename?: 'AtestadoSdcDto'
          readonly tipoAtestado: TipoAtestadoEnum
          readonly dias: number
          readonly cid10?: {
            readonly __typename?: 'Cid10'
            readonly id: string
            readonly codigo: string
            readonly nome: string
          } | null
        }>
      }
  >
}

export type AtendimentoHeaderCidadaoQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
  fetchCidadaoVinculacaoEquipeAndTelefones: Scalars['Boolean']['input']
}>

export type AtendimentoHeaderCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly nomeTradicional?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly nomeMae?: string | null
    readonly telefoneResidencial?: string | null
    readonly telefoneCelular?: string | null
    readonly telefoneContato?: string | null
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly ativo?: boolean | null
    readonly faleceu?: boolean | null
    readonly unificado?: boolean | null
    readonly unificacaoBase?: string | null
    readonly cidadaoVinculacaoEquipe?: {
      readonly __typename?: 'CidadaoVinculacaoEquipe'
      readonly id?: string | null
      readonly unidadeSaude?: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      } | null
    } | null
  }
}

export type ConfiguracaoRndsQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoRndsQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
  }
  readonly configuracaoCertificadoHabilitado?: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly rndsHabilitado: boolean
  } | null
}

export type ConfiguracaoSistemasExternosAtendimentoQueryVariables = Exact<{
  input?: InputMaybe<IframesQueryInput>
}>

export type ConfiguracaoSistemasExternosAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly hasIframes: boolean
}

export type BuscaListagemHistoricoClinicoQueryVariables = Exact<{
  input: HistoricoQueryInput
}>

export type BuscaListagemHistoricoClinicoQuery = {
  readonly __typename?: 'Query'
  readonly historico: {
    readonly __typename?: 'HistoricoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Historico'
      readonly idAtendRecente?: string | null
      readonly idAtendProcessado?: string | null
      readonly codigoUnicoRegistro?: string | null
      readonly dataAtendimento?: any | null
      readonly dataInativacao?: any | null
      readonly dataUltimaRetificacao?: any | null
      readonly turno?: TurnoEnum | null
      readonly tipoApresentacao?: TipoRegistroHistoricoClinico | null
      readonly tipoAtendProf?: TipoAtendimentoProfissional | null
      readonly isCancelado?: boolean | null
      readonly isInativo: boolean
      readonly isRetificado: boolean
      readonly coSubtipoAtendimento?: number | null
      readonly origemAtendimento?: OrigemDadoEnum | null
      readonly cpfCnsCidadao?: string | null
      readonly classificacaoRisco?: ClassificacaoRisco | null
      readonly idAtividadeColetiva?: string | null
      readonly idCidadao?: string | null
      readonly isAtendRecente: boolean
      readonly condicoesAvaliadas: ReadonlyArray<string>
      readonly examesRealizadosZika?: ReadonlyArray<string | null> | null
      readonly cnsProfissional?: string | null
      readonly isVersaoFichaRetificavel: boolean
      readonly hasPrescricaoMedicamento?: boolean | null
      readonly hasOrientacao?: boolean | null
      readonly hasAtestado?: boolean | null
      readonly hasLembrete?: boolean | null
      readonly hasAlergia?: boolean | null
      readonly hasSolicitacaoExame?: boolean | null
      readonly hasResultadoExame?: boolean | null
      readonly hasEncaminhamento?: boolean | null
      readonly hasEncaminhamentoEspecializado?: boolean | null
      readonly hasProcedimentoClinico?: boolean | null
      readonly hasMarcadorConsumoAlimentar: boolean
      readonly hasCuidadoCompartilhado: boolean
      readonly hasGuiasEncaminhamentos: boolean
      readonly hasIvcf?: boolean | null
      readonly hasAnexoArquivo: boolean
      readonly hasMchat?: boolean | null
      readonly dadosClinicos?: string | null
      readonly tipoConsultaOdonto?: TipoConsultaOdontoEnum | null
      readonly hasObservacao?: boolean | null
      readonly isAtendObsFinalizado?: boolean | null
      readonly inicioAtendimentoObservacao?: any | null
      readonly fimAtendimentoObservacao?: any | null
      readonly nomeFinalizadorObservacao?: string | null
      readonly cnsFinalizadorObservacao?: string | null
      readonly cboFinalizadorObservacao?: string | null
      readonly ubsFinalizadorObservacao?: string | null
      readonly ineFinalizadorObservacao?: string | null
      readonly ciapNome?: string | null
      readonly ciapCodigo?: string | null
      readonly cidNome?: string | null
      readonly cidCodigo?: string | null
      readonly classificacaoPrioridade?: string | null
      readonly reclassificacaoPrioridade?: string | null
      readonly conduta?: string | null
      readonly cnsSolicitante?: string | null
      readonly nomeSolicitante?: string | null
      readonly cboSolicitante?: string | null
      readonly ineSolicitante?: string | null
      readonly siglaEquipeSolicitante?: string | null
      readonly nomeUbsSolicitante?: string | null
      readonly cnsExecutante?: string | null
      readonly nomeExecutante?: string | null
      readonly cboExecutante?: string | null
      readonly ineExecutante?: string | null
      readonly siglaEquipeExecutante?: string | null
      readonly nomeUbsExecutante?: string | null
      readonly idadeGestacional?: {
        readonly __typename?: 'IdadeGestacional'
        readonly dias: number
        readonly semanas: number
      } | null
      readonly profissional?: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      } | null
      readonly cbo?: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      } | null
      readonly estagiario?: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      } | null
      readonly cboEstagio?: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      } | null
      readonly unidadeSaude?: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly condicoesVacinacao?: {
        readonly __typename?: 'CondicoesVacinacao'
        readonly idAtend: string
        readonly isViajante?: boolean | null
        readonly condicaoMaternal?: CondicaoMaternalDbEnum | null
        readonly isComunicanteHanseniase?: boolean | null
      } | null
      readonly fichasConcatenadas?: {
        readonly __typename?: 'FichasConcatenadasHistorico'
        readonly uuidProcedimento?: string | null
        readonly uuidZika?: string | null
      } | null
      readonly cuidadoCompartilhadoEvolucao?: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly id: string
        readonly conduta: CondutaCuidadoCompartilhadoEnum
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly reclassificacaoPrioridade?: ClassificacaoPrioridadeCuidadoEnum | null
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      } | null
      readonly cuidadoCompartilhado?: {
        readonly __typename?: 'CuidadoCompartilhado'
        readonly id: string
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly lotacaoSolicitante: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HistoricoAntecedentesPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly antecedentes?: {
    readonly __typename?: 'AntecedenteItemDto'
    readonly id: string
    readonly observacoes?: string | null
    readonly puericultura?: {
      readonly __typename?: 'AntecedentePuericulturaDto'
      readonly tipoGravidez?: string | null
      readonly tipoParto?: string | null
      readonly idadeGestacionalDias?: string | null
      readonly idadeGestacionalSemanas?: string | null
      readonly apgarUm?: string | null
      readonly apgarCinco?: string | null
      readonly apgarDez?: string | null
      readonly peso?: string | null
      readonly comprimento?: string | null
      readonly perimetroCefalico?: string | null
    } | null
    readonly informacoesObstetricas?: {
      readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
      readonly gestaPrevias?: string | null
      readonly abortos?: string | null
      readonly partos?: string | null
      readonly partosVaginais?: string | null
      readonly partosCesareas?: string | null
      readonly partosDomiciliares?: string | null
      readonly nascidosVivos?: string | null
      readonly natimortos?: string | null
      readonly recemNascidoAbaixo?: string | null
      readonly recemNascidoAcima?: string | null
      readonly filhosVivos?: string | null
      readonly obitoAntesPrimeiraSemana?: string | null
      readonly obitoAposPrimeiraSemana?: string | null
      readonly desfechoUltimaGestacao?: string | null
    } | null
  } | null
  readonly cirurgiasInternacoes?: ReadonlyArray<{
    readonly __typename?: 'AntecedenteCirurgiasInternacoes'
    readonly id: string
    readonly descricao: string
    readonly observacoes?: string | null
    readonly dataCirurgiaInternacao?: any | null
  } | null> | null
}

export type HistoricoAvaliacaoPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly evolucaoAvaliacao?: {
    readonly __typename?: 'EvolucaoAvaliacao'
    readonly id: string
    readonly descricao?: string | null
    readonly ciapsCids?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
      readonly id: string
      readonly nota?: string | null
      readonly isCiapCidNaListaDeProblemas: boolean
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid11?: {
        readonly __typename?: 'Cid11'
        readonly id: string
        readonly codigo: string
        readonly nome: string
        readonly ativo: boolean
      } | null
    }> | null
  } | null
  readonly evolucaoProblema?: ReadonlyArray<{
    readonly __typename?: 'EvolucaoProblema'
    readonly id: string
    readonly dataInicio?: any | null
    readonly dataFim?: any | null
    readonly situacao: SituacaoProblema
    readonly observacao?: string | null
    readonly atualizadoEm?: any | null
    readonly possuiCid: boolean
    readonly possuiCid11: boolean
    readonly possuiCiap: boolean
    readonly problema?: {
      readonly __typename?: 'Problema'
      readonly id: string
      readonly descricaoOutro?: string | null
      readonly situacao: SituacaoProblema
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid11?: {
        readonly __typename?: 'Cid11'
        readonly id: string
        readonly codigo: string
        readonly nome: string
        readonly ativo: boolean
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    } | null
  } | null> | null
  readonly alergiaEvolucao?: ReadonlyArray<{
    readonly __typename?: 'EvolucaoAlergia'
    readonly id: string
    readonly criticidade: CriticidadeAlergia
    readonly dataInicio?: any | null
    readonly observacao?: string | null
    readonly tipoReacao?: TipoReacaoAlergia | null
    readonly grauCerteza: GrauCertezaAlergia
    readonly manifestacoesLegado?: string | null
    readonly possuiSubstanciaEspecificaCbara?: boolean | null
    readonly alergia?: {
      readonly __typename?: 'Alergia'
      readonly id: string
      readonly substanciaEspecificaLegado?: string | null
      readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
      readonly substanciaEspecifica?: {
        readonly __typename?: 'SubstanciaEspecificaAlergia'
        readonly id: string
        readonly categoria: CategoriaSubstanciaAlergia
        readonly nome: string
        readonly sinonimos?: string | null
        readonly sigla?: string | null
      } | null
    } | null
    readonly manifestacoes: ReadonlyArray<{
      readonly __typename?: 'ManifestacaoAlergia'
      readonly id: string
      readonly nome: string
      readonly sinonimo?: string | null
    }>
  } | null> | null
}

export type HistoricoDesfechoPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
  readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
  readonly procedimentosAtendimento?: ReadonlyArray<{
    readonly __typename?: 'AtendimentoProcedimento'
    readonly id: string
    readonly procedimento: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    }
  } | null> | null
  readonly notificacoesCasoSuspeito?: ReadonlyArray<{
    readonly __typename?: 'SinanNotificacaoEvolucao'
    readonly id: string
    readonly notificacao: {
      readonly __typename?: 'FichaNotificacaoCasoSuspeito'
      readonly id: string
      readonly nomeNotificacao: string
    }
  } | null> | null
}

export type HistoricoDesfechoOdontoPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
  readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
  readonly atendimentoProfissionalOdonto?: {
    readonly __typename?: 'AtendimentoProfissionalOdonto'
    readonly id: string
    readonly cdsTipoFornecimOdonto?: ReadonlyArray<FornecimentoOdontoEnum | null> | null
    readonly tipoConduta?: ReadonlyArray<TipoEncaminhamentoOdontoEnum | null> | null
  } | null
  readonly procedimentosAtendimento?: ReadonlyArray<{
    readonly __typename?: 'AtendimentoProcedimento'
    readonly id: string
    readonly procedimento: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    }
  } | null> | null
  readonly notificacoesCasoSuspeito?: ReadonlyArray<{
    readonly __typename?: 'SinanNotificacaoEvolucao'
    readonly id: string
    readonly notificacao: {
      readonly __typename?: 'FichaNotificacaoCasoSuspeito'
      readonly id: string
      readonly nomeNotificacao: string
    }
  } | null> | null
}

export type HistoricoDimensaoProcedimentoFragment = {
  readonly __typename?: 'DimensaoProcedimento'
  readonly id: string
  readonly codigoProcedimento: string
  readonly descricaoProcedimento: string
  readonly dimensaoProcedimentoReferencia?: {
    readonly __typename?: 'DimensaoProcedimento'
    readonly id: string
    readonly codigoProcedimento: string
    readonly descricaoProcedimento: string
  } | null
}

export type HistoricoFinalizadorObservacaoFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly atendimentoProfissionalObservacao?: {
    readonly __typename?: 'AtendimentoProfissionalObservacao'
    readonly id: string
    readonly atendimentoObservacao: {
      readonly __typename?: 'AtendimentoObservacao'
      readonly id: string
      readonly atendimentoProfissionalFinalizador?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
            readonly tipoEstabelecimento: TipoEstabelecimentoEnum
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
          } | null
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      } | null
    }
  } | null
}

export type HistoricoInfoAdministrativasPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
  readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
  readonly estagio?: {
    readonly __typename?: 'Estagio'
    readonly id: string
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeCivil: string
      readonly nomeSocial?: string | null
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
  } | null
  readonly atendimento?: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly isRegistroTardio: boolean
    readonly dataCriacaoRegistro?: any | null
    readonly localAtendimento?: {
      readonly __typename?: 'LocalAtendimento'
      readonly id: string
      readonly localAtendimentoExibicao?: string | null
    } | null
  } | null
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeCivil: string
      readonly nomeSocial?: string | null
    }
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
      readonly tipoEstabelecimento: TipoEstabelecimentoEnum
    }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly cbo: {
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
      readonly actions?: {
        readonly __typename?: 'CboActions'
        readonly cadastroDomiciliar: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly cadastroIndividual: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly atividadeColetiva: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
      } | null
    }
  }
  readonly lotacaoAtendimentoCompartilhado?: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeCivil: string
      readonly nomeSocial?: string | null
    }
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly cbo: {
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
      readonly actions?: {
        readonly __typename?: 'CboActions'
        readonly cadastroDomiciliar: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly cadastroIndividual: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly atividadeColetiva: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
      } | null
    }
  } | null
  readonly atendimentoProfissionalObservacao?: {
    readonly __typename?: 'AtendimentoProfissionalObservacao'
    readonly id: string
    readonly atendimentoObservacao: {
      readonly __typename?: 'AtendimentoObservacao'
      readonly id: string
      readonly atendimentoProfissionalFinalizador?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
            readonly tipoEstabelecimento: TipoEstabelecimentoEnum
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
          } | null
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
            readonly actions?: {
              readonly __typename?: 'CboActions'
              readonly cadastroDomiciliar: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly cadastroIndividual: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
              readonly atividadeColetiva: {
                readonly __typename?: 'Action'
                readonly enabled: boolean
                readonly hint?: string | null
              }
            } | null
          }
        }
      } | null
    }
  } | null
}

export type HistoricoObjetivoPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly evolucaoObjetivo?: {
    readonly __typename?: 'EvolucaoObjetivo'
    readonly id: string
    readonly descricao?: string | null
  } | null
  readonly medicoes?: ReadonlyArray<{
    readonly __typename?: 'Medicao'
    readonly valorImc?: number | null
    readonly dum?: any | null
    readonly valorVacinacaoEmDia?: boolean | null
    readonly id: string
    readonly valorPeso?: number | null
    readonly valorAltura?: number | null
    readonly valorFrequenciaCardiaca?: number | null
    readonly valorPressaoArterial?: string | null
    readonly valorPerimetroCefalico?: number | null
    readonly valorFrequenciaRespiratoria?: number | null
    readonly valorTemperatura?: number | null
    readonly valorSaturacaoO2?: number | null
    readonly valorGlicemia?: number | null
    readonly tipoGlicemia?: TipoGlicemia | null
    readonly perimetroPanturrilha?: number | null
    readonly valorCircunferenciaAbdominal?: number | null
    readonly valorForcaMuscMaoDireita?: string | null
    readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
    readonly valorForcaMuscMaoEsquerda?: string | null
    readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
    readonly pele?: string | null
    readonly olhoDireito?: string | null
    readonly olhoEsquerdo?: string | null
    readonly ouvidoDireito?: string | null
    readonly ouvidoEsquerdo?: string | null
    readonly membroInferiorDireito?: string | null
    readonly membroInferiorEsquerdo?: string | null
  } | null> | null
  readonly marcadorConsumoAlimentar?: {
    readonly __typename?: 'MarcadorConsumoAlimentar'
    readonly id: string
    readonly categoria: FaixaEtariaConsumoAlimentar
    readonly respostas: ReadonlyArray<{
      readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
      readonly pergunta: PerguntasQuestionarioEnum
      readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
    }>
  } | null
  readonly examesResultados?: ReadonlyArray<{
    readonly __typename?: 'ResultadoExame'
    readonly id: string
    readonly dataSolicitacao?: any | null
    readonly dataRealizacao?: any | null
    readonly dataResultado?: any | null
    readonly resultado?: string | null
    readonly exame: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    }
    readonly especifico?: {
      readonly __typename?: 'ResultadoExameEspecifico'
      readonly id: string
      readonly exameEspecificoEnum: ExameEspecificoEnum
      readonly valor?: number | null
      readonly igDias?: number | null
      readonly igSemanas?: number | null
      readonly dpp?: any | null
      readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
      readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
    } | null
  } | null> | null
  readonly ivcf?: {
    readonly __typename?: 'Ivcf'
    readonly id: string
    readonly resultado: any
    readonly dimensoesAlteradas: string
    readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
  } | null
  readonly arquivosAnexados: ReadonlyArray<{
    readonly __typename?: 'ArquivoAtendimentoProfissional'
    readonly id: string
    readonly titulo: string
    readonly observacao?: string | null
    readonly categoria: CategoriaArquivoAtendProfEnum
    readonly arquivo: {
      readonly __typename?: 'Arquivo'
      readonly id: string
      readonly uuid: string
      readonly formato: string
    }
    readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
  }>
  readonly mChats?: ReadonlyArray<{
    readonly __typename?: 'MChat'
    readonly id: string
    readonly pontuacao: number
    readonly risco: MChatRiscoEnum
    readonly isMchatRf: boolean
    readonly aplicacao: ReadonlyArray<{
      readonly __typename?: 'MchatAplicacao'
      readonly id: string
      readonly pergunta: MChatPerguntaEnum
      readonly stPassou?: boolean | null
      readonly outros?: string | null
      readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
    }>
  }> | null
}

export type HistoricoPlanoCuidadoFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly planosDeCuidado?: ReadonlyArray<{
    readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
    readonly id: string
    readonly descricao: string
    readonly dataDescricao: any
  }> | null
}

export type HistoricoPlanoPecCuidadoCompartilhadoFragment = {
  readonly __typename?: 'CuidadoCompartilhado'
  readonly id: string
  readonly discussao: string
  readonly cidadaoAceitaAtendTic: boolean
  readonly ciap?: {
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  } | null
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly primeiraEvolucao: {
    readonly __typename?: 'CuidadoCompartilhadoEvolucao'
    readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
    readonly lotacaoExecutante?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly cns?: string | null
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
    } | null
    readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    readonly unidadeSaudeExecutante: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
  }
}

export type HistoricoPlanoPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly quantidadeAtestados?: number | null
  readonly quantidadeOrientacoes?: number | null
  readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
  readonly evolucaoPlano?: {
    readonly __typename?: 'EvolucaoPlano'
    readonly id: string
    readonly descricao?: string | null
    readonly intervencoesProcedimentos?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoPlanoCiap'
      readonly id: string
      readonly nota?: string | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly procedimento?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
      } | null
    } | null> | null
  } | null
  readonly encaminhamentosEspecializados?: ReadonlyArray<{
    readonly __typename?: 'EncaminhamentoExternoEspecializado'
    readonly id: string
    readonly observacoes?: string | null
    readonly motivoEncaminhamento?: string | null
    readonly complemento?: string | null
    readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
    readonly hipoteseDiagnosticoCid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly hipoteseDiagnosticoCiap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
    readonly especialidadeSisreg: {
      readonly __typename?: 'EspecialidadeSisreg'
      readonly id: string
      readonly descricao: string
    }
  } | null> | null
  readonly requisicoesExames?: ReadonlyArray<{
    readonly __typename?: 'SolicitacaoExame'
    readonly id: string
    readonly justificativa: string
    readonly observacoes?: string | null
    readonly tipoExame: TipoExameEnum
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly exames: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly observacao?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
    }>
  }> | null
  readonly receitaMedicamento?: ReadonlyArray<{
    readonly __typename?: 'ReceitaMedicamento'
    readonly id: string
    readonly quantidadeReceitada: number
    readonly recomendacoes?: string | null
    readonly posologia: string
    readonly dtInicioTratamento?: any | null
    readonly dtFimTratamento?: any | null
    readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
    readonly medicamento: {
      readonly __typename?: 'Medicamento'
      readonly id: string
      readonly principioAtivo: string
      readonly concentracao?: string | null
      readonly formaFarmaceutica?: {
        readonly __typename?: 'FormaFarmaceutica'
        readonly id: string
        readonly nome: string
      } | null
    }
    readonly aplicacaoMedicamento: {
      readonly __typename?: 'AplicacaoMedicamento'
      readonly id: string
      readonly nome: string
    }
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
  } | null> | null
  readonly cuidadosCompartilhados?: ReadonlyArray<{
    readonly __typename?: 'CuidadoCompartilhado'
    readonly id: string
    readonly discussao: string
    readonly cidadaoAceitaAtendTic: boolean
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly primeiraEvolucao: {
      readonly __typename?: 'CuidadoCompartilhadoEvolucao'
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly lotacaoExecutante?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly cns?: string | null
          readonly nome: string
          readonly nomeCivil: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
        } | null
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      } | null
      readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly unidadeSaudeExecutante: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
    }
  }> | null
  readonly guiasEncaminhamento?: ReadonlyArray<{
    readonly __typename?: 'GuiaEncaminhamento'
    readonly id: string
    readonly discussao: string
    readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    readonly especialidade: { readonly __typename?: 'EspecialidadeEsusReg'; readonly id: string; readonly nome: string }
  }> | null
}

export type HistoricoPlanoPecGuiaEncaminhamentoFragment = {
  readonly __typename?: 'GuiaEncaminhamento'
  readonly id: string
  readonly discussao: string
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly ciap?: {
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  } | null
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
  readonly especialidade: { readonly __typename?: 'EspecialidadeEsusReg'; readonly id: string; readonly nome: string }
}

export type HistoricoRegistrosAnterioresVacinacaoFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly vacinacao?: {
    readonly __typename?: 'AtendimentoVacinacao'
    readonly id: string
    readonly registrosVacinacao?: ReadonlyArray<{
      readonly __typename?: 'RegistroVacinacao'
      readonly id: string
      readonly dataAplicacao?: any | null
      readonly isRegistroAnterior?: boolean | null
      readonly isAplicadoExterior?: boolean | null
      readonly observacoes?: string | null
      readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
      readonly doseImunobiologico: {
        readonly __typename?: 'DoseImunobiologico'
        readonly id: string
        readonly sigla: string
      }
      readonly tipoRegistroVacinacao: {
        readonly __typename?: 'TipoRegistroVacinacao'
        readonly id: string
        readonly identificador: TipoRegistroVacinacaoEnum
      }
      readonly loteImunobiologico?: {
        readonly __typename?: 'LoteImunobiologico'
        readonly id: string
        readonly lote?: string | null
        readonly fabricante?: {
          readonly __typename?: 'ImunobiologicoFabricante'
          readonly id: string
          readonly nome: string
        } | null
      } | null
      readonly estrategiaVacinacao?: {
        readonly __typename?: 'EstrategiaVacinacao'
        readonly id: string
        readonly nome: string
      } | null
    }> | null
  } | null
}

export type HistoricoSubjetivoPecFragmentFragment = {
  readonly __typename?: 'AtendimentoProfissional'
  readonly id: string
  readonly evolucaoSubjetivo?: {
    readonly __typename?: 'EvolucaoSubjetivo'
    readonly id: string
    readonly descricao?: string | null
    readonly ciaps?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoSubjetivoCiap'
      readonly id: string
      readonly nota?: string | null
      readonly ciap: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
  } | null
}

export type SolicitacoesOciDwFragmentFragment = {
  readonly __typename?: 'FatoSolicitacaoOci'
  readonly id: string
  readonly dimensaoProcedimento: {
    readonly __typename?: 'DimensaoProcedimento'
    readonly id: string
    readonly codigoProcedimento: string
    readonly descricaoProcedimento: string
  }
}

export type SolicitacoesOciHistoricoFragmentFragment = {
  readonly __typename?: 'SolicitacaoExame'
  readonly id: string
  readonly justificativa: string
  readonly observacoes?: string | null
  readonly tipoExame: TipoExameEnum
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly procedimentos: ReadonlyArray<{
    readonly __typename?: 'ResultadoExame'
    readonly id: string
    readonly observacao?: string | null
    readonly procedimento: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    }
  }>
}

export type HistoricoAtendimentoDomiciliarAdQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAtendimentoDomiciliarAdQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly valorImc?: number | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly medicaoAnterior?: boolean | null
      readonly dataMedicao: any
    } | null> | null
    readonly evolucaoAvaliacao?: {
      readonly __typename?: 'EvolucaoAvaliacao'
      readonly id: string
      readonly descricao?: string | null
      readonly ciapsCids?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
        readonly nota?: string | null
        readonly isCiapCidNaListaDeProblemas: boolean
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
      }> | null
    } | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly atendimentoProfissionalAD?: {
      readonly __typename?: 'AtendimentoProfissionalAtencaoDomiciliar'
      readonly id: string
      readonly origem?: AtencaoDomiciliarOrigem | null
      readonly modalidade: AtencaoDomiciliarModalidade
      readonly conduta?: AtencaoDomiciliarCondutaDesfecho | null
      readonly cid10Principal?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid10Secundario1?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid10Secundario2?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly condicoesAvaliadasAD?: ReadonlyArray<{
        readonly __typename?: 'AtencaoDomiciliarResposta'
        readonly id: number
        readonly situacaoAtiva?: boolean | null
        readonly questao?: {
          readonly __typename?: 'AtencaoDomiciliarQuestao'
          readonly id: string
          readonly descricao: string
        } | null
      } | null> | null
    } | null
    readonly cidadaoAD?: {
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly dataObito?: any | null
      readonly numeroDocumentoObito?: string | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
      }
      readonly cid10Principal?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
    } | null> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoAtendimentoDomiciliarDwQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAtendimentoDomiciliarDwQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoDomiciliar?: {
    readonly __typename?: 'FatoAtendimentoDomiciliar'
    readonly id: string
    readonly condicoesAvaliadas: ReadonlyArray<string | null>
    readonly fatosAtendDomProblemaCondicao?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendDomProblemaCondicao'
      readonly id: string
      readonly dataInicioProblema?: any | null
      readonly dataFimProblema?: any | null
      readonly dimensaoCiap?: {
        readonly __typename?: 'DimensaoCiap'
        readonly id: string
        readonly codigoCiap: string
        readonly nomeCiap: string
      } | null
      readonly dimensaoCid10?: {
        readonly __typename?: 'DimensaoCid10'
        readonly id: string
        readonly codigoCid10: string
        readonly nomeCid10: string
      } | null
      readonly dimensaoSituacaoProblema?: {
        readonly __typename?: 'DimensaoSituacaoProblema'
        readonly id: string
        readonly identificador: number
        readonly descricao: string
      } | null
    } | null> | null
    readonly dimensaoProfissional1?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoProfissional2?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo1?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoCbo2?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude1?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoUnidadeSaude2?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe1?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoEquipe2?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoLocalAtendimento?: {
      readonly __typename?: 'DimensaoLocalAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoModalidadeAD?: {
      readonly __typename?: 'DimensaoModalidadeAD'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoCondutaAD?: {
      readonly __typename?: 'DimensaoCondutaAD'
      readonly id: string
      readonly conduta: string
    } | null
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendDomProced'
      readonly id: string
      readonly dimensaoProcedimento: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
      }
    } | null> | null
  } | null
}

export type HistoricoConsultaPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoConsultaPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly quantidadeAtestados?: number | null
    readonly quantidadeOrientacoes?: number | null
    readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly medicaoAnterior?: boolean | null
      readonly dataMedicao: any
      readonly valorImc?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly procedimentos: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly examesResultados?: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly resultado?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly formato: string
      }
      readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    }>
    readonly mChats?: ReadonlyArray<{
      readonly __typename?: 'MChat'
      readonly id: string
      readonly pontuacao: number
      readonly risco: MChatRiscoEnum
      readonly isMchatRf: boolean
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'MchatAplicacao'
        readonly id: string
        readonly pergunta: MChatPerguntaEnum
        readonly stPassou?: boolean | null
        readonly outros?: string | null
        readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
      }>
    }> | null
    readonly planosDeCuidado?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
      readonly id: string
      readonly descricao: string
      readonly dataDescricao: any
    }> | null
    readonly evolucaoAvaliacao?: {
      readonly __typename?: 'EvolucaoAvaliacao'
      readonly id: string
      readonly descricao?: string | null
      readonly ciapsCids?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
        readonly nota?: string | null
        readonly isCiapCidNaListaDeProblemas: boolean
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
      }> | null
    } | null
    readonly evolucaoProblema?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProblema'
      readonly id: string
      readonly dataInicio?: any | null
      readonly dataFim?: any | null
      readonly situacao: SituacaoProblema
      readonly observacao?: string | null
      readonly atualizadoEm?: any | null
      readonly possuiCid: boolean
      readonly possuiCid11: boolean
      readonly possuiCiap: boolean
      readonly problema?: {
        readonly __typename?: 'Problema'
        readonly id: string
        readonly descricaoOutro?: string | null
        readonly situacao: SituacaoProblema
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
      } | null
    } | null> | null
    readonly alergiaEvolucao?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoAlergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly dataInicio?: any | null
      readonly observacao?: string | null
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly manifestacoesLegado?: string | null
      readonly possuiSubstanciaEspecificaCbara?: boolean | null
      readonly alergia?: {
        readonly __typename?: 'Alergia'
        readonly id: string
        readonly substanciaEspecificaLegado?: string | null
        readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
        readonly substanciaEspecifica?: {
          readonly __typename?: 'SubstanciaEspecificaAlergia'
          readonly id: string
          readonly categoria: CategoriaSubstanciaAlergia
          readonly nome: string
          readonly sinonimos?: string | null
          readonly sigla?: string | null
        } | null
      } | null
      readonly manifestacoes: ReadonlyArray<{
        readonly __typename?: 'ManifestacaoAlergia'
        readonly id: string
        readonly nome: string
        readonly sinonimo?: string | null
      }>
    } | null> | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly encaminhamentosEspecializados?: ReadonlyArray<{
      readonly __typename?: 'EncaminhamentoExternoEspecializado'
      readonly id: string
      readonly observacoes?: string | null
      readonly motivoEncaminhamento?: string | null
      readonly complemento?: string | null
      readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
      readonly hipoteseDiagnosticoCid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly hipoteseDiagnosticoCiap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly especialidadeSisreg: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      }
    } | null> | null
    readonly requisicoesExames?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly receitaMedicamento?: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly quantidadeReceitada: number
      readonly recomendacoes?: string | null
      readonly posologia: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly concentracao?: string | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly aplicacaoMedicamento: {
        readonly __typename?: 'AplicacaoMedicamento'
        readonly id: string
        readonly nome: string
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    } | null> | null
    readonly cuidadosCompartilhados?: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly discussao: string
      readonly cidadaoAceitaAtendTic: boolean
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly primeiraEvolucao: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      }
    }> | null
    readonly guiasEncaminhamento?: ReadonlyArray<{
      readonly __typename?: 'GuiaEncaminhamento'
      readonly id: string
      readonly discussao: string
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly especialidade: {
        readonly __typename?: 'EspecialidadeEsusReg'
        readonly id: string
        readonly nome: string
      }
    }> | null
    readonly antecedentes?: {
      readonly __typename?: 'AntecedenteItemDto'
      readonly id: string
      readonly observacoes?: string | null
      readonly puericultura?: {
        readonly __typename?: 'AntecedentePuericulturaDto'
        readonly tipoGravidez?: string | null
        readonly tipoParto?: string | null
        readonly idadeGestacionalDias?: string | null
        readonly idadeGestacionalSemanas?: string | null
        readonly apgarUm?: string | null
        readonly apgarCinco?: string | null
        readonly apgarDez?: string | null
        readonly peso?: string | null
        readonly comprimento?: string | null
        readonly perimetroCefalico?: string | null
      } | null
      readonly informacoesObstetricas?: {
        readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
        readonly gestaPrevias?: string | null
        readonly abortos?: string | null
        readonly partos?: string | null
        readonly partosVaginais?: string | null
        readonly partosCesareas?: string | null
        readonly partosDomiciliares?: string | null
        readonly nascidosVivos?: string | null
        readonly natimortos?: string | null
        readonly recemNascidoAbaixo?: string | null
        readonly recemNascidoAcima?: string | null
        readonly filhosVivos?: string | null
        readonly obitoAntesPrimeiraSemana?: string | null
        readonly obitoAposPrimeiraSemana?: string | null
        readonly desfechoUltimaGestacao?: string | null
      } | null
    } | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
    readonly vacinacao?: {
      readonly __typename?: 'AtendimentoVacinacao'
      readonly id: string
      readonly registrosVacinacao?: ReadonlyArray<{
        readonly __typename?: 'RegistroVacinacao'
        readonly id: string
        readonly dataAplicacao?: any | null
        readonly isRegistroAnterior?: boolean | null
        readonly isAplicadoExterior?: boolean | null
        readonly observacoes?: string | null
        readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
        readonly doseImunobiologico: {
          readonly __typename?: 'DoseImunobiologico'
          readonly id: string
          readonly sigla: string
        }
        readonly tipoRegistroVacinacao: {
          readonly __typename?: 'TipoRegistroVacinacao'
          readonly id: string
          readonly identificador: TipoRegistroVacinacaoEnum
        }
        readonly loteImunobiologico?: {
          readonly __typename?: 'LoteImunobiologico'
          readonly id: string
          readonly lote?: string | null
          readonly fabricante?: {
            readonly __typename?: 'ImunobiologicoFabricante'
            readonly id: string
            readonly nome: string
          } | null
        } | null
        readonly estrategiaVacinacao?: {
          readonly __typename?: 'EstrategiaVacinacao'
          readonly id: string
          readonly nome: string
        } | null
      }> | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoAtendimentoIndividualDwQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAtendimentoIndividualDwQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoIndividualDw?: {
    readonly __typename?: 'FatoAtendimentoIndividual'
    readonly id: string
    readonly stFicouEmObservacao?: boolean | null
    readonly stVacinacaoEmDia?: boolean | null
    readonly nuPeso?: number | null
    readonly nuAltura?: number | null
    readonly nuImc?: number | null
    readonly nuPerimetroCefalico?: number | null
    readonly dum?: any | null
    readonly stGravidezPlanejada?: boolean | null
    readonly nuIdadeGestacional?: number | null
    readonly nuGestasPrevias?: number | null
    readonly nuPartos?: number | null
    readonly nasfPolo: ReadonlyArray<string | null>
    readonly stNasf: boolean
    readonly condutaDesfecho: ReadonlyArray<string | null>
    readonly encaminhamentos: ReadonlyArray<string | null>
    readonly encaminhamentoServicoEspecializado?: boolean | null
    readonly nuCircAbdominal?: number | null
    readonly nuPerimPanturrilha?: number | null
    readonly nuPressaoSistolica?: number | null
    readonly nuPressaoDiastolica?: number | null
    readonly nuFreqRespiratoria?: number | null
    readonly nuFreqCardiaca?: number | null
    readonly nuTemperatura?: number | null
    readonly nuSaturacaoO2?: number | null
    readonly nuGlicemia?: number | null
    readonly dimensaoTipoGlicemia?: DimensaoTipoGlicemiaEnum | null
    readonly mchatPontuacao?: number | null
    readonly mchatRfPontuacao?: number | null
    readonly filtroCiapPlano?: string | null
    readonly filtroCiapMotivoConsulta?: string | null
    readonly dimensaoAleitamento?: {
      readonly __typename?: 'DimensaoAleitamento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoModalidadeAd?: {
      readonly __typename?: 'DimensaoModalidadeAD'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoRacionalidadeSaude?: {
      readonly __typename?: 'DimensaoRacionalidadeSaude'
      readonly id: string
      readonly descricao: string
    } | null
    readonly examesSolicitados?: ReadonlyArray<{
      readonly __typename?: 'DimensaoProcedimento'
      readonly id: string
      readonly codigoProcedimento: string
      readonly descricaoProcedimento: string
    } | null> | null
    readonly examesAvaliados?: ReadonlyArray<{
      readonly __typename?: 'DimensaoProcedimento'
      readonly id: string
      readonly codigoProcedimento: string
      readonly descricaoProcedimento: string
      readonly dimensaoProcedimentoReferencia?: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
      } | null
    } | null> | null
    readonly resultadosExamesEspecificos?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendimentoIndividualExames'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly dataResultadoData?: any | null
      readonly nuResultadoValor?: number | null
      readonly nuResultadoDia?: number | null
      readonly nuResultadoSemana?: number | null
      readonly resultadoPuericultura?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
      readonly resultadoExameEstruturadoQualitativo?: OpcoesResultadoExameQualitativoEnum | null
      readonly dimensaoProcedimento?: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
        readonly dimensaoProcedimentoReferencia?: {
          readonly __typename?: 'DimensaoProcedimento'
          readonly id: string
          readonly codigoProcedimento: string
          readonly descricaoProcedimento: string
        } | null
      } | null
    } | null> | null
    readonly dimensaoProfissional1?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoProfissional2?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo1?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoCbo2?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude1?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoUnidadeSaude2?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe1?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoEquipe2?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoLocalAtendimento?: {
      readonly __typename?: 'DimensaoLocalAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimProfFinalizadorObs?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimCboFinalizadorObs?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
    } | null
    readonly dimUbsFinalizadorObs?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimEquipeFinalizadorObs?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimTipoParticipacaoCidadao?: {
      readonly __typename?: 'DimensaoTipoParticipacaoAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimTipoParticipacaoProfConvidado?: {
      readonly __typename?: 'DimensaoTipoParticipacaoAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly medicamentos?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendimentoIndividualMedicamentos'
      readonly id?: string | null
      readonly unidadeMedidaDuracao?: UnidadeMedidaTempoEnum | null
      readonly unidadeFrequenciaDose?: UnidadeMedidaTempoEnum | null
      readonly tipoFrequencia?: TipoFrequencia | null
      readonly duracao?: any | null
      readonly quantidade?: any | null
      readonly dataInicioTratamento?: any | null
      readonly dose?: string | null
      readonly doseUnica?: boolean | null
      readonly usoContinuo?: boolean | null
      readonly doseFrequencia?: any | null
      readonly frequenciaDose?: string | null
      readonly qtDoseManha?: string | null
      readonly qtDoseTarde?: string | null
      readonly qtDoseNoite?: string | null
      readonly dimensaoCatmat?: {
        readonly __typename?: 'DimensaoCatmat'
        readonly id: string
        readonly principioAtivo?: string | null
        readonly concentracao?: string | null
        readonly dimensaoFormaFarmaceutica?: {
          readonly __typename?: 'DimensaoFormaFarmaceutica'
          readonly id: string
          readonly identificador?: string | null
          readonly nome?: string | null
          readonly valido?: boolean | null
        } | null
      } | null
      readonly dimensaoViaAdministracao?: {
        readonly __typename?: 'DimensaoViaAdministracao'
        readonly id: string
        readonly nome?: string | null
      } | null
    } | null> | null
    readonly problemas: ReadonlyArray<{
      readonly __typename?: 'FatoAtendimentoIndividualProblemas'
      readonly id: string
      readonly dataInicioProblema?: any | null
      readonly dataFimProblema?: any | null
      readonly dimensaoCiap?: {
        readonly __typename?: 'DimensaoCiap'
        readonly id: string
        readonly codigoCiap: string
        readonly nomeCiap: string
      } | null
      readonly dimensaoCid10?: {
        readonly __typename?: 'DimensaoCid10'
        readonly id: string
        readonly codigoCid10: string
        readonly nomeCid10: string
      } | null
      readonly dimensaoSituacaoProblema?: {
        readonly __typename?: 'DimensaoSituacaoProblema'
        readonly id: string
        readonly identificador: number
        readonly descricao: string
      } | null
    } | null>
    readonly ivcf?: {
      readonly __typename?: 'FatoIvcf'
      readonly id: string
      readonly resultado: number
      readonly dimensoesAlteradas: string
      readonly dimensaoGrauVulnerabilidadeIvcf: {
        readonly __typename?: 'DimensaoGrauVulnerabilidadeIvcf'
        readonly id?: string | null
        readonly descricao?: string | null
      }
    } | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'FatoSolicitacaoOci'
      readonly id: string
      readonly dimensaoProcedimento: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
      }
    }> | null
    readonly dimensaoMchatRisco?: {
      readonly __typename?: 'DimensaoMchatRisco'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoMchatRfRisco?: {
      readonly __typename?: 'DimensaoMchatRisco'
      readonly id: string
      readonly descricao: string
    } | null
    readonly fatoAppAtendimento?: {
      readonly __typename?: 'FatoAppAtendimento'
      readonly id: string
      readonly campoAbertoSubjetivo?: string | null
      readonly campoAbertoObjetivo?: string | null
      readonly campoAbertoAvaliacao?: string | null
      readonly campoAbertoPlano?: string | null
    } | null
    readonly encaminhamentosEspecializados?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendIndividualEncaminhamentos'
      readonly id: string
      readonly dimensaoCid10?: {
        readonly __typename?: 'DimensaoCid10'
        readonly id: string
        readonly codigoCid10: string
        readonly nomeCid10: string
      } | null
      readonly dimensaoCiap?: {
        readonly __typename?: 'DimensaoCiap'
        readonly id: string
        readonly codigoCiap: string
        readonly nomeCiap: string
      } | null
      readonly dimensaoClassificacaoRiscoEncaminhamento?: {
        readonly __typename?: 'DimensaoClassificacaoRiscoEncaminhamento'
        readonly id: string
        readonly nome: string
        readonly identificador: string
      } | null
      readonly dimensaoCboGuiaEncaminhamento?: {
        readonly __typename?: 'DimensaoCbo'
        readonly id: string
        readonly cbo: string
        readonly nome: string
      } | null
      readonly dimensaoPrioridadeCuidado?: {
        readonly __typename?: 'DimensaoPrioridadeCuidado'
        readonly id: string
        readonly descricao: string
        readonly nuIdentificador: string
      } | null
      readonly especialidadeSisreg?: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      } | null
    }> | null
  } | null
}

export type HistoricoCiapFiltroQueryVariables = Exact<{
  input: CiapByCodigosQueryInput
}>

export type HistoricoCiapFiltroQuery = {
  readonly __typename?: 'Query'
  readonly ciapsByCodigos: ReadonlyArray<{
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  }>
}

export type HistoricoConcatenadaProcedimentoQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoConcatenadaProcedimentoQuery = {
  readonly __typename?: 'Query'
  readonly historicoProcedimentoDw?: {
    readonly __typename?: 'FatoProcedAtend'
    readonly id: string
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'DimensaoProcedimento'
      readonly id: string
      readonly codigoProcedimento: string
      readonly descricaoProcedimento: string
    }> | null
  } | null
}

export type HistoricoConcatenadaZikaQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoConcatenadaZikaQuery = {
  readonly __typename?: 'Query'
  readonly historicoZikaDetail?: {
    readonly __typename?: 'HistoricoZikaDetail'
    readonly examesDeImagem: ReadonlyArray<{
      readonly __typename?: 'ExameZika'
      readonly id: string
      readonly nome: string
      readonly resultado: string
      readonly dataRealizacao: any
    } | null>
    readonly outrosExames: ReadonlyArray<{
      readonly __typename?: 'ExameZika'
      readonly id: string
      readonly nome: string
      readonly resultado: string
      readonly dataRealizacao: any
    } | null>
  } | null
}

export type HistoricoPreNatalPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoPreNatalPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly quantidadeAtestados?: number | null
    readonly quantidadeOrientacoes?: number | null
    readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly valorAlturaUterina?: string | null
      readonly valorBatimentoCardiacoFetal?: string | null
      readonly valorBatimentoCardiacoFetal2?: string | null
      readonly medicaoAnterior?: boolean | null
      readonly dataMedicao: any
      readonly valorImc?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly atendimentoProfissionalPreNatal?: {
      readonly __typename?: 'AtendimentoProfissionalPreNatal'
      readonly id: string
      readonly gravidezPlanejada?: boolean | null
      readonly movimentacaoFetal?: boolean | null
      readonly tipoEdema?: TipoEdemaEnum | null
    } | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly procedimentos: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly examesResultados?: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly resultado?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly formato: string
      }
      readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    }>
    readonly mChats?: ReadonlyArray<{
      readonly __typename?: 'MChat'
      readonly id: string
      readonly pontuacao: number
      readonly risco: MChatRiscoEnum
      readonly isMchatRf: boolean
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'MchatAplicacao'
        readonly id: string
        readonly pergunta: MChatPerguntaEnum
        readonly stPassou?: boolean | null
        readonly outros?: string | null
        readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
      }>
    }> | null
    readonly planosDeCuidado?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
      readonly id: string
      readonly descricao: string
      readonly dataDescricao: any
    }> | null
    readonly evolucaoAvaliacao?: {
      readonly __typename?: 'EvolucaoAvaliacao'
      readonly id: string
      readonly descricao?: string | null
      readonly ciapsCids?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
        readonly nota?: string | null
        readonly isCiapCidNaListaDeProblemas: boolean
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
      }> | null
    } | null
    readonly evolucaoProblema?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProblema'
      readonly id: string
      readonly dataInicio?: any | null
      readonly dataFim?: any | null
      readonly situacao: SituacaoProblema
      readonly observacao?: string | null
      readonly atualizadoEm?: any | null
      readonly possuiCid: boolean
      readonly possuiCid11: boolean
      readonly possuiCiap: boolean
      readonly problema?: {
        readonly __typename?: 'Problema'
        readonly id: string
        readonly descricaoOutro?: string | null
        readonly situacao: SituacaoProblema
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
      } | null
    } | null> | null
    readonly alergiaEvolucao?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoAlergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly dataInicio?: any | null
      readonly observacao?: string | null
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly manifestacoesLegado?: string | null
      readonly possuiSubstanciaEspecificaCbara?: boolean | null
      readonly alergia?: {
        readonly __typename?: 'Alergia'
        readonly id: string
        readonly substanciaEspecificaLegado?: string | null
        readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
        readonly substanciaEspecifica?: {
          readonly __typename?: 'SubstanciaEspecificaAlergia'
          readonly id: string
          readonly categoria: CategoriaSubstanciaAlergia
          readonly nome: string
          readonly sinonimos?: string | null
          readonly sigla?: string | null
        } | null
      } | null
      readonly manifestacoes: ReadonlyArray<{
        readonly __typename?: 'ManifestacaoAlergia'
        readonly id: string
        readonly nome: string
        readonly sinonimo?: string | null
      }>
    } | null> | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly encaminhamentosEspecializados?: ReadonlyArray<{
      readonly __typename?: 'EncaminhamentoExternoEspecializado'
      readonly id: string
      readonly observacoes?: string | null
      readonly motivoEncaminhamento?: string | null
      readonly complemento?: string | null
      readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
      readonly hipoteseDiagnosticoCid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly hipoteseDiagnosticoCiap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly especialidadeSisreg: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      }
    } | null> | null
    readonly requisicoesExames?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly receitaMedicamento?: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly quantidadeReceitada: number
      readonly recomendacoes?: string | null
      readonly posologia: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly concentracao?: string | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly aplicacaoMedicamento: {
        readonly __typename?: 'AplicacaoMedicamento'
        readonly id: string
        readonly nome: string
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    } | null> | null
    readonly cuidadosCompartilhados?: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly discussao: string
      readonly cidadaoAceitaAtendTic: boolean
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly primeiraEvolucao: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      }
    }> | null
    readonly guiasEncaminhamento?: ReadonlyArray<{
      readonly __typename?: 'GuiaEncaminhamento'
      readonly id: string
      readonly discussao: string
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly especialidade: {
        readonly __typename?: 'EspecialidadeEsusReg'
        readonly id: string
        readonly nome: string
      }
    }> | null
    readonly antecedentes?: {
      readonly __typename?: 'AntecedenteItemDto'
      readonly id: string
      readonly observacoes?: string | null
      readonly puericultura?: {
        readonly __typename?: 'AntecedentePuericulturaDto'
        readonly tipoGravidez?: string | null
        readonly tipoParto?: string | null
        readonly idadeGestacionalDias?: string | null
        readonly idadeGestacionalSemanas?: string | null
        readonly apgarUm?: string | null
        readonly apgarCinco?: string | null
        readonly apgarDez?: string | null
        readonly peso?: string | null
        readonly comprimento?: string | null
        readonly perimetroCefalico?: string | null
      } | null
      readonly informacoesObstetricas?: {
        readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
        readonly gestaPrevias?: string | null
        readonly abortos?: string | null
        readonly partos?: string | null
        readonly partosVaginais?: string | null
        readonly partosCesareas?: string | null
        readonly partosDomiciliares?: string | null
        readonly nascidosVivos?: string | null
        readonly natimortos?: string | null
        readonly recemNascidoAbaixo?: string | null
        readonly recemNascidoAcima?: string | null
        readonly filhosVivos?: string | null
        readonly obitoAntesPrimeiraSemana?: string | null
        readonly obitoAposPrimeiraSemana?: string | null
        readonly desfechoUltimaGestacao?: string | null
      } | null
    } | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
    readonly vacinacao?: {
      readonly __typename?: 'AtendimentoVacinacao'
      readonly id: string
      readonly registrosVacinacao?: ReadonlyArray<{
        readonly __typename?: 'RegistroVacinacao'
        readonly id: string
        readonly dataAplicacao?: any | null
        readonly isRegistroAnterior?: boolean | null
        readonly isAplicadoExterior?: boolean | null
        readonly observacoes?: string | null
        readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
        readonly doseImunobiologico: {
          readonly __typename?: 'DoseImunobiologico'
          readonly id: string
          readonly sigla: string
        }
        readonly tipoRegistroVacinacao: {
          readonly __typename?: 'TipoRegistroVacinacao'
          readonly id: string
          readonly identificador: TipoRegistroVacinacaoEnum
        }
        readonly loteImunobiologico?: {
          readonly __typename?: 'LoteImunobiologico'
          readonly id: string
          readonly lote?: string | null
          readonly fabricante?: {
            readonly __typename?: 'ImunobiologicoFabricante'
            readonly id: string
            readonly nome: string
          } | null
        } | null
        readonly estrategiaVacinacao?: {
          readonly __typename?: 'EstrategiaVacinacao'
          readonly id: string
          readonly nome: string
        } | null
      }> | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoPuericulturaPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoPuericulturaPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly quantidadeAtestados?: number | null
    readonly quantidadeOrientacoes?: number | null
    readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly valorAlturaUterina?: string | null
      readonly valorBatimentoCardiacoFetal?: string | null
      readonly valorBatimentoCardiacoFetal2?: string | null
      readonly medicaoAnterior?: boolean | null
      readonly dataMedicao: any
      readonly valorImc?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly atendimentoProfissionalPuericultura?: {
      readonly __typename?: 'AtendimentoProfissionalPuericultura'
      readonly id: string
      readonly aleitamentoMaterno?: TipoAleitamentoMaternoEnum | null
      readonly neuroAlteracaoFenotipica?: ReadonlyArray<{
        readonly __typename?: 'NeuroAlteracaoFenotipicaEvolucao'
        readonly id: string
        readonly statusAvaliacao?: StatusAvaliadoEnum | null
        readonly alteracaoFenotipicaDetalhe?: {
          readonly __typename?: 'NeuroAlteracaoFenotipicaDetalhe'
          readonly id: string
          readonly descricao?: string | null
        } | null
      } | null> | null
      readonly neuroFatorRisco?: ReadonlyArray<{
        readonly __typename?: 'NeuroFatorRiscoEvolucao'
        readonly id: string
        readonly statusAvaliacao?: StatusAvaliadoEnum | null
        readonly fatorRiscoDetalhe?: {
          readonly __typename?: 'NeuroFatorRiscoDetalhe'
          readonly id: string
          readonly descricao?: string | null
        } | null
      } | null> | null
      readonly neuroMarco?: ReadonlyArray<{
        readonly __typename?: 'NeuroMarcoEvolucao'
        readonly id: string
        readonly statusAvaliacao?: StatusAvaliadoEnum | null
        readonly anosIdadeRegistro?: number | null
        readonly mesesIdadeRegistro?: number | null
        readonly marcoDetalhe?: {
          readonly __typename?: 'NeuroMarcoDetalhe'
          readonly id: string
          readonly titulo?: string | null
          readonly faixaEtaria?: {
            readonly __typename?: 'NeuroFaixaEtaria'
            readonly id: string
            readonly descricao?: string | null
          } | null
        } | null
      } | null> | null
    } | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly procedimentos: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly examesResultados?: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly resultado?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly formato: string
      }
      readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    }>
    readonly mChats?: ReadonlyArray<{
      readonly __typename?: 'MChat'
      readonly id: string
      readonly pontuacao: number
      readonly risco: MChatRiscoEnum
      readonly isMchatRf: boolean
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'MchatAplicacao'
        readonly id: string
        readonly pergunta: MChatPerguntaEnum
        readonly stPassou?: boolean | null
        readonly outros?: string | null
        readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
      }>
    }> | null
    readonly planosDeCuidado?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
      readonly id: string
      readonly descricao: string
      readonly dataDescricao: any
    }> | null
    readonly evolucaoAvaliacao?: {
      readonly __typename?: 'EvolucaoAvaliacao'
      readonly id: string
      readonly descricao?: string | null
      readonly ciapsCids?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
        readonly nota?: string | null
        readonly isCiapCidNaListaDeProblemas: boolean
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
      }> | null
    } | null
    readonly evolucaoProblema?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProblema'
      readonly id: string
      readonly dataInicio?: any | null
      readonly dataFim?: any | null
      readonly situacao: SituacaoProblema
      readonly observacao?: string | null
      readonly atualizadoEm?: any | null
      readonly possuiCid: boolean
      readonly possuiCid11: boolean
      readonly possuiCiap: boolean
      readonly problema?: {
        readonly __typename?: 'Problema'
        readonly id: string
        readonly descricaoOutro?: string | null
        readonly situacao: SituacaoProblema
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
      } | null
    } | null> | null
    readonly alergiaEvolucao?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoAlergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly dataInicio?: any | null
      readonly observacao?: string | null
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly manifestacoesLegado?: string | null
      readonly possuiSubstanciaEspecificaCbara?: boolean | null
      readonly alergia?: {
        readonly __typename?: 'Alergia'
        readonly id: string
        readonly substanciaEspecificaLegado?: string | null
        readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
        readonly substanciaEspecifica?: {
          readonly __typename?: 'SubstanciaEspecificaAlergia'
          readonly id: string
          readonly categoria: CategoriaSubstanciaAlergia
          readonly nome: string
          readonly sinonimos?: string | null
          readonly sigla?: string | null
        } | null
      } | null
      readonly manifestacoes: ReadonlyArray<{
        readonly __typename?: 'ManifestacaoAlergia'
        readonly id: string
        readonly nome: string
        readonly sinonimo?: string | null
      }>
    } | null> | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly encaminhamentosEspecializados?: ReadonlyArray<{
      readonly __typename?: 'EncaminhamentoExternoEspecializado'
      readonly id: string
      readonly observacoes?: string | null
      readonly motivoEncaminhamento?: string | null
      readonly complemento?: string | null
      readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
      readonly hipoteseDiagnosticoCid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly hipoteseDiagnosticoCiap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly especialidadeSisreg: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      }
    } | null> | null
    readonly requisicoesExames?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly receitaMedicamento?: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly quantidadeReceitada: number
      readonly recomendacoes?: string | null
      readonly posologia: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly concentracao?: string | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly aplicacaoMedicamento: {
        readonly __typename?: 'AplicacaoMedicamento'
        readonly id: string
        readonly nome: string
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    } | null> | null
    readonly cuidadosCompartilhados?: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly discussao: string
      readonly cidadaoAceitaAtendTic: boolean
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly primeiraEvolucao: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      }
    }> | null
    readonly guiasEncaminhamento?: ReadonlyArray<{
      readonly __typename?: 'GuiaEncaminhamento'
      readonly id: string
      readonly discussao: string
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly especialidade: {
        readonly __typename?: 'EspecialidadeEsusReg'
        readonly id: string
        readonly nome: string
      }
    }> | null
    readonly antecedentes?: {
      readonly __typename?: 'AntecedenteItemDto'
      readonly id: string
      readonly observacoes?: string | null
      readonly puericultura?: {
        readonly __typename?: 'AntecedentePuericulturaDto'
        readonly tipoGravidez?: string | null
        readonly tipoParto?: string | null
        readonly idadeGestacionalDias?: string | null
        readonly idadeGestacionalSemanas?: string | null
        readonly apgarUm?: string | null
        readonly apgarCinco?: string | null
        readonly apgarDez?: string | null
        readonly peso?: string | null
        readonly comprimento?: string | null
        readonly perimetroCefalico?: string | null
      } | null
      readonly informacoesObstetricas?: {
        readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
        readonly gestaPrevias?: string | null
        readonly abortos?: string | null
        readonly partos?: string | null
        readonly partosVaginais?: string | null
        readonly partosCesareas?: string | null
        readonly partosDomiciliares?: string | null
        readonly nascidosVivos?: string | null
        readonly natimortos?: string | null
        readonly recemNascidoAbaixo?: string | null
        readonly recemNascidoAcima?: string | null
        readonly filhosVivos?: string | null
        readonly obitoAntesPrimeiraSemana?: string | null
        readonly obitoAposPrimeiraSemana?: string | null
        readonly desfechoUltimaGestacao?: string | null
      } | null
    } | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
    readonly vacinacao?: {
      readonly __typename?: 'AtendimentoVacinacao'
      readonly id: string
      readonly registrosVacinacao?: ReadonlyArray<{
        readonly __typename?: 'RegistroVacinacao'
        readonly id: string
        readonly dataAplicacao?: any | null
        readonly isRegistroAnterior?: boolean | null
        readonly isAplicadoExterior?: boolean | null
        readonly observacoes?: string | null
        readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
        readonly doseImunobiologico: {
          readonly __typename?: 'DoseImunobiologico'
          readonly id: string
          readonly sigla: string
        }
        readonly tipoRegistroVacinacao: {
          readonly __typename?: 'TipoRegistroVacinacao'
          readonly id: string
          readonly identificador: TipoRegistroVacinacaoEnum
        }
        readonly loteImunobiologico?: {
          readonly __typename?: 'LoteImunobiologico'
          readonly id: string
          readonly lote?: string | null
          readonly fabricante?: {
            readonly __typename?: 'ImunobiologicoFabricante'
            readonly id: string
            readonly nome: string
          } | null
        } | null
        readonly estrategiaVacinacao?: {
          readonly __typename?: 'EstrategiaVacinacao'
          readonly id: string
          readonly nome: string
        } | null
      }> | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoPuerperioPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoPuerperioPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly quantidadeAtestados?: number | null
    readonly quantidadeOrientacoes?: number | null
    readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly medicaoAnterior?: boolean | null
      readonly dataMedicao: any
      readonly valorImc?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly procedimentos: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly examesResultados?: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly resultado?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly formato: string
      }
      readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    }>
    readonly mChats?: ReadonlyArray<{
      readonly __typename?: 'MChat'
      readonly id: string
      readonly pontuacao: number
      readonly risco: MChatRiscoEnum
      readonly isMchatRf: boolean
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'MchatAplicacao'
        readonly id: string
        readonly pergunta: MChatPerguntaEnum
        readonly stPassou?: boolean | null
        readonly outros?: string | null
        readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
      }>
    }> | null
    readonly planosDeCuidado?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
      readonly id: string
      readonly descricao: string
      readonly dataDescricao: any
    }> | null
    readonly evolucaoAvaliacao?: {
      readonly __typename?: 'EvolucaoAvaliacao'
      readonly id: string
      readonly descricao?: string | null
      readonly ciapsCids?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
        readonly nota?: string | null
        readonly isCiapCidNaListaDeProblemas: boolean
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
      }> | null
    } | null
    readonly evolucaoProblema?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProblema'
      readonly id: string
      readonly dataInicio?: any | null
      readonly dataFim?: any | null
      readonly situacao: SituacaoProblema
      readonly observacao?: string | null
      readonly atualizadoEm?: any | null
      readonly possuiCid: boolean
      readonly possuiCid11: boolean
      readonly possuiCiap: boolean
      readonly problema?: {
        readonly __typename?: 'Problema'
        readonly id: string
        readonly descricaoOutro?: string | null
        readonly situacao: SituacaoProblema
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
      } | null
    } | null> | null
    readonly alergiaEvolucao?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoAlergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly dataInicio?: any | null
      readonly observacao?: string | null
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly manifestacoesLegado?: string | null
      readonly possuiSubstanciaEspecificaCbara?: boolean | null
      readonly alergia?: {
        readonly __typename?: 'Alergia'
        readonly id: string
        readonly substanciaEspecificaLegado?: string | null
        readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
        readonly substanciaEspecifica?: {
          readonly __typename?: 'SubstanciaEspecificaAlergia'
          readonly id: string
          readonly categoria: CategoriaSubstanciaAlergia
          readonly nome: string
          readonly sinonimos?: string | null
          readonly sigla?: string | null
        } | null
      } | null
      readonly manifestacoes: ReadonlyArray<{
        readonly __typename?: 'ManifestacaoAlergia'
        readonly id: string
        readonly nome: string
        readonly sinonimo?: string | null
      }>
    } | null> | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly encaminhamentosEspecializados?: ReadonlyArray<{
      readonly __typename?: 'EncaminhamentoExternoEspecializado'
      readonly id: string
      readonly observacoes?: string | null
      readonly motivoEncaminhamento?: string | null
      readonly complemento?: string | null
      readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
      readonly hipoteseDiagnosticoCid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly hipoteseDiagnosticoCiap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly especialidadeSisreg: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      }
    } | null> | null
    readonly requisicoesExames?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly receitaMedicamento?: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly quantidadeReceitada: number
      readonly recomendacoes?: string | null
      readonly posologia: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly concentracao?: string | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly aplicacaoMedicamento: {
        readonly __typename?: 'AplicacaoMedicamento'
        readonly id: string
        readonly nome: string
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    } | null> | null
    readonly cuidadosCompartilhados?: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly discussao: string
      readonly cidadaoAceitaAtendTic: boolean
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly primeiraEvolucao: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      }
    }> | null
    readonly guiasEncaminhamento?: ReadonlyArray<{
      readonly __typename?: 'GuiaEncaminhamento'
      readonly id: string
      readonly discussao: string
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly especialidade: {
        readonly __typename?: 'EspecialidadeEsusReg'
        readonly id: string
        readonly nome: string
      }
    }> | null
    readonly antecedentes?: {
      readonly __typename?: 'AntecedenteItemDto'
      readonly id: string
      readonly observacoes?: string | null
      readonly puericultura?: {
        readonly __typename?: 'AntecedentePuericulturaDto'
        readonly tipoGravidez?: string | null
        readonly tipoParto?: string | null
        readonly idadeGestacionalDias?: string | null
        readonly idadeGestacionalSemanas?: string | null
        readonly apgarUm?: string | null
        readonly apgarCinco?: string | null
        readonly apgarDez?: string | null
        readonly peso?: string | null
        readonly comprimento?: string | null
        readonly perimetroCefalico?: string | null
      } | null
      readonly informacoesObstetricas?: {
        readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
        readonly gestaPrevias?: string | null
        readonly abortos?: string | null
        readonly partos?: string | null
        readonly partosVaginais?: string | null
        readonly partosCesareas?: string | null
        readonly partosDomiciliares?: string | null
        readonly nascidosVivos?: string | null
        readonly natimortos?: string | null
        readonly recemNascidoAbaixo?: string | null
        readonly recemNascidoAcima?: string | null
        readonly filhosVivos?: string | null
        readonly obitoAntesPrimeiraSemana?: string | null
        readonly obitoAposPrimeiraSemana?: string | null
        readonly desfechoUltimaGestacao?: string | null
      } | null
    } | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
    readonly vacinacao?: {
      readonly __typename?: 'AtendimentoVacinacao'
      readonly id: string
      readonly registrosVacinacao?: ReadonlyArray<{
        readonly __typename?: 'RegistroVacinacao'
        readonly id: string
        readonly dataAplicacao?: any | null
        readonly isRegistroAnterior?: boolean | null
        readonly isAplicadoExterior?: boolean | null
        readonly observacoes?: string | null
        readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
        readonly doseImunobiologico: {
          readonly __typename?: 'DoseImunobiologico'
          readonly id: string
          readonly sigla: string
        }
        readonly tipoRegistroVacinacao: {
          readonly __typename?: 'TipoRegistroVacinacao'
          readonly id: string
          readonly identificador: TipoRegistroVacinacaoEnum
        }
        readonly loteImunobiologico?: {
          readonly __typename?: 'LoteImunobiologico'
          readonly id: string
          readonly lote?: string | null
          readonly fabricante?: {
            readonly __typename?: 'ImunobiologicoFabricante'
            readonly id: string
            readonly nome: string
          } | null
        } | null
        readonly estrategiaVacinacao?: {
          readonly __typename?: 'EstrategiaVacinacao'
          readonly id: string
          readonly nome: string
        } | null
      }> | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoAtendimentoOdontologicoDwQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAtendimentoOdontologicoDwQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoOdontoDw?: {
    readonly __typename?: 'FatoAtendimentoOdonto'
    readonly id: string
    readonly isPacienteNecessidadesEspeciais: boolean
    readonly isGestante?: boolean | null
    readonly vigilanciaSaudeBucal: ReadonlyArray<string | null>
    readonly fornecimento: ReadonlyArray<string | null>
    readonly conduta: ReadonlyArray<string | null>
    readonly encaminhamento: ReadonlyArray<string | null>
    readonly nuPeso?: number | null
    readonly nuAltura?: number | null
    readonly nuPerimetroCefalico?: number | null
    readonly nuCircAbdominal?: number | null
    readonly nuPerimPanturrilha?: number | null
    readonly nuPressaoSistolica?: number | null
    readonly nuPressaoDiastolica?: number | null
    readonly nuFreqRespiratoria?: number | null
    readonly nuFreqCardiaca?: number | null
    readonly nuTemperatura?: number | null
    readonly nuSaturacaoO2?: number | null
    readonly nuImc?: number | null
    readonly nuGlicemia?: number | null
    readonly dimensaoTipoGlicemia?: DimensaoTipoGlicemiaEnum | null
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendOdontoProced'
      readonly id: string
      readonly quantidadeProcedimentos: number
      readonly dimensaoProcedimento: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
      }
    } | null> | null
    readonly dimensaoProfissional1?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoProfissional2?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo1?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoCbo2?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude1?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoUnidadeSaude2?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe1?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoEquipe2?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoLocalAtendimento?: {
      readonly __typename?: 'DimensaoLocalAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimTipoParticipacaoCidadao?: {
      readonly __typename?: 'DimensaoTipoParticipacaoAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimTipoParticipacaoProfConvidado?: {
      readonly __typename?: 'DimensaoTipoParticipacaoAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly medicamentos?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendimentoOdontoMedicamentos'
      readonly id?: string | null
      readonly unidadeMedidaDuracao?: UnidadeMedidaTempoEnum | null
      readonly unidadeFrequenciaDose?: UnidadeMedidaTempoEnum | null
      readonly tipoFrequencia?: TipoFrequencia | null
      readonly duracao?: any | null
      readonly quantidade?: any | null
      readonly dataInicioTratamento?: any | null
      readonly dose?: string | null
      readonly doseUnica?: boolean | null
      readonly usoContinuo?: boolean | null
      readonly doseFrequencia?: any | null
      readonly frequenciaDose?: string | null
      readonly qtDoseManha?: string | null
      readonly qtDoseTarde?: string | null
      readonly qtDoseNoite?: string | null
      readonly dimensaoCatmat?: {
        readonly __typename?: 'DimensaoCatmat'
        readonly id: string
        readonly principioAtivo?: string | null
        readonly concentracao?: string | null
        readonly dimensaoFormaFarmaceutica?: {
          readonly __typename?: 'DimensaoFormaFarmaceutica'
          readonly id: string
          readonly identificador?: string | null
          readonly nome?: string | null
          readonly valido?: boolean | null
        } | null
      } | null
      readonly dimensaoViaAdministracao?: {
        readonly __typename?: 'DimensaoViaAdministracao'
        readonly id: string
        readonly nome?: string | null
      } | null
    } | null> | null
    readonly problemas?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendOdontoProblemas'
      readonly id: string
      readonly dataInicioProblema?: any | null
      readonly dataFimProblema?: any | null
      readonly dimensaoCiap?: {
        readonly __typename?: 'DimensaoCiap'
        readonly id: string
        readonly codigoCiap: string
        readonly nomeCiap: string
      } | null
      readonly dimensaoCid10?: {
        readonly __typename?: 'DimensaoCid10'
        readonly id: string
        readonly codigoCid10: string
        readonly nomeCid10: string
      } | null
      readonly dimensaoSituacaoProblema?: {
        readonly __typename?: 'DimensaoSituacaoProblema'
        readonly id: string
        readonly identificador: number
        readonly descricao: string
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'FatoIvcf'
      readonly id: string
      readonly resultado: number
      readonly dimensoesAlteradas: string
      readonly dimensaoGrauVulnerabilidadeIvcf: {
        readonly __typename?: 'DimensaoGrauVulnerabilidadeIvcf'
        readonly id?: string | null
        readonly descricao?: string | null
      }
    } | null
    readonly exames?: ReadonlyArray<{
      readonly __typename?: 'FatoAtendimentoOdontoExames'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly dataResultadoData?: any | null
      readonly nuResultadoValor?: number | null
      readonly nuResultadoDia?: number | null
      readonly nuResultadoSemana?: number | null
      readonly resultadoPuericultura?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
      readonly resultadoExameEstruturadoQualitativo?: OpcoesResultadoExameQualitativoEnum | null
      readonly dimensaoProcedimentoAvaliado?: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
        readonly dimensaoProcedimentoReferencia?: {
          readonly __typename?: 'DimensaoProcedimento'
          readonly id: string
          readonly codigoProcedimento: string
          readonly descricaoProcedimento: string
        } | null
      } | null
      readonly dimensaoProcedimentoSolicitado?: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
        readonly dimensaoProcedimentoReferencia?: {
          readonly __typename?: 'DimensaoProcedimento'
          readonly id: string
          readonly codigoProcedimento: string
          readonly descricaoProcedimento: string
        } | null
      } | null
    } | null> | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'FatoSolicitacaoOci'
      readonly id: string
      readonly dimensaoProcedimento: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly codigoProcedimento: string
        readonly descricaoProcedimento: string
      }
    }> | null
  } | null
}

export type HistoricoAtendimentoOdontoPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAtendimentoOdontoPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly quantidadeAtestados?: number | null
    readonly quantidadeOrientacoes?: number | null
    readonly encaminhamentos?: ReadonlyArray<TipoEncaminhamentoExternoEnum> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly necessidadesEspeciais?: boolean | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly medicaoAnterior?: boolean | null
      readonly dataMedicao: any
      readonly valorImc?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly evolucaoAvaliacao?: {
      readonly __typename?: 'EvolucaoAvaliacao'
      readonly id: string
      readonly necessidadeDeProtese?: boolean | null
      readonly tiposVigilanciaBucal?: ReadonlyArray<VigilanciaEmSaudeBucalEnum | null> | null
      readonly descricao?: string | null
      readonly ciapsCids?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
        readonly id: string
        readonly nota?: string | null
        readonly isCiapCidNaListaDeProblemas: boolean
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
      }> | null
    } | null
    readonly atendimentoProfissionalOdonto?: {
      readonly __typename?: 'AtendimentoProfissionalOdonto'
      readonly id: string
      readonly observacaoRPC?: string | null
      readonly cdsTipoFornecimOdonto?: ReadonlyArray<FornecimentoOdontoEnum | null> | null
      readonly tipoConduta?: ReadonlyArray<TipoEncaminhamentoOdontoEnum | null> | null
      readonly odontograma?: {
        readonly __typename?: 'Odontograma'
        readonly id: string
        readonly proteseTotalInferior?: boolean | null
        readonly proteseTotalSuperior?: boolean | null
        readonly contencao?: boolean | null
        readonly aparelho?: boolean | null
      } | null
      readonly evolucoes?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoProcedimentoOdonto'
        readonly id: string
        readonly descricaoParteBucal?: string | null
        readonly observacao?: string | null
        readonly procedimentos?: ReadonlyArray<{
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        }> | null
        readonly partesBucais?: ReadonlyArray<{
          readonly __typename?: 'ParteBucal'
          readonly id: string
          readonly tipoParteBucal: TipoParteBucalEnum
          readonly descricao?: string | null
          readonly parteBucalEnum: ParteBucalEnum
        }> | null
      } | null> | null
      readonly periogramaSimplificado?: {
        readonly __typename?: 'PeriogramaSimplificado'
        readonly id: string
        readonly avaliacaoSextante1: string
        readonly avaliacaoSextante2: string
        readonly avaliacaoSextante3: string
        readonly avaliacaoSextante4: string
        readonly avaliacaoSextante5: string
        readonly avaliacaoSextante6: string
        readonly observacao?: string | null
      } | null
      readonly periogramaCompleto?: ReadonlyArray<{
        readonly __typename?: 'PeriogramaCompleto'
        readonly id: string
        readonly excluido: boolean
        readonly profundidadeVestibular?: string | null
        readonly recessaoVestibular?: string | null
        readonly profundidadeInterna?: string | null
        readonly recessaoInterna?: string | null
        readonly placaDVestibular?: boolean | null
        readonly placaVVestibular?: boolean | null
        readonly placaMVestibular?: boolean | null
        readonly sangramentoDVestibular?: boolean | null
        readonly sangramentoVVestibular?: boolean | null
        readonly sangramentoMVestibular?: boolean | null
        readonly placaDInterna?: boolean | null
        readonly placaVInterna?: boolean | null
        readonly placaMInterna?: boolean | null
        readonly sangramentoDInterna?: boolean | null
        readonly sangramentoVInterna?: boolean | null
        readonly sangramentoMInterna?: boolean | null
        readonly mobilidade?: string | null
        readonly lesaoDeFurca?: string | null
        readonly dente: {
          readonly __typename?: 'ParteBucal'
          readonly id: string
          readonly parteBucalEnum: ParteBucalEnum
        }
      } | null> | null
      readonly tecidosMoles?: ReadonlyArray<{
        readonly __typename?: 'TecidoMole'
        readonly id: string
        readonly descricaoSintomatologia?: string | null
        readonly parteBucal: {
          readonly __typename?: 'ParteBucal'
          readonly id: string
          readonly descricao?: string | null
        }
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly caracteristicasLesao?: ReadonlyArray<{
          readonly __typename?: 'CaracteristicaLesao'
          readonly id: string
          readonly caracteristicaLesao: CaracteristicaLesaoEnum
        }> | null
        readonly evolucaoProcedimentoOdonto?: {
          readonly __typename?: 'EvolucaoProcedimentoOdonto'
          readonly id: string
          readonly observacao?: string | null
          readonly procedimentos?: ReadonlyArray<{
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
          }> | null
        } | null
      } | null> | null
    } | null
    readonly solicitacoesOci?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly procedimentos: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly examesResultados?: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly resultado?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly formato: string
      }
      readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    }>
    readonly mChats?: ReadonlyArray<{
      readonly __typename?: 'MChat'
      readonly id: string
      readonly pontuacao: number
      readonly risco: MChatRiscoEnum
      readonly isMchatRf: boolean
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'MchatAplicacao'
        readonly id: string
        readonly pergunta: MChatPerguntaEnum
        readonly stPassou?: boolean | null
        readonly outros?: string | null
        readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
      }>
    }> | null
    readonly evolucaoProblema?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProblema'
      readonly id: string
      readonly dataInicio?: any | null
      readonly dataFim?: any | null
      readonly situacao: SituacaoProblema
      readonly observacao?: string | null
      readonly atualizadoEm?: any | null
      readonly possuiCid: boolean
      readonly possuiCid11: boolean
      readonly possuiCiap: boolean
      readonly problema?: {
        readonly __typename?: 'Problema'
        readonly id: string
        readonly descricaoOutro?: string | null
        readonly situacao: SituacaoProblema
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly cid11?: {
          readonly __typename?: 'Cid11'
          readonly id: string
          readonly codigo: string
          readonly nome: string
          readonly ativo: boolean
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
      } | null
    } | null> | null
    readonly alergiaEvolucao?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoAlergia'
      readonly id: string
      readonly criticidade: CriticidadeAlergia
      readonly dataInicio?: any | null
      readonly observacao?: string | null
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly grauCerteza: GrauCertezaAlergia
      readonly manifestacoesLegado?: string | null
      readonly possuiSubstanciaEspecificaCbara?: boolean | null
      readonly alergia?: {
        readonly __typename?: 'Alergia'
        readonly id: string
        readonly substanciaEspecificaLegado?: string | null
        readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
        readonly substanciaEspecifica?: {
          readonly __typename?: 'SubstanciaEspecificaAlergia'
          readonly id: string
          readonly categoria: CategoriaSubstanciaAlergia
          readonly nome: string
          readonly sinonimos?: string | null
          readonly sigla?: string | null
        } | null
      } | null
      readonly manifestacoes: ReadonlyArray<{
        readonly __typename?: 'ManifestacaoAlergia'
        readonly id: string
        readonly nome: string
        readonly sinonimo?: string | null
      }>
    } | null> | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly encaminhamentosEspecializados?: ReadonlyArray<{
      readonly __typename?: 'EncaminhamentoExternoEspecializado'
      readonly id: string
      readonly observacoes?: string | null
      readonly motivoEncaminhamento?: string | null
      readonly complemento?: string | null
      readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
      readonly hipoteseDiagnosticoCid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly hipoteseDiagnosticoCiap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly especialidadeSisreg: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      }
    } | null> | null
    readonly requisicoesExames?: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly tipoExame: TipoExameEnum
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly observacao?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
    }> | null
    readonly receitaMedicamento?: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly quantidadeReceitada: number
      readonly recomendacoes?: string | null
      readonly posologia: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly concentracao?: string | null
        readonly formaFarmaceutica?: {
          readonly __typename?: 'FormaFarmaceutica'
          readonly id: string
          readonly nome: string
        } | null
      }
      readonly aplicacaoMedicamento: {
        readonly __typename?: 'AplicacaoMedicamento'
        readonly id: string
        readonly nome: string
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    } | null> | null
    readonly cuidadosCompartilhados?: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly discussao: string
      readonly cidadaoAceitaAtendTic: boolean
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly primeiraEvolucao: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly cns?: string | null
            readonly nome: string
            readonly nomeCivil: string
            readonly nomeSocial?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
        readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaudeExecutante: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
      }
    }> | null
    readonly guiasEncaminhamento?: ReadonlyArray<{
      readonly __typename?: 'GuiaEncaminhamento'
      readonly id: string
      readonly discussao: string
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly especialidade: {
        readonly __typename?: 'EspecialidadeEsusReg'
        readonly id: string
        readonly nome: string
      }
    }> | null
    readonly antecedentes?: {
      readonly __typename?: 'AntecedenteItemDto'
      readonly id: string
      readonly observacoes?: string | null
      readonly puericultura?: {
        readonly __typename?: 'AntecedentePuericulturaDto'
        readonly tipoGravidez?: string | null
        readonly tipoParto?: string | null
        readonly idadeGestacionalDias?: string | null
        readonly idadeGestacionalSemanas?: string | null
        readonly apgarUm?: string | null
        readonly apgarCinco?: string | null
        readonly apgarDez?: string | null
        readonly peso?: string | null
        readonly comprimento?: string | null
        readonly perimetroCefalico?: string | null
      } | null
      readonly informacoesObstetricas?: {
        readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
        readonly gestaPrevias?: string | null
        readonly abortos?: string | null
        readonly partos?: string | null
        readonly partosVaginais?: string | null
        readonly partosCesareas?: string | null
        readonly partosDomiciliares?: string | null
        readonly nascidosVivos?: string | null
        readonly natimortos?: string | null
        readonly recemNascidoAbaixo?: string | null
        readonly recemNascidoAcima?: string | null
        readonly filhosVivos?: string | null
        readonly obitoAntesPrimeiraSemana?: string | null
        readonly obitoAposPrimeiraSemana?: string | null
        readonly desfechoUltimaGestacao?: string | null
      } | null
    } | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
    readonly vacinacao?: {
      readonly __typename?: 'AtendimentoVacinacao'
      readonly id: string
      readonly registrosVacinacao?: ReadonlyArray<{
        readonly __typename?: 'RegistroVacinacao'
        readonly id: string
        readonly dataAplicacao?: any | null
        readonly isRegistroAnterior?: boolean | null
        readonly isAplicadoExterior?: boolean | null
        readonly observacoes?: string | null
        readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
        readonly doseImunobiologico: {
          readonly __typename?: 'DoseImunobiologico'
          readonly id: string
          readonly sigla: string
        }
        readonly tipoRegistroVacinacao: {
          readonly __typename?: 'TipoRegistroVacinacao'
          readonly id: string
          readonly identificador: TipoRegistroVacinacaoEnum
        }
        readonly loteImunobiologico?: {
          readonly __typename?: 'LoteImunobiologico'
          readonly id: string
          readonly lote?: string | null
          readonly fabricante?: {
            readonly __typename?: 'ImunobiologicoFabricante'
            readonly id: string
            readonly nome: string
          } | null
        } | null
        readonly estrategiaVacinacao?: {
          readonly __typename?: 'EstrategiaVacinacao'
          readonly id: string
          readonly nome: string
        } | null
      }> | null
    } | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoAtividadeColetivaQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAtividadeColetivaQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtividadeColetiva?: {
    readonly __typename?: 'FatoAtividadeColetivaParticipante'
    readonly id: string
    readonly nuUuidFicha: string
    readonly stAvaliacaoAlterada?: boolean | null
    readonly nuPesoParticipante?: number | null
    readonly nuAlturaParticipante?: number | null
    readonly nuImcParticipante?: number | null
    readonly pnctParticipante: ReadonlyArray<string | null>
    readonly fatoAtividadeColetiva: {
      readonly __typename?: 'FatoAtividadeColetiva'
      readonly id: string
      readonly descricaoOutraLocalidade?: string | null
      readonly nuAvaliacoesAlteradas?: number | null
      readonly stPseEducacao: boolean
      readonly stPseSaude: boolean
      readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
      readonly praticasSaude?: ReadonlyArray<PraticaSaudeEnum | null> | null
      readonly publicoAlvo?: ReadonlyArray<PublicoAlvoEnum | null> | null
      readonly dimensaoProcedimento?: {
        readonly __typename?: 'DimensaoProcedimento'
        readonly id: string
        readonly descricaoProcedimento: string
        readonly codigoProcedimento: string
      } | null
      readonly dimensaoProfissional?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly cns?: string | null
        readonly nome?: string | null
      } | null
      readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
      readonly dimensaoUnidadeSaude?: {
        readonly __typename?: 'DimensaoUnidadeSaude'
        readonly id: string
        readonly nome: string
        readonly cnes: string
      } | null
      readonly dimensaoEquipe?: {
        readonly __typename?: 'DimensaoEquipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly dimensaoTipoAtividade: {
        readonly __typename?: 'DimensaoTipoAtividade'
        readonly id: string
        readonly descricaoTipoAtividade: string
      }
      readonly dimensaoInep?: {
        readonly __typename?: 'DimensaoInep'
        readonly id: string
        readonly nuIdentificador: string
        readonly noEstabelecimento?: string | null
      } | null
      readonly dimensaoUnddSadeAcdmSade?: {
        readonly __typename?: 'DimensaoUnidadeSaude'
        readonly id: string
        readonly nome: string
        readonly cnes: string
      } | null
    }
  } | null
}

export type HistoricoAtividadeColetivaReuniaoQueryVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
  cidadaoId: Scalars['Long']['input']
}>

export type HistoricoAtividadeColetivaReuniaoQuery = {
  readonly __typename?: 'Query'
  readonly atividadeColetiva: {
    readonly __typename?: 'AtividadeColetiva'
    readonly id: string
    readonly tipoAtividade: TipoAtividadeEnum
    readonly temasReuniao?: ReadonlyArray<TemaReuniaoEnum | null> | null
    readonly outraLocalidade?: string | null
    readonly lotacaoResponsavel: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    }
    readonly inepLocalAtividade?: {
      readonly __typename?: 'Inep'
      readonly id: string
      readonly nomeEstabelecimento: string
      readonly dsInep: string
    } | null
    readonly unidadeSaudeLocalAtividade?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
    } | null
    readonly observacaoCidadao?: {
      readonly __typename?: 'AtividadeColetivaObservacaoCidadao'
      readonly id: string
      readonly observacao: string
    } | null
  }
}

export type HistoricoAtividadeColetivaSaudeQueryVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
  cidadaoId: Scalars['Long']['input']
}>

export type HistoricoAtividadeColetivaSaudeQuery = {
  readonly __typename?: 'Query'
  readonly atividadeColetiva: {
    readonly __typename?: 'AtividadeColetiva'
    readonly id: string
    readonly tipoAtividade: TipoAtividadeEnum
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly praticasSaude?: ReadonlyArray<PraticaSaudeEnum | null> | null
    readonly publicoAlvo?: ReadonlyArray<PublicoAlvoEnum | null> | null
    readonly outraLocalidade?: string | null
    readonly anotacoes?: string | null
    readonly atividadeEducacaoPse: boolean
    readonly atividadeSaudePse: boolean
    readonly procedimento?: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
    } | null
    readonly lotacaoResponsavel: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    }
    readonly inepLocalAtividade?: {
      readonly __typename?: 'Inep'
      readonly id: string
      readonly nomeEstabelecimento: string
      readonly dsInep: string
    } | null
    readonly unidadeSaudeLocalAtividade?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
    } | null
    readonly participante?: {
      readonly __typename?: 'AtividadeColetivaRegistroParticipante'
      readonly id: string
      readonly atividadeColetivaId: any
      readonly peso?: number | null
      readonly altura?: number | null
      readonly avaliacaoAlterada?: boolean | null
      readonly pnctAbandonouGrupo?: boolean | null
      readonly pnctCessouHabitoFumar?: boolean | null
    } | null
  }
}

export type HistoricoAvaliacaoElegibilidadeAdQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAvaliacaoElegibilidadeAdQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly atendimentoProfissionalAD?: {
      readonly __typename?: 'AtendimentoProfissionalAtencaoDomiciliar'
      readonly id: string
      readonly origem?: AtencaoDomiciliarOrigem | null
      readonly modalidade: AtencaoDomiciliarModalidade
      readonly elegivel?: boolean | null
      readonly conclusao?: ReadonlyArray<string | null> | null
      readonly conduta?: AtencaoDomiciliarCondutaDesfecho | null
      readonly cid10Principal?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid10Secundario1?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly cid10Secundario2?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly condicoesAvaliadasElegibilidade?: ReadonlyArray<{
        readonly __typename?: 'AtendimentoProfissionalAtencaoDomiciliarQuestao'
        readonly id: string
        readonly situacaoAtiva?: boolean | null
        readonly descricao?: string | null
      } | null> | null
    } | null
    readonly cidadaoAD?: {
      readonly __typename?: 'AtencaoDomiciliarCidadao'
      readonly id: string
      readonly dataObito?: any | null
      readonly numeroDocumentoObito?: string | null
    } | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoAvaliacaoElegibilidadeDwQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoAvaliacaoElegibilidadeDwQuery = {
  readonly __typename?: 'Query'
  readonly historicoElegibilidadeDetail?: {
    readonly __typename?: 'FatoAvaliacaoElegibilidade'
    readonly id: string
    readonly nuUuidFicha: string
    readonly procedenciaOrigem?: string | null
    readonly condicoesAvaliadas?: ReadonlyArray<string | null> | null
    readonly conclusao?: ReadonlyArray<string | null> | null
    readonly isElegivel: boolean
    readonly cpfCuidador?: string | null
    readonly cnsCuidador?: string | null
    readonly dimensaoCid10Principal?: {
      readonly __typename?: 'DimensaoCid10'
      readonly id: string
      readonly codigoCid10: string
      readonly nomeCid10: string
    } | null
    readonly dimensaoCid10SecundarioUm?: {
      readonly __typename?: 'DimensaoCid10'
      readonly id: string
      readonly codigoCid10: string
      readonly nomeCid10: string
    } | null
    readonly dimensaoCid10SecundarioDois?: {
      readonly __typename?: 'DimensaoCid10'
      readonly id: string
      readonly codigoCid10: string
      readonly nomeCid10: string
    } | null
    readonly dimensaoProfissional1?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly cns?: string | null
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo1?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly cbo: string
      readonly nome: string
    } | null
    readonly dimensaoUnidadeSaude1?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe1?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoProfissional2?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly cns?: string | null
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo2?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly cbo: string
      readonly nome: string
    } | null
    readonly dimensaoUnidadeSaude2?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe2?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoCuidador?: {
      readonly __typename?: 'DimensaoCuidador'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoModalidadeAD?: {
      readonly __typename?: 'DimensaoModalidadeAD'
      readonly id: string
      readonly descricao: string
    } | null
  } | null
}

export type CboHistoricoCuidadoCompartilhadoHeaderFragment = {
  readonly __typename?: 'Cbo'
  readonly id: string
  readonly nome: string
}

export type HistoricoCuidadoCompartilhadoDwDetalhesQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoCuidadoCompartilhadoDwDetalhesQuery = {
  readonly __typename?: 'Query'
  readonly historicoCuidadoCompartilhadoDw?: {
    readonly __typename?: 'FatoCuidadoCompartilhado'
    readonly id: string
    readonly dataCriacaoCuidado?: any | null
    readonly codigoSequencialEvolucao?: number | null
    readonly isExecutante?: boolean | null
    readonly dimProfissionalSolicitante?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimCboSolicitante?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
    } | null
    readonly dimUnidadeSaudeSolicitante?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimEquipeSolicitante?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimProfissionalExecutante?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimCboExecutante?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
    } | null
    readonly dimUnidadeSaudeExecutante?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimEquipeExecutante?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoCondutaCuidado?: {
      readonly __typename?: 'DimensaoCondutaCuidado'
      readonly id: string
      readonly nuIdentificador: string
    } | null
    readonly dimensaoCid10?: {
      readonly __typename?: 'DimensaoCid10'
      readonly id: string
      readonly codigoCid10: string
      readonly nomeCid10: string
    } | null
    readonly dimensaoCiap?: {
      readonly __typename?: 'DimensaoCiap'
      readonly id: string
      readonly codigoCiap: string
      readonly nomeCiap: string
    } | null
    readonly dimensaoPrioridadeCuidado?: {
      readonly __typename?: 'DimensaoPrioridadeCuidado'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimReclassificacaoPrioridade?: {
      readonly __typename?: 'DimensaoPrioridadeCuidado'
      readonly id: string
      readonly descricao: string
    } | null
  } | null
}

export type HistoricoCuidadoCompartilhadoEvolucaoDetalhesQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type HistoricoCuidadoCompartilhadoEvolucaoDetalhesQuery = {
  readonly __typename?: 'Query'
  readonly cuidadoCompartilhadoEvolucao?: {
    readonly __typename?: 'CuidadoCompartilhadoEvolucao'
    readonly id: string
    readonly conduta: CondutaCuidadoCompartilhadoEnum
    readonly dataEvolucao: any
    readonly descricao?: string | null
    readonly codigoSequencialEvolucao: number
    readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
    readonly reclassificacaoPrioridade?: ClassificacaoPrioridadeCuidadoEnum | null
    readonly enviarGarantiaAcesso?: CondutaCuidadoCompartilhadoEnum | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly cns?: string | null
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
    }
    readonly cuidadoCompartilhado: {
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly iniciadoEm: any
      readonly discussao: string
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly atendimento?: {
          readonly __typename?: 'Atendimento'
          readonly id: string
          readonly localAtendimento?: {
            readonly __typename?: 'LocalAtendimento'
            readonly id: string
            readonly localAtendimentoExibicao?: string | null
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
        } | null
      }
    }
    readonly agenda?: {
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly horarioInicial: any
      readonly observacao?: string | null
      readonly situacao: SituacaoAgendadoEnum
    } | null
  } | null
}

export type HistoricoCuidadoCompartilhadoEvolucaoHeaderFragment = {
  readonly __typename?: 'CuidadoCompartilhadoEvolucao'
  readonly id: string
  readonly conduta: CondutaCuidadoCompartilhadoEnum
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly reclassificacaoPrioridade?: ClassificacaoPrioridadeCuidadoEnum | null
  readonly lotacaoExecutante?: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly cns?: string | null
      readonly nome: string
      readonly nomeCivil: string
      readonly nomeSocial?: string | null
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
    } | null
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
  } | null
  readonly cboExecutante: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
  readonly unidadeSaudeExecutante: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
}

export type HistoricoCuidadoCompartilhadoHeaderFragment = {
  readonly __typename?: 'CuidadoCompartilhado'
  readonly id: string
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly ciap?: {
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  } | null
  readonly lotacaoSolicitante: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly cns?: string | null
      readonly nome: string
      readonly nomeCivil: string
      readonly nomeSocial?: string | null
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
    } | null
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
  }
}

export type LotacaoHistoricoCuidadoCompartilhadoHeaderFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly cns?: string | null
    readonly nome: string
    readonly nomeCivil: string
    readonly nomeSocial?: string | null
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
  } | null
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
}

export type UnidadeSaudeHistoricoCuidadoCompartilhadoHeaderFragment = {
  readonly __typename?: 'UnidadeSaude'
  readonly id: string
  readonly nome?: string | null
  readonly cnes: string
}

export type HistoricoCuidadoCompartilhadoLotacaoAfetadaQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type HistoricoCuidadoCompartilhadoLotacaoAfetadaQuery = {
  readonly __typename?: 'Query'
  readonly cuidadoCompartilhadoEvolucao?: {
    readonly __typename?: 'CuidadoCompartilhadoEvolucao'
    readonly id: string
    readonly lotacaoAfetada?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly cns?: string | null
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
    } | null
  } | null
}

export type HistoricoAuditImpressaoEscutaMutationVariables = Exact<{
  atendProfId: Scalars['ID']['input']
}>

export type HistoricoAuditImpressaoEscutaMutation = {
  readonly __typename?: 'Mutation'
  readonly auditImpressaoEscutaInicial?: string | null
}

export type HistoricoEscutaInicialQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoEscutaInicialQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly classificacaoRisco?: ClassificacaoRisco | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly acompanhadoEspecialidade?: string | null
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly valorImc?: number | null
      readonly id: string
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly obrigatorio?: boolean | null
      readonly automatico?: boolean | null
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly tipoProcedimento?: TipoProcedimentoEnum | null
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type ImpressaoEscutaInicialQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type ImpressaoEscutaInicialQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly classificacaoRisco?: ClassificacaoRisco | null
    readonly iniciadoEm: any
    readonly motivoConsulta?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly texto?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly automatico?: boolean | null
      readonly _id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
      }
    } | null> | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isAgendado: boolean
      readonly cidadao: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly cns?: string | null
        readonly cpf?: string | null
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
        readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      }
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly numeroConselhoClasse?: string | null
        readonly conselhoClasse?: {
          readonly __typename?: 'ConselhoClasse'
          readonly id: string
          readonly sigla: string
        } | null
        readonly ufEmissoraConselhoClasse?: {
          readonly __typename?: 'UF'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        } | null
      }
      readonly municipio: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    }
  } | null
}

export type HistoricoMarcadoresConsumoAlimentarQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoMarcadoresConsumoAlimentarQuery = {
  readonly __typename?: 'Query'
  readonly historicoConsumoAlimentarDetail?: {
    readonly __typename?: 'HistoricoConsumoAlimentarDetail'
    readonly id: string
    readonly subtitle: string
    readonly questionario: string
    readonly perguntasRespostas: ReadonlyArray<{
      readonly __typename?: 'PerguntasRespostasHistoricoConsumoAlimentar'
      readonly pergunta: string
      readonly respostas: ReadonlyArray<string | null>
    } | null>
    readonly perguntasRespostasOntem: ReadonlyArray<{
      readonly __typename?: 'PerguntasRespostasHistoricoConsumoAlimentar'
      readonly pergunta: string
      readonly respostas: ReadonlyArray<string | null>
    } | null>
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoLocalAtendimento?: {
      readonly __typename?: 'DimensaoLocalAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
  } | null
}

export type HistoricoProcedimentoDwQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoProcedimentoDwQuery = {
  readonly __typename?: 'Query'
  readonly historicoProcedimentoDw?: {
    readonly __typename?: 'FatoProcedAtend'
    readonly id: string
    readonly nuPeso?: number | null
    readonly nuAltura?: number | null
    readonly nuPerimetroCefalico?: number | null
    readonly nuCircAbdominal?: number | null
    readonly nuPerimPanturrilha?: number | null
    readonly nuPressaoSistolica?: number | null
    readonly nuPressaoDiastolica?: number | null
    readonly nuFreqRespiratoria?: number | null
    readonly nuFreqCardiaca?: number | null
    readonly nuTemperatura?: number | null
    readonly nuSaturacaoO2?: number | null
    readonly nuImc?: number | null
    readonly nuGlicemia?: number | null
    readonly dimensaoTipoGlicemia?: DimensaoTipoGlicemiaEnum | null
    readonly filtroCiapPlano?: string | null
    readonly filtroCiapMotivoConsulta?: string | null
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'DimensaoProcedimento'
      readonly id: string
      readonly codigoProcedimento: string
      readonly descricaoProcedimento: string
    }> | null
    readonly dimensaoProfissional: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    }
    readonly dimensaoCbo: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string }
    readonly dimensaoUnidadeSaude: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    }
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoLocalAtendimento?: {
      readonly __typename?: 'DimensaoLocalAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
    readonly ivcf?: {
      readonly __typename?: 'FatoIvcf'
      readonly id: string
      readonly resultado: number
      readonly dimensoesAlteradas: string
      readonly dimensaoGrauVulnerabilidadeIvcf: {
        readonly __typename?: 'DimensaoGrauVulnerabilidadeIvcf'
        readonly id?: string | null
        readonly descricao?: string | null
      }
    } | null
    readonly fatoAppAtendimento?: {
      readonly __typename?: 'FatoAppAtendimento'
      readonly id: string
      readonly campoAbertoSubjetivo?: string | null
      readonly campoAbertoObjetivo?: string | null
      readonly campoAbertoAvaliacao?: string | null
      readonly campoAbertoPlano?: string | null
    } | null
  } | null
}

export type HistoricoProcedimentoPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoProcedimentoPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoAtendimentoPec?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly quantidadeOrientacoes?: number | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null
    readonly planosDeCuidado?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
      readonly id: string
      readonly descricao: string
      readonly dataDescricao: any
    }> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly valorImc?: number | null
      readonly dum?: any | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly id: string
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly examesResultados?: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly resultado?: string | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
    } | null> | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly formato: string
      }
      readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    }>
    readonly mChats?: ReadonlyArray<{
      readonly __typename?: 'MChat'
      readonly id: string
      readonly pontuacao: number
      readonly risco: MChatRiscoEnum
      readonly isMchatRf: boolean
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'MchatAplicacao'
        readonly id: string
        readonly pergunta: MChatPerguntaEnum
        readonly stPassou?: boolean | null
        readonly outros?: string | null
        readonly perguntaOpcao?: MChatPerguntaOpcaoEnum | null
      }>
    }> | null
    readonly antecedentes?: {
      readonly __typename?: 'AntecedenteItemDto'
      readonly id: string
      readonly observacoes?: string | null
      readonly puericultura?: {
        readonly __typename?: 'AntecedentePuericulturaDto'
        readonly tipoGravidez?: string | null
        readonly tipoParto?: string | null
        readonly idadeGestacionalDias?: string | null
        readonly idadeGestacionalSemanas?: string | null
        readonly apgarUm?: string | null
        readonly apgarCinco?: string | null
        readonly apgarDez?: string | null
        readonly peso?: string | null
        readonly comprimento?: string | null
        readonly perimetroCefalico?: string | null
      } | null
      readonly informacoesObstetricas?: {
        readonly __typename?: 'AntecedenteInformacoesObstetricasDto'
        readonly gestaPrevias?: string | null
        readonly abortos?: string | null
        readonly partos?: string | null
        readonly partosVaginais?: string | null
        readonly partosCesareas?: string | null
        readonly partosDomiciliares?: string | null
        readonly nascidosVivos?: string | null
        readonly natimortos?: string | null
        readonly recemNascidoAbaixo?: string | null
        readonly recemNascidoAcima?: string | null
        readonly filhosVivos?: string | null
        readonly obitoAntesPrimeiraSemana?: string | null
        readonly obitoAposPrimeiraSemana?: string | null
        readonly desfechoUltimaGestacao?: string | null
      } | null
    } | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type HistoricoVacinacaoDwQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoVacinacaoDwQuery = {
  readonly __typename?: 'Query'
  readonly historicoVacinacaoDw: {
    readonly __typename?: 'FatoVacinacao'
    readonly id: string
    readonly viajante?: boolean | null
    readonly comunicanteHanseniase?: boolean | null
    readonly dataRegistro: any
    readonly dimensaoCondicaoMaternal?: {
      readonly __typename?: 'DimensaoCondicaoMaternal'
      readonly id: string
      readonly descricao: string
      readonly identificador: number
    } | null
    readonly fatosVacinacaoVacina?: ReadonlyArray<{
      readonly __typename?: 'FatoVacinacaoVacina'
      readonly id: string
      readonly nomeFabricante?: string | null
      readonly nomeLote?: string | null
      readonly isRegistroAnterior: boolean
      readonly dataRegistroVacinaAplicada: any
      readonly dataRegistro: any
      readonly isPesquisaClinica?: boolean | null
      readonly anvisaProtocoloEstudo?: string | null
      readonly anvisaProtocoloVersao?: string | null
      readonly anvisaNumeroRegistro?: string | null
      readonly dimensaoImunobiologico: {
        readonly __typename?: 'DimensaoImunobiologico'
        readonly id: string
        readonly nome: string
      }
      readonly dimensaoEstrategiaVacinacao?: {
        readonly __typename?: 'DimensaoEstrategiaVacinacao'
        readonly id: string
        readonly nome: string
      } | null
      readonly dimensaoDoseImunobiologico: {
        readonly __typename?: 'DimensaoDoseImunobiologico'
        readonly id: string
        readonly nome: string
      }
      readonly dimensaoViaAdministracao?: {
        readonly __typename?: 'DimensaoViaAdministracaoVacina'
        readonly id: string
        readonly nome: string
      } | null
      readonly dimensaoLocalAplicacao?: {
        readonly __typename?: 'DimensaoLocalAplicacaoVacina'
        readonly id: string
        readonly nome: string
      } | null
      readonly dimensaoCboPrescritor?: {
        readonly __typename?: 'DimensaoCbo'
        readonly id: string
        readonly cbo: string
      } | null
      readonly dimensaoCid10MotivoIndicacao?: {
        readonly __typename?: 'DimensaoCid10'
        readonly id: string
        readonly codigoCid10: string
        readonly nomeCid10: string
      } | null
    }> | null
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoLocalAtendimento?: {
      readonly __typename?: 'DimensaoLocalAtendimento'
      readonly id: string
      readonly descricao: string
    } | null
  }
}

export type HistoricoVacinacaoPecQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoVacinacaoPecQuery = {
  readonly __typename?: 'Query'
  readonly historicoVacinacaoPec: {
    readonly __typename?: 'AtendimentoVacinacao'
    readonly id: string
    readonly condicaoMaternal?: CondicaoMaternalDbEnum | null
    readonly isViajante?: boolean | null
    readonly isComunicanteHanseniase?: boolean | null
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly finalizadoEm?: any | null
      readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
      readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
      readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
      readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
      readonly procedimentosAtendimento?: ReadonlyArray<{
        readonly __typename?: 'AtendimentoProcedimento'
        readonly id: string
        readonly procedimento: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
      readonly notificacoesCasoSuspeito?: ReadonlyArray<{
        readonly __typename?: 'SinanNotificacaoEvolucao'
        readonly id: string
        readonly notificacao: {
          readonly __typename?: 'FichaNotificacaoCasoSuspeito'
          readonly id: string
          readonly nomeNotificacao: string
        }
      } | null> | null
      readonly estagio?: {
        readonly __typename?: 'Estagio'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeCivil: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        } | null
      } | null
      readonly atendimento?: {
        readonly __typename?: 'Atendimento'
        readonly id: string
        readonly isRegistroTardio: boolean
        readonly dataCriacaoRegistro?: any | null
        readonly localAtendimento?: {
          readonly __typename?: 'LocalAtendimento'
          readonly id: string
          readonly localAtendimentoExibicao?: string | null
        } | null
      } | null
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeCivil: string
          readonly nomeSocial?: string | null
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
          readonly tipoEstabelecimento: TipoEstabelecimentoEnum
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        } | null
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
          readonly actions?: {
            readonly __typename?: 'CboActions'
            readonly cadastroDomiciliar: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly cadastroIndividual: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly atividadeColetiva: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          } | null
        }
      }
      readonly lotacaoAtendimentoCompartilhado?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeCivil: string
          readonly nomeSocial?: string | null
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        } | null
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
          readonly actions?: {
            readonly __typename?: 'CboActions'
            readonly cadastroDomiciliar: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly cadastroIndividual: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly atividadeColetiva: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          } | null
        }
      } | null
      readonly atendimentoProfissionalObservacao?: {
        readonly __typename?: 'AtendimentoProfissionalObservacao'
        readonly id: string
        readonly atendimentoObservacao: {
          readonly __typename?: 'AtendimentoObservacao'
          readonly id: string
          readonly atendimentoProfissionalFinalizador?: {
            readonly __typename?: 'AtendimentoProfissional'
            readonly id: string
            readonly lotacao: {
              readonly __typename?: 'Lotacao'
              readonly id: string
              readonly profissional: {
                readonly __typename?: 'Profissional'
                readonly id: string
                readonly nome: string
                readonly nomeCivil: string
                readonly nomeSocial?: string | null
              }
              readonly unidadeSaude: {
                readonly __typename?: 'UnidadeSaude'
                readonly id: string
                readonly nome?: string | null
                readonly cnes: string
                readonly tipoEstabelecimento: TipoEstabelecimentoEnum
              }
              readonly equipe?: {
                readonly __typename?: 'Equipe'
                readonly id: string
                readonly nome: string
                readonly ine: string
              } | null
              readonly cbo: {
                readonly __typename?: 'Cbo'
                readonly id: string
                readonly nome: string
                readonly cbo2002: string
                readonly actions?: {
                  readonly __typename?: 'CboActions'
                  readonly cadastroDomiciliar: {
                    readonly __typename?: 'Action'
                    readonly enabled: boolean
                    readonly hint?: string | null
                  }
                  readonly cadastroIndividual: {
                    readonly __typename?: 'Action'
                    readonly enabled: boolean
                    readonly hint?: string | null
                  }
                  readonly atividadeColetiva: {
                    readonly __typename?: 'Action'
                    readonly enabled: boolean
                    readonly hint?: string | null
                  }
                } | null
              }
            }
          } | null
        }
      } | null
    }
    readonly registrosVacinacao?: ReadonlyArray<{
      readonly __typename?: 'RegistroVacinacao'
      readonly id: string
      readonly isRegistroAnterior?: boolean | null
      readonly isAplicadoExterior?: boolean | null
      readonly dataAplicacao?: any | null
      readonly isPesquisaClinica?: boolean | null
      readonly anvisaProtocoloEstudo?: string | null
      readonly anvisaProtocoloVersao?: string | null
      readonly anvisaNumeroRegistro?: string | null
      readonly observacoes?: string | null
      readonly imunobiologico: { readonly __typename?: 'Imunobiologico'; readonly id: string; readonly nome: string }
      readonly estrategiaVacinacao?: {
        readonly __typename?: 'EstrategiaVacinacao'
        readonly id: string
        readonly nome: string
      } | null
      readonly grupoAtendimento?: {
        readonly __typename?: 'GrupoAtendimento'
        readonly id: string
        readonly nome: string
      } | null
      readonly tipoRegistroVacinacao: {
        readonly __typename?: 'TipoRegistroVacinacao'
        readonly id: string
        readonly identificador: TipoRegistroVacinacaoEnum
      }
      readonly doseImunobiologico: {
        readonly __typename?: 'DoseImunobiologico'
        readonly id: string
        readonly nome: string
      }
      readonly loteImunobiologico?: {
        readonly __typename?: 'LoteImunobiologico'
        readonly id: string
        readonly lote?: string | null
        readonly validade?: any | null
        readonly fabricante?: {
          readonly __typename?: 'ImunobiologicoFabricante'
          readonly id: string
          readonly nome: string
        } | null
      } | null
      readonly viaAdministracao?: {
        readonly __typename?: 'ViaAdministracao'
        readonly id: string
        readonly nome: string
      } | null
      readonly localAplicacaoVacinacao?: {
        readonly __typename?: 'LocalAplicacao'
        readonly id: string
        readonly nome: string
      } | null
      readonly cboPrescritor?: { readonly __typename?: 'Cbo'; readonly id: string; readonly cbo2002: string } | null
      readonly cid10MotivoIndicacao?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
    }> | null
  }
}

export type HistoricoVisitaDomiciliarQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoVisitaDomiciliarQuery = {
  readonly __typename?: 'Query'
  readonly historicoVisitaDomiciliar?: {
    readonly __typename?: 'FatoVisitaDomiciliar'
    readonly id: string
    readonly nuUuidFicha: string
    readonly cpfCidadao?: string | null
    readonly cnsCidadao?: string | null
    readonly motivoVisita: ReadonlyArray<string | null>
    readonly buscaAtiva: ReadonlyArray<string | null>
    readonly acompanhamento: ReadonlyArray<string | null>
    readonly controleAmbiental: ReadonlyArray<string | null>
    readonly anotacoes?: string | null
    readonly tipoVisita?: number | null
    readonly peso?: number | null
    readonly altura?: number | null
    readonly temperatura?: string | null
    readonly medicaoGlicemia?: string | null
    readonly medicaoPressaoArterial?: string | null
    readonly stVisitaCompartilhada?: boolean | null
    readonly dimensaoDesfechoVisita: {
      readonly __typename?: 'DimensaoDesfechoVisita'
      readonly id: string
      readonly numeroIdentificador: string
      readonly descricao: string
    }
    readonly dimensaoTipoGlicemia?: {
      readonly __typename?: 'DimensaoTipoGlicemia'
      readonly id: string
      readonly descricao: string
    } | null
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly ivcf?: {
      readonly __typename?: 'FatoIvcf'
      readonly id: string
      readonly resultado: number
      readonly dimensoesAlteradas: string
      readonly dimensaoGrauVulnerabilidadeIvcf: {
        readonly __typename?: 'DimensaoGrauVulnerabilidadeIvcf'
        readonly id?: string | null
        readonly descricao?: string | null
      }
    } | null
  } | null
}

export type HistoricoZikaDetailQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type HistoricoZikaDetailQuery = {
  readonly __typename?: 'Query'
  readonly historicoZikaDetail?: {
    readonly __typename?: 'HistoricoZikaDetail'
    readonly examesDeImagem: ReadonlyArray<{
      readonly __typename?: 'ExameZika'
      readonly id: string
      readonly nome: string
      readonly resultado: string
      readonly dataRealizacao: any
    } | null>
    readonly outrosExames: ReadonlyArray<{
      readonly __typename?: 'ExameZika'
      readonly id: string
      readonly nome: string
      readonly resultado: string
      readonly dataRealizacao: any
    } | null>
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
  } | null
}

export type DisponibilidadeDadosClinicosHistoricoQueryVariables = Exact<{ [key: string]: never }>

export type DisponibilidadeDadosClinicosHistoricoQuery = {
  readonly __typename?: 'Query'
  readonly disponibilidadeDadosClinicosHistorico: {
    readonly __typename?: 'DisponibilidadeDadosClinicosHistorico'
    readonly statusProcessamento: boolean
  }
}

export type ProntuarioFamiliarAcompVulnerabilidadeQueryVariables = Exact<{
  input: CidadaosQueryInput
}>

export type ProntuarioFamiliarAcompVulnerabilidadeQuery = {
  readonly __typename?: 'Query'
  readonly cidadaos: {
    readonly __typename?: 'CidadaosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly dataNascimento?: any | null
      readonly familias: ReadonlyArray<{
        readonly __typename?: 'Familia'
        readonly id: string
        readonly vulnerabilidadeFamiliar?: {
          readonly __typename?: 'VulnerabilidadeFamiliar'
          readonly id: string
          readonly classificacao: ClassificacaoVulnerabilidadeFamiliar
          readonly grauSugestivo?: GrauSugestivoVulnerabilidadeFamiliar | null
          readonly escore?: number | null
          readonly classificacaoSubestimada?: boolean | null
          readonly criterios: {
            readonly __typename?: 'CriteriosVulnerabilidadeFamiliar'
            readonly criteriosInequivocos: ReadonlyArray<string>
            readonly criteriosSugestivos: ReadonlyArray<string>
            readonly criteriosPontuados: ReadonlyArray<{
              readonly __typename?: 'CriterioPontuadoVulnerabilidadeFamiliar'
              readonly id: string
              readonly descricao: string
              readonly numeroMoradores?: number | null
              readonly peso: number
              readonly resultado: number
            }>
          }
        } | null
        readonly imovel?: {
          readonly __typename?: 'ImovelDto'
          readonly id: string
          readonly possuiInconsistencia?: boolean | null
        } | null
      }>
      readonly informacoesSocioEconomicasDW?: {
        readonly __typename?: 'InformacoesSocioEconomicasDW'
        readonly dataRegistro: any
        readonly alimentosAcabaramSemDinheiro?: boolean | null
        readonly comeuPoucoPorFaltaDeDinheiro?: boolean | null
      } | null
      readonly beneficiarioBolsaFamilia: {
        readonly __typename?: 'BeneficiarioBolsaFamilia'
        readonly id: string
        readonly isBeneficiario: boolean
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProntuarioFamiliarQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type ProntuarioFamiliarQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly cidadaoNucleoFamiliar?: {
      readonly __typename?: 'CidadaoNucleoFamiliar'
      readonly id: string
      readonly mudouSe?: boolean | null
    } | null
    readonly familias: ReadonlyArray<{
      readonly __typename?: 'Familia'
      readonly cnes: string
      readonly ine: string
      readonly id: string
      readonly resideDesde?: any | null
      readonly numeroProntuarioFamiliar?: string | null
      readonly rendaFamiliar?: RendaFamiliar | null
      readonly cpfCnsResponsavel?: string | null
      readonly isResponsavelCadastrado: boolean
      readonly isResponsavelDeclarado: boolean
      readonly isResponsavelVivo: boolean
      readonly isResponsavelUnico: boolean
      readonly isResponsavelAindaReside: boolean
      readonly isFamiliaAindaReside: boolean
      readonly isInformacaoSuficiente: boolean
      readonly isDomicilioAtivo: boolean
      readonly numeroMembros?: number | null
      readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
      readonly cidadaosTerritorioBasico: ReadonlyArray<{
        readonly __typename?: 'CidadaoTerritorioBasico'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly sexo?: SexoEnum | null
        readonly dataNascimento?: any | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly ultimaFichaCadastrada?: {
          readonly __typename?: 'UltimaFichaCadastradaDto'
          readonly id: string
          readonly isProcessado: boolean
        } | null
        readonly cidadaoNucleoFamiliar?: {
          readonly __typename?: 'CidadaoNucleoFamiliar'
          readonly id: string
          readonly grauParentescoResponsavelFamiliar?: GrauParentescoEnum | null
        } | null
        readonly prontuario?: { readonly __typename?: 'Prontuario'; readonly id: string } | null
      }>
      readonly imovel?: {
        readonly __typename?: 'ImovelDto'
        readonly id: string
        readonly tipoEndereco?: TipoEnderecoEnum | null
        readonly complemento?: string | null
        readonly pontoReferencia?: string | null
        readonly cep?: string | null
        readonly telefoneContato?: string | null
        readonly telefoneResidencial?: string | null
        readonly microarea?: string | null
        readonly numero?: string | null
        readonly bairro?: string | null
        readonly logradouro?: string | null
        readonly numeroMoradores?: number | null
        readonly tipoImovel?: TipoImovelEnum | null
        readonly latitude?: number | null
        readonly longitude?: number | null
        readonly numeroResidenciaIndigena?: string | null
        readonly tipoLogradouro?: {
          readonly __typename?: 'TipoLogradouro'
          readonly id: string
          readonly nome: string
        } | null
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
        } | null
        readonly aldeia?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
        readonly poloBase?: { readonly __typename?: 'PoloBase'; readonly id: string; readonly nome: string } | null
        readonly dsei?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
        readonly condicoesMoradia: {
          readonly __typename?: 'CondicoesMoradia'
          readonly id: string
          readonly tipoAbastecimentoAgua?: TipoAbastecimentoAguaEnum | null
          readonly tipoSituacaoMoradia?: TipoSituacaoMoradiaEnum | null
          readonly tipoTratamentoAgua?: TipoTratamentoAguaEnum | null
          readonly tipoPosseTerra?: TipoPosseTerraEnum | null
          readonly tipoMaterialParede?: TipoMaterialParedeEnum | null
          readonly tipoLocalizacao?: TipoLocalizacaoEnum | null
          readonly tipoEscoamentoSanitario?: TipoEscoamentoSanitarioEnum | null
          readonly tipoDomicilio?: TipoDomicilioEnum | null
          readonly tipoDestinoLixo?: TipoDestinoLixoEnum | null
          readonly tipoAcessoDomicilio?: TipoAcessoDomicilioEnum | null
          readonly isEnergiaEletricaDisponivel?: boolean | null
          readonly tipoOrigemEnergiaEletrica?: TipoOrigemEnergiaEletricaEnum | null
          readonly numeroComodos?: number | null
        }
        readonly animaisImovel?: {
          readonly __typename?: 'AnimaisImovel'
          readonly id?: any | null
          readonly possuiAnimais?: boolean | null
          readonly possuiGato?: boolean | null
          readonly possuiCachorro?: boolean | null
          readonly possuiPassaro?: boolean | null
          readonly possuiMacaco?: boolean | null
          readonly possuiGalinha?: boolean | null
          readonly possuiPorco?: boolean | null
          readonly possuiRepteis?: boolean | null
          readonly possuiOutros?: boolean | null
          readonly quantidadeAnimais?: number | null
        } | null
      } | null
    }>
  }
}

export type ProntuarioFamiliarVisitasDomiciliaresQueryVariables = Exact<{
  input: VisitasQueryInput
}>

export type ProntuarioFamiliarVisitasDomiciliaresQuery = {
  readonly __typename?: 'Query'
  readonly visitas: {
    readonly __typename?: 'VisitasQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FatoVisitaDomiciliar'
      readonly id: string
      readonly dataVisita?: any | null
      readonly motivoVisita: ReadonlyArray<string | null>
      readonly buscaAtiva: ReadonlyArray<string | null>
      readonly acompanhamento: ReadonlyArray<string | null>
      readonly controleAmbiental: ReadonlyArray<string | null>
      readonly tipoVisita?: number | null
      readonly anotacoes?: string | null
      readonly dimensaoProfissional?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly nome?: string | null
      } | null
      readonly dimensaoEquipe?: {
        readonly __typename?: 'DimensaoEquipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly dimensaoCbo?: {
        readonly __typename?: 'DimensaoCbo'
        readonly id: string
        readonly nome: string
        readonly cbo: string
      } | null
      readonly turno?: { readonly __typename?: 'DimensaoTurno'; readonly id: string; readonly descricao: string } | null
      readonly cidadaoPec?: {
        readonly __typename?: 'FatoCidadaoPec'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
      } | null
    }>
  }
}

export type GerarLinkSistemaExternoMutationVariables = Exact<{
  input: GerarLinkSistemaExternoInput
}>

export type GerarLinkSistemaExternoMutation = {
  readonly __typename?: 'Mutation'
  readonly gerarLinkSistemaExterno?: string | null
}

export type IframesAtendimentoQueryVariables = Exact<{
  input?: InputMaybe<IframesQueryInput>
}>

export type IframesAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly iframes: ReadonlyArray<{
    readonly __typename?: 'Iframe'
    readonly id: string
    readonly providerId: string
    readonly nome: string
  } | null>
}

export type HasProblemasGestacaoQueryVariables = Exact<{
  id: Scalars['Long']['input']
}>

export type HasProblemasGestacaoQuery = {
  readonly __typename?: 'Query'
  readonly hasProblemasGestacao?: boolean | null
}

export type HasPuericulturaQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type HasPuericulturaQuery = { readonly __typename?: 'Query'; readonly hasPuericultura: boolean }

export type LoadAntecedentesQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type LoadAntecedentesQuery = {
  readonly __typename?: 'Query'
  readonly antecedente?: {
    readonly __typename?: 'Antecedente'
    readonly id: string
    readonly observacoes?: string | null
    readonly dataUltimaAtualizacaoPessoal?: any | null
    readonly gestacoesPrevias?: string | null
    readonly qtPartos?: string | null
    readonly qtAbortos?: string | null
    readonly qtCesareas?: string | null
    readonly partosVaginais?: string | null
    readonly partosDomiciliares?: string | null
    readonly desfechoUltimaGestacao?: DesfechoUltimaGestacaoEnum | null
    readonly nascidosVivos?: string | null
    readonly natimortos?: string | null
    readonly obitoAntesPrimeiraSemana?: string | null
    readonly obitoAposPrimeiraSemana?: string | null
    readonly filhosVivos?: string | null
    readonly recemNascidosAcima?: string | null
    readonly recemNascidosAbaixo?: string | null
    readonly dataUltimoParto?: any | null
    readonly dataUltimaAtualizacaoGestacional?: any | null
    readonly peso?: string | null
    readonly altura?: string | null
    readonly perimetroCefalico?: string | null
    readonly apgarUm?: string | null
    readonly apgarCinco?: string | null
    readonly apgarDez?: string | null
    readonly tipoGravidez?: TipoGravidezEnum | null
    readonly tipoParto?: TipoPartoEnum | null
    readonly idadeGestacionalSemanas?: string | null
    readonly idadeGestacionalDias?: string | null
    readonly dataUltimaAtualizacaoPuericultura?: any | null
    readonly antecedentesFamiliaresCiap?: ReadonlyArray<{
      readonly __typename?: 'AntecedentesFamiliaresCiap'
      readonly idCiap: string
      readonly codigoCiap: string
      readonly descricao: string
      readonly observacao?: string | null
    } | null> | null
    readonly cirurgiasInternacoes?: ReadonlyArray<{
      readonly __typename?: 'AntecedenteCirurgiasInternacoes'
      readonly id: string
      readonly descricao: string
      readonly observacoes?: string | null
      readonly dataCirurgiaInternacao?: any | null
    } | null> | null
  } | null
}

export type AcompanhamentoIdosoCardQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  cidadaoId: Scalars['ID']['input']
}>

export type AcompanhamentoIdosoCardQuery = {
  readonly __typename?: 'Query'
  readonly ultimaAvaliacaoMultidimensional?: any | null
}

export type UltimoIvcfQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  cidadaoId: Scalars['ID']['input']
}>

export type UltimoIvcfQuery = {
  readonly __typename?: 'Query'
  readonly ultimoIvcf: {
    readonly __typename?: 'UltimoIvcfDto'
    readonly id: string
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
      readonly dataResultado: any
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        }
      }
    } | null
    readonly fatoIvcf?: {
      readonly __typename?: 'FatoIvcf'
      readonly id: string
      readonly resultado: number
      readonly dimensoesAlteradas: string
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
      readonly dataResultado: any
      readonly dimensaoCbo: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string }
      readonly dimensaoProfissional: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly nome?: string | null
      }
    } | null
  }
}

export type AcompanhamentoPuericulturaCardQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  dataReferencia: Scalars['LocalDate']['input']
}>

export type AcompanhamentoPuericulturaCardQuery = {
  readonly __typename?: 'Query'
  readonly ultimoAtendimentoPuericultura: {
    readonly __typename?: 'AtendimentoPuericultura'
    readonly id?: string | null
    readonly dataInicio?: any | null
    readonly nomeProfissional?: string | null
  }
  readonly tipoAleitamentoMaterno: {
    readonly __typename?: 'AleitamentoMaterno'
    readonly id?: string | null
    readonly tipo?: TipoAleitamentoMaternoEnum | null
    readonly dataInicioAtendimento?: any | null
  }
  readonly preNatalPartoNascimento?: {
    readonly __typename?: 'Antecedente'
    readonly id: string
    readonly tipoGravidez?: TipoGravidezEnum | null
    readonly tipoParto?: TipoPartoEnum | null
    readonly idadeGestacionalSemanas?: string | null
    readonly idadeGestacionalDias?: string | null
    readonly apgarUm?: string | null
    readonly apgarCinco?: string | null
    readonly apgarDez?: string | null
    readonly peso?: string | null
    readonly altura?: string | null
    readonly perimetroCefalico?: string | null
  } | null
  readonly alteracoesFenotipicas?: ReadonlyArray<{
    readonly __typename?: 'AlteracaoFenotipica'
    readonly id: string
    readonly descricao: string
    readonly status: StatusAvaliadoEnum
    readonly dataAvaliacao?: any | null
  }> | null
  readonly fatoresRisco?: ReadonlyArray<{
    readonly __typename?: 'FatorRisco'
    readonly id: string
    readonly descricao: string
    readonly status: StatusAvaliadoEnum
    readonly dataAvaliacao?: any | null
  }> | null
  readonly marcosDesenvolvimento?: ReadonlyArray<{
    readonly __typename?: 'MarcoDesenvolvimento'
    readonly id: string
    readonly descricao: string
    readonly hint?: string | null
    readonly status: StatusAvaliadoEnum
    readonly dataAvaliacao?: any | null
    readonly alcancadoComMeses?: number | null
    readonly alcancadoComAnos?: number | null
    readonly faixaEtariaEnum?: NeuroFaixaEtariaEnum | null
    readonly faixaEtariaFim?: number | null
    readonly descricaoFaixaEtaria?: string | null
  }> | null
  readonly medicoesAnteriores: ReadonlyArray<{
    readonly __typename?: 'Medicao'
    readonly id: string
    readonly dataMedicao: any
    readonly valorVacinacaoEmDia?: boolean | null
    readonly valorPerimetroCefalico?: number | null
  }>
  readonly antecedente?: {
    readonly __typename?: 'Antecedente'
    readonly id: string
    readonly perimetroCefalico?: string | null
  } | null
  readonly registrosMChat?: ReadonlyArray<{
    readonly __typename?: 'MChat'
    readonly id: string
    readonly pontuacao: number
    readonly risco: MChatRiscoEnum
    readonly isMchatRf: boolean
    readonly dataResultado: any
    readonly aplicacao: ReadonlyArray<{
      readonly __typename?: 'MchatAplicacao'
      readonly id: string
      readonly pergunta: MChatPerguntaEnum
      readonly stPassou?: boolean | null
    }>
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  }> | null
}

export type AcompanhamentoVulnerabilidadeCardQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type AcompanhamentoVulnerabilidadeCardQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly dataNascimento?: any | null
    readonly informacoesSocioEconomicasDW?: {
      readonly __typename?: 'InformacoesSocioEconomicasDW'
      readonly dataRegistro: any
      readonly alimentosAcabaramSemDinheiro?: boolean | null
      readonly comeuPoucoPorFaltaDeDinheiro?: boolean | null
    } | null
    readonly familias: ReadonlyArray<{
      readonly __typename?: 'Familia'
      readonly id: string
      readonly cidadaos: ReadonlyArray<{
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly dataNascimento?: any | null
      }>
    }>
  }
}

export type AcompanhamentoCidadaosVulnerabilidadeAlimentarQueryVariables = Exact<{
  input: CidadaosQueryInput
}>

export type AcompanhamentoCidadaosVulnerabilidadeAlimentarQuery = {
  readonly __typename?: 'Query'
  readonly cidadaos: {
    readonly __typename?: 'CidadaosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly dataNascimento?: any | null
      readonly informacoesSocioEconomicasDW?: {
        readonly __typename?: 'InformacoesSocioEconomicasDW'
        readonly dataRegistro: any
        readonly alimentosAcabaramSemDinheiro?: boolean | null
        readonly comeuPoucoPorFaltaDeDinheiro?: boolean | null
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AlergiasCardQueryVariables = Exact<{
  filtro: AlergiasQueryInput
  prontuarioId: Scalars['ID']['input']
}>

export type AlergiasCardQuery = {
  readonly __typename?: 'Query'
  readonly existemAlergiasResolvidasRefutadas: boolean
  readonly alergias: {
    readonly __typename?: 'AlergiaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Alergia'
      readonly id: string
      readonly categoriaSubstanciaEspecificaLegado?: CategoriaSubstanciaAlergiaLegado | null
      readonly substanciaEspecificaLegado?: string | null
      readonly tipoReacao?: TipoReacaoAlergia | null
      readonly criticidade: CriticidadeAlergia
      readonly grauCerteza: GrauCertezaAlergia
      readonly substanciaEspecifica?: {
        readonly __typename?: 'SubstanciaEspecificaAlergia'
        readonly id: string
        readonly coSubstanciaEspecifica: any
        readonly coPrincipioAtivo?: any | null
        readonly categoria: CategoriaSubstanciaAlergia
        readonly nome: string
      } | null
    }>
  }
}

export type LembretesCardQueryVariables = Exact<{
  lembretesQueryInput: LembretesQueryInput
}>

export type LembretesCardQuery = {
  readonly __typename?: 'Query'
  readonly lembretes: ReadonlyArray<{
    readonly __typename?: 'Lembrete'
    readonly id: string
    readonly ultimoLembrete: {
      readonly __typename?: 'LembreteEvolucao'
      readonly id: string
      readonly descricao: string
      readonly ativo: boolean
      readonly data: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  } | null>
}

export type MedicamentoUsoBarraLateralQueryVariables = Exact<{
  input: ListaMedicamentoAtivoConcluidoQueryInput
}>

export type MedicamentoUsoBarraLateralQuery = {
  readonly __typename?: 'Query'
  readonly listaMedicamento: {
    readonly __typename?: 'ListaMedicamentoAtivoConcluidoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ReceitaMedicamento'
      readonly id: string
      readonly dtInicioTratamento?: any | null
      readonly dtFimTratamento?: any | null
      readonly registroManual?: boolean | null
      readonly tipoReceita?: TipoReceitaEnum | null
      readonly usoContinuo?: boolean | null
      readonly posologia: string
      readonly qtDuracaoTratamento?: number | null
      readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
      readonly quantidadeReceitada: number
      readonly medicamento: {
        readonly __typename?: 'Medicamento'
        readonly id: string
        readonly principioAtivo: string
        readonly concentracao?: string | null
        readonly medicamentoCatmat?: {
          readonly __typename?: 'MedicamentoCatmat'
          readonly id: string
          readonly codigoCatMat?: string | null
          readonly principioAtivo: {
            readonly __typename?: 'PrincipioAtivo'
            readonly id: string
            readonly nome: string
            readonly listaMaterial: {
              readonly __typename?: 'ListaMedicamento'
              readonly id: string
              readonly tipoReceita: TipoReceitaEnum
            }
          }
        } | null
      }
      readonly atendProf?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly versaoAnterior?: boolean | null
        readonly atendimento?: { readonly __typename?: 'Atendimento'; readonly id: string } | null
      } | null
      readonly receitaUsoContinuoGrupo?: {
        readonly __typename?: 'ReceitaMedicamento'
        readonly id: string
        readonly dtInicioTratamento?: any | null
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type PossuiTratamentoConcluidoQueryVariables = Exact<{
  input: PossuiTratamentoConcluidoQueryInput
}>

export type PossuiTratamentoConcluidoQuery = {
  readonly __typename?: 'Query'
  readonly possuiTratamentoConcluido: boolean
}

export type GrupoMedicoesCardFragment = {
  readonly __typename?: 'GrupoMedicoesTipo'
  readonly tipo: TipoMedicaoEnum
  readonly medicoes: ReadonlyArray<{
    readonly __typename?: 'ItemGrupoMedicoesTipo'
    readonly dataMedicao: any
    readonly valor: string
    readonly observacao?: string | null
  }>
}

export type MedicoesCardQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  fetchMedicoesAnteriores: Scalars['Boolean']['input']
  dataReferencia?: InputMaybe<Scalars['Instant']['input']>
}>

export type MedicoesCardQuery = {
  readonly __typename?: 'Query'
  readonly ultimasMedicoesDoDia: ReadonlyArray<{
    readonly __typename?: 'GrupoMedicoesTipo'
    readonly tipo: TipoMedicaoEnum
    readonly medicoes: ReadonlyArray<{
      readonly __typename?: 'ItemGrupoMedicoesTipo'
      readonly dataMedicao: any
      readonly valor: string
      readonly observacao?: string | null
    }>
  }>
  readonly ultimasMedicoesDiasAnteriores?: ReadonlyArray<{
    readonly __typename?: 'GrupoMedicoesTipo'
    readonly tipo: TipoMedicaoEnum
    readonly medicoes: ReadonlyArray<{
      readonly __typename?: 'ItemGrupoMedicoesTipo'
      readonly dataMedicao: any
      readonly valor: string
      readonly observacao?: string | null
    }>
  }>
  readonly medicoesNoNascimento?: {
    readonly __typename?: 'Antecedente'
    readonly id: string
    readonly peso?: string | null
    readonly altura?: string | null
    readonly perimetroCefalico?: string | null
  } | null
}

export type MedicoesFragmentFragment = {
  readonly __typename?: 'Medicao'
  readonly id: string
  readonly valorPeso?: number | null
  readonly valorAltura?: number | null
  readonly valorFrequenciaCardiaca?: number | null
  readonly valorPressaoArterial?: string | null
  readonly valorPerimetroCefalico?: number | null
  readonly valorFrequenciaRespiratoria?: number | null
  readonly valorTemperatura?: number | null
  readonly valorSaturacaoO2?: number | null
  readonly valorGlicemia?: number | null
  readonly tipoGlicemia?: TipoGlicemia | null
  readonly perimetroPanturrilha?: number | null
  readonly valorCircunferenciaAbdominal?: number | null
  readonly valorForcaMuscMaoDireita?: string | null
  readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
  readonly valorForcaMuscMaoEsquerda?: string | null
  readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
  readonly pele?: string | null
  readonly olhoDireito?: string | null
  readonly olhoEsquerdo?: string | null
  readonly ouvidoDireito?: string | null
  readonly ouvidoEsquerdo?: string | null
  readonly membroInferiorDireito?: string | null
  readonly membroInferiorEsquerdo?: string | null
}

export type AcompanhamentoPreNatalCardQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type AcompanhamentoPreNatalCardQuery = {
  readonly __typename?: 'Query'
  readonly atendimentosProfUltimaGestacao?: ReadonlyArray<{
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly iniciadoEm: any
    readonly atendimentoProfissionalPreNatal?: {
      readonly __typename?: 'AtendimentoProfissionalPreNatal'
      readonly id: string
      readonly preNatal?: {
        readonly __typename?: 'PreNatal'
        readonly id: string
        readonly altoRisco: boolean
        readonly tipoGravidez?: {
          readonly __typename?: 'TipoGravidez'
          readonly id: string
          readonly descricao?: string | null
        } | null
      } | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly dataMedicao: any
      readonly dum?: any | null
      readonly medicaoAnterior?: boolean | null
    } | null> | null
  } | null> | null
}

export type DataUltimaConsultaOdontoGestanteQueryVariables = Exact<{
  input: DataUltimaConsultaOdontoGestanteQueryInput
}>

export type DataUltimaConsultaOdontoGestanteQuery = {
  readonly __typename?: 'Query'
  readonly dataUltimaConsultaOdontoGestante?: any | null
}

export type PeriodoGestacionalQueryVariables = Exact<{
  input: PeriodoGestacionalQueryInput
}>

export type PeriodoGestacionalQuery = {
  readonly __typename?: 'Query'
  readonly periodoGestacional: {
    readonly __typename?: 'PeriodoGestacional'
    readonly dataInicioGestacao?: any | null
    readonly dataProvavelPartoEcografica?: any | null
    readonly idadeGestacionalCronologicaEmDias?: number | null
    readonly idadeGestacionalEcograficaEmDias?: number | null
    readonly hasIgEcoChanged: boolean
    readonly hasDppEcoChanged: boolean
    readonly fonteIdadeGestacional?: FonteIdadeGestacionalEnum | null
  }
}

export type RiscosQueryVariables = Exact<{
  input: RiscoInput
}>

export type RiscosQuery = {
  readonly __typename?: 'Query'
  readonly riscos: ReadonlyArray<{
    readonly __typename?: 'Risco'
    readonly estratificacao?: EstratificacaoRisco | null
    readonly origem?: string | null
    readonly descricaoOrigem?: string | null
    readonly grupo?: GrupoRisco | null
  }>
}

export type ResultadosExamesCardQueryVariables = Exact<{
  input: ResultadosExameQueryInput
}>

export type ResultadosExamesCardQuery = {
  readonly __typename?: 'Query'
  readonly resultadosExame: {
    readonly __typename?: 'ResultadosExamePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly resultado?: string | null
      readonly dataSolicitacao?: any | null
      readonly dataRealizacao?: any | null
      readonly dataResultado?: any | null
      readonly observacao?: string | null
      readonly conferido?: boolean | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }
      readonly especifico?: {
        readonly __typename?: 'ResultadoExameEspecifico'
        readonly id: string
        readonly exameEspecificoEnum: ExameEspecificoEnum
        readonly valor?: number | null
        readonly igDias?: number | null
        readonly igSemanas?: number | null
        readonly dpp?: any | null
        readonly resultadoExamePuericulturaEnum?: FichaComplementarZikaMicrocefaliaResultadoExameEnum | null
        readonly resultadoExameEstruturadoQualitativoEnum?: OpcoesResultadoExameQualitativoEnum | null
      } | null
      readonly atendimentoProfissionalResultado?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
      } | null
    } | null>
  }
}

export type EvolucoesProblemasAtendObservacaoQueryVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type EvolucoesProblemasAtendObservacaoQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly atendimentoProfissional?: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly evolucaoProblema?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoProblema'
        readonly id: string
        readonly problema?: {
          readonly __typename?: 'Problema'
          readonly id: string
          readonly situacao: SituacaoProblema
          readonly descricaoOutro?: string | null
          readonly ciap?: {
            readonly __typename?: 'Ciap'
            readonly id: string
            readonly codigo: string
            readonly descricao: string
          } | null
          readonly cid10?: {
            readonly __typename?: 'Cid10'
            readonly id: string
            readonly codigo: string
            readonly nome: string
          } | null
          readonly cid11?: {
            readonly __typename?: 'Cid11'
            readonly id: string
            readonly codigo: string
            readonly nome: string
            readonly ativo: boolean
          } | null
          readonly ultimaEvolucao: {
            readonly __typename?: 'EvolucaoProblema'
            readonly id: string
            readonly dataInicio?: any | null
            readonly dataFim?: any | null
            readonly situacao: SituacaoProblema
            readonly observacao?: string | null
            readonly atualizadoEm?: any | null
          }
          readonly evolucaoAvaliacaoCiapCid?: {
            readonly __typename?: 'EvolucaoAvaliacaoCiapCid'
            readonly id: string
          } | null
        } | null
      } | null> | null
    } | null
  }
}

export type GrupoCondicaoQueryVariables = Exact<{
  input: GrupoCondicaoEnum
}>

export type GrupoCondicaoQuery = {
  readonly __typename?: 'Query'
  readonly grupoByEnum: {
    readonly __typename?: 'GrupoCondicao'
    readonly id: string
    readonly ciaps?: ReadonlyArray<{
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null> | null
    readonly cids?: ReadonlyArray<{
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null> | null
  }
}

export type ProblemasFaltantesLpcQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type ProblemasFaltantesLpcQuery = {
  readonly __typename?: 'Query'
  readonly problemasFaltantesLPC: ReadonlyArray<{
    readonly __typename?: 'CiapCidSugestao'
    readonly dataRegistroProblema?: string | null
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly inclui?: string | null
      readonly exclui?: string | null
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
  } | null>
}

export type LotacaoSugestaoAgendamentoFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly ativo: boolean
  readonly importada: boolean
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly cpf: string
  }
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly tipoEquipe: { readonly __typename?: 'TipoEquipe'; readonly id: string; readonly descricao?: string | null }
  } | null
}

export type SugestaoDatasAgendamentoQueryVariables = Exact<{
  input: SugestoesDatasInput
}>

export type SugestaoDatasAgendamentoQuery = {
  readonly __typename?: 'Query'
  readonly sugestoesDatas: {
    readonly __typename?: 'SugestoesDatas'
    readonly preNatal: ReadonlyArray<any>
    readonly odontologica: ReadonlyArray<any>
  }
}

export type SugestaoProfissionaisAgendamentoQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type SugestaoProfissionaisAgendamentoQuery = {
  readonly __typename?: 'Query'
  readonly sugestoesProfissionais: {
    readonly __typename?: 'ProfissionaisSugestaoAgendamento'
    readonly preNatal?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly importada: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly cpf: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly descricao?: string | null
        }
      } | null
    } | null
    readonly odontologico?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly importada: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly cpf: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly descricao?: string | null
        }
      } | null
    } | null
  }
}

export type IvcfEmAtendimentoObservacaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type IvcfEmAtendimentoObservacaoQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly dataResultado: any
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'IvcfAplicacao'
        readonly id: string
        readonly pergunta: IvcfPerguntaEnum
        readonly resposta: boolean
      } | null>
    } | null
  }
}

export type PreNatalEmAtendimentoObservacaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PreNatalEmAtendimentoObservacaoQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly id: string
      readonly valorAlturaUterina?: string | null
      readonly valorBatimentoCardiacoFetal?: string | null
      readonly valorBatimentoCardiacoFetal2?: string | null
      readonly medicaoAnterior?: boolean | null
    } | null> | null
    readonly atendimentoProfissionalPreNatal?: {
      readonly __typename?: 'AtendimentoProfissionalPreNatal'
      readonly id: string
      readonly gravidezPlanejada?: boolean | null
      readonly movimentacaoFetal?: boolean | null
      readonly tipoEdema?: TipoEdemaEnum | null
      readonly preNatal?: {
        readonly __typename?: 'PreNatal'
        readonly id: string
        readonly altoRisco: boolean
        readonly tipoGravidez?: {
          readonly __typename?: 'TipoGravidez'
          readonly id: string
          readonly descricao?: string | null
          readonly tipoGravidez?: TipoGravidezEnum | null
        } | null
      } | null
    } | null
  }
}

export type ExamesSolicitadosQueryVariables = Exact<{
  input: ResultadosExameQueryInput
}>

export type ExamesSolicitadosQuery = {
  readonly __typename?: 'Query'
  readonly resultadosExame: {
    readonly __typename?: 'ResultadosExamePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ResultadoExame'
      readonly id: string
      readonly dataSolicitacao?: any | null
      readonly exame: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
      }
      readonly atendimentoProfissionalSolicitacao?: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        }
      } | null
    } | null>
  }
}

export type ArquivosAnexadosNoProntuarioQueryVariables = Exact<{
  prontuarioId: Scalars['Long']['input']
}>

export type ArquivosAnexadosNoProntuarioQuery = {
  readonly __typename?: 'Query'
  readonly arquivosAnexadosNoProntuario: ReadonlyArray<{
    readonly __typename?: 'ArquivoAtendimentoProfissional'
    readonly id: string
    readonly titulo: string
    readonly observacao?: string | null
    readonly categoria: CategoriaArquivoAtendProfEnum
    readonly arquivo: {
      readonly __typename?: 'Arquivo'
      readonly id: string
      readonly uuid: string
      readonly dataCriacao: any
    }
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  }>
}

export type UltimoAtendimentoProfissionalComMcaByProntuarioIdQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type UltimoAtendimentoProfissionalComMcaByProntuarioIdQuery = {
  readonly __typename?: 'Query'
  readonly ultimoAtendimentoProfissionalComMCAByProntuarioId?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly iniciadoEm: any
  } | null
}

export type PuericulturaQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  dataReferencia: Scalars['LocalDate']['input']
}>

export type PuericulturaQuery = {
  readonly __typename?: 'Query'
  readonly hasPuericultura: boolean
  readonly alteracoesFenotipicas?: ReadonlyArray<{
    readonly __typename?: 'AlteracaoFenotipica'
    readonly id: string
    readonly descricao: string
    readonly status: StatusAvaliadoEnum
    readonly dataAvaliacao?: any | null
  }> | null
  readonly fatoresRisco?: ReadonlyArray<{
    readonly __typename?: 'FatorRisco'
    readonly id: string
    readonly descricao: string
    readonly status: StatusAvaliadoEnum
    readonly dataAvaliacao?: any | null
  }> | null
  readonly marcosDesenvolvimento?: ReadonlyArray<{
    readonly __typename?: 'MarcoDesenvolvimento'
    readonly id: string
    readonly descricao: string
    readonly hint?: string | null
    readonly status: StatusAvaliadoEnum
    readonly dataAvaliacao?: any | null
    readonly alcancadoComMeses?: number | null
    readonly alcancadoComAnos?: number | null
    readonly faixaEtariaEnum?: NeuroFaixaEtariaEnum | null
    readonly faixaEtariaFim?: number | null
    readonly descricaoFaixaEtaria?: string | null
  }> | null
  readonly medicoesAnteriores: ReadonlyArray<{
    readonly __typename?: 'Medicao'
    readonly id: string
    readonly dataMedicao: any
    readonly valorPerimetroCefalico?: number | null
  }>
  readonly antecedente?: {
    readonly __typename?: 'Antecedente'
    readonly id: string
    readonly perimetroCefalico?: string | null
  } | null
}

export type UltimoMChatFragment = {
  readonly __typename?: 'MChat'
  readonly id: string
  readonly pontuacao: number
  readonly risco: MChatRiscoEnum
  readonly isMchatRf: boolean
  readonly dataResultado: any
  readonly aplicacao: ReadonlyArray<{
    readonly __typename?: 'MchatAplicacao'
    readonly id: string
    readonly pergunta: MChatPerguntaEnum
    readonly stPassou?: boolean | null
  }>
  readonly atendimentoProfissional: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    }
  }
}

export type UltimoMChatQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type UltimoMChatQuery = {
  readonly __typename?: 'Query'
  readonly ultimoMChatR?: {
    readonly __typename?: 'MChat'
    readonly id: string
    readonly pontuacao: number
    readonly risco: MChatRiscoEnum
    readonly isMchatRf: boolean
    readonly dataResultado: any
    readonly aplicacao: ReadonlyArray<{
      readonly __typename?: 'MchatAplicacao'
      readonly id: string
      readonly pergunta: MChatPerguntaEnum
      readonly stPassou?: boolean | null
    }>
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  } | null
  readonly ultimoMChatRf?: {
    readonly __typename?: 'MChat'
    readonly id: string
    readonly pontuacao: number
    readonly risco: MChatRiscoEnum
    readonly isMchatRf: boolean
    readonly dataResultado: any
    readonly aplicacao: ReadonlyArray<{
      readonly __typename?: 'MchatAplicacao'
      readonly id: string
      readonly pergunta: MChatPerguntaEnum
      readonly stPassou?: boolean | null
    }>
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  } | null
}

export type RegistrosMChatQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type RegistrosMChatQuery = {
  readonly __typename?: 'Query'
  readonly registrosMChat?: ReadonlyArray<{
    readonly __typename?: 'MChat'
    readonly id: string
    readonly risco: MChatRiscoEnum
    readonly dataResultado: any
    readonly isMchatRf: boolean
  }> | null
}

export type SolicitacoesExamesPagedQueryVariables = Exact<{
  input: SolicitacoesExameQueryInput
}>

export type SolicitacoesExamesPagedQuery = {
  readonly __typename?: 'Query'
  readonly solicitacoesExamePaged: {
    readonly __typename?: 'SolicitacoesExamePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly data: any
      readonly tipoExame: TipoExameEnum
      readonly observacoes?: string | null
      readonly justificativa: string
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly conferido?: boolean | null
        readonly observacao?: string | null
        readonly solicitacao?: {
          readonly __typename?: 'SolicitacaoExame'
          readonly id: string
          readonly data: any
        } | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
        readonly atendimentoProfissionalResultado?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
        } | null
      }>
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly sexo?: string | null
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      }
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type SolicitacoesExameUnpagedQueryVariables = Exact<{
  input: SolicitacoesExameQueryInput
}>

export type SolicitacoesExameUnpagedQuery = {
  readonly __typename?: 'Query'
  readonly solicitacoesExame: {
    readonly __typename?: 'SolicitacoesExamePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'SolicitacaoExame'
      readonly id: string
      readonly data: any
      readonly tipoExame: TipoExameEnum
      readonly justificativa: string
      readonly observacoes?: string | null
      readonly exames: ReadonlyArray<{
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly conferido?: boolean | null
        readonly observacao?: string | null
        readonly solicitacao?: {
          readonly __typename?: 'SolicitacaoExame'
          readonly id: string
          readonly data: any
        } | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        }
      }>
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
        readonly ciapsRelacionadas?: ReadonlyArray<{ readonly __typename?: 'Ciap'; readonly id: string } | null> | null
      } | null
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      }
      readonly solicitacaoCitopatologico?: {
        readonly __typename?: 'SolicitacaoExameCitopatologico'
        readonly id: string
        readonly questoes: ReadonlyArray<{
          readonly __typename?: 'SolicitacaoExameCitopatologicoQuestao'
          readonly id: string
          readonly pergunta: RastreioCancerPerguntaDbEnum
          readonly resposta: string
        } | null>
      } | null
    }>
  }
}

export type AtestadoModelosLoadQueryVariables = Exact<{ [key: string]: never }>

export type AtestadoModelosLoadQuery = {
  readonly __typename?: 'Query'
  readonly atestadoModelos: ReadonlyArray<{
    readonly __typename?: 'AtestadoModelo'
    readonly id: string
    readonly nome: string
  } | null>
}

export type LoadAtestadoByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type LoadAtestadoByIdQuery = {
  readonly __typename?: 'Query'
  readonly atestado: {
    readonly __typename?: 'Atestado'
    readonly id: string
    readonly descricao?: string | null
    readonly tipo?: TipoAtestadoEnum | null
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly numeroConselhoClasse?: string | null
          readonly conselhoClasse?: {
            readonly __typename?: 'ConselhoClasse'
            readonly id: string
            readonly sigla: string
          } | null
          readonly ufEmissoraConselhoClasse?: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          } | null
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  }
}

export type LoadAtestadosQueryVariables = Exact<{
  input: AtestadoQueryInput
}>

export type LoadAtestadosQuery = {
  readonly __typename?: 'Query'
  readonly atestados: {
    readonly __typename?: 'AtestadoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Atestado'
      readonly id: string
      readonly assinadoDigitalmente: boolean
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly numeroConselhoClasse?: string | null
            readonly conselhoClasse?: {
              readonly __typename?: 'ConselhoClasse'
              readonly id: string
              readonly sigla: string
            } | null
            readonly ufEmissoraConselhoClasse?: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            } | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly municipio: {
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }
        }
      }
    } | null>
  }
}

export type AtestadoModeloByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtestadoModeloByIdQuery = {
  readonly __typename?: 'Query'
  readonly atestadoModelo: {
    readonly __typename?: 'AtestadoModelo'
    readonly id: string
    readonly nome: string
    readonly descricao: string
  }
}

export type AtestadoModeloDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtestadoModeloDeleteMutation = { readonly __typename?: 'Mutation'; readonly excluirAtestadoModelo: string }

export type AtestadoModeloSaveMutationVariables = Exact<{
  input: AtestadoModeloInput
}>

export type AtestadoModeloSaveMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtestadoModelo: { readonly __typename?: 'AtestadoModelo'; readonly id: string }
}

export type CompartilhamentoCuidadoPlanoQueryVariables = Exact<{
  compartilhamentoCuidadoPlanoQueryInput: CompartilhamentoCuidadoPlanoQueryInput
}>

export type CompartilhamentoCuidadoPlanoQuery = {
  readonly __typename?: 'Query'
  readonly compartilhamentosCuidadoPlano: ReadonlyArray<{
    readonly __typename?: 'CompartilhamentoCuidadoPlanoDto'
    readonly id: string
    readonly dataInicio: any
    readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
    readonly discussao: string
    readonly cidadaoAceitaAtendTic?: boolean | null
    readonly isEncaminhamento: boolean
    readonly atendimentoProfissional: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
    readonly lotacaoSolicitante: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
        readonly cns?: string | null
      }
    }
    readonly lotacaoExecutanteAtual?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
        readonly cns?: string | null
      }
    } | null
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly unidadeSaude?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    } | null
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
    readonly especialidade?: {
      readonly __typename?: 'EspecialidadeEsusReg'
      readonly id: string
      readonly nome: string
    } | null
  }>
}

export type CompartilhamentoCuidadoLotacaoFragment = {
  readonly __typename?: 'Lotacao'
  readonly id: string
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf: string
    readonly cns?: string | null
  }
}

export type EspecialidadesEsusRegFragment = {
  readonly __typename?: 'EspecialidadeEsusReg'
  readonly id: string
  readonly nome: string
}

export type GuiasEncaminhamentoFragment = {
  readonly __typename?: 'GuiaEncaminhamento'
  readonly id: string
  readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
  readonly discussao: string
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly cid10?: {
    readonly __typename?: 'Cid10'
    readonly id: string
    readonly codigo: string
    readonly nome: string
  } | null
  readonly ciap?: {
    readonly __typename?: 'Ciap'
    readonly id: string
    readonly codigo: string
    readonly descricao: string
  } | null
  readonly especialidade: { readonly __typename?: 'EspecialidadeEsusReg'; readonly id: string; readonly nome: string }
}

export type AcessoHasCbosDisponiveisVinculacaoEquipeQueryVariables = Exact<{ [key: string]: never }>

export type AcessoHasCbosDisponiveisVinculacaoEquipeQuery = {
  readonly __typename?: 'Query'
  readonly acessoHasCbosDisponiveisVinculacaoEquipe: boolean
}

export type AcessoHasVinculacaoEquipeNasfQueryVariables = Exact<{ [key: string]: never }>

export type AcessoHasVinculacaoEquipeNasfQuery = {
  readonly __typename?: 'Query'
  readonly acessoHasVinculacaoEquipeNasf: boolean
}

export type EstabelecimentosCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: EstabelecimentosCuidadoCompartilhadoByCboIdQueryInput
}>

export type EstabelecimentosCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly estabelecimentosCuidadoCompartilhado: {
    readonly __typename?: 'UnidadeSaudePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
      readonly ativo?: boolean | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type LotacoesCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: LotacoesCuidadoCompartilhadoByEstabelecimentoIdQueryInput
  date: Scalars['LocalDate']['input']
}>

export type LotacoesCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly lotacoesCuidadoCompartilhado: {
    readonly __typename?: 'LotacaoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly hasAgendaFechada: boolean
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CuidadosCompartilhadoPlanoQueryVariables = Exact<{
  input: CuidadosCompartilhadoQueryInput
}>

export type CuidadosCompartilhadoPlanoQuery = {
  readonly __typename?: 'Query'
  readonly cuidadosCompartilhado: {
    readonly __typename?: 'CuidadosCompartilhadoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly iniciadoEm: any
      readonly discussao: string
      readonly cidadaoAceitaAtendTic: boolean
      readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
      readonly lotacaoExecutanteAtual?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
      } | null
      readonly cboExecutanteAtual: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly lotacaoSolicitante: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
    }>
  }
}

export type AuditGerarDeclaracaoComparecimentoMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type AuditGerarDeclaracaoComparecimentoMutation = {
  readonly __typename?: 'Mutation'
  readonly auditGerarDeclaracaoComparecimento?: boolean | null
}

export type AtendimentoProfissionalEncaminhamentoByIdQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type AtendimentoProfissionalEncaminhamentoByIdQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
    }
  }
}

export type EncaminhamentoEspecializadoByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type EncaminhamentoEspecializadoByIdQuery = {
  readonly __typename?: 'Query'
  readonly encaminhamentoEspecializado: {
    readonly __typename?: 'EncaminhamentoExternoEspecializado'
    readonly id: string
    readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
    readonly complemento?: string | null
    readonly motivoEncaminhamento?: string | null
    readonly observacoes?: string | null
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
          readonly cns?: string | null
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
      }
    }
    readonly especialidadeSisreg: {
      readonly __typename?: 'EspecialidadeSisreg'
      readonly id: string
      readonly descricao: string
    }
    readonly hipoteseDiagnosticoCiap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
    } | null
    readonly hipoteseDiagnosticoCid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly nome: string
      readonly codigo: string
    } | null
  }
}

export type EncaminhamentosExternosEspecializadosQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  editAtendProfId?: InputMaybe<Scalars['ID']['input']>
}>

export type EncaminhamentosExternosEspecializadosQuery = {
  readonly __typename?: 'Query'
  readonly encaminhamentosEspecializados: {
    readonly __typename?: 'EncaminhamentoExternoEspecializadoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'EncaminhamentoExternoEspecializado'
      readonly id: string
      readonly motivoEncaminhamento?: string | null
      readonly classificacaoRiscoEncaminhamento: ClassificacaoRiscoEncaminhamentoEnum
      readonly complemento?: string | null
      readonly observacoes?: string | null
      readonly especialidadeSisreg: {
        readonly __typename?: 'EspecialidadeSisreg'
        readonly id: string
        readonly descricao: string
      }
      readonly hipoteseDiagnosticoCid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly hipoteseDiagnosticoCiap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string }
        }
      }
    } | null>
  }
}

export type EncaminhamentosExternosQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  editAtendProfId?: InputMaybe<Scalars['ID']['input']>
}>

export type EncaminhamentosExternosQuery = {
  readonly __typename?: 'Query'
  readonly encaminhamentos: ReadonlyArray<{
    readonly __typename?: 'EncaminhamentoExterno'
    readonly tipo: TipoEncaminhamentoExternoEnum
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string }
      }
    }
  }>
}

export type PartesBucaisQueryVariables = Exact<{
  input: PartesBucaisQueryInput
}>

export type PartesBucaisQuery = {
  readonly __typename?: 'Query'
  readonly partesBucais: {
    readonly __typename?: 'PartesBucaisPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ParteBucal'
      readonly id: string
      readonly descricao?: string | null
      readonly parteBucalEnum: ParteBucalEnum
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type OdontogramaProcedimentosQueryVariables = Exact<{
  input: EvolucoesProcedimentoOdontoInput
}>

export type OdontogramaProcedimentosQuery = {
  readonly __typename?: 'Query'
  readonly evolucoesProcedimentoOdonto: {
    readonly __typename?: 'EvolucaoProcedimentoPayload'
    readonly content?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProcedimentoOdonto'
      readonly id: string
      readonly descricaoParteBucal?: string | null
      readonly observacao?: string | null
      readonly atendimentoProfissionalOdonto: {
        readonly __typename?: 'AtendimentoProfissionalOdonto'
        readonly id: string
      }
      readonly partesBucais?: ReadonlyArray<{
        readonly __typename?: 'ParteBucal'
        readonly id: string
        readonly tipoParteBucal: TipoParteBucalEnum
        readonly descricao?: string | null
      }> | null
      readonly procedimentos?: ReadonlyArray<{
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
        } | null
      }> | null
    } | null> | null
  }
}

export type OdontogramaQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type OdontogramaQuery = {
  readonly __typename?: 'Query'
  readonly odontograma: {
    readonly __typename?: 'Odontograma'
    readonly id: string
    readonly proteseTotalInferior?: boolean | null
    readonly proteseTotalSuperior?: boolean | null
    readonly contencao?: boolean | null
    readonly aparelho?: boolean | null
    readonly evolucoesDente?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoDente'
      readonly id: string
      readonly situacoesFace?: ReadonlyArray<SituacaoFaceEnum> | null
      readonly situacoesRaiz?: ReadonlyArray<SituacaoRaizEnum> | null
      readonly situacaoCoroaCima?: SituacaoCoroaEnum | null
      readonly situacaoCoroaBaixo?: SituacaoCoroaEnum | null
      readonly situacaoCoroaEsquerda?: SituacaoCoroaEnum | null
      readonly situacaoCoroaDireita?: SituacaoCoroaEnum | null
      readonly situacaoCoroaCentro?: SituacaoCoroaEnum | null
      readonly dente: { readonly __typename?: 'Dente'; readonly id: string; readonly numero?: number | null }
    } | null> | null
  }
}

export type OdontogramasQueryVariables = Exact<{
  input: OdontogramasQueryInput
}>

export type OdontogramasQuery = {
  readonly __typename?: 'Query'
  readonly odontogramas: {
    readonly __typename?: 'OdontogramasPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Odontograma'
      readonly id: string
      readonly proteseTotalSuperior?: boolean | null
      readonly proteseTotalInferior?: boolean | null
      readonly contencao?: boolean | null
      readonly aparelho?: boolean | null
      readonly evolucoesDente?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoDente'
        readonly id: string
        readonly situacoesRaiz?: ReadonlyArray<SituacaoRaizEnum> | null
        readonly situacoesFace?: ReadonlyArray<SituacaoFaceEnum> | null
        readonly situacaoCoroaCima?: SituacaoCoroaEnum | null
        readonly situacaoCoroaDireita?: SituacaoCoroaEnum | null
        readonly situacaoCoroaEsquerda?: SituacaoCoroaEnum | null
        readonly situacaoCoroaBaixo?: SituacaoCoroaEnum | null
        readonly situacaoCoroaCentro?: SituacaoCoroaEnum | null
        readonly dente: { readonly __typename?: 'Dente'; readonly id: string; readonly numero?: number | null }
      } | null> | null
    } | null>
  }
}

export type PeriodoOdontogramaSelectQueryVariables = Exact<{
  input: OdontogramasQueryInput
}>

export type PeriodoOdontogramaSelectQuery = {
  readonly __typename?: 'Query'
  readonly odontogramas: {
    readonly __typename?: 'OdontogramasPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Odontograma'
      readonly id: string
      readonly atendimentoProfissionalOdonto: {
        readonly __typename?: 'AtendimentoProfissionalOdonto'
        readonly id: string
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly finalizadoEm?: any | null
          readonly iniciadoEm: any
        }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HistoricoEvolucoesOdontoTableQueryVariables = Exact<{
  input: EvolucoesProcedimentoOdontoInput
}>

export type HistoricoEvolucoesOdontoTableQuery = {
  readonly __typename?: 'Query'
  readonly evolucoesProcedimentoOdonto: {
    readonly __typename?: 'EvolucaoProcedimentoPayload'
    readonly content?: ReadonlyArray<{
      readonly __typename?: 'EvolucaoProcedimentoOdonto'
      readonly id: string
      readonly observacao?: string | null
      readonly descricaoParteBucal?: string | null
      readonly atendimentoProfissionalOdonto: {
        readonly __typename?: 'AtendimentoProfissionalOdonto'
        readonly id: string
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly iniciadoEm: any
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          }
        }
      }
      readonly procedimentos?: ReadonlyArray<{
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }> | null
      readonly partesBucais?: ReadonlyArray<{
        readonly __typename?: 'ParteBucal'
        readonly id: string
        readonly tipoParteBucal: TipoParteBucalEnum
        readonly descricao?: string | null
        readonly parteBucalEnum: ParteBucalEnum
      }> | null
    } | null> | null
    readonly pageInfo?: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    } | null
  }
}

export type PeriogramasCompletoQueryVariables = Exact<{
  input: PeriogramaCompletoQueryInput
}>

export type PeriogramasCompletoQuery = {
  readonly __typename?: 'Query'
  readonly periogramasCompleto: ReadonlyArray<{
    readonly __typename?: 'PeriogramaCompleto'
    readonly id: string
    readonly excluido: boolean
    readonly profundidadeVestibular?: string | null
    readonly recessaoVestibular?: string | null
    readonly profundidadeInterna?: string | null
    readonly recessaoInterna?: string | null
    readonly placaDVestibular?: boolean | null
    readonly placaVVestibular?: boolean | null
    readonly placaMVestibular?: boolean | null
    readonly sangramentoDVestibular?: boolean | null
    readonly sangramentoVVestibular?: boolean | null
    readonly sangramentoMVestibular?: boolean | null
    readonly placaDInterna?: boolean | null
    readonly placaVInterna?: boolean | null
    readonly placaMInterna?: boolean | null
    readonly sangramentoDInterna?: boolean | null
    readonly sangramentoVInterna?: boolean | null
    readonly sangramentoMInterna?: boolean | null
    readonly mobilidade?: string | null
    readonly lesaoDeFurca?: string | null
    readonly dente: { readonly __typename?: 'ParteBucal'; readonly id: string; readonly parteBucalEnum: ParteBucalEnum }
    readonly atendimentoProfissionalOdonto: {
      readonly __typename?: 'AtendimentoProfissionalOdonto'
      readonly id: string
      readonly observacaoRPC?: string | null
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly iniciadoEm: any
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      }
    }
  } | null>
}

export type HistoricoPeriogramaSimplificadoQueryVariables = Exact<{
  input: PeriogramaSimplificadoQueryInput
}>

export type HistoricoPeriogramaSimplificadoQuery = {
  readonly __typename?: 'Query'
  readonly periogramasSimplificados: {
    readonly __typename?: 'PeriogramaSimplificadoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'PeriogramaSimplificado'
      readonly id: string
      readonly avaliacaoSextante1: string
      readonly avaliacaoSextante2: string
      readonly avaliacaoSextante3: string
      readonly avaliacaoSextante4: string
      readonly avaliacaoSextante5: string
      readonly avaliacaoSextante6: string
      readonly observacao?: string | null
      readonly atendimentoProfissionalOdonto: {
        readonly __typename?: 'AtendimentoProfissionalOdonto'
        readonly id: string
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly iniciadoEm: any
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HistoricoTecidosMolesQueryVariables = Exact<{
  input: TecidosMolesQueryInput
}>

export type HistoricoTecidosMolesQuery = {
  readonly __typename?: 'Query'
  readonly tecidosMoles: {
    readonly __typename?: 'TecidosMolesPayload'
    readonly content?: ReadonlyArray<{
      readonly __typename?: 'TecidoMole'
      readonly id: string
      readonly descricaoSintomatologia?: string | null
      readonly parteBucal: {
        readonly __typename?: 'ParteBucal'
        readonly id: string
        readonly descricao?: string | null
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly caracteristicasLesao?: ReadonlyArray<{
        readonly __typename?: 'CaracteristicaLesao'
        readonly id: string
        readonly caracteristicaLesao: CaracteristicaLesaoEnum
      }> | null
      readonly evolucaoProcedimentoOdonto?: {
        readonly __typename?: 'EvolucaoProcedimentoOdonto'
        readonly id: string
        readonly observacao?: string | null
        readonly procedimentos?: ReadonlyArray<{
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }> | null
      } | null
      readonly atendimentoProfissionalOdonto: {
        readonly __typename?: 'AtendimentoProfissionalOdonto'
        readonly id: string
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly iniciadoEm: any
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          }
        }
      }
    } | null> | null
    readonly pageInfo?: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    } | null
  }
}

export type GruposExamesQueryVariables = Exact<{
  input: GrupoExameQueryInput
}>

export type GruposExamesQuery = {
  readonly __typename?: 'Query'
  readonly gruposExame: {
    readonly __typename?: 'GruposExameQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'GrupoExame'
      readonly id: string
      readonly nome: string
      readonly idadeMinima?: number | null
      readonly idadeMaxima?: number | null
      readonly procedimentos?: ReadonlyArray<{
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly idadeMinima?: number | null
        readonly idadeMaxima?: number | null
        readonly idadeAplicavel?: boolean | null
        readonly sexo?: SexoEnum | null
        readonly ativo?: boolean | null
        readonly procedimentoReferencia?: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly descricao: string
          readonly codigo: string
        } | null
      } | null> | null
    } | null>
  }
}

export type UltimoExameCitopatologicoQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type UltimoExameCitopatologicoQuery = {
  readonly __typename?: 'Query'
  readonly ultimaSolicitacaoCitopatologicoUtero?: {
    readonly __typename?: 'ExameCitopatologicoUteroPayload'
    readonly id: string
    readonly requisicaoExameId: string
    readonly respostas: ReadonlyArray<{
      readonly __typename?: 'RastreioCancerPerguntaRespostaDto'
      readonly pergunta: RastreioCancerPerguntaDbEnum
      readonly opcao?: RastreioCancerPerguntaOpcaoEnum | null
      readonly descricao?: string | null
      readonly data?: any | null
    } | null>
  } | null
}

export type HistoricoPlanosDeCuidadoQueryVariables = Exact<{
  atendProfId: Scalars['ID']['input']
}>

export type HistoricoPlanosDeCuidadoQuery = {
  readonly __typename?: 'Query'
  readonly planosDeCuidado: ReadonlyArray<{
    readonly __typename?: 'AtendimentoObservacaoPlanoCuidado'
    readonly id: string
    readonly descricao: string
    readonly dataDescricao: any
    readonly atendimentoProfissionalObservacao: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoProfissional: {
        readonly __typename?: 'AtendimentoProfissional'
        readonly id: string
        readonly lotacao: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        }
      }
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalIniciador: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly iniciadoEm: any
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          }
        }
      }
    }
  }>
}

export type OrientacoesQueryVariables = Exact<{
  orientacaoQueryInput: OrientacaoQueryInput
}>

export type OrientacoesQuery = {
  readonly __typename?: 'Query'
  readonly orientacoes: ReadonlyArray<{
    readonly __typename?: 'Orientacao'
    readonly id: string
    readonly descricao: string
    readonly atendimentoProfissional: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly tipoAtendimento?: TipoAtendimentoEnum | null
      readonly atendimento?: {
        readonly __typename?: 'Atendimento'
        readonly id: string
        readonly localAtendimento?: {
          readonly __typename?: 'LocalAtendimento'
          readonly id: string
          readonly localAtendimentoExibicao?: string | null
        } | null
      } | null
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly numeroConselhoClasse?: string | null
          readonly conselhoClasse?: {
            readonly __typename?: 'ConselhoClasse'
            readonly id: string
            readonly sigla: string
          } | null
          readonly ufEmissoraConselhoClasse?: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          } | null
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly sigla: string
            readonly nome: string
          }
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    }
  } | null>
}

export type AuditaImpressaoOrientacaoMutationVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
  atendimentoId?: InputMaybe<Scalars['ID']['input']>
  orientacaoId?: InputMaybe<Scalars['ID']['input']>
}>

export type AuditaImpressaoOrientacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly auditaImpressaoOrientacao?: string | null
}

export type PrincipiosAtivosAlergiasQueryVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type PrincipiosAtivosAlergiasQuery = {
  readonly __typename?: 'Query'
  readonly principiosAtivosAlergias: ReadonlyArray<{
    readonly __typename?: 'PrincipioAtivo'
    readonly id: string
    readonly nome: string
  }>
}

export type HistoricoPrescricaoQueryVariables = Exact<{
  input: HistoricoPrescricaoQueryInput
}>

export type HistoricoPrescricaoQuery = {
  readonly __typename?: 'Query'
  readonly historicoPrescricao: {
    readonly __typename?: 'HistoricoPrescricaoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly versao?: string | null
      readonly versaoAnterior?: boolean | null
      readonly finalizadoEm?: any | null
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly numeroConselhoClasse?: string | null
          readonly ufEmissoraConselhoClasse?: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly sigla: string
          } | null
          readonly conselhoClasse?: {
            readonly __typename?: 'ConselhoClasse'
            readonly id: string
            readonly sigla: string
          } | null
        }
      }
      readonly receitaMedicamento?: ReadonlyArray<{
        readonly __typename?: 'ReceitaMedicamento'
        readonly id: string
        readonly quantidadeReceitada: number
        readonly recomendacoes?: string | null
        readonly dose?: string | null
        readonly qtDose?: string | null
        readonly qtDoseManha?: string | null
        readonly qtDoseTarde?: string | null
        readonly qtDoseNoite?: string | null
        readonly frequenciaDose?: string | null
        readonly posologia: string
        readonly tipoFrequenciaDose?: TipoFrequencia | null
        readonly qtPeriodoFrequencia?: number | null
        readonly medidaTempoFrequencia?: UnidadeMedidaTempoEnum | null
        readonly dtInicioTratamento?: any | null
        readonly dtFimTratamento?: any | null
        readonly qtDuracaoTratamento?: number | null
        readonly medidaTempoTratamento?: UnidadeMedidaTempoEnum | null
        readonly usoContinuo?: boolean | null
        readonly registroManual?: boolean | null
        readonly doseUnica?: boolean | null
        readonly tipoReceita?: TipoReceitaEnum | null
        readonly tratamentoInterrompido?: boolean | null
        readonly justificativaInterrupcao?: string | null
        readonly dtInterrupcao?: any | null
        readonly medicamento: {
          readonly __typename?: 'Medicamento'
          readonly id: string
          readonly principioAtivo: string
          readonly concentracao?: string | null
          readonly unidadeFornecimento?: string | null
          readonly medicamentoCatmat?: {
            readonly __typename?: 'MedicamentoCatmat'
            readonly id: string
            readonly ativo: boolean
            readonly volume?: string | null
            readonly codigoCatMat?: string | null
            readonly codigoObm?: string | null
            readonly codigoRename?: string | null
            readonly unidadeFornecimento: {
              readonly __typename?: 'UnidadeMedida'
              readonly id: string
              readonly nome: string
              readonly nomePlural: string
            }
            readonly principioAtivo: {
              readonly __typename?: 'PrincipioAtivo'
              readonly id: string
              readonly nome: string
              readonly listaMaterial: {
                readonly __typename?: 'ListaMedicamento'
                readonly id: string
                readonly tipo: string
                readonly tipoReceita: TipoReceitaEnum
              }
            }
          } | null
          readonly formaFarmaceutica?: {
            readonly __typename?: 'FormaFarmaceutica'
            readonly id: string
            readonly nome: string
          } | null
        }
        readonly aplicacaoMedicamento: {
          readonly __typename?: 'AplicacaoMedicamento'
          readonly id: string
          readonly nome: string
        }
        readonly unidadeMedidaDose?: {
          readonly __typename?: 'UnidadeMedida'
          readonly id: string
          readonly nome: string
          readonly nomePlural: string
        } | null
        readonly receitaUsoContinuoGrupo?: {
          readonly __typename?: 'ReceitaMedicamento'
          readonly id: string
          readonly dtInicioTratamento?: any | null
        } | null
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly ativo?: boolean | null
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
      } | null> | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ConexaoHorusQueryVariables = Exact<{ [key: string]: never }>

export type ConexaoHorusQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
    readonly horus: { readonly __typename?: 'ConfiguracaoHorus'; readonly id: string; readonly habilitado: boolean }
  }
}

export type ConsultaEstoqueHorusQueryVariables = Exact<{
  filter: ConsultaEstoqueHorusQueryInput
}>

export type ConsultaEstoqueHorusQuery = { readonly __typename?: 'Query'; readonly consultaEstoqueHorus: string }

export type BundlesFhirComAssinaturaPendenteQueryVariables = Exact<{
  atendProfId: Scalars['ID']['input']
}>

export type BundlesFhirComAssinaturaPendenteQuery = {
  readonly __typename?: 'Query'
  readonly bundlesFhirComAssinaturaPendente: ReadonlyArray<{
    readonly __typename?: 'BundleFhirComAssinaturaPendente'
    readonly id: string
    readonly tipoRegistroRndsEnum: TipoRegistroRndsEnum
    readonly descricao: string
  }>
}

export type MarcarBundlesComoNaoEnviadoMutationVariables = Exact<{
  atendProfId: Scalars['ID']['input']
}>

export type MarcarBundlesComoNaoEnviadoMutation = {
  readonly __typename?: 'Mutation'
  readonly marcarBundlesComoNaoEnviado: boolean
}

export type CategoriasMedicamentosQueryVariables = Exact<{ [key: string]: never }>

export type CategoriasMedicamentosQuery = {
  readonly __typename?: 'Query'
  readonly categoriasMedicamentos: ReadonlyArray<{
    readonly __typename?: 'CategoriaMedicamento'
    readonly id: string
    readonly nome: ListaMedicamentoEnum
    readonly disponivelParaPrescricaoDigital: boolean
    readonly categoriasCompativeis: ReadonlyArray<ListaMedicamentoEnum>
  }>
}

export type CidadaoEmailUpdateMutationVariables = Exact<{
  input: AtualizarEmailCidadaoInput
}>

export type CidadaoEmailUpdateMutation = {
  readonly __typename?: 'Mutation'
  readonly atualizarEmailCidadao: {
    readonly __typename?: 'ContatoCidadao'
    readonly id: string
    readonly email?: string | null
  }
}

export type CidadaoInformacoesContatoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoInformacoesContatoQuery = {
  readonly __typename?: 'Query'
  readonly contatoCidadao: {
    readonly __typename?: 'ContatoCidadao'
    readonly id: string
    readonly email?: string | null
  }
}

export type TiposReceitaProibidosQueryVariables = Exact<{ [key: string]: never }>

export type TiposReceitaProibidosQuery = {
  readonly __typename?: 'Query'
  readonly tiposReceitaProibidos: ReadonlyArray<TipoReceitaEnum>
}

export type EscutaInicialSaveMutationVariables = Exact<{
  input: EscutaInicialInput
}>

export type EscutaInicialSaveMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarEscutaInicial: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string }
}

export type EscutaInicialViewQueryVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type EscutaInicialViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly statusAtendimento: StatusAtendimento
    readonly iniciadoEm: any
    readonly isAgendado: boolean
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly cns?: string | null
      readonly cpf?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
      readonly sexo: SexoEnum
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    }
    readonly prontuario: {
      readonly __typename?: 'Prontuario'
      readonly id: string
      readonly gestacoes?: ReadonlyArray<{
        readonly __typename?: 'PeriodoGestacao'
        readonly id: string
        readonly inicio: any
        readonly fim?: any | null
      }> | null
      readonly preNatalAtivo?: {
        readonly __typename?: 'PreNatal'
        readonly id: string
        readonly ultimaDum?: any | null
      } | null
    }
    readonly tiposServico?: ReadonlyArray<{ readonly __typename?: 'TipoServico'; readonly id: string } | null> | null
    readonly atendimentoProfissional?: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly tipo: TipoAtendimentoProfissional
      readonly iniciadoEm: any
      readonly rascunho?: string | null
      readonly estagio?: { readonly __typename?: 'Estagio'; readonly id: string } | null
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly cpf: string
          readonly cns?: string | null
          readonly nome: string
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
      }
    } | null
  }
  readonly procedimentosAutomaticos: ReadonlyArray<{
    readonly __typename?: 'Procedimento'
    readonly id: string
    readonly descricao: string
    readonly codigo: string
    readonly ativo?: boolean | null
    readonly procedimentoReferencia?: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
    } | null
  } | null>
}

export type SalvarEscutaInicialParaAprovacaoMutationVariables = Exact<{
  input: EscutaInicialAprovacaoInput
}>

export type SalvarEscutaInicialParaAprovacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarEscutaInicialParaAprovacao: boolean
}

export type EscutaInicialDetailQueryVariables = Exact<{
  input: HistoricoDetailQueryInput
}>

export type EscutaInicialDetailQuery = {
  readonly __typename?: 'Query'
  readonly escutaInicialDetail?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly classificacaoRisco?: ClassificacaoRisco | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly acompanhadoEspecialidade?: string | null
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly valorImc?: number | null
      readonly id: string
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly obrigatorio?: boolean | null
      readonly automatico?: boolean | null
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly tipoProcedimento?: TipoProcedimentoEnum | null
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly estagio?: {
      readonly __typename?: 'Estagio'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
      readonly dataCriacaoRegistro?: any | null
      readonly localAtendimento?: {
        readonly __typename?: 'LocalAtendimento'
        readonly id: string
        readonly localAtendimentoExibicao?: string | null
      } | null
    } | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipoEstabelecimento: TipoEstabelecimentoEnum
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    } | null
    readonly atendimentoProfissionalObservacao?: {
      readonly __typename?: 'AtendimentoProfissionalObservacao'
      readonly id: string
      readonly atendimentoObservacao: {
        readonly __typename?: 'AtendimentoObservacao'
        readonly id: string
        readonly atendimentoProfissionalFinalizador?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly lotacao: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeCivil: string
              readonly nomeSocial?: string | null
            }
            readonly unidadeSaude: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
              readonly cnes: string
              readonly tipoEstabelecimento: TipoEstabelecimentoEnum
            }
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly ine: string
            } | null
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
              readonly actions?: {
                readonly __typename?: 'CboActions'
                readonly cadastroDomiciliar: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly cadastroIndividual: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
                readonly atividadeColetiva: {
                  readonly __typename?: 'Action'
                  readonly enabled: boolean
                  readonly hint?: string | null
                }
              } | null
            }
          }
        } | null
      }
    } | null
  } | null
}

export type EscutaInicialVisualizarQueryVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type EscutaInicialVisualizarQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly isAgendado: boolean
    readonly cidadao: { readonly __typename?: 'CidadaoBasico'; readonly id: string }
    readonly escutaInicialAtendProf?: {
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
    } | null
  }
}

export type CiapFragment = {
  readonly __typename?: 'Ciap'
  readonly id: string
  readonly codigo: string
  readonly descricao: string
}

export type Cid10Fragment = {
  readonly __typename?: 'Cid10'
  readonly id: string
  readonly codigo: string
  readonly nome: string
}

export type Cid11Fragment = {
  readonly __typename?: 'Cid11'
  readonly id: string
  readonly codigo: string
  readonly nome: string
  readonly ativo: boolean
}

export type EquipeAtendimentoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type EquipeAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly equipe: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
    readonly tipoEquipe: {
      readonly __typename?: 'TipoEquipe'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    }
  }
}

export type ExcluirAtendimentoMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type ExcluirAtendimentoMutation = { readonly __typename?: 'Mutation'; readonly excluirAtendimento: string }

export type ListaAtendimentoQueryVariables = Exact<{
  input: AtendimentosQueryInput
}>

export type ListaAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly atendimentos: {
    readonly __typename?: 'AtendimentosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly prontuarioId: string
      readonly iniciadoEm: any
      readonly encaminhadoEm: any
      readonly statusAtendimento: StatusAtendimento
      readonly statusRevisaoAtendimento?: StatusRevisaoAtendimento | null
      readonly classificacaoRisco?: ClassificacaoRisco | null
      readonly ultimaAlteracaoStatusEm: any
      readonly hasTagNaoFinalizado: boolean
      readonly cidadao: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
      }
      readonly agendado?: {
        readonly __typename?: 'Agendado'
        readonly id: string
        readonly horarioInicial: any
        readonly situacao: SituacaoAgendadoEnum
        readonly lotacaoAgendada: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
        readonly lotacaoParticipante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly nomeSocial?: string | null
          }
        } | null
        readonly videochamada?: { readonly __typename?: 'Videochamada'; readonly id: string } | null
      } | null
      readonly tiposServico?: ReadonlyArray<{
        readonly __typename?: 'TipoServico'
        readonly id: string
        readonly nome: string
      } | null> | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly area?: string | null
      } | null
      readonly responsavel?:
        | {
            readonly __typename?: 'Estagio'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeSocial?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
            }
          }
        | {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly nomeSocial?: string | null
            }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
            }
          }
        | null
      readonly actions: {
        readonly __typename?: 'AtendimentoActions'
        readonly atender?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly revisarRetificar?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly escutaInicial?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly vacinacao?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly informarAusencia?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly cancelarAusencia?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly visualizarProntuario?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly visualizarEscutaInicial?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly editar?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly excluir?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly atendimentosDia?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly declaracaoComparecimento?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly cancelarRegistro?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly tornarResponsavelObservacao?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly gerarAutorizacaoRetiradaAbsorventes?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
        readonly chamarCidadaoPainel?: {
          readonly __typename?: 'Action'
          readonly hint?: string | null
          readonly enabled: boolean
        } | null
      }
      readonly ultimoResponsavelObservacao?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type PossuiAtendimentosNaoFinalizadosQueryVariables = Exact<{
  input: PossuiAtendimentosNaoFinalizadosInput
}>

export type PossuiAtendimentosNaoFinalizadosQuery = {
  readonly __typename?: 'Query'
  readonly possuiAtendimentosNaoFinalizados?: boolean | null
}

export type SalvarAtendimentoMutationVariables = Exact<{
  input: AtendimentoInput
}>

export type SalvarAtendimentoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
    }
  }
}

export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables = Exact<{
  prontuarioId: Scalars['ID']['input']
}>

export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarJustificativaAutomaticaVisualizarEscutaInicial: string
}

export type TornarLotacaoAtualResponsavelAtendimentoObservacaoMutationVariables = Exact<{
  atendimentoId: Scalars['ID']['input']
}>

export type TornarLotacaoAtualResponsavelAtendimentoObservacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly tornarLotacaoAtualResponsavelAtendimentoObservacao: string
}

export type AtenderMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type AtenderMutation = {
  readonly __typename?: 'Mutation'
  readonly realizarAtendimentoIndividual: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly statusAtendimento: StatusAtendimento
    readonly cidadao: { readonly __typename?: 'CidadaoBasico'; readonly id: string }
    readonly atendimentoProfissional?: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string } | null
  }
}

export type CancelarAusenciaMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type CancelarAusenciaMutation = {
  readonly __typename?: 'Mutation'
  readonly cancelarCidadaoNaoAguardou: { readonly __typename?: 'Atendimento'; readonly id: string }
}

export type InformarAusenciaMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type InformarAusenciaMutation = {
  readonly __typename?: 'Mutation'
  readonly informarCidadaoNaoAguardou: { readonly __typename?: 'Atendimento'; readonly id: string }
}

export type RealizarAtendimentoVacinacaoMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type RealizarAtendimentoVacinacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly realizarAtendimentoVacinacao: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly cidadao: { readonly __typename?: 'CidadaoBasico'; readonly id: string }
    readonly atendimentoProfissional?: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string } | null
  }
}

export type RealizarEscutaInicialMutationVariables = Exact<{
  atendimento: Scalars['ID']['input']
}>

export type RealizarEscutaInicialMutation = {
  readonly __typename?: 'Mutation'
  readonly realizarEscutaInicial: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly cidadao: { readonly __typename?: 'CidadaoBasico'; readonly id: string }
    readonly atendimentoProfissional?: { readonly __typename?: 'AtendimentoProfissional'; readonly id: string } | null
  }
}

export type AtendimentosDoDiaQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtendimentosDoDiaQuery = {
  readonly __typename?: 'Query'
  readonly atendimentosDoDia: {
    readonly __typename?: 'AtendimentosProfissionalPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProfissional'
      readonly id: string
      readonly iniciadoEm: any
      readonly finalizadoEm?: any | null
      readonly tipo: TipoAtendimentoProfissional
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
      readonly atendimento?: {
        readonly __typename?: 'Atendimento'
        readonly id: string
        readonly iniciadoEm: any
        readonly dataCriacaoRegistro?: any | null
        readonly cidadao: {
          readonly __typename?: 'CidadaoBasico'
          readonly id: string
          readonly nome: string
          readonly cpf?: string | null
          readonly cns?: string | null
          readonly dataNascimento?: any | null
          readonly nomeSocial?: string | null
        }
      } | null
    } | null>
  }
}

export type ChamarPainelMutationVariables = Exact<{
  input: ChamarPainelInput
}>

export type ChamarPainelMutation = { readonly __typename?: 'Mutation'; readonly chamarPainel: boolean }

export type CidadaoPainelChamadasQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoPainelChamadasQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
    }
  }
}

export type CidadaoDeclaracaoComparecimentoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoDeclaracaoComparecimentoQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly dataCriacaoRegistro?: any | null
    readonly iniciadoEm: any
    readonly isRegistroTardio: boolean
    readonly responsavel?:
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        }
      | null
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly dataNascimento?: any | null
      readonly nome: string
      readonly nomeSocial?: string | null
    }
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly endereco?: {
        readonly __typename?: 'Endereco'
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
      } | null
    }
  }
}

export type AtendimentoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly agendado?: { readonly __typename?: 'Agendado'; readonly id: string } | null
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
      readonly sexo: SexoEnum
      readonly racaCor?: {
        readonly __typename?: 'RacaCor'
        readonly id: string
        readonly nome: string
        readonly codigoMS: string
        readonly codigoCadsus: string
        readonly racaCorDbEnum: RacaCorDbEnum
      } | null
    }
    readonly responsavel?:
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
            readonly isAD: boolean
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          } | null
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
            readonly cnes: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly ine: string
            readonly nome: string
            readonly isAD: boolean
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          } | null
        }
      | null
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null
    readonly tiposServico?: ReadonlyArray<{
      readonly __typename?: 'TipoServico'
      readonly id: string
      readonly nome: string
    } | null> | null
  }
}

export type ResponsavelAtendimentoCommon_Estagio_Fragment = {
  readonly __typename?: 'Estagio'
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly isAD: boolean
    readonly tipoEquipe: {
      readonly __typename?: 'TipoEquipe'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    }
  } | null
}

export type ResponsavelAtendimentoCommon_Lotacao_Fragment = {
  readonly __typename?: 'Lotacao'
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly isAD: boolean
    readonly tipoEquipe: {
      readonly __typename?: 'TipoEquipe'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    }
  } | null
}

export type ResponsavelAtendimentoCommonFragment =
  | ResponsavelAtendimentoCommon_Estagio_Fragment
  | ResponsavelAtendimentoCommon_Lotacao_Fragment

export type ResponsavelAtendimentoLotacaoFragment = {
  readonly __typename?: 'Lotacao'
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly isAD: boolean
    readonly tipoEquipe: {
      readonly __typename?: 'TipoEquipe'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    }
  } | null
}

export type ResponsavelAtendimentoEstagioFragment = {
  readonly __typename?: 'Estagio'
  readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }
  readonly equipe?: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly ine: string
    readonly nome: string
    readonly isAD: boolean
    readonly tipoEquipe: {
      readonly __typename?: 'TipoEquipe'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    }
  } | null
}

export type EditarAtendimentoMutationVariables = Exact<{
  input: AtendimentoEditInput
}>

export type EditarAtendimentoMutation = {
  readonly __typename?: 'Mutation'
  readonly editarAtendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
    }
  }
}

export type AtividadeColetivaGrupoSelectQueryVariables = Exact<{
  input: GrupoParticipanteAtividadeColetivaQueryInput
}>

export type AtividadeColetivaGrupoSelectQuery = {
  readonly __typename?: 'Query'
  readonly gruposParticipantesAtividadeColetiva: {
    readonly __typename?: 'GrupoParticipanteAtividadeColetivaPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'GrupoParticipanteAtividadeColetiva'
      readonly id: string
      readonly nome: string
      readonly tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
      readonly lotacoesEnvolvidas: ReadonlyArray<{
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly ativo: boolean
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly cpf: string
          readonly cns?: string | null
        }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly ine: string
          readonly nome: string
        } | null
      }>
      readonly cidadaosParticipantes: ReadonlyArray<{
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
        readonly dataObito?: any | null
      }>
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AtividadeColetivaTableQueryVariables = Exact<{
  input: AtividadeColetivaQueryInput
}>

export type AtividadeColetivaTableQuery = {
  readonly __typename?: 'Query'
  readonly atividadesColetivas: {
    readonly __typename?: 'AtividadeColetivaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AtividadeColetiva'
      readonly id: string
      readonly dataAtividade: any
      readonly tipoAtividade: TipoAtividadeEnum
      readonly numeroParticipantes: number
      readonly registroEnviado: boolean
      readonly lotacaoResponsavel: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type FatoAtividadeColetivaTableQueryVariables = Exact<{
  input: AtividadeColetivaQueryInput
}>

export type FatoAtividadeColetivaTableQuery = {
  readonly __typename?: 'Query'
  readonly fatoAtividadesColetivas: {
    readonly __typename?: 'FatoAtividadeColetivaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FatoAtividadeColetiva'
      readonly id: string
      readonly dataRegistro?: any | null
      readonly origem?: OrigemDadoEnum | null
      readonly nuParticipantes?: number | null
      readonly dimensaoTipoAtividade: {
        readonly __typename?: 'DimensaoTipoAtividade'
        readonly id: string
        readonly nuIdentificador: number
      }
      readonly dimensaoProfissional?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly nome?: string | null
      } | null
      readonly dimensaoCbo?: { readonly __typename?: 'DimensaoCbo'; readonly id: string; readonly nome: string } | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ExcluirAtividadeColetivaMutationVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
}>

export type ExcluirAtividadeColetivaMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirAtividadeColetiva: any
}

export type VerificaCidadaoCadastradoQueryVariables = Exact<{
  cpf?: InputMaybe<Scalars['String']['input']>
  cns?: InputMaybe<Scalars['String']['input']>
}>

export type VerificaCidadaoCadastradoQuery = {
  readonly __typename?: 'Query'
  readonly cpfJaCadastrado: boolean
  readonly cnsJaCadastrado: boolean
}

export type SalvarAtividadeColetivaMutationVariables = Exact<{
  input: AtividadeColetivaInput
}>

export type SalvarAtividadeColetivaMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarAtividadeColetiva: any
}

export type FatoAtividadeColetivaFragmentFragment = {
  readonly __typename?: 'FatoAtividadeColetiva'
  readonly id: string
  readonly dataRegistro?: any | null
  readonly nuParticipantes?: number | null
  readonly descricaoOutraLocalidade?: string | null
  readonly stPseEducacao: boolean
  readonly stPseSaude: boolean
  readonly dimensaoProfissional?: {
    readonly __typename?: 'DimensaoProfissional'
    readonly id: string
    readonly nome?: string | null
  } | null
  readonly dimensaoCbo?: {
    readonly __typename?: 'DimensaoCbo'
    readonly id: string
    readonly nome: string
    readonly cbo: string
  } | null
  readonly dimensaoUnidadeSaude?: {
    readonly __typename?: 'DimensaoUnidadeSaude'
    readonly id: string
    readonly nome: string
    readonly cnes: string
  } | null
  readonly dimensaoEquipe?: {
    readonly __typename?: 'DimensaoEquipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
  } | null
  readonly dimensaoTipoAtividade: {
    readonly __typename?: 'DimensaoTipoAtividade'
    readonly id: string
    readonly nuIdentificador: number
  }
  readonly dimensaoTurno: { readonly __typename?: 'DimensaoTurno'; readonly id: string; readonly descricao: string }
  readonly dimensaoUnddSadeAcdmSade?: {
    readonly __typename?: 'DimensaoUnidadeSaude'
    readonly id: string
    readonly nome: string
    readonly cnes: string
  } | null
  readonly fatoAtividadeColetivaProfissionalParticipante?: ReadonlyArray<{
    readonly __typename?: 'FatoAtividadeColetivaProfissionalParticipante'
    readonly id: string
    readonly dimensaoProfissionalParticipante?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly cns?: string | null
      readonly nome?: string | null
    } | null
    readonly dimensaoCboParticipante?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
      readonly cbo: string
    } | null
  }> | null
}

export type AtividadeColetivaGrupoTableQueryVariables = Exact<{
  input: GrupoParticipanteAtividadeColetivaQueryInput
}>

export type AtividadeColetivaGrupoTableQuery = {
  readonly __typename?: 'Query'
  readonly gruposParticipantesAtividadeColetiva: {
    readonly __typename?: 'GrupoParticipanteAtividadeColetivaPayLoad'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'GrupoParticipanteAtividadeColetiva'
      readonly id: string
      readonly nome: string
      readonly tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
      readonly quantidadeIntegrantes: number
      readonly ativo: boolean
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
      readonly lotacoesEnvolvidas: ReadonlyArray<{
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
      }>
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AtividadeColetivaGruposQueryVariables = Exact<{
  atividadeColetivaGrupoId: Scalars['ID']['input']
}>

export type AtividadeColetivaGruposQuery = {
  readonly __typename?: 'Query'
  readonly grupoParticipanteAtividadeColetiva: {
    readonly __typename?: 'GrupoParticipanteAtividadeColetiva'
    readonly id: string
    readonly nome: string
    readonly tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
    readonly ativo: boolean
    readonly quantidadeIntegrantes: number
    readonly dataUltimaAtualizacao: any
    readonly dataAtualizacaoStatusAtivo: any
    readonly lotacaoAtualizacaoStatusAtivo: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    }
    readonly unidadeSaude: { readonly __typename?: 'UnidadeSaude'; readonly id: string; readonly nome?: string | null }
    readonly lotacoesEnvolvidas: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly isAD: boolean
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
    }>
    readonly cidadaosParticipantes: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
      readonly sexo: SexoEnum
      readonly faleceu?: boolean | null
      readonly unificado?: boolean | null
    }>
  }
}

export type ExcluirGrupoParticipanteAtividadeColetivaMutationVariables = Exact<{
  grupoParticipanteAtividadeColetivaId: Scalars['ID']['input']
}>

export type ExcluirGrupoParticipanteAtividadeColetivaMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirGrupoParticipanteAtividadeColetiva: string
}

export type SalvarAtividadeColetivaGruposMutationVariables = Exact<{
  input: GrupoParticipanteAtividadeColetivaInput
}>

export type SalvarAtividadeColetivaGruposMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarGrupoParticipanteAtividadeColetiva: string
}

export type UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutationVariables = Exact<{
  grupoParticipanteAtividadeColetivaId: Scalars['ID']['input']
  ativo: Scalars['Boolean']['input']
}>

export type UpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation = {
  readonly __typename?: 'Mutation'
  readonly updateStatusAtivoGrupoParticipanteAtividadeColetiva: string
}

export type AtividadeColetivaEditarReuniaoQueryVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
}>

export type AtividadeColetivaEditarReuniaoQuery = {
  readonly __typename?: 'Query'
  readonly atividadeColetiva: {
    readonly __typename?: 'AtividadeColetiva'
    readonly id: string
    readonly registroEnviado: boolean
    readonly tipoAtividade: TipoAtividadeEnum
    readonly turno: TurnoEnum
    readonly atividadeSaudePse: boolean
    readonly temasReuniao?: ReadonlyArray<TemaReuniaoEnum | null> | null
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly dataAtividade: any
    readonly numeroParticipantes: number
    readonly outraLocalidade?: string | null
    readonly anotacoes?: string | null
    readonly lotacaoResponsavel: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly email?: string | null
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly isAD: boolean
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly inepLocalAtividade?: {
      readonly __typename?: 'Inep'
      readonly id: string
      readonly dsInep: string
      readonly nomeEstabelecimento: string
    } | null
    readonly unidadeSaudeLocalAtividade?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    } | null
    readonly lotacoesEnvolvidas?: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly isAD: boolean
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
    } | null> | null
    readonly observacoes?: ReadonlyArray<{
      readonly __typename?: 'AtividadeColetivaObservacaoCidadao'
      readonly id: string
      readonly observacao: string
      readonly cidadao: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cns?: string | null
        readonly cpf?: string | null
        readonly sexo: SexoEnum
      }
    } | null> | null
  }
}

export type AtividadeColetivaVisualizarReuniaoQueryVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
}>

export type AtividadeColetivaVisualizarReuniaoQuery = {
  readonly __typename?: 'Query'
  readonly atividadeColetiva: {
    readonly __typename?: 'AtividadeColetiva'
    readonly id: string
    readonly tipoAtividade: TipoAtividadeEnum
    readonly atividadeSaudePse: boolean
    readonly turno: TurnoEnum
    readonly temasReuniao?: ReadonlyArray<TemaReuniaoEnum | null> | null
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly dataAtividade: any
    readonly numeroParticipantes: number
    readonly outraLocalidade?: string | null
    readonly anotacoes?: string | null
    readonly atividadeEducacaoPse: boolean
    readonly lotacaoResponsavel: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    }
    readonly inepLocalAtividade?: {
      readonly __typename?: 'Inep'
      readonly id: string
      readonly nomeEstabelecimento: string
      readonly dsInep: string
    } | null
    readonly unidadeSaudeLocalAtividade?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
    } | null
    readonly lotacoesEnvolvidas?: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
    } | null> | null
    readonly observacoes?: ReadonlyArray<{
      readonly __typename?: 'AtividadeColetivaObservacaoCidadao'
      readonly id: string
      readonly observacao: string
      readonly cidadao: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cns?: string | null
        readonly cpf?: string | null
        readonly sexo: SexoEnum
        readonly dataNascimento?: any | null
      }
    } | null> | null
  }
}

export type FatoAtividadeColetivaReuniaoQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type FatoAtividadeColetivaReuniaoQuery = {
  readonly __typename?: 'Query'
  readonly fatoAtividadeColetiva?: {
    readonly __typename?: 'FatoAtividadeColetiva'
    readonly nuAvaliacoesAlteradas?: number | null
    readonly temasReuniao?: ReadonlyArray<TemaReuniaoEnum | null> | null
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly stPseSaude: boolean
    readonly stPseEducacao: boolean
    readonly origem?: OrigemDadoEnum | null
    readonly id: string
    readonly dataRegistro?: any | null
    readonly nuParticipantes?: number | null
    readonly descricaoOutraLocalidade?: string | null
    readonly dimensaoInep?: {
      readonly __typename?: 'DimensaoInep'
      readonly id: string
      readonly nuIdentificador: string
      readonly noEstabelecimento?: string | null
    } | null
    readonly fatoAtividadeColetivaParticipantes?: ReadonlyArray<{
      readonly __typename?: 'FatoAtividadeColetivaParticipante'
      readonly id: string
      readonly nuCpfParticipante?: string | null
      readonly nuCnsParticipante?: string | null
      readonly dtNascimentoParticipante: any
      readonly dimensaoSexo: {
        readonly __typename?: 'DimensaoSexo'
        readonly id: string
        readonly identificador: number
      }
      readonly fatoCidadaoPec?: {
        readonly __typename?: 'FatoCidadaoPec'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly cns?: string | null
        readonly cpf?: string | null
        readonly dataNascimento?: any | null
        readonly dimensaoSexo?: {
          readonly __typename?: 'DimensaoSexo'
          readonly id: string
          readonly identificador: number
        } | null
      } | null
      readonly fatoAtividadeColetiva: { readonly __typename?: 'FatoAtividadeColetiva'; readonly id: string }
    }> | null
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
      readonly cbo: string
    } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoTipoAtividade: {
      readonly __typename?: 'DimensaoTipoAtividade'
      readonly id: string
      readonly nuIdentificador: number
    }
    readonly dimensaoTurno: { readonly __typename?: 'DimensaoTurno'; readonly id: string; readonly descricao: string }
    readonly dimensaoUnddSadeAcdmSade?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly fatoAtividadeColetivaProfissionalParticipante?: ReadonlyArray<{
      readonly __typename?: 'FatoAtividadeColetivaProfissionalParticipante'
      readonly id: string
      readonly dimensaoProfissionalParticipante?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly cns?: string | null
        readonly nome?: string | null
      } | null
      readonly dimensaoCboParticipante?: {
        readonly __typename?: 'DimensaoCbo'
        readonly id: string
        readonly nome: string
        readonly cbo: string
      } | null
    }> | null
  } | null
}

export type AtividadeColetivaEditarSaudeQueryVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
}>

export type AtividadeColetivaEditarSaudeQuery = {
  readonly __typename?: 'Query'
  readonly atividadeColetiva: {
    readonly __typename?: 'AtividadeColetiva'
    readonly id: string
    readonly tipoAtividade: TipoAtividadeEnum
    readonly turno: TurnoEnum
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly praticasSaude?: ReadonlyArray<PraticaSaudeEnum | null> | null
    readonly publicoAlvo?: ReadonlyArray<PublicoAlvoEnum | null> | null
    readonly dataAtividade: any
    readonly numeroParticipantes: number
    readonly outraLocalidade?: string | null
    readonly anotacoes?: string | null
    readonly atividadeEducacaoPse: boolean
    readonly atividadeSaudePse: boolean
    readonly registroEnviado: boolean
    readonly lotacaoResponsavel: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly email?: string | null
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly isAD: boolean
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      }
    }
    readonly inepLocalAtividade?: {
      readonly __typename?: 'Inep'
      readonly id: string
      readonly dsInep: string
      readonly nomeEstabelecimento: string
    } | null
    readonly unidadeSaudeLocalAtividade?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    } | null
    readonly procedimento?: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
    } | null
    readonly lotacoesEnvolvidas?: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly isAD: boolean
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
    } | null> | null
    readonly participantes?: ReadonlyArray<{
      readonly __typename?: 'AtividadeColetivaRegistroParticipante'
      readonly id: string
      readonly peso?: number | null
      readonly altura?: number | null
      readonly avaliacaoAlterada?: boolean | null
      readonly pnctAbandonouGrupo?: boolean | null
      readonly pnctCessouHabitoFumar?: boolean | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly dataObito?: any | null
      } | null
      readonly cidadaoParticipante?: {
        readonly __typename?: 'AtividadeColetivaCidadaoParticipante'
        readonly id: string
        readonly nome?: string | null
        readonly dataNascimento: any
        readonly sexo: SexoEnum
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly stNaoPossuiCpf?: boolean | null
        readonly justificativaNaoPossuiCpf?: JustificativaNaoPossuiCpfEnum | null
      } | null
    } | null> | null
  }
}

export type AtividadeColetivaVisualizarSaudeQueryVariables = Exact<{
  atividadeColetivaId: Scalars['Long']['input']
}>

export type AtividadeColetivaVisualizarSaudeQuery = {
  readonly __typename?: 'Query'
  readonly atividadeColetiva: {
    readonly __typename?: 'AtividadeColetiva'
    readonly id: string
    readonly tipoAtividade: TipoAtividadeEnum
    readonly turno: TurnoEnum
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly praticasSaude?: ReadonlyArray<PraticaSaudeEnum | null> | null
    readonly publicoAlvo?: ReadonlyArray<PublicoAlvoEnum | null> | null
    readonly dataAtividade: any
    readonly numeroParticipantes: number
    readonly numeroAvaliacoesAlteradas?: number | null
    readonly outraLocalidade?: string | null
    readonly anotacoes?: string | null
    readonly atividadeEducacaoPse: boolean
    readonly atividadeSaudePse: boolean
    readonly lotacaoResponsavel: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly ativo: boolean
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly nomeSocial?: string | null
        readonly id: string
        readonly nome: string
        readonly cpf: string
        readonly cns?: string | null
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    }
    readonly inepLocalAtividade?: {
      readonly __typename?: 'Inep'
      readonly id: string
      readonly nomeEstabelecimento: string
      readonly dsInep: string
    } | null
    readonly unidadeSaudeLocalAtividade?: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
    } | null
    readonly procedimento?: {
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
    } | null
    readonly lotacoesEnvolvidas?: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
    } | null> | null
    readonly participantes?: ReadonlyArray<{
      readonly __typename?: 'AtividadeColetivaRegistroParticipante'
      readonly id: string
      readonly atividadeColetivaId: any
      readonly peso?: number | null
      readonly altura?: number | null
      readonly avaliacaoAlterada?: boolean | null
      readonly pnctAbandonouGrupo?: boolean | null
      readonly pnctCessouHabitoFumar?: boolean | null
      readonly cidadaoParticipante?: {
        readonly __typename?: 'AtividadeColetivaCidadaoParticipante'
        readonly id: string
        readonly nome?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly dataNascimento: any
        readonly sexo: SexoEnum
      } | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
      } | null
    } | null> | null
  }
}

export type FatoAtividadeColetivaSaudeQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type FatoAtividadeColetivaSaudeQuery = {
  readonly __typename?: 'Query'
  readonly fatoAtividadeColetiva?: {
    readonly __typename?: 'FatoAtividadeColetiva'
    readonly nuAvaliacoesAlteradas?: number | null
    readonly temasSaude?: ReadonlyArray<TemaSaudeEnum | null> | null
    readonly praticasSaude?: ReadonlyArray<PraticaSaudeEnum | null> | null
    readonly publicoAlvo?: ReadonlyArray<PublicoAlvoEnum | null> | null
    readonly origem?: OrigemDadoEnum | null
    readonly id: string
    readonly dataRegistro?: any | null
    readonly nuParticipantes?: number | null
    readonly descricaoOutraLocalidade?: string | null
    readonly stPseEducacao: boolean
    readonly stPseSaude: boolean
    readonly dimensaoInep?: {
      readonly __typename?: 'DimensaoInep'
      readonly id: string
      readonly nuIdentificador: string
      readonly noEstabelecimento?: string | null
    } | null
    readonly dimensaoProcedimento?: {
      readonly __typename?: 'DimensaoProcedimento'
      readonly id: string
      readonly descricaoProcedimento: string
      readonly codigoProcedimento: string
    } | null
    readonly fatoAtividadeColetivaParticipantes?: ReadonlyArray<{
      readonly __typename?: 'FatoAtividadeColetivaParticipante'
      readonly id: string
      readonly stAvaliacaoAlterada?: boolean | null
      readonly nuPesoParticipante?: number | null
      readonly nuAlturaParticipante?: number | null
      readonly stPnctAbandonouGrupo?: boolean | null
      readonly stPnctCessouHabitoFumar?: boolean | null
      readonly nuCpfParticipante?: string | null
      readonly nuCnsParticipante?: string | null
      readonly dtNascimentoParticipante: any
      readonly dimensaoSexo: {
        readonly __typename?: 'DimensaoSexo'
        readonly id: string
        readonly identificador: number
      }
      readonly fatoCidadaoPec?: {
        readonly __typename?: 'FatoCidadaoPec'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly cns?: string | null
        readonly cpf?: string | null
        readonly dataNascimento?: any | null
        readonly dimensaoSexo?: {
          readonly __typename?: 'DimensaoSexo'
          readonly id: string
          readonly identificador: number
        } | null
      } | null
      readonly fatoAtividadeColetiva: { readonly __typename?: 'FatoAtividadeColetiva'; readonly id: string }
    }> | null
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly nome?: string | null
    } | null
    readonly dimensaoCbo?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
      readonly cbo: string
    } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoTipoAtividade: {
      readonly __typename?: 'DimensaoTipoAtividade'
      readonly id: string
      readonly nuIdentificador: number
    }
    readonly dimensaoTurno: { readonly __typename?: 'DimensaoTurno'; readonly id: string; readonly descricao: string }
    readonly dimensaoUnddSadeAcdmSade?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly fatoAtividadeColetivaProfissionalParticipante?: ReadonlyArray<{
      readonly __typename?: 'FatoAtividadeColetivaProfissionalParticipante'
      readonly id: string
      readonly dimensaoProfissionalParticipante?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly cns?: string | null
        readonly nome?: string | null
      } | null
      readonly dimensaoCboParticipante?: {
        readonly __typename?: 'DimensaoCbo'
        readonly id: string
        readonly nome: string
        readonly cbo: string
      } | null
    }> | null
  } | null
}

export type AuditoriaHistoricoTableQueryVariables = Exact<{
  input: AuditoriaHistoricoQueryInput
}>

export type AuditoriaHistoricoTableQuery = {
  readonly __typename?: 'Query'
  readonly auditoriaHistorico: {
    readonly __typename?: 'AuditoriaHistoricoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AuditoriaHistorico'
      readonly id: string
      readonly dataInicio: any
      readonly dataFim: any
      readonly dataSolicitacao: any
      readonly status: StatusProcessoAuditoria
      readonly csv?: boolean | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ProcessarAuditoriaMutationVariables = Exact<{
  input: AuditoriaInput
}>

export type ProcessarAuditoriaMutation = {
  readonly __typename?: 'Mutation'
  readonly processAuditoria?: boolean | null
}

export type AutorizarMunicipioConfigAgendaPadraoQueryVariables = Exact<{ [key: string]: never }>

export type AutorizarMunicipioConfigAgendaPadraoQuery = {
  readonly __typename?: 'Query'
  readonly duracaoAtendimentoPadraoMunicipio?: {
    readonly __typename?: 'DuracaoAtendimentoPadraoMunicipio'
    readonly duracaoAtendimentoPadraoMunicipio: number
  } | null
  readonly configuracaoHorariosMunicipio: {
    readonly __typename?: 'ConfiguracaoAgendaMunicipal'
    readonly id: string
    readonly configuracaoHorarioAgenda: {
      readonly __typename?: 'ConfiguracaoHorarioAgenda'
      readonly configuracaoDiasSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoDiaSemana'
        readonly diaSemana: DiaSemanaEnum
        readonly periodos?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoPeriodo'
          readonly periodo: PeriodoEnum
          readonly horarioInicial?: string | null
          readonly horarioFinal?: string | null
        }> | null
      }> | null
    }
  }
}

export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables = Exact<{
  duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput
  configuracaoAgendaMunicipalInput?: InputMaybe<ConfiguracaoAgendaMunicipalInput>
}>

export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarDuracaoPadraoAtendimento: {
    readonly __typename?: 'DuracaoAtendimentoPadraoMunicipio'
    readonly duracaoAtendimentoPadraoMunicipio: number
  }
  readonly salvarConfiguracaoHorariosMunicipio?: {
    readonly __typename?: 'ConfiguracaoAgendaMunicipal'
    readonly id: string
    readonly configuracaoHorarioAgenda: {
      readonly __typename?: 'ConfiguracaoHorarioAgenda'
      readonly configuracaoDiasSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoDiaSemana'
        readonly diaSemana: DiaSemanaEnum
        readonly periodos?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoPeriodo'
          readonly periodo: PeriodoEnum
          readonly horarioInicial?: string | null
          readonly horarioFinal?: string | null
        }> | null
      }> | null
    }
  } | null
}

export type SaveAutorizarMunicipioMutationVariables = Exact<{
  input: AutorizarMunicipioInput
}>

export type SaveAutorizarMunicipioMutation = {
  readonly __typename?: 'Mutation'
  readonly autorizarMunicipio: {
    readonly __typename?: 'AdministradorMunicipal'
    readonly id: string
    readonly autorizado: boolean
  }
}

export type AutorizarMunicipioQueryVariables = Exact<{
  acessoId: Scalars['ID']['input']
}>

export type AutorizarMunicipioQuery = {
  readonly __typename?: 'Query'
  readonly acesso:
    | {
        readonly __typename: 'AdministradorGeral'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
      }
    | {
        readonly __typename: 'AdministradorMunicipal'
        readonly autorizado: boolean
        readonly chaveMunicipio: string
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
      }
    | {
        readonly __typename: 'Estagio'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
      }
    | {
        readonly __typename: 'GestorEstadual'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
      }
    | {
        readonly __typename: 'GestorMunicipal'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
      }
    | {
        readonly __typename: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
        }
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
      }
}

export type ConcluirConfiguracaoMunicipioMutationVariables = Exact<{ [key: string]: never }>

export type ConcluirConfiguracaoMunicipioMutation = {
  readonly __typename?: 'Mutation'
  readonly concluirConfiguracaoMunicipio: {
    readonly __typename?: 'AdministradorMunicipal'
    readonly id: string
    readonly habilitado: boolean
  }
}

export type ImportacoesBolsaFamiliaQueryVariables = Exact<{
  input: ImportacaoBolsaFamiliaQueryInput
}>

export type ImportacoesBolsaFamiliaQuery = {
  readonly __typename?: 'Query'
  readonly importacoesBolsaFamilia: {
    readonly __typename?: 'ImportacaoBolsaFamiliaPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ImportacaoBolsaFamilia'
      readonly id: string
      readonly dataImportacaoInicio: any
      readonly statusImportacao: StatusImportacaoBolsaFamiliaEnum
      readonly vigencia: string
      readonly complementar: boolean
      readonly profissionalResponsavel: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
      }
      readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type VigenciaMaisRecenteBolsaFamiliaQueryVariables = Exact<{ [key: string]: never }>

export type VigenciaMaisRecenteBolsaFamiliaQuery = {
  readonly __typename?: 'Query'
  readonly vigenciaMaisRecente?: {
    readonly __typename?: 'VigenciaBolsaFamilia'
    readonly id: string
    readonly vigencia: string
  } | null
}

export type BuscaAtivaVacinacaoQueryVariables = Exact<{
  input: BuscaAtivaVacinacaoInput
}>

export type BuscaAtivaVacinacaoQuery = {
  readonly __typename?: 'Query'
  readonly buscaAtivaVacinacao: {
    readonly __typename?: 'BuscaAtivaVacinacaoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'BuscaAtivaVacinacaoDto'
      readonly id: string
      readonly cidadaoId?: string | null
      readonly nomeSocialOuNomeCidadao: string
      readonly cpfCidadao?: string | null
      readonly cnsCidadao?: string | null
      readonly dataNascimentoCidadao: any
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly endereco?: string | null
      readonly vacinasAtrasadas?: ReadonlyArray<{
        readonly __typename?: 'BuscaAtivaVacinaImuno'
        readonly cidadaoId: string
        readonly nome: string
        readonly siglaDose: string
        readonly imunobiologicoId?: any | null
        readonly doseId?: any | null
      } | null> | null
      readonly vacinasNoPrazo?: ReadonlyArray<{
        readonly __typename?: 'BuscaAtivaVacinaImuno'
        readonly cidadaoId: string
        readonly nome: string
        readonly siglaDose: string
        readonly imunobiologicoId?: any | null
        readonly doseId?: any | null
      } | null> | null
      readonly vacinasAplicadas?: ReadonlyArray<{
        readonly __typename?: 'BuscaAtivaVacinaImuno'
        readonly cidadaoId: string
        readonly nome: string
        readonly siglaDose: string
        readonly dataAplicacaoVacina?: any | null
      } | null> | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CidadaosCadastroImovelQueryVariables = Exact<{
  input: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type CidadaosCadastroImovelQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosTerritorio: ReadonlyArray<{
    readonly __typename?: 'CidadaoTerritorio'
    readonly id: string
    readonly cns?: string | null
    readonly cpf?: string | null
    readonly justificativaNaoPossuiCpf?: any | null
    readonly stNaoPossuiCpf?: boolean | null
    readonly dataNascimento?: any | null
    readonly nome?: string | null
    readonly nomeSocial?: string | null
    readonly sexo?: SexoEnum | null
    readonly telefoneCelular?: string | null
    readonly racaCorDbEnum?: RacaCorDbEnum | null
    readonly etniaId?: string | null
    readonly nomeMae?: string | null
    readonly nomePai?: string | null
    readonly desconheceNomePai?: boolean | null
    readonly desconheceNomeMae?: boolean | null
    readonly nacionalidadeDbEnum?: NacionalidadeEnum | null
    readonly paisNascimentoId?: string | null
    readonly localidadeNascimentoId?: string | null
    readonly dataNaturalizacao?: any | null
    readonly portariaNaturalizacao?: string | null
    readonly dataEntradaBrasil?: any | null
    readonly dataObito?: any | null
    readonly numeroDocumentoObito?: string | null
    readonly ufNascimentoId?: string | null
    readonly cidadaoAldeadoId?: string | null
    readonly permissaoSalvarImovel: {
      readonly __typename?: 'Action'
      readonly enabled: boolean
      readonly hint?: string | null
    }
  }>
}

export type ImoveisCadastrosDuplicadosQueryVariables = Exact<{
  input: TerritorioMicroareaQueryInput
}>

export type ImoveisCadastrosDuplicadosQuery = {
  readonly __typename?: 'Query'
  readonly territorioLogradouro: ReadonlyArray<{
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly complemento?: string | null
    readonly microarea?: string | null
    readonly numero?: string | null
    readonly logradouro?: string | null
    readonly isCadastroCompleto?: boolean | null
    readonly stAtivo: boolean
    readonly dataUltimaAtualizacao?: any | null
    readonly numeroResidenciaIndigena?: string | null
    readonly unidadeSaude: { readonly __typename?: 'UnidadeSaude'; readonly id: string; readonly nome?: string | null }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly familias: ReadonlyArray<{ readonly __typename?: 'Familia'; readonly id: string }>
    readonly poloBase?: { readonly __typename?: 'PoloBase'; readonly id: string; readonly nome: string } | null
    readonly dsei?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
  }>
}

export type ImovelCadastroQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type ImovelCadastroQuery = {
  readonly __typename?: 'Query'
  readonly imovel?: {
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly complemento?: string | null
    readonly pontoReferencia?: string | null
    readonly cep?: string | null
    readonly telefoneContato?: string | null
    readonly telefoneResidencial?: string | null
    readonly microarea?: string | null
    readonly statusRecusa?: boolean | null
    readonly numero?: string | null
    readonly semNumero?: boolean | null
    readonly bairro?: string | null
    readonly logradouro?: string | null
    readonly tipoImovel?: TipoImovelEnum | null
    readonly numeroMoradores?: number | null
    readonly nomeInstituicaoPermanencia?: string | null
    readonly possuiOutrosProfsVinculados?: boolean | null
    readonly numeroResidenciaIndigena?: string | null
    readonly statusMicroareaPoloBase?: boolean | null
    readonly stAtivo: boolean
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
      readonly endereco?: {
        readonly __typename?: 'Endereco'
        readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string } | null
      } | null
    }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly isAD: boolean
    } | null
    readonly profissional?: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly cns?: string | null
      readonly cpf: string
    } | null
    readonly cbo?: {
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
      readonly actions?: {
        readonly __typename?: 'CboActions'
        readonly cadastroDomiciliar: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly cadastroIndividual: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly atividadeColetiva: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
      } | null
    } | null
    readonly tipoLogradouro?: {
      readonly __typename?: 'TipoLogradouro'
      readonly id: string
      readonly nome: string
      readonly numeroDne: string
    } | null
    readonly uf?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
    readonly municipio?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly ibge?: string | null
    } | null
    readonly responsavelTecnico?: {
      readonly __typename?: 'ResponsavelTecnicoImovel'
      readonly id: string
      readonly nome: string
      readonly contato?: string | null
      readonly cns?: string | null
      readonly cargo?: string | null
    } | null
    readonly familias: ReadonlyArray<{
      readonly __typename?: 'Familia'
      readonly id: string
      readonly numeroProntuarioFamiliar?: string | null
      readonly numeroMembros?: number | null
      readonly rendaFamiliar?: RendaFamiliar | null
      readonly resideDesde?: any | null
      readonly cpfCnsResponsavel?: string | null
      readonly isResponsavelCadastrado: boolean
      readonly isResponsavelDeclarado: boolean
      readonly cidadaosTerritorioBasico: ReadonlyArray<{
        readonly __typename?: 'CidadaoTerritorioBasico'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly sexo?: SexoEnum | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly dataNascimento?: any | null
      }>
    }>
    readonly aldeia?: {
      readonly __typename?: 'Aldeia'
      readonly id: string
      readonly nome: string
      readonly poloBase: {
        readonly __typename?: 'PoloBase'
        readonly id: string
        readonly nome: string
        readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
      }
      readonly municipio: ReadonlyArray<{
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly ibge?: string | null
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      }>
    } | null
    readonly poloBase?: {
      readonly __typename?: 'PoloBase'
      readonly id: string
      readonly nome: string
      readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
    } | null
    readonly dsei?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
    readonly municipioAldeia?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly ibge?: string | null
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
    } | null
    readonly ufAldeia?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
    readonly condicoesMoradia: {
      readonly __typename?: 'CondicoesMoradia'
      readonly id: string
      readonly tipoAbastecimentoAgua?: TipoAbastecimentoAguaEnum | null
      readonly tipoSituacaoMoradia?: TipoSituacaoMoradiaEnum | null
      readonly tipoTratamentoAgua?: TipoTratamentoAguaEnum | null
      readonly tipoPosseTerra?: TipoPosseTerraEnum | null
      readonly tipoMaterialParede?: TipoMaterialParedeEnum | null
      readonly tipoLocalizacao?: TipoLocalizacaoEnum | null
      readonly tipoEscoamentoSanitario?: TipoEscoamentoSanitarioEnum | null
      readonly tipoDomicilio?: TipoDomicilioEnum | null
      readonly tipoDestinoLixo?: TipoDestinoLixoEnum | null
      readonly tipoAcessoDomicilio?: TipoAcessoDomicilioEnum | null
      readonly isEnergiaEletricaDisponivel?: boolean | null
      readonly tipoOrigemEnergiaEletrica?: TipoOrigemEnergiaEletricaEnum | null
      readonly numeroComodos?: number | null
    }
    readonly animaisImovel?: {
      readonly __typename?: 'AnimaisImovel'
      readonly id?: any | null
      readonly possuiAnimais?: boolean | null
      readonly possuiGato?: boolean | null
      readonly possuiCachorro?: boolean | null
      readonly possuiPassaro?: boolean | null
      readonly possuiMacaco?: boolean | null
      readonly possuiGalinha?: boolean | null
      readonly possuiPorco?: boolean | null
      readonly possuiRepteis?: boolean | null
      readonly possuiOutros?: boolean | null
      readonly quantidadeAnimais?: number | null
    } | null
  } | null
}

export type IsLotacaoActiveQueryVariables = Exact<{
  input: IsLotacaoActiveInput
}>

export type IsLotacaoActiveQuery = { readonly __typename?: 'Query'; readonly isLotacaoActive: boolean }

export type SalvarImovelMutationVariables = Exact<{
  input: ImovelInput
}>

export type SalvarImovelMutation = { readonly __typename?: 'Mutation'; readonly salvarImovel: boolean }

export type AlterarDuracaoCboMutationVariables = Exact<{
  cboDuracaoForm: CboDuracaoFormInput
}>

export type AlterarDuracaoCboMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarDuracaoCbo?: {
    readonly __typename?: 'CboMunicipio'
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string }
  } | null
}

export type DisponibilizarCboMutationVariables = Exact<{
  cboDisponibilizarForm: CboDisponibilizarFormInput
}>

export type DisponibilizarCboMutation = {
  readonly __typename?: 'Mutation'
  readonly disponibilizarCbo?: {
    readonly __typename?: 'CboMunicipio'
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string }
  } | null
}

export type CboEditComponentQueryVariables = Exact<{ [key: string]: never }>

export type CboEditComponentQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
}

export type CboTableQueryVariables = Exact<{
  input: CbosQueryInput
}>

export type CboTableQuery = {
  readonly __typename?: 'Query'
  readonly cbos: {
    readonly __typename?: 'CbosQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CboMunicipio'
      readonly disponivelLotacao?: boolean | null
      readonly duracao?: number | null
      readonly duracaoPadrao?: number | null
      readonly possuiLotacaoComAgendaOnline?: boolean | null
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly actions: {
        readonly __typename?: 'CboMunicipioActions'
        readonly inativar: { readonly __typename?: 'Action'; readonly enabled: boolean; readonly hint?: string | null }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CriarSalaUnidadeSaudeMutationVariables = Exact<{
  input: CriarSalaUnidadeSaudeInput
}>

export type CriarSalaUnidadeSaudeMutation = {
  readonly __typename?: 'Mutation'
  readonly criarSalaUnidadeSaude: { readonly __typename?: 'SalaUnidadeSaude'; readonly id: string }
}

export type DesabilitarPainelChamadasMutationVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type DesabilitarPainelChamadasMutation = {
  readonly __typename?: 'Mutation'
  readonly desabilitarPainelChamadas: boolean
}

export type DispositivosPareadosUnidadeSaudeQueryVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type DispositivosPareadosUnidadeSaudeQuery = {
  readonly __typename?: 'Query'
  readonly dispositivosPareadosUnidadeSaude: ReadonlyArray<{
    readonly __typename?: 'DispositivoPainel'
    readonly id: string
    readonly nome: string
    readonly dataPareamento: any
  }>
}

export type HabilitarPainelChamadasMutationVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type HabilitarPainelChamadasMutation = {
  readonly __typename?: 'Mutation'
  readonly habilitarPainelChamadas: boolean
}

export type IsPainelChamadasHabilitadoQueryVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type IsPainelChamadasHabilitadoQuery = {
  readonly __typename?: 'Query'
  readonly isPainelChamadasHabilitado: boolean
}

export type ParearDispositivoPainelMutationVariables = Exact<{
  input: ParearDispositivoPainelInput
}>

export type ParearDispositivoPainelMutation = {
  readonly __typename?: 'Mutation'
  readonly parearDispositivoPainel: boolean
}

export type PermissaoPainelChamadasQueryVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type PermissaoPainelChamadasQuery = {
  readonly __typename?: 'Query'
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly actions: {
      readonly __typename?: 'UnidadeSaudeActions'
      readonly permissaoPainelChamadas: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    }
  }
}

export type RemoverDispositivoPainelMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RemoverDispositivoPainelMutation = {
  readonly __typename?: 'Mutation'
  readonly removerDispositivoPainel: string
}

export type RemoverSalaUnidadeSaudeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RemoverSalaUnidadeSaudeMutation = {
  readonly __typename?: 'Mutation'
  readonly removerSalaUnidadeSaude: string
}

export type SalasUnidadeSaudeQueryVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type SalasUnidadeSaudeQuery = {
  readonly __typename?: 'Query'
  readonly salasUnidadeSaude: ReadonlyArray<{
    readonly __typename?: 'SalaUnidadeSaude'
    readonly id: string
    readonly nome: string
  }>
}

export type AtualizarContatoCidadaoMutationVariables = Exact<{
  input: AtualizarContatoCidadaoInput
}>

export type AtualizarContatoCidadaoMutation = {
  readonly __typename?: 'Mutation'
  readonly atualizarContatoCidadao: { readonly __typename?: 'ContatoCidadao'; readonly id: string }
}

export type BuscaCidadaoCadsusPollingQueryVariables = Exact<{
  uuid: Scalars['String']['input']
}>

export type BuscaCidadaoCadsusPollingQuery = {
  readonly __typename?: 'Query'
  readonly buscaCidadaosCadsusCompletoPolling?: {
    readonly __typename?: 'BuscaCidadaosCadsusResultDto'
    readonly usuario: string
    readonly uuid: string
    readonly resultCadsus?: SincronizacaoCadsusResultEnum | null
    readonly cidadaos?: ReadonlyArray<{
      readonly __typename?: 'CidadaoCadsus'
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly nomeMae?: string | null
      readonly nomePai?: string | null
      readonly telefoneContato?: ReadonlyArray<string | null> | null
      readonly telefoneResidencial?: ReadonlyArray<string | null> | null
      readonly telefoneCelular?: ReadonlyArray<string | null> | null
      readonly dataNascimento?: any | null
      readonly dataObito?: any | null
      readonly obito?: string | null
      readonly sexo?: SexoEnum | null
      readonly email?: string | null
      readonly portariaNaturalizacao?: string | null
      readonly dataEntradaBrasil?: any | null
      readonly dataNaturalizacao?: any | null
      readonly municipioResidenciaExterior?: string | null
      readonly numeroPisPasep?: string | null
      readonly cpfOuCnsJaCadastradoBaseLocal?: boolean | null
      readonly racaCor?: {
        readonly __typename?: 'RacaCor'
        readonly id: string
        readonly nome: string
        readonly racaCorDbEnum: RacaCorDbEnum
      } | null
      readonly etnia?: { readonly __typename?: 'Etnia'; readonly id: string; readonly nome: string } | null
      readonly nacionalidade?: {
        readonly __typename?: 'Nacionalidade'
        readonly id: string
        readonly nacionalidadeDbEnum: NacionalidadeEnum
      } | null
      readonly municipioNascimento?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly ibge?: string | null
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly paisNascimento?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
      readonly endereco?: {
        readonly __typename?: 'Endereco'
        readonly bairro?: string | null
        readonly cep?: string | null
        readonly complemento?: string | null
        readonly logradouro?: string | null
        readonly numero?: string | null
        readonly pontoReferencia?: string | null
        readonly semNumero?: boolean | null
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly ibge?: string | null
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
        readonly tipoLogradouro?: {
          readonly __typename?: 'TipoLogradouro'
          readonly id: string
          readonly nome: string
          readonly numeroDne: string
        } | null
        readonly uf?: {
          readonly __typename?: 'UF'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        } | null
      } | null
      readonly paisResidencia?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    } | null> | null
  } | null
}

export type BuscaCidadaoCadsusQueryVariables = Exact<{
  filter: BuscaListaCidadaoCadsusInput
}>

export type BuscaCidadaoCadsusQuery = { readonly __typename?: 'Query'; readonly buscaCidadaosCadsus: string }

export type BuscaDetailCidadaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type BuscaDetailCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nisPisPasep?: string | null
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly dataNascimento?: any | null
    readonly dataAtualizado?: any | null
    readonly dataObito?: any | null
    readonly numeroDocumentoObito?: string | null
    readonly sexo: SexoEnum
    readonly nomeMae?: string | null
    readonly nomePai?: string | null
    readonly telefoneResidencial?: string | null
    readonly telefoneCelular?: string | null
    readonly telefoneContato?: string | null
    readonly email?: string | null
    readonly area?: string | null
    readonly microArea?: string | null
    readonly localidadeExterior?: string | null
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly ativo?: boolean | null
    readonly faleceu?: boolean | null
    readonly possuiAgendamento?: boolean | null
    readonly unificado?: boolean | null
    readonly unificacaoBase?: string | null
    readonly tipoSanguineoEnum?: TipoSanguineoEnum | null
    readonly orientacaoSexualDbEnum?: OrientacaoSexualEnum | null
    readonly portariaNaturalizacao?: string | null
    readonly dataNaturalizacao?: any | null
    readonly dataEntradaBrasil?: any | null
    readonly stCompartilhaProntuario?: boolean | null
    readonly numeroFamilia?: string | null
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly tipoLocalNascimento?: TipoLocalNascimentoEnum | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly cep?: string | null
      readonly bairro?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly semNumero?: boolean | null
      readonly complemento?: string | null
      readonly pontoReferencia?: string | null
      readonly uf?: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string } | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
      } | null
    } | null
    readonly prontuario?: {
      readonly __typename?: 'Prontuario'
      readonly id: string
      readonly puerpera?: boolean | null
      readonly gestacoes?: ReadonlyArray<{
        readonly __typename?: 'PeriodoGestacao'
        readonly id: string
        readonly inicio: any
        readonly fim?: any | null
      }> | null
      readonly preNatalAtivo?: {
        readonly __typename?: 'PreNatal'
        readonly id: string
        readonly altoRisco: boolean
        readonly gravidezPlanejada?: boolean | null
        readonly ultimaDum?: any | null
        readonly tipoGravidez?: {
          readonly __typename?: 'TipoGravidez'
          readonly id: string
          readonly descricao?: string | null
        } | null
      } | null
    } | null
    readonly etnia?: { readonly __typename?: 'Etnia'; readonly id: string; readonly nome: string } | null
    readonly racaCor: {
      readonly __typename?: 'RacaCor'
      readonly id: string
      readonly nome: string
      readonly racaCorDbEnum: RacaCorDbEnum
    }
    readonly cbo?: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string } | null
    readonly escolaridade?: { readonly __typename?: 'Escolaridade'; readonly id: string; readonly nome: string } | null
    readonly localidadeNascimento?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
    } | null
    readonly cidadaoVinculacaoEquipe?: {
      readonly __typename?: 'CidadaoVinculacaoEquipe'
      readonly id?: string | null
      readonly tpCdsOrigem?: CdsOrigemEnum | null
      readonly utilizarCadastroIndividual?: boolean | null
      readonly unidadeSaude?: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
    readonly estadoCivil?: { readonly __typename?: 'EstadoCivil'; readonly id: string; readonly nome: string } | null
    readonly paisExterior?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    readonly nacionalidade?: {
      readonly __typename?: 'Nacionalidade'
      readonly id: string
      readonly nacionalidadeDbEnum: NacionalidadeEnum
    } | null
    readonly paisNascimento?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    readonly periodoAusenciaList?: ReadonlyArray<{
      readonly __typename?: 'PeriodoAusencia'
      readonly id: string
      readonly dtAusencia: any
      readonly dtRetorno?: any | null
    } | null> | null
    readonly cidadaoAldeado?: {
      readonly __typename?: 'CidadaoAldeado'
      readonly id: string
      readonly beneficios?: ReadonlyArray<BeneficioDbEnum | null> | null
      readonly nomeTradicional?: string | null
      readonly responsavelLegal?: string | null
      readonly stChefeFamilia: boolean
      readonly unidadeFunai?: string | null
      readonly livro?: number | null
      readonly folha?: number | null
      readonly cadastroUnico?: string | null
      readonly dtEmissao?: any | null
      readonly dtReconhecimento?: any | null
      readonly aldeiaNascimento?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
      readonly funcaoSocial?: {
        readonly __typename?: 'FuncaoSocial'
        readonly id: string
        readonly nome: string
      } | null
      readonly localOcorrencia?: {
        readonly __typename?: 'LocalOcorrencia'
        readonly id: string
        readonly nome: string
      } | null
      readonly ufNascimento?: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string } | null
    } | null
    readonly enderecoIndigena?: {
      readonly __typename?: 'EnderecoIndigena'
      readonly numero?: string | null
      readonly aldeiaResidencia?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
      readonly poloBaseResidencia?: {
        readonly __typename?: 'PoloBase'
        readonly id: string
        readonly nome: string
      } | null
      readonly dseiResidencia?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
      readonly uf?: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string } | null
    } | null
  }
}

export type CidadaoAtualizacaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoAtualizacaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly stNaoPossuiCpf?: boolean | null
    readonly justificativaNaoPossuiCpf?: JustificativaNaoPossuiCpfEnum | null
    readonly numeroDnv?: string | null
    readonly nisPisPasep?: string | null
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly faleceu?: boolean | null
    readonly dataObito?: any | null
    readonly numeroDocumentoObito?: string | null
    readonly microArea?: string | null
    readonly statusForaArea?: boolean | null
    readonly tipoSanguineoEnum?: TipoSanguineoEnum | null
    readonly nomeMae?: string | null
    readonly desconheceNomeMae?: boolean | null
    readonly nomePai?: string | null
    readonly desconheceNomePai?: boolean | null
    readonly desejaInformarIdentidadeGenero?: boolean | null
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly desejaInformarOrientacaoSexual?: boolean | null
    readonly orientacaoSexualDbEnum?: OrientacaoSexualEnum | null
    readonly portariaNaturalizacao?: string | null
    readonly dataNaturalizacao?: any | null
    readonly dataEntradaBrasil?: any | null
    readonly telefoneResidencial?: string | null
    readonly telefoneCelular?: string | null
    readonly telefoneContato?: string | null
    readonly email?: string | null
    readonly localidadeExterior?: string | null
    readonly stCompartilhaProntuario?: boolean | null
    readonly tipoLocalNascimento?: TipoLocalNascimentoEnum | null
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly numeroFamilia?: string | null
    readonly isCpfCadsus?: boolean | null
    readonly stRegistroCadsus?: boolean | null
    readonly cidadaoNucleoFamiliar?: {
      readonly __typename?: 'CidadaoNucleoFamiliar'
      readonly id: string
      readonly mudouSe?: boolean | null
      readonly isResponsavel?: boolean | null
      readonly cpfCnsResponsavel?: string | null
      readonly grauParentescoResponsavelFamiliar?: GrauParentescoEnum | null
      readonly unidadeSaude?: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipo: { readonly __typename?: 'TipoUnidadeSaude'; readonly id: string; readonly isTipoAps: boolean }
        readonly endereco?: {
          readonly __typename?: 'Endereco'
          readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string } | null
        } | null
      } | null
      readonly profissional?: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
        readonly cns?: string | null
      } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
        readonly isAD: boolean
      } | null
      readonly cbo?: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
        readonly actions?: {
          readonly __typename?: 'CboActions'
          readonly cadastroDomiciliar: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly cadastroIndividual: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
          readonly atividadeColetiva: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          }
        } | null
      } | null
      readonly responsavelFamiliar?: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly uuidUltimaFicha?: string | null
        readonly statusResponsavelFamiliar?: boolean | null
      } | null
    } | null
    readonly escolaridade?: { readonly __typename?: 'Escolaridade'; readonly id: string; readonly nome: string } | null
    readonly estadoCivil?: { readonly __typename?: 'EstadoCivil'; readonly id: string; readonly nome: string } | null
    readonly racaCor: {
      readonly __typename?: 'RacaCor'
      readonly id: string
      readonly nome: string
      readonly racaCorDbEnum: RacaCorDbEnum
    }
    readonly etnia?: { readonly __typename?: 'Etnia'; readonly id: string; readonly nome: string } | null
    readonly nacionalidade?: {
      readonly __typename?: 'Nacionalidade'
      readonly id: string
      readonly nacionalidadeDbEnum: NacionalidadeEnum
    } | null
    readonly localidadeNascimento?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly ibge?: string | null
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
    } | null
    readonly paisNascimento?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly bairro?: string | null
      readonly cep?: string | null
      readonly complemento?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly pontoReferencia?: string | null
      readonly semNumero?: boolean | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
      } | null
      readonly uf?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly paisExterior?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    readonly informacoesSocioEconomicas?: {
      readonly __typename?: 'InformacoesSocioEconomicas'
      readonly id: string
      readonly statusAlimentosAcabaramAntesTerDinheiroComprarMais?: boolean | null
      readonly statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou?: boolean | null
    } | null
    readonly informacoesSociodemograficas?: {
      readonly __typename?: 'InformacoesSociodemograficas'
      readonly id: string
      readonly frequentaEscolaOuCreche?: boolean | null
      readonly criancas0a9anosComQuemFica?: ReadonlyArray<Criancas0a9AnosComQuemFicaEnum> | null
      readonly situacaoMercadoTrabalho?: SituacaoMercadoTrabalhoEnum | null
      readonly possuiPlanoSaudePrivado?: boolean | null
      readonly frequentaCuidadorTradicional?: boolean | null
      readonly participaAlgumGrupoComunitario?: boolean | null
      readonly isMembroComunidadeTradicional?: boolean | null
      readonly povoComunidadeTradicional?: PovoComunidadeTradicionalEnum | null
      readonly possuiDeficiencia?: boolean | null
      readonly deficiencias?: ReadonlyArray<DeficienciaEnum> | null
      readonly isAtendimentoSocioeducativo?: boolean | null
      readonly tipoAtendimentoSocioeducativo?: TipoAtendimentoCidadaoEnum | null
      readonly tempoAtendimentoSocioeducativo?: TempoAtendimentoSocioeducativoCidadaoEnum | null
    } | null
    readonly cbo?: {
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
    } | null
    readonly condicoesSaudeAutorreferidas?: {
      readonly __typename?: 'CondicoesSaudeAutorreferidas'
      readonly id: string
      readonly stGestante?: boolean | null
      readonly maternidadeReferencia?: string | null
      readonly autodenominacaoPeso?: PesoAutorreferidoEnum | null
      readonly stAcamado?: boolean | null
      readonly stDomiciliar?: boolean | null
      readonly stFumante?: boolean | null
      readonly stUsoAlcool?: boolean | null
      readonly stUsoOutrasDrogas?: boolean | null
      readonly stPraticasComplementares?: boolean | null
      readonly stProblemaSaudeMental?: boolean | null
      readonly stHipertensaoArterial?: boolean | null
      readonly stDiabetes?: boolean | null
      readonly stCancer?: boolean | null
      readonly stDerrame?: boolean | null
      readonly stInfarto?: boolean | null
      readonly stHanseniase?: boolean | null
      readonly stTuberculose?: boolean | null
      readonly stDoencaCardiaca?: boolean | null
      readonly doencaCardiaca?: ReadonlyArray<DoencaCardiacaAutorreferidoEnum> | null
      readonly stProblemaRins?: boolean | null
      readonly doencaRins?: ReadonlyArray<DoencaRinsAutorreferidoEnum> | null
      readonly stDoencaRespiratoria?: boolean | null
      readonly doencasRespiratorias?: ReadonlyArray<DoencaRespiratoriaAutorreferidoEnum> | null
      readonly stInternacaoUltimos12Meses?: boolean | null
      readonly causaInternacaoUltimos12Meses?: string | null
      readonly stPlantasMedicinais?: boolean | null
      readonly plantasMedicinais?: string | null
      readonly condicaoSaude1?: string | null
      readonly condicaoSaude2?: string | null
      readonly condicaoSaude3?: string | null
    } | null
    readonly situacaoDeRua?: {
      readonly __typename?: 'SituacaoDeRua'
      readonly id: string
      readonly stSituacaoDeRua?: boolean | null
      readonly tempoSituacaoDeRua?: TempoSituacaoDeRuaEnum | null
      readonly recebeAlgumBeneficio?: boolean | null
      readonly possuiReferenciaFamiliar?: boolean | null
      readonly quantidadeAlimentacaoDiaria?: QuantidadeAlimentacaoDiariaEnum | null
      readonly origemAlimentacao?: ReadonlyArray<OrigemAlimentacaoEnum> | null
      readonly stAcompanhadoOutraInstituicao?: boolean | null
      readonly instituicaoAcompanhamento?: string | null
      readonly stAcessoHigienePessoal?: boolean | null
      readonly higienePessoal?: ReadonlyArray<HigienePessoalEnum> | null
      readonly stVisitaFamiliarComFrequencia?: boolean | null
      readonly grauParentescoVisitaFamiliar?: string | null
    } | null
    readonly cidadaoAldeado?: {
      readonly __typename?: 'CidadaoAldeado'
      readonly id: string
      readonly nomeTradicional?: string | null
      readonly responsavelLegal?: string | null
      readonly stChefeFamilia: boolean
      readonly dtReconhecimento?: any | null
      readonly unidadeFunai?: string | null
      readonly livro?: number | null
      readonly folha?: number | null
      readonly cadastroUnico?: string | null
      readonly dtEmissao?: any | null
      readonly beneficios?: ReadonlyArray<BeneficioDbEnum | null> | null
      readonly aldeiaNascimento?: {
        readonly __typename?: 'Aldeia'
        readonly id: string
        readonly nome: string
        readonly poloBase: {
          readonly __typename?: 'PoloBase'
          readonly id: string
          readonly nome: string
          readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
        }
        readonly municipio: ReadonlyArray<{
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }>
      } | null
      readonly funcaoSocial?: {
        readonly __typename?: 'FuncaoSocial'
        readonly id: string
        readonly nome: string
      } | null
      readonly localOcorrencia?: {
        readonly __typename?: 'LocalOcorrencia'
        readonly id: string
        readonly nome: string
      } | null
      readonly ufNascimento?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly enderecoIndigena?: {
      readonly __typename?: 'EnderecoIndigena'
      readonly numero?: string | null
      readonly dseiResidencia?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
      readonly poloBaseResidencia?: {
        readonly __typename?: 'PoloBase'
        readonly id: string
        readonly nome: string
      } | null
      readonly aldeiaResidencia?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
      readonly uf?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly periodoAusenciaList?: ReadonlyArray<{
      readonly __typename?: 'PeriodoAusencia'
      readonly id: string
      readonly dtAusencia: any
      readonly dtRetorno?: any | null
    } | null> | null
  }
}

export type CidadaoBuscaCpfCnsDnvNisQueryVariables = Exact<{
  filtro: FiltroDocumentosCidadaoInput
}>

export type CidadaoBuscaCpfCnsDnvNisQuery = {
  readonly __typename?: 'Query'
  readonly cidadaosByDocumentos: ReadonlyArray<{
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly numeroDnv?: string | null
    readonly nisPisPasep?: string | null
    readonly sexo: SexoEnum
    readonly dataNascimento?: any | null
    readonly nomeMae?: string | null
    readonly dataAtualizado?: any | null
    readonly localidadeNascimento?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
    } | null
    readonly cidadaoVinculacaoEquipe?: {
      readonly __typename?: 'CidadaoVinculacaoEquipe'
      readonly id?: string | null
      readonly unidadeSaude?: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
    } | null
  }>
}

export type CidadaoEditQueryVariables = Exact<{
  input: BuscaCidadaoCadsusInput
}>

export type CidadaoEditQuery = { readonly __typename?: 'Query'; readonly buscaCidadaoCadsusAtualizado: string }

export type CidadaoListingQueryVariables = Exact<{
  filtro: CidadaosQueryInput
}>

export type CidadaoListingQuery = {
  readonly __typename?: 'Query'
  readonly cidadaos: {
    readonly __typename?: 'CidadaosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nomeMae?: string | null
      readonly dataNascimento?: any | null
      readonly telefoneCelular?: string | null
      readonly telefoneResidencial?: string | null
      readonly sexo: SexoEnum
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly dataAtualizado?: any | null
      readonly ativo?: boolean | null
      readonly unificado?: boolean | null
      readonly unificacaoBase?: string | null
      readonly possuiAgendamento?: boolean | null
      readonly faleceu?: boolean | null
      readonly prontuario?: { readonly __typename?: 'Prontuario'; readonly id: string } | null
      readonly localidadeNascimento?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly cidadaoVinculacaoEquipe?: {
        readonly __typename?: 'CidadaoVinculacaoEquipe'
        readonly id?: string | null
        readonly unidadeSaude?: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        } | null
      } | null
      readonly enderecoIndigena?: {
        readonly __typename?: 'EnderecoIndigena'
        readonly aldeiaResidencia?: {
          readonly __typename?: 'Aldeia'
          readonly id: string
          readonly nome: string
        } | null
        readonly poloBaseResidencia?: {
          readonly __typename?: 'PoloBase'
          readonly id: string
          readonly nome: string
        } | null
        readonly dseiResidencia?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
      } | null
      readonly cidadaoAldeado?: {
        readonly __typename?: 'CidadaoAldeado'
        readonly id: string
        readonly nomeTradicional?: string | null
      } | null
    } | null>
  }
}

export type CidadaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly faleceu?: boolean | null
    readonly isCidadaoAusente?: boolean | null
  }
}

export type CidadaoVisualizacaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CidadaoVisualizacaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly justificativaNaoPossuiCpf?: JustificativaNaoPossuiCpfEnum | null
    readonly numeroDnv?: string | null
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly microArea?: string | null
    readonly nomeMae?: string | null
    readonly desconheceNomeMae?: boolean | null
    readonly nomePai?: string | null
    readonly desconheceNomePai?: boolean | null
    readonly portariaNaturalizacao?: string | null
    readonly dataNaturalizacao?: any | null
    readonly dataEntradaBrasil?: any | null
    readonly tipoSanguineoEnum?: TipoSanguineoEnum | null
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly orientacaoSexualDbEnum?: OrientacaoSexualEnum | null
    readonly nisPisPasep?: string | null
    readonly telefoneResidencial?: string | null
    readonly telefoneCelular?: string | null
    readonly telefoneContato?: string | null
    readonly email?: string | null
    readonly dataUltimaRecusa?: any | null
    readonly dataObito?: any | null
    readonly numeroDocumentoObito?: string | null
    readonly localidadeExterior?: string | null
    readonly stCompartilhaProntuario?: boolean | null
    readonly tipoLocalNascimento?: TipoLocalNascimentoEnum | null
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly numeroFamilia?: string | null
    readonly cidadaoNucleoFamiliar?: {
      readonly __typename?: 'CidadaoNucleoFamiliar'
      readonly id: string
      readonly cpfCnsResponsavel?: string | null
      readonly mudouSe?: boolean | null
      readonly grauParentescoResponsavelFamiliar?: GrauParentescoEnum | null
      readonly isResponsavel?: boolean | null
      readonly responsavelFamiliar?: {
        readonly __typename?: 'CidadaoBasico'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      } | null
      readonly unidadeSaude?: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly tipo: { readonly __typename?: 'TipoUnidadeSaude'; readonly id: string; readonly isTipoAps: boolean }
      } | null
      readonly profissional?: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly cbo?: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      } | null
    } | null
    readonly racaCor: {
      readonly __typename?: 'RacaCor'
      readonly id: string
      readonly nome: string
      readonly racaCorDbEnum: RacaCorDbEnum
    }
    readonly etnia?: { readonly __typename?: 'Etnia'; readonly id: string; readonly nome: string } | null
    readonly nacionalidade?: {
      readonly __typename?: 'Nacionalidade'
      readonly id: string
      readonly nacionalidadeDbEnum: NacionalidadeEnum
    } | null
    readonly localidadeNascimento?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
    } | null
    readonly paisNascimento?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    readonly escolaridade?: { readonly __typename?: 'Escolaridade'; readonly id: string; readonly nome: string } | null
    readonly cbo?: {
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
    } | null
    readonly informacoesSociodemograficas?: {
      readonly __typename?: 'InformacoesSociodemograficas'
      readonly id: string
      readonly frequentaEscolaOuCreche?: boolean | null
      readonly criancas0a9anosComQuemFica?: ReadonlyArray<Criancas0a9AnosComQuemFicaEnum> | null
      readonly situacaoMercadoTrabalho?: SituacaoMercadoTrabalhoEnum | null
      readonly possuiPlanoSaudePrivado?: boolean | null
      readonly frequentaCuidadorTradicional?: boolean | null
      readonly participaAlgumGrupoComunitario?: boolean | null
      readonly isMembroComunidadeTradicional?: boolean | null
      readonly povoComunidadeTradicional?: PovoComunidadeTradicionalEnum | null
      readonly possuiDeficiencia?: boolean | null
      readonly deficiencias?: ReadonlyArray<DeficienciaEnum> | null
      readonly isAtendimentoSocioeducativo?: boolean | null
      readonly tipoAtendimentoSocioeducativo?: TipoAtendimentoCidadaoEnum | null
      readonly tempoAtendimentoSocioeducativo?: TempoAtendimentoSocioeducativoCidadaoEnum | null
    } | null
    readonly informacoesSocioEconomicas?: {
      readonly __typename?: 'InformacoesSocioEconomicas'
      readonly id: string
      readonly statusAlimentosAcabaramAntesTerDinheiroComprarMais?: boolean | null
      readonly statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou?: boolean | null
    } | null
    readonly estadoCivil?: { readonly __typename?: 'EstadoCivil'; readonly id: string; readonly nome: string } | null
    readonly condicoesSaudeAutorreferidas?: {
      readonly __typename?: 'CondicoesSaudeAutorreferidas'
      readonly id: string
      readonly stGestante?: boolean | null
      readonly maternidadeReferencia?: string | null
      readonly autodenominacaoPeso?: PesoAutorreferidoEnum | null
      readonly stAcamado?: boolean | null
      readonly stDomiciliar?: boolean | null
      readonly stFumante?: boolean | null
      readonly stUsoAlcool?: boolean | null
      readonly stUsoOutrasDrogas?: boolean | null
      readonly stPraticasComplementares?: boolean | null
      readonly stProblemaSaudeMental?: boolean | null
      readonly stHipertensaoArterial?: boolean | null
      readonly stDiabetes?: boolean | null
      readonly stCancer?: boolean | null
      readonly stDerrame?: boolean | null
      readonly stInfarto?: boolean | null
      readonly stHanseniase?: boolean | null
      readonly stTuberculose?: boolean | null
      readonly stDoencaCardiaca?: boolean | null
      readonly doencaCardiaca?: ReadonlyArray<DoencaCardiacaAutorreferidoEnum> | null
      readonly stProblemaRins?: boolean | null
      readonly doencaRins?: ReadonlyArray<DoencaRinsAutorreferidoEnum> | null
      readonly stDoencaRespiratoria?: boolean | null
      readonly doencasRespiratorias?: ReadonlyArray<DoencaRespiratoriaAutorreferidoEnum> | null
      readonly stInternacaoUltimos12Meses?: boolean | null
      readonly causaInternacaoUltimos12Meses?: string | null
      readonly stPlantasMedicinais?: boolean | null
      readonly plantasMedicinais?: string | null
      readonly condicaoSaude1?: string | null
      readonly condicaoSaude2?: string | null
      readonly condicaoSaude3?: string | null
    } | null
    readonly situacaoDeRua?: {
      readonly __typename?: 'SituacaoDeRua'
      readonly id: string
      readonly stSituacaoDeRua?: boolean | null
      readonly tempoSituacaoDeRua?: TempoSituacaoDeRuaEnum | null
      readonly recebeAlgumBeneficio?: boolean | null
      readonly possuiReferenciaFamiliar?: boolean | null
      readonly quantidadeAlimentacaoDiaria?: QuantidadeAlimentacaoDiariaEnum | null
      readonly origemAlimentacao?: ReadonlyArray<OrigemAlimentacaoEnum> | null
      readonly stAcompanhadoOutraInstituicao?: boolean | null
      readonly instituicaoAcompanhamento?: string | null
      readonly stAcessoHigienePessoal?: boolean | null
      readonly higienePessoal?: ReadonlyArray<HigienePessoalEnum> | null
      readonly stVisitaFamiliarComFrequencia?: boolean | null
      readonly grauParentescoVisitaFamiliar?: string | null
    } | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly bairro?: string | null
      readonly cep?: string | null
      readonly complemento?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly pontoReferencia?: string | null
      readonly semNumero?: boolean | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
      } | null
      readonly uf?: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string } | null
    } | null
    readonly paisExterior?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
    readonly cidadaoAldeado?: {
      readonly __typename?: 'CidadaoAldeado'
      readonly id: string
      readonly nomeTradicional?: string | null
      readonly responsavelLegal?: string | null
      readonly stChefeFamilia: boolean
      readonly dtReconhecimento?: any | null
      readonly unidadeFunai?: string | null
      readonly livro?: number | null
      readonly folha?: number | null
      readonly cadastroUnico?: string | null
      readonly dtEmissao?: any | null
      readonly beneficios?: ReadonlyArray<BeneficioDbEnum | null> | null
      readonly aldeiaNascimento?: {
        readonly __typename?: 'Aldeia'
        readonly id: string
        readonly nome: string
        readonly poloBase: { readonly __typename?: 'PoloBase'; readonly id: string; readonly nome: string }
        readonly municipio: ReadonlyArray<{
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }>
      } | null
      readonly funcaoSocial?: {
        readonly __typename?: 'FuncaoSocial'
        readonly id: string
        readonly nome: string
      } | null
      readonly localOcorrencia?: {
        readonly __typename?: 'LocalOcorrencia'
        readonly id: string
        readonly nome: string
      } | null
      readonly ufNascimento?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly enderecoIndigena?: {
      readonly __typename?: 'EnderecoIndigena'
      readonly numero?: string | null
      readonly dseiResidencia?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
      readonly poloBaseResidencia?: {
        readonly __typename?: 'PoloBase'
        readonly id: string
        readonly nome: string
      } | null
      readonly aldeiaResidencia?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string } | null
      readonly uf?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly periodoAusenciaList?: ReadonlyArray<{
      readonly __typename?: 'PeriodoAusencia'
      readonly id: string
      readonly dtAusencia: any
      readonly dtRetorno?: any | null
    } | null> | null
  }
}

export type CondicoesAutorreferidasQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type CondicoesAutorreferidasQuery = {
  readonly __typename?: 'Query'
  readonly condicoesAutorreferidas: ReadonlyArray<{
    readonly __typename?: 'CondicaoAutorreferida'
    readonly descricao: string
  } | null>
}

export type ConfiguracaoCadsusQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoCadsusQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
    readonly cadsus: { readonly __typename?: 'ConfiguracaoCadsus'; readonly id: string; readonly habilitado: boolean }
  }
  readonly configuracaoCertificadoHabilitado?: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly cadsusHabilitado: boolean
  } | null
}

export type ConfiguracaoCertificadoQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoCertificadoQuery = {
  readonly __typename?: 'Query'
  readonly configuracaoCertificadoHabilitado?: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly cadsusHabilitado: boolean
  } | null
}

export type CreateCidadaoCadsusMutationVariables = Exact<{
  input: SincronizaCidadaoCadsusInput
}>

export type CreateCidadaoCadsusMutation = { readonly __typename?: 'Mutation'; readonly createCidadaoCadsus: string }

export type ExcluirCidadaoMutationVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type ExcluirCidadaoMutation = { readonly __typename?: 'Mutation'; readonly excluirCidadao: string }

export type ForcaAtualizacaoCidadaoCadsusQueryVariables = Exact<{
  input: BuscaCidadaoCadsusInput
}>

export type ForcaAtualizacaoCidadaoCadsusQuery = {
  readonly __typename?: 'Query'
  readonly buscaCidadaoCadsusAtualizadoForcado: string
}

export type HasCidadaoAgendamentoFuturoQueryVariables = Exact<{
  input: CidadaoPossuiAgendamentoFuturoQueryInput
}>

export type HasCidadaoAgendamentoFuturoQuery = {
  readonly __typename?: 'Query'
  readonly hasAgendamentoFuturo?: boolean | null
}

export type IsCidadaoPresenteOutroAtendimentoNaListaQueryVariables = Exact<{
  input: CidadaoPresenteOutroAtendimentoNaListaQueryInput
}>

export type IsCidadaoPresenteOutroAtendimentoNaListaQuery = {
  readonly __typename?: 'Query'
  readonly presenteOutroAtendimentoNaLista?: boolean | null
}

export type ReativarCidadaoMutationVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type ReativarCidadaoMutation = {
  readonly __typename?: 'Mutation'
  readonly reativarCidadao: { readonly __typename?: 'Cidadao'; readonly id: string }
}

export type RecusarCadastroCidadaoMutationVariables = Exact<{
  cidadaoId?: InputMaybe<Scalars['ID']['input']>
}>

export type RecusarCadastroCidadaoMutation = { readonly __typename?: 'Mutation'; readonly recusarCadastro: boolean }

export type SalvarCidadaoMutationVariables = Exact<{
  input: CidadaoInput
}>

export type SalvarCidadaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarCidadao: { readonly __typename?: 'Cidadao'; readonly id: string; readonly cns?: string | null }
}

export type SincronizaCidadaoCadsusPollingQueryVariables = Exact<{
  uuid: Scalars['String']['input']
}>

export type SincronizaCidadaoCadsusPollingQuery = {
  readonly __typename?: 'Query'
  readonly sincronizacaoCadsusPolling?: {
    readonly __typename?: 'SincronizacaoCadsusResultDto'
    readonly result?: SincronizacaoCadsusResultEnum | null
    readonly errors?: ReadonlyArray<string | null> | null
    readonly uuid: string
    readonly camposAlterados?: ReadonlyArray<{
      readonly __typename?: 'CampoAlteradoCadsus'
      readonly campo?: string | null
      readonly conteudo?: string | null
    } | null> | null
    readonly cidadaoCadsus?: {
      readonly __typename?: 'CidadaoCadsus'
      readonly cns?: string | null
      readonly cpf?: string | null
    } | null
    readonly cidadaosDuplicados?: ReadonlyArray<{
      readonly __typename?: 'CidadaoDuplicadoDto'
      readonly id?: string | null
      readonly nome?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
    } | null> | null
    readonly cidadaoLocal?: {
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nisPisPasep?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
      readonly dataObito?: any | null
      readonly numeroDocumentoObito?: string | null
      readonly sexo: SexoEnum
      readonly desconheceNomeMae?: boolean | null
      readonly nomeMae?: string | null
      readonly desconheceNomePai?: boolean | null
      readonly nomePai?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly email?: string | null
      readonly area?: string | null
      readonly microArea?: string | null
      readonly statusForaArea?: boolean | null
      readonly faleceu?: boolean | null
      readonly tipoSanguineoEnum?: TipoSanguineoEnum | null
      readonly desejaInformarIdentidadeGenero?: boolean | null
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly desejaInformarOrientacaoSexual?: boolean | null
      readonly orientacaoSexualDbEnum?: OrientacaoSexualEnum | null
      readonly localidadeExterior?: string | null
      readonly portariaNaturalizacao?: string | null
      readonly dataNaturalizacao?: any | null
      readonly dataEntradaBrasil?: any | null
      readonly stCompartilhaProntuario?: boolean | null
      readonly uuidUltimaFicha?: string | null
      readonly numeroFamilia?: string | null
      readonly tipoEndereco?: TipoEnderecoEnum | null
      readonly tipoLocalNascimento?: TipoLocalNascimentoEnum | null
      readonly stRegistroCadsus?: boolean | null
      readonly isCpfCadsus?: boolean | null
      readonly endereco?: {
        readonly __typename?: 'Endereco'
        readonly bairro?: string | null
        readonly cep?: string | null
        readonly complemento?: string | null
        readonly logradouro?: string | null
        readonly numero?: string | null
        readonly pontoReferencia?: string | null
        readonly semNumero?: boolean | null
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly ibge?: string | null
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
        readonly tipoLogradouro?: {
          readonly __typename?: 'TipoLogradouro'
          readonly id: string
          readonly nome: string
          readonly numeroDne: string
        } | null
        readonly uf?: {
          readonly __typename?: 'UF'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        } | null
      } | null
      readonly etnia?: { readonly __typename?: 'Etnia'; readonly id: string; readonly nome: string } | null
      readonly racaCor: {
        readonly __typename?: 'RacaCor'
        readonly id: string
        readonly nome: string
        readonly racaCorDbEnum: RacaCorDbEnum
      }
      readonly cbo?: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      } | null
      readonly escolaridade?: {
        readonly __typename?: 'Escolaridade'
        readonly id: string
        readonly nome: string
      } | null
      readonly localidadeNascimento?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly estadoCivil?: { readonly __typename?: 'EstadoCivil'; readonly id: string; readonly nome: string } | null
      readonly paisExterior?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
      readonly nacionalidade?: {
        readonly __typename?: 'Nacionalidade'
        readonly id: string
        readonly nacionalidadeDbEnum: NacionalidadeEnum
      } | null
      readonly paisNascimento?: { readonly __typename?: 'Pais'; readonly id: string; readonly nome: string } | null
      readonly cidadaoVinculacaoEquipe?: {
        readonly __typename?: 'CidadaoVinculacaoEquipe'
        readonly id?: string | null
        readonly utilizarCadastroIndividual?: boolean | null
        readonly unidadeSaude?: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        } | null
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
          readonly tipoEquipe: {
            readonly __typename?: 'TipoEquipe'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
      } | null
      readonly periodoAusenciaList?: ReadonlyArray<{
        readonly __typename?: 'PeriodoAusencia'
        readonly id: string
        readonly dtAusencia: any
        readonly dtRetorno?: any | null
      } | null> | null
      readonly cidadaoAldeado?: {
        readonly __typename?: 'CidadaoAldeado'
        readonly id: string
        readonly nomeTradicional?: string | null
        readonly responsavelLegal?: string | null
        readonly stChefeFamilia: boolean
        readonly beneficios?: ReadonlyArray<BeneficioDbEnum | null> | null
        readonly unidadeFunai?: string | null
        readonly livro?: number | null
        readonly folha?: number | null
        readonly cadastroUnico?: string | null
        readonly dtEmissao?: any | null
        readonly dtReconhecimento?: any | null
        readonly aldeiaNascimento?: {
          readonly __typename?: 'Aldeia'
          readonly id: string
          readonly nome: string
        } | null
        readonly funcaoSocial?: {
          readonly __typename?: 'FuncaoSocial'
          readonly id: string
          readonly nome: string
        } | null
        readonly localOcorrencia?: {
          readonly __typename?: 'LocalOcorrencia'
          readonly id: string
          readonly nome: string
        } | null
        readonly ufNascimento?: {
          readonly __typename?: 'UF'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        } | null
      } | null
      readonly enderecoIndigena?: {
        readonly __typename?: 'EnderecoIndigena'
        readonly numero?: string | null
        readonly aldeiaResidencia?: {
          readonly __typename?: 'Aldeia'
          readonly id: string
          readonly nome: string
          readonly poloBase: {
            readonly __typename?: 'PoloBase'
            readonly id: string
            readonly nome: string
            readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
          }
          readonly municipio: ReadonlyArray<{
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly ibge?: string | null
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }>
        } | null
        readonly poloBaseResidencia?: {
          readonly __typename?: 'PoloBase'
          readonly id: string
          readonly nome: string
          readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
        } | null
        readonly dseiResidencia?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly ibge?: string | null
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
        readonly uf?: {
          readonly __typename?: 'UF'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        } | null
      } | null
    } | null
  } | null
}

export type UnificacoesCidadaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UnificacoesCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly unificacoesCidadao?: ReadonlyArray<{
    readonly __typename?: 'UnificacoesCidadao'
    readonly id: string
    readonly nomeProfissional?: string | null
    readonly dataUnificacao?: any | null
    readonly cidadaos?: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly sexo: SexoEnum
      readonly nomeMae?: string | null
      readonly localidadeNascimento?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
      } | null
    } | null> | null
  } | null> | null
}

export type ImportacoesCnesQueryVariables = Exact<{
  input: ImportacoesCnesQueryInput
}>

export type ImportacoesCnesQuery = {
  readonly __typename?: 'Query'
  readonly importacoesCnes: {
    readonly __typename?: 'ImportacoesCnesQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ImportacaoCnes'
      readonly id: string
      readonly dataImportacao: any
      readonly equipesNovas?: number | null
      readonly equipesAtualizadas?: number | null
      readonly lotacoesNovas?: number | null
      readonly lotacoesAtualizadas?: number | null
      readonly profissionaisNovos?: number | null
      readonly profissionaisAtualizados?: number | null
      readonly unidadesSaudeNovas?: number | null
      readonly unidadesSaudeAtualizadas?: number | null
      readonly processo: { readonly __typename?: 'Processo'; readonly id: string; readonly status: StatusProcesso }
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type DetalhesImportacaoCnesViewQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DetalhesImportacaoCnesViewQuery = {
  readonly __typename?: 'Query'
  readonly importacaoCnes: {
    readonly __typename?: 'ImportacaoCnes'
    readonly id: string
    readonly dataImportacao: any
    readonly detalhes?: string | null
    readonly equipesNovas?: number | null
    readonly equipesAtualizadas?: number | null
    readonly lotacoesNovas?: number | null
    readonly lotacoesAtualizadas?: number | null
    readonly profissionaisNovos?: number | null
    readonly profissionaisAtualizados?: number | null
    readonly unidadesSaudeNovas?: number | null
    readonly unidadesSaudeAtualizadas?: number | null
    readonly vinculacoesEquipesNovas?: number | null
    readonly vinculacoesEquipesAtualizadas?: number | null
    readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
  }
}

export type AnexoArquivosQueryVariables = Exact<{ [key: string]: never }>

export type AnexoArquivosQuery = {
  readonly __typename?: 'Query'
  readonly anexoArquivos: {
    readonly __typename?: 'ConfiguracaoAnexoArquivos'
    readonly id: number
    readonly habilitado: boolean
    readonly diretorio?: string | null
  }
}

export type IsAnexoArquivoEverEnabledQueryVariables = Exact<{ [key: string]: never }>

export type IsAnexoArquivoEverEnabledQuery = {
  readonly __typename?: 'Query'
  readonly isAnexoArquivoEverEnabled: boolean
}

export type IsDiretorioAnexoArquivosValidoQueryVariables = Exact<{
  diretorio: Scalars['String']['input']
}>

export type IsDiretorioAnexoArquivosValidoQuery = {
  readonly __typename?: 'Query'
  readonly isDiretorioAnexoArquivosValido: boolean
}

export type AlterarConfiguracaoAnexoArquivosMutationVariables = Exact<{
  input: AlterarConfiguracaoAnexoArquivosInput
}>

export type AlterarConfiguracaoAnexoArquivosMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarConfiguracaoAnexoArquivos: {
    readonly __typename?: 'ConfiguracaoAnexoArquivos'
    readonly id: number
    readonly habilitado: boolean
    readonly diretorio?: string | null
  }
}

export type ConfiguracoesAvancadasQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracoesAvancadasQuery = {
  readonly __typename?: 'Query'
  readonly avancada: {
    readonly __typename?: 'ConfiguracaoAvancada'
    readonly performance: {
      readonly __typename?: 'ConfiguracaoPerformance'
      readonly qtdRequisicoesSimultaneas?: number | null
      readonly buscaCidadaoPorPropriedades: {
        readonly __typename?: 'ConfiguracaoBuscaCidadaoPorPropriedades'
        readonly id: string
        readonly habilitado: boolean
      }
    }
    readonly cadastroDomiciliarViaCds: {
      readonly __typename?: 'ConfiguracaoFeatureStateDto'
      readonly id: string
      readonly habilitado: boolean
    }
    readonly cadastroIndividualViaCds: {
      readonly __typename?: 'ConfiguracaoFeatureStateDto'
      readonly id: string
      readonly habilitado: boolean
    }
  }
}

export type AlterarBuscaCidadaoPorPropriedadesMutationVariables = Exact<{
  input: Scalars['Boolean']['input']
}>

export type AlterarBuscaCidadaoPorPropriedadesMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarBuscaCidadaoPorPropriedades: {
    readonly __typename?: 'ConfiguracaoBuscaCidadaoPorPropriedades'
    readonly id: string
    readonly habilitado: boolean
  }
}

export type AlterarQtdRequisicoesMutationVariables = Exact<{
  qtdRequisicoesSimultaneas?: InputMaybe<Scalars['Int']['input']>
}>

export type AlterarQtdRequisicoesMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarQtdRequisicoes?: {
    readonly __typename?: 'ConfiguracaoPerformance'
    readonly qtdRequisicoesSimultaneas?: number | null
  } | null
}

export type ConexaoQueryVariables = Exact<{ [key: string]: never }>

export type ConexaoQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: {
      readonly __typename?: 'ConfiguracaoInternet'
      readonly habilitado: boolean
      readonly dataUltimoTeste?: any | null
      readonly resultadoUltimoTeste?: boolean | null
    }
    readonly cadsus: {
      readonly __typename?: 'ConfiguracaoCadsus'
      readonly id: string
      readonly habilitado: boolean
      readonly desabilitadoAteData?: any | null
      readonly intervalo?: number | null
    }
    readonly horus: {
      readonly __typename?: 'ConfiguracaoHorus'
      readonly id: string
      readonly habilitado: boolean
      readonly desabilitadoAteData?: any | null
      readonly intervalo?: number | null
    }
    readonly videochamadas: {
      readonly __typename?: 'ConfiguracaoVideochamadas'
      readonly id: string
      readonly habilitado: boolean
    }
    readonly agendaOnline?: {
      readonly __typename?: 'AgendaOnline'
      readonly ativa: boolean
      readonly detalhesAtivacao?: {
        readonly __typename?: 'DetalhesAtivacao'
        readonly dataEvento: any
        readonly profissional?: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
        } | null
      } | null
      readonly testeConexao?: {
        readonly __typename?: 'TesteConexao'
        readonly sucesso: boolean
        readonly dataEvento: any
      } | null
    } | null
    readonly prescricaoDigital: {
      readonly __typename?: 'ConfiguracaoPrescricaoDigital'
      readonly id: string
      readonly habilitado: boolean
      readonly usuario?: string | null
      readonly senha?: string | null
    }
  }
}

export type AlternarConexaoInternetMutationVariables = Exact<{
  habilitado?: InputMaybe<Scalars['Boolean']['input']>
}>

export type AlternarConexaoInternetMutation = {
  readonly __typename?: 'Mutation'
  readonly alternarInternet?: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean } | null
}

export type TestarConexaoInternetMutationVariables = Exact<{ [key: string]: never }>

export type TestarConexaoInternetMutation = {
  readonly __typename?: 'Mutation'
  readonly testarConexaoInternet?: {
    readonly __typename?: 'ConfiguracaoInternet'
    readonly habilitado: boolean
    readonly dataUltimoTeste?: any | null
    readonly resultadoUltimoTeste?: boolean | null
  } | null
}

export type GerarChaveAtivacaoAgendaOnlineMutationVariables = Exact<{ [key: string]: never }>

export type GerarChaveAtivacaoAgendaOnlineMutation = {
  readonly __typename?: 'Mutation'
  readonly gerarChaveAtivacaoAgendaOnline: string
}

export type AtivarAgendaOnlineMutationVariables = Exact<{
  ativacaoAgendaOnlineInput: AtivacaoAgendaOnlineInput
}>

export type AtivarAgendaOnlineMutation = {
  readonly __typename?: 'Mutation'
  readonly ativarAgendaOnline?: {
    readonly __typename?: 'AgendaOnline'
    readonly ativa: boolean
    readonly detalhesAtivacao?: {
      readonly __typename?: 'DetalhesAtivacao'
      readonly dataEvento: any
      readonly profissional?: { readonly __typename?: 'Profissional'; readonly nome: string } | null
    } | null
  } | null
}

export type TestarConexaoAgendaOnlineMutationVariables = Exact<{ [key: string]: never }>

export type TestarConexaoAgendaOnlineMutation = {
  readonly __typename?: 'Mutation'
  readonly testarConexaoAgendaOnline: {
    readonly __typename?: 'TesteConexao'
    readonly sucesso: boolean
    readonly dataEvento: any
  }
}

export type CfgLotacaoAgendaOnlineQueryVariables = Exact<{ [key: string]: never }>

export type CfgLotacaoAgendaOnlineQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly hasLotacoesConfiguradasOnline?: boolean | null
    readonly lotacoesAgendaOnlineComDuracaoPadrao?: number | null
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
}

export type DesativarAgendaOnlineMutationVariables = Exact<{ [key: string]: never }>

export type DesativarAgendaOnlineMutation = {
  readonly __typename?: 'Mutation'
  readonly desativarAgendaOnline?: {
    readonly __typename?: 'AgendaOnline'
    readonly ativa: boolean
    readonly detalhesAtivacao?: {
      readonly __typename?: 'DetalhesAtivacao'
      readonly dataEvento: any
      readonly profissional?: { readonly __typename?: 'Profissional'; readonly nome: string } | null
    } | null
  } | null
}

export type UnificacaoBaseAtivaQueryVariables = Exact<{ [key: string]: never }>

export type UnificacaoBaseAtivaQuery = {
  readonly __typename?: 'Query'
  readonly pedidoEnvioBaseAtivo?: { readonly __typename?: 'PedidoEnvioBase'; readonly id?: string | null } | null
  readonly unificacoesBase?: ReadonlyArray<{
    readonly __typename?: 'UnificacaoBase'
    readonly id: string
    readonly status?: StatusUnificacaoBaseEnum | null
  } | null> | null
}

export type AlterarConfiguracaoPrescricaoDigitalMutationVariables = Exact<{
  input: AlterarConfiguracaoPrescricaoDigitalInput
}>

export type AlterarConfiguracaoPrescricaoDigitalMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarConfiguracaoPrescricaoDigital: {
    readonly __typename?: 'ConfiguracaoPrescricaoDigital'
    readonly id: string
    readonly habilitado: boolean
    readonly usuario?: string | null
    readonly senha?: string | null
  }
}

export type AlterarCadsusMutationVariables = Exact<{
  alterarCadsusInput: AlterarCadsusInput
}>

export type AlterarCadsusMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarCadsus?: {
    readonly __typename?: 'ConfiguracaoCadsus'
    readonly id: string
    readonly habilitado: boolean
    readonly intervalo?: number | null
    readonly desabilitadoAteData?: any | null
  } | null
}

export type AlterarHorusMutationVariables = Exact<{
  alterarHorusInput: AlterarHorusInput
}>

export type AlterarHorusMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarHorus?: {
    readonly __typename?: 'ConfiguracaoHorus'
    readonly id: string
    readonly habilitado: boolean
    readonly intervalo?: number | null
    readonly desabilitadoAteData?: any | null
  } | null
}

export type AlterarVideochamadaMutationVariables = Exact<{
  input: AlterarConfiguracaoVideochamadasInput
}>

export type AlterarVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarConfiguracaoVideochamadas: {
    readonly __typename?: 'ConfiguracaoVideochamadas'
    readonly id: string
    readonly habilitado: boolean
  }
}

export type AlterarConfiguracaoCadastroDomiciliarViaCdsMutationVariables = Exact<{
  input: Scalars['Boolean']['input']
}>

export type AlterarConfiguracaoCadastroDomiciliarViaCdsMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarConfiguracaoCadastroDomiciliarViaCds: {
    readonly __typename?: 'ConfiguracaoFeatureStateDto'
    readonly id: string
    readonly habilitado: boolean
  }
}

export type AlterarConfiguracaoCadastroIndividualViaCdsMutationVariables = Exact<{
  input: Scalars['Boolean']['input']
}>

export type AlterarConfiguracaoCadastroIndividualViaCdsMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarConfiguracaoCadastroIndividualViaCds: {
    readonly __typename?: 'ConfiguracaoFeatureStateDto'
    readonly id: string
    readonly habilitado: boolean
  }
}

export type HasMunicipioAtivoQueryVariables = Exact<{ [key: string]: never }>

export type HasMunicipioAtivoQuery = { readonly __typename?: 'Query'; readonly hasMunicipioAtivo: boolean }

export type MunicipiosResponsaveisQueryVariables = Exact<{
  input: MunicipioResponsavelFiltroInput
}>

export type MunicipiosResponsaveisQuery = {
  readonly __typename?: 'Query'
  readonly municipiosResponsaveis: {
    readonly __typename?: 'MunicipioResponsavelQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'AdministradorMunicipal'
      readonly id: string
      readonly habilitado: boolean
      readonly ativo: boolean
      readonly dataAdicao?: any | null
      readonly dataInativacao?: any | null
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
      }
      readonly municipio: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type InserirMunicipioResponsavelMutationVariables = Exact<{
  input: MunicipioResponsavelInput
}>

export type InserirMunicipioResponsavelMutation = {
  readonly __typename?: 'Mutation'
  readonly inserirMunicipioResponsavel: {
    readonly __typename?: 'AdministradorMunicipal'
    readonly id: string
    readonly habilitado: boolean
    readonly ativo: boolean
    readonly dataAdicao?: any | null
    readonly dataInativacao?: any | null
    readonly profissional: { readonly __typename?: 'Profissional'; readonly nome: string }
    readonly municipio: { readonly __typename?: 'Municipio'; readonly nome: string }
  }
}

export type AtualizarMunicipioResponsavelMutationVariables = Exact<{
  input: MunicipioResponsavelUpdateInput
}>

export type AtualizarMunicipioResponsavelMutation = {
  readonly __typename?: 'Mutation'
  readonly atualizarMunicipioResponsavel: {
    readonly __typename?: 'AdministradorMunicipal'
    readonly id: string
    readonly habilitado: boolean
    readonly ativo: boolean
    readonly dataAdicao?: any | null
    readonly dataInativacao?: any | null
    readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    readonly municipio: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
    }
  }
}

export type ExcluirMunicipioResponsavelMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirMunicipioResponsavelMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirMunicipioResponsavel: string
}

export type AlterarNumeroTentativasLoginMutationVariables = Exact<{
  tentativas?: InputMaybe<Scalars['Int']['input']>
}>

export type AlterarNumeroTentativasLoginMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarNumeroTentativasLogin?: {
    readonly __typename?: 'ConfiguracaoTentativasLogin'
    readonly tentativasLogin?: number | null
  } | null
}

export type AlterarPeriodoInatividadeMutationVariables = Exact<{
  periodo?: InputMaybe<Scalars['Int']['input']>
}>

export type AlterarPeriodoInatividadeMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarPeriodoInatividade?: {
    readonly __typename?: 'ConfiguracaoPeriodoInatividade'
    readonly periodoInatividade?: number | null
  } | null
}

export type AlterarPeriodoRedefinicaoSenhaMutationVariables = Exact<{
  periodo?: InputMaybe<Scalars['Int']['input']>
}>

export type AlterarPeriodoRedefinicaoSenhaMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarPeriodoRedefinicaoSenha?: {
    readonly __typename?: 'ConfiguracaoRedefinicaoSenha'
    readonly redefinicaoSenha?: number | null
  } | null
}

export type ForcarRedefinirSenhasMutationVariables = Exact<{ [key: string]: never }>

export type ForcarRedefinirSenhasMutation = {
  readonly __typename?: 'Mutation'
  readonly forcarRedefinirSenhas?: {
    readonly __typename?: 'ConfiguracaoRedefinicaoSenha'
    readonly redefinicaoSenha?: number | null
  } | null
}

export type SegurancaQueryVariables = Exact<{ [key: string]: never }>

export type SegurancaQuery = {
  readonly __typename?: 'Query'
  readonly seguranca: {
    readonly __typename?: 'ConfiguracaoSeguranca'
    readonly periodoEmMesesParaRedefinir: {
      readonly __typename?: 'ConfiguracaoRedefinicaoSenha'
      readonly redefinicaoSenha?: number | null
    }
    readonly periodoEmMinutosInatividade: {
      readonly __typename?: 'ConfiguracaoPeriodoInatividade'
      readonly periodoInatividade?: number | null
    }
    readonly loginNumeroTentativas: {
      readonly __typename?: 'ConfiguracaoTentativasLogin'
      readonly tentativasLogin?: number | null
    }
  }
}

export type AlterarDadosServidorInstalacaoMutationVariables = Exact<{
  input: ConfiguracaoDadosServidorInput
}>

export type AlterarDadosServidorInstalacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarDadosServidor?: {
    readonly __typename?: 'ConfiguracaoDadosServidorFormDto'
    readonly nomeInstalacao?: string | null
    readonly linkInstalacao?: string | null
  } | null
}

export type AlterarServidorSmtpMutationVariables = Exact<{
  input: ConfiguracaoSmtpInput
}>

export type AlterarServidorSmtpMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarServidorSMTP?: {
    readonly __typename?: 'ServidorSMTP'
    readonly email?: string | null
    readonly senha?: string | null
    readonly usuario?: string | null
    readonly endereco?: string | null
    readonly porta?: string | null
  } | null
}

export type DesabilitarConexaoSmtpMutationVariables = Exact<{ [key: string]: never }>

export type DesabilitarConexaoSmtpMutation = {
  readonly __typename?: 'Mutation'
  readonly desabilitarConexaoSMTP: boolean
}

export type DadosServidoresQueryVariables = Exact<{ [key: string]: never }>

export type DadosServidoresQuery = {
  readonly __typename?: 'Query'
  readonly servidores: {
    readonly __typename?: 'ConfiguracaoServidoresFormDto'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
    readonly dadosServidor?: {
      readonly __typename?: 'ConfiguracaoDadosServidorFormDto'
      readonly nomeInstalacao?: string | null
      readonly linkInstalacao?: string | null
    } | null
    readonly servidorSMTP?: {
      readonly __typename?: 'ServidorSMTP'
      readonly email?: string | null
      readonly senha?: string | null
      readonly usuario?: string | null
      readonly endereco?: string | null
      readonly porta?: string | null
      readonly ativo?: boolean | null
      readonly dataRegistro?: any | null
    } | null
  }
}

export type ConfiguracaoInternetQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoInternetQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
}

export type PedidoEnvioBaseAtivoQueryVariables = Exact<{ [key: string]: never }>

export type PedidoEnvioBaseAtivoQuery = {
  readonly __typename?: 'Query'
  readonly pedidoEnvioBaseAtivo?: {
    readonly __typename?: 'PedidoEnvioBase'
    readonly id?: string | null
    readonly nomeInstalacao: string
    readonly chaveAutenticacao?: string | null
    readonly linkInstalacao: string
    readonly status: StatusPedidoEnvioEnum
    readonly loginAtivo: boolean
  } | null
}

export type PedidosEnvioBaseQueryVariables = Exact<{ [key: string]: never }>

export type PedidosEnvioBaseQuery = {
  readonly __typename?: 'Query'
  readonly pedidosEnvioBase?: ReadonlyArray<{
    readonly __typename?: 'PedidoEnvioBase'
    readonly id?: string | null
    readonly linkInstalacao: string
    readonly status: StatusPedidoEnvioEnum
    readonly dataSolicitacao: any
    readonly dataFimUnificacao?: any | null
    readonly loginAtivo: boolean
  } | null> | null
}

export type UnificacoesBaseQueryVariables = Exact<{ [key: string]: never }>

export type UnificacoesBaseQuery = {
  readonly __typename?: 'Query'
  readonly unificacoesBase?: ReadonlyArray<{
    readonly __typename?: 'UnificacaoBase'
    readonly id: string
    readonly nomeInstalacao: string
    readonly status?: StatusUnificacaoBaseEnum | null
    readonly dataSolicitacao: any
    readonly dataFimUnificacao?: any | null
  } | null> | null
}

export type AceitarSolicitacaoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AceitarSolicitacaoMutation = { readonly __typename?: 'Mutation'; readonly aceitarSolicitacao: boolean }

export type CadastrarEnderecoEnvioMutationVariables = Exact<{
  input: InfoCadastroEnvioInput
}>

export type CadastrarEnderecoEnvioMutation = {
  readonly __typename?: 'Mutation'
  readonly cadastrarEnderecoEnvio: {
    readonly __typename?: 'CadastroEnderecoEnvioDto'
    readonly errorLogin?: ReadonlyArray<string | null> | null
    readonly pedidoEnvioBase?: { readonly __typename?: 'PedidoEnvioBase'; readonly id?: string | null } | null
    readonly errorImportacaoCnes?: {
      readonly __typename?: 'LocalidadeCnesDesatualizadoDto'
      readonly instalacaoCentral?: string | null
      readonly instalacaoLocal?: string | null
    } | null
  }
}

export type CancelarSolicitacaoEnvioMutationVariables = Exact<{
  input: CancelarSolicitacaoEnvioInput
}>

export type CancelarSolicitacaoEnvioMutation = {
  readonly __typename?: 'Mutation'
  readonly cancelarSolicitacaoEnvio: boolean
}

export type HasImpressaoDocumentosDuplicadosQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type HasImpressaoDocumentosDuplicadosQuery = {
  readonly __typename?: 'Query'
  readonly hasDocumentosDuplicados: boolean
}

export type InicarUnificacaoBaseMutationVariables = Exact<{ [key: string]: never }>

export type InicarUnificacaoBaseMutation = { readonly __typename?: 'Mutation'; readonly iniciarUnificacaoBase: boolean }

export type NegarSolicitacaoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NegarSolicitacaoMutation = { readonly __typename?: 'Mutation'; readonly negarSolicitacao: boolean }

export type RefazerLoginMutationVariables = Exact<{
  senha: Scalars['String']['input']
}>

export type RefazerLoginMutation = {
  readonly __typename?: 'Mutation'
  readonly refazLoginExpirado?: ReadonlyArray<string | null> | null
}

export type CadsusHabilitadoInstalacaoQueryVariables = Exact<{ [key: string]: never }>

export type CadsusHabilitadoInstalacaoQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly cadsus: { readonly __typename?: 'ConfiguracaoCadsus'; readonly id: string; readonly habilitado: boolean }
  }
}

export type CertificadoSelectQueryVariables = Exact<{
  input: CertificadoQueryInput
}>

export type CertificadoSelectQuery = {
  readonly __typename?: 'Query'
  readonly certificados: {
    readonly __typename?: 'CertificadoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Certificado'
      readonly path: string
      readonly nome: string
    } | null>
  }
}

export type SalvarConfiguracaoCertificadoMutationVariables = Exact<{
  configuracaoCertificadoInput: ConfiguracaoCertificadoInput
}>

export type SalvarConfiguracaoCertificadoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarConfiguracaoCertificado: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly dataInclusao: any
    readonly dataHabilitacao: any
    readonly dataValidadeCertificado: any
    readonly rndsHabilitado: boolean
    readonly cadsusHabilitado: boolean
    readonly farmaciaHabilitado: boolean
    readonly error?: ReadonlyArray<string | null> | null
    readonly admMunicipal: {
      readonly __typename?: 'AdministradorMunicipal'
      readonly profissional: { readonly __typename?: 'Profissional'; readonly nome: string }
    }
  }
}

export type ConfiguracaoCertificadoHabilitadoQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoCertificadoHabilitadoQuery = {
  readonly __typename?: 'Query'
  readonly configuracaoCertificadoHabilitado?: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly dataInclusao: any
    readonly dataHabilitacao: any
    readonly dataValidadeCertificado: any
    readonly rndsHabilitado: boolean
    readonly cadsusHabilitado: boolean
    readonly farmaciaHabilitado: boolean
    readonly error?: ReadonlyArray<string | null> | null
    readonly admMunicipal: {
      readonly __typename?: 'AdministradorMunicipal'
      readonly profissional: { readonly __typename?: 'Profissional'; readonly nome: string }
    }
  } | null
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
  }
}

export type ContraChaveAtivacaoMunicipioQueryVariables = Exact<{ [key: string]: never }>

export type ContraChaveAtivacaoMunicipioQuery = {
  readonly __typename?: 'Query'
  readonly contraChaveAtivacaoMunicipio?: string | null
}

export type ExcluirConfiguracaoCertificadoMutationVariables = Exact<{
  configuracaoCertificadoId: Scalars['ID']['input']
}>

export type ExcluirConfiguracaoCertificadoMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirConfiguracaoCertificado: string
}

export type ValidarConfiguracaoCertificadoMutationVariables = Exact<{
  configuracaoCertificadoInput: ConfiguracaoCertificadoInput
}>

export type ValidarConfiguracaoCertificadoMutation = {
  readonly __typename?: 'Mutation'
  readonly validarConfiguracaoCertificado: ReadonlyArray<ServicosCertificadoEnum | null>
}

export type ConfiguracaoAgendaMunicipioQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoAgendaMunicipioQuery = {
  readonly __typename?: 'Query'
  readonly duracaoAtendimentoPadraoMunicipio?: {
    readonly __typename?: 'DuracaoAtendimentoPadraoMunicipio'
    readonly duracaoAtendimentoPadraoMunicipio: number
  } | null
  readonly configuracaoHorariosMunicipio: {
    readonly __typename?: 'ConfiguracaoAgendaMunicipal'
    readonly id: string
    readonly configuracaoHorarioAgenda: {
      readonly __typename?: 'ConfiguracaoHorarioAgenda'
      readonly configuracaoDiasSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoDiaSemana'
        readonly diaSemana: DiaSemanaEnum
        readonly periodos?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoPeriodo'
          readonly periodo: PeriodoEnum
          readonly horarioInicial?: string | null
          readonly horarioFinal?: string | null
        }> | null
      }> | null
    }
  }
}

export type SalvarConfiguracaoHorariosMunicipioMutationVariables = Exact<{
  configuracaoAgendaMunicipalInput?: InputMaybe<ConfiguracaoAgendaMunicipalInput>
}>

export type SalvarConfiguracaoHorariosMunicipioMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarConfiguracaoHorariosMunicipio?: {
    readonly __typename?: 'ConfiguracaoAgendaMunicipal'
    readonly id: string
    readonly configuracaoHorarioAgenda: {
      readonly __typename?: 'ConfiguracaoHorarioAgenda'
      readonly configuracaoDiasSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoDiaSemana'
        readonly diaSemana: DiaSemanaEnum
        readonly periodos?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoPeriodo'
          readonly periodo: PeriodoEnum
          readonly horarioInicial?: string | null
          readonly horarioFinal?: string | null
        }> | null
      }> | null
    }
  } | null
}

export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables = Exact<{
  duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput
}>

export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarDuracaoPadraoAtendimento: {
    readonly __typename?: 'DuracaoAtendimentoPadraoMunicipio'
    readonly duracaoAtendimentoPadraoMunicipio: number
  }
}

export type ExcluirGrupoExameMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirGrupoExameMutation = { readonly __typename?: 'Mutation'; readonly excluirGrupoExame: string }

export type GrupoExamesQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GrupoExamesQuery = {
  readonly __typename?: 'Query'
  readonly grupoExame: {
    readonly __typename?: 'GrupoExame'
    readonly id: string
    readonly nome: string
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    } | null> | null
  }
}

export type SalvarGrupoExameMutationVariables = Exact<{
  input: GrupoExameInput
}>

export type SalvarGrupoExameMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarGrupoExame: {
    readonly __typename?: 'GrupoExame'
    readonly id: string
    readonly nome: string
    readonly procedimentos?: ReadonlyArray<{
      readonly __typename?: 'Procedimento'
      readonly id: string
      readonly descricao: string
      readonly codigo: string
      readonly ativo?: boolean | null
      readonly procedimentoReferencia?: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
        readonly ativo?: boolean | null
      } | null
    } | null> | null
  }
}

export type GrupoExameTableQueryVariables = Exact<{
  input: GrupoExameQueryInput
}>

export type GrupoExameTableQuery = {
  readonly __typename?: 'Query'
  readonly gruposExame: {
    readonly __typename?: 'GruposExameQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'GrupoExame'
      readonly id: string
      readonly nome: string
      readonly quantidadeProcedimentos?: number | null
      readonly hasProcedimentosInativos?: boolean | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type GerarRelatorioRndsCsvMutationVariables = Exact<{
  input: GerarRelatorioRndsCsvInput
}>

export type GerarRelatorioRndsCsvMutation = {
  readonly __typename?: 'Mutation'
  readonly gerarRelatorioRndsCsv?: boolean | null
}

export type CertificadoRndsQueryVariables = Exact<{ [key: string]: never }>

export type CertificadoRndsQuery = {
  readonly __typename?: 'Query'
  readonly configuracaoCertificadoHabilitado?: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly rndsHabilitado: boolean
  } | null
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly internet: { readonly __typename?: 'ConfiguracaoInternet'; readonly habilitado: boolean }
  }
}

export type ResumoEnviosRndsQueryVariables = Exact<{
  input: TipoRegistroRndsEnum
}>

export type ResumoEnviosRndsQuery = {
  readonly __typename?: 'Query'
  readonly resumoEnviosRnds: {
    readonly __typename?: 'QuantidadeStatusEnvioRndsDto'
    readonly qtdEnviado?: any | null
    readonly qtdNaoEnviado?: any | null
    readonly qtdFalhaConexao?: any | null
    readonly qtdDadosInvalidos?: any | null
    readonly qtdErro?: any | null
  }
}

export type StatusConexaoRndsQueryVariables = Exact<{ [key: string]: never }>

export type StatusConexaoRndsQuery = {
  readonly __typename?: 'Query'
  readonly statusConexaoRnds: StatusConexaoRndsEnum
}

export type EquipeEMultiVinculacoesTableQueryVariables = Exact<{
  input: TodasVinculacoesEquipesInput
}>

export type EquipeEMultiVinculacoesTableQuery = {
  readonly __typename?: 'Query'
  readonly todasVinculacoesEquipeEmulti: {
    readonly __typename?: 'TodasVinculacoesEquipesPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TodasVinculacoesEquipeDto'
      readonly quantidadeVinculacoes: number
      readonly equipeEmulti: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      }
      readonly vinculacoesPorEstabelecimento: ReadonlyArray<{
        readonly __typename?: 'VinculacaoEquipePorEstabelecimentoDto'
        readonly estabelecimento: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
          readonly cnes: string
        }
        readonly equipes: ReadonlyArray<{
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        }>
      }>
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ExcluirVinculacaoServicoMutationVariables = Exact<{
  referenciaId: Scalars['Long']['input']
}>

export type ExcluirVinculacaoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirVinculacaoServico?: boolean | null
}

export type SalvarVinculacaoServicoMutationVariables = Exact<{
  input: SalvarVinculacaoServicoInput
}>

export type SalvarVinculacaoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarVinculacaoServico?: boolean | null
}

export type UnidadesSaudeByTipoVinculacaoServicoQueryVariables = Exact<{
  input: UnidadesSaudeByTipoVinculacaoServicoInput
}>

export type UnidadesSaudeByTipoVinculacaoServicoQuery = {
  readonly __typename?: 'Query'
  readonly unidadesSaudeByTipoVinculacaoServico: ReadonlyArray<{
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
    readonly hasVinculacaoServico: boolean
  }>
}

export type VinculacoesEstabelecimentosTableQueryVariables = Exact<{
  input: VinculacaoServicosInput
}>

export type VinculacoesEstabelecimentosTableQuery = {
  readonly __typename?: 'Query'
  readonly vinculacoesServico: {
    readonly __typename?: 'VinculacaoServicosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'VinculacaoServicoDto'
      readonly quantidadeVinculacoes: number
      readonly referencia: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly vinculacoes: ReadonlyArray<{
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }>
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type VinculacaoServicoQueryVariables = Exact<{
  referenciaId: Scalars['Long']['input']
}>

export type VinculacaoServicoQuery = {
  readonly __typename?: 'Query'
  readonly vinculacaoServico?: {
    readonly __typename?: 'VinculacaoServicoDto'
    readonly referencia: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
    readonly vinculacoes: ReadonlyArray<{
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }>
  } | null
}

export type TipoServicoCheckQueryVariables = Exact<{
  input: TipoServicoQueryInput
}>

export type TipoServicoCheckQuery = {
  readonly __typename?: 'Query'
  readonly tiposServico: {
    readonly __typename?: 'TipoServicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TipoServico'
      readonly id: string
      readonly nome: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type TipoServicoTableQueryVariables = Exact<{
  input: TipoServicoQueryInput
}>

export type TipoServicoTableQuery = {
  readonly __typename?: 'Query'
  readonly tiposServico: {
    readonly __typename?: 'TipoServicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TipoServico'
      readonly id: string
      readonly nome: string
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly id: string } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type AlterarTipoServicoMutationVariables = Exact<{
  input: TipoServicoUpdateInput
}>

export type AlterarTipoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarTipoServico?: {
    readonly __typename?: 'TipoServico'
    readonly id: string
    readonly nome: string
  } | null
}

export type SalvarTipoServicoMutationVariables = Exact<{
  input: TipoServicoInput
}>

export type SalvarTipoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarTipoServico?: {
    readonly __typename?: 'TipoServico'
    readonly id: string
    readonly nome: string
  } | null
}

export type ExcluirTipoServicoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirTipoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirTipoServico?: string | null
}

export type CuidadoCompartilhadoFinalizacoesQueryVariables = Exact<{
  input: CuidadoCompartilhadoEvolucoesQueryInput
}>

export type CuidadoCompartilhadoFinalizacoesQuery = {
  readonly __typename?: 'Query'
  readonly cuidadoCompartilhadoFinalizacoes: {
    readonly __typename?: 'CuidadoCompartilhadoFinalizacaoAutoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CuidadoFinalizacaoAuto'
      readonly id: string
      readonly dataFinalizado: any
      readonly dataReaberto?: any | null
      readonly sequenciaEvolucao: number
    }>
  }
}

export type CuidadoCompartilhadoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CuidadoCompartilhadoQuery = {
  readonly __typename?: 'Query'
  readonly cuidadoCompartilhado?: {
    readonly __typename?: 'CuidadoCompartilhado'
    readonly id: string
    readonly iniciadoEm: any
    readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
    readonly cidadaoAceitaAtendTic: boolean
    readonly discussao: string
    readonly status: StatusCuidadoCompartilhadoEnum
    readonly tempoDecorridoUltimaEvolucao: any
    readonly cid10?: {
      readonly __typename?: 'Cid10'
      readonly id: string
      readonly codigo: string
      readonly nome: string
    } | null
    readonly ciap?: {
      readonly __typename?: 'Ciap'
      readonly id: string
      readonly codigo: string
      readonly descricao: string
    } | null
    readonly lotacaoExecutanteAtual?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
        readonly telefone?: string | null
        readonly email?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
    } | null
    readonly cboExecutanteAtual: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    readonly unidadeSaudeExecutanteAtual: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly tipo: { readonly __typename?: 'TipoUnidadeSaude'; readonly id: string; readonly codigoMs: any }
      readonly subtipo?: {
        readonly __typename?: 'SubtipoUnidadeSaude'
        readonly id: string
        readonly codigoMs?: string | null
      } | null
    }
    readonly lotacaoSolicitante: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeCivil: string
        readonly nomeSocial?: string | null
        readonly telefone?: string | null
        readonly email?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
    }
    readonly cidadao: {
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
      readonly dataAtualizado?: any | null
      readonly sexo: SexoEnum
      readonly nomeMae?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly email?: string | null
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly ativo?: boolean | null
      readonly faleceu?: boolean | null
      readonly possuiAgendamento?: boolean | null
      readonly unificado?: boolean | null
      readonly unificacaoBase?: string | null
      readonly prontuario?: {
        readonly __typename?: 'Prontuario'
        readonly id: string
        readonly preNatalAtivo?: {
          readonly __typename?: 'PreNatal'
          readonly id: string
          readonly ultimaDum?: any | null
        } | null
        readonly gestacoes?: ReadonlyArray<{
          readonly __typename?: 'PeriodoGestacao'
          readonly id: string
          readonly inicio: any
          readonly fim?: any | null
        }> | null
      } | null
      readonly cidadaoVinculacaoEquipe?: {
        readonly __typename?: 'CidadaoVinculacaoEquipe'
        readonly id?: string | null
        readonly tpCdsOrigem?: CdsOrigemEnum | null
        readonly unidadeSaude?: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        } | null
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        } | null
      } | null
    }
  } | null
}

export type SalvarCuidadoCompartilhadoMutationVariables = Exact<{
  input: SalvarCuidadoCompartilhadoInput
}>

export type SalvarCuidadoCompartilhadoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarCuidadoCompartilhado: { readonly __typename?: 'CuidadoCompartilhado'; readonly id: string }
}

export type CboTrocaExecutanteSelectFieldQueryVariables = Exact<{
  input: CbosTrocaExecutanteCuidadoCompartilhadoQueryInput
}>

export type CboTrocaExecutanteSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cbosTrocaExecutante: {
    readonly __typename?: 'CboPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CuidadoCompartilhadoEvolucoesQueryVariables = Exact<{
  input: CuidadoCompartilhadoEvolucoesQueryInput
}>

export type CuidadoCompartilhadoEvolucoesQuery = {
  readonly __typename?: 'Query'
  readonly cuidadoCompartilhadoEvolucoes: {
    readonly __typename?: 'CuidadoCompartilhadoEvolucoesPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhadoEvolucao'
      readonly id: string
      readonly dataEvolucao: any
      readonly conduta: CondutaCuidadoCompartilhadoEnum
      readonly descricao?: string | null
      readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
      readonly reclassificacaoPrioridade?: ClassificacaoPrioridadeCuidadoEnum | null
      readonly enviarGarantiaAcesso?: CondutaCuidadoCompartilhadoEnum | null
      readonly codigoSequencialEvolucao: number
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
      }
      readonly lotacaoExecutante?: { readonly __typename?: 'Lotacao'; readonly id: string } | null
      readonly lotacaoAfetada?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
      } | null
      readonly agenda?: {
        readonly __typename?: 'Agendado'
        readonly id: string
        readonly horarioInicial: any
        readonly situacao: SituacaoAgendadoEnum
        readonly observacao?: string | null
        readonly justificativaCancelamento?: {
          readonly __typename?: 'JustificativaCancelamentoAgendado'
          readonly id: string
          readonly justificativa?: string | null
        } | null
      } | null
      readonly cuidadoCompartilhado: {
        readonly __typename?: 'CuidadoCompartilhado'
        readonly id: string
        readonly lotacaoSolicitante: { readonly __typename?: 'Lotacao'; readonly id: string }
      }
    } | null>
  }
}

export type VisualizarCuidadoCompartilhadoMutationVariables = Exact<{
  input: VisualizarCuidadoCompartilhadoInput
}>

export type VisualizarCuidadoCompartilhadoMutation = {
  readonly __typename?: 'Mutation'
  readonly visualizarCuidadoCompartilhado: string
}

export type CuidadoCompartilhadoNotificacaoQueryVariables = Exact<{
  input: CuidadosCompartilhadoQueryInput
}>

export type CuidadoCompartilhadoNotificacaoQuery = {
  readonly __typename?: 'Query'
  readonly cuidadosCompartilhado: {
    readonly __typename?: 'CuidadosCompartilhadoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly lotacaoExecutanteAtual?: { readonly __typename?: 'Lotacao'; readonly id: string } | null
      readonly lotacaoSolicitante: { readonly __typename?: 'Lotacao'; readonly id: string }
    }>
  }
}

export type IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQueryVariables = Exact<{
  tipoCoMs: Scalars['Long']['input']
}>

export type IsTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServicoQuery = {
  readonly __typename?: 'Query'
  readonly isTipoUnidadeSaudeAllowedAsReferenciaVinculacaoServico: boolean
}

export type ListaCuidadoCompartilhadoQueryVariables = Exact<{
  input: CuidadosCompartilhadoQueryInput
}>

export type ListaCuidadoCompartilhadoQuery = {
  readonly __typename?: 'Query'
  readonly cuidadosCompartilhado: {
    readonly __typename?: 'CuidadosCompartilhadoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CuidadoCompartilhado'
      readonly id: string
      readonly iniciadoEm: any
      readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
      readonly status: StatusCuidadoCompartilhadoEnum
      readonly discussao: string
      readonly tempoDecorridoUltimaEvolucao: any
      readonly cidadao: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly dataNascimento?: any | null
        readonly nomeSocial?: string | null
        readonly nome: string
      }
      readonly lotacaoExecutanteAtual?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
      } | null
      readonly cboExecutanteAtual: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly unidadeSaudeExecutanteAtual: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
      }
      readonly lotacaoSolicitante: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
        }
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
      }
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
      readonly ciap?: {
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      } | null
      readonly actions?: {
        readonly __typename?: 'CuidadoCompartilhadoActions'
        readonly discutirCasoSolicitante?: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        } | null
        readonly discutirCasoExecutante?: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        } | null
        readonly visualizarDiscussao?: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        } | null
        readonly tornarseExecutante?: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        } | null
      } | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CbosCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: CbosListaCuidadoCompartilhadoQueryInput
}>

export type CbosCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly cbosListaCuidadoCompartilhado: ReadonlyArray<{
    readonly __typename?: 'Cbo'
    readonly id: string
    readonly nome: string
    readonly cbo2002: string
  }>
}

export type EquipeCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: EquipesListaCuidadoCompartilhadoQueryInput
}>

export type EquipeCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly equipesListaCuidadoCompartilhado: ReadonlyArray<{
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
    readonly tipoEquipe: { readonly __typename?: 'TipoEquipe'; readonly id: string; readonly sigla: string }
  }>
}

export type UnidadeSaudeCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: EstabelecimentosListaCuidadoCompartilhadoQueryInput
}>

export type UnidadeSaudeCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly estabelecimentosListaCuidadoCompartilhado: ReadonlyArray<{
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
  }>
}

export type ProfissionaisCuidadoCompartilhadoSelectFieldQueryVariables = Exact<{
  input: ProfissionaisListaCuidadoCompartilhadoQueryInput
}>

export type ProfissionaisCuidadoCompartilhadoSelectFieldQuery = {
  readonly __typename?: 'Query'
  readonly profissionaisListaCuidadoCompartilhado: ReadonlyArray<{
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nome: string
    readonly cpf: string
  }>
}

export type TornarseExecutanteCuidadoCompartilhadoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TornarseExecutanteCuidadoCompartilhadoMutation = {
  readonly __typename?: 'Mutation'
  readonly tornarseExecutanteCuidadoCompartilhado: { readonly __typename?: 'CuidadoCompartilhado'; readonly id: string }
}

export type AutorizacaoRetiradaAbsorventesQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type AutorizacaoRetiradaAbsorventesQuery = {
  readonly __typename?: 'Query'
  readonly autorizacaoRetiradaAbsorventeByCidadaoId: {
    readonly __typename?: 'AutorizacaoRetiradaAbsorventeQueryPayload'
    readonly status: StatusAutorizacaoAbsorvente
    readonly autorizacao?: {
      readonly __typename?: 'AutorizacaoRetiradaAbsorvente'
      readonly id: string
      readonly hash?: string | null
      readonly codigoRms?: string | null
      readonly ufRms?: string | null
      readonly cidadao: {
        readonly __typename?: 'CidadaoDignidadeMenstrual'
        readonly id: string
        readonly cns?: string | null
        readonly dataNascimento?: any | null
        readonly nome?: string | null
        readonly nomeMae?: string | null
      }
    } | null
  }
}

export type ConfiguracaoCertificadoDignidadeMenstrualQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoCertificadoDignidadeMenstrualQuery = {
  readonly __typename?: 'Query'
  readonly configuracaoCertificadoHabilitado?: {
    readonly __typename?: 'ConfiguracaoCertificado'
    readonly id: string
    readonly farmaciaHabilitado: boolean
  } | null
}

export type EquipeDetailQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type EquipeDetailQuery = {
  readonly __typename?: 'Query'
  readonly equipe: {
    readonly __typename?: 'Equipe'
    readonly id: string
    readonly nome: string
    readonly ine: string
    readonly area?: string | null
    readonly ativo?: boolean | null
    readonly tipoEquipe: {
      readonly __typename?: 'TipoEquipe'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    }
  }
}

export type EquipeTableQueryVariables = Exact<{
  input: EquipesQueryInput
}>

export type EquipeTableQuery = {
  readonly __typename?: 'Query'
  readonly equipes: {
    readonly __typename?: 'EquipePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly area?: string | null
      readonly ativo?: boolean | null
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CriarEstagioMutationVariables = Exact<{
  input: EstagioCreateInput
}>

export type CriarEstagioMutation = {
  readonly __typename?: 'Mutation'
  readonly createEstagio: { readonly __typename?: 'Estagio'; readonly id: string }
}

export type DeleteEstagioMutationVariables = Exact<{
  estagioId: Scalars['ID']['input']
}>

export type DeleteEstagioMutation = { readonly __typename?: 'Mutation'; readonly deleteEstagio: string }

export type EstagioEditViewQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type EstagioEditViewQuery = {
  readonly __typename?: 'Query'
  readonly estagio: {
    readonly __typename?: 'Estagio'
    readonly id: string
    readonly ativo: boolean
    readonly dataInicioVigencia: any
    readonly dataFimVigencia: any
    readonly instituicaoEnsino?: string | null
    readonly nivelTecnico: boolean
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
    } | null
    readonly lotacaoSupervisora: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly cpf: string
        readonly nome: string
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
      } | null
    }
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly cpf: string
      readonly nome: string
    }
    readonly perfis: ReadonlyArray<{
      readonly __typename?: 'Perfil'
      readonly id: string
      readonly nome: string
      readonly ativo: boolean
    }>
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
    readonly actions: {
      readonly __typename?: 'AcessoActions'
      readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
    }
  }
}

export type ProfissionalEstagioQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ProfissionalEstagioQuery = {
  readonly __typename?: 'Query'
  readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
}

export type UpdateEstagioMutationVariables = Exact<{
  input: EstagioUpdateInput
}>

export type UpdateEstagioMutation = {
  readonly __typename?: 'Mutation'
  readonly updateEstagio: { readonly __typename?: 'Estagio'; readonly id: string }
}

export type ListaRegulacaoQueryVariables = Exact<{
  input: ListaRegulacaoQueryInput
}>

export type ListaRegulacaoQuery = {
  readonly __typename?: 'Query'
  readonly listaRegulacao: {
    readonly __typename?: 'ListaRegulacaoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Regulacao'
      readonly id: string
      readonly uuid: string
      readonly tipoRegulacao: TipoRegulacaoEnum
      readonly exame?: {
        readonly __typename?: 'ResultadoExame'
        readonly id: string
        readonly dataSolicitacao?: any | null
        readonly observacao?: string | null
        readonly exame: {
          readonly __typename?: 'Procedimento'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
        readonly atendimentoProfissionalSolicitacao?: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly finalizadoEm?: any | null
        } | null
        readonly solicitacao?: {
          readonly __typename?: 'SolicitacaoExame'
          readonly id: string
          readonly justificativa: string
          readonly observacoes?: string | null
          readonly cid10?: {
            readonly __typename?: 'Cid10'
            readonly id: string
            readonly codigo: string
            readonly nome: string
          } | null
        } | null
      } | null
      readonly guiaEncaminhamento?: {
        readonly __typename?: 'GuiaEncaminhamento'
        readonly id: string
        readonly classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum
        readonly discussao: string
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly cid10?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly atendimentoProfissional: {
          readonly __typename?: 'AtendimentoProfissional'
          readonly id: string
          readonly finalizadoEm?: any | null
        }
      } | null
      readonly lotacao: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        readonly unidadeSaude: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        }
        readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
        readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
      }
      readonly prontuario: {
        readonly __typename?: 'Prontuario'
        readonly id: string
        readonly cidadao?: {
          readonly __typename?: 'Cidadao'
          readonly id: string
          readonly nome: string
          readonly nomeSocial?: string | null
          readonly dataNascimento?: any | null
          readonly cidadaoVinculacaoEquipe?: {
            readonly __typename?: 'CidadaoVinculacaoEquipe'
            readonly id?: string | null
            readonly unidadeSaude?: {
              readonly __typename?: 'UnidadeSaude'
              readonly id: string
              readonly nome?: string | null
            } | null
            readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
          } | null
        } | null
      }
      readonly ultimaEvolucao: {
        readonly __typename?: 'RegulacaoEvolucao'
        readonly id: string
        readonly dataEvolucao: any
        readonly statusRegulacao: StatusRegulacaoEnum
        readonly prioridade: PrioridadeRegulacaoEnum
        readonly observacao?: string | null
      }
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HistoricoRegulacaoEvolucaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type HistoricoRegulacaoEvolucaoQuery = {
  readonly __typename?: 'Query'
  readonly evolucoesRegulacao: ReadonlyArray<{
    readonly __typename?: 'RegulacaoEvolucao'
    readonly id: string
    readonly dataEvolucao: any
    readonly statusRegulacao: StatusRegulacaoEnum
    readonly observacao?: string | null
    readonly prioridade: PrioridadeRegulacaoEnum
  }>
}

export type HistoricoAcessoTableQueryVariables = Exact<{
  input: HistoricoAcessoQueryInput
}>

export type HistoricoAcessoTableQuery = {
  readonly __typename?: 'Query'
  readonly historicoAcessos: {
    readonly __typename?: 'HistoricoAcessoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'HistoricoAcesso'
      readonly id: string
      readonly sucesso: boolean
      readonly data: any
      readonly cliente: string
      readonly local: string
      readonly ip: string
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type UltimoAcessoQueryVariables = Exact<{ [key: string]: never }>

export type UltimoAcessoQuery = {
  readonly __typename?: 'Query'
  readonly ultimoAcesso?: { readonly __typename?: 'HistoricoAcesso'; readonly id: string; readonly data: any } | null
}

export type AlterarUnidadePadraoHorusMutationVariables = Exact<{
  input: UnidadeConsultaHorusIds
}>

export type AlterarUnidadePadraoHorusMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarUnidadePadraoHorus: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
  }
}

export type CadastroUnidadeConsultaHorusMutationVariables = Exact<{
  input: UnidadeConsultaHorusIds
}>

export type CadastroUnidadeConsultaHorusMutation = {
  readonly __typename?: 'Mutation'
  readonly adicionarUnidadeConsultaHorus: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
  }
}

export type HorusListViewQueryVariables = Exact<{
  unidadeSaudeId: Scalars['ID']['input']
}>

export type HorusListViewQuery = {
  readonly __typename?: 'Query'
  readonly unidadesConsultaHorus: ReadonlyArray<{
    readonly __typename?: 'HorusFormDto'
    readonly unidadePadrao: boolean
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
  } | null>
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly actions: {
      readonly __typename?: 'UnidadeSaudeActions'
      readonly permissaoConexaoHorus: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    }
  }
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly horus: { readonly __typename?: 'ConfiguracaoHorus'; readonly id: string; readonly habilitado: boolean }
  }
}

export type RemoverUnidadeConsultaHorusMutationVariables = Exact<{
  input: UnidadeConsultaHorusIds
}>

export type RemoverUnidadeConsultaHorusMutation = {
  readonly __typename?: 'Mutation'
  readonly removerUnidadeConsultaHorus: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
  }
}

export type InstalarMutationVariables = Exact<{
  input: InstalacaoInput
}>

export type InstalarMutation = { readonly __typename?: 'Mutation'; readonly instalar: boolean }

export type CredenciaisIntegracaoQueryVariables = Exact<{
  input: CredencialIntegracaoQueryInput
}>

export type CredenciaisIntegracaoQuery = {
  readonly __typename?: 'Query'
  readonly credenciaisIntegracao: {
    readonly __typename?: 'CredencialIntegracaoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CredenciaIntegracao'
      readonly id: string
      readonly nomeResponsavel: string
      readonly nomeCredencial: string
      readonly dataCriacao: any
      readonly email: string
      readonly ativo: boolean
      readonly tipoPessoa: TipoPessoaEnum
      readonly cpfCnpj: string
      readonly recursos: ReadonlyArray<RecursoIntegracaoEnum>
      readonly urlWebhookRegulacao?: string | null
      readonly municipiosVinculados?: ReadonlyArray<{
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
      }> | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type InativarCredencialIntegracaoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarCredencialIntegracaoMutation = {
  readonly __typename?: 'Mutation'
  readonly inativarCredencialIntegracao: { readonly __typename?: 'CredenciaIntegracao'; readonly id: string }
}

export type IsCredencialIntegracaoRegulacaoJaCriadaQueryVariables = Exact<{ [key: string]: never }>

export type IsCredencialIntegracaoRegulacaoJaCriadaQuery = {
  readonly __typename?: 'Query'
  readonly isCredencialIntegracaoRegulacaoJaCriada: boolean
}

export type SalvarCredencialIntegracaoMutationVariables = Exact<{
  input: CredencialIntegracaoInput
}>

export type SalvarCredencialIntegracaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarCredencialIntegracao: {
    readonly __typename?: 'SalvarCredencialIntegracaoPayload'
    readonly userPassword: {
      readonly __typename?: 'CredenciaIntegracaoUserPasswordPayload'
      readonly user: string
      readonly password: string
    }
  }
}

export type InativarSistemaExternoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarSistemaExternoMutation = {
  readonly __typename?: 'Mutation'
  readonly inativarSistemaExterno: { readonly __typename?: 'SistemaExterno'; readonly id: string }
}

export type SalvarSistemaExternoMutationVariables = Exact<{
  input: SalvarSistemaExternoInput
}>

export type SalvarSistemaExternoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarSistemaExterno: {
    readonly __typename?: 'SalvarSistemaExternoPayload'
    readonly chaveAssinatura: string
  }
}

export type SistemasExternosQueryVariables = Exact<{
  input: SistemaExternoQueryInput
}>

export type SistemasExternosQuery = {
  readonly __typename?: 'Query'
  readonly sistemasExternos: {
    readonly __typename?: 'SistemaExternoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'SistemaExterno'
      readonly id: string
      readonly nome: string
      readonly url: string
      readonly nomeResponsavel: string
      readonly email: string
      readonly ativo: boolean
      readonly tipoPessoa: TipoPessoaEnum
      readonly cpfCnpj: string
      readonly tipo: TipoSistemaExternoEnum
      readonly municipios: ReadonlyArray<{
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
      }>
      readonly perfis: ReadonlyArray<{ readonly __typename?: 'Perfil'; readonly id: string; readonly nome: string }>
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CuidadoCompartilhadoEvolucaoGarantiaAcessoFragmentFragment = {
  readonly __typename?: 'CuidadoCompartilhadoEvolucao'
  readonly id: string
  readonly condutaAgendamento?: CondutaCuidadoCompartilhadoEnum | null
  readonly cuidadoCompartilhado: {
    readonly __typename?: 'CuidadoCompartilhado'
    readonly id: string
    readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
    readonly lotacaoSolicitante: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly area?: string | null
      } | null
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly email?: string | null
      }
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
    }
  }
  readonly lotacaoExecutante?: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly area?: string | null
    } | null
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly email?: string | null
    }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
  } | null
}

export type GarantiaAcessoCidadaoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GarantiaAcessoCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
    readonly sexo: SexoEnum
    readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
    readonly faleceu?: boolean | null
    readonly cidadaoVinculacaoEquipe?: {
      readonly __typename?: 'CidadaoVinculacaoEquipe'
      readonly id?: string | null
      readonly unidadeSaude?: { readonly __typename?: 'UnidadeSaude'; readonly id: string } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        }
      } | null
    } | null
  }
}

export type GarantiaAcessoQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type GarantiaAcessoQuery = {
  readonly __typename?: 'Query'
  readonly garantiaAcessoItemById: {
    readonly __typename?: 'ListaEspera'
    readonly id?: string | null
    readonly motivoEspera?: string | null
    readonly tipoAtendimento?: ListaEsperaTipoAtendimentoEnum | null
    readonly dataEntrada?: any | null
    readonly cidadao?: {
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly telefoneResidencial?: string | null
      readonly telefoneCelular?: string | null
      readonly telefoneContato?: string | null
      readonly faleceu?: boolean | null
    } | null
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null
    readonly tipoServico?: { readonly __typename?: 'TipoServico'; readonly id: string; readonly nome: string } | null
    readonly cuidadoCompartilhadoEvolucao?: {
      readonly __typename?: 'CuidadoCompartilhadoEvolucao'
      readonly id: string
      readonly condutaAgendamento?: CondutaCuidadoCompartilhadoEnum | null
      readonly cuidadoCompartilhado: {
        readonly __typename?: 'CuidadoCompartilhado'
        readonly id: string
        readonly lotacaoSolicitante: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly ativo: boolean
          readonly importada: boolean
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
            readonly email?: string | null
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
        }
      }
      readonly lotacaoExecutante?: {
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly ativo: boolean
        readonly importada: boolean
        readonly profissional: {
          readonly __typename?: 'Profissional'
          readonly id: string
          readonly nome: string
          readonly cpf: string
          readonly email?: string | null
        }
        readonly cbo: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        }
      } | null
    } | null
  }
}

export type GarantiaAcessoTableQueryVariables = Exact<{
  input: GarantiaAcessoFilter
}>

export type GarantiaAcessoTableQuery = {
  readonly __typename?: 'Query'
  readonly garantiaAcessoByUnidadeSaudeId: {
    readonly __typename?: 'GarantiaAcessoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ListaEspera'
      readonly id?: string | null
      readonly motivoEspera?: string | null
      readonly dataEntrada?: any | null
      readonly dataSaida?: any | null
      readonly tipoAtendimento?: ListaEsperaTipoAtendimentoEnum | null
      readonly qtdCidadaoPresente?: number | null
      readonly cidadao?: {
        readonly __typename?: 'Cidadao'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly dataNascimento?: any | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly telefoneResidencial?: string | null
        readonly telefoneCelular?: string | null
        readonly telefoneContato?: string | null
        readonly faleceu?: boolean | null
        readonly prontuario?: { readonly __typename?: 'Prontuario'; readonly id: string } | null
      } | null
      readonly unidadeSaude?: { readonly __typename?: 'UnidadeSaude'; readonly id: string } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly area?: string | null
      } | null
      readonly tipoServico?: { readonly __typename?: 'TipoServico'; readonly id: string; readonly nome: string } | null
      readonly cuidadoCompartilhadoEvolucao?: {
        readonly __typename?: 'CuidadoCompartilhadoEvolucao'
        readonly id: string
        readonly condutaAgendamento?: CondutaCuidadoCompartilhadoEnum | null
        readonly cuidadoCompartilhado: {
          readonly __typename?: 'CuidadoCompartilhado'
          readonly id: string
          readonly classificacaoPrioridadeAtual: ClassificacaoPrioridadeCuidadoEnum
          readonly lotacaoSolicitante: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly equipe?: {
              readonly __typename?: 'Equipe'
              readonly id: string
              readonly nome: string
              readonly area?: string | null
            } | null
            readonly profissional: {
              readonly __typename?: 'Profissional'
              readonly id: string
              readonly nome: string
              readonly email?: string | null
            }
            readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          }
        }
        readonly lotacaoExecutante?: {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly area?: string | null
          } | null
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly email?: string | null
          }
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
        } | null
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type UnidadesSaudeByGarantiaAcessoCidadaoQueryVariables = Exact<{
  input: UnidadesSaudeByGarantiaAcessoCidadaoInput
}>

export type UnidadesSaudeByGarantiaAcessoCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly unidadesSaudeByGarantiaAcessoCidadao: ReadonlyArray<{
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
  }>
}

export type AgendarConsultaGarantiaAcessoMutationVariables = Exact<{
  input: GarantiaAcessoAgendarConsultaInput
}>

export type AgendarConsultaGarantiaAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly agendarConsultaGarantiaAcesso: string
}

export type AdicionarGarantiaAcessoCeoMutationVariables = Exact<{
  input: GarantiaAcessoItemCreateInput
}>

export type AdicionarGarantiaAcessoCeoMutation = {
  readonly __typename?: 'Mutation'
  readonly adicionarCidadaoGarantiaAcessoCeo: string
}

export type AdicionarGarantiaAcessoMutationVariables = Exact<{
  input: GarantiaAcessoItemCreateInput
}>

export type AdicionarGarantiaAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly adicionarCidadaoGarantiaAcesso: string
}

export type EditarCidadaoGarantiaAcessoMutationVariables = Exact<{
  input: GarantiaAcessoItemUpdateInput
}>

export type EditarCidadaoGarantiaAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly editarCidadaoGarantiaAcesso: string
}

export type RemoverCidadaoGarantiaAcessoMutationVariables = Exact<{
  input: GarantiaAcessoItemDeleteInput
}>

export type RemoverCidadaoGarantiaAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly removerCidadaoGarantiaAcesso: string
}

export type LoginMutationVariables = Exact<{
  input: LoginInput
}>

export type LoginMutation = {
  readonly __typename?: 'Mutation'
  readonly login: { readonly __typename?: 'LoginPayload'; readonly success: boolean }
}

export type AcessoEstagioQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AcessoEstagioQuery = {
  readonly __typename?: 'Query'
  readonly estagio: {
    readonly __typename?: 'Estagio'
    readonly id: string
    readonly ativo: boolean
    readonly lotacaoSupervisora: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly descricao?: string | null
      }
    } | null
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly unidadeSaude: { readonly __typename?: 'UnidadeSaude'; readonly id: string; readonly nome?: string | null }
  }
}

export type SelecionarAcessoMutationVariables = Exact<{
  input: SelecionarAcessoInput
}>

export type SelecionarAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly selecionarAcesso?: {
    readonly __typename?: 'Sessao'
    readonly id: string
    readonly recursos?: ReadonlyArray<string | null> | null
    readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    readonly acesso?:
      | { readonly __typename?: 'AdministradorGeral'; readonly id: string; readonly moduloInicial?: string | null }
      | { readonly __typename?: 'AdministradorMunicipal'; readonly id: string; readonly moduloInicial?: string | null }
      | { readonly __typename?: 'Estagio'; readonly id: string; readonly moduloInicial?: string | null }
      | { readonly __typename?: 'GestorEstadual'; readonly id: string; readonly moduloInicial?: string | null }
      | { readonly __typename?: 'GestorMunicipal'; readonly id: string; readonly moduloInicial?: string | null }
      | { readonly __typename?: 'Lotacao'; readonly id: string; readonly moduloInicial?: string | null }
      | null
  } | null
}

export type ImunobiologicoComboQueryVariables = Exact<{
  input: ImunobiologicoQueryInput
}>

export type ImunobiologicoComboQuery = {
  readonly __typename?: 'Query'
  readonly imunobiologicos: {
    readonly __typename?: 'ImunobiologicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Imunobiologico'
      readonly id: string
      readonly sigla: string
      readonly nome: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type LoteHasCadastroQueryVariables = Exact<{
  input: LoteImunobiologicoInput
}>

export type LoteHasCadastroQuery = { readonly __typename?: 'Query'; readonly loteHasCadastro?: boolean | null }

export type ExcluirLoteImunobiologicoMutationVariables = Exact<{
  idLote: Scalars['ID']['input']
}>

export type ExcluirLoteImunobiologicoMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirLoteImunobiologico?: string | null
}

export type LoteImunobiologicoFabricanteQueryVariables = Exact<{
  input: ImunobiologicoFabricanteQueryInput
}>

export type LoteImunobiologicoFabricanteQuery = {
  readonly __typename?: 'Query'
  readonly fabricantesImunobiologico: {
    readonly __typename?: 'ImunobiologicoFabricanteQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ImunobiologicoFabricante'
      readonly id: string
      readonly nome: string
      readonly codigoRnds?: string | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type LoteImunobiologicoQueryVariables = Exact<{
  input: LoteImunobiologicoQueryInput
}>

export type LoteImunobiologicoQuery = {
  readonly __typename?: 'Query'
  readonly lotesImunobiologico: {
    readonly __typename?: 'LotesImunobiologicoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'LoteImunobiologico'
      readonly id: string
      readonly lote?: string | null
      readonly validade?: any | null
      readonly ativo?: boolean | null
      readonly fabricante?: {
        readonly __typename?: 'ImunobiologicoFabricante'
        readonly id: string
        readonly nome: string
        readonly codigoRnds?: string | null
      } | null
      readonly imunobiologico?: {
        readonly __typename?: 'Imunobiologico'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type SetStatusLoteImunobiologicoMutationVariables = Exact<{
  input: LoteImunobiologicoInput
  ativado?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SetStatusLoteImunobiologicoMutation = {
  readonly __typename?: 'Mutation'
  readonly setStatusLoteImunobiologico?: string | null
}

export type SalvarLoteImunobiologicoMutationVariables = Exact<{
  input: LoteImunobiologicoInput
}>

export type SalvarLoteImunobiologicoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarLoteImunobiologico?: { readonly __typename?: 'LoteImunobiologico'; readonly id: string } | null
}

export type ExibirNotificacaoNovidadesMutationVariables = Exact<{ [key: string]: never }>

export type ExibirNotificacaoNovidadesMutation = {
  readonly __typename?: 'Mutation'
  readonly exibirNotificacaoNovidades: {
    readonly __typename?: 'Usuario'
    readonly id: string
    readonly notificaNovidadesVersao: boolean
  }
}

export type VisualizouNovidadesMutationVariables = Exact<{ [key: string]: never }>

export type VisualizouNovidadesMutation = { readonly __typename?: 'Mutation'; readonly visualizarNovidades: boolean }

export type VisualizarNovidadesQueryVariables = Exact<{ [key: string]: never }>

export type VisualizarNovidadesQuery = {
  readonly __typename?: 'Query'
  readonly sessao?: {
    readonly __typename?: 'Sessao'
    readonly id: string
    readonly profissional: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly usuario: { readonly __typename?: 'Usuario'; readonly id: string; readonly visualizouNovidades: boolean }
    }
  } | null
}

export type MarcarNotificacaoComoLidaMutationVariables = Exact<{
  codigoExterno: Scalars['ID']['input']
  tipoTopico: TipoTopicoNotificacaoEnum
}>

export type MarcarNotificacaoComoLidaMutation = {
  readonly __typename?: 'Mutation'
  readonly marcarNotificacaoComoLida: boolean
}

export type VisualizarTodasNotificacoesByTipoTopicoMutationVariables = Exact<{
  tipoTopico: TipoTopicoNotificacaoEnum
}>

export type VisualizarTodasNotificacoesByTipoTopicoMutation = {
  readonly __typename?: 'Mutation'
  readonly visualizarTodasNotificacoesByTipoTopico: any
}

export type AtivarPerfilMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtivarPerfilMutation = {
  readonly __typename?: 'Mutation'
  readonly ativarPerfil: { readonly __typename?: 'Perfil'; readonly id: string; readonly ativo: boolean }
}

export type CriarPerfilMutationVariables = Exact<{
  input: PerfilInput
}>

export type CriarPerfilMutation = {
  readonly __typename?: 'Mutation'
  readonly criarPerfil: {
    readonly __typename?: 'Perfil'
    readonly id: string
    readonly nome: string
    readonly ativo: boolean
  }
}

export type ExcluirPerfilMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirPerfilMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirPerfil: { readonly __typename?: 'ExcluirPerfilPayload'; readonly id: string }
}

export type InativarPerfilMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarPerfilMutation = {
  readonly __typename?: 'Mutation'
  readonly inativarPerfil: { readonly __typename?: 'Perfil'; readonly id: string; readonly ativo: boolean }
}

export type RecursosQueryVariables = Exact<{
  tipoAcesso: TipoAcesso
}>

export type RecursosQuery = { readonly __typename?: 'Query'; readonly recursos: ReadonlyArray<string> }

export type PerfilDetailQueryVariables = Exact<{
  perfilId: Scalars['ID']['input']
}>

export type PerfilDetailQuery = {
  readonly __typename?: 'Query'
  readonly perfil?: {
    readonly __typename?: 'Perfil'
    readonly id: string
    readonly nome: string
    readonly tipoPerfil: TipoAcesso
    readonly recursos: ReadonlyArray<string | null>
    readonly perfilPadrao?: string | null
  } | null
}

export type AtualizarPerfilMutationVariables = Exact<{
  input: PerfilInput
}>

export type AtualizarPerfilMutation = {
  readonly __typename?: 'Mutation'
  readonly atualizarPerfil: {
    readonly __typename?: 'Perfil'
    readonly id: string
    readonly nome: string
    readonly ativo: boolean
  }
}

export type PerfilEditQueryVariables = Exact<{
  perfilId: Scalars['ID']['input']
}>

export type PerfilEditQuery = {
  readonly __typename?: 'Query'
  readonly perfil?: {
    readonly __typename?: 'Perfil'
    readonly id: string
    readonly nome: string
    readonly tipoPerfil: TipoAcesso
    readonly recursos: ReadonlyArray<string | null>
    readonly perfilPadrao?: string | null
  } | null
}

export type PerfilTableQueryVariables = Exact<{
  input: PerfisQueryInput
}>

export type PerfilTableQuery = {
  readonly __typename?: 'Query'
  readonly perfis: {
    readonly __typename?: 'PerfisQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Perfil'
      readonly id: string
      readonly nome: string
      readonly ativo: boolean
      readonly tipoPerfil: TipoAcesso
      readonly perfilPadrao?: string | null
      readonly actions: {
        readonly __typename?: 'PerfilActions'
        readonly excluir: { readonly __typename?: 'Action'; readonly enabled: boolean; readonly hint?: string | null }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ResponderPesquisaSatisfacaoMutationVariables = Exact<{
  input: RespostaPesquisa
}>

export type ResponderPesquisaSatisfacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly responderPesquisaSatisfacao: {
    readonly __typename?: 'Usuario'
    readonly id: string
    readonly mostrarPesquisaSatisfacao: boolean
  }
}

export type ProfissionalEditQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ProfissionalEditQuery = {
  readonly __typename?: 'Query'
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly nomeCivil: string
    readonly nomeSocial?: string | null
    readonly numeroConselhoClasse?: string | null
    readonly sexo?: string | null
    readonly telefone?: string | null
    readonly cns?: string | null
    readonly cpf: string
    readonly dataNascimento?: any | null
    readonly email?: string | null
    readonly conselhoClasse?: {
      readonly __typename?: 'ConselhoClasse'
      readonly id: string
      readonly descricao?: string | null
      readonly sigla: string
    } | null
    readonly ufEmissoraConselhoClasse?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly bairro?: string | null
      readonly cep?: string | null
      readonly complemento?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly pontoReferencia?: string | null
      readonly semNumero?: boolean | null
      readonly municipio?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly ibge?: string | null
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
        readonly numeroDne: string
      } | null
      readonly uf?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly lotacoes: ReadonlyArray<{ readonly __typename?: 'Lotacao'; readonly id: string; readonly ativo: boolean }>
    readonly estagios: ReadonlyArray<{ readonly __typename?: 'Estagio'; readonly id: string; readonly ativo: boolean }>
  }
}

export type SalvarProfissionalMutationVariables = Exact<{
  input: ProfissionalInput
}>

export type SalvarProfissionalMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarProfissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
}

export type ConfiguracaoAgendaOnlineLotacaoQueryVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
}>

export type ConfiguracaoAgendaOnlineLotacaoQuery = {
  readonly __typename?: 'Query'
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly hasConfiguracaoAgendaOnline?: boolean | null
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
    } | null
    readonly unidadeSaude: { readonly __typename?: 'UnidadeSaude'; readonly id: string; readonly nome?: string | null }
    readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    readonly gradeConfiguracaoAgendaOnline?: {
      readonly __typename?: 'ConfiguracaoAgendaOnlineLotacao'
      readonly horariosConsolidados: ReadonlyArray<string | null>
      readonly configuracoesSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoSemanaAgendaOnline'
        readonly diaSemana: DiaSemanaEnum
        readonly configuracoes: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoHorarioAgendaOnline'
          readonly horario: string
          readonly ativo: boolean
        } | null>
      }> | null
    } | null
    readonly actions: {
      readonly __typename?: 'LotacaoActions'
      readonly permissaoConfigurarAgendaOnline: { readonly __typename?: 'Action'; readonly enabled: boolean }
    }
  }
}

export type SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables = Exact<{
  configuracaoAgendaOnlineLotacaoInput: ConfiguracaoAgendaOnlineLotacaoInput
}>

export type SalvarConfiguracaoAgendaOnlineLotacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarConfiguracaoAgendaOnlineLotacao: boolean
}

export type ConfiguracaoAgendaLotacaoQueryVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
}>

export type ConfiguracaoAgendaLotacaoQuery = {
  readonly __typename?: 'Query'
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly hasConfiguracaoAgenda?: boolean | null
    readonly hasConfiguracaoAgendaOnline?: boolean | null
    readonly hasAgendamentoFuturo?: boolean | null
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly ine: string
      readonly nome: string
    } | null
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
    readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    readonly configuracaoAgenda?: {
      readonly __typename?: 'ConfiguracaoAgendaLotacao'
      readonly configuracaoHorarioAgenda: {
        readonly __typename?: 'ConfiguracaoHorarioAgenda'
        readonly configuracaoDiasSemana?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoDiaSemana'
          readonly diaSemana: DiaSemanaEnum
          readonly periodos?: ReadonlyArray<{
            readonly __typename?: 'ConfiguracaoPeriodo'
            readonly periodo: PeriodoEnum
            readonly horarioInicial?: string | null
            readonly horarioFinal?: string | null
          }> | null
        }> | null
      }
    } | null
    readonly actions: {
      readonly __typename?: 'LotacaoActions'
      readonly permissaoConfigurarAgenda: { readonly __typename?: 'Action'; readonly enabled: boolean }
      readonly permissaoFecharAgenda: { readonly __typename?: 'Action'; readonly enabled: boolean }
    }
  }
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
  readonly duracaoAtendimentoPadraoMunicipio?: {
    readonly __typename?: 'DuracaoAtendimentoPadraoMunicipio'
    readonly duracaoAtendimentoPadraoMunicipio: number
  } | null
  readonly configuracaoHorariosMunicipio: {
    readonly __typename?: 'ConfiguracaoAgendaMunicipal'
    readonly id: string
    readonly configuracaoHorarioAgenda: {
      readonly __typename?: 'ConfiguracaoHorarioAgenda'
      readonly configuracaoDiasSemana?: ReadonlyArray<{
        readonly __typename?: 'ConfiguracaoDiaSemana'
        readonly diaSemana: DiaSemanaEnum
        readonly periodos?: ReadonlyArray<{
          readonly __typename?: 'ConfiguracaoPeriodo'
          readonly periodo: PeriodoEnum
          readonly horarioInicial?: string | null
          readonly horarioFinal?: string | null
        }> | null
      }> | null
    }
  }
}

export type DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DesativarConfiguracaoAgendaOnlineLotacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly desativarConfiguracaoAgendaOnlineLotacao: boolean
}

export type ExcluirConfiguracaoAgendaLotacaoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirConfiguracaoAgendaLotacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirConfiguracaoAgendaLotacao: boolean
}

export type SalvarConfiguracaoAgendaLotacaoMutationVariables = Exact<{
  configuracaoAgendaLotacaoInput: ConfiguracaoAgendaLotacaoInput
}>

export type SalvarConfiguracaoAgendaLotacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarConfiguracaoAgendaLotacao: boolean
}

export type ExcluirFechamentoAgendaMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirFechamentoAgendaMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirFechamento?: string | null
}

export type FechamentoAgendaTableQueryVariables = Exact<{
  input: FechamentoAgendaQueryInput
}>

export type FechamentoAgendaTableQuery = {
  readonly __typename?: 'Query'
  readonly fechamentos: {
    readonly __typename?: 'FechamentoAgendaQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FechamentoAgenda'
      readonly id?: string | null
      readonly dataInicial?: any | null
      readonly dataFinal?: any | null
      readonly motivo?: string | null
      readonly especifique?: string | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type SalvarFechamentoAgendaMutationVariables = Exact<{
  input: FechamentoAgendaInput
}>

export type SalvarFechamentoAgendaMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarFechamento?: { readonly __typename?: 'FechamentoAgenda'; readonly id?: string | null } | null
}

export type ProfissionalAcessosQueryVariables = Exact<{
  profissionalId: Scalars['ID']['input']
}>

export type ProfissionalAcessosQuery = {
  readonly __typename?: 'Query'
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly id: string
    readonly cns?: string | null
    readonly acessos?: ReadonlyArray<
      | {
          readonly __typename?: 'AdministradorGeral'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly ativo: boolean
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          } | null>
          readonly actions: {
            readonly __typename?: 'AcessoActions'
            readonly permissaoEdicao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoExclusao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoAtivacaoInativacao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          }
        }
      | {
          readonly __typename?: 'AdministradorMunicipal'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly ativo: boolean
          readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          } | null>
          readonly actions: {
            readonly __typename?: 'AcessoActions'
            readonly permissaoEdicao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoExclusao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoAtivacaoInativacao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          }
        }
      | {
          readonly __typename?: 'Estagio'
          readonly nivelTecnico: boolean
          readonly dataFimVigencia: any
          readonly instituicaoEnsino?: string | null
          readonly dataInicioVigencia: any
          readonly id: string
          readonly tipo: TipoAcesso
          readonly ativo: boolean
          readonly lotacaoSupervisora: {
            readonly __typename?: 'Lotacao'
            readonly id: string
            readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
            readonly cbo: {
              readonly __typename?: 'Cbo'
              readonly id: string
              readonly nome: string
              readonly cbo2002: string
            }
          }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
            }
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          }>
          readonly actions: {
            readonly __typename?: 'AcessoActions'
            readonly permissaoEdicao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoExclusao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoAtivacaoInativacao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          }
        }
      | {
          readonly __typename?: 'GestorEstadual'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly ativo?: boolean | null
          readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          } | null>
          readonly actions: {
            readonly __typename?: 'AcessoActions'
            readonly permissaoEdicao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoExclusao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoAtivacaoInativacao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          }
        }
      | {
          readonly __typename?: 'GestorMunicipal'
          readonly id: string
          readonly tipo: TipoAcesso
          readonly ativo?: boolean | null
          readonly municipio: { readonly __typename?: 'Municipio'; readonly id: string; readonly nome: string }
          readonly perfis: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          } | null>
          readonly actions: {
            readonly __typename?: 'AcessoActions'
            readonly permissaoEdicao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoExclusao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoAtivacaoInativacao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          }
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly importada: boolean
          readonly hasConfiguracaoAgenda?: boolean | null
          readonly hasConfiguracaoAgendaOnline?: boolean | null
          readonly hasAgendamentoFuturo?: boolean | null
          readonly id: string
          readonly tipo: TipoAcesso
          readonly ativo: boolean
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
          readonly equipe?: {
            readonly __typename?: 'Equipe'
            readonly id: string
            readonly nome: string
            readonly ine: string
            readonly tipoEquipe: {
              readonly __typename?: 'TipoEquipe'
              readonly id: string
              readonly descricao?: string | null
            }
          } | null
          readonly unidadeSaude: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          }
          readonly perfis?: ReadonlyArray<{
            readonly __typename?: 'Perfil'
            readonly id: string
            readonly nome: string
            readonly ativo: boolean
          } | null> | null
          readonly actions: {
            readonly __typename?: 'LotacaoActions'
            readonly permissaoConfigurarAgenda: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoConfigurarAgendaOnline: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoFecharAgenda: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoEdicao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoExclusao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
            readonly permissaoAtivacaoInativacao: {
              readonly __typename?: 'Action'
              readonly enabled: boolean
              readonly hint?: string | null
            }
          }
        }
    > | null
  }
}

export type ProfissionalDetailFragment = {
  readonly __typename?: 'Profissional'
  readonly cns?: string | null
  readonly cpf: string
  readonly dataNascimento?: any | null
  readonly email?: string | null
  readonly id: string
  readonly nomeCivil: string
  readonly nomeSocial?: string | null
  readonly numeroConselhoClasse?: string | null
  readonly sexo?: string | null
  readonly telefone?: string | null
  readonly conselhoClasse?: {
    readonly __typename?: 'ConselhoClasse'
    readonly id: string
    readonly descricao?: string | null
    readonly sigla: string
  } | null
  readonly endereco?: {
    readonly __typename?: 'Endereco'
    readonly bairro?: string | null
    readonly cep?: string | null
    readonly complemento?: string | null
    readonly logradouro?: string | null
    readonly numero?: string | null
    readonly pontoReferencia?: string | null
    readonly semNumero?: boolean | null
    readonly municipio?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly ibge?: string | null
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
    } | null
    readonly tipoLogradouro?: {
      readonly __typename?: 'TipoLogradouro'
      readonly id: string
      readonly nome: string
      readonly numeroDne: string
    } | null
    readonly uf?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
  } | null
  readonly ufEmissoraConselhoClasse?: {
    readonly __typename?: 'UF'
    readonly id: string
    readonly nome: string
    readonly sigla: string
  } | null
}

export type ProfissionalDetailQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ProfissionalDetailQuery = {
  readonly __typename?: 'Query'
  readonly profissional: {
    readonly __typename?: 'Profissional'
    readonly cns?: string | null
    readonly cpf: string
    readonly dataNascimento?: any | null
    readonly email?: string | null
    readonly id: string
    readonly nomeCivil: string
    readonly nomeSocial?: string | null
    readonly numeroConselhoClasse?: string | null
    readonly sexo?: string | null
    readonly telefone?: string | null
    readonly lotacoes: ReadonlyArray<{
      readonly __typename?: 'Lotacao'
      readonly ativo: boolean
      readonly id: string
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
        readonly tipoEquipe: {
          readonly __typename?: 'TipoEquipe'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        }
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
    }>
    readonly conselhoClasse?: {
      readonly __typename?: 'ConselhoClasse'
      readonly id: string
      readonly descricao?: string | null
      readonly sigla: string
    } | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly bairro?: string | null
      readonly cep?: string | null
      readonly complemento?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly pontoReferencia?: string | null
      readonly semNumero?: boolean | null
      readonly municipio?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly ibge?: string | null
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
        readonly numeroDne: string
      } | null
      readonly uf?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly ufEmissoraConselhoClasse?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
  }
}

export type AcessoCreateQueryVariables = Exact<{
  profissionalId: Scalars['ID']['input']
}>

export type AcessoCreateQuery = {
  readonly __typename?: 'Query'
  readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
}

export type AcessoEditQueryVariables = Exact<{
  acessoId: Scalars['ID']['input']
  profissionalId: Scalars['ID']['input']
}>

export type AcessoEditQuery = {
  readonly __typename?: 'Query'
  readonly acesso:
    | {
        readonly __typename?: 'AdministradorGeral'
        readonly tipo: TipoAcesso
        readonly actions: {
          readonly __typename?: 'AcessoActions'
          readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
          readonly ativo: boolean
        } | null>
      }
    | {
        readonly __typename?: 'AdministradorMunicipal'
        readonly tipo: TipoAcesso
        readonly actions: {
          readonly __typename?: 'AcessoActions'
          readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
          readonly ativo: boolean
        } | null>
      }
    | {
        readonly __typename?: 'Estagio'
        readonly tipo: TipoAcesso
        readonly actions: {
          readonly __typename?: 'AcessoActions'
          readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
          readonly ativo: boolean
        }>
      }
    | {
        readonly __typename?: 'GestorEstadual'
        readonly tipo: TipoAcesso
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
        readonly actions: {
          readonly __typename?: 'AcessoActions'
          readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
          readonly ativo: boolean
        } | null>
      }
    | {
        readonly __typename?: 'GestorMunicipal'
        readonly tipo: TipoAcesso
        readonly municipio: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        }
        readonly actions: {
          readonly __typename?: 'AcessoActions'
          readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
        }
        readonly perfis: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
          readonly ativo: boolean
        } | null>
      }
    | {
        readonly __typename?: 'Lotacao'
        readonly tipo: TipoAcesso
        readonly actions: {
          readonly __typename?: 'LotacaoActions'
          readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
        }
        readonly perfis?: ReadonlyArray<{
          readonly __typename?: 'Perfil'
          readonly id: string
          readonly nome: string
          readonly ativo: boolean
        } | null> | null
      }
  readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
}

export type SalvarAcessoMutationVariables = Exact<{
  input: OutroAcessoInput
}>

export type SalvarAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarOutroAcesso:
    | { readonly __typename?: 'AdministradorGeral'; readonly id: string }
    | { readonly __typename?: 'AdministradorMunicipal'; readonly id: string }
    | { readonly __typename?: 'Estagio'; readonly id: string }
    | { readonly __typename?: 'GestorEstadual'; readonly id: string }
    | { readonly __typename?: 'GestorMunicipal'; readonly id: string }
    | { readonly __typename?: 'Lotacao'; readonly id: string }
}

export type AgendaEmConflitoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AgendaEmConflitoQuery = { readonly __typename?: 'Query'; readonly agendaEmConflito: boolean }

export type ExcluirLotacaoMutationVariables = Exact<{
  lotacaoId: Scalars['ID']['input']
}>

export type ExcluirLotacaoMutation = { readonly __typename?: 'Mutation'; readonly excluirLotacao: string }

export type ProfissionaisLotacoesSectionQueryVariables = Exact<{ [key: string]: never }>

export type ProfissionaisLotacoesSectionQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly agendaOnline?: { readonly __typename?: 'AgendaOnline'; readonly ativa: boolean } | null
  }
}

export type AlterarLotacaoMutationVariables = Exact<{
  input: AlterarLotacaoInput
}>

export type AlterarLotacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarLotacao: { readonly __typename?: 'Lotacao'; readonly id: string }
}

export type CriarLotacaoMutationVariables = Exact<{
  input: LotacaoInput
}>

export type CriarLotacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly criarLotacao: { readonly __typename?: 'Lotacao'; readonly id: string }
}

export type LotacaoCreateQueryVariables = Exact<{
  profissionalId: Scalars['ID']['input']
}>

export type LotacaoCreateQuery = {
  readonly __typename?: 'Query'
  readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
}

export type LotacaoEditViewQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type LotacaoEditViewQuery = {
  readonly __typename?: 'Query'
  readonly lotacao: {
    readonly __typename?: 'Lotacao'
    readonly id: string
    readonly importada: boolean
    readonly hasConfiguracaoAgenda?: boolean | null
    readonly atualizaPerfil?: boolean | null
    readonly ativo: boolean
    readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string; readonly cbo2002: string }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null
    readonly perfis?: ReadonlyArray<{
      readonly __typename?: 'Perfil'
      readonly id: string
      readonly nome: string
      readonly ativo: boolean
    } | null> | null
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
    readonly actions: {
      readonly __typename?: 'LotacaoActions'
      readonly permissaoEdicao: { readonly __typename?: 'Action'; readonly enabled: boolean }
    }
  }
}

export type AlterarAtivacaoAcessoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AlterarAtivacaoAcessoMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarAtivacaoAcesso: boolean
}

export type ExcluirAcessoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirAcessoMutation = { readonly __typename?: 'Mutation'; readonly excluirAcesso: string }

export type DefinirSenhaProvisoriaMutationVariables = Exact<{
  input: DefinirSenhaProvisoriaInput
}>

export type DefinirSenhaProvisoriaMutation = {
  readonly __typename?: 'Mutation'
  readonly definirSenhaProvisoria: boolean
}

export type ExcluirProfissionalMutationVariables = Exact<{
  profissionalId: Scalars['ID']['input']
}>

export type ExcluirProfissionalMutation = { readonly __typename?: 'Mutation'; readonly excluirProfissional: string }

export type ProfissionalTableQueryVariables = Exact<{
  input: ProfissionaisQueryInput
}>

export type ProfissionalTableQuery = {
  readonly __typename?: 'Query'
  readonly profissionais: {
    readonly __typename?: 'ProfissionaisQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf: string
      readonly cns?: string | null
      readonly lotacoes: ReadonlyArray<{
        readonly __typename?: 'Lotacao'
        readonly id: string
        readonly ativo: boolean
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }>
      readonly estagios: ReadonlyArray<{
        readonly __typename?: 'Estagio'
        readonly id: string
        readonly ativo: boolean
        readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      }>
      readonly usuario: { readonly __typename?: 'Usuario'; readonly id: string; readonly bloqueado: boolean }
      readonly actions: {
        readonly __typename?: 'ProfissionalActions'
        readonly redefinirSenha: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type SolicitarRedefinicaoSenhaMutationVariables = Exact<{
  input: SolicitarRecuperacaoSenhaInput
}>

export type SolicitarRedefinicaoSenhaMutation = {
  readonly __typename?: 'Mutation'
  readonly solicitarRedefinicaoSenha: {
    readonly __typename?: 'QRCode'
    readonly value: string
    readonly base64PngImage: string
  }
}

export type SalvarJustificativaVisualizarProntuarioMutationVariables = Exact<{
  input: JustificativaVisualizarProntuarioInput
}>

export type SalvarJustificativaVisualizarProntuarioMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarJustificativaVisualizarProntuario: string
}

export type RecuperarSenhaBloqueadoQueryVariables = Exact<{ [key: string]: never }>

export type RecuperarSenhaBloqueadoQuery = { readonly __typename?: 'Query'; readonly recuperarSenhaBloqueado: boolean }

export type RedefinirSenhaMutationVariables = Exact<{
  input: RedefinirSenhaInput
}>

export type RedefinirSenhaMutation = { readonly __typename?: 'Mutation'; readonly redefinirSenha: boolean }

export type SolicitacaoRecuperarSenhaMutationVariables = Exact<{
  input: SolicitarRecuperacaoSenhaInput
}>

export type SolicitacaoRecuperarSenhaMutation = {
  readonly __typename?: 'Mutation'
  readonly solicitarRecuperarSenha: boolean
}

export type AtendimentoRegistroTardioQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AtendimentoRegistroTardioQuery = {
  readonly __typename?: 'Query'
  readonly atendimento: {
    readonly __typename?: 'Atendimento'
    readonly id: string
    readonly justificativa?: RegistroTardioJustificativaEnum | null
    readonly iniciadoEm: any
    readonly cidadao: {
      readonly __typename?: 'CidadaoBasico'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly dataNascimento?: any | null
    }
    readonly responsavel?:
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
          readonly cbo: {
            readonly __typename?: 'Cbo'
            readonly id: string
            readonly nome: string
            readonly cbo2002: string
          }
        }
      | null
    readonly actions: {
      readonly __typename?: 'AtendimentoActions'
      readonly editar?: { readonly __typename?: 'Action'; readonly enabled: boolean } | null
    }
    readonly localAtendimento?: {
      readonly __typename?: 'LocalAtendimento'
      readonly id: string
      readonly localAtendimentoExibicao?: string | null
    } | null
  }
}

export type EditarRegistroTardioMutationVariables = Exact<{
  input: RegistroTardioInput
}>

export type EditarRegistroTardioMutation = {
  readonly __typename?: 'Mutation'
  readonly editarRegistroTardio: { readonly __typename?: 'Atendimento'; readonly id: string }
}

export type SalvarRegistroTardioMutationVariables = Exact<{
  input: RegistroTardioInput
}>

export type SalvarRegistroTardioMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarRegistroTardio: { readonly __typename?: 'Atendimento'; readonly id: string }
}

export type UltimoAtendimentoProfissionalCidadaoQueryVariables = Exact<{
  input?: InputMaybe<UltimoAtendimentoProfissionalFinalizadoQueryInput>
}>

export type UltimoAtendimentoProfissionalCidadaoQuery = {
  readonly __typename?: 'Query'
  readonly ultimoAtendimentoProfissionalCidadao?: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly finalizadoEm?: any | null
    readonly lotacao: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
      readonly profissional: { readonly __typename?: 'Profissional'; readonly id: string; readonly nome: string }
    }
  } | null
}

export type AbsenteismosQueryVariables = Exact<{
  input: RelatorioGerencialAbsenteismoInput
}>

export type AbsenteismosQuery = {
  readonly __typename?: 'Query'
  readonly absenteismos?: ReadonlyArray<{
    readonly __typename?: 'Absenteismo'
    readonly id: string
    readonly municipio?: string | null
    readonly unidadeSaude?: string | null
    readonly equipe?: string | null
    readonly nomeProfissional?: string | null
    readonly nomeSituacaoAgendamento: string
    readonly categoriaProfissional?: string | null
    readonly turno: string
    readonly intervaloAgendamento: string
    readonly faixaEtaria: string
    readonly cbo?: string | null
    readonly producoes?: string | null
  }> | null
}

export type ModeloPersonalizadoRelatorioGerencialQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ModeloPersonalizadoRelatorioGerencialQuery = {
  readonly __typename?: 'Query'
  readonly modeloPersonalizadoRelatorioGerencialById?: {
    readonly __typename?: 'ModeloPersonalizadoRelatorioGerencial'
    readonly id: string
    readonly nome: string
    readonly isPublico: boolean
    readonly tipoModulo: TipoModuloEnum
    readonly atorPapelCriadorId: string
    readonly modelo: {
      readonly __typename?: 'ModeloRelatorioGerencial'
      readonly unidadePeriodo?: UnidadePeriodoRelatorioGerencialEnum | null
      readonly opcaoSelecionada?: OpcaoSelecionadaRelatorioGerencialEnum | null
      readonly tipoAgrupamento?: TipoAgrupamentoRelatorioGerencialEnum | null
      readonly aggregator: AggregatorRelatorioGerencialEnum
      readonly ciaps: ReadonlyArray<{
        readonly __typename?: 'Ciap'
        readonly id: string
        readonly codigo: string
        readonly descricao: string
      }>
      readonly cids: ReadonlyArray<{
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      }>
      readonly gruposCondicoes: ReadonlyArray<{
        readonly __typename?: 'GrupoCondicao'
        readonly id: string
        readonly grupo: GrupoCondicaoEnum
        readonly ciaps?: ReadonlyArray<{
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null> | null
        readonly cids?: ReadonlyArray<{
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly codigo: string
          readonly nome: string
        } | null> | null
      }>
      readonly campos: ReadonlyArray<{
        readonly __typename?: 'CampoSalvoRelatorioGerencial'
        readonly key: string
        readonly posicao: PosicaoCampoRelatorioGerencialEnum
        readonly items: ReadonlyArray<string>
      }>
    }
  } | null
}

export type ModelosByTipoQueryVariables = Exact<{
  tipoModulo: TipoModuloEnum
}>

export type ModelosByTipoQuery = {
  readonly __typename?: 'Query'
  readonly modelosPersonalizadosByTipoModulo: ReadonlyArray<{
    readonly __typename?: 'ModeloPersonalizadoSelect'
    readonly id: string
    readonly nome: string
    readonly isPublico: boolean
  }>
}

export type EditarModeloPersonalizadoRelatorioGerencialMutationVariables = Exact<{
  input: EditarModeloRelatorioGerencialInput
}>

export type EditarModeloPersonalizadoRelatorioGerencialMutation = {
  readonly __typename?: 'Mutation'
  readonly editarModeloPersonalizadoRelatorioGerencial?: {
    readonly __typename?: 'ModeloPersonalizado'
    readonly id: string
    readonly nome: string
    readonly isPublico: boolean
    readonly tipoModulo: TipoModuloEnum
    readonly modelo: string
  } | null
}

export type ExcluirModeloPersonalizadoRelatorioGerencialMutationVariables = Exact<{
  input: ExcluirModeloRelatorioGerencialInput
}>

export type ExcluirModeloPersonalizadoRelatorioGerencialMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirModeloPersonalizadoRelatorioGerencial?: boolean | null
}

export type SalvarModeloPersonalizadoRelatorioGerencialMutationVariables = Exact<{
  input: SalvarModeloRelatorioGerencialInput
}>

export type SalvarModeloPersonalizadoRelatorioGerencialMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarModeloPersonalizadoRelatorioGerencial?: {
    readonly __typename?: 'ModeloPersonalizado'
    readonly id: string
    readonly nome: string
    readonly isPublico: boolean
    readonly tipoModulo: TipoModuloEnum
    readonly modelo: string
  } | null
}

export type DataUltimoProcessamentoQueryVariables = Exact<{ [key: string]: never }>

export type DataUltimoProcessamentoQuery = {
  readonly __typename?: 'Query'
  readonly dataUltimoProcessamento?: any | null
}

export type InfoProfissionalCpfQueryVariables = Exact<{
  input: CpfContraChaveInput
}>

export type InfoProfissionalCpfQuery = {
  readonly __typename?: 'Query'
  readonly profissionalByCpfContraChave?: { readonly __typename?: 'Profissional'; readonly id: string } | null
}

export type RedefinirSenhaAdminInstalacaoMutationVariables = Exact<{
  input: RedefinirSenhaAdminInstalacaoInput
}>

export type RedefinirSenhaAdminInstalacaoMutation = {
  readonly __typename?: 'Mutation'
  readonly redefinirSenhaAdminInstalacao: boolean
}

export type SaveAdminProfissionalMutationVariables = Exact<{
  input: ProfissionalContraChaveInput
}>

export type SaveAdminProfissionalMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarProfissionalContraChave: { readonly __typename?: 'Profissional'; readonly id: string }
}

export type ValidateNovoAdminQueryVariables = Exact<{
  input: ValidateNovoAdminInput
}>

export type ValidateNovoAdminQuery = { readonly __typename?: 'Query'; readonly validatePermissaoNovoAdmin: boolean }

export type ValidateResetAdminQueryVariables = Exact<{
  input: CpfContraChaveInput
}>

export type ValidateResetAdminQuery = { readonly __typename?: 'Query'; readonly validateResetAdmin: boolean }

export type AlteraAdminMutationVariables = Exact<{
  input: ValidateNovoAdminInput
}>

export type AlteraAdminMutation = {
  readonly __typename?: 'Mutation'
  readonly denifinirNovoAdministrador?: boolean | null
}

export type ChaveByCpfQueryVariables = Exact<{
  cpf: Scalars['String']['input']
}>

export type ChaveByCpfQuery = { readonly __typename?: 'Query'; readonly chaveByCpf: string }

export type ProfissionalAdminDetailQueryVariables = Exact<{
  input: CpfContraChaveInput
}>

export type ProfissionalAdminDetailQuery = {
  readonly __typename?: 'Query'
  readonly profissionalByCpfContraChave?: {
    readonly __typename?: 'Profissional'
    readonly cns?: string | null
    readonly cpf: string
    readonly dataNascimento?: any | null
    readonly email?: string | null
    readonly id: string
    readonly nomeCivil: string
    readonly nomeSocial?: string | null
    readonly numeroConselhoClasse?: string | null
    readonly sexo?: string | null
    readonly telefone?: string | null
    readonly usuario: { readonly __typename?: 'Usuario'; readonly id: string }
    readonly conselhoClasse?: {
      readonly __typename?: 'ConselhoClasse'
      readonly id: string
      readonly descricao?: string | null
      readonly sigla: string
    } | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly bairro?: string | null
      readonly cep?: string | null
      readonly complemento?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly pontoReferencia?: string | null
      readonly semNumero?: boolean | null
      readonly municipio?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly ibge?: string | null
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
        readonly numeroDne: string
      } | null
      readonly uf?: {
        readonly __typename?: 'UF'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      } | null
    } | null
    readonly ufEmissoraConselhoClasse?: {
      readonly __typename?: 'UF'
      readonly id: string
      readonly nome: string
      readonly sigla: string
    } | null
  } | null
}

export type LoadImoveisQueryVariables = Exact<{
  input: ImoveisQueryInput
}>

export type LoadImoveisQuery = {
  readonly __typename?: 'Query'
  readonly imoveis: {
    readonly __typename?: 'ImoveisQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'ImovelDto'
      readonly id: string
      readonly logradouro?: string | null
      readonly bairro?: string | null
      readonly microarea?: string | null
      readonly numero?: string | null
      readonly cep?: string | null
      readonly complemento?: string | null
      readonly tipoLogradouro?: {
        readonly __typename?: 'TipoLogradouro'
        readonly id: string
        readonly nome: string
      } | null
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
        readonly ativo?: boolean | null
      } | null
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
        readonly ativo?: boolean | null
      }
      readonly familias: ReadonlyArray<{
        readonly __typename?: 'Familia'
        readonly id: string
        readonly cidadaosTerritorioBasico: ReadonlyArray<{
          readonly __typename?: 'CidadaoTerritorioBasico'
          readonly id: string
          readonly permissaoReterritorializar?: {
            readonly __typename?: 'Action'
            readonly enabled: boolean
            readonly hint?: string | null
          } | null
          readonly ultimaFichaCadastrada?: {
            readonly __typename?: 'UltimaFichaCadastradaDto'
            readonly id: string
            readonly isProcessado: boolean
          } | null
        }>
        readonly responsavel?: {
          readonly __typename?: 'CidadaoTerritorioBasico'
          readonly id: string
          readonly nome?: string | null
          readonly nomeSocial?: string | null
        } | null
      }>
      readonly permissaoReterritorializar?: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      } | null
      readonly responsavelTecnico?: {
        readonly __typename?: 'ResponsavelTecnicoImovel'
        readonly id: string
        readonly nome: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type IsProcessTerritorioRunningQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type IsProcessTerritorioRunningQuery = {
  readonly __typename?: 'Query'
  readonly isProcessamentoTerritorioRunning: boolean
}

export type ReterritorializarMutationVariables = Exact<{
  input: ReterritorializarInput
}>

export type ReterritorializarMutation = { readonly __typename?: 'Mutation'; readonly reterritorializar: boolean }

export type AtendimentoIndividualRetificacaoViewQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type AtendimentoIndividualRetificacaoViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly tipoAtendimento?: TipoAtendimentoEnum | null
    readonly tipoParticipacaoCidadao?: TipoParticipacaoAtendimentoEnum | null
    readonly tipoParticipacaoProfissionalConvidado?: TipoParticipacaoAtendimentoEnum | null
    readonly racionalidadeSaude?: RacionalidadeEmSaudeEnum | null
    readonly condutas?: ReadonlyArray<CondutaEnum | null> | null
    readonly evolucaoObjetivo?: {
      readonly __typename?: 'EvolucaoObjetivo'
      readonly id: string
      readonly descricao?: string | null
    } | null
    readonly ivcf?: {
      readonly __typename?: 'Ivcf'
      readonly id: string
      readonly resultado: any
      readonly dimensoesAlteradas: string
      readonly dataResultado: any
      readonly riscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum
      readonly aplicacao: ReadonlyArray<{
        readonly __typename?: 'IvcfAplicacao'
        readonly id: string
        readonly pergunta: IvcfPerguntaEnum
        readonly resposta: boolean
      } | null>
    } | null
    readonly marcadorConsumoAlimentar?: {
      readonly __typename?: 'MarcadorConsumoAlimentar'
      readonly id: string
      readonly categoria: FaixaEtariaConsumoAlimentar
      readonly respostas: ReadonlyArray<{
        readonly __typename?: 'RespostaMarcadoresConsumoAlimentar'
        readonly pergunta: PerguntasQuestionarioEnum
        readonly opcoesSelecionadas: ReadonlyArray<OpcaoTipoPerguntaEnum>
      }>
    } | null
    readonly medicoes?: ReadonlyArray<{
      readonly __typename?: 'Medicao'
      readonly dataMedicao: any
      readonly medicaoAnterior?: boolean | null
      readonly valorVacinacaoEmDia?: boolean | null
      readonly id: string
      readonly valorPeso?: number | null
      readonly valorAltura?: number | null
      readonly valorFrequenciaCardiaca?: number | null
      readonly valorPressaoArterial?: string | null
      readonly valorPerimetroCefalico?: number | null
      readonly valorFrequenciaRespiratoria?: number | null
      readonly valorTemperatura?: number | null
      readonly valorSaturacaoO2?: number | null
      readonly valorGlicemia?: number | null
      readonly tipoGlicemia?: TipoGlicemia | null
      readonly perimetroPanturrilha?: number | null
      readonly valorCircunferenciaAbdominal?: number | null
      readonly valorForcaMuscMaoDireita?: string | null
      readonly unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular | null
      readonly valorForcaMuscMaoEsquerda?: string | null
      readonly unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular | null
      readonly pele?: string | null
      readonly olhoDireito?: string | null
      readonly olhoEsquerdo?: string | null
      readonly ouvidoDireito?: string | null
      readonly ouvidoEsquerdo?: string | null
      readonly membroInferiorDireito?: string | null
      readonly membroInferiorEsquerdo?: string | null
    } | null> | null
    readonly evolucaoPlano?: {
      readonly __typename?: 'EvolucaoPlano'
      readonly id: string
      readonly descricao?: string | null
      readonly intervencoesProcedimentos?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoPlanoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly automatico?: boolean | null
        readonly ciap?: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        } | null
        readonly procedimento?: {
          readonly __typename?: 'Procedimento'
          readonly idadeMinima?: number | null
          readonly idadeMaxima?: number | null
          readonly sexo?: SexoEnum | null
          readonly id: string
          readonly descricao: string
          readonly codigo: string
          readonly ativo?: boolean | null
          readonly procedimentoReferencia?: {
            readonly __typename?: 'Procedimento'
            readonly id: string
            readonly descricao: string
            readonly codigo: string
            readonly ativo?: boolean | null
          } | null
        } | null
      } | null> | null
    } | null
    readonly orientacoes?: ReadonlyArray<{
      readonly __typename?: 'Orientacao'
      readonly id: string
      readonly descricao: string
    } | null> | null
    readonly evolucaoSubjetivo?: {
      readonly __typename?: 'EvolucaoSubjetivo'
      readonly id: string
      readonly descricao?: string | null
      readonly ciaps?: ReadonlyArray<{
        readonly __typename?: 'EvolucaoSubjetivoCiap'
        readonly id: string
        readonly nota?: string | null
        readonly ciap: {
          readonly __typename?: 'Ciap'
          readonly id: string
          readonly codigo: string
          readonly descricao: string
        }
      } | null> | null
    } | null
    readonly procedimentosAtendimento?: ReadonlyArray<{
      readonly __typename?: 'AtendimentoProcedimento'
      readonly id: string
      readonly automatico?: boolean | null
      readonly procedimento: {
        readonly __typename?: 'Procedimento'
        readonly id: string
        readonly descricao: string
        readonly codigo: string
      }
    } | null> | null
    readonly notificacoesCasoSuspeito?: ReadonlyArray<{
      readonly __typename?: 'SinanNotificacaoEvolucao'
      readonly id: string
      readonly notificacao: {
        readonly __typename?: 'FichaNotificacaoCasoSuspeito'
        readonly id: string
        readonly nomeNotificacao: string
      }
    } | null> | null
    readonly lotacaoAtendimentoCompartilhado?: {
      readonly __typename?: 'Lotacao'
      readonly id: string
      readonly profissional: {
        readonly __typename?: 'Profissional'
        readonly id: string
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly cpf: string
      }
      readonly unidadeSaude: {
        readonly __typename?: 'UnidadeSaude'
        readonly id: string
        readonly nome?: string | null
        readonly cnes: string
      }
      readonly cbo: {
        readonly __typename?: 'Cbo'
        readonly id: string
        readonly nome: string
        readonly cbo2002: string
      }
      readonly equipe?: {
        readonly __typename?: 'Equipe'
        readonly id: string
        readonly ine: string
        readonly nome: string
        readonly isAD: boolean
      } | null
    } | null
    readonly arquivosAnexados: ReadonlyArray<{
      readonly __typename?: 'ArquivoAtendimentoProfissional'
      readonly id: string
      readonly titulo: string
      readonly observacao?: string | null
      readonly categoria: CategoriaArquivoAtendProfEnum
      readonly arquivo: {
        readonly __typename?: 'Arquivo'
        readonly id: string
        readonly uuid: string
        readonly dataCriacao: any
      }
    }>
    readonly atestados?: ReadonlyArray<{
      readonly __typename?: 'Atestado'
      readonly id: string
      readonly descricao?: string | null
      readonly tipo?: TipoAtestadoEnum | null
      readonly assinadoDigitalmente: boolean
      readonly dias?: number | null
      readonly dataHorarioAfastamento?: any | null
      readonly cid10?: {
        readonly __typename?: 'Cid10'
        readonly id: string
        readonly codigo: string
        readonly nome: string
      } | null
    }> | null
  }
}

export type InativarAtendimentoMutationVariables = Exact<{
  input: InativarAtendimentoInput
}>

export type InativarAtendimentoMutation = { readonly __typename?: 'Mutation'; readonly inativarAtendimento: boolean }

export type RetificarAtendimentoMutationVariables = Exact<{
  input: RetificacaoAtendimentoInput
}>

export type RetificarAtendimentoMutation = { readonly __typename?: 'Mutation'; readonly retificarAtendimento: any }

export type AtendimentoVacinacaoRetificacaoViewQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type AtendimentoVacinacaoRetificacaoViewQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly finalizadoEm?: any | null
    readonly vacinacao?: {
      readonly __typename?: 'AtendimentoVacinacao'
      readonly id: string
      readonly condicaoMaternal?: CondicaoMaternalDbEnum | null
      readonly isViajante?: boolean | null
      readonly isComunicanteHanseniase?: boolean | null
      readonly registrosVacinacao?: ReadonlyArray<{
        readonly __typename?: 'RegistroVacinacao'
        readonly id: string
        readonly uuid?: string | null
        readonly isRegistroAnterior?: boolean | null
        readonly dataAprazamento?: any | null
        readonly dataAplicacao?: any | null
        readonly observacoes?: string | null
        readonly isAplicadoExterior?: boolean | null
        readonly isPesquisaClinica?: boolean | null
        readonly anvisaProtocoloEstudo?: string | null
        readonly anvisaProtocoloVersao?: string | null
        readonly anvisaNumeroRegistro?: string | null
        readonly imunobiologico: {
          readonly __typename?: 'Imunobiologico'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        }
        readonly doseImunobiologico: {
          readonly __typename?: 'DoseImunobiologico'
          readonly id: string
          readonly nome: string
          readonly sigla: string
        }
        readonly loteImunobiologico?: {
          readonly __typename?: 'LoteImunobiologico'
          readonly id: string
          readonly lote?: string | null
          readonly validade?: any | null
          readonly fabricante?: {
            readonly __typename?: 'ImunobiologicoFabricante'
            readonly id: string
            readonly nome: string
          } | null
        } | null
        readonly viaAdministracao?: {
          readonly __typename?: 'ViaAdministracao'
          readonly id: string
          readonly nome: string
        } | null
        readonly localAplicacaoVacinacao?: {
          readonly __typename?: 'LocalAplicacao'
          readonly id: string
          readonly nome: string
        } | null
        readonly tipoRegistroVacinacao: {
          readonly __typename?: 'TipoRegistroVacinacao'
          readonly id: string
          readonly identificador: TipoRegistroVacinacaoEnum
        }
        readonly estrategiaVacinacao?: {
          readonly __typename?: 'EstrategiaVacinacao'
          readonly id: string
          readonly nome: string
          readonly codigo: string
          readonly estrategiaVacinacaoDbEnum: EstrategiaVacinacaoEnum
        } | null
        readonly grupoAtendimento?: {
          readonly __typename?: 'GrupoAtendimento'
          readonly id: string
          readonly nome: string
        } | null
        readonly cboPrescritor?: {
          readonly __typename?: 'Cbo'
          readonly id: string
          readonly nome: string
          readonly cbo2002: string
        } | null
        readonly cid10MotivoIndicacao?: {
          readonly __typename?: 'Cid10'
          readonly id: string
          readonly nome: string
          readonly codigo: string
        } | null
      }> | null
    } | null
  }
}

export type CabecalhoModalRetificacaoAtendimentoQueryVariables = Exact<{
  cidadaoId: Scalars['ID']['input']
}>

export type CabecalhoModalRetificacaoAtendimentoQuery = {
  readonly __typename?: 'Query'
  readonly cidadao: {
    readonly __typename?: 'Cidadao'
    readonly id: string
    readonly cpf?: string | null
    readonly cns?: string | null
    readonly nome: string
    readonly nomeSocial?: string | null
    readonly nomeMae?: string | null
    readonly dataNascimento?: any | null
  }
}

export type RetificacaoAtendimentoModalQueryVariables = Exact<{
  atendimentoProfissionalId: Scalars['ID']['input']
}>

export type RetificacaoAtendimentoModalQuery = {
  readonly __typename?: 'Query'
  readonly atendimentoIndividual: {
    readonly __typename?: 'AtendimentoProfissional'
    readonly id: string
    readonly atendimento?: {
      readonly __typename?: 'Atendimento'
      readonly id: string
      readonly isRegistroTardio: boolean
    } | null
  }
}

export type SistemasExternosMenuLateralQueryVariables = Exact<{ [key: string]: never }>

export type SistemasExternosMenuLateralQuery = {
  readonly __typename?: 'Query'
  readonly iframes: ReadonlyArray<{
    readonly __typename?: 'Iframe'
    readonly id: string
    readonly providerId: string
    readonly nome: string
  } | null>
}

export type SobreQueryVariables = Exact<{ [key: string]: never }>

export type SobreQuery = {
  readonly __typename?: 'Query'
  readonly info: {
    readonly __typename?: 'Info'
    readonly id: string
    readonly commit: string
    readonly competenciaSigtap: string
    readonly databaseVendor: string
    readonly databaseSchemaVersion: string
    readonly recursosDisponiveis: string
    readonly versao: string
    readonly internetHabilitada: boolean
    readonly smtpConfigurado: boolean
    readonly govBREnabled: boolean
  }
}

export type AceitarTermosUsoMutationVariables = Exact<{ [key: string]: never }>

export type AceitarTermosUsoMutation = {
  readonly __typename?: 'Mutation'
  readonly aceitarTermosUso?: {
    readonly __typename?: 'Usuario'
    readonly id: string
    readonly forcarTrocaSenha: boolean
    readonly aceitouTermosUso: boolean
  } | null
}

export type AlternarTransmissaoLinkMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AlternarTransmissaoLinkMutation = {
  readonly __typename?: 'Mutation'
  readonly alternarTransmissaoLink: string
}

export type ExcluirTransmissaoLinkMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExcluirTransmissaoLinkMutation = {
  readonly __typename?: 'Mutation'
  readonly excluirTransmissaoLink: string
}

export type InserirTransmissaoLinkMutationVariables = Exact<{
  form: TransmissaoLinkInsertDto
}>

export type InserirTransmissaoLinkMutation = {
  readonly __typename?: 'Mutation'
  readonly inserirTransmissaoLink: string
}

export type TransmissaoLinkQueryVariables = Exact<{
  input: TransmissaoLinkPagingQueryFiltroDto
}>

export type TransmissaoLinkQuery = {
  readonly __typename?: 'Query'
  readonly transmissaoLink: {
    readonly __typename?: 'TransmissaoLinksPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TransmissaoLink'
      readonly id: string
      readonly hostname: string
      readonly name: string
      readonly ativo: boolean
      readonly statusConexao?: boolean | null
      readonly dataTesteConexao?: any | null
      readonly actions: {
        readonly __typename?: 'TransmissaoLinkActions'
        readonly alternarAtivacao: {
          readonly __typename?: 'Action'
          readonly enabled: boolean
          readonly hint?: string | null
        }
        readonly excluir: { readonly __typename?: 'Action'; readonly enabled: boolean; readonly hint?: string | null }
        readonly editar: { readonly __typename?: 'Action'; readonly enabled: boolean; readonly hint?: string | null }
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type TestarConexaoLinkTransmissaoMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type TestarConexaoLinkTransmissaoMutation = {
  readonly __typename?: 'Mutation'
  readonly testarConexaoLinkTransmissao: {
    readonly __typename?: 'ResultadoTesteConexao'
    readonly validationDescription: string
    readonly link: {
      readonly __typename?: 'TransmissaoLink'
      readonly id: string
      readonly hostname: string
      readonly name: string
      readonly ativo: boolean
      readonly statusConexao?: boolean | null
      readonly dataTesteConexao?: any | null
    }
  }
}

export type UpdateTransmissaoLinkMutationVariables = Exact<{
  form: TransmissaoLinkUpdateDto
}>

export type UpdateTransmissaoLinkMutation = { readonly __typename?: 'Mutation'; readonly updateTransmissaoLink: string }

export type TransmissaoRecebimentoLotesQueryVariables = Exact<{
  input: TransmissaoRecebimentoLoteFiltro
}>

export type TransmissaoRecebimentoLotesQuery = {
  readonly __typename?: 'Query'
  readonly transmissaoRecebimentoLotes: {
    readonly __typename?: 'TransmissaoRecebimentoQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TransmissaoRecebimentoLoteDto'
      readonly id: string
      readonly numeroLote?: string | null
      readonly responsavel: string
      readonly processado?: boolean | null
      readonly data: any
      readonly possuiInconsistencia: boolean
      readonly counts: {
        readonly __typename?: 'TransmissaoRecebimentoLoteCountsDto'
        readonly fichasValidas: number
        readonly fichasInvalidas: number
        readonly totalFichas: number
        readonly fichasRepetidas: number
      }
      readonly origemLote: {
        readonly __typename?: 'TipoOrigemDadoTransporte'
        readonly id: string
        readonly descricao: string
      }
      readonly credencialIntegracao?: {
        readonly __typename?: 'CredenciaIntegracao'
        readonly id: string
        readonly nomeResponsavel: string
      } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type CredenciaisIntegracaoOldQueryVariables = Exact<{
  input: CredencialIntegracaoQueryInput
}>

export type CredenciaisIntegracaoOldQuery = {
  readonly __typename?: 'Query'
  readonly credenciaisIntegracao: {
    readonly __typename?: 'CredencialIntegracaoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CredenciaIntegracao'
      readonly id: string
      readonly nomeResponsavel: string
      readonly nomeCredencial: string
      readonly dataCriacao: any
      readonly email: string
      readonly ativo: boolean
      readonly tipoPessoa: TipoPessoaEnum
      readonly cpfCnpj: string
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type InativarCredencialIntegracaoOldMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type InativarCredencialIntegracaoOldMutation = {
  readonly __typename?: 'Mutation'
  readonly inativarCredencialIntegracao: { readonly __typename?: 'CredenciaIntegracao'; readonly id: string }
}

export type SalvarCredencialIntegracaoOldMutationVariables = Exact<{
  input: CredencialIntegracaoInput
}>

export type SalvarCredencialIntegracaoOldMutation = {
  readonly __typename?: 'Mutation'
  readonly salvarCredencialIntegracao: {
    readonly __typename?: 'SalvarCredencialIntegracaoPayload'
    readonly userPassword: {
      readonly __typename?: 'CredenciaIntegracaoUserPasswordPayload'
      readonly user: string
      readonly password: string
    }
  }
}

export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables = Exact<{
  horario: Scalars['LocalTime']['input']
}>

export type AlterarHorarioGeracaoLotesProcessamentoFichasMutation = {
  readonly __typename?: 'Mutation'
  readonly alterarHorarioGeracaoLotesProcessamentoFichas: any
}

export type LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables = Exact<{ [key: string]: never }>

export type LoadHorarioGeracaoLotesProcessamentoFichasQuery = {
  readonly __typename?: 'Query'
  readonly loadHorarioGeracaoLotesProcessamentoFichas?: any | null
}

export type LoteEnvioQueryVariables = Exact<{
  idLote: Scalars['ID']['input']
  filtroHistorico: HistoricoExportacaoFiltro
}>

export type LoteEnvioQuery = {
  readonly __typename?: 'Query'
  readonly loteEnvio: {
    readonly __typename?: 'LoteEnvio'
    readonly id: string
    readonly dataCriacao: any
    readonly quantidadeFichas: number
    readonly nodos?: ReadonlyArray<{
      readonly __typename?: 'NodoLoteEnvio'
      readonly id?: string | null
      readonly dataEnvio?: any | null
      readonly nodeNome: string
      readonly statusEnvio: StatusEnvio
    } | null> | null
    readonly historicoExportacao: {
      readonly __typename?: 'LoteHistoricoExportacaoPayload'
      readonly content: ReadonlyArray<{
        readonly __typename?: 'LoteHistoricoExportacao'
        readonly id: string
        readonly nomeProfissional: string
        readonly dataExportacao: any
      } | null>
      readonly pageInfo: {
        readonly __typename?: 'PageInfo'
        readonly number: number
        readonly size: number
        readonly totalPages: number
        readonly totalElements: number
        readonly sort?: ReadonlyArray<string | null> | null
        readonly first: boolean
        readonly last: boolean
        readonly numberOfElements: number
      }
    }
  }
}

export type GerarLotesMutationVariables = Exact<{ [key: string]: never }>

export type GerarLotesMutation = { readonly __typename?: 'Mutation'; readonly gerarLote: boolean }

export type LotesEnvioQueryVariables = Exact<{
  input: LotesEnvioFiltro
}>

export type LotesEnvioQuery = {
  readonly __typename?: 'Query'
  readonly lotesEnvio: {
    readonly __typename?: 'LotesEnvioPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'LoteEnvio'
      readonly id: string
      readonly statusEnvio: StatusEnvio
      readonly dataCriacao: any
      readonly quantidadeFichas: number
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type TransmissaoRecebimentoCnesDetailItemsQueryVariables = Exact<{
  input: TransmissaoRecebimentoCnesDetailFiltro
}>

export type TransmissaoRecebimentoCnesDetailItemsQuery = {
  readonly __typename?: 'Query'
  readonly transmissaoRecebimentoCnesDetailItems: ReadonlyArray<{
    readonly __typename?: 'TransmissaoRecebimentoCnesDetailItem'
    readonly nomeEstabelecimento?: string | null
    readonly tipoFicha: string
    readonly quantidade: number
  } | null>
}

export type TransmissaoRecebimentoCnesQueryVariables = Exact<{
  input: TransmissaoRecebimentoCnesFiltro
}>

export type TransmissaoRecebimentoCnesQuery = {
  readonly __typename?: 'Query'
  readonly transmissaoRecebimentoCnes: {
    readonly __typename?: 'TransmissaoRecebimentoCnesPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'TransmissaoRecebimentoCnesDto'
      readonly numCnes: string
      readonly mesRecebimento: number
      readonly anoRecebimento: number
      readonly fichasRecebidas: number
      readonly estabelecimentoOrigem?: string | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type ExistemFichasParaProcessarQueryVariables = Exact<{ [key: string]: never }>

export type ExistemFichasParaProcessarQuery = {
  readonly __typename?: 'Query'
  readonly existemFichasParaProcessar: boolean
}

export type TransmissaoQueryVariables = Exact<{ [key: string]: never }>

export type TransmissaoQuery = {
  readonly __typename?: 'Query'
  readonly transmissao: {
    readonly __typename?: 'Transmissao'
    readonly id: string
    readonly importacaoArquivo: {
      readonly __typename?: 'ImportacaoArquivo'
      readonly dataEvento?: any | null
      readonly status: StatusImportacaoArquivo
      readonly message?: string | null
    }
  }
}

export type AtivarTipoServicoMutationVariables = Exact<{
  unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput
}>

export type AtivarTipoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly ativarTipoServico: {
    readonly __typename?: 'RlUnidadeSaudeTipoServicoIds'
    readonly unidadeSaudeId: string
    readonly tipoServicoId: string
  }
}

export type DesativarTipoServicoMutationVariables = Exact<{
  unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput
}>

export type DesativarTipoServicoMutation = {
  readonly __typename?: 'Mutation'
  readonly desativarTipoServico: {
    readonly __typename?: 'RlUnidadeSaudeTipoServicoIds'
    readonly unidadeSaudeId: string
    readonly tipoServicoId: string
  }
}

export type UnidadeSaudeDetailQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type UnidadeSaudeDetailQuery = {
  readonly __typename?: 'Query'
  readonly unidadeSaude: {
    readonly __typename?: 'UnidadeSaude'
    readonly id: string
    readonly nome?: string | null
    readonly cnes: string
    readonly cnpj?: string | null
    readonly email?: string | null
    readonly telefone1?: string | null
    readonly telefone2?: string | null
    readonly fax?: string | null
    readonly tipoEstabelecimento: TipoEstabelecimentoEnum
    readonly ativo?: boolean | null
    readonly tipo: { readonly __typename?: 'TipoUnidadeSaude'; readonly id: string; readonly descricao: string }
    readonly subtipo?: {
      readonly __typename?: 'SubtipoUnidadeSaude'
      readonly id: string
      readonly codigoMs?: string | null
      readonly descricao?: string | null
      readonly tipoUnidadeSaude: { readonly __typename?: 'TipoUnidadeSaude'; readonly id: string }
    } | null
    readonly complexidades?: ReadonlyArray<{
      readonly __typename?: 'Complexidade'
      readonly id: string
      readonly nome: string
    } | null> | null
    readonly endereco?: {
      readonly __typename?: 'Endereco'
      readonly cep?: string | null
      readonly logradouro?: string | null
      readonly numero?: string | null
      readonly semNumero?: boolean | null
      readonly complemento?: string | null
      readonly pontoReferencia?: string | null
      readonly bairro?: string | null
      readonly municipio?: { readonly __typename?: 'Municipio'; readonly nome: string } | null
      readonly uf?: { readonly __typename?: 'UF'; readonly sigla: string } | null
      readonly tipoLogradouro?: { readonly __typename?: 'TipoLogradouro'; readonly nome: string } | null
    } | null
    readonly actions: {
      readonly __typename?: 'UnidadeSaudeActions'
      readonly permissaoAtivarInativarTipoServico: {
        readonly __typename?: 'Action'
        readonly enabled: boolean
        readonly hint?: string | null
      }
    }
  }
}

export type UnidadeSaudeTipoServicoQueryVariables = Exact<{
  input: UnidadeSaudeTipoServicoQueryInput
}>

export type UnidadeSaudeTipoServicoQuery = {
  readonly __typename?: 'Query'
  readonly unidadeSaudeTiposServico: {
    readonly __typename?: 'UnidadeSaudeTiposServicoPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'UnidadeSaudeTipoServico'
      readonly ativo: boolean
      readonly tipoServico: { readonly __typename?: 'TipoServico'; readonly id: string; readonly nome: string }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type UnidadeSaudeTableQueryVariables = Exact<{
  input: UnidadesSaudeQueryInput
}>

export type UnidadeSaudeTableQuery = {
  readonly __typename?: 'Query'
  readonly unidadesSaude: {
    readonly __typename?: 'UnidadeSaudePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly cnes: string
      readonly nome?: string | null
      readonly telefone1?: string | null
      readonly telefone2?: string | null
      readonly ativo?: boolean | null
      readonly endereco?: { readonly __typename?: 'Endereco'; readonly bairro?: string | null } | null
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type NomesInstalacoesUnificacaoBaseQueryVariables = Exact<{ [key: string]: never }>

export type NomesInstalacoesUnificacaoBaseQuery = {
  readonly __typename?: 'Query'
  readonly nomesInstalacoes?: {
    readonly __typename?: 'NomesInstalacoesUnificacaoDto'
    readonly nomeInstalacaoCentral?: string | null
    readonly nomesInstalacoesUnificadas?: ReadonlyArray<string | null> | null
  } | null
}

export type UnificacaoBaseCadastrosDuplicadosQueryVariables = Exact<{
  input: CidadaoUnificacaoBaseInput
}>

export type UnificacaoBaseCadastrosDuplicadosQuery = {
  readonly __typename?: 'Query'
  readonly cadastrosDuplicados: {
    readonly __typename?: 'CidadaoUnificacaoBasePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'CidadaoUnificacaoBase'
      readonly id: any
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly cidadao: {
        readonly __typename?: 'Cidadao'
        readonly nome: string
        readonly nomeSocial?: string | null
        readonly nomeMae?: string | null
        readonly dataNascimento?: any | null
        readonly sexo: SexoEnum
        readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
        readonly ativo?: boolean | null
        readonly faleceu?: boolean | null
        readonly unificado?: boolean | null
        readonly unificacaoBase?: string | null
        readonly localidadeNascimento?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly nome: string
          readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
        } | null
        readonly cidadaoVinculacaoEquipe?: {
          readonly __typename?: 'CidadaoVinculacaoEquipe'
          readonly id?: string | null
          readonly unidadeSaude?: {
            readonly __typename?: 'UnidadeSaude'
            readonly id: string
            readonly nome?: string | null
          } | null
        } | null
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type UnificaCadastrosMutationVariables = Exact<{
  input: UnificacaoCadastroInput
}>

export type UnificaCadastrosMutation = { readonly __typename?: 'Mutation'; readonly unificaCadastros: boolean }

export type UnificacaoCidadaosListingQueryVariables = Exact<{
  input: CidadaosQueryInput
}>

export type UnificacaoCidadaosListingQuery = {
  readonly __typename?: 'Query'
  readonly listagemCidadaos: {
    readonly __typename?: 'CidadaosPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Cidadao'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly nomeMae?: string | null
      readonly dataNascimento?: any | null
      readonly telefoneCelular?: string | null
      readonly telefoneResidencial?: string | null
      readonly sexo: SexoEnum
      readonly identidadeGeneroDbEnum?: IdentidadeGeneroEnum | null
      readonly dataAtualizado?: any | null
      readonly ativo?: boolean | null
      readonly unificado?: boolean | null
      readonly unificacaoBase?: string | null
      readonly faleceu?: boolean | null
      readonly uuidUltimaFicha?: string | null
      readonly prontuario?: { readonly __typename?: 'Prontuario'; readonly id: string } | null
      readonly localidadeNascimento?: {
        readonly __typename?: 'Municipio'
        readonly id: string
        readonly nome: string
        readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly nome: string; readonly sigla: string }
      } | null
      readonly cidadaoVinculacaoEquipe?: {
        readonly __typename?: 'CidadaoVinculacaoEquipe'
        readonly id?: string | null
        readonly dataAtualizacaoCadastro?: any | null
        readonly unidadeSaude?: {
          readonly __typename?: 'UnidadeSaude'
          readonly id: string
          readonly nome?: string | null
        } | null
        readonly equipe?: {
          readonly __typename?: 'Equipe'
          readonly id: string
          readonly nome: string
          readonly ine: string
        } | null
      } | null
    } | null>
  }
}

export type CancelarSolicitacaoEntradaVideochamadaMutationVariables = Exact<{
  input: CancelarSolicitacaoEntradaVideochamadaInput
}>

export type CancelarSolicitacaoEntradaVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly cancelarSolicitacaoEntradaVideochamada: boolean
}

export type EncerrarMinhasVideochamadasMutationVariables = Exact<{ [key: string]: never }>

export type EncerrarMinhasVideochamadasMutation = {
  readonly __typename?: 'Mutation'
  readonly encerrarMinhasVideochamadas: boolean
}

export type EncerrarVideochamadaMutationVariables = Exact<{
  videochamadaUuid: Scalars['String']['input']
}>

export type EncerrarVideochamadaMutation = { readonly __typename?: 'Mutation'; readonly encerrarVideochamada: boolean }

export type IniciarVideochamadaMutationVariables = Exact<{
  input: IniciarVideochamadaInput
}>

export type IniciarVideochamadaMutation = { readonly __typename?: 'Mutation'; readonly iniciarVideochamada: string }

export type ResponderSolicitacaoEntradaVideochamadaMutationVariables = Exact<{
  input: ResponderSolicitacaoEntradaVideochamadaInput
}>

export type ResponderSolicitacaoEntradaVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly responderSolicitacaoEntradaVideochamada: boolean
}

export type VideochamadaViewQueryVariables = Exact<{
  uuid: Scalars['String']['input']
}>

export type VideochamadaViewQuery = {
  readonly __typename?: 'Query'
  readonly videochamada?: {
    readonly __typename?: 'Videochamada'
    readonly id: string
    readonly dataInicio?: any | null
    readonly dataFim?: any | null
    readonly agendamento?: {
      readonly __typename?: 'Agendado'
      readonly id: string
      readonly horarioInicial: any
    } | null
    readonly owner?:
      | {
          readonly __typename?: 'AdministradorGeral'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      | {
          readonly __typename?: 'AdministradorMunicipal'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      | {
          readonly __typename?: 'Estagio'
          readonly id: string
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      | {
          readonly __typename?: 'GestorEstadual'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      | {
          readonly __typename?: 'GestorMunicipal'
          readonly id: string
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      | {
          readonly __typename?: 'Lotacao'
          readonly id: string
          readonly cbo: { readonly __typename?: 'Cbo'; readonly id: string; readonly nome: string }
          readonly profissional: {
            readonly __typename?: 'Profissional'
            readonly id: string
            readonly nome: string
            readonly cpf: string
          }
        }
      | null
  } | null
}

export type SolicitarEntradaVideochamadaMutationVariables = Exact<{
  input: SolicitarEntradaVideochamadaInput
}>

export type SolicitarEntradaVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly solicitarEntradaVideochamada: {
    readonly __typename?: 'ParticipanteVideochamada'
    readonly id: string
    readonly nome: string
    readonly cpf: string
  }
}

export type ConfiguracaoVideochamadasQueryVariables = Exact<{ [key: string]: never }>

export type ConfiguracaoVideochamadasQuery = {
  readonly __typename?: 'Query'
  readonly conexao: {
    readonly __typename?: 'ConfiguracaoConexao'
    readonly videochamadas: {
      readonly __typename?: 'ConfiguracaoVideochamadas'
      readonly id: string
      readonly habilitado: boolean
    }
  }
}

export type ConfiguracoesIceServersQueryVariables = Exact<{
  input: IceServersConfigurationInput
}>

export type ConfiguracoesIceServersQuery = {
  readonly __typename?: 'Query'
  readonly iceServersConfiguration: {
    readonly __typename?: 'IceServersConfig'
    readonly urls: ReadonlyArray<string>
    readonly user?: string | null
    readonly password?: string | null
  }
}

export type IsParticipantePermitidoVideochamadaQueryVariables = Exact<{
  input: VerificarParticipantePermitidoVideochamadaInput
}>

export type IsParticipantePermitidoVideochamadaQuery = {
  readonly __typename?: 'Query'
  readonly isParticipantePermitidoVideochamada: boolean
}

export type NotificarConexaoVideochamadaFalhouMutationVariables = Exact<{
  videochamadaUuid: Scalars['String']['input']
}>

export type NotificarConexaoVideochamadaFalhouMutation = {
  readonly __typename?: 'Mutation'
  readonly notifyConexaoVideochamadaFalhou: boolean
}

export type NotificarEntradaParticipanteVideochamadaMutationVariables = Exact<{
  videochamadaUuid: Scalars['String']['input']
  participanteId: Scalars['ID']['input']
  nomeParticipante: Scalars['String']['input']
}>

export type NotificarEntradaParticipanteVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly notifyEntradaParticipanteVideochamada: boolean
}

export type NotificarSaidaDonoVideochamadaMutationVariables = Exact<{
  videochamadaUuid: Scalars['String']['input']
}>

export type NotificarSaidaDonoVideochamadaMutation = {
  readonly __typename?: 'Mutation'
  readonly notifySaidaDonoVideochamada: boolean
}

export type NotificarVideochamadaLotadaMutationVariables = Exact<{
  videochamadaUuid: Scalars['String']['input']
  lotada: Scalars['Boolean']['input']
}>

export type NotificarVideochamadaLotadaMutation = {
  readonly __typename?: 'Mutation'
  readonly notifyVideochamadaLotada: boolean
}

export type StatusVideochamadaQueryVariables = Exact<{
  uuid: Scalars['String']['input']
}>

export type StatusVideochamadaQuery = {
  readonly __typename?: 'Query'
  readonly videochamada?: {
    readonly __typename?: 'Videochamada'
    readonly id: string
    readonly status: StatusVideochamadaEnum
  } | null
}

export type EquipesVinculadasTableQueryVariables = Exact<{
  input: EquipesQueryInput
}>

export type EquipesVinculadasTableQuery = {
  readonly __typename?: 'Query'
  readonly equipesVinculadas: {
    readonly __typename?: 'EquipePayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly area?: string | null
      readonly ativo?: boolean | null
      readonly tipoEquipe: {
        readonly __typename?: 'TipoEquipe'
        readonly id: string
        readonly nome: string
        readonly sigla: string
      }
    } | null>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
}

export type HasEquipesVinculadasQueryVariables = Exact<{
  equipePrincipalId: Scalars['ID']['input']
}>

export type HasEquipesVinculadasQuery = { readonly __typename?: 'Query'; readonly hasEquipesVinculadas: boolean }

export type FamiliasImovelQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type FamiliasImovelQuery = {
  readonly __typename?: 'Query'
  readonly imovel?: {
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly familias: ReadonlyArray<{
      readonly __typename?: 'Familia'
      readonly id: string
      readonly cnes: string
      readonly ine: string
      readonly numeroProntuarioFamiliar?: string | null
      readonly rendaFamiliar?: RendaFamiliar | null
      readonly resideDesde?: any | null
      readonly numeroMembros?: number | null
      readonly cpfCnsResponsavel?: string | null
      readonly isResponsavelCadastrado: boolean
      readonly isResponsavelDeclarado: boolean
      readonly isResponsavelVivo: boolean
      readonly isResponsavelUnico: boolean
      readonly isResponsavelAindaReside: boolean
      readonly isFamiliaAindaReside: boolean
      readonly isInformacaoSuficiente: boolean
      readonly isDomicilioAtivo: boolean
      readonly equipe?: { readonly __typename?: 'Equipe'; readonly id: string; readonly nome: string } | null
      readonly cidadaosTerritorioBasico: ReadonlyArray<{
        readonly __typename?: 'CidadaoTerritorioBasico'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly sexo?: SexoEnum | null
        readonly dataNascimento?: any | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly telefoneCelular?: string | null
        readonly telefoneContato?: string | null
        readonly isFaleceu?: boolean | null
        readonly ultimaFichaCadastrada?: {
          readonly __typename?: 'UltimaFichaCadastradaDto'
          readonly id: string
          readonly isProcessado: boolean
        } | null
        readonly cidadaoNucleoFamiliar?: {
          readonly __typename?: 'CidadaoNucleoFamiliar'
          readonly id: string
          readonly grauParentescoResponsavelFamiliar?: GrauParentescoEnum | null
        } | null
      }>
    }>
  } | null
}

export type ImovelInformacoesCadastraisQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type ImovelInformacoesCadastraisQuery = {
  readonly __typename?: 'Query'
  readonly imovel?: {
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly tipoImovel?: TipoImovelEnum | null
    readonly telefoneContato?: string | null
    readonly telefoneResidencial?: string | null
    readonly dataUltimaVisita?: any | null
    readonly microarea?: string | null
    readonly nomeInstituicaoPermanencia?: string | null
    readonly statusRecusa?: boolean | null
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly unidadeSaude: {
      readonly __typename?: 'UnidadeSaude'
      readonly id: string
      readonly nome?: string | null
      readonly cnes: string
    }
    readonly equipe?: {
      readonly __typename?: 'Equipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
      readonly isAD: boolean
    } | null
    readonly profissional?: {
      readonly __typename?: 'Profissional'
      readonly id: string
      readonly nome: string
      readonly nomeSocial?: string | null
      readonly cns?: string | null
      readonly cpf: string
    } | null
    readonly cbo?: {
      readonly __typename?: 'Cbo'
      readonly id: string
      readonly nome: string
      readonly cbo2002: string
    } | null
    readonly ultimaVisitaComAnotacao?: {
      readonly __typename?: 'FatoVisitaDomiciliar'
      readonly id: string
      readonly anotacoes?: string | null
      readonly dataVisita?: any | null
    } | null
    readonly ultimaFichaCadastrada?: {
      readonly __typename?: 'UltimaFichaCadastradaDto'
      readonly id: string
      readonly isProcessado: boolean
    } | null
    readonly responsavelTecnico?: {
      readonly __typename?: 'ResponsavelTecnicoImovel'
      readonly id: string
      readonly nome: string
      readonly contato?: string | null
      readonly cns?: string | null
      readonly cargo?: string | null
    } | null
    readonly condicoesMoradia: {
      readonly __typename?: 'CondicoesMoradia'
      readonly id: string
      readonly tipoAbastecimentoAgua?: TipoAbastecimentoAguaEnum | null
      readonly tipoSituacaoMoradia?: TipoSituacaoMoradiaEnum | null
      readonly tipoTratamentoAgua?: TipoTratamentoAguaEnum | null
      readonly tipoPosseTerra?: TipoPosseTerraEnum | null
      readonly tipoMaterialParede?: TipoMaterialParedeEnum | null
      readonly tipoLocalizacao?: TipoLocalizacaoEnum | null
      readonly tipoEscoamentoSanitario?: TipoEscoamentoSanitarioEnum | null
      readonly tipoDomicilio?: TipoDomicilioEnum | null
      readonly tipoDestinoLixo?: TipoDestinoLixoEnum | null
      readonly tipoAcessoDomicilio?: TipoAcessoDomicilioEnum | null
      readonly isEnergiaEletricaDisponivel?: boolean | null
      readonly tipoOrigemEnergiaEletrica?: TipoOrigemEnergiaEletricaEnum | null
      readonly numeroComodos?: number | null
    }
    readonly animaisImovel?: {
      readonly __typename?: 'AnimaisImovel'
      readonly id?: any | null
      readonly possuiAnimais?: boolean | null
      readonly possuiGato?: boolean | null
      readonly possuiCachorro?: boolean | null
      readonly possuiPassaro?: boolean | null
      readonly possuiMacaco?: boolean | null
      readonly possuiGalinha?: boolean | null
      readonly possuiPorco?: boolean | null
      readonly possuiRepteis?: boolean | null
      readonly possuiOutros?: boolean | null
      readonly quantidadeAnimais?: number | null
    } | null
  } | null
}

export type VisualizarImovelHeaderQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type VisualizarImovelHeaderQuery = {
  readonly __typename?: 'Query'
  readonly imovel?: {
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly tipoImovel?: TipoImovelEnum | null
    readonly logradouro?: string | null
    readonly numero?: string | null
    readonly semNumero?: boolean | null
    readonly complemento?: string | null
    readonly bairro?: string | null
    readonly cep?: string | null
    readonly microarea?: string | null
    readonly telefoneResidencial?: string | null
    readonly telefoneContato?: string | null
    readonly dataUltimaAtualizacao?: any | null
    readonly isCadastroCompleto?: boolean | null
    readonly latitude?: number | null
    readonly longitude?: number | null
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly numeroResidenciaIndigena?: string | null
    readonly statusRecusa?: boolean | null
    readonly stAtivo: boolean
    readonly condicoesMoradia: {
      readonly __typename?: 'CondicoesMoradia'
      readonly id: string
      readonly tipoLocalizacao?: TipoLocalizacaoEnum | null
      readonly tipoDomicilio?: TipoDomicilioEnum | null
    }
    readonly tipoLogradouro?: {
      readonly __typename?: 'TipoLogradouro'
      readonly id: string
      readonly nome: string
    } | null
    readonly municipio?: {
      readonly __typename?: 'Municipio'
      readonly id: string
      readonly nome: string
      readonly uf: { readonly __typename?: 'UF'; readonly id: string; readonly sigla: string }
    } | null
    readonly aldeia?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
    readonly poloBase?: { readonly __typename?: 'PoloBase'; readonly id: string; readonly nome: string } | null
    readonly dsei?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
  } | null
}

export type ImovelUltimasVisitasQueryVariables = Exact<{
  input: VisitasQueryInput
  imovelId: Scalars['ID']['input']
}>

export type ImovelUltimasVisitasQuery = {
  readonly __typename?: 'Query'
  readonly visitas: {
    readonly __typename?: 'VisitasQueryPayload'
    readonly content: ReadonlyArray<{
      readonly __typename?: 'FatoVisitaDomiciliar'
      readonly id: string
      readonly nuUuidFicha: string
      readonly dataVisita?: any | null
      readonly motivoVisita: ReadonlyArray<string | null>
      readonly buscaAtiva: ReadonlyArray<string | null>
      readonly acompanhamento: ReadonlyArray<string | null>
      readonly controleAmbiental: ReadonlyArray<string | null>
      readonly dimensaoProfissional?: {
        readonly __typename?: 'DimensaoProfissional'
        readonly id: string
        readonly nome?: string | null
      } | null
      readonly dimensaoEquipe?: {
        readonly __typename?: 'DimensaoEquipe'
        readonly id: string
        readonly nome: string
        readonly ine: string
      } | null
      readonly dimensaoCbo?: {
        readonly __typename?: 'DimensaoCbo'
        readonly id: string
        readonly nome: string
        readonly cbo: string
      } | null
      readonly dimensaoDesfechoVisita: {
        readonly __typename?: 'DimensaoDesfechoVisita'
        readonly id: string
        readonly numeroIdentificador: string
        readonly descricao: string
      }
      readonly tipoOrigem?: {
        readonly __typename?: 'DimensaoTipoOrigem'
        readonly id: string
        readonly nome: string
      } | null
    }>
    readonly pageInfo: {
      readonly __typename?: 'PageInfo'
      readonly number: number
      readonly size: number
      readonly totalPages: number
      readonly totalElements: number
      readonly sort?: ReadonlyArray<string | null> | null
      readonly first: boolean
      readonly last: boolean
      readonly numberOfElements: number
    }
  }
  readonly imovel?: {
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly tipoImovel?: TipoImovelEnum | null
  } | null
}

export type ImovelVisitaQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type ImovelVisitaQuery = {
  readonly __typename?: 'Query'
  readonly visita?: {
    readonly __typename?: 'FatoVisitaDomiciliar'
    readonly id: string
    readonly nuUuidFicha: string
    readonly dataVisita?: any | null
    readonly cpfCidadao?: string | null
    readonly cnsCidadao?: string | null
    readonly dataNascimentoCidadao?: any | null
    readonly motivoVisita: ReadonlyArray<string | null>
    readonly anotacoes?: string | null
    readonly buscaAtiva: ReadonlyArray<string | null>
    readonly acompanhamento: ReadonlyArray<string | null>
    readonly controleAmbiental: ReadonlyArray<string | null>
    readonly peso?: number | null
    readonly altura?: number | null
    readonly temperatura?: string | null
    readonly medicaoGlicemia?: string | null
    readonly medicaoPressaoArterial?: string | null
    readonly stVisitaCompartilhada?: boolean | null
    readonly latitude?: number | null
    readonly longitude?: number | null
    readonly dimensaoSexo?: {
      readonly __typename?: 'DimensaoSexo'
      readonly id: string
      readonly descricao: string
    } | null
    readonly cidadaoPec?: {
      readonly __typename?: 'FatoCidadaoPec'
      readonly id: string
      readonly nome?: string | null
      readonly nomeSocial?: string | null
      readonly cpf?: string | null
      readonly cns?: string | null
      readonly dataNascimento?: any | null
      readonly dimensaoSexo?: {
        readonly __typename?: 'DimensaoSexo'
        readonly id: string
        readonly descricao: string
      } | null
    } | null
    readonly dimensaoProfissional?: {
      readonly __typename?: 'DimensaoProfissional'
      readonly id: string
      readonly cns?: string | null
      readonly nome?: string | null
    } | null
    readonly dimensaoUnidadeSaude?: {
      readonly __typename?: 'DimensaoUnidadeSaude'
      readonly id: string
      readonly nome: string
      readonly cnes: string
    } | null
    readonly dimensaoEquipe?: {
      readonly __typename?: 'DimensaoEquipe'
      readonly id: string
      readonly nome: string
      readonly ine: string
    } | null
    readonly dimensaoCbo?: {
      readonly __typename?: 'DimensaoCbo'
      readonly id: string
      readonly nome: string
      readonly cbo: string
    } | null
    readonly dimensaoTipoGlicemia?: {
      readonly __typename?: 'DimensaoTipoGlicemia'
      readonly id: string
      readonly descricao: string
      readonly numeroIdentificador: string
    } | null
    readonly tipoOrigem?: {
      readonly __typename?: 'DimensaoTipoOrigem'
      readonly id: string
      readonly nome: string
    } | null
    readonly turno?: { readonly __typename?: 'DimensaoTurno'; readonly id: string; readonly descricao: string } | null
    readonly dimensaoDesfechoVisita: {
      readonly __typename?: 'DimensaoDesfechoVisita'
      readonly id: string
      readonly numeroIdentificador: string
      readonly descricao: string
    }
  } | null
}

export type AnimaisDomicilioFragmentFragment = {
  readonly __typename?: 'ImovelDto'
  readonly animaisImovel?: {
    readonly __typename?: 'AnimaisImovel'
    readonly id?: any | null
    readonly possuiAnimais?: boolean | null
    readonly possuiGato?: boolean | null
    readonly possuiCachorro?: boolean | null
    readonly possuiPassaro?: boolean | null
    readonly possuiMacaco?: boolean | null
    readonly possuiGalinha?: boolean | null
    readonly possuiPorco?: boolean | null
    readonly possuiRepteis?: boolean | null
    readonly possuiOutros?: boolean | null
    readonly quantidadeAnimais?: number | null
  } | null
}

export type CondicoesMoradiaFragmentFragment = {
  readonly __typename?: 'ImovelDto'
  readonly condicoesMoradia: {
    readonly __typename?: 'CondicoesMoradia'
    readonly id: string
    readonly tipoAbastecimentoAgua?: TipoAbastecimentoAguaEnum | null
    readonly tipoSituacaoMoradia?: TipoSituacaoMoradiaEnum | null
    readonly tipoTratamentoAgua?: TipoTratamentoAguaEnum | null
    readonly tipoPosseTerra?: TipoPosseTerraEnum | null
    readonly tipoMaterialParede?: TipoMaterialParedeEnum | null
    readonly tipoLocalizacao?: TipoLocalizacaoEnum | null
    readonly tipoEscoamentoSanitario?: TipoEscoamentoSanitarioEnum | null
    readonly tipoDomicilio?: TipoDomicilioEnum | null
    readonly tipoDestinoLixo?: TipoDestinoLixoEnum | null
    readonly tipoAcessoDomicilio?: TipoAcessoDomicilioEnum | null
    readonly isEnergiaEletricaDisponivel?: boolean | null
    readonly tipoOrigemEnergiaEletrica?: TipoOrigemEnergiaEletricaEnum | null
    readonly numeroComodos?: number | null
  }
}

export type ImoveisPermissaoAtualizarQueryVariables = Exact<{
  input: TerritorioMicroareaQueryInput
}>

export type ImoveisPermissaoAtualizarQuery = {
  readonly __typename?: 'Query'
  readonly imoveisPermissaoAtualizar: {
    readonly __typename?: 'TotalImoveisPermissao'
    readonly totalImoveisPermitidos: number
    readonly totalImoveis: number
  }
}

export type AtualizarEnderecoLogradouroMutationVariables = Exact<{
  input: AtualizarEnderecoTerritorioInput
}>

export type AtualizarEnderecoLogradouroMutation = {
  readonly __typename?: 'Mutation'
  readonly atualizarEnderecoTerritorio: boolean
}

export type ProcessarUltimaFichaCidadaosTerritorioMutationVariables = Exact<{
  input: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ProcessarUltimaFichaCidadaosTerritorioMutation = {
  readonly __typename?: 'Mutation'
  readonly processarCidadaosTerritorio: boolean
}

export type ProcessarUltimaFichaTerritorioMutationVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type ProcessarUltimaFichaTerritorioMutation = {
  readonly __typename?: 'Mutation'
  readonly processarTerritorio: boolean
}

export type TerritorioMicroareaQueryVariables = Exact<{
  input: TerritorioMicroareaQueryInput
}>

export type TerritorioMicroareaQuery = {
  readonly __typename?: 'Query'
  readonly territorioMicroarea: {
    readonly __typename?: 'TerritorioMicroarea'
    readonly id: string
    readonly logradouros: {
      readonly __typename?: 'LogradourosTerritorioQueryPayload'
      readonly content: ReadonlyArray<{
        readonly __typename?: 'LogradouroTerritorioDto'
        readonly id: string
        readonly logradouro?: string | null
        readonly tipoLogradouroId?: string | null
        readonly tipoLogradouroNome?: string | null
        readonly tipoLogradouroDne?: string | null
        readonly bairro?: string | null
        readonly cep?: string | null
        readonly tipoEndereco: TipoEnderecoEnum
        readonly numeroImoveis: number
        readonly municipio?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly ibge?: string | null
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
        readonly aldeia?: {
          readonly __typename?: 'Aldeia'
          readonly id: string
          readonly nome: string
          readonly poloBase: {
            readonly __typename?: 'PoloBase'
            readonly id: string
            readonly nome: string
            readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
          }
          readonly municipio: ReadonlyArray<{
            readonly __typename?: 'Municipio'
            readonly id: string
            readonly ibge?: string | null
            readonly nome: string
            readonly uf: {
              readonly __typename?: 'UF'
              readonly id: string
              readonly nome: string
              readonly sigla: string
            }
          }>
        } | null
        readonly poloBase?: {
          readonly __typename?: 'PoloBase'
          readonly id: string
          readonly nome: string
          readonly dsei: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string }
        } | null
        readonly dsei?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
        readonly municipioAldeia?: {
          readonly __typename?: 'Municipio'
          readonly id: string
          readonly ibge?: string | null
          readonly nome: string
          readonly uf: {
            readonly __typename?: 'UF'
            readonly id: string
            readonly nome: string
            readonly sigla: string
          }
        } | null
      }>
      readonly pageInfo: {
        readonly __typename?: 'PageInfo'
        readonly number: number
        readonly size: number
        readonly totalPages: number
        readonly totalElements: number
        readonly sort?: ReadonlyArray<string | null> | null
        readonly first: boolean
        readonly last: boolean
        readonly numberOfElements: number
      }
    }
    readonly indices: {
      readonly __typename?: 'IndicesAcompanhamentoMicroarea'
      readonly quantidadeImoveisCadastroCompleto: any
      readonly totalImoveisNaoRecusados: any
      readonly quantidadeImoveisAtualizados: any
      readonly totalImoveisAtualizados: any
      readonly quantidadeDomiciliosAvaliados: any
      readonly quantidadeDomiciliosVisitados: any
    }
  }
}

export type VisualizacaoTerritorialQueryVariables = Exact<{
  input: TerritorioEquipeQueryInput
}>

export type VisualizacaoTerritorialQuery = {
  readonly __typename?: 'Query'
  readonly territorioEquipe: {
    readonly __typename?: 'TerritorioEquipeDto'
    readonly microareas: ReadonlyArray<string | null>
    readonly hasInativos: boolean
    readonly poloBase?: { readonly __typename?: 'PoloBase'; readonly id: string; readonly nome: string } | null
  }
}

export type VisualizarCidadaosImovelQueryVariables = Exact<{
  input: Scalars['ID']['input']
}>

export type VisualizarCidadaosImovelQuery = {
  readonly __typename?: 'Query'
  readonly imovel?: {
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly uuidDomicilio: string
    readonly dataUltimaVisita?: any | null
    readonly telefoneResidencial?: string | null
    readonly telefoneContato?: string | null
    readonly tipoImovel?: TipoImovelEnum | null
    readonly logradouro?: string | null
    readonly numero?: string | null
    readonly complemento?: string | null
    readonly cep?: string | null
    readonly bairro?: string | null
    readonly numeroMoradores?: number | null
    readonly dataUltimaAtualizacao?: any | null
    readonly tipoEndereco?: TipoEnderecoEnum | null
    readonly numeroResidenciaIndigena?: string | null
    readonly ultimaFichaCadastrada?: {
      readonly __typename?: 'UltimaFichaCadastradaDto'
      readonly id: string
      readonly isProcessado: boolean
    } | null
    readonly tipoLogradouro?: {
      readonly __typename?: 'TipoLogradouro'
      readonly id: string
      readonly nome: string
    } | null
    readonly familias: ReadonlyArray<{
      readonly __typename?: 'Familia'
      readonly id: string
      readonly cnes: string
      readonly ine: string
      readonly numeroProntuarioFamiliar?: string | null
      readonly cpfCnsResponsavel?: string | null
      readonly isResponsavelCadastrado: boolean
      readonly isResponsavelDeclarado: boolean
      readonly isResponsavelVivo: boolean
      readonly isResponsavelUnico: boolean
      readonly isResponsavelAindaReside: boolean
      readonly isFamiliaAindaReside: boolean
      readonly isInformacaoSuficiente: boolean
      readonly isDomicilioAtivo: boolean
      readonly cidadaosTerritorioBasico: ReadonlyArray<{
        readonly __typename?: 'CidadaoTerritorioBasico'
        readonly id: string
        readonly uuidCidadao?: string | null
        readonly nome?: string | null
        readonly nomeSocial?: string | null
        readonly sexo?: SexoEnum | null
        readonly dataNascimento?: any | null
        readonly cpf?: string | null
        readonly cns?: string | null
        readonly telefoneCelular?: string | null
        readonly telefoneContato?: string | null
        readonly isFaleceu?: boolean | null
        readonly ultimaFichaCadastrada?: {
          readonly __typename?: 'UltimaFichaCadastradaDto'
          readonly id: string
          readonly uuidFichaOrigem?: string | null
          readonly isProcessado: boolean
        } | null
      }>
    }>
    readonly condicoesMoradia: {
      readonly __typename?: 'CondicoesMoradia'
      readonly id: string
      readonly tipoLocalizacao?: TipoLocalizacaoEnum | null
      readonly tipoDomicilio?: TipoDomicilioEnum | null
    }
    readonly responsavelTecnico?: {
      readonly __typename?: 'ResponsavelTecnicoImovel'
      readonly id: string
      readonly nome: string
      readonly contato?: string | null
      readonly cns?: string | null
      readonly cargo?: string | null
    } | null
    readonly aldeia?: { readonly __typename?: 'Aldeia'; readonly id: string; readonly nome: string } | null
    readonly poloBase?: { readonly __typename?: 'PoloBase'; readonly id: string; readonly nome: string } | null
    readonly dsei?: { readonly __typename?: 'Dsei'; readonly id: string; readonly nome: string } | null
  } | null
}

export type VisualizarImoveisQueryVariables = Exact<{
  input: TerritorioMicroareaQueryInput
}>

export type VisualizarImoveisQuery = {
  readonly __typename?: 'Query'
  readonly territorioLogradouro: ReadonlyArray<{
    readonly __typename?: 'ImovelDto'
    readonly id: string
    readonly uuidDomicilio: string
    readonly numero?: string | null
    readonly complemento?: string | null
    readonly cep?: string | null
    readonly tipoImovel?: TipoImovelEnum | null
    readonly dataUltimaVisita?: any | null
    readonly numeroMoradores?: number | null
    readonly dataUltimaAtualizacao?: any | null
    readonly isCadastroCompleto?: boolean | null
    readonly descricaoTipoDomicilio?: string | null
    readonly descricaoMaterialParede?: string | null
    readonly numeroResidenciaIndigena?: string | null
    readonly statusRecusa?: boolean | null
    readonly possuiInconsistencia?: boolean | null
    readonly stAtivo: boolean
    readonly familias: ReadonlyArray<{
      readonly __typename?: 'Familia'
      readonly id: string
      readonly responsavel?: {
        readonly __typename?: 'CidadaoTerritorioBasico'
        readonly id: string
        readonly nome?: string | null
        readonly nomeSocial?: string | null
      } | null
      readonly cidadaosTerritorioBasico: ReadonlyArray<{
        readonly __typename?: 'CidadaoTerritorioBasico'
        readonly id: string
      }>
    }>
    readonly responsavelTecnico?: {
      readonly __typename?: 'ResponsavelTecnicoImovel'
      readonly id: string
      readonly nome: string
    } | null
    readonly ultimaFichaCadastrada?: {
      readonly __typename?: 'UltimaFichaCadastradaDto'
      readonly id: string
      readonly isProcessado: boolean
    } | null
    readonly condicoesMoradia: {
      readonly __typename?: 'CondicoesMoradia'
      readonly tipoDomicilio?: TipoDomicilioEnum | null
    }
  }>
}
